webpackJsonp([124],Array(24).concat([
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(689)();
}


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(239);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(387);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(386);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(153);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(153);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StorageUtil = function () {
    function StorageUtil() {
        _classCallCheck(this, StorageUtil);
    }

    _createClass(StorageUtil, null, [{
        key: "setItem",
        value: function setItem(key, val) {
            var isSession = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var adapter = isSession ? sessionStorage : localStorage;
            adapter.setItem(key, JSON.stringify(val));
        }
    }, {
        key: "getItem",
        value: function getItem(key) {
            var isSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var adapter = isSession ? sessionStorage : localStorage;
            var val = adapter.getItem(key);
            try {
                return JSON.parse(val);
            } catch (err) {
                return val;
            }
        }
    }, {
        key: "delItem",
        value: function delItem(key) {
            var isSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var adapter = isSession ? sessionStorage : localStorage;
            adapter.removeItem(key);
        }

        /**
         * 设置带过期时间的缓存（性能优化：TTL缓存机制）
         * @param key 缓存键
         * @param val 缓存值
         * @param ttlSeconds 过期时间（秒）
         * @param isSession 是否使用sessionStorage
         */

    }, {
        key: "setItemWithTTL",
        value: function setItemWithTTL(key, val, ttlSeconds) {
            var isSession = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            var adapter = isSession ? sessionStorage : localStorage;
            var item = {
                value: val,
                expiry: Date.now() + ttlSeconds * 1000,
                createTime: Date.now()
            };
            adapter.setItem(key, JSON.stringify(item));
        }

        /**
         * 获取带过期检查的缓存（性能优化：自动过期检查）
         * @param key 缓存键
         * @param isSession 是否使用sessionStorage
         * @returns 缓存值或null（已过期或不存在）
         */

    }, {
        key: "getItemWithTTL",
        value: function getItemWithTTL(key) {
            var isSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var adapter = isSession ? sessionStorage : localStorage;
            var itemStr = adapter.getItem(key);
            if (!itemStr) return null;

            try {
                var item = JSON.parse(itemStr);
                if (item.expiry && Date.now() > item.expiry) {
                    adapter.removeItem(key);
                    return null;
                }
                return item.value;
            } catch (err) {
                return null;
            }
        }

        /**
         * 清除所有过期的缓存（性能优化：定期清理）
         * @param isSession 是否使用sessionStorage
         */

    }, {
        key: "clearExpiredCache",
        value: function clearExpiredCache() {
            var isSession = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var adapter = isSession ? sessionStorage : localStorage;
            var keys = Object.keys(adapter);
            keys.forEach(function (key) {
                var itemStr = adapter.getItem(key);
                if (itemStr) {
                    try {
                        var item = JSON.parse(itemStr);
                        if (item.expiry && Date.now() > item.expiry) {
                            adapter.removeItem(key);
                        }
                    } catch (err) {
                        // 非TTL格式缓存，忽略
                    }
                }
            });
        }

        /**
         * 检查缓存是否有效（性能优化：缓存有效性检查）
         * @param key 缓存键
         * @param isSession 是否使用sessionStorage
         * @returns Boolean 是否有效
         */

    }, {
        key: "isCacheValid",
        value: function isCacheValid(key) {
            var isSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var adapter = isSession ? sessionStorage : localStorage;
            var itemStr = adapter.getItem(key);
            if (!itemStr) return false;

            try {
                var item = JSON.parse(itemStr);
                if (item.expiry) {
                    return Date.now() < item.expiry;
                }
                return true; // 无TTL的缓存，默认有效
            } catch (err) {
                return false;
            }
        }
    }]);

    return StorageUtil;
}();
// 定制setItemEvent事件，用于页面监听localStorage变化


exports.default = StorageUtil;
var orignalSetItem = localStorage.setItem;
localStorage.setItem = function (key, newValue) {
    var setItemEvent = new Event("setItemEvent");
    setItemEvent.key = key;
    setItemEvent.newValue = newValue;
    window.dispatchEvent(setItemEvent);
    orignalSetItem.apply(this, arguments);
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SystemConst = exports.SystemConst = {
    lang: 'lang', //多语言
    currencySymbol: 'currencySymbol', // 货币符号
    showGoodsDetailMode: 'showGoodsDetailMode',
    multi_currency_symbol_: 'multi_currency_symbol_',
    mShop_user: "ysUser",
    mMgr_user: "ysMgrUser",
    ysClient: "ysClient",
    userInfoHome: "userInfoHome", //我的页面信息缓存
    pcShop_user: "pcShop_user",
    pcMgr_user: "pcMgr_user",
    token: "token",
    wechatData: "wechatData",
    companyId: "companyId", // 公司id
    platformCompanyId: "platformCompanyId", // 平台公司id
    companyName: "companyName", // 公司id
    companyData: "companyData", // 公司信息
    companyTheme: "companyTheme", // 公司主题色
    authCode: "authCode", // 登陆标识
    accountList: "accountList", // 账号列表
    prevLocation: "prevLocation", //上次路由
    localHistory: "localHistory", //本地history
    cartCount: "cartCount", //购物车数量
    floorData: "floorData", // 自定义装修页面数据
    indexList: "indexList", //首页列表
    homePageName: "homePageName", //装修页标题
    shopGoodsList: "shopGoodsList", // 订货端商品列表
    shopGoodsListLoaded: "shopGoodsListLoaded", //标记订货端商品列表页初次加载完成
    shopIndexAnchor: "shopIndexAnchor", //首页滚动位置
    shopPageCache: "shopPageCache", //首页缓存数据

    goodsListAnchor: "goodsListAnchor", //商品列表页面滚动位置
    goodsListParams: "goodsListParams", //商品列表页面筛选条件
    goodsListSlideAnchor: "goodsListSlideAnchor", //商品列表分类滚动位置
    orderListParams: 'orderListParams', // 订单列表筛选条件

    classifyListAnchor: "classifyListAnchor", //分类列表页面滚动位置
    classifyListParams: " classifyListParams", //分类列表页面筛选条件
    classifyListSlideAnchor: "classifyListSlideAnchor", //分类列表分类滚动位置

    imgClassifySlideAnchor: "imgClassifySlideAnchor", //商品列表生鲜农贸模式下一级分类滚动位置
    selectClassifyInfo: 'selectClassifyInfo', //商品列表生鲜农贸模式记录选择分类

    goodsListLabelAnchor: "goodsListLabelAnchor", //商品标签页面滚动位置
    goodsListLabelParams: "goodsListLabelParams", //商品标签页面筛选条件
    goodsListLabelTitle: "goodsListLabelTitle", //商品标签页面标题
    goodsListLabelQuery: "goodsListLabelQuery", //商品标签页面url条件

    goodsSearchResultAnchor: "goodsSearchResultAnchor", //搜索结果页滚动位置
    goodsSearchResultParams: "goodsSearchResultParams", //搜索结果页筛选条件

    mgrOrderListAnchor: "mgrOrderListAnchor", //管理端订单列表锚点
    mgrOrderListParams: "mgrOrderListParams", //管理端订单列表筛选条件

    isMgr: "isMgr", //是否管理端
    isLogin: "isLogin", // 是否登陆
    isExperience: "isExperience", //是否体验账号
    enableMinCount: "enableMinCount", // 起订量
    enableMaxCount: "enableMaxCount", // 限订量
    brandList: "brandList", // 商品品牌列表
    styleList: "styleList", // 商品风格列表
    typeList: "typeList", // 商品分类列表
    groupClassifyList: 'groupClassifyList', //组合分类
    tagList: "tagList", // 商品标签列表
    propertyList: "propertyList", // 商品属性列表
    priceScale: "priceScale", // 商品价格精度
    countScale: "countScale", // 商品数量精度

    enableStyle: "enableStyle", // 是否开启风格筛选
    enableBrand: "enableBrand", // 是否开启品牌筛选

    stockShowType: "stockShowType", // 库存展示方式
    enableStockZero: "enableStockZero", // 是否允许超售
    enableExpectTime: "enableExpectTime", // 是否允许超期
    enableOrderTotal: "enableOrderTotal", // 是否开启下单金额限制
    orderTotal: "orderTotal", // 下单金额限制

    enableTax: "enableTax", // 是否开启发票
    containTax: "containTax", // 商品是否含税
    generalTax: "generalTax", //普通发票税率
    addedTax: "addedTax", //增值税发票税率
    otherTax: "otherTax", //其他发票
    taxType: "taxType", //发票类型
    defaultTaxType: "defaultTaxType", //默认发票类型
    enableSpecialTotal: "enableSpecialTotal",

    orderDefaultUnit: "orderDefaultUnit",

    allowVisitor: "allowVisitor", // 游客是否允许访问
    allowClientPrice: "allowClientPrice", // 游客是否允许查看价格
    showGoodsType: "showGoodsType", // 商品列表展示模式
    showGoodsUnit: "showGoodsUnit", // 是否显示单位
    shopHomeTitle: "shopHomeTitle", // 商品列表展示模式
    allowClientRegister: "allowClientRegister", // 是否允许游客注册
    registerAgreement: "registerAgreement", // 注册协议
    defaultShipWay: "defaultShipWay", // 支付方式
    shopSetting: "shopSetting", // 商城设置

    defaultHomePageBannerList: "defaultHomePageBannerList",
    // 管理端
    mgrGoodsList: "mgrGoodsList",
    mgrGoodsListAnchor: "mgrGoodsListAnchor", //商品列表页面滚动位置
    mgrGoodsListParams: "mgrGoodsListParams", //商品列表页面筛选条件

    shareDefaultLogo: "http://timg.ysdinghuo.com/shareDefaultLogo.png", //分享默认图片

    shareUserId: "shareUserId", // 分享人id
    shareClientId: "shareClientId", // 分享人id
    refundProduct: "refundProduct", // 退货商品
    refundList: "refundList", // 退货单
    refundGoodsList: "refundGoodsList", // 退货商品
    enableSaleBackOrder: "enableSaleBackOrder", // 仅允许订单退货
    additionalFeeSetting: "additionalFeeSetting", // 订单确认附加服务设置
    enableShopNoOrder: "enableShopNoOrder", // 是否开启禁止下单
    shopNoOrderTime: "shopNoOrderTime", // 禁止时间
    anotherCart: "anotherCart", // 再来一单
    shopCartList: "shopCartList", // 购物车列表

    houseSetting: "houseSetting", // 仓库设置
    msgGoods: "msgGoods", //咨询商品
    msgOrder: "msgOrder", //咨询订单
    isShowBindTips: "isShowBindTips", //是否显示个人中心页面绑定手机提示
    isLighting: "isLighting", //是否是灯饰行业

    wechatBind: "wechatBind", // 3_1_9:是否微信绑定

    enableRebateLevel: "enableRebateLevel", //分销等级
    distributionModelTitle: 'distributionModelTitle', // 分销标题
    distributionJobName: 'distributionJobName', // 分销人职位
    posterBackground: 'posterBackground', // 推广海报背景图
    invitationCardBackground: 'invitationCardBackground', // 邀请卡背景图
    joiningInstructions: 'joiningInstructions', //加盟说明

    navBarDecorate: 'navigationBarDecorate', //导航应用页面
    navBarJson: 'navBarJson', //导航装修json数据
    navDecoratePage: 'navDecoratePage', //应用导航页
    barPathname: 'barPathname', //导航路由
    floatingWindowDecorate: "floatingWindowDecorate", //悬浮窗装修页面
    floatingWindowJson: "floatingWindowJson", //悬浮窗装修数据
    publicAdDecorate: "publicAdDecorate", //公共广告应用页面
    publicAdJson: "publicAdJson", //公共广告装修数据
    publicAdPosition: "publicAdPosition", //公共广告位置
    goodsListSetting: "goodsListSetting", //商品列表设置
    goodsTypeSetting: "goodsTypeSetting", //商品分类设置
    topGoodsTypeNode: "topGoodsTypeNode", //首个分类
    enableH5Scene: "enableH5Scene", //是否开启了h5显示去配灯按钮
    MineSetting: "MineSetting", // 个人中心设置
    BaseSetting: "BaseSetting", // 基础设置

    bindWay: 'bindWay', //上下级绑定方式
    parentClientId: 'parentClientId', //上级客户ID

    generalizeGoodsAnchor: 'generalizeGoodsAnchor', // 推广商品滚动条位置
    generalizeGoodsParams: 'generalizeGoodsParams', //推广商品页面参数位置
    companyOpenScore: 'companyOpenScore', //积分商城权限
    companyEnableSign: 'companyEnableSign', //积分商城签到权限

    applicationStatus: "applicationStatus", //应用状态
    companyShopSwitch: "companyShopSwitch", //应用状态

    defaulGoods: "defaulGoods",

    orderListAnchorTop: 'orderListAnchorTop', // 订单列表缓存
    saleSetting: 'saleSetting',
    saleBackReasonList: 'saleBackReasonList', // 退货原因列表

    clientSetting: 'clientSetting', // 客户设置
    enableOrderSource: 'enableOrderSource', // 订单来源必填
    clientShowCubage: 'clientShowCubage', // 客户端显示体积
    clientShowWeight: 'clientShowWeight', // 客户端显示重量
    enableRechargeDeductConfirm: 'enableRechargeDeductConfirm',
    enableCustomAttachmentRequired: 'enableCustomAttachmentRequired',
    enableChangeInvoice: 'enableChangeInvoice',
    enableCustomAttachmentClose: 'enableCustomAttachmentClose',
    showMarketPrice: 'enable_show_market_price_', // 是否显示单位
    consignManagerTitle: 'consignManagerTitle',
    consignManagerPickUp: 'consignManagerPickUp',
    consignManagerInventory: 'consignManagerInventory',
    consignManagerMyInventory: 'consignManagerMyInventory',
    userInfo: 'userInfo',
    messagePrompt: 'message_prompt_',
    languageType: 'languageType',
    rmbExchangeRate: 'rmbExchangeRate',
    application38: 'application38',
    enableGlobal: 'enableGlobal',
    enableGoodsImgDownload: 'enableGoodsImgDownload',
    msgSetting: 'msgSetting',
    customerServiceList: 'customerServiceList', // 客服列表
    switchLanguageType: 'switchLanguageType', // 客服列表
    huiFuWeiXinCombinedPay: 'huiFuWeiXinCombinedPay'
};
// indexedDB缓存表
var DBConst = exports.DBConst = {
    goodsList: 'goodsList', // 商品列表缓存
    goodsListLabel: 'goodsListLabel', // 分类列表缓存
    orderList: 'orderList', // 订单列表缓存

    cartList: 'cartList', // 购物车列表缓存
    generalizeGoodsList: 'generalizeGoodsList' // 推广商品列表
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(385);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(99)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(98);
var IE8_DOM_DEFINE = __webpack_require__(246);
var toPrimitive = __webpack_require__(165);
var dP = Object.defineProperty;

exports.f = __webpack_require__(55) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var origin = typeof window.location.origin === 'undefined' ? window.location.protocol + "//" + window.location.host : window.location.origin;
var prodHost = 'ysdinghuo';
var testHost = 'yimaideng';
var devHost = 'http://' + location.hostname;
var UrlUtil = {
    getHost: function getHost() {
        if (true) {
            return prodHost;
        } else if (process.env.API_ENV === 'test') {
            return testHost;
        } else {
            return devHost;
        }
    },
    getAPI: function getAPI() {
        if (true) {
            return 'https://api.' + prodHost + '.com';
        } else if (process.env.API_ENV === 'test') {
            return 'http://api.yimaideng.cn';
        } else {
            // return `http://api.yimaideng.cn`;
            return devHost + ':8990';
        }
    },

    getMShopUrl: function getMShopUrl() {
        if (true) {
            return 'https://m.' + prodHost + '.com';
        } else if (process.env.API_ENV === 'test') {
            return 'http://m.' + testHost + '.cn';
        } else {
            return devHost + ':8991';
        }
    },
    getMMgrUrl: function getMMgrUrl() {
        if (true) {
            return 'https://mgr.' + prodHost + '.com';
        } else if (process.env.API_ENV === 'test') {
            return 'http://mgr.' + testHost + '.cn';
        } else {
            return devHost + ':8996';
        }
    },
    getLightUrl: function getLightUrl() {
        if (true) {
            return 'https://pd.' + prodHost + '.com';
        } else if (process.env.API_ENV === 'test') {
            return 'http://pd.' + testHost + '.cn';
        } else {
            return devHost + ':9002';
        }
    },
    getAccountUrl: function getAccountUrl(companyID) {
        if (true) {
            return companyID ? 'https://store' + companyID + '.' + prodHost + '.com' : 'https://account.' + prodHost + '.com';
        } else if (process.env.API_ENV === 'test') {
            return companyID ? 'http://store' + companyID + '.' + testHost + '.cn' : 'http://account.' + testHost + '.cn';
        } else if (window.location.href.indexOf('192.168')) {
            return devHost + ':8993';
        }
    },
    getBitMapUrl: function getBitMapUrl() {
        if (true) {
            return 'https://point.' + prodHost + '.com';
        } else if (process.env.API_ENV === 'test') {
            return 'http://point.' + testHost + '.cn';
        } else {
            return devHost + ':5003';
        }
    }
};
exports.default = UrlUtil;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(56);
var core = __webpack_require__(54);
var ctx = __webpack_require__(244);
var hide = __webpack_require__(79);
var has = __webpack_require__(61);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(62);
var createDesc = __webpack_require__(121);
module.exports = __webpack_require__(55) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(247);
var defined = __webpack_require__(155);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(162)('wks');
var uid = __webpack_require__(122);
var Symbol = __webpack_require__(56).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BargainFetch = exports.ConsignFetch = exports.BehaviorFetch = exports.AggregatePayFetch = exports.PickUpStationFetch = exports.GoodsSnFetch = exports.FreeGoodsFetch = exports.CreditQuotaFetch = exports.ExperienceFetch = exports.ClientAddressFetch = exports.VouchersFetch = exports.DepositFetch = exports.DistributionFetch = exports.SaleBackFetch = exports.IntegralFetch = exports.ApplicationFetch = exports.ClientFetch = exports.PayFetch = exports.System = exports.OrderFetch = exports.CartFetch = exports.ShopFetch = exports.GoldOrnamentFetch = exports.DistributionReportFetch = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 中文
// 英语


__webpack_require__(652);

__webpack_require__(653);

var _appUtil = __webpack_require__(96);

var _appUtil2 = _interopRequireDefault(_appUtil);

var _Utils = __webpack_require__(147);

var _Utils2 = _interopRequireDefault(_Utils);

var _BusinessUtil = __webpack_require__(112);

var _storageUtil = __webpack_require__(50);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

var _urlConfig = __webpack_require__(77);

var _urlConfig2 = _interopRequireDefault(_urlConfig);

var _zh_CN = __webpack_require__(115);

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _es_ES = __webpack_require__(114);

var _es_ES2 = _interopRequireDefault(_es_ES);

var _en_US = __webpack_require__(113);

var _en_US2 = _interopRequireDefault(_en_US);

var _constant = __webpack_require__(51);

var _commonUtils = __webpack_require__(111);

var _md = __webpack_require__(226);

var _md2 = _interopRequireDefault(_md);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reqKey = "yunshang";
var API = _urlConfig2.default.getAPI();

// 多语言
var messages = {
    'zh': _zh_CN2.default,
    'es': _es_ES2.default,
    'en': _en_US2.default
};
var lang = _storageUtil2.default.getItem(_constant.SystemConst.lang) || 'zh';

// 铺货上报接口
var DistributionReportFetch = exports.DistributionReportFetch = {
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/v1/sale/saleOrder/searchProductList', _params, _success, _error);
    },
    distributionReportSave: function distributionReportSave(_params, _success, _error) {
        _request('POST', API + '/v1/sl/clientGoodsReport/save', _extends({ _meth: 'body' }, _params), _success, _error);
    }
};

// 金饰定制模块接口
var GoldOrnamentFetch = exports.GoldOrnamentFetch = {
    //获取金饰定制设置
    getByCompany: function getByCompany(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goldOrnamentSetting/noAuth/getByCompany/' + _params, _params, _success, _error);
    },
    // 查询销量最大前3条商品信息
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goldOrnamentProduct/noAuth/searchList', _params, _success, _error);
    },
    searchOrnamentGoodsList: function searchOrnamentGoodsList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goldOrnamentGoods/noAuth/searchList', _params, _success, _error);
    },
    goldOrnamentProduct: function goldOrnamentProduct(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goldOrnamentProduct/noAuth/getById/' + _params.id_ + '/' + _params.company_id_, _params, _success, _error);
    },
    searchElectroplateTechnologyList: function searchElectroplateTechnologyList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goldOrnamentSetting/noAuth/searchElectroplateTechnologyList', _params, _success, _error);
    },
    searchStoneColourList: function searchStoneColourList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goldOrnamentSetting/noAuth/searchStoneColourList', _params, _success, _error);
    },
    searchStoneCutTechnologyList: function searchStoneCutTechnologyList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goldOrnamentSetting/noAuth/searchStoneCutTechnologyList', _params, _success, _error);
    }
};
//商品模块接口
var ShopFetch = exports.ShopFetch = {
    //生鲜码上溯源
    getTraceabilityInfo: function getTraceabilityInfo(_params, _success, _error) {
        _request('GET', API + '/v1/house/outHouse/noAuth/getTraceabilityInfoByItemId/' + _params + ' ', _params, _success, _error);
    },
    //码上溯源
    codeTraceability: function codeTraceability(_params1, _params2, _success, _error) {
        _request('GET', API + '/v1/goodsMgr/noAuth/codeTraceability/' + _params1 + '/' + _params2 + ' ', _params1, _success, _error);
    },
    updateStatus: function updateStatus(_params, _success, _error) {
        _request('POST', API + '/v1/base/user/updateStatus', _params, _success, _error);
    },
    saveChildUser: function saveChildUser(_params, _success, _error) {
        _request('POST', API + '/v1/client/client/saveChildUser', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    searchChildUser: function searchChildUser(_params, _success, _error) {
        _request('GET', API + '/v1/client/client/searchChildUser', _params, _success, _error);
    },
    //获取客户设置信息
    getClientSetting: function getClientSetting(_params, _success, _error) {
        _request('GET', API + '/v1/sl/clientSetting/getByCompanyId', _params, _success, _error);
    },
    //获取商品首页广告图
    searchBannerList: function searchBannerList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/home/noAuth/searchBannerList', _params, _success, _error);
    },
    //记录当前广告的点击次数
    updateBannerClick: function updateBannerClick(_params, _success, _error) {
        _request('POST', API + '/v1/shop/home/noAuth/changeClickNum/' + _params, _params, _success, _error);
    },
    //获取商品首页广告图
    searchIndexGoodsList: function searchIndexGoodsList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/home/noAuth/searchIndexGoodsList', _params, _success, _error);
    },
    //分页获取首页公告列表
    searchNoticeList: function searchNoticeList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/home/noAuth/searchNoticeList', _params, _success, _error);
    },
    //获取公告详情
    getNoticeById: function getNoticeById(_params, _success, _error) {
        _request('GET', API + '/v1/shop/home/noAuth/getNoticeById/' + _params, _params, _success, _error);
    },
    //获取商品详情
    getGoodsById: function getGoodsById(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/getGoodsById/' + _params, _params, _success, _error);
    },
    //获取商品详情
    getGoodsByIdAndClientIdForShop: function getGoodsByIdAndClientIdForShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/getGoodsByIdAndClientIdForShop', _params, _success, _error);
    },
    // 根据产品条形码获取客户产品信息
    getGoodsByBarcodeAndClientIdForShop: function getGoodsByBarcodeAndClientIdForShop(_params, _success) {
        _request('GET', API + '/v1/shop/goods/getGoodsByBarcodeAndClientIdForShop', _params, _success);
    },
    //商城商品分页查询
    searchListForShop: function searchListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/searchListForShop', _params, _success, _error);
    },
    //web端查询收藏商品
    searchFavoriteGoodsForWeb: function searchFavoriteGoodsForWeb(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/searchFavoriteGoodsForWeb', _params, _success, _error);
    },
    //web端收藏商品分类筛选
    searchTypeByFavorite: function searchTypeByFavorite(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/searchTypeByFavorite', _params, _success, _error);
    },
    //web端查询常购商品清单
    searchClientGoodsForWeb: function searchClientGoodsForWeb(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/searchClientGoodsForWeb', _params, _success, _error);
    },
    //web端常购商品分类筛选
    searchTypeByClientGoods: function searchTypeByClientGoods(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/searchTypeByClientGoods', _params, _success, _error);
    },
    //获取指定公司的商品分类树
    getUsePropertyTree: function getUsePropertyTree(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/getUsePropertyTree', _params, _success, _error);
    },
    //商城商品分页查询
    searchGoods: function searchGoods(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/searchGoods', _params, _success, _error);
    },
    //我收藏的商品分页查询
    searchFavoriteListForShop: function searchFavoriteListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goodsFavorite/noAuth/searchFavoriteListForShop', _params, _success, _error);
    },
    //查询商品被收藏数量
    countFavorites: function countFavorites(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goodsFavorite/noAuth/countFavorites/' + _params, _params, _success, _error);
    },
    //商城商品分页查询
    checkPhone: function checkPhone(_params, _success, _error) {
        _request('GET', API + '/api/v1/account/checkPhone', _params, _success, _error);
    },
    addGoodsFavorite: function addGoodsFavorite(_params, _success, _error) {
        _request('POST', API + '/v1/shop/goodsFavorite/addGoodsFavorite', _params, _success, _error);
    },
    deleteGoodsFavorite: function deleteGoodsFavorite(_params, _success, _error) {
        _request('POST', API + '/v1/shop/goodsFavorite/deleteGoodsFavorite', _params, _success, _error);
    },
    batchDeleteGoodsFavorite: function batchDeleteGoodsFavorite(_params, _success, _error) {
        _request('POST', API + '/v1/shop/goodsFavorite/batchDeleteGoodsFavorite', _params, _success, _error);
    },
    //列出企业所有商品风格
    listStyleByCompany: function listStyleByCompany(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/listStyleByCompany', _params, _success, _error);
    },
    //列出企业所有商品品牌
    listBrandByCompany: function listBrandByCompany(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/listBrandByCompany', _params, _success, _error);
    },
    //列出企业所有商品分类
    listTypeByCompany: function listTypeByCompany(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/getTypeTree', _params, _success, _error);
    },
    //列出企业所有商品标签
    searchTagList: function searchTagList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/listTagByCompany', _params, _success, _error);
    },
    //获取商品设置信息
    getGoodsSetting: function getGoodsSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/goodsSetting/getByCompanyId/' + _params, _params, _success, _error);
    },
    //获取销售设置信息
    getSaleSetting: function getSaleSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/setting/getSaleSetting/' + _params, _params, _success, _error);
    },
    //获取销售设置信息
    getShopSetting: function getShopSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/setting/getShopSetting/' + _params, _params, _success, _error);
    },
    //获取商城开放注册应用设置
    getShopRegisterSetting: function getShopRegisterSetting(_params, _success, _error) {
        _request('GET', API + '/v1/shopRegisterSetting/noAuth/getByCompany', _params, _success, _error);
    },
    //获取仓库设置
    getHouseSetting: function getHouseSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/setting/getHouseSetting/' + _params, _params, _success, _error);
    },
    //获取企业信息
    getCompany: function getCompany(_params, _success, _error) {
        _request('GET', API + '/v1/shop/home/noAuth/getCompany/' + _params, _params, _success, _error);
    },
    // 获取客户分类列表
    findList: function findList(_params, _success, _error) {
        _request('GET', API + '/v1/client/clientType/findList', _params, _success, _error);
    },
    // 获取首页信息
    getPageDataByWeb: function getPageDataByWeb(_params, _success, _error) {
        _request('GET', API + '/v1/shop/decorate/noAuth/getPageDataByWeb', _params, _success, _error);
    },
    // 获取店铺装修商品
    searchListForDecorate: function searchListForDecorate(_params, _success, _error) {
        _request('GET', API + '/v1/shop/decorate/noAuth/searchListForDecorate', _params, _success, _error);
    },
    // 批量查询楼层商品（性能优化：一次请求查询多个楼层）
    batchSearchListForDecorate: function batchSearchListForDecorate(_params, _success, _error) {
        _request('POST', API + '/v1/shop/decorate/noAuth/batchSearchListForDecorate', _params, _success, _error);
    },
    updateClientLastVisitedTime: function updateClientLastVisitedTime(_params, _success, _error) {
        _request('POST', API + '/v1/decorate/wpShopTemplate/noAuth/updateClientLastVisitedTime/' + _params, _params, _success, _error);
    },
    // 获取店铺装修商品
    countDecorateVisitor: function countDecorateVisitor(_params, _success, _error) {
        _request('POST', API + '/v1/decorate/wpShopTemplate/noAuth/countVisitor/' + _params, _params, _success, _error);
    },
    // 获取店铺装修促销
    listForGoodsPromotionActivityIds: function listForGoodsPromotionActivityIds(_params, _success, _error) {
        _request('GET', API + '/v1/shop/decorate/noAuth/listForGoodsPromotionActivityIds', _params, _success, _error);
    },
    //查询指定商品当前应用的促销
    goodsPromotionByGoods: function goodsPromotionByGoods(_params, _success, _error) {
        _request('GET', API + '/v1/sale/goodsPromotion/listByGoods/' + _params, _params, _success, _error);
    },
    //查询促销列表
    searchListActivityForShop: function searchListActivityForShop(_params, _success, _error) {
        _request('GET', API + '/v1/sale/goodsPromotion/noAuth/searchListActivityForShop', _params, _success, _error);
    },
    //获取运费计算设置
    // getShipFeeSettingByLogin: (_params, _success, _error) => {
    //     _request('GET', `${API}/v1/setting/shipFeeSetting/getByLoginUser/${_params}`, _params, _success, _error)
    // },
    //获取运费计算设置
    getShipFeeSetting: function getShipFeeSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/shipFeeSetting/shopGetAllShipFeeSetting/' + _params, _params, _success, _error);
    },
    //获取运费计算设置
    getShipFeeSettingByLogin: function getShipFeeSettingByLogin(_params, _success, _error) {
        _request('GET', API + '/v1/setting/shipFeeSetting/getAllShipFeeSetting/' + _params, _params, _success, _error);
    },
    //获取客户优惠券
    listCouponByShop: function listCouponByShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/coupon/listCouponByShop', _params, _success, _error);
    },
    //获取客户相关优惠券活动
    listCouponActivityByShop: function listCouponActivityByShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/coupon/listCouponActivityByShop', _params, _success, _error);
    },
    //领取优惠券
    receiveCoupon: function receiveCoupon(_params, _success, _error) {
        _request('POST', API + '/v1/shop/coupon/receiveCoupon', _params, _success, _error);
    },
    //批量领取优惠券
    batchReceiveCoupon: function batchReceiveCoupon(_params, _success, _error) {
        _request('POST', API + '/v1/shop/coupon/batchReceiveCoupon', _params, _success, _error);
    },
    //获取预存款明细
    searchPreBalanceListForShop: function searchPreBalanceListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/searchPreBalanceListForShop', _params, _success, _error);
    },
    // 获取返款账户明细
    searchRebatesBalanceListForShop: function searchRebatesBalanceListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/finance/clientRebatesBalanceRecord/searchRebatesBalanceListForShop', _params, _success, _error);
    },
    //记录浏览商品足迹
    saveGoodsViewLog: function saveGoodsViewLog(_params, _success, _error) {
        _request('POST', API + '/v1/goods/goodsViewLog/save', _params, _success, _error);
    },
    //获取浏览商品足迹
    searchViewLogListForShop: function searchViewLogListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/goods/goodsViewLog/searchViewLogListForShop', _params, _success, _error);
    },
    //刪除足迹
    deleteViewLogListByIds: function deleteViewLogListByIds(_params, _success, _error) {
        _request('DELETE', API + '/v1/goods/goodsViewLog/deleteByIds/' + _params, _params, _success, _error);
    },
    //获取推荐商品
    searchRecommendedGoodsListForShop: function searchRecommendedGoodsListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/searchRecommendedGoodsListForShop', _params, _success, _error);
    },
    //获取商品套餐列表
    searchGoodsPackageListForShop: function searchGoodsPackageListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/searchGoodsPackageListForShop', _params, _success, _error);
    },
    //获取商品套餐详情
    getGoodsPackageByIdForWeb: function getGoodsPackageByIdForWeb(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/getGoodsPackageByIdForWeb/' + _params, _params, _success, _error);
    },

    //查询客户是否申请注销
    cancelInfoByClientId: function cancelInfoByClientId(_params, _success, _error) {
        _request('GET', API + '/v1/shopRegisterSetting/cancelInfoByClientId/' + _params, _params, _success, _error);
    },
    //新增注销记录
    saveCancel: function saveCancel(_params, _success, _error) {
        _request('POST', API + '/v1/shopRegisterSetting/saveCancel', _extends({ _meth: 'body' }, _params), _success, _error);
    }
};
//购物车模块接口
var CartFetch = exports.CartFetch = {
    //保存/修改商城购物车列表
    saveCart: function saveCart(_params, _success, _error) {
        _request('POST', API + '/v1/shop/cart/updateForShop', _params, _success, _error);
    },
    //webapp再来一单添加商品合并到购物车
    mergeCartForWeb: function mergeCartForWeb(_params, _success, _error) {
        _request('POST', API + '/v1/shop/cart/mergeCartForWeb', _params, _success, _error);
    },
    //修改商城购物车列表
    updateCart: function updateCart(_params, _success, _error) {
        _request('POST', API + '/v1/shop/cart/updateForWeb', _params, _success, _error);
    },
    //购物车查询
    searchListForShopCart: function searchListForShopCart(_params, _success, _error) {
        _request('GET', API + '/v1/shop/cart/searchListForShopCart', _params, _success, _error);
    },
    //修改商城购物车数量
    modifyCartNum: function modifyCartNum(_params, _success, _error) {
        _request('POST', API + '/v1/shop/cart/modifyCartNum', _params, _success, _error);
    },
    //删除商城购物车
    batchDelete: function batchDelete(_params, _success, _error) {
        _request('POST', API + '/v1/shop/cart/batchDelete', _params, _success, _error);
    },
    //列出企业配置的配送方式
    listShipWay: function listShipWay(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/noAuth/listShipWay', _params, _success, _error);
    },
    //获取送货地址--代客下单
    clientAddress: function clientAddress(_params, _success, _error) {
        _request('GET', API + '/v1/sale/valetSale/listByClientId/' + _params, _params, _success, _error);
    },
    //获取发票类型
    getSaleSetting: function getSaleSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/setting/getSaleSetting/' + _params, _params, _success, _error);
    },
    //保存订单
    batchSave: function batchSave(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/batchSave', _params, _success, _error);
    },
    //保存订单
    save: function save(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/save', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //保存预售订单
    presaleSave: function presaleSave(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/presaleSave', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //获取商品优惠信息
    getPromotionByGoodsId: function getPromotionByGoodsId(_params, _success, _error) {
        _request('GET', API + '/v1/sale/goodsPromotion/getPromotionByGoodsId', _params, _success, _error);
    },
    //根据规格ids串获取商品优惠信息
    getPromotionByProductIds: function getPromotionByProductIds(_params, _success, _error) {
        _request('GET', API + '/v1/sale/goodsPromotion/getPromotionByProductIds', _params, _success, _error);
    },
    batchGetPromotionByProductIds: function batchGetPromotionByProductIds(_params, _success, _error) {
        _request('POST', API + '/v1/sale/goodsPromotion/batchGetPromotionByProductIds', _params, _success, _error);
    },
    //获取商品优惠信息
    getPromotionByProductId: function getPromotionByProductId(_params, _success, _error) {
        _request('GET', API + '/v1/sale/goodsPromotion/getPromotionByProductId', _params, _success, _error);
    },
    //获取商品优惠信息
    getActivityById: function getActivityById(_params, _success, _error) {
        _request('GET', API + '/v1/sale/goodsPromotion/getActivityById/' + _params, null, _success, _error);
    },
    //获取订单优惠信息
    getPromotionByCompanyId: function getPromotionByCompanyId(_params, _success, _error) {
        _request('GET', API + '/v1/sale/orderPromotion/getPromotionByCompanyId', _params, _success, _error);
    },
    batchGetPromotionByCompanyIds: function batchGetPromotionByCompanyIds(_params, _success, _error) {
        _request('GET', API + '/v1/sale/orderPromotion/batchGetPromotionByCompanyIds', _params, _success, _error);
    },
    //获取购物车SKU总数量
    sumNumber: function sumNumber(_params, _success, _error) {
        _request('GET', API + '/v1/shop/cart/sumNumber', _params, _success, _error);
    },
    //清除购物车下架商品
    cleanDownawayGoods: function cleanDownawayGoods(_params, _success, _error) {
        _request('POST', API + '/v1/shop/cart/cleanDownawayGoods', _params, _success, _error);
    },
    //批量添加商城商品收藏
    batchAddGoodsFavorite: function batchAddGoodsFavorite(_params, _success, _error) {
        _request('POST', API + '/v1/shop/goodsFavorite/batchAddGoodsFavorite', _params, _success, _error);
    },
    //合并订单
    combinedPaySave: function combinedPaySave(_params, _success, _error) {
        _request('POST', API + '/v1/finance/combinedPay/save', _params, _success, _error);
    },
    //合并订单
    combinedPayGetById: function combinedPayGetById(_params, _success, _error) {
        _request('GET', API + '/v1/finance/combinedPay/getById/' + _params, _params, _success, _error);
    },
    //获取优惠券活动
    getCouponActivityById: function getCouponActivityById(_params, _success, _error) {
        _request('GET', API + '/v1/shop/coupon/getCouponActivityById/' + _params, _params, _success, _error);
    },
    getCouponRecordById: function getCouponRecordById(_params, _success, _error) {
        _request('GET', API + '/v1/shop/coupon/getCouponRecordById/' + _params, _params, _success, _error);
    },

    //获取商品预售信息
    getpresalePromotionByGoodsId: function getpresalePromotionByGoodsId(_params, _success, _error) {
        _request('GET', API + '/v1/sale/presalePromotion/getPromotionByGoodsId', _params, _success, _error);
    },
    //获取商品预售信息
    getPresalePromotionByProductIds: function getPresalePromotionByProductIds(_params, _success, _error) {
        _request('GET', API + '/v1/sale/presalePromotion/getPromotionByProductIds', _params, _success, _error);
    },
    //获取预售活动信息
    getPresalePromotionById: function getPresalePromotionById(_params, _success, _error) {
        _request('GET', API + '/v1/sale/presalePromotion/getActivityById/' + _params, _params, _success, _error);
    },
    //购物车商品缓存添加
    batchSaveCartCache: function batchSaveCartCache(_params, _success, _error) {
        _request('POST', API + '/v1/goods/goodsToCartCache/batchSave', _extends({}, _params), _success, _error);
    },
    //购物车商品缓存
    searchListForShopCartCache: function searchListForShopCartCache(_params, _success, _error) {
        _request('GET', API + '/v1/goods/goodsToCartCache/searchListForShop', _params, _success, _error);
    },
    //购物车商品缓存
    deleteByEditCartCache: function deleteByEditCartCache(_params, _success, _error) {
        _request('GET', API + '/v1/goods/goodsToCartCache/deleteByEdit', _params, _success, _error);
    },
    //购物车商品缓存
    cleanByclientIdCartCache: function cleanByclientIdCartCache(_params, _success, _error) {
        _request('DELETE', API + '/v1/goods/goodsToCartCache/cleanByclientId/' + _params, _params, _success, _error);
    }
};
//商城订单
var OrderFetch = exports.OrderFetch = {
    //保存/修改商城购物车列表
    getById: function getById(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/getById/' + _params, _params, _success, _error);
    },
    // 获取订单详情
    getSaleOrderById: function getSaleOrderById(_params, _success, _error) {
        _request('GET', API + '/v1/sale/saleOrder/getById/' + _params, _params, _success, _error);
    },
    //订单支付(线下或预付款)
    orderPay: function orderPay(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/orderPayByOfflineOrPre', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //订单支付(线下或预付款)
    getPreBalance: function getPreBalance(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/getPreBalance', _params, _success, _error);
    },
    //
    searchListForShop: function searchListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/searchListForShop', _params, _success, _error);
    },
    //取消订单
    orderCancel: function orderCancel(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/cancel', _params, _success, _error);
    },
    //删除订单
    deleteOrderById: function deleteOrderById(_params, _success, _error) {
        _request('DELETE', API + '/v1/shop/order/deleteById/' + _params, _params, _success, _error);
    },
    //删除订单
    markNotViewForShop: function markNotViewForShop(_params, _success, _error) {
        _request('DELETE', API + '/v1/shop/order/markNotViewForShop/' + _params, _params, _success, _error);
    },
    //确认收货
    receiveById: function receiveById(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/batchReceive/' + _params, _params, _success, _error);
    },
    //确认收货
    receive: function receive(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/receive', _extends({}, _params, { _meth: 'body' }), _success, _error);
    },
    // 根据快递单号获取物流信息
    getLogisticInfo: function getLogisticInfo(_params, _success, _error) {
        _request('GET', API + '/v1/common/helper/getLogisticInfo', _params, _success, _error);
    },
    // 获取企业线下收款账号
    listOfflineAccount: function listOfflineAccount(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/listOfflineAccount', _params, _success, _error);
    },
    // 获取企业线下收款账号
    listAccount: function listAccount(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/listAccount', _params, _success, _error);
    },
    // 获取企业线上收款账号
    listOnlineAccount: function listOnlineAccount(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/listOnlineAccount', _params, _success, _error);
    },
    orderPayByOfflineOrPre: function orderPayByOfflineOrPre(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/orderPayByOfflineOrPre', _params, _success, _error);
    },
    // 分页获取商城订单消息列表
    searchOrderMessage: function searchOrderMessage(_params, _success, _error) {
        _request('GET', API + '/v1/shop/orderMessage/searchListByLogin', _params, _success, _error);
    },
    // 标记订单消息为已读
    markRead: function markRead(_params, _success, _error) {
        _request('POST', API + '/v1/shop/orderMessage/markRead/' + _params, null, _success, _error);
    },
    // 标记订单消息为全部已读
    markAllRead: function markAllRead(_params, _success, _error) {
        _request('POST', API + '/v1/shop/orderMessage/markAllRead', _params, _success, _error);
    },
    //获取收款单核销记录
    findSaleOrderIncomeList: function findSaleOrderIncomeList(_params, _success, _error) {
        _request('GET', API + '/v1/finance/income/noAuth/findSaleOrderIncomeList/' + _params, _params, _success, _error);
    },
    //修改销售单商品备注
    modifyItemRemark: function modifyItemRemark(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/modifyItemRemark', _params, _success, _error);
    },
    //客户订货统计（最近两年）
    clientSaleReport: function clientSaleReport(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/clientSaleReport', _params, _success, _error);
    },
    // 规格销售报表-按规格统计列表
    productSaleReportSearchList: function productSaleReportSearchList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/productSaleReportSearchList', _params, _success, _error);
    },
    // 分类销售报表-按分类统计列表
    goodsTypeSaleReportSearchList: function goodsTypeSaleReportSearchList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/order/goodsTypeSaleReportSearchList', _params, _success, _error);
    },
    // 添加日志
    saveOrderLog: function saveOrderLog(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/saveOrderLog', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //
    getOrderMoneyRestrictDto: function getOrderMoneyRestrictDto(_params, _success, _error) {
        _request('GET', API + '/v1/sale/saleOrder/getOrderMoneyRestrictDto/' + _params, _params, _success, _error);
    },
    // 申请开票
    updateOrderTaxRate: function updateOrderTaxRate(_params, _success, _error) {
        _request('POST', API + '/v1/sale/saleOrder/updateOrderTaxRate', _extends({ _meth: 'body' }, _params), _success, _error);
    }

};
//系统模块
var System = exports.System = {
    saveClientInquiry: function saveClientInquiry(_params, _success, _error) {
        _request('POST', API + '/v1/sl/clientInquiry/save', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    editShopPopCheckCount: function editShopPopCheckCount(_params, _success, _error) {
        _request('POST', API + '/v1/sl/homePagePop/editCheckCount/' + _params, _params, _success, _error);
    },
    getPopInfo: function getPopInfo(_params, _success, _error) {
        _request('GET', API + '/v1/sl/homePagePop/getPopInfo', _params, _success, _error);
    },
    cooperateApplySave: function cooperateApplySave(_params, _success, _error) {
        _request('POST', API + '/v1/bs/upstreamApply/save', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    joinApplySave: function joinApplySave(_params, _success, _error) {
        _request('POST', API + '/v1/bs/joinApply/save', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    getPartnerJoinInfo: function getPartnerJoinInfo(_params, _success, _error) {
        _request('GET', API + '/v1/bs/partnerJoinSetting/getPartnerJoinInfo', _params, _success, _error);
    },
    // 获取客服列表
    getCustomerServiceList: function getCustomerServiceList(_params, _success, _error) {
        _request('GET', API + '/v1/client/client/getCustomerServiceList', _params, _success, _error);
    },

    getMsgSettingByCompanyId: function getMsgSettingByCompanyId(_params, _success, _error) {
        _request('GET', API + '/v1/bs/msgSetting/getByCompanyId', _params, _success, _error);
    },

    // 根据国家获取税费
    getTaxById: function getTaxById(_params, _success, _error) {
        _request('GET', API + '/v1/bs/regionEx/getById/' + _params, _params, _success, _error);
    },
    // 根据国家获取运费
    getEconomizeById: function getEconomizeById(_params, _success, _error) {
        _request('GET', API + '/v1/bs/regionShippingFee/getByEconomizeId/' + _params, _params, _success, _error);
    },
    searchListQuotationDetails: function searchListQuotationDetails(_params, _success, _error) {
        _request('GET', API + '/v1/sl/quotationOrderItem/searchListQuotationDetails', _params, _success, _error);
    },
    saveCreditQuotaApply: function saveCreditQuotaApply(_params, _success, _error) {
        _request('POST', API + '/v1/application/creditQuota/saveCreditQuotaApply', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    findNoCreditApplyClientList: function findNoCreditApplyClientList(_params, _success, _error) {
        _request('GET', API + '/v1/client/client/findNoCreditApplyClientList', _params, _success, _error);
    },
    buildSimpleRegionExTree: function buildSimpleRegionExTree(_params, _success, _error) {
        _request('GET', API + '/v1/common/helper/buildSimpleRegionExTree/' + _params, _params, _success, _error);
    },
    searchCountryRegionExList: function searchCountryRegionExList(_params, _success, _error) {
        _request('GET', API + '/v1/bs/regionEx/searchCountryRegionExList', _params, _success, _error);
    },
    getExchangeRate: function getExchangeRate(_params, _success, _error) {
        _request('POST', API + '/v1/bs/wbRmbClient/isExchangeRate', _params, _success, _error);
    },
    getCompany: function getCompany(_params, _success, _error) {
        _request('GET', API + '/v1/base/company/getById/' + _params, _params, _success, _error);
    },
    getCompanySetting: function getCompanySetting(_params, _success, _error) {
        _request('GET', API + '/v1/base/company/getCompanyShop1Setting', _params, _success, _error);
    },
    //订货端获取企业设置
    getShopCompanySetting: function getShopCompanySetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/setting/getShopCompanySetting/' + _params, _params, _success, _error);
    },
    //管理端-第一步点击就记录体验信息-体验
    experienceRegister: function experienceRegister(_params, _success, _error) {
        _request('POST', API + '/v1/account/experienceRegister', _params, _success, _error);
    },
    //管理端-体验
    experience: function experience(_params, _success, _error) {
        _request('POST', API + '/v1/account/getExperienceUser', _extends({}, _params, { type_: 1 }), _success, _error);
    },
    //订货端-体验
    shopExperience: function shopExperience(_params, _success, _error) {
        _request('POST', API + '/v1/account/getExperienceUser', _extends({}, _params, { type_: 2 }), _success, _error);
    },
    //登陆
    login: function login(_params, _success, _error) {
        _request('POST', API + '/v1/account/login', _params, _success, _error);
    },
    //混合登陆（兼容账号跟手机号去登陆）
    loginMixed: function loginMixed(_params, _success, _error) {
        _request('POST', API + '/v1/account/mixedLogin', _params, _success, _error);
    },
    //登陆
    logout: function logout(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/noAuth/logout', _params, _success, _error);
    },
    //验证验证码
    checkRegistCode: function checkRegistCode(_params, _success, _error) {
        _request('POST', API + '/v1/account/checkRegistCode', _params, _success, _error);
    },
    //创建企业
    createCompany: function createCompany(_params, _success, _error) {
        _request('POST', API + '/v1/account/createCompany', _params, _success, _error);
    },
    //获取重置密码验证码
    resetCode: function resetCode(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/noAuth/resetCode', _params, _success, _error);
    },
    //发送注册验证码
    registCode: function registCode(_params, _success, _error) {
        _request('GET', API + '/v1/account/registCode', _params, _success, _error);
    },
    //发送注册验证码--pc分享出来的注册
    registCodeNoAuth: function registCodeNoAuth(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/noAuth/registCode', _params, _success, _error);
    },
    //校验注册验证码--pc分享出来的注册
    checkNoAuthRegistCode: function checkNoAuthRegistCode(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/noAuth/checkRegistCode', _params, _success, _error);
    },
    //快速注册-订货端注册优化优化
    checkQuickRegistCode: function checkQuickRegistCode(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/noAuth/quickRegist', _params, _success, _error);
    },
    //绑定刚注册的账号--pc分享出来的注册，完成注册后继续绑定
    completeNoAuthRegist: function completeNoAuthRegist(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/noAuth/completeRegist', _params, _success, _error);
    },
    //发送绑定验证码
    bindCode: function bindCode(_params, _success, _error) {
        _request('GET', API + '/v1/base/user/bindPhoneCode', _params, _success, _error);
    },
    //验证绑定手机的验证码
    checkBindCode: function checkBindCode(_params, _success, _error) {
        _request('POST', API + '/v1/base/user/checkBindPhoneCode', _params, _success, _error);
    },
    //绑定手机号
    bindPhone: function bindPhone(_params, _success, _error) {
        _request('POST', API + '/v1/base/user/bindPhone', _params, _success, _error);
    },
    //订货端重置密码
    resetPasswordByShop: function resetPasswordByShop(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/noAuth/resetPasswordByShop', _params, _success, _error);
    },
    //获取重置密码验证码---管理端
    resetCodeByManager: function resetCodeByManager(_params, _success, _error) {
        _request('GET', API + '/v1/account/resetCode', _params, _success, _error);
    },
    //管理端重置密码---管理端
    resetPasswordByManager: function resetPasswordByManager(_params, _success, _error) {
        _request('POST', API + '/v1/account/resetPassword', _params, _success, _error);
    },
    //获取登陆用户信息
    getClientInfo: function getClientInfo(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/getClientInfo', _params, _success, _error);
    },
    //获取登陆用户信息
    getClientById: function getClientById(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/getClientById/' + _params, _params, _success, _error);
    },
    //设置默认地址
    getUserInfo: function getUserInfo(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/getShopUserInfo', _params, _success, _error);
    },
    // 保存用户客户信息
    saveUserClientInfo: function saveUserClientInfo(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/saveUserClientInfo', _params, _success, _error);
    },
    // 保存用户头像
    updateUserHeadImg: function updateUserHeadImg(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/updateUserHeadImg', _params, _success, _error);
    },
    //获取商品设置信息
    getGoodsSetting: function getGoodsSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/goodsSetting/getByCompanyId/' + _params, _params, _success, _error);
    },
    //获取销售设置信息
    getSaleSetting: function getSaleSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/setting/getSaleSetting', _params, _success, _error);
    },
    // 获取文件上传的token信息
    getUploadToken: function getUploadToken(_params, _success, _error) {
        _request('GET', API + '/v1/common/upload/getUploadToken', _params, _success, _error);
    },
    // 获取公司基本信息
    getCompanyInfo: function getCompanyInfo(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/getCompanyById/' + _params, _params, _success, _error);
    },
    //取当前登录人关联的所有账号信息列表
    getAccountList: function getAccountList(_params, _success, _error) {
        _request('GET', API + '/v1/base/user/getAccountList', _params, _success, _error);
    },
    //获取客户关联的员工列表
    getStaffList: function getStaffList(_params, _success, _error) {
        _request('GET', API + '/v1/base/user/searchList', _params, _success, _error);
    },
    // 获取商城主题
    getThemeSetting: function getThemeSetting(_params, _success, _error) {
        _request('GET', API + '/v1/setting/setting/getThemeSetting/' + _params, _params, _success, _error);
    },
    //获取当前登录用户的authCode
    getAuthCode: function getAuthCode(_params, _success, _error) {
        _request('GET', API + '/v1/account/getAuthCode', _params, _success, _error);
    },
    //获取当前登录用户的authCode
    getMobileShopVersion: function getMobileShopVersion(_params, _success, _error) {
        _request('GET', API + '/v1/account/getMobileShopVersion', _params, _success, _error);
    },
    //获取省市县
    buildRegionTree: function buildRegionTree(_params, _success, _error) {
        _request('GET', API + '/v1/common/helper/buildRegionTree', _params, _success, _error);
    },
    buildSimpleRegionTree: function buildSimpleRegionTree(_params, _success, _error) {
        _request('GET', API + '/v1/common/helper/buildSimpleRegionTree', _params, _success, _error);
    },
    //获取微信jsticket
    getWxTicket: function getWxTicket(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/noAuth/getWxTicket', _params, _success, _error);
    },
    //获取微信jsticket/
    getWxQrcode: function getWxQrcode(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/noAuth/getWxQrCode', _params, _success, _error);
    },
    //获取分享设置
    getShareSetting: function getShareSetting(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/getShareSetting', _params, _success, _error);
    },
    //保存分享设置
    saveShareSetting: function saveShareSetting(_params, _success, _error) {
        _request('POST', API + '/v1/shop/account/saveShareSetting', _params, _success, _error);
    },
    // 添加客服消息
    addMsgForClient: function addMsgForClient(_params, _success, _error) {
        _request('POST', API + '/v1/client/client/addMsgForClient', _params, _success, _error);
    },
    // 获取指定对话消息列表
    searchMsgList: function searchMsgList(_params, _success, _error) {
        _request('GET', API + '/v1/client/client/searchMsgList', _params, _success, _error);
    },
    // 获取指定对话消息列表
    markReadByClient: function markReadByClient(_params, _success, _error) {
        _request('POST', API + '/v1/client/client/markReadByClient/' + _params, _params, _success, _error);
    },
    // 获取消息对话列表
    searchGroupMsgListForClient: function searchGroupMsgListForClient(_params, _success, _error) {
        _request('GET', API + '/v1/client/client/searchGroupMsgListForClient', _params, _success, _error);
    },
    // 关键词搜索
    searchKeyWordList: function searchKeyWordList(_params, _success, _error) {
        _request('GET', API + '/v1/shop/goods/noAuth/searchKeyWordList', _params, _success, _error);
    },

    // 个人中心
    getShopUserInfoForHome: function getShopUserInfoForHome(_params, _success, _error) {
        _request('GET', API + '/v1/shop/account/getShopUserInfoForHome', _params, _success, _error);
    },
    // 获取商城帮助
    shopHelpTypeSearchList: function shopHelpTypeSearchList(_params, _success, _error) {
        _request('GET', API + '/v1/shopHelp/shopHelpType/noAuth/searchListForShop', _params, _success, _error);
    },
    // 获取微信用户信息
    getWeChatUserInfo: function getWeChatUserInfo(_params, _success, _error) {
        _request('GET', API + '/v1/setting/weChatSetting/noAuth/getWeChatUserInfo', _params, _success, _error);
    },
    // 微信openId登录
    openIdLogin: function openIdLogin(_params, _success, _error) {
        _request('POST', API + '/v1/account/openIdLogin', _params, _success, _error);
    },
    // 绑定微信openId
    bindOpenId: function bindOpenId(_params, _success, _error) {
        _request('POST', API + '/v1/account/bindOpenId', _params, _success, _error);
    },
    // 登录并绑定微信openId
    bindOpenIdForLogin: function bindOpenIdForLogin(_params, _success, _error) {
        _request('POST', API + '/v1/account/bindOpenIdForLogin', _params, _success, _error);
    },
    // 保存/修改商城注册记录
    shopRegisterSave: function shopRegisterSave(_params, _success, _error) {
        _request('POST', API + '/v1/shopRegister/noAuth/save', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //
    getApplicationStatus: function getApplicationStatus(_params, _success, _error) {
        _request('GET', API + '/v1/application/noAuth/getApplicationStatus', _params, _success, _error);
    },
    //订单发票统计列表
    searchOrderInvoiceCountList: function searchOrderInvoiceCountList(_params, _success, _error) {
        _request('GET', API + '/v1/invoice/invoiceLog/searchOrderInvoiceCountList', _params, _success, _error);
    },
    //订单发票统计列表
    searchInvoiceLogMap: function searchInvoiceLogMap(_params, _success, _error) {
        _request('POST', API + '/v1/invoice/invoiceLog/searchInvoiceLogMap', _extends({}, _params, {
            _meth: 'body'
        }), _success, _error);
    },
    //订单发票详情
    getInvoiceById: function getInvoiceById(_params, _success, _error) {
        _request('GET', API + '/v1/invoice/invoiceLog/getById/' + _params, _params, _success, _error);
    },
    //获取AuthCode
    getOpenAuthCode: function getOpenAuthCode(_params, _success, _error) {
        _request('GET', API + '/openapi/v1/auth/getAuthCode', _params, _success, _error);
    }
};
//支付模块接口
var PayFetch = exports.PayFetch = {
    getOrderInfoForStripe: function getOrderInfoForStripe(_params, _success, _error) {
        _request('GET', API + '/v1/stripePay/apply/noAuth/getOrderInfo', _params, _success, _error);
    },
    //stripe
    createPaymentForStripe: function createPaymentForStripe(_params, _success, _error) {
        _request('GET', API + '/v1/stripePay/apply/createPaymentIntent', _params, _success, _error);
    },
    palPay: function palPay(_params, _success, _error) {
        _request('GET', API + '/v1/paypal/notify/noAuth/paySuccess1', _params, _success, _error);
    },
    //PayPal
    createOrderByPayPal: function createOrderByPayPal(_params, _success, _error) {
        _request('GET', API + '/v1/paypal/apply/createOrder', _params, _success, _error);
    },
    //构建支付宝支付参数
    buildWebAlipayApi: function buildWebAlipayApi(_params, _success, _error) {
        _request('POST', API + '/v1/shop/pay/buildWebAlipayApi', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //构建订单合并支付支付宝支付请求
    buildCombinedPayWebAlipayApi: function buildCombinedPayWebAlipayApi(_params, _success, _error) {
        _request('POST', API + '/v1/shop/pay/buildCombinedPayWebAlipayApi', _params, _success, _error);
    },
    //微信公众号支付
    pubWeixinApi: function pubWeixinApi(_params, _success, _error) {
        _request('GET', API + '/v1/shop/pay/pubWeixinApi', _params, _success, _error);
    },
    weixinH5Api: function weixinH5Api(_params, _success, _error) {
        _request('GET', API + '/v1/shop/pay/noAuth/weixinH5Api', _params, _success, _error);
    },
    //微信外h5订单合并支付
    weixinCombinedPayH5Api: function weixinCombinedPayH5Api(_params, _success, _error) {
        _request('GET', API + '/v1/shop/pay/weixinCombinedPayH5Api', _params, _success, _error);
    },
    // 合并付款 公众号支付
    weixinCombinedPayApi: function weixinCombinedPayApi(_params, _success, _error) {
        _request('GET', API + '/v1/shop/pay/weixinCombinedPayApi', _params, _success, _error);
    },
    //合并付款预存款和线下付
    combinedPayByOfflineOrPre: function combinedPayByOfflineOrPre(_params, _success, _error) {
        _request('POST', API + '/v1/finance/combinedPay/combinedPayByOfflineOrPre', _params, _success, _error);
    },
    //构建预存款充值支付宝支付请求
    buildPreBalanceRechargeAlipayApi: function buildPreBalanceRechargeAlipayApi(_params, _success, _error) {
        _request('POST', API + '/v1/shop/pay/buildPreBalanceRechargeAlipayApi', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //预存款充值微信外h5支付
    weixinPreBalanceRechargeH5Api: function weixinPreBalanceRechargeH5Api(_params, _success, _error) {
        _request('GET', API + '/v1/shop/pay/weixinPreBalanceRechargeH5Api', _params, _success, _error);
    },
    //预存款充值微信公众号支付
    pubPreBalanceRechargeWeixinApi: function pubPreBalanceRechargeWeixinApi(_params, _success, _error) {
        _request('GET', API + '/v1/shop/pay/pubPreBalanceRechargeWeixinApi', _params, _success, _error);
    },
    // 组合支付
    combinationPay: function combinationPay(_params, _success, _error) {
        _request('POST', API + '/v1/shop/order/combinationPay', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //获取支付状态
    getPayFinanceStatus: function getPayFinanceStatus(_params, _success, _error) {
        _request('GET', API + '/v1/shop/pay/getPayFinanceStatus', _params, _success, _error);
    },
    // 京东支付h5收银台
    jdOrderH5Cashier: function jdOrderH5Cashier(_params, _success, _error) {
        _request('POST', API + '/v1/jdPay/apply/noAuth/orderH5Cashier', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    jdOrderH5CashierV2: function jdOrderH5CashierV2(_params, _success, _error) {
        _request('POST', API + '/v2/jdPay/apply/orderH5Cashier', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    // 预存款充值h5收银台
    preBalanceRechargeH5Cashier: function preBalanceRechargeH5Cashier(_params, _success, _error) {
        _request('POST', API + '/v1/jdPay/apply/preBalanceRechargeH5Cashier', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    // 合并支付h5收银台
    combinedH5Cashier: function combinedH5Cashier(_params, _success, _error) {
        _request('POST', API + '/v1/jdPay/apply/combinedH5Cashier', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //查询是否开通产品类别
    checkPayType: function checkPayType(_params, _success, _error) {
        _request('GET', API + '/v1/jdPay/merchant/checkPayType', _params, _success, _error);
    },
    //查询是否开通产品类别
    getJdAccountByClientId: function getJdAccountByClientId(_params, _success, _error) {
        _request('POST', API + '/v1/fn/jdAccount/noAuth/getByClientId', _extends({ _meth: 'body' }, _params), _success, _error);
    }

};
//代客下单
var ClientFetch = exports.ClientFetch = {
    //创建订单
    saveByClient: function saveByClient(_params, _success, _error) {
        _request('POST', API + '/v1/sale/valetSale/saveByClient', _params, _success, _error);
    },
    //根据规格ids串获取商品优惠信息
    getPromotionByProductIdsByClient: function getPromotionByProductIdsByClient(_params, _success, _error) {
        _request('GET', API + '/v1/sale/valetSale/getPromotionByProductIdsByClient', _params, _success, _error);
    },
    //获取订单优惠信息
    getPromotionByClient: function getPromotionByClient(_params, _success, _error) {
        _request('GET', API + '/v1/sale/valetSale/getPromotionByClient', _params, _success, _error);
    },
    //商城商品分页查询
    searchListForShopByClient: function searchListForShopByClient(_params, _success, _error) {
        _request('GET', API + '/v1/sale/valetSale/noAuth/searchListForShopByClient', _params, _success, _error);
    },
    //客户列表
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/v1/client/client/searchList', _params, _success, _error);
    },
    //新增客户
    addNewClient: function addNewClient(_params, _success, _error) {
        _request('POST', API + '/v1/client/client/save', _params, _success, _error);
    },
    // 获取商城主题
    companyShopToMgr: function companyShopToMgr(_params, _success, _error) {
        _request('POST', API + '/v1/client/companyShop/toMgr/' + _params, _params, _success, _error);
    }
};

var ApplicationFetch = exports.ApplicationFetch = {
    getMiniProgram: function getMiniProgram(_params, _success, _error) {
        _request('GET', API + '/v1/application/miniProgram/noAuth/getByCompanyId/' + _params, _params, _success, _error);
    }
};
//积分商城模块
var IntegralFetch = exports.IntegralFetch = {
    //分页获取积分商品表列表
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/api/v1/score/goods/searchList', _params, _success, _error);
    },
    //分页获取积分商品表列表
    getById: function getById(_params, _success, _error) {
        _request('GET', API + '/api/v1/score/goods/getById/' + _params, _params, _success, _error);
    },
    //获取积分商品分类列表
    listAll: function listAll(_params, _success, _error) {
        _request('GET', API + '/api/v1/score/goods/listAllType', _params, _success, _error);
    },
    //获取我的积分信息
    getMyScore: function getMyScore(_params, _success, _error) {
        _request('GET', API + '//api/v1/buyer/mine/getMyScore', _params, _success, _error);
    },
    //获取我的积分明细列表
    getMyScoreLog: function getMyScoreLog(_params, _success, _error) {
        _request('GET', API + '/api/v1/buyer/mine/getMyScoreLog', _params, _success, _error);
    },
    //获取积分规则设置
    getRulesSetting: function getRulesSetting(_params, _success, _error) {
        _request('GET', API + '/api/v1/buyer/mine/getRulesSetting', _params, _success, _error);
    },
    //创建积分订单
    createOrder: function createOrder(_params, _success, _error) {
        _request('POST', API + '/api/v1/score/order/createOrder', _params, _success, _error);
    },
    //分页获取积分订单信息列表
    searchOrderList: function searchOrderList(_params, _success, _error) {
        _request('GET', API + '/api/v1/score/order/searchList', _params, _success, _error);
    },
    //获取积分订单信息
    getOrderById: function getOrderById(_params, _success, _error) {
        _request('GET', API + '/api/v1/score/order/getById/' + _params, _params, _success, _error);
    },
    //根据快递单号获取物流信息
    getLogisticInfo: function getLogisticInfo(_params, _success, _error) {
        _request('GET', API + '/api/v1/common/data/getLogisticInfo', _params, _success, _error);
    },
    //根据快递单号获取物流信息
    getMySign: function getMySign(_params, _success, _error) {
        _request('GET', API + '/api/v1/buyer/mine/getMySign', _params, _success, _error);
    },
    //签到
    sign: function sign(_params, _success, _error) {
        _request('GET', API + '/api/v1/buyer/mine/sign', _params, _success, _error);
    },
    //签到
    getScoreCompanySetting: function getScoreCompanySetting(_params, _success, _error) {
        _request('GET', API + '/api/v1/buyer/mine/getScoreCompanySetting', _params, _success, _error);
    }
};
// 退货
var SaleBackFetch = exports.SaleBackFetch = {
    // 申请退货
    save: function save(_params, _success, _error) {
        _request('POST', API + '/v1/sale/saleBack/save', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    // 退货列表
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/v1/sale/saleBack/searchList', _params, _success, _error);
    },
    // 退货列表
    getById: function getById(_params, _success, _error) {
        _request('GET', API + '/v1/sale/saleBack/getById/' + _params, _params, _success, _error);
    },
    // 退货原因
    getSaleBackReasonList: function getSaleBackReasonList(_params, _success, _error) {
        _request('GET', API + '/v1/sale/saleBack/searchListForSaleBackReason', _params, _success, _error);
    }
};
// 销售中心
var DistributionFetch = exports.DistributionFetch = {
    //客户信息
    getByClientId: function getByClientId(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionClientData/getByClientId/' + _params, _params, _success, _error);
    },
    //手机端客户分销销售中心统计数据
    getCountDateByClientId: function getCountDateByClientId(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionClientData/getCountDateByClientId/' + _params, _params, _success, _error);
    },
    //手机端客户业绩统计
    getPerformanceStatistics: function getPerformanceStatistics(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionClientData/getPerformanceStatistics/' + _params, _params, _success, _error);
    },
    //我的客户统计
    searchChildenClientList: function searchChildenClientList(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionClientData/searchChildenClientList', _params, _success, _error);
    },
    //订单统计
    searchOrderList: function searchOrderList(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionRebate/searchList', _params, _success, _error);
    },
    //保存提现账号
    saveAccount: function saveAccount(_params, _success, _error) {
        _request('POST', API + '/v1/distribution/distributionClientData/save', _params, _success, _error);
    },
    //提现
    distributionWithdrawalSave: function distributionWithdrawalSave(_params, _success, _error) {
        _request('POST', API + '/v1/distribution/distributionWithdrawal/save', _params, _success, _error);
    },
    //提现
    transferToFinance: function transferToFinance(_params1, _params2, _success, _error) {
        _request('POST', API + '/v1/distribution/distributionWithdrawal/transferToFinance/' + _params1 + '/' + _params2 + ' ', _params1, _success, _error);
    },
    //账户明细
    searchLogList: function searchLogList(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionPayLog/searchList', _params, _success, _error);
    },
    //提现记录
    searchLWithdrawalLogList: function searchLWithdrawalLogList(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionWithdrawal/searchList', _params, _success, _error);
    },
    //设置客户上级客户
    saveParentClient: function saveParentClient(_params, _success, _error) {
        _request('POST', API + '/v1/distribution/distributionClientData/saveParentClient', _params, _success, _error);
    },
    //推广商品列表
    searchListForShop: function searchListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionRebate/noAuth/searchListForShop', _params, _success, _error);
    },
    //最高佣金
    getGoodsCommissionById: function getGoodsCommissionById(_params, _success, _error) {
        _request('GET', API + '/v1/distribution/distributionRebate/noAuth/getGoodsById/' + _params, _params, _success, _error);
    }
};
// 预存款
var DepositFetch = exports.DepositFetch = {
    checkClientBalance: function checkClientBalance(_params, _success, _error) {
        _request('GET', API + '/v1/fn/rechargeDeduct/checkClientBalance', _params, _success, _error);
    },
    save: function save(_params, _success, _error) {
        _request('POST', API + '/v1/fn/rechargeDeduct/save', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    //查询企业的预存款充值设置明细
    searchItemListByLogin: function searchItemListByLogin(_params, _success, _error) {
        _request('GET', API + '/v1/shop/preBalanceRecharge/searchItemListByLogin', _params, _success, _error);
    },
    //申请预存款充值充值
    applyRecharge: function applyRecharge(_params, _success, _error) {
        _request('POST', API + '/v1/shop/preBalanceRecharge/applyRecharge', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    // 查询存款充值记录
    getById: function getById(_params, _success, _error) {
        _request('POST', API + '/v1/shop/preBalanceRecharge/getById/' + _params, _params, _success, _error);
    }
};
// 代金券接口
var VouchersFetch = exports.VouchersFetch = {
    // 获取代金券列表
    searchClientVouchersList: function searchClientVouchersList(_params, _success, _error) {
        _request('GET', API + '/v1/vouchers/vouchers/searchClientVouchersList', _params, _success, _error);
    },
    // 更新代金券列表
    updateIsReadByIds: function updateIsReadByIds(_params, _success, _error) {
        _request('GET', API + '/v1/vouchers/vouchers/updateIsReadByIds/' + _params, _params, _success, _error);
    },
    // 获取代金券明細
    searchVouchersLog: function searchVouchersLog(_params, _success, _error) {
        _request('GET', API + '/v1/vouchers/vouchersLog/searchList', _params, _success, _error);
    },
    // 根据商品获取代金券
    searchListByGoodsIdAndClientId: function searchListByGoodsIdAndClientId(_params, _success, _error) {
        _request('GET', API + '/v1/vouchers/vouchers/searchListByGoodsIdAndClientId', _params, _success, _error);
    },
    // 根据规格获取代金券
    searchListByProductIdAndClientId: function searchListByProductIdAndClientId(_params, _success, _error) {
        _request('GET', API + '/v1/vouchers/vouchers/searchListByProductIdAndClientId', _params, _success, _error);
    }
};
// 代金券接口
var ClientAddressFetch = exports.ClientAddressFetch = {
    //获取送货地址
    listAddress: function listAddress(_params, _success, _error) {
        _request('GET', API + '/v1/shop/address/listByLoginUser', _params, _success, _error);
    },
    //保存、修改地址
    saveAddress: function saveAddress(_params, _success, _error) {
        _request('POST', API + '/v1/shop/address/save', _extends({}, _params, { _meth: 'body' }), _success, _error);
    },
    //获取地址
    deleteAddress: function deleteAddress(_params, _success, _error) {
        _request('DELETE', API + '/v1/shop/address/deleteById/' + _params, _params, _success, _error);
    },
    //设置默认地址
    setDefault: function setDefault(_params, _success, _error) {
        _request('POST', API + '/v1/shop/address/setDefault/' + _params, _params, _success, _error);
    }
};
//线下体验馆模块
var ExperienceFetch = exports.ExperienceFetch = {
    //分页获取线下体验馆列表
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/v1/store/experienceShop/searchList', _params, _success, _error);
    },
    //分页获取省市区列表
    searchRegionList: function searchRegionList(_params, _success, _error) {
        _request('GET', API + '/v1/common/helper/searchRegionList', _params, _success, _error);
    },
    //获取线下体验馆
    getById: function getById(_params, _success, _error) {
        _request('GET', API + '/v1/store/experienceShop/getById/' + _params, _params, _success, _error);
    }

};
//授信
var CreditQuotaFetch = exports.CreditQuotaFetch = {
    //客户申请授信
    saveQuotaApply: function saveQuotaApply(_params, _success, _error) {
        _request('POST', API + '/v1/application/creditQuota/saveCreditQuotaApply', _extends({}, _params, {
            _meth: 'body'
        }), _success, _error);
    },
    selectExistQuotationOrderByClient: function selectExistQuotationOrderByClient(_params, _success, _error) {
        _request('POST', API + '/v1/sl/quotationOrder/selectExistQuotationOrderByClient', _extends({}, _params, {
            _meth: 'body'
        }), _success, _error);
    },
    //客户申请授信
    getQuotaApplyById: function getQuotaApplyById(_params, _success, _error) {
        _request('GET', API + '/v1/application/creditQuota/getCreditQuotaApplyByClientId', _params, _success, _error);
    },
    //分页获取授信额度变更列表
    searchLogListForShop: function searchLogListForShop(_params, _success, _error) {
        _request('GET', API + '/v1/application/creditQuota/searchLogListForShop', _params, _success, _error);
    }
};
// 免费领
var FreeGoodsFetch = exports.FreeGoodsFetch = {
    //购物车查看对应客户类型可参与的免费活动信息
    freeActivityByClientType: function freeActivityByClientType(_params, _success, _error) {
        _request('GET', API + '/v1/sl/freeGoodsActivity/freeActivityByClientType', _params, _success, _error);
    }
};
// 串号查询
var GoodsSnFetch = exports.GoodsSnFetch = {
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/v1/hs/goodsSnCheck/searchList', _params, _success, _error);
    },
    //查询指定企业串号查询设置, 企业id为空时,企业id=登录用户企业
    getSearchSetting: function getSearchSetting(_params, _success, _error) {
        _request('GET', API + '/v1/house/goodsSnSearchSetting/noAuth/getSearchSetting', _params, _success, _error);
    },
    //精确查询串号信息, 企业id为空时,企业id=登录用户企业
    getByCode: function getByCode(_params, _success, _error) {
        _request('GET', API + '/v1/house/goodsSn/noAuth/getByCode', _params, _success, _error);
    },
    checkGoodsSn: function checkGoodsSn(_params, _success, _error) {
        _request('GET', API + '/v1/hs/goodsSnCheck/checkGoodsSn', _params, _success, _error);
    },
    save: function save(_params, _success, _error) {
        _request('POST', API + '/v1/hs/goodsSnCheck/save', _extends({}, _params, { _meth: 'body' }), _success, _error);
    }

};
// 自提点
var PickUpStationFetch = exports.PickUpStationFetch = {
    //分页查询自提点
    searchList: function searchList(_params, _success, _error) {
        _request('GET', API + '/v1/house/selfPickSite/searchListForShop', _params, _success, _error);
    },
    //客户默认自提点
    getClientDefaultSite: function getClientDefaultSite(_params, _success, _error) {
        _request('POST', API + '/v1/house/selfPickSite/getClientDefaultSite/' + _params, _params, _success, _error);
    }
};

var AggregatePayFetch = exports.AggregatePayFetch = {
    //获取聚合配置信息
    getByType: function getByType(_params, _success, _error) {
        _request('POST', API + '/v1/finance/aggregatePayConfig/noAuth/getByType', _extends({}, _params, { _meth: 'body' }), _success, _error);
    },
    //微信外请求微信小程序唤醒微信小程序支付
    buildWeixinMiniProgramUrlLink: function buildWeixinMiniProgramUrlLink(_params, _success, _error) {
        _request('GET', API + '/v1/yiShengPay/apply/buildWeixinMiniProgramUrlLink', _params, _success, _error);
    },
    //微信外请求微信小程序唤醒微信小程序支付 京东支付
    jdPayBuildWeixinMiniProgramUrlLink: function jdPayBuildWeixinMiniProgramUrlLink(_params, _success, _error) {
        _request('POST', API + '/v1/jdPay/apply/buildWeixinMiniProgramUrlLink', _extends({}, _params, {
            _meth: 'body'
        }), _success, _error);
    },
    //微信外请求微信小程序唤醒微信小程序支付 京东支付
    buildWechatMiniProgramUrlLinkForNative: function buildWechatMiniProgramUrlLinkForNative(_params, _success, _error) {
        _request('POST', API + '/v1/jdPay/apply/buildWechatMiniProgramUrlLinkForNative', _extends({}, _params, {
            _meth: 'body'
        }), _success, _error);
    },
    // H5单个支付
    h5PayApi: function h5PayApi(_params, _success, _error) {
        _request('GET', API + '/v1/kuaiqian/apply/h5PayApi', _params, _success, _error);
    },
    // H5合并支付
    h5CombinedPay: function h5CombinedPay(_params, _success, _error) {
        _request('GET', API + '/v1/kuaiqian/apply/combinedH5PayApi', _params, _success, _error);
    },
    // 快钱公众号支付
    orderPayApi: function orderPayApi(_params, _success, _error) {
        _request('GET', API + '/v1/kuaiqian/apply/orderPayApi', _params, _success, _error);
    },
    combinedPayApi: function combinedPayApi(_params, _success, _error) {
        _request('GET', API + '/v1/kuaiqian/apply/combinedPayApi', _params, _success, _error);
    },
    sdkPayApi: function sdkPayApi(_params, _success, _error) {
        _request('GET', API + '/v1/kuaiqian/apply/sdkPayApi', _params, _success, _error);
    },
    // H5单个支付
    huifuH5PayApi: function huifuH5PayApi(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/noAuth/orderPayApi', _params, _success, _error);
    },
    h5HuiFucombinedPay: function h5HuiFucombinedPay(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/combinedPayApi', _params, _success, _error);
    },
    wxMiniPayApi: function wxMiniPayApi(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/wxMiniPayApi', _params, _success, _error);
    },
    weiXinPayAppApi: function weiXinPayAppApi(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/weiXinPayAppApi', _params, _success, _error);
    },
    aliPayMiniPayApi: function aliPayMiniPayApi(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/aliPayMiniPayApi', _params, _success, _error);
    },
    aliPayAppApi: function aliPayAppApi(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/aliPayAppApi', _params, _success, _error);
    },
    getHuifuAccount: function getHuifuAccount(_params, _success, _error) {
        _request('GET', API + '/v1/finance/account/getAccountByType', _params, _success, _error);
    },
    wxHuiFuMiniPayApi: function wxHuiFuMiniPayApi(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/wxHuiFuMiniPayApi', _params, _success, _error);
    },
    wxH5PreBalanceRechargeApi: function wxH5PreBalanceRechargeApi(_params, _success, _error) {
        _request('GET', API + '/v1/huifu/apply/wxH5PreBalanceRechargeApi', _params, _success, _error);
    }
};

// 行为分析模块接口
var BehaviorFetch = exports.BehaviorFetch = {
    // 单事件上报
    track: function track(_params, _success, _error) {
        _request('POST', API + '/v1/shop/behavior/track', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    // 批量事件上报
    trackBatch: function trackBatch(_params, _success, _error) {
        _request('POST', API + '/v1/shop/behavior/track/batch', _extends({ _meth: 'body' }, _params), _success, _error);
    },
    // 获取客户行为标签
    getTagsByClientId: function getTagsByClientId(_params, _success, _error) {
        _request('GET', API + '/v1/shop/behavior/tags/' + _params, _params, _success, _error);
    },
    // 获取搜索热词
    getHotKeywords: function getHotKeywords(_params, _success, _error) {
        _request('GET', API + '/v1/shop/behavior/hotKeywords', _params, _success, _error);
    },
    // 获取加购未购列表
    getCartNoBuy: function getCartNoBuy(_params, _success, _error) {
        _request('GET', API + '/v1/shop/behavior/cartNoBuy', _params, _success, _error);
    },
    // 获取客户行为画像
    getClientProfile: function getClientProfile(_params, _success, _error) {
        _request('GET', API + '/v1/shop/behavior/profile/' + _params, _params, _success, _error);
    },
    // 退订营销推送
    unsubscribe: function unsubscribe(_params, _success, _error) {
        _request('POST', API + '/v1/shop/behavior/unsubscribe', _params, _success, _error);
    },
    // 取消退订
    cancelUnsubscribe: function cancelUnsubscribe(_params, _success, _error) {
        _request('POST', API + '/v1/shop/behavior/cancelUnsubscribe', _params, _success, _error);
    }
};

var ConsignFetch = exports.ConsignFetch = {
    searchPickUpProductList: function searchPickUpProductList(_params, _success, _error) {
        _request('GET', API + '/v1/hs/pickUpGoods/searchPickUpProductList', _params, _success, _error);
    },
    searchConsignProductList: function searchConsignProductList(_params, _success, _error) {
        _request('GET', API + '/v1/hs/consignManager/searchConsignProductList', _params, _success, _error);
    },
    consignStockSave: function consignStockSave(_params, _success, _error) {
        _request('POST', API + '/v1/hs/consignManager/save', _extends({}, _params, { _meth: 'body' }), _success, _error);
    },
    pickUpGoodsSave: function pickUpGoodsSave(_params, _success, _error) {
        _request('POST', API + '/v1/hs/pickUpGoods/save', _extends({}, _params, { _meth: 'body' }), _success, _error);
    },
    getPickUpGoodsById: function getPickUpGoodsById(_params, _success, _error) {
        _request('GET', API + '/v1/hs/pickUpGoods/getById/' + _params, _params, _success, _error);
    },
    searchGoodsManagerList: function searchGoodsManagerList(_params, _success, _error) {
        _request('GET', API + '/v1/hs/consignManager/searchGoodsManagerList', _params, _success, _error);
    },
    searchPickUpGoodsList: function searchPickUpGoodsList(_params, _success, _error) {
        _request('GET', API + '/v1/hs/pickUpGoods/searchListForShop', _params, _success, _error);
    },
    getConsignManagerSetting: function getConsignManagerSetting(_params, _success, _error) {
        _request('GET', API + '/v1/ap/consignManagerSetting/getByCompanyId', _params, _success, _error);
    },
    //确认收货
    receive: function receive(_params, _success, _error) {
        _request('POST', API + '/v1/hs/pickUpGoods/receive', _extends({}, _params, { _meth: 'body' }), _success, _error);
    }
};

// 砍价活动模块接口
var BargainFetch = exports.BargainFetch = {
    // 根据订单获取可用活动
    getByOrder: function getByOrder(_params, _success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/getByOrder/' + _params, _params, _success, _error);
    },
    getByOrderNoAuth: function getByOrderNoAuth(_params, _success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/noAuth/getByOrder/' + _params.order_id_ + '/' + _params.company_id_ + '/' + _params.client_id_, _params, _success, _error);
    },
    // 发起砍价
    joinActivity: function joinActivity(_params, _success, _error) {
        _request('POST', API + '/v1/sale/bargainActivity/joinActivity', _extends({}, _params, { _meth: 'body' }), _success, _error);
    },
    // 帮好友砍价
    helpBargain: function helpBargain(_params, _success, _error) {
        _request('POST', API + '/v1/sale/bargainActivity/helpBargain', _extends({}, _params, { _meth: 'body' }), _success, _error);
    },
    // 通过分享码获取详情
    getByShareCodeByNoAuth: function getByShareCodeByNoAuth(_params, _success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/noAuth/getByShareCode/' + _params, _params, _success, _error);
    },
    // 通过分享码获取详情
    getByShareCode: function getByShareCode(_params, _success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/getByShareCode/' + _params, _params, _success, _error);
    },
    // 获取我的砍价详情
    getMyBargain: function getMyBargain(_params, _success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/getMyBargain/' + _params.activityId + '/' + _params.orderId, _params, _success, _error);
    },
    // 获取我的砍价活动列表
    getMyBargainList: function getMyBargainList(_success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/getMyBargainList', null, _success, _error);
    },
    // 获取帮砍记录列表
    getHelpList: function getHelpList(_params, _success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/getHelpList/' + _params, _params, _success, _error);
    },
    // 查询订单砍价券
    getBargainCoupon: function getBargainCoupon(_params, _success, _error) {
        _request('GET', API + '/v1/sale/bargainActivity/getBargainCoupon/' + _params, _params, _success, _error);
    }
};

/**
 * fetch请求数据Model
 * @param _method   请求方法
 * @param  _url     请求url
 * @param _params   请求参数
 * @param _onSuccess    请求成功回调
 * @param _onError      请求失败回调
 */
function _request(_method, _url, _params, _onSuccess, _onError) {
    var isMobile = navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
    var token = '';
    try {
        token = JSON.parse(localStorage.getItem("token"));
    } catch (err) {
        token = localStorage.removeItem("token");
    }
    /**
     * params._meth === 'body' 兼容后端body实体传参
     * */

    var paramStr = "";
    // 性能优化：支持数组参数作为JSON body发送（批量接口）
    if (Array.isArray(_params)) {
        paramStr = JSON.stringify(_params);
    } else if (_params && _params._meth === 'body' || _method.toLowerCase() === 'post') {
        paramStr = _params && _params._meth === 'body' || _method.toLowerCase() === 'body' ? JSON.stringify(_params) : Tools._getSearchFromObjectNoEncode(_commonUtils.CommonUtil.objSort(_params)).substring(1);
    } else if (_method === 'GET') {
        if (Object.prototype.toString.call(_params) === '[object Object]') {
            if (_params && Object.keys(_params).length > 0) {
                var obj = _commonUtils.CommonUtil.objSort(_params);
                Object.keys(obj).forEach(function (key) {
                    paramStr += key + obj[key];
                });
            }
        }
    }

    var _options = {
        method: _method,
        // mode: "cors",
        headers: {
            'Content-Type': Array.isArray(_params) || _params && _params._meth === 'body' ? 'application/json;charset=utf-8' : 'application/x-www-form-urlencoded',
            'yunshltoken': token,
            'timestamp': _commonUtils.CommonUtil.getNonce(),
            'nonce': _commonUtils.CommonUtil.getRandomParam(),
            'tokentype': _appUtil2.default.isApp ? 'APP' : isMobile ? 'WEBAPP' : 'PC',
            'appsource': _appUtil2.default.isIos ? 'IOS' : _appUtil2.default.isAndroid ? 'ANDROID' : isMobile ? 'WEBAPP' : 'PC'
        },
        body: _method.toLowerCase() === 'get' ? null : Array.isArray(_params) ? JSON.stringify(_params) : _params && _params._meth === 'body' ? JSON.stringify(_params) : Tools._getSearchFromObject(_params).substring(1)
    };
    // console.log('timestamp',_options.headers.timestamp)
    // console.log('nonce',_options.headers.nonce)
    // console.log('content',paramStr)
    var checkKey = reqKey + _options.headers.yunshltoken + _options.headers.timestamp + _options.headers.nonce + paramStr;
    _options.headers.signnatrue = (0, _md2.default)(checkKey);
    if (_method.toLowerCase() == 'get') {
        _url += Tools._getSearchFromObject(_params);
    }
    fetch(_url, _options).then(Tools.checkStates).then(Tools.parseJSON).then(function (data) {
        if (typeof _onSuccess === 'function') {
            _onSuccess(data);
        }
    }).catch(function (err) {
        console.log('_url====>', _url);
        console.log('err====>', err);
        if (err.state == 401) {
            console.log('err.state==========>', err.state);
            var _lang = _storageUtil2.default.getItem(_constant.SystemConst.lang) || 'zh';
            var titleTips = messages[_lang]['DengLuGuoQi'] || '登录过期';
            var contentTips = messages[_lang]['DLGQ_QCXDL'] || '登录信息已经过期，请重新登录';
            var statusCode = undefined;
            if (err["status-code"] && !window.statusCode) {
                statusCode = err["status-code"];
                if (statusCode === '401.3') {
                    //下线通知,您的账号已在其他设备登录，请重新登录。如非本人操作，请及时修改密码
                    titleTips = messages[_lang]['XiaXianTongZhi'] || '下线通知';
                    contentTips = messages[_lang]['NDZHYZQTSB'] || '您的账号已在其他设备登录，请重新登录。如非本人操作，请及时修改密码';
                } else if (statusCode === '401.4') {
                    //登录过期，登录信息已经过期，请重新登录
                    titleTips = messages[_lang]['DengLuGuoQi'] || '登录过期';
                    contentTips = messages[_lang]['DLGQ_QCXDL'] || '登录信息已经过期，请重新登录';
                }
            }
            if (!window.statusCode) {
                window.statusCode = statusCode;
                var btnSetting = {
                    confirmLabel: messages[_lang]['QueDing'] || '确定'
                };
                if (_storageUtil2.default.getItem('isMgr') === 0) {
                    btnSetting = { cancelLabel: messages[_lang]['QuXiao'] || '取消' };
                }
                _Utils2.default.title(titleTips, contentTips, btnSetting).then(function () {
                    _BusinessUtil.BusinessUtil.toLogout();
                    window.statusCode = undefined;
                    return;
                }, function () {
                    if (!_storageUtil2.default.getItem('allowVisitor')) {
                        _BusinessUtil.BusinessUtil.toLogout();
                    } else {
                        _BusinessUtil.BusinessUtil.clearAccount();
                    }
                });
            }
        }
        if (err.response) {
            err.response.text().then(function (text) {
                if (!text) return;
                var data = {};
                try {
                    data = JSON.parse(text);
                } catch (parseErr) {
                    return;
                }
                if (data.message) console.error(data.message);
            }).catch(function () {});
        }
        if (typeof _onError === "function") {
            _onError(err);
        }
    });
}

var Tools = {
    // 检查请求响应
    checkStates: function checkStates(response) {
        // document.getElementById('loading').setAttribute('class', 'loadEffect');
        if (response.ok) {
            return response;
        } else {
            var error = new Error(response.statusText);
            error["status-code"] = response.headers.get("status-code");
            error.state = response.status;
            error.response = response;
            throw error;
        }
    },
    // 解析成json串
    parseJSON: function parseJSON(response) {
        return response.json();
    },
    // 拼接get请求参数到url
    _getSearchFromObject: function _getSearchFromObject(param, key) {
        if (param == null) return '';
        if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) !== 'object') {
            return '';
        }
        var _search = '?';
        for (var _key in param) {
            _search += _key + '=' + encodeURIComponent(param[_key]) + '&';
        }
        return _search.slice(0, -1);
    },
    // 拼接get请求参数到url
    _getSearchFromObjectNoEncode: function _getSearchFromObjectNoEncode(param, key) {
        if (param == null) return '';
        if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) !== 'object') {
            return '';
        }
        var _search = '?';
        for (var _key2 in param) {
            _search += _key2 + '=' + param[_key2] + '&';
        }
        return _search.slice(0, -1);
    }
};

/***/ }),
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _urlConfig = __webpack_require__(77);

var _urlConfig2 = _interopRequireDefault(_urlConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UA = localStorage.getItem('wkData-webUA') || window.navigator.userAgent; /**
                                                                              * Created by Samj on 2017/8/15.
                                                                              * trim by LHW on 2018/10/20.
                                                                              */

var AppUtil = {
    isApp: UA.indexOf('YunShlApp') > -1,
    isIos: UA.indexOf('YunShlApp/ios') > -1,
    isAndroid: UA.indexOf('YunShlApp/android') > -1,
    // 保存扫码清单
    saveScanList: function saveScanList(params) {
        if (AppUtil.isAndroid) {
            window.ysDingHuo.saveScanList(JSON.stringify(params));
        } else if (AppUtil.isIos) {
            window.webkit.messageHandlers.saveScanList.postMessage(JSON.stringify(params));
        }
    },
    toLogout: function toLogout(message) {
        AppUtil.jsCallAppParam(2, { message: message });
    },
    loadClient: function loadClient() {
        if (AppUtil.isAndroid) {
            return window.ysDingHuo.loadClient();
        } else if (AppUtil.isIos) {
            return wkLoadMethodCall('loadClient');
        }
    },
    loadVersion: function loadVersion() {
        try {
            // 旧版不带参数
            return AppUtil.callAppFunc('loadVersion');
        } catch (err) {
            // 新版带参数
            return AppUtil.callAppFunc('loadVersion', 'loadVersion');
        }
    },
    loadExInfo: function loadExInfo() {
        if (AppUtil.isAndroid) {
            return window.ysDingHuo.loadExInfo();
        } else if (AppUtil.isIos) {
            return wkLoadMethodCall('loadExInfo');
        }
    },
    loadExperience: function loadExperience() {
        if (AppUtil.isAndroid) {
            return window.ysDingHuo.loadExperience();
        } else if (AppUtil.isIos) {
            return wkLoadMethodCall('loadExperience');
        }
    },
    loadUser: function loadUser() {
        if (AppUtil.isAndroid && window.ysDingHuo) {
            return window.ysDingHuo.loadUser();
        } else if (AppUtil.isIos) {
            return wkLoadMethodCall('loadUser');
        }
    },
    goPrint: function goPrint() {
        if (AppUtil.isApp) {
            if (window.ysDingHuo) {
                return window.ysDingHuo.goPrint();
            } else if (window.webkit) {
                return wkLoadMethodCall('goPrint');
            }
        }
    },
    cleanCache: function cleanCache() {
        if (AppUtil.isIos) {
            return wkLoadMethodCall('cleanCache');
        } else if (AppUtil.isAndroid && window.ysDingHuo) {
            return window.ysDingHuo.cleanCache();
        }
    },
    //更新app缓存
    refreshCache: function refreshCache() {
        return AppUtil.callAppFunc('refreshCache');
    },
    showFullPic: function showFullPic(url) {
        if (AppUtil.isIos) {
            window.webkit.messageHandlers.showFullPic.postMessage(url);
        } else if (AppUtil.isAndroid) {
            window.ysDingHuo.showFullPic(url);
        }
    },
    goBigImage: function goBigImage(index, urlArr) {
        if (AppUtil.isIos) {
            window.webkit.messageHandlers.goBigImage.postMessage(JSON.stringify({ type: index, params: urlArr }));
        } else if (AppUtil.isAndroid) {
            window.ysDingHuo.goBigImage(index, JSON.stringify(urlArr));
        }
    },
    //打开外部链接
    goWeb: function goWeb(url, title) {
        if (AppUtil.isIos) {
            window.webkit.messageHandlers.goWeb.postMessage(JSON.stringify({ url: url, params: title }));
        } else if (AppUtil.isAndroid && window.ysDingHuo.goWeb) {
            window.ysDingHuo.goWeb(url, title);
        }
    },
    //打开外部链接
    loadMac: function loadMac() {
        return AppUtil.callAppFunc('loadMac');
    },
    // url分享图片
    shareUrl: function shareUrl(params) {
        AppUtil.postAppFun('shareUrl', params);
    },
    isLighting: function isLighting() {
        if (AppUtil.isApp) {
            return AppUtil.callAppFunc('industry');
        }
    },
    // 去配灯
    toLighting: function toLighting(params) {
        AppUtil.postAppFun('distributing', params);
    },
    // 保存用户信息
    saveUserInfo: function saveUserInfo(params) {
        AppUtil.postAppFun('saveUserInfo', params);
    },
    // 修改状态栏颜色
    changeAppBarColor: function changeAppBarColor(params) {
        AppUtil.postAppFun('changeAppBarColor', params);
    },
    // 微信支付
    applyWxPay: function applyWxPay(url) {
        var params = {
            Referer: 'm.' + _urlConfig2.default.getHost() + '.com://',
            wxpay: 'true',
            url: url
        };
        if (AppUtil.isAndroid) {
            window.ysDingHuo.applyWxPay(JSON.stringify(params));
        } else if (AppUtil.isIos) {
            window.webkit.messageHandlers.applyWxPay.postMessage(JSON.stringify(params));
        }
    },
    // 微信支付--订单
    applyWxPayByOrderId: function applyWxPayByOrderId(orderId) {
        AppUtil.callAppFunc('applyWxPayByOrderId', orderId);
    },
    tabbarHide: function tabbarHide(hide) {
        if (AppUtil.isAndroid) {
            window.ysDingHuo.tabbarHide(hide);
        } else if (AppUtil.isIos) {
            window.webkit.messageHandlers.tabbarHide.postMessage(hide);
        }
    },

    // 保存图片到本地
    saveDomToImg: function saveDomToImg(baseUrl) {
        AppUtil.postAppFun("saveDomToImg", baseUrl);
    },
    // 扫码
    openAppScan: function openAppScan(params) {
        AppUtil.postAppFun("openAppScan", params);
    },
    // 扫码返回
    backOrderCreate: function backOrderCreate(params) {
        AppUtil.postAppFun("backOrderCreate", params);
    },
    // 调起小程序
    callWechatMini: function callWechatMini(params) {
        // if (!method) return;
        if (AppUtil.isAndroid) {
            if (params) {
                window.ysDingHuo.callWechatMini(JSON.stringify(params));
            } else {
                window.ysDingHuo.callWechatMini();
            }
        } else if (AppUtil.isIos) {
            window.webkit.messageHandlers.callWechatMini.postMessage(JSON.stringify(params));
        }
    },

    jsCallAppParam: function jsCallAppParam(type, params) {
        if (AppUtil.isAndroid) {
            return window.ysDingHuo.jsCallAppParam(type, JSON.stringify(params));
        } else if (AppUtil.isIos) {
            window.webkit.messageHandlers.jsCallAppParam.postMessage(JSON.stringify({ type: type, param: params }));
        }
    },
    postAppFun: function postAppFun(method, params) {
        if (!method) return;
        if (AppUtil.isAndroid) {
            if (params) {
                window.ysDingHuo[method](JSON.stringify(params));
            } else {
                window.ysDingHuo[method]();
            }
        } else if (AppUtil.isIos) {
            window.webkit.messageHandlers[method].postMessage(JSON.stringify({ param: params }));
        }
    },

    callAppFunc: function callAppFunc(method, params) {
        if (!method) return;
        if (AppUtil.isIos) {
            if (!window.webkit.messageHandlers[method]) return;
            //1:先调一下oc的方法
            window.webkit.messageHandlers[method].postMessage(params);
            //2:再去本地查找预加载传过来存在本地的值
            return localStorage.getItem('wkData-' + method);
        } else if (AppUtil.isAndroid && window.ysDingHuo[method]) {
            if (params) {
                return window.ysDingHuo[method](params);
            } else {
                return window.ysDingHuo[method]();
            }
        }
    }
};

//ios 那边wkwebview
function wkLoadMethodCall(methodName) {
    if (!methodName) {
        return;
    }
    //1:先调一下oc的方法
    window.webkit.messageHandlers[methodName].postMessage(null);
    //2:再去本地查找预加载传过来存在本地的值
    return localStorage.getItem('wkData-' + methodName);
}

exports.default = AppUtil;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(239);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InitUtil = exports.CommonUtil = undefined;

var _modal = __webpack_require__(364);

var _modal2 = _interopRequireDefault(_modal);

var _toast = __webpack_require__(362);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(365);

__webpack_require__(363);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(95);

var _jsBase = __webpack_require__(149);

var _routeFetch = __webpack_require__(94);

var _constant = __webpack_require__(51);

var _storageUtil = __webpack_require__(50);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

var _urlConfig = __webpack_require__(77);

var _urlConfig2 = _interopRequireDefault(_urlConfig);

var _appUtil = __webpack_require__(96);

var _appUtil2 = _interopRequireDefault(_appUtil);

var _Utils = __webpack_require__(147);

var _Utils2 = _interopRequireDefault(_Utils);

var _checkUtil = __webpack_require__(223);

var _checkUtil2 = _interopRequireDefault(_checkUtil);

var _BusinessUtil = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _charStr = 'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789';

var CommonUtil = exports.CommonUtil = {
    initCompanySetting: function initCompanySetting() {
        var companyId = _storageUtil2.default.getItem(_constant.SystemConst.companyId);
        var platformCompanyId = _storageUtil2.default.getItem(_constant.SystemConst.platformCompanyId);
        if (!platformCompanyId && !companyId) return;
        // 商城设置信息
        InitUtil.getShopCompanySetting(platformCompanyId || companyId);
        // 注册设置
        InitUtil.getShopRegisterSetting(platformCompanyId || companyId);
        // 商品设置信息
        InitUtil.getGoodsSetting(platformCompanyId || companyId);
        // 商品分类信息
        InitUtil.listTypeByCompany(platformCompanyId || companyId);
    },

    /**
     * 异步版本的initCompanySetting（性能优化：并行请求）
     * @param companyId 公司ID
     * @param platformCompanyId 平台公司ID
     * @returns Promise 并行请求所有设置信息
     */
    initCompanySettingAsync: function initCompanySettingAsync(companyId, platformCompanyId) {
        return new Promise(function (resolve, reject) {
            var targetCompanyId = platformCompanyId || companyId;
            if (!targetCompanyId) {
                resolve(null);
                return;
            }
            // 并行请求所有设置信息
            Promise.all([InitUtil.getShopCompanySetting(targetCompanyId), InitUtil.getShopRegisterSetting(targetCompanyId), InitUtil.getGoodsSetting(targetCompanyId), InitUtil.listTypeByCompany(targetCompanyId)]).then(function (results) {
                resolve(results);
            }).catch(function (error) {
                reject(error);
            });
        });
    },

    setTheme: function setTheme(theme) {
        document.body.className = "page-reset theme-" + (theme || 'ffb919');
        var $jsFullLoading = document.getElementById("jsFullLoading");
        if ($jsFullLoading) {
            document.body.removeChild($jsFullLoading);
        }
    },

    // 前往订货端体验账号
    toShopExperience: function toShopExperience() {
        return new Promise(function (resolve, reject) {
            var companyId = _storageUtil2.default.getItem(_constant.SystemConst.companyId);
            _routeFetch.System.shopExperience({
                company_: companyId
            }, function (rs) {
                if (rs.status === 1 && rs.data.type_ === 3) {
                    // app缓存用户信息
                    _appUtil2.default.saveUserInfo(rs.data);
                    var auth_code_ = _jsBase.Base64.encode(JSON.stringify({
                        bind_phone_: rs.data.bind_phone_,
                        company_id_: rs.data.company_id_,
                        company_name_: rs.data.company_name_,
                        company_theme_: rs.data.company_theme_,
                        client_id_: rs.data.client_id_,
                        env_: rs.data.env_,
                        login_: rs.data.login_,
                        id_: rs.data.id_,
                        name_: rs.data.name_,
                        phone_: rs.data.phone_,
                        type_: rs.data.type_,
                        token_: rs.data.token_,
                        head_img_: rs.data.head_img_,
                        auth_code_: rs.data.auth_code_,
                        duty_name_: rs.data.duty_name_,
                        dept_name_: rs.data.dept_name_
                    }));
                    // 更新数据中心数据并跳转
                    window.location.href = _urlConfig2.default.getMShopUrl() + "/shop?companyId=" + companyId + "&auth_code_=" + auth_code_;

                    resolve(rs);
                } else {
                    reject(rs);
                    _Utils2.default.message('数据错误，请联系客服');
                }
            });
        });
    },

    //跳转管理端体验
    toMgrExperience: function toMgrExperience() {
        if (!_appUtil2.default.isApp && "prod" === 'production') {
            _reactRouter.browserHistory.replaceState(null, '/shop/JumpError');
            return;
        }
        var companyId = _storageUtil2.default.getItem(_constant.SystemConst.companyId);
        _routeFetch.System.experience({ company_: companyId }, function (rs) {
            if (rs.status === 1 && rs.data.type_ !== 3) {
                // if (AppUtil.isApp) {
                //     AppUtil.jsCallAppParam(6, {message: JSON.stringify(rs.data)});
                //     return;
                // }
                _appUtil2.default.saveUserInfo(rs.data);
                var auth_code_ = _jsBase.Base64.encode(JSON.stringify({
                    bind_phone_: rs.data.bind_phone_,
                    company_id_: rs.data.company_id_,
                    company_name_: rs.data.company_name_,
                    company_theme_: rs.data.company_theme_,
                    client_id_: rs.data.client_id_,
                    env_: rs.data.env_,
                    login_: rs.data.login_,
                    id_: rs.data.id_,
                    name_: rs.data.name_,
                    phone_: rs.data.phone_,
                    type_: rs.data.type_,
                    token_: rs.data.token_,
                    head_img_: rs.data.head_img_,
                    auth_code_: rs.data.auth_code_,
                    duty_name_: rs.data.duty_name_,
                    dept_name_: rs.data.dept_name_
                }));
                // 更新数据中心数据并跳转
                window.location.href = _urlConfig2.default.getMMgrUrl() + "/home?companyId=" + companyId + "&auth_code_=" + auth_code_;
            } else {
                _Utils2.default.message('数据错误，请联系客服');
            }
        });
    },

    //跳转管理端体验
    companyShopToMgr: function companyShopToMgr() {
        this.ysClient = JSON.parse(localStorage.getItem(_constant.SystemConst.ysClient));
        var clientId = this.ysClient.id_;
        _routeFetch.ClientFetch.companyShopToMgr(clientId, function (rs) {
            if (rs.status === 1 && rs.data.type_ !== 3) {
                // if (AppUtil.isApp) {
                //     AppUtil.jsCallAppParam(6, {message: JSON.stringify(rs.data)});
                //     return;
                // }
                _appUtil2.default.saveUserInfo(rs.data);
                var auth_code_ = _jsBase.Base64.encode(JSON.stringify({
                    bind_phone_: rs.data.bind_phone_,
                    company_id_: rs.data.company_id_,
                    company_name_: rs.data.company_name_,
                    company_theme_: rs.data.company_theme_,
                    client_id_: rs.data.client_id_,
                    env_: rs.data.env_,
                    login_: rs.data.login_,
                    id_: rs.data.id_,
                    name_: rs.data.name_,
                    phone_: rs.data.phone_,
                    type_: rs.data.type_,
                    token_: rs.data.token_,
                    head_img_: rs.data.head_img_,
                    auth_code_: rs.data.auth_code_,
                    duty_name_: rs.data.duty_name_,
                    dept_name_: rs.data.dept_name_,
                    company_shop_switch_: rs.data.company_shop_switch_
                }));
                // 更新数据中心数据并跳转
                window.location.href = _urlConfig2.default.getMMgrUrl() + "/home?companyId=" + rs.data.company_id_ + "&auth_code_=" + auth_code_;
            } else {
                _Utils2.default.message('数据错误，请联系客服');
            }
        });
    },

    // 获取url参数
    getSearchFromUrl: function getSearchFromUrl() {
        var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;

        var searchObj = {};
        var subIndex = search.indexOf("?");
        if (subIndex > -1) {
            search = search.substr(subIndex + 1);
        }
        search.split('&').map(function (item) {
            var itemArr = item.split("=");
            if (itemArr[0] && itemArr[1]) {
                searchObj[itemArr[0]] = itemArr[1];
            }
        });
        return searchObj;
    },

    // 设置价格精度
    priceScale: function priceScale(price) {
        var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

        if (!price) return 0;
        if (isNaN(Number(price))) return;
        var times = Math.pow(10, scale);
        var s1 = price.toString();
        var valArr = s1.split(".");
        var m = valArr[1] ? valArr[1].length : 0;
        var priceZoom = s1 * Math.pow(10, m) * times / Math.pow(10, m);
        var des = parseInt(priceZoom + 0.5, 10) / times;

        return +des.toFixed(scale);
    },

    // 替换表情
    replaceEmoji: function replaceEmoji(v) {
        if (!v.trim()) return v;
        return v.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|\uD83C[\uDC00-\uDFFF]/g, "");
    },

    //时间格式化
    formatDate: function formatDate(date) {
        var pad = function pad(n) {
            return n < 10 ? "0" + n : n;
        };
        var dateStr = date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
        var timeStr = pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds());
        return dateStr + " " + timeStr;
    },

    // 获取动画样式
    getTransitionName: function getTransitionName(_ref) {
        var pathname = _ref.pathname;

        var localHistory = _storageUtil2.default.getItem(_constant.SystemConst.localHistory, true);
        // 上一级路由
        var prevPathName = (localHistory[localHistory.length - 2] || {}).pathname;
        // 一级导航路由
        var barPathname = _storageUtil2.default.getItem(_constant.SystemConst.barPathname);
        var tabRouter = barPathname || ['/shop/GoodsList', '/shop/OrderList', '/shop/RefundList', '/shop/CartList', '/shop/User'];
        var transitionName = 'page';
        if (prevPathName) {
            // 进入一级页面
            if (tabRouter.includes(pathname)) {
                if (!tabRouter.includes(prevPathName)) {
                    transitionName = 'page-back';
                }
            } else {
                transitionName = 'page-go';
            }
            // 订货单 <==> 退货单 、常用清单 <==> 退货单切换不启动动画
            var closeAnime = [{ pathname: "/shop/OrderList", prevPathName: "/shop/RefundList" }, { pathname: "/shop/RefundList", prevPathName: "/shop/OrderList" }, { pathname: "/shop/KeepList", prevPathName: "/shop/MyCollect" }, { pathname: "/shop/MyCollect", prevPathName: "/shop/KeepList" }];
            if (closeAnime.findIndex(function (item) {
                return item.pathname === pathname && item.prevPathName === prevPathName;
            }) > -1) {
                transitionName = 'page';
            }
            var backAnime = [{ pathname: "/shop/GoodsListLabel", prevPathName: "/shop/GoodsDetail" }, // 商品分类页面<==>商品详情
            { pathname: "/shop/GeneralizeGoods", prevPathName: "/shop/GoodsDetail" }, // 推广商品<==>商品详情
            { pathname: "/shop/MyCollect", prevPathName: "/shop/GoodsDetail" }, // 我的收藏<==>商品详情
            { pathname: "/shop/KeepList", prevPathName: "/shop/GoodsDetail" }, // 常用清单<==>商品详情
            { pathname: "/shop/GoodsList", prevPathName: "/shop/GoodsDetail" }, // 商品列表<==>商品详情
            { pathname: "/shop/UserFootprint", prevPathName: "/shop/GoodsDetail" }, // 最近浏览<==>商品详情
            { pathname: "/shop/GoodsSearchResult", prevPathName: "/shop/GoodsDetail" }, //
            { pathname: "/shop/GoodsListLabel", prevPathName: "/shop/GoodsSearch" }, //

            { pathname: "/shop/GoodsDetail", prevPathName: "/shop/GoodsMessage" }, { pathname: "/shop/GoodsDetail", prevPathName: "/shop/NoticeDetail" }, { pathname: "/shop/GoodsDetail", prevPathName: "/shop/ShopNotice" }, { pathname: "/shop/PerformanceStatistics", prevPathName: "/shop/ClientOrderStatistics" }, // 商品推广订单 => 业绩统计

            { pathname: "/shop/WithdrawDeposit", prevPathName: "/shop/WithdrawAccount" }, { pathname: "/shop/GoodsClassifyFilter", prevPathName: "/shop/GoodsListLabel" }, // 商品分类列表
            { pathname: "/shop/GoodsGroupClassifyFilter", prevPathName: "/shop/GoodsListLabel" }, // 商品分类列表
            { pathname: "/shop/ShopNotice", prevPathName: "/shop/NoticeDetail" }, { pathname: "/shop/RefundList", prevPathName: "/shop/RefundDetail" }, { pathname: "/shop/RefundList", prevPathName: "/shop/RefundApply" }, { pathname: "/shop/RefundDetail", prevPathName: "/shop/RefundResult" }, { pathname: "/shop/OrderDetail", prevPathName: "/shop/RefundApply" }, { pathname: "/shop/RefundApply", prevPathName: "/shop/RefundProduct" }, { pathname: "/shop/RefundList", prevPathName: "/shop/RefundResult" }, { pathname: "/shop/OrderStatistics", prevPathName: "/shop/OrderStatisticsDetail" }, { pathname: "/shop/Integral", prevPathName: "/shop/IntegralList" }, { pathname: "/shop/Integral", prevPathName: "/shop/IntegralFlow" }, { pathname: "/shop/Integral", prevPathName: "/shop/IntegralOrder" }, { pathname: "/shop/IntegralList", prevPathName: "/shop/IntegralDetail" }, { pathname: "/shop/IntegralRule", prevPathName: "/shop/IntegralRuleDetail" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/PerformanceStatistics" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/ClientStatistics" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/ClientStatistics" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/ClientOrderStatistics" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/GeneralizeGoods" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/InvitationHome" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/SettlementHome" }, { pathname: "/shop/DistributionHome", prevPathName: "/shop/WithdrawAccount" }, { pathname: "/shop/SettlementHome", prevPathName: "/shop/AccountLog" }, { pathname: "/shop/SettlementHome", prevPathName: "/shop/WithdrawLog" }, { pathname: "/shop/SettlementHome", prevPathName: "/shop/WithdrawDeposit" }, { pathname: "/shop/GoodsPromotionList", prevPathName: "/shop/GoodsListLabel" }, { pathname: "/shop/OrderBatchPay", prevPathName: "/shop/OrderDetail" }, { pathname: "/shop/page", prevPathName: "/shop/page" }, { pathname: "/shop/DepositDetail", prevPathName: "/shop/DepositRecharge" }, { pathname: "/shop/Custom", prevPathName: "/shop/Custom/Search" }, { pathname: "/shop/Custom/Search", prevPathName: "/shop/Custom/Goods" }, { pathname: "/shop/Custom/Goods", prevPathName: "/shop/CartOrder" }, { pathname: "/shop/Custom", prevPathName: "/shop/Custom/Goods" }, { pathname: "/shop/GoodsDetail", prevPathName: "/shop/Custom" }, { pathname: "/shop/Custom", prevPathName: "/shop/page" }, { pathname: "/shop/SettleAccountsDetail", prevPathName: "/shop/DepositDetail" }, { pathname: "/shop/SettleAccountsDetail", prevPathName: "/shop/BackAccountDetail" }, { pathname: "/shop/InvoiceAssistantList", prevPathName: "/shop/InvoiceAssistantDetail" }];

            if (backAnime.findIndex(function (item) {
                return item.pathname === pathname && item.prevPathName === prevPathName;
            }) > -1) {
                transitionName = 'page-back';
            }
        }
        // fix:YSDH-9353 微页面跳转到微页面的动画修改为渐变动画
        if (pathname === '/shop/page' && localHistory[localHistory.length - 1].pathname === '/shop/page') {
            transitionName = 'page-back';
        }
        return transitionName;
    },

    // 获取装修跳转路径
    getDecorateLocation: function getDecorateLocation(target) {
        var applicationStatus = _storageUtil2.default.getItem(_constant.SystemConst.applicationStatus);
        var goodsTypeSetting = _storageUtil2.default.getItem(_constant.SystemConst.goodsTypeSetting) || {};
        var companyOpenScore = _storageUtil2.default.getItem(_constant.SystemConst.companyOpenScore);
        var companyEnableSign = _storageUtil2.default.getItem(_constant.SystemConst.companyEnableSign);
        if (typeof target === "undefined") return;
        var newLocation = {
            query: {
                companyId: _storageUtil2.default.getItem(_constant.SystemConst.companyId)
            }
        };
        switch (target.type_) {
            case 1:
                //已上架商品
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsDetail";
                newLocation.query.id = target.val_;
                break;
            case 2:
                //商品分类
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                // YSDH-8715: fix 从装修的功能导航点击进来未选中分类
                // newLocation.query.type_ = `${target.key_ ? target.key_ + ',' : ''}${target.val_}`;
                newLocation.query.type_ = target.val_;
                newLocation.query.showTagFilter = true;
                break;
            case 3:
                //商品标签
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.tag_ = target.val_;
                newLocation.query.showTagFilter = true;
                break;
            case 4:
                //商品品牌
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.brand_ = target.val_;
                break;
            case 5:
                //通知公告
                if (!target.val_) return;
                newLocation.pathname = "/shop/NoticeDetail";
                newLocation.query.id = target.val_;
                break;
            case 6:
                //商品促销
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.goods_activity_id_ = target.val_;
                break;
            case 7:
                //模板页面
                if (!target.val_) return;
                newLocation.pathname = "/shop/page";
                newLocation.query.pid = target.val_;
                break;
            case 8:
                //外部链接
                if (!_checkUtil2.default.isUrl(target.val_)) return;
                if (_appUtil2.default.isApp) {
                    _appUtil2.default.goWeb(target.val_, name);
                } else {
                    window.location.href = "" + target.val_;
                }
                break;
            case 9:
                // 全部商品
                newLocation.pathname = "/shop/GoodsList";
                break;
            case 10:
                // 购物车
                newLocation.pathname = "/shop/CartList";
                break;
            case 11:
                // 收藏商品
                // props.history.pushState(null, "/shop/MyCollect", {tag_: '-1,'});
                newLocation.pathname = "/shop/MyCollect";
                newLocation.query.tag_ = "-1";
                break;
            case 12:
                // 常用商品(常购商品)
                newLocation.pathname = "/shop/KeepList";
                break;
            case 13:
                // 全部分类
                newLocation.pathname = goodsTypeSetting.show_type_ === 4 ? "/shop/GoodsGroupClassifyFilter" : "/shop/GoodsClassifyFilter";
                break;
            case 14:
                // 领券中心
                newLocation.pathname = "/shop/ReceiveCoupon";
                break;
            case 16: // 限时特卖
            case 17:
                // 限时秒杀
                //暂无限时特卖以及限时秒杀
                break;
            case 18:
                // 通知公告列表
                newLocation.pathname = "/shop/ShopNotice";
                break;
            case 19:
                // 个人中心
                newLocation.pathname = "/shop/User";
                break;
            case 20:
                // 我的订单
                newLocation.pathname = "/shop/OrderList";
                break;
            case 21:
                // 签到好礼
                if (!companyOpenScore && !companyEnableSign) {
                    _toast2.default.info('暂不支持签到！');
                    newLocation.pathname = '';
                } else {
                    newLocation.pathname = "/shop/IntegralSign";
                }
                break;
            case 22:
                // 我的积分
                newLocation.pathname = "/shop/Integral";
                break;
            case 23:
                // 商品属性
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.property_id_ = target.val_;
                break;
            case 24:
                // 预售商品
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.quick_search_ = 6;
                break;
            case 25:
                // 首页
                newLocation.pathname = "/shop";
                break;
            case 26:
                // 全部促销
                newLocation.pathname = "/shop/GoodsPromotionList";
                break;
            case 27:
                // 商品套餐
                newLocation.pathname = "/shop/GoodsPackageList";
                break;
            case 28:
                // 商品品牌
                newLocation.pathname = "/shop/GoodsBrandList";
                break;
            case 30:
                // 预存款充值
                newLocation.pathname = "/shop/DepositRecharge";
                break;
            case 31:
                // 体验馆
                newLocation.pathname = "/shop/ExperienceList";
                break;
            case 32:
                // 金饰定制
                if (!applicationStatus.application_39_status_) {
                    _toast2.default.info('请先开启金饰定制应用', 3, null, false);
                    return newLocation;
                }
                newLocation.pathname = "/shop/Custom";
                break;
            case 34:
                // 串号查询
                newLocation.pathname = "/shop/GoodsSnSearch";
                break;
        }
        return newLocation;
    },

    // 获取导航pathname
    getBarPathname: function getBarPathname(buttons) {
        if (!buttons) return;
        var goodsTypeSetting = _storageUtil2.default.getItem(_constant.SystemConst.goodsTypeSetting) || {};
        var barPathname = [];
        buttons.forEach(function (item) {
            var target = item.target_;
            if (!target) return;
            switch (target.type_) {
                case 1:
                    //已上架商品
                    barPathname.push("/shop/GoodsDetail");
                    break;
                case 2: //商品分类
                case 3: //商品标签
                case 4: //商品标签
                case 6: //商品促销
                case 23: // 商品属性
                case 24:
                    // 预售商品
                    barPathname.push("/shop/GoodsListLabel");
                    break;
                case 5:
                    //通知公告
                    barPathname.push("/shop/NoticeDetail");
                    break;
                case 7:
                    //模板页面
                    barPathname.push("/shop/page");
                    break;
                case 8:
                    //外部链接
                    break;
                case 9:
                    // 全部商品
                    barPathname.push("/shop/GoodsList");
                    break;
                case 10:
                    // 购物车
                    barPathname.push("/shop/CartList");
                    break;
                case 11:
                    // 收藏商品
                    barPathname.push("/shop/MyCollect");
                    break;
                case 12:
                    // 常用商品(常购商品)
                    barPathname.push("/shop/KeepList");
                    break;
                case 13:
                    // 全部分类
                    barPathname.push(goodsTypeSetting.show_type_ === 4 ? "/shop/GoodsGroupClassifyFilter" : "/shop/GoodsClassifyFilter");
                    break;
                case 14:
                    // 领券中心
                    barPathname.push("/shop/ReceiveCoupon");
                    break;
                case 16: // 限时特卖
                case 17:
                    // 限时秒杀
                    //暂无限时特卖以及限时秒杀
                    break;
                case 18:
                    // 通知公告列表
                    barPathname.push("/shop/ShopNotice");
                    break;
                case 19:
                    // 个人中心
                    barPathname.push("/shop/User");
                    break;
                case 20:
                    // 我的订单
                    barPathname.push("/shop/OrderList");
                    break;
                case 21:
                    // 签到好礼
                    barPathname.push("/shop/IntegralSign");
                    break;
                case 22:
                    // 我的积分
                    barPathname.push("/shop/Integral");
                    break;
                case 25:
                    // 首页
                    barPathname.push("/shop");
                    break;
                case 31:
                    // 体验馆
                    barPathname.push("/shop/ExperienceList");
                    break;
            }
        });
        return barPathname;
    },

    // 微信绑定
    toWechatBind: function toWechatBind() {
        if (_checkUtil2.default.isWeiXin) {
            var wechatBind = _storageUtil2.default.getItem(_constant.SystemConst.wechatBind);
            // console.log('check has bind', wechatBind);
            if (!wechatBind) {
                var companyData = _storageUtil2.default.getItem(_constant.SystemConst.companyData);
                // console.log('check has wechat_setting_is_open_login_auth_', companyData.wechat_setting_is_open_login_auth_)
                // console.log('check has wechat_setting_wechat_appid_', companyData.wechat_setting_wechat_appid_)
                if (companyData.wechat_setting_is_open_login_auth_ && companyData.wechat_setting_wechat_appid_) {
                    /*
                     由于微信授权会重定向url,sessionStore的值会丢失
                     所以这里使用微信授权提供的state携带参数
                     参考文档:https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421140842
                     使用V作为参数间隔
                     */
                    var query = CommonUtil.getSearchFromUrl();
                    var state = [companyData.id_, query.id]; // [企业id,商品id];
                    // console.log('redirect_uri', location.href);
                    // console.log('redirect_uri state', state);

                    var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + companyData.wechat_setting_wechat_appid_ + "&redirect_uri=" + location.href + "&response_type=code&scope=snsapi_userinfo&state=" + state.join('V') + "#wechat_redirect";
                    window.location.href = url;
                }
            }
        }
    },

    // 保存登录信息
    saveStorageFormLogin: function saveStorageFormLogin(loginUser) {
        _storageUtil2.default.setItem(_constant.SystemConst.mShop_user, loginUser);
        _storageUtil2.default.setItem(_constant.SystemConst.token, loginUser.token_);
        _storageUtil2.default.setItem(_constant.SystemConst.companyId, loginUser.company_id_);
        _storageUtil2.default.setItem(_constant.SystemConst.companyName, loginUser.company_name_);
        _storageUtil2.default.setItem(_constant.SystemConst.companyTheme, loginUser.company_theme_);
        _storageUtil2.default.setItem(_constant.SystemConst.authCode, loginUser.auth_code_);
        // YSDH-7542
        _storageUtil2.default.setItem(_constant.SystemConst.isShowBindTips, 1);
        _storageUtil2.default.setItem(_constant.SystemConst.isLighting, loginUser.isLighting || 0);
        // 3_1_9:是否微信绑定
        _storageUtil2.default.setItem(_constant.SystemConst.wechatBind, loginUser.wechat_bind_);
        //店铺切换账号是否可用
        _storageUtil2.default.setItem(_constant.SystemConst.companyShopSwitch, loginUser.company_shop_switch_);
    },
    checkLoginStatus: function checkLoginStatus(loginStatus) {
        if (typeof loginStatus !== 'number') return null;
        var companyDate = _storageUtil2.default.getItem(_constant.SystemConst.companyData);
        var link_phone_ = companyDate && companyDate.link_phone_ || '0755-2665 9381';
        var company_name_ = companyDate && companyDate.name_;
        var actions = [{ text: '我知道了' }, {
            text: '呼叫', onPress: function onPress() {
                return new Promise(function () {
                    window.location.href = "tel:" + link_phone_;
                });
            }
        }];
        var telNode = _react2.default.createElement(
            "a",
            { href: "tel:" + link_phone_ },
            "\uFF08",
            link_phone_,
            "\uFF09"
        );
        switch (loginStatus) {
            case 0:
                break;
            case 1:
                // Toast.success(`登录成功`, 1);
                return true;
            case 2:
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u767B\u5F55\u8D26\u53F7\u4E0D\u5B58\u5728",
                    _react2.default.createElement("br", null),
                    "\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u5F00\u901A",
                    _react2.default.createElement("br", null),
                    telNode
                ), actions);
                break;
            case 3:
                //账号禁用
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u8BE5\u4F01\u4E1A\u8D26\u53F7\u88AB\u7981\u7528",
                    _react2.default.createElement("br", null),
                    "\u8BF7\u8054\u7CFB\u4E91\u4E0A\u8BA2\u8D27",
                    _react2.default.createElement("br", null),
                    telNode
                ), actions);
                break;
            case 4:
                //试用结束
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u8BE5\u4F01\u4E1A\u8D26\u53F7\u8BD5\u7528\u671F\u7ED3\u675F",
                    _react2.default.createElement("br", null),
                    "\u8BF7\u8054\u7CFB\u4E91\u4E0A\u8BA2\u8D27",
                    _react2.default.createElement("br", null),
                    telNode
                ), actions);
                break;
            case 5:
                //使用过期
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u8BE5\u4F01\u4E1A\u8D26\u53F7\u5DF2\u8FC7\u671F\u4E86",
                    _react2.default.createElement("br", null),
                    "\u9700\u8981\u7EED\u8D39\u624D\u80FD\u4F7F\u7528",
                    _react2.default.createElement("br", null),
                    "\u8BF7\u8054\u7CFB\u4E91\u4E0A\u8BA2\u8D27 ",
                    _react2.default.createElement("br", null),
                    telNode
                ), actions);
                break;
            case 6:
                //使用过期
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u8BE5\u4F01\u4E1A\u4E0D\u5B58\u5728\u6B64\u5E10\u53F7"
                ), [{ text: '我知道了' }]);
                break;
            case 7:
                // 客户账号已禁用
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u60A8\u7684\u8BA2\u8D27\u8D26\u53F7\u5DF2\u88AB\u4F01\u4E1A",
                    company_name_,
                    "\u7981\u7528\uFF0C\u4E0D\u53EF\u767B\u5F55\u3002\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
                    telNode
                ), actions);
                break;
            case 8:
                // 客户账号已停用
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u60A8\u5DF2\u4E0D\u662F\u4F01\u4E1A",
                    company_name_,
                    "\u7684\u5408\u4F5C\u5BA2\u6237\uFF0C\u4E0D\u53EF\u767B\u5F55\u3002\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
                    telNode
                ), actions);
                break;
            case 9:
                // 店铺账号已禁用
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u60A8\u7684\u5E97\u94FA\u5DF2\u88AB\u505C\u7528\uFF0C\u4E0D\u53EF\u767B\u5F55\u3002\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
                    telNode
                ), actions);
                break;
            case 10:
                // tv未开通装修专版
                _toast2.default.hide();
                _modal2.default.alert(null, _react2.default.createElement(
                    "div",
                    null,
                    "\u8BE5\u8D26\u53F7\u672A\u5F00\u901A\u706F\u9970\u4E13\u7248\u529F\u80FD\u3002\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
                    telNode
                ), actions);
                break;
            default:
                _toast2.default.info("\u6570\u636E\u5F02\u5E38\u8BF7\u91CD\u65B0\u5C1D\u8BD5\u6216\u8005\u8054\u7CFB\u7BA1\u7406\u5458", 1, null, false);
        }
    },
    setStatisticalCode: function setStatisticalCode(data) {
        var body = document.getElementsByTagName("body")[0];
        if (data) {
            data = JSON.parse(data);
            data.forEach(function (item) {
                var scriptDom = document.createElement("script");
                scriptDom.type = "text/javascript";
                scriptDom.src = item.name;
                body.appendChild(scriptDom);
            });
        } else {
            var scriptDom = document.createElement("script");
            scriptDom.type = "text/javascript";
            scriptDom.src = 'https://hm.baidu.com/hm.js?5c6da7c14905c6a9a405904833d3dd8d';
            body.appendChild(scriptDom);
        }
    },

    //数据格式转换
    stringToArr: function stringToArr(string) {
        if (Array.isArray(string)) return string;
        try {
            return JSON.parse(string) || [];
        } catch (e) {
            return [];
        }
    },
    stringToObj: function stringToObj(string) {
        if (!string) return;
        if (CommonUtil.isType(string) === 'Object') return string;

        try {
            return JSON.parse(string) || {};
        } catch (e) {
            return {};
        }
    },
    handleMultiUnits: function handleMultiUnits(multi_unit_) {
        var usableUnitList = [];
        if (multi_unit_.usable_[0] === 1) {
            usableUnitList.push(multi_unit_.unit_id_);
        }
        (multi_unit_.extend_units_ || []).map(function (unit, index) {
            if (unit.unit_id_ && multi_unit_.usable_[index + 1] === 1) {
                // 可订货单位
                usableUnitList.push(unit.unit_id_);
            }
        });
        return usableUnitList;
    },
    isType: function isType(value) {
        var type = Object.prototype.toString.call(value);
        return type.replace(/\[object (\w+)\]/, '$1');
    },

    /**
     * 随机生成索引
     * @param min 最小值
     * @param max 最大值
     * @param i 当前获取位置
     */
    randomIndex: function randomIndex(min, max, i) {
        var index = Math.floor(Math.random() * (max - min + 1) + min),
            numStart = _charStr.length - 10;
        //如果字符串第一位是数字，则递归重新获取
        if (i == 0 && index >= numStart) {
            index = this.randomIndex(min, max, i);
        }
        //返回最终索引值
        return index;
    },

    /**
     * 随机生成字符串
     * @param len 指定生成字符串长度
     */
    getRandomString: function getRandomString(len) {
        var min = 0,
            max = _charStr.length - 1,
            _str = '';
        //判断是否指定长度，否则默认长度为15
        len = len || 15;
        //循环生成字符串
        for (var i = 0, index; i < len; i++) {
            index = this.randomIndex(min, max, i);
            _str += _charStr[index];
        }
        return _str;
    },
    getRandomParam: function getRandomParam() {
        var nonce = this.getRandomString(20);
        /*if (url.indexOf('?') > -1) {
            url += "&nonce=" + nonce;
        } else {
            url += "?nonce=" + nonce;
        }*/
        return nonce;
    },
    objSort: function objSort(arys) {
        //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
        if (!arys) {
            return {};
        }
        var newkey = Object.keys(arys).sort();
        //console.log('newkey='+newkey);
        var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
        for (var i = 0; i < newkey.length; i++) {
            //遍历newkey数组
            newObj[newkey[i]] = arys[newkey[i]];
            //向新创建的对象中按照排好的顺序依次增加键值对
        }
        return newObj; //返回排好序的新对象
    },
    getNonce: function getNonce() {
        var nonce = new Date().getTime() + '' + Math.floor(Math.random() * 10000);
        return nonce;
    }
};
var InitUtil = exports.InitUtil = {
    getCompanySetting: function getCompanySetting() {
        return new Promise(function (resolve, reject) {
            _routeFetch.System.getCompanySetting({}, function (rs) {
                if (rs.status === 1) {
                    _storageUtil2.default.setItem(_constant.SystemConst.enableOrderSource, !!rs.data.enable_order_source_);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            });
        });
    },

    // 获取商城设置
    getShopCompanySetting: function getShopCompanySetting(companyId) {
        return new Promise(function (resolve, reject) {
            _routeFetch.System.getShopCompanySetting(companyId, function (rs) {
                if (rs.status === 1) {
                    var _rs$data = rs.data,
                        goodsSetting = _rs$data.goodsSetting,
                        houseSetting = _rs$data.houseSetting,
                        saleSetting = _rs$data.saleSetting,
                        shopSetting = _rs$data.shopSetting,
                        incomeSetting = _rs$data.incomeSetting,
                        distributionRebateSetting = _rs$data.distributionRebateSetting,
                        top_goods_type_node_ = _rs$data.top_goods_type_node_,
                        sceneSettingDto = _rs$data.sceneSettingDto;

                    if (incomeSetting) {
                        // 启用客户资金充值扣款审核后，客户资金的充值及扣款需审核后才生效
                        _storageUtil2.default.setItem(_constant.SystemConst.enableRechargeDeductConfirm, incomeSetting.enable_recharge_deduct_confirm_);
                        // 启用后客户在商城端使用线下转账方式时必须上传附件
                        _storageUtil2.default.setItem(_constant.SystemConst.enableCustomAttachmentRequired, incomeSetting.enable_custom_attachment_required_);
                        _storageUtil2.default.setItem(_constant.SystemConst.enableChangeInvoice, incomeSetting.enable_change_invoice_);
                        _storageUtil2.default.setItem(_constant.SystemConst.enableCustomAttachmentClose, incomeSetting.enable_custom_attachment_close_);
                        _storageUtil2.default.setItem(_constant.SystemConst.huiFuWeiXinCombinedPay, incomeSetting.huifu_weixin_combined_pay_);
                    }
                    // 商品设置
                    if (goodsSetting) {
                        // 是否可以下载商品图片
                        _storageUtil2.default.setItem(_constant.SystemConst.enableGoodsImgDownload, goodsSetting.enable_goods_img_download_);
                        // 是否开启起订量
                        _storageUtil2.default.setItem(_constant.SystemConst.enableMinCount, goodsSetting.min_count_);
                        // 是否开启限订量
                        _storageUtil2.default.setItem(_constant.SystemConst.enableMaxCount, goodsSetting.max_count_);
                        // 是否开启品牌筛选
                        _storageUtil2.default.setItem(_constant.SystemConst.enableBrand, goodsSetting.enable_brand_);
                        // 是否开启风格筛选
                        _storageUtil2.default.setItem(_constant.SystemConst.enableStyle, goodsSetting.enable_style_);
                        //商品价格精度
                        _storageUtil2.default.setItem(_constant.SystemConst.priceScale, goodsSetting.price_scale_ && goodsSetting.price_scale_);
                        //商品数量精度
                        _storageUtil2.default.setItem(_constant.SystemConst.countScale, goodsSetting.count_scale_ && goodsSetting.count_scale_);
                        // 客户端显示体积
                        _storageUtil2.default.setItem(_constant.SystemConst.clientShowCubage, goodsSetting.client_show_cubage_);
                        _storageUtil2.default.setItem(_constant.SystemConst.clientShowWeight, goodsSetting.client_show_weight_);
                    }
                    if (houseSetting) {
                        _storageUtil2.default.setItem(_constant.SystemConst.houseSetting, houseSetting);
                    }
                    if (saleSetting) {
                        _storageUtil2.default.setItem(_constant.SystemConst.saleSetting, saleSetting);
                        _storageUtil2.default.setItem(_constant.SystemConst.stockShowType, saleSetting.stock_show_type_);
                        // 是否允许超售
                        _storageUtil2.default.setItem(_constant.SystemConst.enableStockZero, saleSetting.enable_stock_zero_);

                        // 交货日期是否必填
                        _storageUtil2.default.setItem(_constant.SystemConst.enableExpectTime, saleSetting.enable_expect_time_);
                        // 开启下单金额限制
                        _storageUtil2.default.setItem(_constant.SystemConst.enableOrderTotal, saleSetting.enable_order_total_);
                        _storageUtil2.default.setItem(_constant.SystemConst.orderTotal, saleSetting.order_total_);
                        // 开启特批价
                        _storageUtil2.default.setItem(_constant.SystemConst.enableSpecialTotal, saleSetting.enable_special_total_);
                        // 是否可开发票
                        _storageUtil2.default.setItem(_constant.SystemConst.enableTax, saleSetting.enable_tax_);
                        _storageUtil2.default.setItem(_constant.SystemConst.containTax, saleSetting.contain_tax_);
                        _storageUtil2.default.setItem(_constant.SystemConst.generalTax, saleSetting.general_tax_);
                        _storageUtil2.default.setItem(_constant.SystemConst.addedTax, saleSetting.added_tax_);
                        _storageUtil2.default.setItem(_constant.SystemConst.otherTax, saleSetting.other_tax_);
                        _storageUtil2.default.setItem(_constant.SystemConst.taxType, saleSetting.tax_types_);
                        _storageUtil2.default.setItem(_constant.SystemConst.defaultTaxType, saleSetting.default_tax_type_);

                        _storageUtil2.default.setItem(_constant.SystemConst.orderDefaultUnit, saleSetting.order_default_unit_);
                        _storageUtil2.default.setItem(_constant.SystemConst.enableSaleBackOrder, saleSetting.enable_sale_back_order_);
                        var additional_fee_setting_ = saleSetting.additional_fee_setting_json_ && JSON.parse(saleSetting.additional_fee_setting_json_);
                        if (additional_fee_setting_) {
                            additional_fee_setting_ = additional_fee_setting_.filter(function (item) {
                                return item.status_;
                            });
                        }
                        _storageUtil2.default.setItem(_constant.SystemConst.additionalFeeSetting, additional_fee_setting_);

                        _storageUtil2.default.setItem(_constant.SystemConst.enableShopNoOrder, saleSetting.enable_shop_no_order_);
                        if (saleSetting.shop_no_order_time_) {
                            _storageUtil2.default.setItem(_constant.SystemConst.shopNoOrderTime, JSON.parse(saleSetting.shop_no_order_time_));
                        }
                    }
                    if (shopSetting) {
                        _storageUtil2.default.setItem(_constant.SystemConst.messagePrompt, shopSetting.message_prompt_);
                        // 商品列表设置
                        _storageUtil2.default.setItem(_constant.SystemConst.goodsListSetting, JSON.parse(shopSetting.goods_list_setting_json_));
                        // 商品分类设置
                        _storageUtil2.default.setItem(_constant.SystemConst.goodsTypeSetting, JSON.parse(shopSetting.goods_type_setting_json_));

                        _storageUtil2.default.setItem(_constant.SystemConst.shopSetting, shopSetting);
                        _storageUtil2.default.setItem(_constant.SystemConst.showGoodsDetailMode, shopSetting.show_goods_detail_mode_);
                        // 是否允许游客访问
                        _storageUtil2.default.setItem(_constant.SystemConst.allowVisitor, shopSetting.allow_visitor_);
                        // 是否允许游客查看价格
                        _storageUtil2.default.setItem(_constant.SystemConst.allowClientPrice, shopSetting.allow_client_price_);
                        // 商品列表展示类型
                        _storageUtil2.default.setItem(_constant.SystemConst.showGoodsType, shopSetting.show_goods_type_);
                        // 商城标题
                        _storageUtil2.default.setItem(_constant.SystemConst.showGoodsUnit, shopSetting.show_goods_unit_);
                        // 是否显示单位
                        _storageUtil2.default.setItem(_constant.SystemConst.shopHomeTitle, shopSetting.shop_home_title_);
                        // 是否显示零售价
                        _storageUtil2.default.setItem(_constant.SystemConst.showMarketPrice, shopSetting.enable_show_market_price_);

                        var navBarDecorate = JSON.parse(shopSetting.navigation_bar_decorate_);
                        var navBarJson = JSON.parse(shopSetting.navigation_bar_json_);
                        // 悬浮窗页面
                        _storageUtil2.default.setItem(_constant.SystemConst.allowFloatingWindow, shopSetting.allow_floating_window_);
                        _storageUtil2.default.setItem(_constant.SystemConst.floatingWindowDecorate, JSON.parse(shopSetting.floating_window_decorate_));
                        _storageUtil2.default.setItem(_constant.SystemConst.floatingWindowJson, JSON.parse(shopSetting.floating_window_json_));
                        // 公共广告
                        var publicAdJson = JSON.parse(shopSetting.public_ad_json_);
                        _storageUtil2.default.setItem(_constant.SystemConst.publicAdDecorate, JSON.parse(shopSetting.public_ad_decorate_));
                        _storageUtil2.default.setItem(_constant.SystemConst.publicAdJson, publicAdJson);
                        _storageUtil2.default.setItem(_constant.SystemConst.publicAdPosition, (publicAdJson || {}).position_ || 0);
                        // 导航应用页面
                        _storageUtil2.default.setItem(_constant.SystemConst.navBarDecorate, navBarDecorate);
                        // 导航装修应用页面
                        if (shopSetting.navigation_bar_decorate_) {
                            var goodsTypeSetting = JSON.parse(shopSetting.goods_type_setting_json_);
                            var navDecoratePage = [];
                            navBarDecorate.forEach(function (item) {
                                switch (item) {
                                    case 1:
                                        navDecoratePage.push("/");
                                        navDecoratePage.push("/shop");
                                        navDecoratePage.push("/Shop");
                                        break;
                                    case 2:
                                        navDecoratePage.push("/shop/GoodsList");
                                        break;
                                    case 3:
                                        navDecoratePage.push("/shop/OrderList");
                                        navDecoratePage.push("/shop/RefundList");
                                        break;
                                    case 4:
                                        navDecoratePage.push("/shop/CartList");
                                        break;
                                    case 5:
                                        navDecoratePage.push("/shop/User");
                                        break;
                                    case 6:
                                        navDecoratePage.push(goodsTypeSetting.show_type_ === 4 ? "/shop/GoodsGroupClassifyFilter" : "/shop/GoodsClassifyFilter");
                                        break;
                                    case 7:
                                        navDecoratePage.push("/shop/page");
                                        break;
                                }
                            });
                            // 导航应用页面pathname
                            _storageUtil2.default.setItem(_constant.SystemConst.navDecoratePage, navDecoratePage);
                            // 导航装修
                            _storageUtil2.default.setItem(_constant.SystemConst.navBarJson, navBarJson);
                            var barPathname = CommonUtil.getBarPathname(navBarJson.buttons_);
                            // 导航装修路由
                            _storageUtil2.default.setItem(_constant.SystemConst.barPathname, barPathname);
                        }

                        //个人中心设置
                        if (shopSetting.mine_page_json_) {
                            _storageUtil2.default.setItem(_constant.SystemConst.MineSetting, JSON.parse(shopSetting.mine_page_json_));
                        }
                        //基础设置
                        if (shopSetting.base_setting_json_) {
                            _storageUtil2.default.setItem(_constant.SystemConst.BaseSetting, JSON.parse(shopSetting.base_setting_json_));
                        }
                    }
                    if (distributionRebateSetting) {
                        _storageUtil2.default.setItem(_constant.SystemConst.enableRebateLevel, distributionRebateSetting.enable_rebate_level_);
                        _storageUtil2.default.setItem(_constant.SystemConst.distributionModelTitle, distributionRebateSetting.distribution_model_title_);
                        _storageUtil2.default.setItem(_constant.SystemConst.distributionJobName, distributionRebateSetting.distribution_job_name_);
                        _storageUtil2.default.setItem(_constant.SystemConst.posterBackground, distributionRebateSetting.poster_background_);
                        _storageUtil2.default.setItem(_constant.SystemConst.invitationCardBackground, distributionRebateSetting.invitation_card_background_);
                        _storageUtil2.default.setItem(_constant.SystemConst.joiningInstructions, distributionRebateSetting.joining_instructions_);
                        _storageUtil2.default.setItem(_constant.SystemConst.bindWay, distributionRebateSetting.bind_way_);
                    }
                    if (top_goods_type_node_) {
                        _storageUtil2.default.setItem(_constant.SystemConst.topGoodsTypeNode, top_goods_type_node_);
                    }
                    if (sceneSettingDto) {
                        _storageUtil2.default.setItem(_constant.SystemConst.enableH5Scene, sceneSettingDto.enable_h5_scene_);
                    } else {
                        _storageUtil2.default.setItem(_constant.SystemConst.enableH5Scene, null);
                    }
                    resolve(rs);
                } else {
                    reject(rs);
                }
            }, function (rs) {
                reject(rs);
            });
        });
    },
    getCompany: function getCompany(companyId) {
        return new Promise(function (resolve, reject) {
            _routeFetch.ShopFetch.getCompany(companyId, function (rs) {
                if (rs.status === 1) {
                    var shopSettingDto = rs.data.shopSettingDto;
                    // 公司信息

                    _storageUtil2.default.setItem(_constant.SystemConst.companyData, rs.data);
                    // 公司名称
                    _storageUtil2.default.setItem(_constant.SystemConst.companyName, rs.data.name_);
                    //设置页面标题
                    document.title = rs.data.name_;
                    // 公司id
                    _storageUtil2.default.setItem(_constant.SystemConst.companyId, rs.data.id_);

                    _storageUtil2.default.setItem(_constant.SystemConst.multi_currency_symbol_, rs.data.currency_type_ || '￥');
                    _storageUtil2.default.setItem(_constant.SystemConst.currencySymbol, rs.data.currency_type_ || '￥');

                    resolve(rs);
                } else {
                    reject(rs);
                }
            }, function (rs) {
                reject(rs);
            });
        });
    },

    // 获取微信授权信息
    getWechatUserInfo: function getWechatUserInfo(code, companyId) {
        console.log('getWeChatUserInfo');
        return new Promise(function (resolve, reject) {

            _routeFetch.System.getWeChatUserInfo({ code: code, company_id_: companyId }, function (rs) {
                var query = CommonUtil.getSearchFromUrl();
                delete query.code;
                _reactRouter.browserHistory.replaceState(null, location.pathname, query);
                console.log('clear location query.code');
                if (rs.status === 1) {
                    var _rs$data2 = rs.data,
                        openid = _rs$data2.openid,
                        errcode = _rs$data2.errcode,
                        headimgurl = _rs$data2.headimgurl,
                        nickname = _rs$data2.nickname;

                    if (errcode) {
                        // 1.检查授权获取结果
                        switch (errcode) {
                            case 40001:
                                _toast2.default.info('微信授权验证已过期', 1, null, false);
                                break;
                            default:
                                _toast2.default.info('微信授权失败', 1, null, false);
                                break;
                        }
                        console.error('微信授权失败,错误信息', rs.data);
                    } else {
                        var isLogin = _BusinessUtil.BusinessUtil.isLogin();
                        console.log('check user is login', isLogin);
                        if (isLogin) {
                            // A用户已登录
                            console.log('bind openid whit user', openid);
                            _routeFetch.System.bindOpenId({ wechat_openid_: openid, company_id_: companyId }, function (rs) {
                                if (rs.status === 1) {
                                    console.log('modify user bind state', true);
                                    _storageUtil2.default.setItem(_constant.SystemConst.wechatBind, true);
                                    resolve(rs);
                                } else {
                                    reject(rs);
                                }
                            }, function (rs) {
                                reject(rs);
                            });
                        } else {
                            // B用户未登录
                            console.log('check user has bind');
                            _routeFetch.System.openIdLogin({ wechat_openid_: openid, company_id_: companyId }, function (rs) {
                                if (rs.status === 1) {
                                    console.log('loginStatus', rs.data);
                                    CommonUtil.checkLoginStatus(rs.data.loginStatus);
                                    if (rs.data.loginStatus == 1) {
                                        console.log('user is bind, auto login');
                                        // 本地保存登录信息
                                        CommonUtil.saveStorageFormLogin(rs.data.loginUser);
                                        /*YSDH-9108 取消reload, User GoodsDetail补充监听*/
                                    } else if (rs.data.loginStatus == 0) {
                                        console.log('store wechat user info');
                                        // 添加到缓存,'我的'页面展示
                                        _storageUtil2.default.setItem(_constant.SystemConst.wechatData, { headimgurl: headimgurl, nickname: nickname, openid: openid });
                                    } else {
                                        console.log('error user status, to origin login');
                                    }
                                    resolve(rs);
                                } else {
                                    reject(rs);
                                }
                            }, function (rs) {
                                reject(rs);
                            });
                        }
                    }
                    resolve(rs);
                } else {
                    reject(rs);
                }
            }, function (rs) {
                reject(rs);
            });
        });
    },

    // 获取注册设置
    getShopRegisterSetting: function getShopRegisterSetting(companyId) {
        return new Promise(function (resolve, reject) {
            _routeFetch.ShopFetch.getShopRegisterSetting({ company_id_: companyId }, function (rs) {
                if (rs.status === 1) {
                    var _rs$data3 = rs.data,
                        register_agreement_set_ = _rs$data3.register_agreement_set_,
                        register_agreement_name_ = _rs$data3.register_agreement_name_,
                        register_agreement_url_ = _rs$data3.register_agreement_url_,
                        enable_application_ = _rs$data3.enable_application_,
                        audit_ = _rs$data3.audit_;

                    _storageUtil2.default.setItem(_constant.SystemConst.allowClientRegister, enable_application_);
                    _storageUtil2.default.setItem('allowClientRegisterAudit', audit_);
                    _storageUtil2.default.setItem('registerAgreement', {
                        register_agreement_set_: register_agreement_set_, register_agreement_name_: register_agreement_name_, register_agreement_url_: register_agreement_url_
                    });
                    _storageUtil2.default.setItem('shopRegisterSetting', rs.data);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            });
        });
    },

    // 获取客户信息
    getClientInfo: function getClientInfo(companyId) {
        return new Promise(function (resolve, reject) {
            var ysUser = _storageUtil2.default.getItem(_constant.SystemConst.mShop_user);
            if (ysUser && ysUser.client_id_) {
                _routeFetch.System.getClientById(ysUser.client_id_, function (rs) {
                    if (rs.status === 1) {
                        _storageUtil2.default.setItem(_constant.SystemConst.ysClient, rs.data);
                        _routeFetch.System.getCompany(rs.data.company_id_, function (res) {
                            if (res.status === 1) {
                                _storageUtil2.default.setItem(_constant.SystemConst.multi_currency_symbol_, res.data.currency_type_ || '￥');
                                _storageUtil2.default.setItem(_constant.SystemConst.currencySymbol, res.data.currency_type_ || '￥');
                            }
                        });
                        resolve(rs);
                    } else {
                        reject(rs);
                    }
                });
            }
        });
    },

    // 购物车数量
    getCartNumber: function getCartNumber() {
        var ysUser = _storageUtil2.default.getItem(_constant.SystemConst.mShop_user);
        if (ysUser && ysUser.client_id_) {
            _routeFetch.CartFetch.sumNumber(null, function (rs) {
                if (rs.status === 1) {
                    _storageUtil2.default.setItem(_constant.SystemConst.cartCount, rs.data);
                }
            });
        }
    },

    //商城端版本不一致,清除缓存
    cleanShopCache: function cleanShopCache() {
        if (_appUtil2.default.isApp) {
            _routeFetch.System.getMobileShopVersion({}, function (rs) {
                if (rs.status == 1) {
                    var appVersion = _storageUtil2.default.getItem('shopVersion');
                    if (appVersion) {
                        if (rs.data > appVersion) {
                            _Utils2.default.title('登录过期', '登录过期，请重新登录', { confirmLabel: '确认' }).then(function () {
                                localStorage.clear();
                                sessionStorage.clear();
                                _appUtil2.default.cleanCache();
                            });
                        }
                    } else {
                        _storageUtil2.default.setItem('shopVersion', rs.data);
                    }
                }
            });
        }
    },


    // 客户设置
    getClientSetting: function getClientSetting() {
        return new Promise(function (resolve, reject) {
            _routeFetch.ShopFetch.getClientSetting({}, function (rs) {
                if (rs.status === 1) {
                    _storageUtil2.default.setItem(_constant.SystemConst.clientSetting, rs.data);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            });
        });
    },


    // 商品设置
    getGoodsSetting: function getGoodsSetting(companyId) {
        return new Promise(function (resolve, reject) {
            _routeFetch.ShopFetch.getGoodsSetting(companyId, function (rs) {
                if (rs.status === 1) {
                    // console.log(rs);
                    // 品牌数据列表
                    _storageUtil2.default.setItem(_constant.SystemConst.brandList, rs.data.brandList);
                    // 风格数据列表
                    _storageUtil2.default.setItem(_constant.SystemConst.styleList, rs.data.styleList);

                    _storageUtil2.default.setItem(_constant.SystemConst.tagList, rs.data.tagList);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            });
        });
    },
    listTypeByCompany: function listTypeByCompany(companyId) {
        return new Promise(function (resolve, reject) {
            _routeFetch.ShopFetch.listTypeByCompany({ companyId: companyId }, function (rs) {
                if (rs.status === 1) {
                    var handleRemoveIsShowShop = function handleRemoveIsShowShop(list) {
                        list.forEach(function (type) {
                            if (type.children && type.children.length > 0) {
                                type.children = handleRemoveIsShowShop(type.children);
                            }
                        });
                        return list.filter(function (item) {
                            return item.fieldMap.is_display_store_;
                        });
                    };
                    rs.data.children = handleRemoveIsShowShop(rs.data.children);
                    _storageUtil2.default.setItem(_constant.SystemConst.typeList, rs.data);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            });
        });
    },
    getApplicationStatus: function getApplicationStatus(companyId) {
        return _routeFetch.System.getApplicationStatus({ company_id_: companyId }, function (rs) {
            if (rs.status === 1) {
                _storageUtil2.default.setItem(_constant.SystemConst.applicationStatus, rs.data);
            }
        });
    },
    getUserInfo: function getUserInfo() {
        return _routeFetch.System.getUserInfo(null, function (rs) {
            if (rs.status === 1) {
                _storageUtil2.default.setItem(_constant.SystemConst.userInfo, rs.data);
            }
        });
    },
    getMsgSettingByCompanyId: function getMsgSettingByCompanyId() {
        return _routeFetch.System.getMsgSettingByCompanyId(null, function (rs) {
            if (rs.status === 1) {
                _storageUtil2.default.setItem(_constant.SystemConst.msgSetting, rs.data);
            }
        });
    },
    getCustomerServiceList: function getCustomerServiceList() {
        return _routeFetch.System.getCustomerServiceList({}, function (rs) {
            if (rs.status === 1) {
                _storageUtil2.default.setItem(_constant.SystemConst.customerServiceList, rs.data || []);
            }
        });
    }
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BusinessUtil = undefined;

var _routeFetch = __webpack_require__(94);

var _Utils = __webpack_require__(147);

var _Utils2 = _interopRequireDefault(_Utils);

var _mathUtils = __webpack_require__(224);

var _mathUtils2 = _interopRequireDefault(_mathUtils);

var _storageUtil = __webpack_require__(50);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

var _constant = __webpack_require__(51);

var _urlConfig = __webpack_require__(77);

var _urlConfig2 = _interopRequireDefault(_urlConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BusinessUtil = {

    //修改购物车
    updateCart: function updateCart(cartInfo, _success) {
        var _arr = [];

        var info = {
            company_id_: localStorage.getItem("companyId"), //公司id
            product_id_: cartInfo.product_id_, //规格id
            goods_id_: cartInfo.goods_id_, //商品id
            number_: cartInfo.number_, //数量
            unit_id_: cartInfo.unit_id_
        };
        _arr.push(info);
        // BusinessUtil.updateSpecInfoWithCartInfo(info);
        _routeFetch.CartFetch.saveCart({ jsonStr: JSON.stringify(_arr) }, function (rs) {
            if (rs.status === 1) {
                var cartNumber = 0;
                var cartCount = 0;
                var cartTotal = 0;
                var productIds = '';
                var productList = [];
                if (rs.data.pdList.length > 0) {
                    // 获取id串
                    rs.data.pdList.map(function (goods) {
                        goods.productList.map(function (product) {
                            product.inputNumber = product.cart_number_;
                            productIds += productIds.length > 0 ? ',' + product.id_ : product.id_;
                            // 返回规格用于更新数量
                            if (product.id_ === cartInfo.product_id_) {
                                productList.push(product);
                            }
                        });
                    });
                    // 获取优惠
                    _routeFetch.CartFetch.getPromotionByProductIds({ productIds: productIds }, function (rs1) {
                        if (rs1.status === 1) {
                            rs1.data.map(function (promotion) {
                                rs.data.pdList.map(function (goods) {
                                    if (goods.id_ == promotion.goods_id_) {
                                        goods.productList.map(function (product) {
                                            if (product.id_ == promotion.product_id_) {
                                                product.promotion = promotion;
                                            }
                                        });
                                    }
                                });
                            });
                            //应用促销规则
                            rs.data.pdList.map(function (goods) {
                                cartNumber++;
                                var multi_unit_ = _Utils2.default.toParse(goods.multi_unit_);

                                goods.productList.map(function (product) {
                                    product = BusinessUtil.usePromotionPrice(product);
                                    cartCount = cartCount + product.cart_number_;

                                    // 多单位并且选择的不是默认单位,计算价格
                                    if (goods.is_multi_unit_ && product.unit_id_ !== multi_unit_.unit_id_) {
                                        var units = {};
                                        multi_unit_.extend_units_.map(function (unit) {
                                            if (product.unit_id_ === unit.unit_id_) {
                                                units = unit;
                                            }
                                        });
                                        // 单位换算
                                        cartTotal = cartTotal + product.cart_number_ * product.realPrice * units.scale_;
                                        if (!product.promotion && product.is_original_price_ && multi_unit_.enable_discount_) {
                                            cartTotal -= units.discount_ * product.cart_number_;
                                        }
                                    } else {
                                        cartTotal = cartTotal + product.cart_number_ * product.realPrice;
                                    }
                                });
                            });
                            window.cartNumber = cartNumber;
                            window.cartCount = cartCount;
                            window.cartTotal = cartTotal;
                            window.cartInfo = rs.data.pdList;
                            localStorage.setItem('cartNumber', window.cartNumber);
                            localStorage.setItem('cartCount', window.cartCount);
                            localStorage.setItem('cartTotal', window.cartTotal);
                            window.cartInfo = rs.data.pdList;
                            _success(window.cartTotal, window.cartCount, window.cartTotal, productList);
                        }
                    });
                }

                if (rs.data.pdList.length === 0) {
                    window.cartNumber = cartNumber;
                    window.cartCount = cartCount;
                    window.cartTotal = cartTotal;
                    localStorage.setItem('cartNumber', window.cartNumber);
                    localStorage.setItem('cartCount', window.cartCount);
                    localStorage.setItem('cartTotal', window.cartTotal);
                    window.cartInfo = rs.data.pdList;
                    _success(window.cartNumber, window.cartCount, window.cartTotal, productList);
                }
            }
        });
    },
    updateWindowCart: function updateWindowCart(pdList) {
        var cartNumber = 0,
            cartCount = 0,
            cartTotal = 0;
        if (pdList && pdList.length > 0) {

            pdList.map(function (goods) {
                cartNumber++;
                goods.productList.map(function (product) {
                    cartCount = cartCount + product.cart_number_;
                    cartTotal = cartTotal + product.cart_number_ * product.price_;

                    //同时修改商品规格的存储信息
                    var info = {
                        company_id_: localStorage.getItem("companyId"), //公司id
                        product_id_: product.id_, //规格id
                        goods_id_: goods.id_, //商品id
                        number_: product.cart_number_ //数量
                    };
                });
            });
        }
        window.cartNumber = cartNumber;
        window.cartCount = cartCount;
        window.cartTotal = cartTotal;
        window.cartInfo = pdList;

        localStorage.setItem("cartCount", cartCount);
        var company_id_ = localStorage.getItem("companyId"); //公司id
        //同时修改商品规格的存储信息
        if ((!pdList || pdList.length == 0) && company_id_) {
            var key = "GoodsSpec_" + company_id_;
            localStorage.removeItem(key);
        }
    },

    //判断订单是否有优惠信息,有则应用优惠信息
    userOrderPromotionPrice: function userOrderPromotionPrice(cartData) {
        if (cartData.orderPromotion) {
            var totalNum = _Utils.NumberUtil.toNumber(cartData.totalNum);
            var totalPrice = _Utils.NumberUtil.toNumber(cartData.totalPrice);
            var promotionIndex = undefined;
            if (cartData.orderPromotion.type_ == 1) {
                //买赠
                if (cartData.orderPromotion.is_stair_) {
                    //启用阶梯
                    for (var i in cartData.orderPromotion.item_list_) {
                        cartData.orderPromotion.item_list_[i].isUse = undefined;
                        if (totalPrice >= cartData.orderPromotion.item_list_[i].target_money_) {
                            promotionIndex = i;
                            if (i > 0) {
                                cartData.orderPromotion.item_list_[i - 1].isUse = false;
                            }
                        }
                    }
                } else {
                    promotionIndex = totalPrice >= _Utils.NumberUtil.toNumber(cartData.orderPromotion.item_list_[0].target_money_) ? 0 : undefined;
                }
                if (promotionIndex != undefined) {
                    /*
                     // 注:这个算法本来就是有错误的-需要判断是否启用阶梯,再判断是否要按倍数计算
                     let target_money_ = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].target_money_);
                     let multiple = Math.floor(totalPrice / target_money_);   //倍数
                     cartData.presentNumber = MathUtil.mul(multiple, NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].present_number_));
                     cartData.orderPromotion.item_list_[promotionIndex].real_present_number_ = cartData.presentNumber;
                     cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                     cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                     */
                    cartData.presentNumber = _Utils.NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].present_number_);
                    cartData.orderPromotion.item_list_[promotionIndex].real_present_number_ = cartData.presentNumber;
                    cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                    cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[Number(promotionIndex) + 1];
                } else {
                    cartData.useOrderPromotion = undefined;
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[0];
                }
                cartData.promotionTotal = 0;
            } else if (cartData.orderPromotion.type_ == 2) {
                //直降
                if (cartData.orderPromotion.is_stair_) {
                    //启用阶梯
                    for (var i in cartData.orderPromotion.item_list_) {
                        cartData.orderPromotion.item_list_[i].isUse = undefined;
                        if (totalPrice >= cartData.orderPromotion.item_list_[i].target_money_) {
                            promotionIndex = i;
                            if (i > 0) {
                                cartData.orderPromotion.item_list_[i - 1].isUse = false;
                            }
                        }
                    }
                } else {
                    promotionIndex = totalPrice >= _Utils.NumberUtil.toNumber(cartData.orderPromotion.item_list_[0].target_money_) ? 0 : undefined;
                }
                if (promotionIndex != undefined) {
                    /*
                     cartData.orderPromotion.item_list_[promotionIndex].isUse = isUse;
                     cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                     let targetMoney = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].target_money_);
                     let cutMoney = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].cut_money_);
                     cartData.promotionTotal = Math.floor(MathUtil.div(totalPrice, targetMoney)) * cutMoney;
                     */
                    var cutMoney = _Utils.NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].cut_money_);
                    cartData.promotionTotal = cutMoney;
                    cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                    cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[Number(promotionIndex) + 1];
                } else {
                    cartData.useOrderPromotion = undefined;
                    cartData.promotionTotal = 0;
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[0];
                }
            } else if (cartData.orderPromotion.type_ == 3) {
                //打折
                if (cartData.orderPromotion.is_stair_) {
                    //启用阶梯
                    for (var i in cartData.orderPromotion.item_list_) {
                        cartData.orderPromotion.item_list_[i].isUse = undefined;
                        if (totalPrice >= cartData.orderPromotion.item_list_[i].target_money_) {
                            promotionIndex = i;
                            if (i > 0) {
                                cartData.orderPromotion.item_list_[i - 1].isUse = false;
                            }
                        }
                    }
                } else {
                    promotionIndex = totalPrice >= _Utils.NumberUtil.toNumber(cartData.orderPromotion.item_list_[0].target_money_) ? 0 : undefined;
                }
                if (promotionIndex != undefined) {
                    cartData.promotionTotal = _mathUtils2.default.mul(totalPrice, _mathUtils2.default.minus(1, cartData.orderPromotion.item_list_[promotionIndex].cut_percent_ / 100.00));
                    cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                    cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[Number(promotionIndex) + 1];
                } else {
                    cartData.useOrderPromotion = undefined;
                    cartData.promotionTotal = 0;
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[0];
                }
            }
        } else {
            cartData.promotionTotal = 0;
        }
        return cartData;
    },
    checkExperience: function checkExperience(companyId) {
        var experienceCompanyIds = [118, 729, 724, 121, 128, 117, 124, 116, 119, 122, 123, 725];
        return experienceCompanyIds.includes(Number(companyId));
    },
    clearAccount: function clearAccount() {
        //管理端退出
        localStorage.removeItem("ysMgrUser");
        //订货端退出
        localStorage.removeItem("ysUser");
        //删除购物车信息
        delete window.cartNumber;
        delete window.cartCount;
        delete window.cartTotal;
        localStorage.removeItem('cartNumber');
        localStorage.removeItem('cartCount');
        localStorage.removeItem('cartTotal');
        localStorage.removeItem("mgrAccountList");
        localStorage.removeItem("shopAccountList");
    },
    toLogout: function toLogout(rUrl, save) {
        var query = BusinessUtil.getSearchFromUrl();

        if (!save) {
            BusinessUtil.clearAccount();
        }

        var hostUrl = BusinessUtil.buildHostUrl();
        // 获取分享人
        var shareUserId = _storageUtil2.default.getItem('_shareClientId_') || _storageUtil2.default.getItem(_constant.SystemConst.shareUserId, true);
        var shareClientId = _storageUtil2.default.getItem(_constant.SystemConst.shareClientId, true);
        var search = shareUserId ? '&u=' + shareUserId : shareClientId ? '&c=' + shareClientId : '';

        // 清除本地缓存
        // localStorage.clear();
        localStorage.removeItem("ysUser");
        sessionStorage.clear();
        _storageUtil2.default.setItem(_constant.SystemConst.companyId, query.companyId);

        var logOutUrl = hostUrl + '/' + (rUrl || 'login') + '?companyId=' + query.companyId + search;
        if (_Utils.CheckUtil.isSecondUrl) {
            //如果是第二正式url  am.ysdinghuo.com
            logOutUrl = 'https://astore' + query.companyId + '.' + _urlConfig2.default.getHost() + '.com/' + (rUrl || 'login') + '?companyId=' + query.companyId + search;
        } else if (_Utils.CheckUtil.isThirdUrl) {
            logOutUrl = 'https://bstore' + query.companyId + '.' + _urlConfig2.default.getHost() + '.com/' + (rUrl || 'login') + '?companyId=' + query.companyId + search;
        }
        window.location.href = logOutUrl;
    },
    //企業注冊
    toCompanyRegister: function toCompanyRegister() {
        var url = _urlConfig2.default.getAccountUrl() + '/register';
        window.location.href = url;
    },


    //检查是否已登录
    isLogin: function isLogin() {
        var companyId = _storageUtil2.default.getItem(_constant.SystemConst.platformCompanyId) || _storageUtil2.default.getItem(_constant.SystemConst.companyId);
        if (companyId) {
            var ysUser = _storageUtil2.default.getItem(_constant.SystemConst.mShop_user);
            //如果已有用户登录信息,判断用户存储的用户信息的企业id是否跟当前访问的企业一致
            if (ysUser) {
                var userCompanyId = ysUser.company_id_;
                if (+companyId !== userCompanyId) {
                    // localStorage.removeItem('ysUser');
                    // localStorage.removeItem("accountData");
                    // localStorage.removeItem("mgrAccountList");
                    // localStorage.removeItem("shopAccountList");
                    // localStorage.removeItem("token");
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }
    },

    //确认是否跳转登录
    toLogin: function toLogin(path) {
        if (!BusinessUtil.isLogin()) {
            var companyId = localStorage.getItem("companyId");
            // 统一支持nextPath参数，生产环境也传递
            location.href = BusinessUtil.buildHostUrl() + '/login?companyId=' + companyId + (path ? '&nextPath=' + encodeURIComponent(path) : '');
            return;
        } else {
            return;
        }
    },

    buildHostUrl: function buildHostUrl() {
        var hostname = window.location.hostname;

        var query = BusinessUtil.getSearchFromUrl();
        if (true) {
            if (_Utils.CheckUtil.isSecondUrl) {
                return 'https://astore' + query.companyId + '.' + _urlConfig2.default.getHost() + '.com';
            } else if (_Utils.CheckUtil.isThirdUrl) {
                return 'https://bstore' + query.companyId + '.' + _urlConfig2.default.getHost() + '.com';
            }
            return 'https://store' + query.companyId + '.' + _urlConfig2.default.getHost() + '.com';
        } else if (process.env.API_ENV === 'test') {
            return 'http://store' + query.companyId + '.yimaideng.cn';
        } else {
            return 'http://' + hostname + ':8993';
        }
    },
    // 获取url参数
    getSearchFromUrl: function getSearchFromUrl() {
        var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;

        var searchObj = {};
        var subIndex = search.indexOf("?");
        if (subIndex > -1) {
            search = search.substr(subIndex + 1);
        }
        search.split('&').map(function (item) {
            var itemArr = item.split("=");
            if (itemArr[0] && itemArr[1]) {
                searchObj[itemArr[0]] = itemArr[1];
            }
        });
        return searchObj;
    },

    //清除用户账号信息
    cleanAccountData: function cleanAccountData(newCompanyId) {
        //有传值
        if (newCompanyId && localStorage.getItem("ysUser")) {
            //如果两次企业不一致
            // if (newCompanyId != JSON.parse(localStorage.getItem("ysUser")).company_id_) {
            //     localStorage.removeItem('ysUser');
            //     localStorage.removeItem("accountData");
            //     localStorage.removeItem("mgrAccountList");
            //     localStorage.removeItem("shopAccountList");
            //     localStorage.removeItem("token");
            // }
        }
    },
    // 小程序处理-- 永远带上分享的业务id
    fixWxMiniProgramShare: function fixWxMiniProgramShare(url) {
        if (!url) {
            url = location.href;
        }
        var shareUserId = _storageUtil2.default.getItem('_shareClientId_') || _storageUtil2.default.getItem(_constant.SystemConst.shareUserId, true);
        var shareClientId = _storageUtil2.default.getItem(_constant.SystemConst.shareClientId, true);
        var search = shareUserId ? '&u=' + shareUserId : shareClientId ? '&c=' + shareClientId : '';
        return url + search;
    },

    fixShareParams: function fixShareParams() {
        var query = {};
        var shareUserId = _storageUtil2.default.getItem('_shareClientId_') || _storageUtil2.default.getItem(_constant.SystemConst.shareUserId, true);
        var shareClientId = _storageUtil2.default.getItem(_constant.SystemConst.shareClientId, true);
        if (shareUserId) {
            query.u = shareUserId;
        }
        if (shareClientId) {
            query.c = shareClientId;
        }
        return query;
    },

    // 退货单状态
    refundStatus: {
        '11,21,31': '待审核',
        '41,51': '待退货',
        '61,71': '待退款',
        '100': '已完成',
        '999': '已取消'
    }
};

exports.BusinessUtil = BusinessUtil;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var en_US = {
    "GuanShui": "Customs duty‌",
    "ZiZhangHao": "SubAccount",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",

    "Ci": "once",
    "ZBZCBQFH": "Emoji are not supported yet",
    "FaSongLianJie": "Send link",
    "YiChangXiaoXi": "Exception message",
    "QingShuRu": "Please enter",
    "FaSong": "Send",

    "DQSJXYKSSJ": "The current time is less than the start time",
    "DQSJCGJSSJ": "Current time exceeds end time",
    "QuXiao": "Cancel",
    "NianYueRi": "year month day",
    "ShiFen": "Time",
    "QueDing": "Determine",
    "Nian": "year",
    "Yue": "month",
    "Ri": "day",
    "Shi": "H",
    "Fen": "M",

    "Qi": "Up",

    "1GeCuXiao": "1 promotion",
    "ChaKanZengPin": "View giveaway",
    "JHDJSHS_1T": "Remaining: {d} days {h} hours {m} minutes {s} seconds",
    "YHGZ_ZPBKD": "Preferential rules: gifts cannot be obtained by stacking",
    "YHGZ_AZZGM": "Discount rules: enjoy the discount according to the final purchase quantity",
    "GuanBi": "shut down",
    "Man1Song1": "Get {mai} full{song}",

    "QuanBu": "All",
    "ZWXGSJ": "No relevant data",
    "ZuiDiJia": "Lowest price",
    "ZuiGaoJia": "Highest price",
    "LeiXing": "Types of",
    "PinPai": "Brand",
    "BiaoQian": "label",
    "JiaGeQuJian": "The price range",
    "SPMC_GG_BH_": "Product name / Specifications / Serial number / Initials",
    "ZuHeShaiXuan": "Combinatorial screening",
    "ChongZhi_CanShu": "Reset",

    "ZDKSC1ZTP": "You can upload up to 1 picture",
    "ZYXSCTP": "Only upload pictures",
    "SCTPDXBYXC": "The upload image size is not allowed to exceed 5M",
    "QBYCFSCTP_": "Please do not upload pictures repeatedly, or make sure the picture name is unique",
    "ShangChuanChengGong": "Uploaded successfully",
    "ZDKSC1Z": "You can upload up to 1",

    "CCSLZDXZ": "Maximum number exceeded",
    "QiDingLiang": "MOQ",
    "ShouQi": "Collapse",
    "ShanChu": "Delete",

    "FanHui": "return",

    "Dai": "generation",
    "YiQuXiao": "Cancelled",
    "ZengPin": "Giveaway",
    "1Zhong": "{num} Species",
    "1Jian": "1 item",
    "HeJi": "Total",
    "DaiFu": "To be paid",

    "_DDM1YZ1J_": "[Free {name}{number} on full order of {target}]",
    "_DDM1YLJ1Y_": "[Order full {m} minus {n} yuan]",
    "_DDM1YLX1Z_": "[Order full {m} yuan enjoy {n} fold]",
    "DingDanCuXiao": "Order promotion",

    "DLCKJG": "Log in to view prices",

    "DianPuZhuYe": "Store Home",
    "GouWuChe": "Shopping cart",
    "ZaiXianKeFu": "Online service",
    "GeRenZhongXin": "Personal center",
    "LianXiDianHua": "contact number",
    "FanHuiDingBu": "Back to top",

    "ZBDYML": "Page not found",
    "KNWZCW_HZY": "The URL may be wrong, or the page may be deleted",
    "FanHuiShangJi": "Return to superior",
    "FanHuiShouYe": "Back to top",

    "SPQDBNWK": "Product list cannot be empty",
    "WoZhiDaoLe": "I know",
    "SFQRSCSP": "Are you sure to delete the product?",
    "QueRen": "confirm",
    "ZYXSRSZBQB": "Only numbers are allowed and no more than 2 decimal places",
    "ShangPinDanJia": "Commodity price",
    "YSPYJ": "Original price",
    "QSRZDJG": "Please enter the specified price",
    "ShuLiang": "Quantity",
    "DanWei": "unit",
    "DanJia": "unit price",
    "BeiZhu": "Remarks",
    "YiChuShangPin": "Remove product",
    "XiuGai": "modify",

    "TPSLCCYXSZ": "The number of pictures exceeds the allowable value!",
    "WJBDDY5M_QC": "The file should not be larger than 5m, please choose again",
    "TPSCWC": "Picture upload completed",

    "_DGSLM1JZ1J": "[Free one for every 10 orders]",
    "_M1JLXMJ1Y_": "[Full {target} enjoy every {cut_money_}]",
    "_DHJJZ1Y_": "[The order price is reduced to {cuted_price_} yuan]",
    "_M1JLXMJ1Z_": "[Full {target} enjoy every {cut_percent_} fold]",
    "_YDHJD1Z_": "[The original order price is discounted by {cuted_percent_}]",
    "YuJiKaiShiFaHuo": "Shipment is expected to begin with {date}",
    "YuJi": "Expected",
    "MMYDDR": "MM month DD day",
    "KaiShiFaHuo": "Start shipping",
    "_DGSLM1Z1_": "[Free {provide} with full order quantity {target}]",
    "_M1LXM1Y_": "[For every 10 USD, enjoy 100 USD]",
    "_M1LXM1Z_": "[10% off for every 100-plus]",
    "DaiQueRen": "To be confirmed",
    "DaiFaHuo": "Pending shipment",
    "DaiShouHuo": "Shipped",
    "YiWanCheng": "Completed",
    "DaiFuKuan": "Unpaid",
    "YiFuKuan": "Paid",
    "YiZuoFei": "Abolished",
    "DaiShenHe": "Pending review",
    "DaiHeXiao": "To be written off",
    "YiHeXiao": "Written off",
    "XianXiaZhiFu": "Offline payments",
    "ZhiNengDaoZhangShiBie": "线下汇款(智能到账识别)",
    "WeiXinZhiFu": "WeChat Pay",
    "ZFBZF": "Pay with Ali-Pay",
    "YuEZhiFu": "Balance Payment",
    "HuoDaoFuKuan": "Cash on delivery",
    "DaiTuiHuo": "Pending return",
    "DaiTuiKuan": "Pending refund",
    "ChuangJianDingDan": "Create Order",
    "BianJiDingDan": "Edit order",
    "TiJiaoDingDan": "Submit orders",
    "DingDanShenHe": "Order review",
    "CaiWuShenHe": "Financial Audit",
    "BoHui": "turn down",
    "TianJiaShouKuan": "Add Payment",
    "ZaiXianZhiFu": "Online payments",
    "ShouKuanShenHe": "Collection review",
    "ShouKuanZuoFei": "Invalid receipt",
    "ChuKu": "Outbound",
    "ChuKuShenHe": "Outbound audit",
    "FaHuo": "Ship",
    "TianJiaWuLiu": "Add logistics",
    "XiuGaiWuLiu": "Modify logistics",
    "ChuKuZuoFei": "Out of stock",
    "ShouHuo": "Receipt",
    "DingDanHeZhun": "Order approval",
    "QuXiaoDingDan": "Cancel order",
    "CJTHD": "Create a return order",
    "DaYin": "print",
    "DaoChu": "Export",
    "DingDanWanCheng": "Order completed",
    "QiangZhiWanCheng": "Compulsory completion",
    "DingDanZuoFei": "Order void",
    "MaiZeng": "Buy gifts",
    "ZhiJiang": "fall",
    "DaZhe": "Discount",
    "YuShou": "Pre-sale",
    "DingDanManZeng": "Free orders",
    "DingDanManJian": "Order full reduction",
    "DingDanManZhe": "Full discount",
    "XinRenQuan": "Newcomer coupon",
    "ManJianQuan": "Full cut coupons",
    "ShangPinQuan": "Merchandise coupon",
    "DaiJieSuan": "To be settled",
    "YiJieSuan": "Settled",
    "QuanBuShangPin": "All products",
    "TuiJianShangPin": "Recommended products",
    "XinPin": "New product",
    "ReXiaoShangPin": "Hot Products",
    "ChangYongShangPin": "Commonly used goods",

    "DaiShouKuan": "Pending Payment",
    "BuFenShouKuan": "Partial collection",
    "YiShouKuan": "paid for",
    "BXYFP": "No invoice required",
    "ZZSPTFP": "VAT general invoice",
    "ZZSZYFP": "VAT invoice",
    "QiTaFaPiao": "Other invoices",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Pre-deposit",
    "XianXiaZhuangZhang": "Offline transfer",
    "XianShangZhiFu": "Online Payment",
    "YCKZF": "Advance deposit Payment",
    "DaiTiJiao": "To be submitted",
    "KuaiDi": "Express delivery",
    "SongHuoShangMen": "Delivery",
    "ShangMenZiQu": "Home Pickup",
    "WuLiuHuoYun": "Logistics freight",
    "QiTa": "Other",

    "QSRBXY6WDM": "Please enter a password with at least 6 digits",
    "QSRBDY20WDM": "Please enter a password no larger than 20 digits",
    "MMGSCW": "Password format error",

    "SJCW_QLXKF": "Data is wrong, please contact customer service",
    "ZBZCQD": "No sign-in support yet",
    "HuJiao": "call",
    "DLZHBCZ": "Login account does not exist",
    "QLXGLYKT": "Please contact the administrator to activate",
    "GQYZHBJY": "The corporate account is disabled",
    "QLXYSDH": "Please contact \"Cloud Order\"",
    "GQYZHSYQJS": "The trial period of the enterprise account ends",
    "GQYZHYGQL": "The enterprise account has expired",
    "XYXFCNSY": "Renewal required to use",
    "GQYBCZCZH": "The company does not have this account",
    "NDDHZHYBQY": "Your order account has been banned by the enterprise \"Order on the Cloud\" and you cannot log in. Please contact the administrator",
    "NYBSQY1DHZ": "You are no longer a cooperative customer of Enterprise 1 and cannot log in. Please contact the administrator",
    "NDDPYBTY_B": "Your store has been deactivated and you cannot log in. Please contact the administrator",
    "GZHWKTDSZB": "The account has not opened the special feature of lighting. Please contact the administrator",
    "WXSQYZYGQ": "WeChat authorization verification has expired",
    "WXSQSB": "WeChat authorization failed",
    "WXSQSB_CWX": "WeChat authorization failure error message",
    "DengLuGuoQi": "Login expired",
    "DLGQ_QCXDL": "Login expired, please log in again",

    "ShangJia": "Put on shelf",
    "YiXiaJia": "Removed",
    "YiJinYong": "disabled",
    "YiQiYong": "activated",
    "YiTingYong": "terminated",
    "KeHuZhuCe": "Customer registration",
    "XinZengDaoRu": "New import",
    "DDDSH": "Pending order review",
    "DCWSH": "Pending financial review",
    "DaiChuKu": "To be out of the library",
    "DCK_BF_": "Out of stock (partial)",
    "DFH_BF_": "To be shipped (partial)",
    "DSH_BF_": "To be received (partial)",
    "DSK_BF_": "To be collected (partial)",
    "WTHSQ": "No return application",
    "THDSH": "Returns are pending review",
    "THCLZ": "Return processing",
    "THYWC": "Return has been completed",
    "DYDHD": "Print order form",
    "DYFHD": "Print invoice",
    "DCDHD": "Export order form",
    "DCFHDWE_P": "Export invoice as Excel/PDF file",
    "TuiDanZuoFei": "Charge back",
    "DTHSH": "Pending return audit",
    "DaiRuKu": "Pending storage",
    "DRK_BF_": "Pending storage (partial)",
    "DFK_BF_": "Pending Payment (partial)",
    "ChuangJianTuiDan": "Create chargeback",
    "BianJiTuiDan": "Edit chargeback",
    "TiJiaoTuiDan": "Submit a refund",
    "TuiHuoShenHe": "Return audit",
    "RuKu": "Warehousing",
    "RuKuShenHe": "Warehousing audit",
    "RuKuZuoFei": "Put into storage",
    "TianJiaFuKuan": "Add Payment",
    "FuKuanZuoFei": "Payment is invalid",
    "FuKuanShenHe": "Payment review",
    "TuiDanWanCheng": "Refund completed",
    "QiTaChuKu": "Other outbound",
    "XiaoShouChuKu": "Sales out of stock",
    "PanKuiChuKu": "Out of stock",
    "DiaoBoChuKu": "Transfer out of library",
    "CaiGouTuiHuo": "Purchase returns",
    "TuiHuoRuKu": "Returned goods",
    "CaiGouRuKu": "Purchase storage",
    "QiTaRuKu": "Other storage",
    "PanYingRuKu": "Surplus inventory",
    "DiaoBoRuKu": "Transfer to storage",
    "CJCGD": "Create Purchase Order",
    "BJCGD": "Edit purchase order",
    "TJCGD": "Submit Purchase Order",
    "CGDZF": "Purchase order is invalid",
    "CGDWC": "Purchase order completed",
    "CGTHZF": "Purchase returns are invalid",
    "CGTHWC": "Purchase returns completed",
    "THDDY": "Return order printing",
    "THDDC": "Export order export",
    "CKDDY": "Print out receipt",
    "CKDDC": "Export order export",
    "GLDZH": "Management account",
    "DHDZH": "Order account",
    "ShenHeTongGuo": "examination passed",
    "SHBTG": "Audit not passed",
    "WuXuFaPiao": "No invoice required",
    "DaiKeXiaDan": "Valet orders",
    "ZiZhuXiaDan": "Place orders autonomously",
    "PCShangCheng": "PC Mall",
    "APPShangCheng": "APP Mall",
    "TVShangCheng": "TV Mall",
    "WeiXinShangCheng": "WeChat Mall",
    "ShouJiShangCheng": "Mobile phone mall",
    "ADDXSMLTC": "Gross profit margin on order",
    "ADDXSSRTC": "Commission on sales revenue",
    "AKHSSYG": "By customer's employee",
    "AnZhiDanRen": "Single player",
    "ATHJEBLKCT": "Deduct the commission amount in proportion to the amount returned",
    "DDYTHBJXTC": "Orders are returned without commission",
    "DaiDaKuan": "Pending Payment",
    "WeiKaiShi": "has not started",
    "JinXingZhong": "processing",
    "YiGuoQi": "Expired",

    "YouHuo": "In stock",
    "WuHuo": "Sold Out",
    "Yi": "Billion",
    "QianWan": "Ten million",
    "BaiWan": "million",
    "Wan": "Ten thousand",
    "Sheng1Tian": "1 day left",
    "Sheng1XiaoShi": "1 hour left",
    "1Miao": "1 second",
    "GangGang": "just",
    "1FenZhongQian": "1 minute ago",
    "1XiaoShiQian": "1 hour ago",
    "1TianQian": "1 day ago",
    "1GeYueQian": "1 month ago",
    "1NianQian": "1 year ago",
    "WeiZhiLeiXing": "Unknown type",

    "YYGBCDSP_K": "There is a good product, take a look",
    "ZanWeiSheZhi": "Not set yet",

    "HQWXSQXX": "Get WeChat authorization information",

    "JGJYYDMBQ": "The zoom ratio will be set according to the existing meta tags",

    "NLJZZ": "Hard to load",
    "ShangPinMingXi": "Product details",
    "ShangPinLeiBie": "Product category",
    "QXZFPNR": "Please select the invoice content",
    "QXZFPLX": "Please select invoice type",
    "QTXFPTT": "Please fill in the invoice",
    "FaPiaoTaiTou": "Invoice",
    "NSRSBH": "Taxpayer Identification Number",
    "FaPiaoNeiRong": "invoice content",
    "FaPiaoXinXi": "Invoice Information",
    "KaiJuFaPiao": "Invoice",
    "FaPiaoLeiXing": "invoice type",
    "Han": "Contain",
    "WeiHan": "Not included",
    "Shui": "tax",
    "QSRFPTT": "Please enter the invoice header",
    "QSRNSRSBH": "Please enter the taxpayer identification number",

    "YiManZu_Man": "Satisfied [full",
    "ZaiGou": "Repurchase",
    "YMZ_DHJJZ": "Has been satisfied [Order price dropped",
    "JianJiangZhi": "Drop to",
    "YMZ_YDHJD": "Has satisfied [the original order price hit",
    "JianMeiJian": "Pieces per piece",
    "SYTCSLW0_WFJRGWC": "The number of remaining packages is 0 and cannot be added to the shopping cart",
    "QingXuanXeShangPin": "Please select a product!",
    "GSPYXJ": "This product is no longer available!",
    "ZJ2TN": "Within the last {day} days",
    "QDQCXJSP": "Are you sure you want to clear the product?",
    "QingChuChengGong": "Cleared successfully",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Package products cannot be added to the shopping cart, please cancel the package products and then move to the shopping cart!",
    "SPSLBN": "The number of products cannot",
    "TaoCanHan": "Package includes",
    "TaoCan": "Package",
    "QHDSL": "Please check the quantity",
    "SPSLBNDY": "The number of products cannot be lower than",
    "XianDingLiang": "Limited quantity",
    "YiRuShouCang": "Move to favorites",
    "QuanXuan": "Select all",
    "JianZeng": "Gift",
    "JianLiXiang_Man": "Piece Li Xiang[full",
    "Yuan_": "USD]",
    "Zhe_": "fold]",
    "KCBZ_WFJRGWC": "Insufficient inventory to add to cart",
    "XDJEDYDY": "Order amount is greater than or equal to",
    "WYXJHYSXDSP": "No discontinued or expired products!",
    "DYQDL": "Below the MOQ",
    "ZSPG1J": "{count} products, total {number}",
    "WanCheng": "Carry out",
    "BianJi": "Edit",
    "You": "Have",
    "ZSPBFHYQ_W": "10 kinds of products do not meet the requirements, are not checked, click to view",
    "SPSLBNGY": "The number of products cannot be higher than",
    "JXDJ_CKXYGBFHYQSP": "Continue to click to see the next product that does not meet the requirements",
    "XiaDan": "Place an order",
    "JianJiang": "Piece drop",
    "QRYCSP": "Confirm removal?",
    "QXZXDSP": "Please select the order product",
    "KCBZ_QCXXZ": "Insufficient stock, please choose again!",
    "KuCun": "in stock",
    "YCKXD": "Only 100 dollars can be placed",
    "QDSCSP": "Are you sure to collect items?",
    "ShouCangChengGong": "Collection success",
    "GYXDL": "Above the limit",
    "LiSheng": "Province",
    "GWCHSKD_QGYGB": "The shopping cart is still empty, go shopping",
    "QuGuangGuang": "Go shopping",
    "QCXJSP": "Clear products",
    "ZongE": "lump sum",
    "YouHui": "Discount",

    "QXZJHRQ": "Please select a delivery date",
    "FuJiaFeiYong": "Additional fees",
    "ZhongShangPin_Gong": "10 products,total 1",
    "PeiSongShiJian": "Delivery Time",
    "QXZPSSJ": "Please select delivery time",
    "DingDanJinE": "Order amount",
    "SCFJ_ZD4Z": "Upload attachments, up to 4 sheets, single sheet not exceeding 3M",
    "KeYongShangPin": "Available products",
    "ShiYongShuoMing": "Instructions for use",
    "YouXiaoQi": "Expiration date",
    "Man": "full",
    "BZZBZCTSFH": "Remarks temporarily do not support special symbols",
    "QingXuanZe": "please choose",
    "KaiPiaoXuJia": "Invoice needs to be added",
    "PeiSongFangShi": "Delivery Method",
    "ZiTi": "Self Pickup",
    "PeiSong": "Delivery",
    "MianYunFei": "Free Shipping",
    "ZuiYou": "Best",
    "KeHuZhiDing": "Customer Specified",
    "ShangJiaPeiSong": "Merchant Delivery",
    "WuPeiSongFangShi": "No Delivery Method",
    "ShangPinZongJia": "Commodity price",
    "YouHuiQuan": "Coupon",
    "ZhangKeXan": "Zhang optional",
    "DDJEWMZ": "Order amount not met",
    "WDYHQ": "my discount coupon",
    "KYYHQ": "Available coupons",
    "YuanKeYong": "Yuan available",
    "ChaKanDingDan": "check order",
    "ShangPinHanShui": "Goods tax included",
    "SPWHS": "The goods do not include tax",
    "GeDian": "Points",
    "QueRenDingDan": "Confirm Order",
    "XZSHDZ": "New shipping address",
    "ShangPinQingDan": "Commodity list",
    "WKYYHQ": "No coupons available",
    "HuChi": "Mutually exclusive",
    "DaiJinQuan": "Voucher",
    "YunFei": "Freight",
    "ShuiFei": "Taxes",
    "WKYYY": "Reason for unavailability",
    "YHQYGQ": "Coupon has expired",
    "WDYHQSYSJ": "Coupon time",
    "ZDSPJEWMZ": "The specified product amount is not met",
    "BKYYHQ": "Unavailable coupons",
    "YMZ_MZ": "Satisfied [free {n} with full {m} yuan]",
    "ZG2JX_MZ": "Repurchase {num} item [Free {present} on full {target}]",
    "YMZ_MYZJ_": "Already satisfied [full {m}USD gift {n} pieces]",
    "YMZ_MYJY_": "Has satisfied [full {m}USD minus {n}USD]",
    "ZGYX_MYJY_": "Repurchase {m}USD and enjoy [full {n}USD minus {o}USD]",
    "YMZ_MYZ_": "Has satisfied [full {m}USD{n} discount]",
    "ZGYX_MYZ_": "Re-purchase {m}US dollars and enjoy [full {n}US dollars {o} discount]",

    //cart-presale-order

    "QXZPSFS": "Please select delivery method",
    "1ZSP_G": "1 product, total 1",
    "YSSP_YJ": "Pre-sale goods, expected",
    "JiaoHuoRiQi": "Delivery dates",
    "GMJLY": "Message to seller",

    //scan-to-cart

    "ZhengZaiChuLi...": "Loading...",
    "FSCSP": "Non-mall merchandise",
    "ZZCLTXM": "Loading...",
    "SPTJCG": "Product added successfully",
    "QSTXM": "Please scan the barcode",
    "SFSCDQSP": "Do you want to delete the current product?",
    "BQ_ZBDXGSP": "Sorry, no related products",
    "XuanZeDanWei": "Choose unit",
    "JRGWC": "Add to Shopping Cart",
    "QXXZDJRSP": "Please select the product to be added first",
    "ZhengZaiChuLi": "Processing",
    "JRGWCCG": "Add to Cart successful",
    "ZanWuShangPin": "No products",

    //earn-brokerage-share

    "XTYJBNFZSP": "The system has copied the product link for you!",
    "NKYHDDYDYJ": "You can get the corresponding commission. Commission can be viewed in ",
    "WeiXinHaoYou": "WeChat friends",
    "ErWeiMa": "QR code",
    "CASBEWM": "Long press to identify QR code",
    "FZSB_QCXFZ": "Copy failed, please copy again!",
    "TWEWM": "Graphic QR Code",
    "BCDXC": "save into the album",
    "CATPBCDXC": "Long press the picture to save to album",
    "FuZhiLianJie": "copy Link",
    "FXZYJ": "Share earning commission",
    "YJZGKZQYJ": "Expected to earn the highest commission",
    "PYTGNFXDYMCGGMH": "After your friends successfully buy through your Shared page, you can get the corresponding commission.Commission is available in \"my -{path}\"",

    //goods-share

    "FXSPGLSKH": "Share products to retail customers",
    "FXHJSCNZSD": "After sharing, your exclusive mobile micro-marketplace will be generated. You can set the price of the products in the marketplace, fill in your contact information, and attract consumers to come and buy.",
    "WSCDQJG_ND": "The current price of the micro mall: your order price ×",
    "DaiSheZhi": "To be set",
    "PengYouQuan": "Circle of friends",
    "GGFXSZ": "Change sharing settings",

    //wechat-login

    "QXSRZH": "Please enter the account number first",
    "MMGSCW_6_20W": "Password format error (6-20 letters or numbers)",
    "BDYYZH": "Bind an existing account",
    "WXKJDL": "WeChat quick login",
    "BangDingZhangHao": "Bind account",
    "YYZH_QDL": "Have an account, log in",
    "ZCXZH": "Register a new account",
    "HuanYingNi": "Welcome",
    "ZH_SJHM": "Account/Mobile Number",
    "MiMa": "password",
    "QDLHCZ": "Please log in to operate",

    //add-to-cart

    "KCBZ_BNTJG": "Insufficient inventory, can't add more",

    //combined-pay-online

    "ZhiFuChengGong": "Payment successful!",
    "ZFSB_QCXCS": "Payment failed, please try again!",

    //

    "QXXZGG": "Please select the specifications first",
    "SXGGX": "Selected specifications required",
    "GMSLXYQDL_": "The purchase quantity is less than the MOQ, please buy again!",
    "GMSLDYXDL_": "The purchase quantity is greater than the limit order quantity, please re-purchase!",
    "ShangPinBianHao": "Product Number",
    "QiDing": "Minimum order",
    "SXGGDGSLBK": "The order quantity of the selected specifications cannot exceed",
    "KCBZ_BNTJ": "Insufficient inventory can not be added",
    "QXXZSP": "Please select the product first",
    "SLBNW0": "The quantity cannot be 0",
    "QXZGG": "Please select specifications",
    "LiJiYuDing": "order now",

    //nav

    "ShouYe": "Home",
    "ShangPin": "commodity",
    "DingDan": "Orders",
    "WoDe": "mine",

    //pay-online

    "ZhiFuQuXiao": "Payment cancellation",

    //account-log

    "ShangPinYongJin": "Commodity commission",
    "YaoQingJiangLi": "Invitation reward",
    "TiXian": "withdraw",
    "TiXianBoHui": "Withdraw",
    "ZhuanWeiYuE": "Transfer to balance",
    "Jin7Tian": "Nearly 7 days",
    "Jin30Tian": "Nearly 30 days",
    "ShouZhiMingXi": "Income and Expenditure Details",
    "ZanWuShuJu": "No data",

    //client-statistics

    "WoDeKeHu": "My client",
    "WoDeYaoQing": "My invitation",

    //distribution-home

    "LeiJiKeHu": "Cumulative customers",
    "LeiJiDingDan": "Cumulative order",
    "YaoQingHaoYou": "invite friends",
    "LeiJiYaoQing": "Cumulative invitation",
    "LJSY_Y_": "Cumulative income (USD)",
    "BHDJS": "Include pending settlement",
    "J7TSY_Y_": "Profit in the last 7 days (USD)",
    "J7TXZKH_R_": "New customers (people) in the last 7 days",
    "KTXYJ": "Withdrawable commission",
    "XYJYO": "Need to cheer",
    "ChangJianWenTi": "common problem",
    "Q_ZMYJX_TG": "Q: How to carry out \"promotion to make money\"",
    "A_FXDPND_Z_": "A: Share the page link with the \earn\ icon in the store to attract friends to click, friend registration (customer relationship is set to register and bind) or order (customer relationship is set to order binding) to buy a band in the store\ Earning \ icon products will be counted as your \"promotion of making money \" income according to a certain calculation method.",
    "Q_RHJS_TGZ": "Q: How to calculate the income from \"promotion of making money\"?",
    "A_MGD_Z_TBD": "A: Each product with the \earn\ icon has a certain percentage of commission. If there is no such mark, the product does not participate in \"promotion of making money\". After a friend makes a successful Payment through your sharing link, the commission will be calculated separately according to the commission percentage of each product in the order (the commission that does not participate in the promotion becomes 0), and finally the commission income of the order will be accumulated. The amount of freight, refund, full reduction, etc. will be deducted from the revenue calculation, and the final transaction price shall prevail.",
    "Q_TGZQ_DSY": "Q: When will the income from \"promotion make money\" arrive?",
    "A_HYTGNDFX": "A: After your friend has successfully paid through your sharing link, you can see the promotion in the promotion order in the sales center. The status is to be settled. After the customer confirms the receipt of the order, the transaction will be automatically transferred to you. Your personal account can be withdrawn at any time.",
    "Q_LJKH_LJY": "Q: Does the cumulative customer and cumulative invitation list have no avatar nickname?",
    "A_WXYQZYGZ": "A: WeChat requires that you only get the nickname of the avatar if you pay attention to the authentication service number. The customer with the authentication service number pays attention to the public account of the store, and the non-certification service number pays attention to the public account of \"ordering on the cloud \". .",
    "Q_WSMWASSG": "Q: Why didn't I get the promotion revenue when sharing according to the above rules?",
    "A_1_HYKNBW": "A: 1. The friend may not have established a customer relationship with you (the friend clicked the link of another salesperson to register or place an order) 2. If the friend opens your sharing link outside the WeChat environment (such as the default browser of the mobile phone), If the browser does not open cookies, it will not be able to record customer relationships, that is, the promotion order cannot be recorded. 3. If the above is not a problem, the promotion order is still not recorded, please contact the staff.",

    //

    "XiaoShouZhongXin": "Selling Centre",

    //generalize-goods

    "SPMC_GG_BH": "Product name / specifications / number",
    "YuJiZhuan": "Expected to earn",

    //invitation-home

    "YaoQingKa": "invitation card",
    "YNYQJR_TGY": "You are invited to join together to promote and win rewards",
    "DJBCDXC": "Click Save to Album",
    "JYQKFSGHY_": "Send the invitation card to friends to promote the store rewards",

    //join-home

    "HuanYingJiaRu": "Welcome",
    "YQNCW": "Invite you to become",
    "LiJiJiaRu": "Join now",

    //order-statistics

    "YuJiYongJin": "Estimated commission",
    "YongJin": "commission",
    "YuJiJiangLi": "Estimated reward",
    "JiangLi": "reward",
    "SPTGDD": "Product promotion orders",
    "YQJLDD": "Inviting reward orders",

    //performance-statistics

    "YeJiTongJi": "Performance statistics",
    "LJKH_R_": "Cumulative customers (person)",
    "SPYJ_Y_": "Commodity commission (USD)",
    "HanDaiJieSuan": "Including pending settlement",
    "XGMCJS": "Explanation of related terms",
    "KeHu": "client",
    "HFXYBDLKHG": "Buyers or distributors who bind customer relationships with distributors",
    "YaoQing": "invite",
    "FXYCGYQDXJ": "Sub-distributors successfully invited by distributors",
    "FXYTJKHGMH": "After the distributor recommends the customer to buy, the distributor can get the commission",
    "XJFXYTGSPH": "After the lower level distributor promotes the product, the higher level gets the reward",

    //posters-promoting

    "NiCheng": "nickname",
    "HaiBaoTuiGuang": "Poster promotion",
    "JHBFSGHY_T": "Sending posters to friends and promoting the store pays off",

    //settlement-home

    "JieSuanZhongXin": "Settlement Center",
    "KTXJE": "Withdrawable cash",
    "TiXianJiLu": "Withdrawals record",

    //withdraw-account

    "KHRXMBNWK": "Account holder name cannot be empty!",
    "KHHBNWK": "Account bank cannot be empty!",
    "YHKHBNWK": "The bank card number cannot be empty!",
    "SFZTPBNWK": "ID card picture cannot be empty!",
    "YHKTPBNWK": "Bank card pictures cannot be empty!",
    "BaoCunChengGong": "Saved successfully!",
    "SCSFZ": "Upload ID",
    "SCYHK": "Upload bank card",
    "BaoCun": "save",
    "TiXianZhangHu": "Withdraw account",
    "TS_QTXZSXX": "Tip: Please fill in the real information, and only then withdraw it after passing the review",
    "KHRXM": "Account holder name",
    "KaiHuHang": "Account Bank",
    "YinhangKaHao": "Bank card number",
    "QSRZSXM": "please enter your real name",
    "QSRKHHMC": "Please enter the bank name",
    "QSRYHKH": "Please enter the bank card number",

    //withdraw-deposit

    "QXSZTXZH": "Please set up a withdrawal account first",
    "QuSheZhi": "To set",
    "JEXY10Y_BKT": "The amount is less than 10 US dollars and cannot be withdrawn!",
    "JECGKTXJE": "The amount exceeds the cash withdrawal amount!",
    "CGDRKTXSX_": "Exceed the upper limit for withdrawals on that day, and the upper limit for single withdrawals is $20,000!",
    "QDJ200YZD": "Are you sure you want to transfer $200 to the balance?",
    "QueDingJiang": "Sure will",
    "ZhuanDaoYuE": "Go to the balance?",
    "_JEDY10YSB": "1. No withdrawal when the amount is less than 10 US dollars;",
    "_BCTXDZSJ": "2. The withdrawal time for this withdrawal is within 5 working days after the successful withdrawal application is initiated, and the single-day withdrawal limit is USD 20,000;",
    "_GBSRWHSS": "3. The income is tax-included income, please go to the relevant tax authorities to declare and pay personal income tax!",
    "_ZDYEKYYS": "4. The transfer balance can be used for shopping in the mall;",

    "TXSQCG_QDD": "Withdrawal application successful, please wait for review",
    "JEDYKTXJE_": "The amount is greater than the cash withdrawal amount and cannot be transferred to the balance!",
    "ZZYECG_QDG": "The transfer balance is successful, please check it in the \"Personal Center\"!",
    "BenCiTiXian": "This withdrawal",
    "ZhuangDaoYuE": "Go to balance",
    "TiXianDao": "Withdraw to",
    "JEW0BKZZYE": "The amount of 0 cannot be transferred to the balance!",
    "DRTXSX2WY": "Daily withdrawal limit of USD 20,000",
    "QuanBuTiXian": "Withdraw all",
    "QueRenTiXian": "Confirm withdrawal",

    //goods-filter-tab

    "ZuiChangGouMai": "Most frequently purchased",
    "MoRenPaiXu": "Default sort",
    "ZongHe": "Comprehensive",
    "FenLei": "Classification",
    "XiaoLiangYouXian": "Sales priority",
    "XiaoLiang": "Sales",
    "JiaGe": "Price",
    "ShaiXuan": "Filter",
    "ZuiJinGouMai": "Recently purchased",
    "CuXiaoYouXian": "Promotion priority",
    "QuanBuFenLei": "All Categories",
    "ZhiKanCuXiao": "Only look at promotions",
    "XuanZeFenLei": "Choose category",
    "QXZFL": "please select a type",

    //goods-list-default

    "ZWXGSP": "No related products",

    //goods-brand-list

    "PinPaiHui": "Brand Exchange",

    //goods-classify-filter

    "TuiJianFenLei": "Recommended categories",
    "ShangPinFenLei": "Categories",
    "GengDuo": "More",

    //goods-detail

    "DLZHBSDQQY": "The login account is not the current corporate customer account",
    "GXNHQ": "Congratulations on your acquisition",
    "SZWSCJGH_C": "Only after setting the price of the micro mall",
    "JHDJSHS_": "Until the end of the event",
    "DLHKFX": "Share after login",
    "ZZHQXX_QSH": "Getting information, please try again later",
    "Zhang": "Zhang",
    "Tian": "day",
    "QXZGGZQPD": "Please select the specifications and then go with the lights!",
    "Yuan": "US dollar",
    "XS_F_M": "Hour/minute/second",
    "Miao": "second",

    //integral

    "WoDeJiFen": "My scores",
    "DaBaiLe": "defeated",
    "JiFen": "integral",
    "DeHuiYuan": "Member of",
    "ZhuanJiFen": "Earn points",
    "JiFenMingXi": "Points Details",
    "HuanLiPin": "Change gifts",
    "CKGDHL": "See more gifts",
    "ChaDingDan": "Check order",

    //integral-convert

    "DHSLBNCG": "Redemption quantity cannot exceed",
    "DuiHuanShuLiang": "Exchange quantity",
    "SuoXuJiFen": "Points required",

    //integral-detail

    "LiPinXiangQing": "Gift details",
    "WoYaoDuiHuan": "I want to exchange",
    "ShengYu": "Remaining",
    "TuWenXiangQing": "Graphic details",
    "Jian": "Piece",
    "YiDuiWan": "Finished",

    //integral-filter

    "FenLeiShaiXuan": "Category screening",
    "JiFenShaiXuan": "Points screening",

    //integral-flow

    "JiFenShouRu": "Point income",
    "JiFenZhiChu": "Point spend",

    //integral-logistics

    "DingDanGenZong": "order tracking",
    "WuLiuGongSi": "Logistics company",
    "WuLiuDanHao": "shipment number",

    //integral-order

    "DingDanLieBiao": "Order List",
    "YiFaHuo": "Shipped",
    "JiFenDingDan": "Point order",
    "ChaKanWuLiu": "View Logistics",

    //integral-order-create

    "LPSLBZ_QCX": "There are not enough gifts, please repay",
    "JiFenBuZu": "Insufficient points",
    "ZhiFuXinXi": "Payment Information",
    "JiXuGuangGuang": "Continue shopping",
    "QTXSHXX": "Please fill in the receipt information",
    "DuiHuanChengGong": "Redemption succeeded",
    "LPDHQR": "Gift redemption confirmation",
    "SCCKJ": "Market reference price",
    "LiJiZhiFu": "pay immediately",

    //integral-order-detail

    "DingDanXiangQing": "Order details",
    "DingDanZhuangTai": "Order Status",
    "DingDanBianHao": "Order number",
    "DuiHuanShiJian": "Redemption time",
    "ShouHuoXinXi": "delivery information",
    "HuaFeiJiFen": "Spend points",

    //integral-rule

    "QDZJF": "Sign in to earn points",
    "XDZJF": "Place points to earn points",
    "1_MRQD_JL": "1. Daily check-in and reward {num} points",
    "2_LXQD3T_EW": "2. Sign in for 3 consecutive days, additional bonus {num} points",
    "3_LXQD7T_EW": "3. 7 consecutive days of check-in, additional bonus {num} points",
    "DLZJF": "Log in to earn points",

    "MRDLYSDHSC": "Log in to the {name} mall daily and reward {num} points",
    "DDWCHKHDYD": "After the order is completed, you can get points that are *{num} times the order amount",

    //integral-rule-detail

    "GuiZe": "rule",

    //integral-sign

    "QianDaoYouLi": "Sign in courteously",
    "QianDaoGuiZe": "Sign-in rules",

    "YLXQD": "Checked in consecutively",
    "YLXQD1T": "Have checked in for {num} consecutive days",
    "QDCG_NYJLX": "Check-in successful, you have checked in for {num} consecutive days",
    "QDCG_BCHD1": "Sign in successfully, get {num} points this time",
    "BCQDHD4JF_": "Sign up this time to get {num} points, great!",

    "QSRBZ": "Please enter a remark",
    "DingDanZengPin": "Order giveaway",
    "GuiGeBianHao": "Specification number",
    "GuiGe": "Specification",

    "CDDWXFK": "No Payment for this order",
    "YHYEBZ": "Insufficient user balance!",
    "ZFJEBNW0": "Payment amount cannot be 0!",
    "ZFJEBNDYDD": "The Payment amount cannot be greater than the order pending Payment amount",
    "DFKJE": "Amount to be paid",
    "FuKuanFangShi": "Payment method",
    "FuJian": "annex",
    "ZHYFZ": "Account copied",
    "GHSKZH": "Change Payment account",
    "SYXXZFQSCF": "To use offline Payment, please upload the attachment of the Payment screenshot so that the finance can confirm the Payment!",
    "XXZF_BXXZS": "Offline Payment must select the receiving account",
    "DingDanZhiFu": "Payment of an order ",
    "ZFFS_HDFK": "Payment method: cash on delivery",
    "BCFKJE": "The amount of this Payment",
    "YuE": "Balance",
    "FuZhiZhangHao": "Copy account",
    "WSZXCXZFPZ": "Applet Payment configuration is not set",
    "XCXZFZHJY": "Applet Payment account disabled",
    "SRZFJE": "Enter Payment amount",
    "FuKuanZhangHu": "Payment account",
    "QueRenZhiFu": "confirm Payment",
    "ShaoHouZhiFu": "Pay later",

    "FKJLYTJ_DD": "Payment record has been added, pending financial review",
    "JiXuGuang": "Continue shopping",
    "BenCiFuKuan": "This payment",
    "FuKuanChengGong": "Successful payment",
    "ZhiFuFangShi": "payment method",
    "ZhiFuDingDan": "Payment order",

    "QXXZSXZFDD": "Please select the order to be paid first",
    "PiLiangFuKuan": "Bulk payment",
    "FuKuan": "Payment",
    "QuFuKuan": "Go to pay",

    "YingFuJinE": "Amounts payable",
    "XiaDanShiJian": "Order time",

    "SFQRSH": "Do you confirm receipt?",
    "DDQRSH": "Order confirmation receipt",
    "DFHSP": "Products to be shipped",
    "ShangPinShuLiang": "amount of goods",
    "ChuKuShiJian": "Delivery time",
    "FaHuoShiJian": "Delivery time",
    "WuLiuBeiZhu": "Logistics notes",
    "QueRenShouHuo": "Confirm receipt",

    "RYFK_QJSYG": "If payment has been made, please contact the administrator in time",
    "QSRQXYY": "Please enter the reason for cancellation",
    "H_DDJZDGB_QJKF": "After the order will be automatically closed, please pay as soon as possible",
    "TuiHuoQingKuang": "Returns",
    "DingDanZongE": "Order total",
    "DingDanBeiZhu": "order notes",
    "FaHuoQingKuang": "Delivery situation",
    "DingDanFuJian": "Order attachment",
    "ShenQingTuiHuo": "Application for return",
    "G1TDSHJL_QRS": "There are altogether {num} receiving records. Do you confirm receipt?",
    "TDSHJL_QRS": "A record of the goods to be received, confirm the receipt?",
    "DaiXiaDan": "Place an order",
    "DingDanHao": "Order number",
    "XiaDanFangShi": "Order method",
    "TuiHuoDan": "Return Form",
    "ShangPinZongE": "Total merchandise",
    "YunFei_ZongZhong": "Freight (total weight)",
    "SF_SPWS": "Taxes and fees (goods not taxed)",
    "TePiJia": "Special price",
    "FuKuanQingKuang": "Payment situstion",
    "TiaoJiLu": "Records",
    "ZaiLaiYiDan": "One more order",
    "MuLiuXinXi": "Logistics information",
    "QDSCGDD_": "Are you sure you want to delete this order?",
    "YiQueRen": "Confirmed",
    "YiShouHuo": "Received",
    "DaiFuJinE": "Amount to be paid",
    "YiFuJinE": "Amount paid",
    "ZanWuJiLu": "No records",

    "SPMC_DDH": "Product name / order number",
    "FuKuanZhuangTai": "payment status",
    "FaHuoZhuangTai": "Delivery status",
    "QiShiShiJian": "Start time",
    "ZhongZhiShiJian": "stop the time",

    "CaoZuoChengGong": "Successful operation",
    "ZBKGM": "Not available for purchase",
    "DQDDSPYXJ": "The current order item is no longer available",
    "DQDDBFSPYXJ": "Some products in the current order have been removed",
    "JTJSJSP": "Only add products",
    "DingHuoDan": "Order Form",

    "DingDanRiZhi": "Order log",

    "FuZhiChengGong": "Copy successful",
    "FuZhiShiBai": "Copy failed",
    "FuZhi": "copy",
    "BoDa": "Call",
    "WCWLDHXX": "No such logistics order information",

    "ZFCS_QCXXD": "Payment is overtime, please re-order",
    "YQYYCKZF": "Pre-deposit payment is enabled",
    "BNDYDFKJE": "Cannot be greater than the amount to be paid",
    "ZFJEBNWK": "Payment amount cannot be empty",
    "QXAPFK_FKH": "Please arrange the payment first, upload the payment information on the screenshot after payment, so that the financial confirmation of the payment",
    "DDTJCG_QJS": "Order submitted successfully, please pay in time",
    "QXZFKFS": "Please choose a payment method",
    "SYYEZFH_HX": "After paying with balance, you have to pay",

    "FuKuanJiLu": "payment record",
    "ZWFKJL": "No payment history",
    "FuKuanXiangQing": "Payment details",
    "FuKuanJinE": "Payment amount",
    "ZhiDan": "Make order",
    "ShenHe": "Audit",
    "ZuoFei": "Void",
    "ZuoFeiYuanYin": "Reason for invalidation",
    "GLDHD": "Related order",
    "HeXiaoJinE": "Write-off amount",
    "HeXiaoZhuangTai": "Write-off status",
    "DanJuZhuangTai": "Document status",
    "KeHuMingCheng": "client's name",
    "ZhangDanHao": "account number",
    "ShouKuanZhangHao": "Accounts receivable",
    "ShouKuanShiJian": "Collection time",
    "FuKuanPingZheng": "Proof of payment",
    "GeFuJian": "Attachments",

    "DingDanTongJi": "Order statistics",

    "DingHuo0Bi": "Order {num} pen",

    "DDTJMX": "Order Statistics Details",
    "AGGTJ": "Statistics by specifications",
    "AFLTJ": "Statistics by category",
    "DDJE_Y": "Order amount/yuan",
    "DHSP_Z": "Order product/species",
    "DingHuoDan_Bi": "Order Form/Pen",
    "DingHuoShangPin": "Order goods",
    "JinE": "Amount",

    "TuiHuo": "Return",

    "THDHWBC_QD": "The return order has not been saved. Are you sure to leave?",
    "QSRSQTHJE": "Please enter the refund amount",
    "QSRTHJE": "Please enter the return amount",
    "QSRBZXX": "Please enter remark information",
    "YingTuiJinE": "Refundable amount",
    "TJTHSQ": "Submit a return request",
    "QXXZDHQD": "Please select the order list first",
    "DingHuoQingDan": "Order list",
    "SQTHJE": "Request return amount",
    "DJXZSP": "Click to select product",
    "TuiHuoJinE": "Returned amount",

    "THDDXQ": "Return order details",
    "YiTuiHuo": "Returned",
    "YiTuiKuan": "refunded",
    "THDZT": "Return order status",
    "TuiHuoDanHao": "Return order number",
    "TuiHuoShiJian": "Return time",
    "TuiHuoCangKu": "Return warehouse",
    "THLXR": "Return Contact",
    "TuiHuoQingDan": "Return list",
    "TuiKuanZongE": "Total refund",
    "TuiKuanQingKuang": "Refund situation",
    "DaiTuiJinE": "Amount to be refunded",
    "YiTuiJinE": "Refunded amount",

    "SPMC_BH_GG": "Product name / serial number / specification serial number / barcode",
    "GZD1TJG": "1 result found",
    "JiaRuQingDan": "Add to list",

    "ShenQingChengGong": "Successful application",
    "THDTJCG": "Return form submitted successfully",
    "ChaKanXiangQing": "see details",

    "HDWKS_WDZL": "The event has not started, come back later",
    "HDYJS_XCZD": "The event is over, come early next time",
    "ZWSZBT": "No title set yet",
    "ChaKanGengDuo": "see more",

    "HCDZSJC": "Caching causes time difference",
    "DLCKCXJ": "Log in to view sale price",
    "ZWSZCX": "No promotion",
    "JuKaiShi": "From the start",
    "Song": "give away",
    "JuJieShu": "End",
    "YiJieShu": "Over",

    "XiaoXi": "news",
    "SaoMaXiaDan": "Scan the order",

    "WZLCSJ": "Unknown floor data",

    "QXZYSDHAPP": "Please download the ordering app on the cloud",
    "QMTYQYGLD": "Fully experience the enterprise management side",
    "XZYSDHAPP": "Download cloud ordering APP",
    "HQGLDWZTY": "Get a complete experience on the management side",
    "JXTYDHD": "Continue to experience the ordering end",

    "GongGaoXiangQing": "Announcement details",
    "GongGaoFuJian": "Announcement attachment",

    "NFWDYMBCZO": "The page you visited does not exist~",
    "KeNengYuanYin": "possible reason",
    "1_ZDZLSRCWD": "1. Enter the wrong address in the address bar;",
    "2_DJLGQLJ": "2. Clicked the expired link.",

    "GuanLiDuan": "Management side",
    "ZhuCe": "registered",
    "HYNTYYSDH": "You are welcome to experience ordering on the cloud",
    "TYZHSJHDQG": "Experience account data will be updated regularly, please do not enter important information",
    "TYZHZDNRSJ": "The content data in the experience account are fictitious, please do not enter important information",
    "ZHZCCG": "Account registration successful",
    "DengLuZhangHao": "Login account",
    "CSMMW": "The initial password is",
    "GNFYHQL": "Send you a coupon",
    "Man1YuanKeYong": "Full {num} yuan available",
    "LQH1TNKY": "Available within {day} days after receipt",
    "YiJianLingQu": "One-click collection",
    "GXNHD1ZYHQ": "Congratulations on getting {num} coupons",
    "Gong1Yuan": "Total {num}USD",
    "LiJiShiYong": "use immediately",

    "NHWDL": "You are not logged in",

    "ShangChengGongGao": "Mall announcement",
    "ZanWuGongGao": "No announcement",
    "1GeFuJian": "{num} attachment",

    "KouKuan": "Deduction",
    "ChongZhi_Kuan": "Top up",
    "KouKuanZuoFei": "Deduction",
    "ChongZhiZuoFei": "Top up",
    "ZhangHuMingXi": "Account details",
    "ZhangHuYuE": "Account Balance",
    "LiJiChongZhi": "Top up now",

    "CZJEBNXY1Y": "The recharge amount cannot be less than 1 USD",
    "QSRZQDSZ": "Please enter the correct value",
    "ZDYJE": "Custom amount",
    "ZWKTXSCZGN": "Online recharge function has not been activated yet",
    "ShiFuJinE": "The amount actually paid",
    "ZhangHuChongZhi": "Account recharge",
    "QXZCZJE": "Please select the recharge amount",
    "QSRCZJE": "Please enter the recharge amount",
    "QLXNDZSYWY": "Please contact your dedicated salesperson to recharge",
    "ShouJia": "Selling price",
    "YiShouQing": "Sold out",
    "ChongZhiJinE": "Recharge amount",
    "QueRenFuKuan": "confirm payment",

    "QSDDID": "Missing order id",
    "ChongZhiChengGong": "Deposit successfully",
    "ChongZhiShiBai": "Recharge failed",
    "CLZ_QSH...": "Processing, please wait...",
    "ChongZhiFangShi": "Recharge method",
    "ChongZhiShiJian": "Recharge time",
    "JYLSH": "Transaction serial number",
    "FanHuiShangCheng": "Back to the mall",

    "ZFSB_QCS": "Payment failed, please try again",
    "ZFYQX": "Payment canceled",
    "ZFYC_QCS": "Payment is abnormal, please try again",

    "LingQuanZhongXin": "Coupon Center",
    "WeiShiYong": "Unused",
    "YiShiYong": "Used",
    "ZWYHQ": "No coupons",

    "YiGouMai": "bought",
    "ChangYongQingDan": "Common list",
    "WoDeShouCang": "My collection",
    "QuGouWuChe": "Go shopping cart",
    "GeShangPin": "Products",

    "YunShangDingHuo": "Order on the cloud",
    "QSRZH": "please enter account!",
    "QSRMM": "Please enter the password!",
    "QSRDLZH": "Please enter a login account",
    "JiZhuMiMa": "Remember password",
    "WangJiMiMa": "forget password?",
    "DengLu": "log in",
    "DLZHBCZ_QL": "The login account does not exist, please contact the administrator to activate",
    "GQYZHSBJY_": "The enterprise account is disabled, please contact the cloud to order",
    "GQYZHSYQJS_": "After the trial period of the enterprise account is over, please contact the cloud to order",
    "GQYZHYGQL_": "The enterprise account has expired and needs to be renewed to use, please contact the cloud to order",
    "LiJiTiYan": "Try it now",

    "YiChuChengGong": "Move out successfully",
    "QueHuo": "Out of stock",
    "YCSCJ": "Remove from favorites",

    "SheZhiChengGong": "Set up successfully",
    "ZWWDXX": "No unread messages",
    "QuanBuYiDu": "All read",
    "DingDanXiaoXi": "Order message",

    "YiQiang": "Robbed",
    "LiJiLingQu": "get it right now",
    "LingQuanHou": "After receiving the coupon",
    "TianNeiKeYong": "Available within 7 days",

    "QSRSJH": "Please enter phone number",
    "QSRYZM": "please enter verification code",
    "QSRXMM": "Please enter a new password",
    "QSRZQSJGS": "Please enter the correct mobile phone format",
    "ChongZhiMiMa": "reset Password",
    "QSRNDSJHM": "please enter your phone number",
    "QSRDXYZ": "Please enter SMS verification",
    "HQYZM": "get verification code",
    "HKCXHQ": "Reacquired after 59 seconds",
    "QSR6_20WSZHZ": "Please enter a password of 6-20 digits or letters",

    "QSRSPJGBL": "Please enter the product price ratio",
    "SPJGBLBXDY": "Commodity price ratio must be greater than or equal to 100 and less than 999.99",
    "DPMCZBZCTS": "Store name does not support special symbols",
    "LXRZBZCTSF": "Contacts currently do not support special symbols",
    "LXFSZBZCTS": "Contact information does not support special symbols",
    "LXDZZBZCTS": "Contact address does not support special symbols yet",
    "DPJJZBZCTS": "Store introduction does not support special symbols",
    "QSRDPJJ_ZD": "Please enter the store description, up to 50 characters",
    "FenXiangSheZhi": "Sharing settings",
    "NDWSCSPJG": "Your micro mall price",
    "NDDHJ_": "Your order price×",
    "LXXX_KBJ_": "Contact information (editable)",
    "DianPuMingCheng": "Store Name",
    "JianJie": "Introduction",
    "QSRDPMC": "Please enter the store name",
    "LianXiRen": "Contact person",
    "QSRLXR": "Please enter a contact",
    "LianXiFangShi": "Contact information",
    "QSRLXFS": "Please enter contact information",
    "LianXiDiZhi": "contact address",
    "QSRLXDZ": "Please enter contact address",

    "WoDeDingDan": "My Order",
    "ZuiJinLiuLan": "Recently Viewed",
    "ShouCangShangPin": "Favorite Product",
    "BDYYZH_ZC": "Bind an existing account | Register a new account",
    "DL_ZC": "Login | Register",
    "BangDingShouJi": "Bind phone",
    "TS_BDSJHM_": "Tip: Bind the mobile phone number, the account is safer!",
    "ChaKanQuanBu": "View all",
    "ShouHuoDiZhi": "Shipping address",
    "LianXiWoMen": "Contact us",
    "SheZhi": "Set up",
    "QuQianDao": "Sign in",
    "JiFenShangCheng": "Points Mall",
    "TuiGuangShangPin": "Promotion of goods",
    "QuChaKan": "Go check",
    "JiFenHuanLi": "Redeem points",
    "DYSPBQ": "Print product labels",

    "GYYSDH": "About \"Cloud Order\"",
    "YQHYSMEWM_": "Invite friends to scan the QR code, directly download and install",
    "DangQianBanBen": "current version",

    "ZWSHDZ": "No delivery address",
    "WoDeDiZhi": "My address",
    "ZhiNengShiBie": "Intelligent Recognition",
    "ZTDZXXKZNS": "Paste address information can intelligently identify name, phone, address",
    "MoRen": "Default",

    "QRSCDZ": "Confirm to delete address?",
    "SHRXM": "Consignee name",
    "SJHMHGDDHZ": "Fill in at least one mobile phone number or landline",
    "QSRSHRXM": "Please enter the consignee's name",
    "ShouJiHaoMa": "Mobile phone number",
    "GuDingDianHua": "Fixed telephone",
    "QSRGDDH": "Please enter a landline",
    "SuoZaiDiQu": "Area",
    "QSRSZDQ": "Please enter your region",
    "QSRXXDZ": "Please enter the detailed address!",
    "QSRZQDSJHM": "Please enter the correct phone number",
    "QSRZQDGDDH": "Please enter the correct landline",
    "XiangXiDiZhi": "Address",
    "MoRenDiZhi": "Default address",
    "SWMRDZ": "Set as the default address",
    "BCBSY": "Save and use",

    "QSRSJHM": "Please enter the phone number",
    "GYHYZC": "This user is already registered",
    "GSJHMYJZCG": "The mobile number has already been registered",
    "QZJDLJK": "Please log in directly",
    "QuDengLu": "Log in",
    "BDHKYTGSJH": "After binding, you can log in through your mobile phone number, which is convenient for you to retrieve your password and improve account security",
    "_BDHKYTGSJ": "*After binding, you can log in by mobile phone number, which is convenient for you to retrieve your password and improve account security",
    "QSRSJYZM": "Please enter the phone verification code",
    "BDXSJ": "Bind new phone",
    "DXYZM": "SMS verification code",
    "XiaYiBu": "Next step",
    "TGCBZ": "Skip this step",

    "DBDSJHMBCZ": "The phone number to be bound does not exist!",
    "QSRDLMM": "Please enter your password!",
    "_GSJHMYBDY": "*The mobile phone number has been bound to the ordering account on the cloud, verify the mobile phone login password, you can bind the current account",
    "DQZHMMJTBW": "The current account password will be synchronized to the phone login password",
    "DangQianZhangHao": "Current account",

    "QDYJZ": "Make sure you take this",
    "JSPSCM": "Is this item deleted?",
    "QDYJZ10JSP": "Are you sure you want to delete these 10 products?",
    "ShanChuChengGong": "successfully deleted!",

    "SJGSCW": "Phone format error",
    "YXGSCW": "Mailbox format error",
    "WoDeZhangHao": "My account",
    "YouXiang": "Mailbox",
    "ShouJi": "Cell phone",
    "XingMing": "Name",
    "XiuGaiTouXiang": "Modify avatar",
    "JiBenXinXi": "Basic Information",
    "ZhangHaoAnQuan": "Account security",
    "XiuGaiMiMa": "Change Password",
    "DianJiBangDing": "Click to bind",
    "RYDSHTY_QL": "If it has been lost or disabled, please replace it immediately to avoid account theft",
    "WBZNDZHAQ_": "To protect the security of your account, please bind your phone",
    "QSRNDXM": "please enter your name",
    "QSRNDDH": "Please enter your phone",
    "QSRNDYX": "Please enter your email",

    "QCHCHXCXDL": "Login again after clearing cache",
    "QingChuHuanCun": "Clear cache",
    "QDYQCHCM": "Are you sure you want to clear the cache?",
    "TuiChuDengLu": "Sign out",
    "ZhangHaoZhuXiao": "账号注销",
    "QieHuanZhangHao": "Switch account",

    "LianXi": "Contact",
    "GongSiDianHua": "Work phone",
    "DiZhi": "Address",

    "DJQMX": "Voucher details",

    "BuKeYong": "Unavailable",
    "KeYong": "Available",
    "ZWDJQ": "No vouchers",
    "ZongEDu": "Total amount",
    "FaFangShiJian": "Release time",
    "EDYYW": "Quota exhausted",
    "QBSPKY": "All products are available",

    "WDDJQ": "My voucher",
    "KYDJQ": "Available vouchers",
    "DJQKDK": "Vouchers are deductible",
    "CKKYSP": "View available products",
    "BKYDJQ": "Unavailable vouchers",
    "BKYYY_ZWFH": "Reason for unavailability: No eligible products",
    "BKYYY": 'Reason of unavailability',

    "DQSPWSCGGT": "The current product has not uploaded the specifications, and it does not support lamp matching!",
    "BoFangShiPin": "Play video",
    "Gong1GeGuiGe": "A total of {num} specifications",
    "YiXuanGuiGe": "Selected specifications",
    "XuanGuiGe": "Choose specifications",
    "LingQuan": "Collect coupons",

    "1ZhongCuXiao": "{num} promotions",
    "1ZhangKeYong": "{num} available",
    "ZuiGaoKeSheng": "Maximum saving",
    "ShangPinTaoCan": "Commodity packages",
    "Gong1GeTaoCan": "Total {num} packages",
    "ShangPinCanShu": "Product parameters",
    "ZhanKai": "Unfold",
    "YiShouCang": "collected",
    "ShouCang": "Collect",
    "KeFu": "Customer service",
    "XiangQing": "Details",
    "TuiJian": "recommend",
    "BianHao": "Numbering",
    "ShangPinXinXi": "Product information",
    "KLYHQ": "Coupons available",
    "KuCunBuZu": "Inventory shortage",
    "DuoGuiGe": "Multiple specifications",
    "YiShou": "Sold",
    "SWBHZ_YS": "Sold out for replenishment, sold",
    "CuXiaoShangPin": "Promotional items",

    "NHWSRSSNR": "You have not entered the search content",
    "SouSuo": "Search for",
    "SSY1XGDSP": "Search for products related to {searchKey}",
    "Yue1GeShangPin": "About {num} products",
    "ZuiJinSouSuo": "Recently searched",
    "QingChu": "Clear",
    "ZWSSJL": "No search history",

    "ZGJGBNDYZD": "The highest price cannot be lower than the lowest price",
    "ShangPinBiaoQian": "Commodity label",
    "BuGaoYu1": "Not higher than 1",
    "BuDiYu1": "Not less than 1",
    "FengGe": "style",

    "JiJiangKaiShi": "About to start",
    "QuanBuCuXiao": "All promotions",

    "Gong1JianShangPin": "A total of {num} products",
    "Sheng": "Save",

    "GTCZGWCZDS": "The quantity of the package in the shopping cart has reached the purchase limit, and it cannot be added to the shopping cart",
    "GTCKCBZ_BK": "The package has insufficient inventory and cannot be added to the shopping cart",
    "JinSheng1Tao": "Only {num} set left",
    "XianGou1Tao": "Limit {num} set",
    "TaoCanXiangQing": "Package details",
    "DanMaiJia": "Single purchase price",
    "TaoCanJia": "Package price",
    "HDYJS": "The event is over",

    "WDL_QXDL": "Not logged in, please log in first",

    "XinPinShangShi": "New product launch",
    "WDLZH_ZWCX": "No account, no promotions!",
    "YiXiaShangPin": "The following products",

    "1ZhongGuiGe": "{num} specifications",
    "YouKuCun": "In stock",

    "BuGaoYu": "not higher than",
    "BuDiYu": "not lower than",
    "CuXiao": "Promotion",
    "ZDYXXZ3G": "Up to 3 options are allowed",
    "GouMai": "buy",

    "Gong1Jian": "Total {num}",

    "YiChuShouCangJia": "Remove from favorites",
    "$": "$",
    "${num}": "${num}",
    "_8999_1Qi": "$ 8999.1 up",
    "Ge": "",
    "BaoZhuangFangShi": "Packing",
    "QRSCSP_": "Confirm to delete the product?",
    "JEWM_TMFRK": "Put the QR code/barcode into the frame, you can automatically scan",
    "1ZSP_G2J": "1 product, 2 in total",
    "JiuMiMa": "Old password",
    "XMM_6_20WZ": "New password (6-20 letters or numbers)",
    "QueRenMiMa": "Confirm password",

    "BDHKSYSJHD": "After binding, you can use your mobile phone number to log in, which is easy to retrieve your password and improve account security",
    "YanZhengMa": "Captcha",
    "1MHKCXHQ": "Reacquired after 1 second",
    "CSJHZ1MQFS": "This phone number sent a verification code 1 second ago, please try again later",
    "GouMaiJiLu": "Purchase History",
    "XinZengDiZhi": "Add address",
    "LingShouJia": "retail price",
    "YouHuiJia": "Preferential price",
    "ShangPinChuKu": "Commodities out of stock",
    "DengDaiShouHuo": "Waiting for delivery",
    "ShouHuoRen": "Receiver",
    "PaiZhao": "Take a picture",
    "XiangCe": "Photo album",

    "TiYanGuan": "Experience Hall",
    "JingYingShiJian": "Operating hours",
    "ZhanGuanDianHua": "Exhibition phone",
    "ZhanGuanDiZhi": "Venue address",
    "SJHQZ_QSDZ": "Data acquisition, please wait and try again!",
    "QXXZSF_": "Please select a province first!",
    "QuanBuShengFen": "All provinces",
    "QuanBuChengShi": "All cities",
    "YingYeShiJian": "Business hours",
    "ChanPinBianHao": "Product ID",
    "DLXXYGQ_QC": "The login information has expired, please log in again",
    "Man999Jian100": "{m} minus {n}",
    "ZG222YX_M1000": "Re-purchase {money} yuan to enjoy [get {num} for every {target} yuan]",
    "YiManZu": "Satisfied",
    "QDYCSP_": "Confirm removal?",
    "DGM10JZ1J": "Get 1 for every 10 orders",

    "XiaXianTongZhi": "Offline notification",
    "NDZHYZQTSB": "Your account has been logged in on other devices, please log in again. If not operated by yourself, please change the password in time",
    "GXNHQ_Z_Y_": "Congratulations on getting {name} {price} {name} ticket",
    "KPXJ1GD": "{num} points are required for invoicing",
    "QSRZQNR": 'Please enter the correct content',
    "NHYDDQKWJQ": 'You still have {num} orders with a total of {money} yuan until the outstanding balance is settled',
    "ZGLXMJ": 'Repurchase {num} item to enjoy [full {target} item reduced to {money_} yuan]',
    "ZGLXMZ": 'Repurchase {num} pieces and enjoy [full {target} pieces per piece {percent}]',

    //发票助手

    "FaPiaoZhuShou": "Invoice assistant",
    "WoDeFaPiao": "My invoice",
    "FaPiaoXiangQing": "Details on the invoice",
    "KaiPiaoShiJian": "The time of make out an invoice",
    "DaiKaiFaPiao": "For invoice",
    "DKFPJE": "Amount to be invoiced",
    "KaiPiaoJinE": "invoice amount",
    "ZFYDWT_QCSCXZF": "Payment encountered problems, please try to pay again or replace the payer",
    "QingXuanZhe": "please choose",

    "ShouXin": 'Credit extension',
    "LJSQSXED": "Apply for a line of credit immediately",
    "SXEDSHZ": "The credit line is under review",
    "SXCZ_XDCG": "Credit enough, successful order",
    "SXEDBZ_FKHFH": "Insufficient credit line, delivery after payment",
    "CGJKZQ_FKFH": "After the borrowing period, payment delivery",
    "DDTJCG_XZZCZHYB": "The order was submitted successfully. Now there is only one last step left!",

    "QTXGSMC": "Please fill in the company name",
    "QSCSFZZMZ": "Please upload the front photo of your ID card",
    "QSCSFZFMZ": "Please upload the photo on the back of your ID card",
    "QSCYYZZ": "Please upload your business license",
    "TJCG_QNXDDSH": "Submitted successfully, please wait patiently for review",
    "SXSQ": "Credit application",
    "QYJBZL": "Basic information of enterprises",
    "SQFRSFZZM": "Upload front of legal person ID card",
    "ZMSLT": "Front example diagram",
    "SCFRSFZFM": "Upload the reverse of legal person ID card",
    "FMSLT": "Reverse example diagram",
    "QQBSFZSJWZ_WZQXKBB": "Please ensure that the four corners of the ID card are complete and the text is clearly distinguishable",
    "SCYYZZ": "Upload business license",
    "ShengHeZhong": "under review",
    "TiJiaoShenHe": "Submit audit",
    "GSMC": "company name ",
    "MianFeiLing": "Get free",
    "M_KMFLQ_HQ": "Full { target } is free, but {short} is less",
    "YHDMFSP": "Free merchandise has been obtained",
    "JRMFL": "Free today",
    "LingGuangLe": "The led light",
    "KeLingQu": "Can receive",
    "YuGuJia": "future prices",
    "LXZSKF": "Contact exclusive customer service",
    "DPYDY_QSHX": "The shop is closed. Please place your order later",
    "DaYangShiJian": "Closing time",

    "ChuanHaoChaXun": 'String of number query',
    'IMEI': 'IMEI',

    "FanKuanYuE": "Refund the balance",
    "FanKuanZhiFu": "Refund payment",
    "FKYEBZ": "The refund balance is insufficient",
    "FanKuanZhangHu": "Rebates account",
    "HaiXuZhiFu": "You have to pay {price}",
    "DDDKFQRBJQSH": "Please wait for confirmation of the quotation",
    "XDTX": "Place the order to remind",
    "NH_GDDBH": "Hello, this order contains \"pre-estimated\" goods, we need to wait for the customer to confirm the quotation before payment?",
    "QRXD": "Confirm the order",
    "DaiHeJia": "For nuclear price",

    "ZHJY": "Account balance",
    "YGTG": "Promotion setup",
    "YuanGong": "Staff",
    "DuiZhanGJieSuan": "Reconciliation and settlement",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "Account balance=Pre deposit balance+Refund balance+Return pending refund - Order payable",
    "YCKYE": "Pre deposit balance",
    "FKYE": "Refund balance",
    "DDYFK": "Order payable",
    "THDTK": "Return pending refund",
    "YuCunKuanZuoFei": "Pre deposit invalidation",
    "FanKuanZhangHuMingXi": "Return account details",
    "TKCZDFKZH": "refund recharge to refund account",
    "RMBJE": "RMB Amount",

    // Stair-step shipping fee
    "JuMianYunFei": "{gap} USD away from free shipping",
    "YiManMianYunFei": "Free shipping conditions met",
    "ManYuanMianYunFei": "Free shipping over {limit} USD",
    "MeiJianYYunFeiZ": "Every {unit} USD less adds {fee} USD shipping",
    "YunFeiShangXian": "Shipping fee capped at {max} USD",
    "PiPeiQuYu": "Matched region: {region}",
    "AnDingDanJinEJieTi": "Order amount stair-step shipping",
    "JieTiYunFeiXiangQing": "Stair-step fee details",
    "ZaiGouMianYunFei": "Buy {amount} USD more for free shipping"
};
exports.default = en_US;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var es_ES = {
    "GuanShui": "Derecho de aduana‌",
    "ZiZhangHao": "Subcuenta",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",

    //components
    "ShangeChuanYanZhengTuPian": "Subir imagen de verificación",
    "ChuanHaoYanZheng": "Verificar IMEI",
    "YanZhengChuanHao": "Verificar IMEI",
    "Ci": "Tiempos",
    "DingDanMan": "Orden completa",
    "YuanZeng": "Regalo S/",
    "SCFJ_ZD4Z_DZBCG": "Cargue archivos adjuntos, hasta 4 fotos, no más de 3M",
    //ChatRoom

    "ZBZCBQFH": "Los emoji no son compatibles en este momento",
    "FaSongLianJie": "Enviar enlace",
    "YiChangXiaoXi": "Mensaje excepción",
    "QingShuRu": "Agregar nota",
    "FaSong": "Enviar",

    //DateSelector

    "DQSJXYKSSJ": "La hora actual es menor que la hora de inicio",
    "DQSJCGJSSJ": "El tiempo actual excede el tiempo final",
    "QuXiao": "Cancelar",
    "NianYueRi": "Fecha",
    "ShiFen": "Hora",
    "QueDing": "Confirmar",
    "Nian": "Año",
    "Yue": "Mes",
    "Ri": "Día",
    "Shi": "H",
    "Fen": "M",
    "Miao": "S",

    //goods-list-card

    "Qi": "Desde ",

    //goods-promotion

    "1GeCuXiao": "{num} promoción",
    "ChaKanZengPin": "Regalo",
    "JHDJSHS_1T": "Fecha Envío: {d} - {h} : {m} : {s}",
    "YHGZ_ZPBKD": "Reglas: solo 1 regalo por pedido",
    "YHGZ_AZZGM": "Reglas: Disfruta de descuentos según la cantidad de compra final",
    "GuanBi": "Cerrar",
    "Man1Song1": 'Obtén {mai} por {song}',

    //group-filtrate

    "QuanBu": "Todos",
    "ZWXGSJ": "Sin datos",
    "ZuiDiJia": "Desde",
    "ZuiGaoJia": "Hasta",
    "LeiXing": "Categorías",
    "PinPai": "Marca",
    "BiaoQian": "Etiquetas",
    "JiaGeQuJian": "Precio",
    "SPMC_GG_BH_": "Busca productos",
    "ZuHeShaiXuan": "Flitros",
    "ChongZhi_CanShu": "Restablecer",

    //image-upload

    "ZDKSC1ZTP": "Sube hasta 1 foto",
    "ZYXSCTP": "Solo sube fotos",
    "SCTPDXBYXC": "El tamaño de carga de la imagen no puede exceder los 5M",
    "QBYCFSCTP_": "No suba imágenes repetidamente ni asegúrese de que el nombre de la imagen sea único.",
    "ShangChuanChengGong": "Subido correctamente",
    "ZDKSC1Z": "Sube hasta 1",

    //keyboard

    "CCSLZDXZ": "Excedió el cantidad máximo",
    "QiDingLiang": "MOQ",
    "ShouQi": "Guardar",
    "ShanChu": "Eliminar",

    //MultiPicker

    "FanHui": "Volver a",

    //order-cart

    "Dai": "Generación",
    "YiQuXiao": "Cancelado",
    "ZengPin": "Gift",
    "1Zhong": "{num} items",
    "1Jian": "{num} pieza",
    "HeJi": "Monto Total",
    "DaiFu": "Por pagar",

    //order-promotion

    "_DDM1YZ1J_": "[Gratis {target} para pedidos superiores a {name}{number} soles]",
    "_DDM1YLJ1Y_": "[Reduzca {m} soles cuando ordene más de {n} soles]",
    "_DDM1YLX1Z_": "[Disfrute de {m}% de descuento en pedidos superiores a {n} soles]",
    "DingDanCuXiao": "Promoción de pedidos",

    //page-ad

    "DLCKJG": "Inicia sesión ver precios",

    //page-floating

    "DianPuZhuYe": "Inicio de tienda",
    "GouWuChe": "Carrito",
    "ZaiXianKeFu": "Servicio online",
    "GeRenZhongXin": "Centro personal",
    "LianXiDianHua": "Teléfono contacto",
    "FanHuiDingBu": "Volver arriba",

    //page-null

    "ZBDYML": "Página no encontrada",
    "KNWZCW_HZY": "La URL puede ser incorrecta o la página puede ser eliminada",
    "FanHuiShangJi": "Volver a superior",
    "FanHuiShouYe": "De vuelta a casa",

    //product-edit

    "SPQDBNWK": "La lista de productos no puede estar vacía.",
    "WoZhiDaoLe": "Yo se",
    "SFQRSCSP": "¿Estás seguro de que deseas eliminar el producto?",
    "QueRen": "Confirmar",
    "ZYXSRSZBQB": "Solo se permiten números y no más de 2 decimales",
    "ShangPinDanJia": "Precio unitario",
    "YSPYJ": "Precio original",
    "QSRZDJG": "Ingrese el precio especificado",
    "ShuLiang": "Cantidad",
    "DanWei": "Unidad",
    "DanJia": "Precio",
    "BeiZhu": "Nota",
    "YiChuShangPin": "Eliminar",
    "XiuGai": "Modificar",

    //yunshl

    "TPSLCCYXSZ": "¡El número de imágenes supera el valor permitido!",
    "WJBDDY5M_QC": "El archivo no debe ser mayor de 5 m, seleccione nuevamente",
    "TPSCWC": "Carga de imagen completada",

    //utils
    //BusinessFilter
    "_DGSLM1Z1_": "[Cantidad de pedido completa  {target} Regalo {provide}]",
    "_M1JLXMJ1Y_": "[completo {target} Disfruta cada {cut_money_} SOL]",
    "_DHJJZ1Y_": "[El precio del pedido baja {cuted_price_} SOL]",
    "_M1JLXMJ1Z_": "[completo {target} Disfruta cada {cut_percent_}]",
    "_YDHJD1Z_": "[de descuento sobre el precio del pedido original {cuted_percent_}]",
    "YuJiKaiShiFaHuo": "Tiempo estimado de entrega {date}",

    "YuJi": "Esperado",
    "MMYDDR": "MM - DD",
    "KaiShiFaHuo": "Comience a enviar",
    "_M1LXM1Y_": "[Cada 1 soles por 1 unidades]",
    "_M1LXM1Z_": "[Disfrute de cada 1% de descuento por cada 1 compra]",
    "DaiQueRen": "Por confirmar",
    "DaiFaHuo": "Por enviar",
    "DaiShouHuo": "Por recibir",
    "YiWanCheng": "Completado",
    "DaiFuKuan": "Por pagar",
    "YiFuKuan": "Pagado",
    "YiZuoFei": "Inválido",
    "DaiShenHe": "Por verificar",
    "DaiHeXiao": "Cancelación pendiente",
    "YiHeXiao": "Dado de baja",
    "XianXiaZhiFu": "Depósito o Transferencia",
    "ZhiNengDaoZhangShiBie": "线下汇款(智能到账识别)",
    "WeiXinZhiFu": "WeChat pago",
    "ZFBZF": "Pago Alipay",
    "YuEZhiFu": "Pago de saldo",
    "HuoDaoFuKuan": "Contra reembolso",
    "DaiTuiHuo": "Para ser devuelto",
    "DaiTuiKuan": "Por reembolsar",
    "ChuangJianDingDan": "Crear orden",
    "BianJiDingDan": "Editar orden",
    "TiJiaoDingDan": "Enviar pedido",
    "DingDanShenHe": "Revisión pedido",
    "CaiWuShenHe": "Revisión financiera",
    "BoHui": "Desestimar",
    "TianJiaShouKuan": "Agregar pago",
    "ZaiXianZhiFu": "Pagar Online",
    "ShouKuanShenHe": "Revisión recibo",
    "ShouKuanZuoFei": "Recibo inválido",
    "ChuKu": "Saliente",
    "ChuKuShenHe": "Auditoría saliente",
    "FaHuo": "Envío",
    "TianJiaWuLiu": "Añadir logística",
    "XiuGaiWuLiu": "Modificar logística",
    "ChuKuZuoFei": "Sin stock",
    "ShouHuo": "Recibo",
    "DingDanHeZhun": "Aprobación pedido",
    "QuXiaoDingDan": "Canceler pedido",
    "CJTHD": "Crear devolución",
    "DaYin": "Imprimir",
    "DaoChu": "Exportar",
    "DingDanWanCheng": "Pedido finalización",
    "QiangZhiWanCheng": "Terminación forzada",
    "DingDanZuoFei": "Orden nula",
    "MaiZeng": "Con Regalo",
    "ZhiJiang": "Bajo precio",
    "DaZhe": "Descuento",
    "YuShou": "Preventa",
    "DingDanManZeng": "Pedido completo gratuito",
    "DingDanManJian": "Reducción de orden completa",
    "DingDanManZhe": "Orden completa",
    "XinRenQuan": "Cupón de recién llegado",
    "ManJianQuan": "Cupón",
    "ShangPinQuan": "Certificado de mercancia",
    "DaiJieSuan": "Acuerdo pendiente",
    "YiJieSuan": "Resuelto",
    "QuanBuShangPin": "Todos productos",
    "TuiJianShangPin": "Productos recomendados",
    "XinPin": "Nuevo producto",
    "ReXiaoShangPin": "Productos Hot",
    "ChangYongShangPin": "Común",

    //BusinessUtil

    "DaiShouKuan": "Por recibir",
    "BuFenShouKuan": "Colección parcial",
    "YiShouKuan": "Recibido",
    "BXYFP": "Boleta",
    "ZZSPTFP": "Factura",
    "ZZSZYFP": "Factura con IVA",
    "QiTaFaPiao": "Otras facturas",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Depósito",
    "XianXiaZhuangZhang": "Transferencia offline",
    "XianShangZhiFu": "Pago online",
    "YCKZF": "Depósito",
    "DaiTiJiao": "Pendiente",
    "KuaiDi": "Expreso",
    "SongHuoShangMen": "Contraentrega",
    "ShangMenZiQu": "Recojo en Tiendas",
    "WuLiuHuoYun": "Logística",
    "QiTa": "Otros",

    //check-util

    "QSRBXY6WDM": "Ingrese una contraseña de al menos 6 dígitos",
    "QSRBDY20WDM": "Ingrese una contraseña que no tenga más de 20 dígitos",
    "MMGSCW": "Formato de contraseña incorrecta",

    //common-utils

    "SJCW_QLXKF": "Error de datos, póngase en contacto con el servicio al cliente",
    "ZBZCQD": "Iniciar sesión no es compatible en este momento",
    "HuJiao": "Llamar",
    "DLZHBCZ": "La cuenta de inicio de sesión no existe",
    "QLXGLYKT": "Póngase en contacto con el administrador para activar",
    "GQYZHBJY": "La cuenta corporativa está deshabilitada",
    "QLXYSDH": "Por favor contacte a Yunshang para ordenar",
    "GQYZHSYQJS": "El período de prueba de la cuenta empresarial finaliza",
    "GQYZHYGQL": "La cuenta corporativa ha expirado",
    "XYXFCNSY": "Necesita renovación para usar",
    "GQYBCZCZH": "Esta cuenta no existe para esta empresa.",
    "NDDHZHYBQY": "Enterprise 1 ha deshabilitado su cuenta de pedido y no puede iniciar sesión. Por favor contacte al administrador",
    "NYBSQY1DHZ": "Ya no eres socio de Enterprise 1 y no puedes iniciar sesión. Por favor contacte al administrador",
    "NDDPYBTY_B": "Su tienda ha sido deshabilitada y no se puede iniciar sesión. Por favor contacte al administrador",
    "GZHWKTDSZB": "Esta cuenta no tiene la característica especial de iluminación. Por favor contacte al administrador",
    "WXSQYZYGQ": "La verificación de autorización de WeChat ha expirado",
    "WXSQSB": "La autorización de WeChat falló",
    "WXSQSB_CWX": "La autorización de WeChat falló con un mensaje de error",
    "DengLuGuoQi": "Inicio sesión caducado",
    "DLGQ_QCXDL": "Inicio de sesión caducado, vuelva a iniciar sesión",

    //data-constant

    "ShangJia": "Estantes",
    "YiXiaJia": "Retirado",
    "YiJinYong": "Discapacitados",
    "YiQiYong": "Habilitado",
    "YiTingYong": "Discapacitados",
    "KeHuZhuCe": "Registro clientes",
    "XinZengDaoRu": "Nueva importación",
    "DDDSH": "Revisión de pedido pendiente",
    "DCWSH": "Revisión financiera pendiente",
    "DaiChuKu": "Para ser enviado",
    "DCK_BF_": "Fuera de stock (parcial)",
    "DFH_BF_": "Para ser enviado (parcial)",
    "DSH_BF_": "Para ser recibido (parcial)",
    "DSK_BF_": "Por recibir (parciales)",
    "WTHSQ": "Sin solicitud de devolución",
    "THDSH": "Devoluciones pendientes de revisión",
    "THCLZ": "Procesamiento de devolución",
    "THYWC": "Devolución completada",
    "DYDHD": "Imprimir formulario de pedido",
    "DYFHD": "Imprimir factura",
    "DCDHD": "Orden de exportación",
    "DCFHDWE_P": "Exportar factura a archivo Excel / PDF",
    "TuiDanZuoFei": "Reembolso nulo",
    "DTHSH": "Revisión de devoluciones pendientes",
    "DaiRuKu": "Para ser almacenado",
    "DRK_BF_": "Para ser almacenado (parcial)",
    "DFK_BF_": "Pago pendiente (parcial)",
    "ChuangJianTuiDan": "Crea un reembolso",
    "BianJiTuiDan": "Editar reembolso",
    "TiJiaoTuiDan": "Enviar un reembolso",
    "TuiHuoShenHe": "Auditoría de devolución",
    "RuKu": "Almacén",
    "RuKuShenHe": "Auditoría entrante",
    "RuKuZuoFei": "Invalidación",
    "TianJiaFuKuan": "Agregar pago",
    "FuKuanZuoFei": "Pago nulo",
    "FuKuanShenHe": "Revisión de pago",
    "TuiDanWanCheng": "Reembolso completado",
    "QiTaChuKu": "Otros salientes",
    "XiaoShouChuKu": "Ventas agotadas",
    "PanKuiChuKu": "Fuera de stock",
    "DiaoBoChuKu": "Transferir fuera",
    "CaiGouTuiHuo": "Compra devuelve",
    "TuiHuoRuKu": "Devoluciones y almacenaje",
    "CaiGouRuKu": "Compra de almacenamiento",
    "QiTaRuKu": "Otro almacenamiento",
    "PanYingRuKu": "Excedente de stock",
    "DiaoBoRuKu": "Traslado al almacén.",
    "CJCGD": "Crear orden de compra",
    "BJCGD": "Editar orden de compra",
    "TJCGD": "Enviar orden de compra",
    "CGDZF": "Orden de compra nula",
    "CGDWC": "Orden de compra completada",
    "CGTHZF": "Devoluciones de compras obsoletas",
    "CGTHWC": "Devoluciones de compra completadas",
    "THDDY": "Impresión de formulario de devolución",
    "THDDC": "Exportar pedido de devolución",
    "CKDDY": "Impresión de pedidos salientes",
    "CKDDC": "Exportación de pedidos salientes",
    "GLDZH": "Cuenta de gestión",
    "DHDZH": "Cuenta de pedido",
    "ShenHeTongGuo": "Aprobado",
    "SHBTG": "Revisión fallida",
    "WuXuFaPiao": "No se requiere factura",
    "DaiKeXiaDan": "Orden en nombre de",
    "ZiZhuXiaDan": "Pedido del cliente",
    "PCShangCheng": "Centro comercial PC",
    "APPShangCheng": "APP mall",
    "TVShangCheng": "Centro comercial de televisión",
    "WeiXinShangCheng": "WeChat Mall",
    "ShouJiShangCheng": "Centro comercial móvil",
    "ADDXSMLTC": "Margen bruto a medida",
    "ADDXSSRTC": "Comisión sobre ingresos por ventas",
    "AKHSSYG": "Por empleado",
    "AnZhiDanRen": "Soltero",
    "ATHJEBLKCT": "Deduzca el monto de la comisión en función del monto devuelto",
    "DDYTHBJXTC": "No hay devoluciones para pedidos",
    "DaiDaKuan": "Pago pendiente",
    "WeiKaiShi": "No empezado",
    "JinXingZhong": "En progreso",
    "YiGuoQi": "Caducado",

    //Utils.js

    "YouHuo": "En stock",
    "WuHuo": "Fuera de stock",
    "Yi": "Mil millones",
    "QianWan": "Diez millones",
    "BaiWan": "Millones",
    "Wan": "mil diez",
    "Sheng1Tian": "Queda 1 día",
    "Sheng1XiaoShi": "Queda 1 hora",
    "1Miao": "1 segundo",
    "GangGang": "Justo ahora",
    "1FenZhongQian": "Hace 1 minuto",
    "1XiaoShiQian": "Hace 1 hora",
    "1TianQian": "Hace un dia",
    "1GeYueQian": "Hace 1 mes",
    "1NianQian": "Hace 1 año",
    "WeiZhiLeiXing": "Tipo desconocido",

    //WechatUtil

    "YYGBCDSP_K": "Hay un buen producto, mira",
    "ZanWeiSheZhi": "No establecido",

    //app

    "HQWXSQXX": "Obtenga información de autorización de WeChat",

    //flexible

    "JGJYYDMBQ": "La escala se establecerá de acuerdo con las metaetiquetas existentes",

    //index

    "NLJZZ": "Loading...",

    //cart-bill

    "ShangPinMingXi": "Detalles producto",
    "ShangPinLeiBie": "Categoría producto",
    "QXZFPNR": "Seleccione el contenido factura",
    "QXZFPLX": "Seleccione un tipo factura",
    "QTXFPTT": "Complete el encabezado factura",
    "FaPiaoTaiTou": "Razón social",
    "NSRSBH": "RUC / DNI",
    "FaPiaoNeiRong": "Contenido de la factura",
    "FaPiaoXinXi": "Factura",
    "KaiJuFaPiao": "Facturación",
    "FaPiaoLeiXing": "Tipo de factura",
    "Han": "Con",
    "WeiHan": "No incluido",
    "Shui": "Impuestos",
    "QSRFPTT": "Por favor ingrese razón social",
    "QSRNSRSBH": "Por favor ingrese RUC / DNI",

    //cart-list

    "YiManZu_Man": "Cumplir [lleno",
    "ZaiGou": "Recompra",
    "YMZ_DHJJZ": "Ha quedado satisfecho",
    "JianJiangZhi": "Pedazos abajo",
    "YMZ_YDHJD": "Ha cumplido [precio de pedido original alcanzado",
    "JianMeiJian": "Piezas por pieza",
    "SYTCSLW0_WFJRGWC": "El número de paquetes restantes es 0",
    "QingXuanXeShangPin": "Por favor seleccione un producto!",
    "GSPYXJ": "¡Este producto ya no está disponible!",
    "ZJ2TN": "En los últimos {day} días",
    "QDQCXJSP": "¿Está seguro de que desea borrar el producto?",
    "QingChuChengGong": "Borrado éxito",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Los Combo no se pueden agregar al carrito de compras, cancele los artículos del paquete y luego muévase al carrito de compras.",
    "SPSLBN": "La cantidad producto no puede",
    "TaoCanHan": "El Combo incluye",
    "TaoCan": "Combo",
    "QHDSL": "verifique la cantidad",
    "SPSLBNDY": "El cantidad de productos no puede ser inferior a",
    "XianDingLiang": "Cantidad máxima",
    "YiRuShouCang": "Favoritos",
    "QuanXuan": "Todos",
    "JianZeng": "Regalo",
    "JianLiXiang_Man": "Disfruta",
    "Yuan_": " Soles",
    "Zhe_": "Doblar",
    "KCBZ_WFJRGWC": "Inventario insuficiente para agregar al carrito",
    "XDJEDYDY": "El monto pedido es mayor o igual que",
    "WYXJHYSXDSP": "¡No se han eliminado ni caducado productos!",
    "DYQDL": "MOQ",
    "ZSPG1J": "{count} Productos {number} unidades",
    "WanCheng": "Completa",
    "BianJi": "Editar",
    "You": "Tener",
    "ZSPBFHYQ_W": "Los productos no cumplen con los requisitos y no están marcados, haga clic para ver",
    "SPSLBNGY": "El cantidad de productos no puede ser superior a",
    "JXDJ_CKXYGBFHYQSP": "Continúe haciendo clic para ver el siguiente producto no conforme",
    "XiaDan": "Enviar",
    "JianJiang": "Pieza caída",
    "QRYCSP": "¿Eliminar producto?",
    "QXZXDSP": "Por favor seleccione un pedido",
    "KCBZ_QCXXZ": "Stock insuficiente, ¡elija de nuevo!",
    "KuCun": "Stock",
    "YCKXD": "Soles puede hacer un pedido",
    "QDSCSP": "¿Estás seguro de que quieres recoger mercancías?",
    "ShouCangChengGong": "Éxito de la colección",
    "GYXDL": "Por encima del límite",
    "LiSheng": "salvar",
    "GWCHSKD_QGYGB": "El carrito de compras aún está vacío.",
    "QuGuangGuang": "Ir de compras",
    "QCXJSP": "Productos claros",
    "ZongE": "Total monto",
    "YouHui": "Descuento",
    "YMZ_MYZJ_": "Ha satisfecho [piezas completas de {m} regalo de S/ {n}]",
    "YMZ_MZ": "Ha satisfecho [piezas completas de {m} regalo de S/ {n}]",
    "ZG222YX_M1000": "Vuelva a comprar {currencySymbol} {money} para disfrutar [obtenga {number} por cada {currencySymbol} {target} ]",
    "ZG2JX_MZ": "Vuelva a comprar  {num} para disfrutar [obtenga {present} por cada  {target} ]",
    "YMZ_MYJY_": "Ha satisfecho [completo S/ {m} menos S/ {n}]",
    "ZGYX_MYJY_": "Recompra S/ {m} para disfrutar [completo S/ {n} menos S/ {o}]",
    "YMZ_MYZ_": "Ha satisfecho el [descuento total de S/ {m} {n}]",
    "ZGYX_MYZ_": "Vuelva a comprar S/ {m} para disfrutar de [descuento total de S/ {n} {o}]",

    //
    "QXZJHRQ": "Seleccione una fecha entrega",
    "FuJiaFeiYong": "Recargo",
    "ZhongShangPin_Gong": "Productos",
    "PeiSongShiJian": "Tiempo envío",
    "QXZPSSJ": "Seleccione un tiempo entrega",
    "DingDanJinE": "Monto Pedido",
    "SCFJ_ZD4Z": "Cargue archivos adjuntos, hasta 4 fotos, no más de 3M",
    "KeYongShangPin": "Productos disponibles",
    "ShiYongShuoMing": "Instrucción",
    "YouXiaoQi": "valido",
    "Man": "Lleno",
    "BZZBZCTSFH": "Las observaciones no admiten símbolos especiales.",
    "QingXuanZe": "Por favor seleccione",
    "KaiPiaoXuJia": "Factura necesita agregar",
    "GeDian": "Puntos",
    "KPXJ1GD": '{num} additional points are required for invoicing',
    "PeiSongFangShi": "Método envío",
    "ShangPinZongJia": "Precio total",
    "YouHuiQuan": "Cupón",
    "ZhangKeXan": "unidades disponible",
    "DDJEWMZ": "No se cumple el monto pedido",
    "WDYHQ": "Mi cupon",
    "KYYHQ": "Cupones disponibles",
    "YuanKeYong": "Soles disponible",
    "ChaKanDingDan": "Ver orden",
    "ShangPinHanShui": "Factura",
    "SPWHS": "Producto sin IGV",

    "QueRenDingDan": "Confirmar pedido",
    "XZSHDZ": "Agregar dirección envío",
    "ShangPinQingDan": "Lista productos",
    "WKYYHQ": "No hay cupones",
    "HuChi": "Excluyentes",
    "DaiJinQuan": "Vales",
    "YunFei": "Flete",
    "ShuiFei": "Impuestos",
    "BKYYY": "Motivo no disponible",
    "YHQYGQ": "El cupón expirado",
    "WDYHQSYSJ": "Cupón caducado",
    "ZDSPJEWMZ": "La monto producto especificada no se cumple",
    "BKYYHQ": "Cupón no disponible",

    //cart-presale-order

    "QXZPSFS": "Seleccione un método envío",
    "1ZSP_G": "1 producto, total",
    "YSSP_YJ": "producto de preventa, esperados",
    "JiaoHuoRiQi": "Fecha de entrega",
    "GMJLY": "Mensaje al vendedor",

    //scan-to-cart

    "ZhengZaiChuLi...": "Procesando ...",
    "FSCSP": "Producto no mall",
    "ZZCLTXM": "Procesando código de barras ...",
    "SPTJCG": "Producto agregado exitosamente",
    "QSTXM": "Escanee el código barras",
    "SFSCDQSP": "¿Eliminar elemento?",
    "BQ_ZBDXGSP": "Lo sentimos, no se encontraron productos relacionados",
    "XuanZeDanWei": "Seleccionar unidad",
    "JRGWC": "Añadir al carrito",
    "QXXZDJRSP": "Seleccione primero los productos que se agregarán",
    "ZhengZaiChuLi": "Procesamiento",
    "JRGWCCG": "Añadir al carrito éxito",
    "ZanWuShangPin": "Sin productos",

    //earn-brokerage-share

    "XTYJBNFZSP": "¡El sistema te ha ayudado a copiar el enlace del producto!",
    "NKYHDDYDYJ": "Puede obtener la comisión correspondiente. Las comisiones están disponibles en \"Mi\"",
    "LiChaKan": "Ver adentro",
    "WeiXinHaoYou": "WeChat amigos",
    "ErWeiMa": "Código QR",
    "CASBEWM": "Mantenga presionado para identificar el código QR",
    "FZSB_QCXFZ": "Copia fallida, por favor copie de nuevo!",
    "TWEWM": "Código QR",
    "BCDXC": "Guardar en álbum",
    "CATPBCDXC": "Mantenga presionada la imagen para guardarla en el álbum",
    "FuZhiLianJie": "Copiar enlace",
    "FXZYJ": "Compartir comisión de ganancia",
    "YJZGKZQYJ": "Comisiones máximas esperadas",
    "PYTGNFXDYMCGGMH": "Después de una compra exitosa de UN amigo a través de la página que usted comparte, usted puede recibir la comisión correspondiente.La comisión puede consultarse en \"mi -{path}\"",

    //goods-share

    "FXSPGLSKH": "Comparta productos",
    "FXHJSCNZSD": "Después de compartir, se generará su micro-centro comercial móvil exclusivo. Puede establecer el precio de los productos en el centro comercial, completar su información de contacto y atraer consumidores los consumidores vienen a comprar.",
    "WSCDQJG_ND": "Precio actual de Micro Mall: el precio de su pedido ×",
    "DaiSheZhi": "Para ser establecido",
    "PengYouQuan": "Círculo de amigos",
    "GGFXSZ": "Cambiar la configuración para compartir",

    //wechat-login

    "QXSRZH": "Ingrese su número cuenta",
    "MMGSCW_6_20W": "Formato de contraseña incorrecta (6-20 caracteres o números)",
    "BDYYZH": "Vincula una cuenta existente",
    "WXKJDL": "Inicio sesión rápido de WeChat",
    "BangDingZhangHao": "Vincular cuenta",
    "YYZH_QDL": "Ya tiene cuenta",
    "ZCXZH": "Regístrese una nueva cuenta",
    "HuanYingNi": "Bienvenido",
    "ZH_SJHM": "Cuenta / Número de móvil",
    "MiMa": "Contraseña",
    "QDLHCZ": "Inicie sesión",

    //add-to-cart

    "KCBZ_BNTJG": "Inventario insuficiente para agregar más",

    //combined-pay-online

    "ZhiFuChengGong": "¡Pago exitoso!",
    "ZFSB_QCXCS": "¡Pago fallido, por favor intente nuevamente!",

    //

    "QXXZGG": "Seleccione la especificación",
    "SXGGX": "Las especificaciones seleccionadas necesitan",
    "GMSLXYQDL_": "La cantidad de compra es menor que el MOQ, ¡compre de nuevo!",
    "GMSLDYXDL_": "La cantidad de compra es mayor que la cantidad de orden límite, ¡compre de nuevo!",
    "ShangPinBianHao": "Producto ID:",
    "QiDing": "MOQ",
    "SXGGDGSLBK": "La cantidad pedida de las especificaciones seleccionadas no puede exceder",
    "KCBZ_BNTJ": "Inventario insuficiente para agregar",
    "QXXZSP": "Seleccione un producto",
    "SLBNW0": "La cantidad no puede ser 0",
    "QXZGG": "Seleccione especs",
    "LiJiYuDing": "Reserve ahora",

    //nav

    "ShouYe": "Inicio",
    "ShangPin": "productos",
    "DingDan": "Pedido",
    "WoDe": "La mia",

    //pay-online

    "ZhiFuQuXiao": "Cancelación de pago!",

    //account-log

    "ShangPinYongJin": "Comisión de productos",
    "YaoQingJiangLi": "Invitación recompensa",
    "TiXian": "Retirarse",
    "TiXianBoHui": "Retiro de retiro",
    "ZhuanWeiYuE": "Girar para equilibrar",
    "Jin7Tian": "Hace 7 días",
    "Jin30Tian": "Hace 30 días",
    "ShouZhiMingXi": "Detalles ingresos y gastos",
    "ZanWuShuJu": "Sin datos",

    //client-statistics

    "WoDeKeHu": "Mi cliente",
    "WoDeYaoQing": "Mi invitación",

    //distribution-home

    "LeiJiKeHu": "Clientes acumulados",
    "LeiJiDingDan": "Orden acumulativa",
    "YaoQingHaoYou": "Invitar amigos",
    "LeiJiYaoQing": "Invitación acumulativa",
    "LJSY_Y_": "Ingresos acumulados (Soles)",
    "BHDJS": "Liquidación pendiente",
    "J7TSY_Y_": "Ganancias en los últimos 7 días (Soles)",
    "J7TXZKH_R_": "Nuevos clientes en 7 días.",
    "KTXYJ": "Comisión extraíble",
    "XYJYO": "Necesito animar",
    "ChangJianWenTi": "Problema común",
    "Q_ZMYJX_TG": "Q: Cómo \"Promocionar y ganar dinero\"",
    "A_FXDPND_Z_": "A: Comparta el enlace de la página con el ícono de \"ganancia\" en la tienda, atraiga a amigos para que hagan clic y regístrese como amigo (la relación con el cliente está configurada para registrarse enlace) o realizar un pedido (la relación con el cliente está configurada para realizar un enlace de pedido) un cierto método de cálculo cuenta como su ingreso de \"promoción de dinero\".",
    "Q_RHJS_TGZ": "Q: ¿Cómo calcular el beneficio \"Promocionar dinero\"?",
    "A_MGD_Z_TBD": "A: Cada producto con el ícono de \"ganancia\" tiene un cierto porcentaje de comisión. Sin esta marca, significa que el producto no participa en la \"promoción y ganancia\" dinero \". Después de que un amigo paga con éxito a través de su enlace para compartir, la comisión se calculará por separado en función del porcentaje de comisión de cada artículo en el pedido (no la participación en la promoción se convierte en 0), y finalmente se acumula en los ingresos por comisiones del pedido. El envío, los reembolsos y las deducciones completas se deducirán en el cálculo de los ingresos para otras cantidades, prevalecerá el precio final de la transacción.",
    "Q_TGZQ_DSY": "Q: ¿Cuándo se acreditarán las ganancias de \"Promocionar dinero\"?",
    "A_HYTGNDFX": "A: Después de que un amigo paga con éxito a través de su enlace para compartir, puede ver la promoción en el pedido de ventas en el centro de ventas. El estado está pendiente calcular, después de que el cliente confirme que se ha liquidado el recibo de la transacción del pedido, este producto se transferirá automáticamente a su cuenta personal y podrá retirarse en cualquier momento.",
    "Q_LJKH_LJY": "Q: ¿No hay un apodo de avatar en la lista acumulada de clientes e invitaciones acumuladas?",
    "A_WXYQZYGZ": "A: WeChat requiere que el apodo del avatar solo se pueda obtener prestando atención al número del servicio de autenticación. Los clientes que son el número del servicio de autenticación deben prestar atención al número público de la tienda los números de servicio no certificados siguen al número público de \"pedido en la nube\" y hacen clic en cualquier página de detalles del producto en la tienda para obtener el apodo del avatar.",
    "Q_WSMWASSG": "Q: ¿Por qué no comparto los ingresos de la promoción cuando comparto de acuerdo con las reglas anteriores?",
    "A_1_HYKNBW": "A: 1. Es posible que su amigo no haya establecido una relación de cliente con usted (el amigo hizo clic en el enlace de otro vendedor para registrarse o hacer un pedido) 2. Si un amigo abre su enlace para compartir fuera del entorno WeChat (como el navegador predeterminado del teléfono móvil), si el navegador no habilita las cookies,Las relaciones con los clientes no se registrarán, es decir, los pedidos de promoción no se registrarán 3. El pedido de promoción aún no se registra cuando no hay ningún problema arriba, por favor contacte al personal",

    //

    "XiaoShouZhongXin": "Centro de ventas",

    //generalize-goods

    "SPMC_GG_BH": "Producto / especificación / SKU",
    "YuJiZhuan": "Tu ganancia",

    //invitation-home

    "YaoQingKa": "Invitación",
    "YNYQJR_TGY": "Encontraras buenos productos a excelente precio",
    "DJBCDXC": "Haga clic para guardar en el álbum",
    "JYQKFSGHY_": "Invita a tus amigos para tener más ganancias",

    //join-home

    "HuanYingJiaRu": "Bienvenido a ",
    "YQNCW": "Te invito a ser",
    "LiJiJiaRu": "Únete ahora",

    //order-statistics

    "YuJiYongJin": "Comisión estimada",
    "YongJin": "Comisión",
    "YuJiJiangLi": "Recompensa esperada",
    "JiangLi": "Recompensa",
    "SPTGDD": "Pedido promoción",
    "YQJLDD": "Pedido recompensa de invitación",

    //performance-statistics

    "YeJiTongJi": "Estadísticas resultado",
    "LJKH_R_": "Cliente acumulativo",
    "SPYJ_Y_": "Comisión (Soles)",
    "HanDaiJieSuan": "Liquidación pendiente",
    "XGMCJS": "Términos explicados",
    "KeHu": "Cliente",
    "HFXYBDLKHG": "Un comprador o distribuidor que tiene una relación de cliente con un distribuidor.",
    "YaoQing": "Invitar",
    "FXYCGYQDXJ": "Distribuidores subordinados invitados con éxito por los distribuidores",
    "FXYTJKHGMH": "La comisión que el distribuidor puede obtener después de que el distribuidor recomienda al cliente comprar",
    "XJFXYTGSPH": "Recompensa recibida por los superiores después de la promoción",

    //posters-promoting

    "NiCheng": "Apodo",
    "HaiBaoTuiGuang": "Promoción de carteles",
    "JHBFSGHY_T": "Enviar carteles a amigos, tiendas gratificantes",

    //settlement-home

    "JieSuanZhongXin": "Centro de liquidación",
    "KTXJE": "Monto disponible",
    "TiXianJiLu": "Registros de retiro",

    //withdraw-account

    "KHRXMBNWK": "¡El nombre del titular de la cuenta no puede estar vacío!",
    "KHHBNWK": "¡El banco de la cuenta no puede estar vacío!",
    "YHKHBNWK": "¡El número de la tarjeta bancaria no puede estar vacío!",
    "SFZTPBNWK": "¡La imagen de identificación no puede estar vacía!",
    "YHKTPBNWK": "¡La imagen de la tarjeta bancaria no puede estar vacía!",
    "BaoCunChengGong": "¡Guardado éxito!",
    "SCSFZ": "Subir ID",
    "SCYHK": "Subir tarjeta bancaria",
    "BaoCun": "Guardar",
    "TiXianZhangHu": "Cuenta de retiro",
    "TS_QTXZSXX": "Recordatorio: complete la información real, puede retirar efectivo solo después de pasar la revisión",
    "KHRXM": "Titular de cuenta",
    "KaiHuHang": "Banco",
    "YinhangKaHao": "Número de bancaria",
    "QSRZSXM": "Ingrese su nombre real",
    "QSRKHHMC": "Ingrese el nombre banco",
    "QSRYHKH": "Ingrese su número de bancaria",

    //withdraw-deposit

    "QXSZTXZH": "Configure cuenta retiro",
    "QuSheZhi": "Ir a la configuración",
    "JEXY10Y_BKT": "La cantidad es inferior a 10 yuanes, no hay retiro de efectivo!",
    "JECGKTXJE": "¡La cantidad excede la cantidad de efectivo disponible!",
    "CGDRKTXSX_": "Superar el límite de retiro el mismo día, ¡el límite de retiro para un solo día es de 20,000 yuanes!",
    "QueDingJiang": "Ok lo haré",
    "ZhuanDaoYuE": "Ir al equilibrio?",

    "_JEDY10YSB": "1. No se permite el retiro de efectivo cuando la cantidad es inferior a 10 yuanes;",
    "_BCTXDZSJ": "2. El tiempo de retiro para este retiro es dentro de los 5 días hábiles posteriores a la iniciación de la solicitud de retiro exitosa.",
    "_GBSRWHSS": "3. Los ingresos son ingresos con impuestos incluidos, ¡diríjase a la agencia tributaria correspondiente para declarar y pagar el impuesto sobre la renta personal por su cuenta!",
    "_ZDYEKYYS": "4. El saldo de transferencia se puede utilizar para comprar en el centro comercial;",

    "TXSQCG_QDD": "Solicitud de retiro exitosa, por favor espere revisión",
    "JEDYKTXJE_": "¡La cantidad es mayor que la cantidad de efectivo disponible y no puede transferirse al saldo!",
    "ZZYECG_QDG": "El saldo de la transferencia es exitoso, por favor verifique en el centro personal",
    "BenCiTiXian": "Esta retirada",
    "ZhuangDaoYuE": "Ir al equilibrio",
    "TiXianDao": "Retirarse a",
    "JEW0BKZZYE": "¡El importe es 0 y no se puede transferir al saldo!",
    "DRTXSX2WY": "Límite de retiro de un día de 20,000 Soles",
    "QuanBuTiXian": "Retirar todo",
    "QueRenTiXian": "Confirmar retiro",

    //goods-filter-tab

    "ZuiChangGouMai": "Defecto",
    "MoRenPaiXu": "Defecto",
    "ZongHe": "Defecto",
    "FenLei": "Categoría",
    "XiaoLiangYouXian": "Ventas",
    "XiaoLiang": "Ventas",
    "JiaGe": "Precio",
    "ShaiXuan": "Flitros",
    "ZuiJinGouMai": "Precio",
    "CuXiaoYouXian": "Promoción",
    "QuanBuFenLei": "Todos",
    "ZhiKanCuXiao": "Solo promociones",
    "XuanZeFenLei": "Seleccione categoría",
    "QXZFL": "Seleccione una categoría",

    //goods-list-default

    "ZWXGSP": "No hay productos relacionados.",

    //goods-brand-list

    "PinPaiHui": "Intercambio de marca",

    //goods-classify-filter

    "TuiJianFenLei": "Clasificación recomendada",
    "ShangPinFenLei": "Categorias",
    "GengDuo": "Más",

    //goods-detail

    "DLZHBSDQQY": "La cuenta de inicio sesión no es la cuenta del cliente corporativo actual",
    "GXNHQ": "Felicidades",
    "SZWSCJGH_C": "Compartir después de establecer el precio del micro centro comercial",
    "JHDJSHS_": "Tiempo final:",
    "DLHKFX": "Compartir después de iniciar sesión",
    "ZZHQXX_QSH": "Obteniendo información, intente nuevamente más tarde",
    "Zhang": "unidades",
    "Tian": "Día",
    "QXZGGZQPD": "Por favor, seleccione las especificaciones y vaya a la lámpara!",
    "Yuan": "Soles",
    "XS_F_M": "Horas / minutos / segundos",

    //integral

    "WoDeJiFen": "Mis puntos",
    "DaBaiLe": "Derrotado",
    "JiFen": "Puntos",
    "DeHuiYuan": "Miembros de",
    "ZhuanJiFen": "Gana puntos",
    "JiFenMingXi": "Detalles puntos",
    "HuanLiPin": "Canjear regalos",
    "CKGDHL": "Ver más regalos",
    "ChaDingDan": "Ver pedido",

    //integral-convert

    "DHSLBNCG": "La cantidad de canje no puede exceder",
    "DuiHuanShuLiang": "Cantidad de canje",
    "SuoXuJiFen": "Puntos requeridos",

    //integral-detail

    "LiPinXiangQing": "Detalles regalo",
    "WoYaoDuiHuan": "Quiero canjear",
    "ShengYu": "Restante",
    "TuWenXiangQing": "Detalles del product",
    "Jian": "Piezas",
    "YiDuiWan": "Terminado",

    //integral-filter

    "FenLeiShaiXuan": "Clasificación",
    "JiFenShaiXuan": "Puntos",

    //integral-flow

    "JiFenShouRu": "Puntos de ingreso",
    "JiFenZhiChu": "Gasto de puntos",

    //integral-logistics

    "DingDanGenZong": "Seguimiento pedidos",
    "WuLiuGongSi": "Empresa logística",
    "WuLiuDanHao": "Número logística",

    //integral-order

    "DingDanLieBiao": "Lista de pedidos",
    "YiFaHuo": "Enviado",
    "JiFenDingDan": "Orden de puntos",
    "ChaKanWuLiu": "Ver logística",

    //integral-order-create

    "LPSLBZ_QCX": "No hay suficientes regalos",
    "JiFenBuZu": "Puntos insuficientes",
    "ZhiFuXinXi": "Información pago",
    "JiXuGuangGuang": "Sigue paseando",
    "QTXSHXX": "Por favor complete la información del recibo",
    "DuiHuanChengGong": "Canjeado exito",
    "LPDHQR": "Confirmación de regalos",
    "SCCKJ": "Precio referencia",
    "LiJiZhiFu": "Paga ahora",

    //integral-order-detail

    "DingDanXiangQing": "Detalles pedido",
    "DingDanZhuangTai": "Estado pedido",
    "DingDanBianHao": "Pedido",
    "DuiHuanShiJian": "Tiempo redención",
    "ShouHuoXinXi": "Recibiendo información",
    "HuaFeiJiFen": "Gastar puntos",

    //integral-rule

    "QDZJF": "Inicia sesión para puntos",
    "XDZJF": "Gane puntos haciendo un pedido",

    "1_MRQD_JL": "1. Registro diario, recompensa {num} punto",
    "2_LXQD3T_EW": "2. Inicie sesión durante 3 días consecutivos con recompensas adicionales {num} punto",
    "3_LXQD7T_EW": "3. Inicie sesión durante 7 días consecutivos con recompensas adicionales {num} punto",

    "DLZJF": "Inicia sesión para ganar puntos",

    "MRDLYSDHSC": "Inicie sesión en {name} mall todos los días y recompense {num} punto",
    "DDWCHKHDYD": "Una vez completado el pedido, puede obtener puntos con el importe del pedido * {num} veces",

    //integral-rule-detail

    "GuiZe": "Reglas",

    //integral-sign

    "QianDaoYouLi": "Inicia sesión con cortesía",
    "QianDaoGuiZe": "Reglas de check-in",

    "YLXQD": "Registrado consecutivamente",
    "YLXQD1T": "Registrado consecutivamente {num} día",
    "QDCG_NYJLX": "Inicio de sesión correcto, ha registrado durante {num} día consecutivo",
    "QDCG_BCHD1": "Inicie sesión correctamente, obtenga esta vez {num} punto",
    "BCQDHD4JF_": "Regístrese para obtener 4 puntos esta vez, ¡genial!",

    //

    "QSRBZ": "Ingrese un comentario",
    "DingDanZengPin": "Pedido regalo",
    "GuiGeBianHao": "SKU: ",
    "GuiGe": "Especs",

    //combined-pay

    "CDDWXFK": "No hay pago por este pedido.",
    "YHYEBZ": "Saldo de usuario insuficiente!",
    "ZFJEBNW0": "¡El monto del pago no puede ser 0!",
    "ZFJEBNDYDD": "El monto del pago no puede ser mayor que el monto del pedido",
    "DFKJE": "Monto a pagar",
    "FuKuanFangShi": "Método pago",
    "FuJian": "Adjunto",
    "ZHYFZ": "Cuenta copiada",
    "GHSKZH": "Cambiar cuenta pago",
    "SYXXZFQSCF": "Para el pago fuera de línea, cargue un archivo adjunto de captura de pantalla de pago para la confirmación financiera.",
    "XXZF_BXXZS": "Pago sin conexión, debe elegir una cuenta de pago",
    "DingDanZhiFu": "Pedido de pago",
    "ZFFS_HDFK": "Método de pago: contra reembolso",
    "BCFKJE": "Este pago",
    "YuE": "Saldo",
    "FuZhiZhangHao": " Copiar",
    "WSZXCXZFPZ": "La configuración de pago del applet no está configurada",
    "XCXZFZHJY": "Cuenta de pago del applet deshabilitada",
    "SRZFJE": "Ingrese el monto pago",
    "FuKuanZhangHu": "Cuenta pago",
    "QueRenZhiFu": "Confirmar pago",
    "ShaoHouZhiFu": "Pagar más tarde",

    //order

    "FKJLYTJ_DD": "Registro de pago agregado, revisión financiera pendiente",
    "JiXuGuang": "Seguir comprando",
    "BenCiFuKuan": "Este pago",
    "FuKuanChengGong": "Pago exitoso",
    "ZhiFuFangShi": "Método pago",
    "ZhiFuDingDan": "Pedido pago",

    //order-batch-pay

    "QXXZSXZFDD": "Por favor seleccione el pedido a pagar",
    "PiLiangFuKuan": "Pago a granel",
    "FuKuan": "Pago",
    "QuFuKuan": "Pagar",

    //order-create-result

    "YingFuJinE": "Monto Pedido",
    "XiaDanShiJian": "Tiempo pedido",

    //order-deliver

    "SFQRSH": "¿Confirmas recibo?",
    "DDQRSH": "Recibo de confirmación",
    "DFHSP": "Producto ser enviados",
    "ShangPinShuLiang": "Cantidad productos",
    "ChuKuShiJian": "Tiempo entrega",
    "FaHuoShiJian": "Tiempo entrega",
    "WuLiuBeiZhu": "Notas logísticas",
    "QueRenShouHuo": "Confirmar recibo",

    //

    "RYFK_QJSYG": "Si se paga, comuníquese administrador",
    "QSRQXYY": "Motivo de cancelación",
    "H_DDJZDGB_QJKF": "Después de que el pedido se cierre automáticamente, pague lo antes posible",
    "TuiHuoQingKuang": "Devoluciones",
    "DingDanZongE": "Pedido total",
    "DingDanBeiZhu": "Notas pedido",
    "FaHuoQingKuang": "Situación de entrega",
    "DingDanFuJian": "Adjuntar pedido",
    "ShenQingTuiHuo": "Aplicar devolución",
    "G1TDSHJL_QRS": "Total {num} registro de recibo, ¿confirmar recibo?",
    "DaiXiaDan": "Pedido para cliente",
    "DingDanHao": "Número pedido",
    "XiaDanFangShi": "Método pedido",
    "TuiHuoDan": "Devolución",
    "ShangPinZongE": "Monto total",
    "YunFei_ZongZhong": "Flete (peso total",
    "SF_SPWS": "Taxes (bienes no gravados)",
    "TePiJia": "Precio especial",
    "FuKuanQingKuang": "Pago",
    "TiaoJiLu": "Registros",
    "ZaiLaiYiDan": "Uno mas",
    "QDSCGDD_": "¿Eliminar este pedido?",
    "YiQueRen": "Confirmado",
    "YiShouHuo": "Recibido",
    "DaiFuJinE": "Monto Por pagar",
    "YiFuJinE": "Monto pagado",
    "ZanWuJiLu": "Sin registro",

    //

    "SPMC_DDH": "Producto / número pedido",
    "FuKuanZhuangTai": "Estado pago",
    "FaHuoZhuangTai": "Estado entrega",
    "QiShiShiJian": "Hora de inicio",
    "ZhongZhiShiJian": "Hora final",

    //order-list

    "CaoZuoChengGong": "Operación exitosa",
    "ZBKGM": "No disponible para comprar",
    "DQDDSPYXJ": "El producto del pedido actual ha sido eliminado",
    "DQDDBFSPYXJ": "Se han eliminado algunos productos del pedido actual.",
    "JTJSJSP": "Agregar solo listados",
    "DingHuoDan": "Pedido compra",

    //order-list

    "DingDanRiZhi": "Registro pedidos",

    //order-logistics

    "FuZhiChengGong": "Copia exitosa",
    "FuZhiShiBai": "Copia fallida",
    "FuZhi": "Copia",
    "BoDa": "Marcar",
    "WCWLDHXX": "No hay información de logística",

    //order-pay

    "ZFCS_QCXXD": "Se agotó el tiempo de pago, reordenar",
    "YQYYCKZF": "Pagos previos al depósito habilitados",
    "BNDYDFKJE": "No puede ser mayor que la cantidad a pagar",
    "ZFJEBNWK": "El monto del pago no puede estar vacío",
    "QXAPFK_FKH": "Primero organice el pago y cargue la información de pago por captura de pantalla después del pago para la confirmación financiera",
    "DDTJCG_QJS": "Pedido enviado correctamente, pague a tiempo",
    "QXZFKFS": "Por favor seleccione un método de pago",
    "SYYEZFH_HX": "Después de pagar con el saldo, aún debe pagar",

    //

    "FuKuanJiLu": "Registro de pago",
    "ZWFKJL": "Sin registro pago",
    "FuKuanXiangQing": "Detalles pago",
    "FuKuanJinE": "Monto pago",
    "ZhiDan": "Fabricación",
    "ShenHe": "Revisar",
    "ZuoFei": "Nulo",
    "ZuoFeiYuanYin": "Razón nula",
    "GLDHD": "Orden relacionada",
    "HeXiaoJinE": "Monto amortizado",
    "HeXiaoZhuangTai": "Estado de baja",
    "DanJuZhuangTai": "Estado pedido",
    "KeHuMingCheng": "Nombre cliente",
    "ZhangDanHao": "Número pedido",
    "ShouKuanZhangHao": "Cuenta de cobro",
    "ShouKuanShiJian": "Tiempo de recogida",
    "FuKuanPingZheng": "Voucher de pago",
    "GeFuJian": "Archivos adjuntos",

    //order-statistics

    "DingDanTongJi": "Estadísticas pedidos",
    "DingHuo0Bi": "0 Pedidos",

    //order-statistics-detail

    "DDTJMX": "Detalles estadísticos",
    "AGGTJ": "Por Especs",
    "AFLTJ": "Por Categoría",
    "DDJE_Y": "Monto/soles",
    "DHSP_Z": "Productos",
    "DingHuoDan_Bi": "Pedidos",
    "DingHuoShangPin": "Producto",
    "JinE": "Monto",

    //refund-list
    "TuiHuo": "Devoluciones",
    //refund-apply

    "THDHWBC_QD": "El formulario de devolución no se ha guardado. ¿Estás seguro de que quieres irte?",
    "QSRSQTHJE": "Por favor ingrese la cantidad solicitada para la devolución",
    "QSRTHJE": "Por favor, introduzca el importe de devolución",
    "QSRBZXX": "Por favor ingrese la información del comentario",
    "YingTuiJinE": "Monto devolución",
    "TJTHSQ": "Enviar devolución",
    "QXXZDHQD": "Seleccione primero la lista de pedidos",
    "DingHuoQingDan": "Lista de pedidos",
    "SQTHJE": "Solicitar un monto de devolución",
    "DJXZSP": "Seleccione productos",
    "TuiHuoJinE": "Monto devolución",
    //refund-detail
    "THDDXQ": "Detalles del pedido de devolución",
    "YiTuiHuo": "Devuelto",
    "YiTuiKuan": "Reembolsado",
    "THDZT": "Estado del pedido de devolución",
    "TuiHuoDanHao": "Número de nota de devolución",
    "TuiHuoShiJian": "Hora de regreso",
    "TuiHuoCangKu": "Almacén de devolución",
    "THLXR": "Contacto de devolución",
    "TuiHuoQingDan": "Lista de retorno",
    "TuiKuanZongE": "Reembolso total",
    "TuiKuanQingKuang": "Situación de reembolso",
    "DaiTuiJinE": "Cantidad a reembolsar",
    "YiTuiJinE": "Cantidad reembolsada",
    //refund-product
    "SPMC_BH_GG": "Busca productos",
    "GZD1TJG": "1 resultado encontrado",
    "JiaRuQingDan": "Agregar",
    //refund-result
    "ShenQingChengGong": "Solicitud exitosa",
    "THDTJCG": "Pedido de devolución enviado correctamente",
    "ChaKanXiangQing": "Ver detalles",
    //goods-package-floor

    "HDWKS_WDZL": "El evento no ha comenzado, vuelve más tarde",
    "HDYJS_XCZD": "El evento ha terminado, ven temprano la próxima vez",
    "ZWSZBT": "Sin título establecido",
    "ChaKanGengDuo": "Ver más",

    //goods-promotion-floor

    "HCDZSJC": "Diferencia horaria causada por el almacenamiento en caché",
    "DLCKCXJ": "Inicie sesión para ver precios promocionales",
    "ZWSZCX": "No hay promociones configuradas",
    "JuKaiShi": "Desde el principio",
    "Song": "Regalar",
    "JuJieShu": "Fin de la distancia",
    "YiJieShu": "Terminó",

    //search-floor

    "XiaoXi": "Noticias",
    "SaoMaXiaDan": "Escanear Código",

    //home-page-custom

    "WZLCSJ": "Datos de piso desconocidos",

    //jump-error

    "QXZYSDHAPP": "Descargue la aplicación de pedidos en la nube",
    "QMTYQYGLD": "Experiencia completa de gestión empresarial.",
    "XZYSDHAPP": "Descargue la aplicación de pedidos en la nube",
    "HQGLDWZTY": "Obtenga la experiencia de gestión completa",
    "JXTYDHD": "Continuar experimentando el lado del pedido",

    //notice-detail

    "GongGaoXiangQing": "Detalles del anuncio",
    "GongGaoFuJian": "Adjunto de anuncio",

    //shop-error

    "NFWDYMBCZO": "La página que visitaste no existe ~",
    "KeNengYuanYin": "Causa probable",
    "1_ZDZLSRCWD": "1. Ingrese la dirección incorrecta en la barra de direcciones;",
    "2_DJLGQLJ": "2. Hizo clic en el enlace desactualizado.",

    //shop-index

    "GuanLiDuan": "Gestión",
    "ZhuCe": "Registrarse",
    "HYNTYYSDH": "Bienvenido a experimentar pedidos en la nube",
    "TYZHSJHDQG": "Los datos de la cuenta de experiencia se actualizan regularmente, no ingrese información importante",
    "TYZHZDNRSJ": "Los datos de contenido en la cuenta de experiencia son ficticios, no ingrese información importante",
    "ZHZCCG": "Registro de cuenta exitoso",
    "DengLuZhangHao": "Cuenta de inicio de sesión",
    "CSMMW": "La contraseña inicial es",
    "GNFYHQL": "Te da un cupón",
    "Man1YuanKeYong": "Más de {currencySymbol}{num}",
    "LQH1TNKY": "Válido solo por {day} días",
    "YiJianLingQu": "Recibir",
    "GXNHD1ZYHQ": "Felicidades por obtener {num} cupón",
    "Gong1Yuan": "Total {currencySymbol} {num}",
    "LiJiShiYong": "Usalo ya!",

    //shop-login

    "NHWDL": "No has iniciado sesión",

    //shop-notice

    "ShangChengGongGao": "Anuncio de centro comercial",
    "ZanWuGongGao": "Sin anuncio",
    "1GeFuJian": "{num} archivo adjunto",

    //deposit-detail

    "KouKuan": "Deducción",
    "ChongZhi_Kuan": "Recarga",
    "KouKuanZuoFei": "Deducción nulo",
    "ChongZhiZuoFei": "Recarga nula",
    "ZhangHuMingXi": "Detalles cuenta",
    "ZhangHuYuE": "Saldo cuenta",
    "LiJiChongZhi": "Recarga ahora",

    //deposit-recharge

    "CZJEBNXY1Y": "La monto de recarga no puede ser inferior a 1 soles",
    "QSRZQDSZ": "Ingrese el valor correcto",
    "ZDYJE": "Cantidad personalizada",
    "ZWKTXSCZGN": "La función de recarga en línea aún no se ha activado",
    "ShiFuJinE": "Cantidad pagada",
    "ZhangHuChongZhi": "Recarga cuenta",
    "QXZCZJE": "Seleccione la monto recarga",
    "QSRCZJE": "Ingrese el monto recarga",
    "QLXNDZSYWY": "Póngase en contacto con su vendedor dedicado para recargar",
    "ShouJia": "Precio",
    "YiShouQing": "Agotado",
    "ChongZhiJinE": "Cantidad recarga",
    "QueRenFuKuan": "Confirmar pago",

    //deposit-recharge-result

    "QSDDID": "ID pedido faltante",
    "ChongZhiChengGong": "Recarga exitosa",
    "ChongZhiShiBai": "Recarga fallida",
    "CLZ_QSH...": "Procesando, por favor espere ...",
    "ChongZhiFangShi": "Método recarga",
    "ChongZhiShiJian": "Tiempo recarga",
    "JYLSH": "Número de serie de transacción",
    "FanHuiShangCheng": "Vuelta al Mall",

    //recharge-online

    "ZFSB_QCS": "Pago fallido, por favor intente nuevamente",
    "ZFYQX": "Pago cancelado",
    "ZFYC_QCS": "Pago anormal, por favor intente nuevamente",

    //recharge-online

    "LingQuanZhongXin": "Centro de cupones",
    "WeiShiYong": "Disponible",
    "YiShiYong": "Usado",
    "ZWYHQ": "Sin cupones",

    //keep-list

    "YiGouMai": "Comprado",
    "ChangYongQingDan": "Lista Compra",
    "WoDeShouCang": "Favoritos",
    "QuGouWuChe": "Ir al carro",
    "GeShangPin": "Productos",

    //login

    "YunShangDingHuo": "Holaplaza.com",
    "QSRZH": "Ingrese su cuenta!",
    "QSRMM": "Ingrese su contraseña!",
    "QSRDLZH": "Ingrese una cuenta de inicio sesión",
    "JiZhuMiMa": "Recordar contraseña",
    "WangJiMiMa": "¿Olvidaste tu contraseña?",
    "DengLu": "Iniciar sesión",
    "DLZHBCZ_QL": "La cuenta de inicio de sesión no existe, póngase en contacto con el administrador para activar",
    "GQYZHSBJY_": "La versión de prueba de la cuenta empresarial está deshabilitada, póngase en contacto Holaplaza.com",
    "GQYZHSYQJS_": "El período de prueba de la cuenta empresarial ha terminado, comuníquese Holaplaza.com",
    "GQYZHYGQL_": "Esta cuenta empresarial ha caducado y requiere renovación para usarla, comuníquese con Holaplaza.com.",
    "LiJiTiYan": "Pruébalo ahora",

    //my-collect

    "YiChuChengGong": "Salir éxito",
    "QueHuo": "Sin stock",
    "YCSCJ": "Eliminar favoritos",

    //order-message

    "SheZhiChengGong": "Configurar éxito",
    "ZWWDXX": "No hay mensajes no leídos",
    "QuanBuYiDu": "Leer todo",
    "DingDanXiaoXi": "Mensaje",

    //

    "YiQiang": "Agarrado",
    "LiJiLingQu": "Reclama ahora",
    "LingQuanHou": "Después de recibir el cupón",
    "TianNeiKeYong": "Disponible en dias",

    //

    "QSRSJH": "Ingrese su número de móvil",
    "QSRYZM": "Ingrese el código verificación",
    "QSRXMM": "Ingrese una nueva contraseña",
    "QSRZQSJGS": "Ingrese el formato de móvil correcto",
    "ChongZhiMiMa": "Restablecer contraseña",
    "QSRNDSJHM": "Por favor ingrese su número de celular",
    "QSRDXYZ": "Por favor ingrese la verificación por SMS",
    "HQYZM": "Obtener Código",
    "HKCXHQ": "Se puede recuperar más tarde",
    "QSR6_20WSZHZ": "Ingrese una contraseña de 6-20 dígitos o letra",

    //share-setting

    "QSRSPJGBL": "Ingrese la relación precio del producto",
    "SPJGBLBXDY": "La relación del precio debe ser mayor o igual que 100 y menor que 999.99",
    "DPMCZBZCTS": "El nombre de la tienda no admite símbolos especiales",
    "LXRZBZCTSF": "Los contactos no admiten símbolos especiales",
    "LXFSZBZCTS": "El método de contacto no admite símbolos especiales",
    "LXDZZBZCTS": "La dirección de contacto no admite símbolos especiales",
    "DPJJZBZCTS": "El perfil de la tienda no admite símbolos especiales.",
    "QSRDPJJ_ZD": "Ingrese una descripción de la tienda, hasta 50 caracteres.",
    "FenXiangSheZhi": "Configuración de uso compartido",
    "NDWSCSPJG": "Su precio de producto WeChat",
    "NDDHJ_": "El precio de pedido ×",
    "LXXX_KBJ_": "Información de contacto (editable)",
    "DianPuMingCheng": "Nombre tienda",
    "JianJie": "Introduccion",
    "QSRDPMC": "Ingrese el nombre tienda",
    "LianXiRen": "Contacto",
    "QSRLXR": "Ingrese un contacto",
    "LianXiFangShi": "Móvil de contacto",
    "QSRLXFS": "Ingrese la información contacto",
    "LianXiDiZhi": "Direccion contacto",
    "QSRLXDZ": "Ingrese una dirección contacto",

    //user

    "WoDeDingDan": "Mi pedido",
    "ZuiJinLiuLan": "Vistos",
    "ShouCangShangPin": " Favoritos",
    "BDYYZH_ZC": "Vincula una cuenta existente | Registra una cuenta nueva",
    "DL_ZC": "Iniciar sesión | Registrarse",
    "BangDingShouJi": "Vincular con su cellular",
    "TS_BDSJHM_": "Consejo: vincule su número de teléfono móvil para que su cuenta sea más segura",
    "ChaKanQuanBu": "Ver todo",
    "ShouHuoDiZhi": "Dirección envío",
    "LianXiWoMen": "Contáctanos",
    "SheZhi": "Configurar",
    "QuQianDao": "Ir a registrarse",
    "QianDao": "Registrarse",
    "JiFenShangCheng": "Mall puntos",
    "TuiGuangShangPin": "Catálogo",
    "QuChaKan": "Ir a",
    "JiFenHuanLi": "Intercambio de puntos",
    "DYSPBQ": "Imprimir etiquetas de productos",

    //user-about

    "GYYSDH": "Holaplaza.com",
    "YQHYSMEWM_": "Invite a un amigo a escanear el código QR, descargue e instale directamente",
    "DangQianBanBen": "Versión actual",

    //user-address

    "ZWSHDZ": "Sin dirección envío",
    "WoDeDiZhi": "Mi direccion",
    "ZhiNengShiBie": "Reconocimiento inteligente",
    "ZTDZXXKZNS": "Pegar la información de la dirección puede identificar de manera inteligente el nombre, el teléfono y la dirección",
    "MoRen": "Defecto",

    //

    "QRSCDZ": "Confirmar eliminar dirección?",
    "SHRXM": "Nombre",
    "SJHMHGDDHZ": "Rellene al menos un número de teléfono móvil o fijo",
    "QSRSHRXM": "Ingrese el nombre del consignatario",
    "ShouJiHaoMa": "Móvil",
    "GuDingDianHua": "Teléfono fijo",
    "QSRGDDH": "Por favor, introduzca un teléfono fijo",
    "SuoZaiDiQu": "Zona",
    "QSRSZDQ": "Por favor ingrese su área",
    "QSRXXDZ": "Ingrese la dirección detallada!",
    "QSRZQDSJHM": "Ingrese el número de movil correcto",
    "QSRZQDGDDH": "Por favor, introduzca el teléfono fijo correcto",
    "XiangXiDiZhi": "Dirección",
    "MoRenDiZhi": "Dirección defecto",
    "SWMRDZ": "Predeterminado",
    "BCBSY": "Guardar y usar",

    //user-bing-one

    "QSRSJHM": "Ingrese su número móvil",
    "GYHYZC": "El usuario ya está registrado.",
    "GSJHMYJZCG": "El número de teléfono ya está registrado.",
    "QZJDLJK": "Inicia sesión directamente",
    "QuDengLu": "Ir al inicio sesión",
    "BDHKYTGSJH": "Después de la vinculación, puede iniciar sesión a través de su número de teléfono móvil, lo que le facilita recuperar su contraseña y mejorar la seguridad de la cuenta.",
    "_BDHKYTGSJ": "* Después del enlace, puede iniciar sesión a través de su número de teléfono móvil, para que pueda recuperar su contraseña y mejorar la seguridad de la cuenta.",
    "QSRSJYZM": "Ingrese el código verificación móvil",
    "BDXSJ": "Enlazar teléfono nuevo",
    "DXYZM": "Código verificación de SMS",
    "XiaYiBu": "Paso siguiente",
    "TGCBZ": "Omite este paso",

    //user-bing-two

    "DBDSJHMBCZ": "¡El número móvil no existe!",
    "QSRDLMM": "Por favor ingrese su contraseña de inicio sesión!",
    "_GSJHMYBDY": "* El número de teléfono móvil ya está vinculado a una cuenta de pedido en la nube. Verifique la contraseña de inicio de sesión del teléfono móvil y puede vincular la cuenta actual",
    "DQZHMMJTBW": "La contraseña de la cuenta actual se sincronizará con la contraseña de inicio de sesión del teléfono.",
    "DangQianZhangHao": "Cuenta corriente",

    //

    "QDYJZ": "Seguro de hacer esto",
    "JSPSCM": "Artículos eliminados?",
    "ShanChuChengGong": "Borrado éxito!",

    //user-info

    "SJGSCW": "Error de formato del móvil",
    "YXGSCW": "El correo electrónico está mal formado",
    "WoDeZhangHao": "Mi cuenta",
    "YouXiang": "Email",
    "ShouJi": "Móvil",
    "XingMing": "Nombre",
    "XiuGaiTouXiang": "Modificar avatar",
    "JiBenXinXi": "Información básica",
    "ZhangHaoAnQuan": "Seguridad de cuenta",
    "XiuGaiMiMa": "Cambiar contraseña",
    "DianJiBangDing": "Click Bind",
    "RYDSHTY_QL": "Si se pierde o se desactiva, reemplácelo de inmediato para evitar el robo de cuenta",
    "WBZNDZHAQ_": "Para proteger la seguridad de su cuenta, ate su teléfono",
    "QSRNDXM": "Ingrese su nombre",
    "QSRNDDH": "Ingrese su móvil",
    "QSRNDYX": "Ingrese su Email",

    //user-setting

    "QCHCHXCXDL": "Inicie sesión nuevamente después de borrar el caché",
    "QingChuHuanCun": "Borrar caché",
    "QDYQCHCM": "¿Seguro que quieres borrar el caché?",
    "TuiChuDengLu": "Cerrar sesión",
    "QieHuanZhangHao": "Cambiar cuenta",

    //user-supplier

    "LianXi": "Contacto ",
    "GongSiDianHua": "Teléfono",
    "DiZhi": "Dirección",

    //vouchers-detail

    "DJQMX": "Detalles Cupón",

    //vouchers-list

    "BuKeYong": "No disponible",
    "KeYong": "Disponible",
    "ZWDJQ": "Sin cupones",
    "ZongEDu": "Monto total",
    "FaFangShiJian": "Tiempo de liberación",
    "EDYYW": "La cuota se ha agotado",
    "QBSPKY": "Todos los productos disponibles",

    //vouchers-select-list

    "WDDJQ": "Mi Cupón",
    "KYDJQ": "Cupón disponibles",
    "DJQKDK": "Los cupones son deducibles",
    "CKKYSP": "Productos disponibles",
    "BKYDJQ": "Cupones no disponibles",
    "BKYYY_ZWFH": "Motivo no disponible: no hay productos elegibles",

    //goods-detail

    "DQSPWSCGGT": "¡El producto actual no ha cargado el mapa de especificaciones y no es compatible con la lámpara!",
    "BoFangShiPin": "Play",
    "Gong1GeGuiGe": "Total {num} Especs",
    "YiXuanGuiGe": "Especs",
    "XuanGuiGe": " Selección",
    "LingQuan": "Cupón",
    // "Jian":"Menos",
    "1ZhongCuXiao": "{num} promoción",
    "1ZhangKeYong": "{num} disponible",
    "ZuiGaoKeSheng": "Hasta para ahorrar",
    "ShangPinTaoCan": "Paquete de productos básicos",
    "Gong1GeTaoCan": "{num} paquete",
    "ShangPinCanShu": "Parámetros del producto",
    "ZhanKai": "Expandir",
    "YiShouCang": "Favorito",
    "ShouCang": "Favorito",
    "KeFu": "Servicio al cliente",
    "XiangQing": "Detalles",
    "TuiJian": "Recomendado",
    "BianHao": "Numero",
    "ShangPinXinXi": "Información del producto",
    "KLYHQ": "Obtener cupón",
    "KuCunBuZu": "Fuera de stock",
    "DuoGuiGe": "Especificaciones múltiples",
    "YiShou": "Vendido",
    "SWBHZ_YS": "Agotado al reponer existencias",
    "CuXiaoShangPin": "Artículos promocionales",

    //goods-search

    "NHWSRSSNR": "No has ingresado tu búsqueda",
    "SouSuo": "Buscar",
    "SSY1XGDSP": "Buscar {searchKey} productos relacionados",
    "Yue1GeShangPin": "Acerca de {num} producto",
    "ZuiJinSouSuo": "Buscado recientemente",
    "QingChu": "Claro",
    "ZWSSJL": "Sin historial de búsqueda",

    //goods-property

    "ZGJGBNDYZD": "El precio más alto no puede ser más bajo que el precio más bajo.",
    "ShangPinBiaoQian": "Etiqueta del producto",
    "BuGaoYu1": "No más de 1",
    "BuDiYu1": "No inferior a 1",
    "FengGe": "Estilo",

    //goods-promotion-list

    "JiJiangKaiShi": "A punto de comenzar",
    "QuanBuCuXiao": "Todas las promociones",

    //goods-package-list

    "Gong1JianShangPin": "{num} productos",
    "Sheng": "Provincia",

    //goods-package-detail

    "GTCZGWCZDS": "La cantidad de este paquete en el carrito de compras ha alcanzado el límite de compra y no se puede agregar al carrito de compras.",
    "GTCKCBZ_BK": "Este paquete está agotado y no se puede agregar al carrito",
    "JinSheng1Tao": "Solo queda {num} juego",
    "XianGou1Tao": "Limitado a {num} juego",
    "TaoCanXiangQing": "Detalles del paquete",
    "DanMaiJia": "Precio de compra individual",
    "TaoCanJia": "Precio del paquete",
    "HDYJS": "El evento ha terminado.",

    //goods-message

    "WDL_QXDL": "No ha iniciado sesión, inicie sesión primero",

    //goods-list-label

    "XinPinShangShi": "Nuevo listado",
    "WDLZH_ZWCX": "¡Sin cuenta de inicio de sesión, sin promociones!",
    "YiXiaShangPin": "Los siguientes productos",

    //goods-list

    "1ZhongGuiGe": "{num} especificación",
    "YouKuCun": "En stock",

    //goods-filter
    "BuGaoYu": "Hasta",
    "BuDiYu": "Desde",
    "CuXiao": "Promoción",
    "ZDYXXZ3G": "Permite la selección de hasta 3",
    "GouMai": "Comprar",
    "Gong1Jian": "Total {num}",
    //缺失
    "YiChuShouCangJia": "Eliminar",
    "$": "S/ ",
    "$1": "S/ {num}",
    "_8999_1Qi": "Desde S/ 8999.1",
    "Ge": "Und",
    "BaoZhuangFangShi": "Método embalaje",
    "QRSCSP_": "¿Eliminar producto?",
    "JEWM_TMFRK": "Escanear código QR o barras",
    "0ZSP_G0J": "0 productos, total 0",
    "JiuMiMa": "Contraseña anterior",
    "XMM_6_20WZ": "Nueva contraseña(6-20 dígitos o letras)",
    "QueRenMiMa": "Confirm contraseña",

    "BDHKSYSJHD": "Vincular con su celular, puede iniciar sesión con su móvil, lo que facilita la recuperación de su contraseña y mejora la seguridad.Vincular con su celular, puede iniciar sesión con su móvil, lo que facilita la recuperación de su contraseña y mejora la seguridad.",
    "YanZhengMa": "Código verificación",
    "1MHKCXHQ": "Después 1s",
    "CSJHZ1MQFS": "Este número de movil envió un código verificación hace 1s, intente nuevamente más tarde",
    "GouMaiJiLu": "Mis compras",
    "XinZengDiZhi": "Agregar",
    "LingShouJia": "Precio normal",
    "YouHuiJia": "Precio oferta",
    "ShangPinChuKu": "enviado",
    "DengDaiShouHuo": "recibido",
    "ShouHuoRen": "Consignatario",
    "PaiZhao": "Tomar foto",
    "XiangCe": "Album",

    "TiYanGuan": "Tienda experiencia",
    "JingYingShiJian": "Horas de funcionamiento",
    "ZhanGuanDianHua": "Teléfono de la exposición",
    "ZhanGuanDiZhi": "Dirección del lugar",
    "SJHQZ_QSDZ": "Adquisición de datos, espere e intente nuevamente.",
    "QXXZSF_": "Por favor, seleccione una provincia primero!",
    "QuanBuShengFen": "Todas las provincias",
    "QuanBuChengShi": "Todas las ciudades",
    "YingYeShiJian": "Horario comercial",
    "ChanPinBianHao": "Producto ID",
    "DLXXYGQ_QC": "Inicio sesión caducado, Por favor inicie sesión nuevamente",
    "Man999Jian100": "Compras mas S/{m}, ahorras S/{n}",

    "YiManZu": "Alcanzado",
    "QDYCSP_": "¿Eliminar producto?",
    "DGM10JZ1J": " Compra 10 Unds, llevas 1 gratis ",

    // route-fetch
    "XiaXianTongZhi": "Notificación",
    "NDZHYZQTSB": "Al parecer su usuario está siendo usado en otro dispositivo, si no eres tu por favor cambia tu contraseña",
    "ManJiang": '{num} por {target} pieza completa',
    "ZGLXMJ": 'Comprar {num} pieza más para compartir [{target} piezas se reducen a {currencySymbol}{money_}]',
    "ZGLXMZ": 'Compra de {num} pieza más y disfruta de UN descuento del {percent}0% en cada una de las {target} piezas. ',
    "QSRZQNR": 'Por favor, introduzca el contenido correcto',
    "NHYDDQKWJQ": 'Usted todavía tiene {num} pedidos pendientes por UN total de {currencySymbol}{money} antes de que usted pueda continuar con su pedido',

    //发票助手

    "FaPiaoZhuShou": "Asistente de facturas",
    "WoDeFaPiao": "Mi factura",
    "FaPiaoXiangQing": "Detalles de la factura",
    "KaiPiaoShiJian": "Tiempo de facturación",
    "DaiKaiFaPiao": "Por facturar",
    "DKFPJE": "Importe a facturar",
    "KaiPiaoJinE": "Monto facturación",
    "ZFYDWT_QCSCXZF": "Payment encountered problems, please try to pay again or change the payment method",
    "QingXuanZhe": "Please select a",

    "SXCZ_XDCG": "Credit enough, successful order",
    "SXEDBZ_FKHFH": "Insufficient credit line, delivery after payment",
    "CGJKZQ_FKFH": "After the borrowing period, payment delivery",
    "DDTJCG_XZZCZHYB": "The order was submitted successfully. Now we are only one step away",

    "MianFeiLing": "免费领",
    "M_KMFLQ_HQ": "满{target}元可免费领取，还差{short}元",
    "YHDMFSP": "已获得免费商品",
    "JRMFL": "今日免费领",
    "LingGuangLe": "领光了",
    "KeLingQu": "可领取",
    "YuGuJia": "预估价",

    "GXNHQ_Z_Y_": "Felicidades por obtener {num} {name} de descuento de {price}",
    "LXZSKF": "Customer service",

    "DPYDY_QSHX": "La tienda está cerrada, haga un pedido más tarde.",
    "DaYangShiJian": "Hora de cierre",

    "ChuanHaoChaXun": 'Consulta de números de serie',
    'IMEI': 'IMEI',

    "FanKuanZhangHu": "Cuenta de reembolso",
    "FanKuanYuE": "Saldo de reembolso",
    "FanKuanZhiFu": "Pago de reembolso",
    "JingDongYiYunJia": "京东易云+",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "Saldo de reembolso insuficiente",
    "HaiXuZhiFu": "Necesito pagar {price}"
};
exports.default = es_ES;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// zh_CN.js
var zh_CN = {
    "GuanShui": "关税",
    "ZiZhangHao": "子账号",

    "ZHONGWEN": "汉语",
    "YINGYU": "英语",
    "XIBANYAYU": "西班牙语",
    "DEYU": "德语",
    "FAYU": "法语",
    "ALABOYU": "阿拉伯语",
    "EYU": "俄语",
    "MALAIYU": "马来语",
    "YUENANYU": "越南语",
    "TAIYU": "泰语",
    "YINNIYU": "印尼语",
    //components
    "ShangeChuanYanZhengTuPian": "上传验证图片",
    "ChuanHaoYanZheng": "串号验证",
    "YanZhengChuanHao": "验证串号",
    "Ci": "次",
    "DingDanMan": "订单满",
    "YuanZeng": "元赠",
    "SCFJ_ZD4Z_DZBCG": "上传附件，最多4张，单张不超过3M",
    //ChatRoom
    "ZBZCBQFH": "暂不支持表情符号",
    "FaSongLianJie": "发送链接",
    "YiChangXiaoXi": "异常消息",
    "QingShuRu": "请输入",
    "FaSong": "发送",
    //DateSelector
    "DQSJXYKSSJ": "当前时间小于开始时间",
    "DQSJCGJSSJ": "当前时间超过结束时间",
    "QuXiao": "取消",
    "NianYueRi": "年月日",
    "ShiFen": "时分",
    "QueDing": "确定",
    "Nian": "年",
    "Yue": "月",
    "Ri": "日",
    "Shi": "时",
    "Fen": "分",
    //goods-list-card
    "Qi": "起",
    //goods-promotion
    "1GeCuXiao": "{num}个促销",
    "ChaKanZengPin": "查看赠品",
    "JHDJSHS_1T": "距活动结束还剩：{d}天{h}小时{m}分{s}秒",
    "YHGZ_ZPBKD": "优惠规则：赠品不可叠加获取",
    "YHGZ_AZZGM": "优惠规则：按最终购买数量享受优惠",
    "GuanBi": "关闭",
    "Man1Song1": '满{mai}送{song}',
    //group-filtrate
    "QuanBu": "全部",
    "ZWXGSJ": "暂无相关数据",
    "ZuiDiJia": "最低价",
    "ZuiGaoJia": "最高价",
    "LeiXing": "类型",
    "PinPai": "品牌",
    "BiaoQian": "标签",
    "JiaGeQuJian": "价格区间",
    "SPMC_GG_BH_": "商品名称 / 规格 / 编号 / 首字母",
    "SPMC_GG_BH_G": "商品名称 / 规格 / 编号",
    "ZuHeShaiXuan": "组合筛选",
    "ChongZhi_CanShu": "重置",
    //image-upload
    "ZDKSC1ZTP": "最多可上传1张图片",
    "ZYXSCTP": "只允许上传图片",
    "SCTPDXBYXC": "上传图片大小不允许超过5M",
    "QBYCFSCTP_": "请不要重复上传图片，或请确保图片名称唯一",
    "ShangChuanChengGong": "上传成功",
    "ZDKSC1Z": "最多可上传1张",
    //keyboard
    "CCSLZDXZ": "超出数量最大限制",
    "QiDingLiang": "起订量",
    "ShouQi": "收起",
    "ShanChu": "删除",
    //MultiPicker
    "FanHui": "返回",
    //order-cart
    "Dai": "代",
    "YiQuXiao": "已取消",
    "ZengPin": "赠品",
    "1Zhong": "{num}种",
    "1Jian": "{num}件",
    "HeJi": "合计",
    "DaiFu": "待付",
    //order-promotion
    "_DDM1YZ1J_": "【订单满{target}元赠{name}{number}件】",
    "_DDM1YLJ1Y_": "【订单满{m}元立减{n}元】",
    "_DDM1YLX1Z_": "【订单满{m}元立享{n}折】",
    "DingDanCuXiao": "订单促销",
    //page-ad
    "DLCKJG": "登录查看价格",
    //page-floating
    "DianPuZhuYe": "店铺主页",
    "GouWuChe": "购物车",
    "ZaiXianKeFu": "在线客服",
    "GeRenZhongXin": "个人中心",
    "LianXiDianHua": "联系电话",
    "FanHuiDingBu": "返回顶部",
    //page-null
    "ZBDYML": "找不到页面了",
    "KNWZCW_HZY": "可能网址错误，或者页面被删除",
    "FanHuiShangJi": "返回上级",
    "FanHuiShouYe": "返回首页",
    //product-edit
    "SPQDBNWK": "商品清单不能为空",
    "WoZhiDaoLe": "我知道了",
    "SFQRSCSP": "是否确认删除商品",
    "QueRen": "确认",
    "ZYXSRSZBQB": "只允许输入数字并且不超过2位小数",
    "ShangPinDanJia": "商品单价",
    "YSPYJ": "原商品原价",
    "QSRZDJG": "请输入指定价格",
    "ShuLiang": "数量",
    "DanWei": "单位",
    "DanJia": "单价",
    "BeiZhu": "备注",
    "YiChuShangPin": "移除商品",
    "XiuGai": "修改",
    //yunshl
    "TPSLCCYXSZ": "图片数量超出允许数值！",
    "WJBDDY5M_QC": "文件不得大于5m，请重新选择",
    "TPSCWC": "图片上传完成",
    //BusinessFilter
    "_DGSLM1Z1_": "【订购数量满{target}赠{provide}】",
    "_M1JLXMJ1Y_": "【满{target}立享每{cut_money_}】",
    "_DHJJZ1Y_": "【订货价降至{cuted_price_}元】",
    "_M1JLXMJ1Z_": "【满{target}立享每{cut_percent_}折】",
    "_YDHJD1Z_": "【原订货价打{cuted_percent_}折】",
    "YuJiKaiShiFaHuo": "预计{date}开始发货",

    "YuJi": "预计",
    "MMYDDR": "MM月DD日",
    "KaiShiFaHuo": "开始发货",

    "_M1LXM1Y_": "【满1立享每1元】",
    "_M1LXM1Z_": "【满1立享每1折】",

    "DaiQueRen": "待确认",
    "DaiFaHuo": "待发货",
    "DaiShouHuo": "待收货",
    "YiWanCheng": "已完成",
    "DaiFuKuan": "待付款",
    "YiFuKuan": "已付款",
    "YiZuoFei": "已作废",
    "DaiShenHe": "待审核",
    "DaiHeXiao": "待核销",
    "YiHeXiao": "已核销",
    "XianXiaZhiFu": "线下支付",
    "ZhiNengDaoZhangShiBie": "线下汇款(智能到账识别)",
    "WeiXinZhiFu": "微信支付",
    "KQ-WeiXinZhiFu": "线上支付（微信/支付宝/银行卡快捷支付）",
    "KQ-ZFBZF": "线上支付（微信/支付宝/银行卡快捷支付）",
    "KQZhiFu": "快钱支付",
    "HFZhiFu": "汇付支付",
    "HFZhiFu_WX": "微信支付",
    "HFZhiFu_ZFB": "支付宝支付",
    "PayPal": "PayPal",
    "Stripe": "Stripe",
    "ZFBZF": "支付宝支付",
    "YuEZhiFu": "余额支付",
    "HuoDaoFuKuan": "货到付款",
    "DaiTuiHuo": "待退货",
    "DaiTuiKuan": "待退款",
    "ChuangJianDingDan": "创建订单",
    "BianJiDingDan": "编辑订单",
    "TiJiaoDingDan": "提交订单",
    "DingDanShenHe": "订单审核",
    "CaiWuShenHe": "财务审核",
    "BoHui": "驳回",
    "TianJiaShouKuan": "添加收款",
    "ZaiXianZhiFu": "在线支付",
    "ShouKuanShenHe": "收款审核",
    "ShouKuanZuoFei": "收款作废",
    "ChuKu": "出库",
    "ChuKuShenHe": "出库审核",
    "FaHuo": "发货",
    "TianJiaWuLiu": "添加物流",
    "XiuGaiWuLiu": "修改物流",
    "ChuKuZuoFei": "出库作废",
    "ShouHuo": "收货",
    "DingDanHeZhun": "订单核准",
    "QuXiaoDingDan": "取消订单",
    "CJTHD": "创建退货单",
    "DaYin": "打印",
    "DaoChu": "导出",
    "DingDanWanCheng": "订单完成 ",
    "QiangZhiWanCheng": "强制完成",
    "DingDanZuoFei": "订单作废",
    "MaiZeng": "买赠",
    "ZhiJiang": "直降",
    "DaZhe": "打折",
    "YuShou": "预售",
    "DingDanManZeng": "订单满赠",
    "DingDanManJian": "订单满减",
    "DingDanManZhe": "订单满折",
    "XinRenQuan": "新人券",
    "ManJianQuan": "满减券",
    "ShangPinQuan": "商品券",
    "DaiJieSuan": "待结算",
    "YiJieSuan": "已结算",
    "QuanBuShangPin": "全部商品",
    "TuiJianShangPin": "推荐商品",
    "XinPin": "新品",
    "ReXiaoShangPin": "热销商品",
    "ChangYongShangPin": "常用商品",
    //BusinessUtil
    "DaiShouKuan": "待收款",
    "BuFenShouKuan": "部分收款",
    "YiShouKuan": "已收款",
    "BXYFP": "不需要发票",
    "ZZSPTFP": "增值税普通发票",
    "ZZSZYFP": "增值税专用发票",
    "QiTaFaPiao": "其他发票",
    "XianXia": "线下",
    "WeiXin": "微信",
    "ZhiFuBao": "支付宝",
    "YuCunKuan": "预存款",
    "XianXiaZhuangZhang": "线下转账",
    "XianShangZhiFu": "线上支付（支持微信/支付宝/京东支付/云闪付）",
    "YCKZF": "预存款支付",
    "DaiTiJiao": "待提交",
    "KuaiDi": "快递",
    "SongHuoShangMen": "商家配送",
    "ShangMenZiQu": "上门自提",
    "WuLiuHuoYun": "物流货运",
    "QiTa": "其他",

    //check-util

    "QSRBXY6WDM": "请输入不小于6位的密码",
    "QSRBDY20WDM": "请输入不大于20位的密码",
    "MMGSCW": "密码格式错误",

    //common-utils

    "SJCW_QLXKF": "数据错误，请联系客服",
    "ZBZCQD": "暂不支持签到",
    "HuJiao": "呼叫",
    "DLZHBCZ": "登录账号不存在",
    "QLXGLYKT": "请联系管理员开通",
    "GQYZHBJY": "该企业账号被禁用",
    "QLXYSDH": "请联系云上订货",
    "GQYZHSYQJS": "该企业账号试用期结束",
    "GQYZHYGQL": "该企业账号已过期了",
    "XYXFCNSY": "需要续费才能使用",
    "GQYBCZCZH": "该企业不存在此帐号",
    "NDDHZHYBQY": "您的订货账号已被企业1禁用，不可登录。请联系管理员",
    "NYBSQY1DHZ": "您已不是企业1的合作客户，不可登录。请联系管理员",
    "NDDPYBTY_B": "您的店铺已被停用，不可登录。请联系管理员",
    "GZHWKTDSZB": "该账号未开通灯饰专版功能。请联系管理员",
    "WXSQYZYGQ": "微信授权验证已过期",
    "WXSQSB": "微信授权失败",
    "WXSQSB_CWX": "微信授权失败,错误信息",
    "DengLuGuoQi": "登录过期",
    "DLGQ_QCXDL": "登录过期，请重新登录",

    //data-constant

    "ShangJia": "上架",
    "YiXiaJia": "已下架",
    "YiJinYong": "已禁用",
    "YiQiYong": "已启用",
    "YiTingYong": "已停用",
    "KeHuZhuCe": "客户注册",
    "XinZengDaoRu": "新增导入",
    "DDDSH": "待订单审核",
    "DCWSH": "待财务审核",
    "DaiChuKu": "待出库",
    "DCK_BF_": "待出库（部分）",
    "DFH_BF_": "待发货(部分)",
    "DSH_BF_": "待收货（部分）",
    "DSK_BF_": "待收款（部分）",
    "WTHSQ": "无退货申请",
    "THDSH": "退货待审核",
    "THCLZ": "退货处理中",
    "THYWC": "退货已完成",
    "DYDHD": "打印订货单",
    "DYFHD": "打印发货单",
    "DCDHD": "导出订货单",
    "DCFHDWE_P": "导出发货单为Excel/PDF文件",
    "TuiDanZuoFei": "退单作废",
    "DTHSH": "待退货审核",
    "DaiRuKu": "待入库",
    "DRK_BF_": "待入库（部分）",
    "DFK_BF_": "待付款（部分）",
    "ChuangJianTuiDan": "创建退单",
    "BianJiTuiDan": "编辑退单",
    "TiJiaoTuiDan": "提交退单",
    "TuiHuoShenHe": "退货审核",
    "RuKu": "入库",
    "RuKuShenHe": "入库审核",
    "RuKuZuoFei": "入库作废",
    "TianJiaFuKuan": "添加付款",
    "FuKuanZuoFei": "付款作废",
    "FuKuanShenHe": "付款审核",
    "TuiDanWanCheng": "退单完成",
    "QiTaChuKu": "其他出库",
    "XiaoShouChuKu": "销售出库",
    "PanKuiChuKu": "盘亏出库",
    "DiaoBoChuKu": "调拨出库",
    "CaiGouTuiHuo": "采购退货",
    "TuiHuoRuKu": "退货入库",
    "CaiGouRuKu": "采购入库",
    "QiTaRuKu": "其他入库",
    "PanYingRuKu": "盘盈入库",
    "DiaoBoRuKu": "调拨入库",
    "CJCGD": "创建采购单",
    "BJCGD": "编辑采购单",
    "TJCGD": "提交采购单",
    "CGDZF": "采购单作废",
    "CGDWC": "采购单完成",
    "CGTHZF": "采购退货作废",
    "CGTHWC": "采购退货完成",
    "THDDY": "退货单打印",
    "THDDC": "退货单导出",
    "CKDDY": "出库单打印",
    "CKDDC": "出库单导出",
    "GLDZH": "管理端账号",
    "DHDZH": "订货端账号",
    "ShenHeTongGuo": "审核通过",
    "SHBTG": "审核不通过",
    "WuXuFaPiao": "无需发票",
    "DaiKeXiaDan": "代客下单",
    "ZiZhuXiaDan": "自主下单",
    "PCShangCheng": "PC商城",
    "APPShangCheng": "APP商城",
    "TVShangCheng": "TV商城",
    "WeiXinShangCheng": "微信商城",
    "ShouJiShangCheng": "手机商城",
    "ADDXSMLTC": "按订单销售毛利提成",
    "ADDXSSRTC": "按订单销售收入提成",
    "AKHSSYG": "按客户所属员工",
    "AnZhiDanRen": "按制单人",
    "ATHJEBLKCT": "按退货金额比例扣除提成金额",
    "DDYTHBJXTC": "订单有退货不进行提成",
    "DaiDaKuan": "待打款",
    "WeiKaiShi": "未开始",
    "JinXingZhong": "进行中",
    "YiGuoQi": "已过期",

    //Utils.js

    "YouHuo": "有货",
    "WuHuo": "无货",
    "Yi": "亿",
    "QianWan": "千万",
    "BaiWan": "百万",
    "Wan": "万",
    "Sheng1Tian": "剩1天",
    "Sheng1XiaoShi": "剩1小时",
    "Miao": "秒",
    "1Miao": "1秒",
    "GangGang": "刚刚",
    "1FenZhongQian": "1分钟前",
    "1XiaoShiQian": "1小时前",
    "1TianQian": "1天前",
    "1GeYueQian": "1个月前",
    "1NianQian": "1年前",
    "WeiZhiLeiXing": "未知类型",

    //WechatUtil

    "YYGBCDSP_K": "有一个不错的商品，快来看一下",
    "ZanWeiSheZhi": "暂未设置",

    //app

    "HQWXSQXX": "获取微信授权信息",

    //flexible

    "JGJYYDMBQ": "将根据已有的meta标签来设置缩放比例",

    //index

    "NLJZZ": "努力加载中",
    "": "routes",
    "ShangPinMingXi": "商品明细",
    "ShangPinLeiBie": "商品类别",
    "QXZFPNR": "请选择发票内容",
    "QXZFPLX": "请选择发票类型",
    "QTXFPTT": "请填写发票抬头",
    "FaPiaoTaiTou": "发票抬头",
    "NSRSBH": "纳税人识别号",
    "FaPiaoNeiRong": "发票内容",
    "FaPiaoXinXi": "发票信息",
    "KaiJuFaPiao": "开具发票",
    "FaPiaoLeiXing": "发票类型",
    "Han": "含",
    "WeiHan": "未含",
    "Shui": "税",
    "QSRFPTT": "请输入发票抬头",
    "QSRNSRSBH": "请输入纳税人识别号",

    //routes
    //cart-bill

    "YiManZu_Man": "已满足【满",
    "ZaiGou": "再购",
    "YMZ_DHJJZ": "已满足【订货价降至",
    "JianJiangZhi": "件降至",
    "YMZ_YDHJD": "已满足【原订货价打",
    "JianMeiJian": "件每件",
    "SYTCSLW0_WFJRGWC": "剩余套餐数量为0，无法加入购物车",
    "QingXuanXeShangPin": "请选择商品！",
    "GSPYXJ": "该商品已下架！",
    "ZJ2TN": "最近{day}天内",
    "QDQCXJSP": "确定清除下架商品？",
    "QingChuChengGong": "清除成功",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "套餐商品不可加入购物车，请取消套餐商品再移入购物车！",
    "SPSLBN": "商品数量不能",
    "TaoCanHan": "套餐含",
    "TaoCan": "套餐",
    "QHDSL": "请核对数量",
    "SPSLBNDY": "商品数量不能低于",
    "XianDingLiang": "限订量",
    "YiRuShouCang": "移入收藏",
    "QuanXuan": "全选",
    "JianZeng": "件赠",
    "JianLiXiang_Man": "件立享【满",
    "Yuan_": "元】",
    "Zhe_": "折】",
    "KCBZ_WFJRGWC": "库存不足，无法加入购物车",
    "XDJEDYDY": "下单金额大于等于",
    "WYXJHYSXDSP": "无已下架或已失效的商品！",
    "DYQDL": "低于起订量",
    "ZSPG1J": "{count} 种商品,共 {number} 件",
    "WanCheng": "完成",
    "BianJi": "编辑",
    "You": "有",
    "ZSPBFHYQ_W": "种商品不符合要求，未被勾选，点击查看",
    "SPSLBNGY": "商品数量不能高于",
    "JXDJ_CKXYGBFHYQSP": "继续点击，查看下一个不符合要求商品",
    "XiaDan": "下单",
    "JianJiang": "件降",
    "QRYCSP": "确认移除商品？",
    "QXZXDSP": "请选择下单商品",
    "KCBZ_QCXXZ": "库存不足，请重新选择！",
    "KuCun": "库存",
    "YCKXD": "元才可下单",
    "QDSCSP": "确定收藏商品？",
    "ShouCangChengGong": "收藏成功",
    "GYXDL": "高于限订量",
    "LiSheng": "立省",
    "GWCHSKD_QGYGB": "购物车还是空的，去逛一逛吧",
    "QuGuangGuang": "去逛逛",
    "QCXJSP": "清除下架商品",
    "ZongE": "总额",
    "YouHui": "优惠",

    //cart-list

    "QXZJHRQ": "请选择配送时间",
    "FuJiaFeiYong": "附加费用",
    "ZhongShangPin_Gong": "种商品，共",
    "PeiSongShiJian": "配送时间",
    "QXZPSSJ": "请选择配送时间",
    "DingDanJinE": "订单金额",
    "SCFJ_ZD4Z": "上传附件，最多4张，单张不超过3M",
    "KeYongShangPin": "可用商品",
    "ShiYongShuoMing": "使用说明",
    "YouXiaoQi": "有效期",
    "Man": "满",
    "BZZBZCTSFH": "备注暂不支持特殊符号",
    "QingXuanZe": "请选择",
    "KaiPiaoXuJia": "开票需加",
    "GeDian": "个点",
    "KPXJ1GD": "开票需加{num}个点",
    "PeiSongFangShi": "配送方式",
    "ZiTi": "自提",
    "PeiSong": "配送",
    "MianYunFei": "免运费",
    "ZuiYou": "最优",
    "KeHuZhiDing": "客户指定",
    "ShangJiaPeiSong": "商家配送",
    "WuPeiSongFangShi": "无配送方式",
    "ShangPinZongJia": "商品总价",
    "YouHuiQuan": "优惠券",
    "ZhangKeXan": "张可选",
    "DDJEWMZ": "订单金额未满足",
    "WDYHQ": "我的优惠券",
    "KYYHQ": "可用优惠券",
    "YuanKeYong": "元可用",
    "ChaKanDingDan": "查看订单",
    "ShangPinHanShui": "商品含税",
    "SPWHS": "商品未含税",

    "QueRenDingDan": "确认订单",
    "XZSHDZ": "新增收货地址",
    "ShangPinQingDan": "商品清单",
    "WKYYHQ": "无可用优惠券",
    "HuChi": "互斥",
    "DaiJinQuan": "代金券",
    "YunFei": "运费",
    "ShuiFei": "税费",
    "BKYYY": "不可用原因",
    "YHQYGQ": "优惠券已过期",
    "WDYHQSYSJ": "未到优惠券使用时间",
    "ZDSPJEWMZ": "指定商品金额未满足",
    "BKYYHQ": "不可用优惠券",
    "YMZ_MYZJ_": "已满足【满{m}元赠{n}件】",
    "YMZ_MZ": "已满足【满{m}元赠{n}】",
    "ZG222YX_M1000": "再购{money}元享【满{target}元赠{num}件】",
    "ZG2JX_MZ": "再购{num}件享【满{target}元赠{present}】",

    "YMZ_MYJY_": "已满足【满{m}元减{n}元】",
    "ZGYX_MYJY_": "再购{m}元享【满{n}元减{o}元】",
    "YMZ_MYZ_": "已满足【满{m}元{n}折】",
    "ZGYX_MYZ_": "再购{m}元享【满{n}元{o}折】",

    //cart-presale-order

    "QXZPSFS": "请选择配送方式",
    "1ZSP_G": "1种商品，共",
    "YSSP_YJ": "预售商品，预计",
    "JiaoHuoRiQi": "交货日期",
    "GMJLY": "给卖家留言",

    //scan-to-cart

    "ZhengZaiChuLi...": "正在处理...",
    "FSCSP": "非商城商品",
    "ZZCLTXM": "正在处理条形码...",
    "SPTJCG": "商品添加成功",
    "QSTXM": "请扫条形码",
    "SFSCDQSP": "是否删除当前商品？",
    "BQ_ZBDXGSP": "抱歉，找不到相关商品",
    "XuanZeDanWei": "选择单位",
    "JRGWC": "加入购物车",
    "QXXZDJRSP": "请先选择待加入商品",
    "ZhengZaiChuLi": "正在处理",
    "JRGWCCG": "加入购物车成功",
    "ZanWuShangPin": "暂无商品",

    //earn-brokerage-share

    "XTYJBNFZSP": "系统已经帮您复制商品链接！",
    "NKYHDDYDYJ": "你可以获得对应的佣金。佣金可在“我的",
    "LiChaKan": "里查看",
    "WeiXinHaoYou": "微信好友",
    "ErWeiMa": "二维码",
    "CASBEWM": "长按识别二维码",
    "FZSB_QCXFZ": "复制失败，请重新复制！",
    "TWEWM": "图文二维码",
    "BCDXC": "保存到相册",
    "CATPBCDXC": "长按图片保存到相册",
    "FuZhiLianJie": "复制链接",
    "FXZYJ": "分享赚佣金",
    "YJZGKZQYJ": "预计最高可赚取佣金",
    "PYTGNFXDYMCGGMH": "朋友通过你分享的页面成功购买后，你可以获得对应的佣金。佣金可在“我的-{path}”里查看",

    //goods-share

    "FXSPGLSKH": "分享商品给零售客户",
    "FXHJSCNZSD": "分享后将生成您专属的手机微商城，您可以设置商城内商品的价格，填写您的联系方式，吸引消费者上门购买。",
    "WSCDQJG_ND": "微商城当前价格：您的订货价 ×",
    "DaiSheZhi": "待设置",
    "PengYouQuan": "朋友圈",
    "GGFXSZ": "更改分享设置",

    //wechat-login

    "QXSRZH": "请先输入账号",
    "MMGSCW_6_20W": "密码格式错误(6-20位字母或数字)",
    "BDYYZH": "绑定已有账号",
    "WXKJDL": "微信快捷登录",
    "BangDingZhangHao": "绑定账号",
    "YYZH_QDL": "已有账号，去登录",
    "ZCXZH": "注册新账户",
    "HuanYingNi": "欢迎你",
    "ZH_SJHM": "账号/手机号码",
    "MiMa": "密码",
    "QDLHCZ": "请登录后操作",

    //add-to-cart

    "KCBZ_BNTJG": "库存不足，不能添加更多",

    //combined-pay-online

    "ZhiFuChengGong": "支付成功！",
    "ZFSB_QCXCS": "支付失败，请重新尝试！",

    //

    "QXXZGG": "请先选择规格",
    "SXGGX": "所选规格需",
    "GMSLXYQDL_": "购买数量小于起订量，请重新购买！",
    "GMSLDYXDL_": "购买数量大于限订量，请重新购买！",
    "ShangPinBianHao": "商品编号",
    "QiDing": "起订",
    "SXGGDGSLBK": "所选规格订购数量不可超过",
    "KCBZ_BNTJ": "库存不足，不能添加",
    "QXXZSP": "请先选择商品",
    "SLBNW0": "数量不能为0",
    "QXZGG": "请选择规格",
    "LiJiYuDing": "立即预订",

    //nav

    "ShouYe": "首页",
    "ShangPin": "商品",
    "DingDan": "订单",
    "WoDe": "我的",

    //pay-online

    "ZhiFuQuXiao": "支付取消",

    //account-log

    "ShangPinYongJin": "商品佣金",
    "YaoQingJiangLi": "邀请奖励",
    "TiXian": "提现",
    "TiXianBoHui": "提现驳回",
    "ZhuanWeiYuE": "转为余额",
    "Jin7Tian": "近7天",
    "Jin30Tian": "近30天",
    "ShouZhiMingXi": "收支明细",
    "ZanWuShuJu": "暂无数据",

    //client-statistics

    "WoDeKeHu": "我的客户",
    "WoDeYaoQing": "我的邀请",

    //distribution-home

    "LeiJiKeHu": "累计客户",
    "LeiJiDingDan": "累计订单",
    "YaoQingHaoYou": "邀请好友",
    "LeiJiYaoQing": "累计邀请",
    "LJSY_Y_": "累计收益（元）",
    "BHDJS": "包含待结算",
    "J7TSY_Y_": "近7天收益（元）",
    "J7TXZKH_R_": "近7天新增客户(人)",
    "KTXYJ": "可提现佣金",
    "XYJYO": "需要加油哦",
    "ChangJianWenTi": "常见问题",
    "Q_ZMYJX_TG": "Q：怎么样进行“推广赚钱",
    "A_FXDPND_Z_": "A：分享店铺内带\"赚\"图标的页面链接，吸引好友点击，好友注册（客户关系设置为注册即绑定）或下单（客户关系设置为下单绑定）在该店铺中购买带\"赚\"图标的商品，都会按照一定的计算方法算作你的“推广赚钱”收益。",
    "Q_RHJS_TGZ": "Q：如何计算“推广赚钱”收益？",
    "A_MGD_Z_TBD": "A：每个带\"赚\"图标的商品都有一定的提成比例，没有该标记的表示该商品不参与“推广赚钱”。好友通过你的分享链接成功付款后，将根据订单中每个商品的提成比例分别计算提成（不参与推广的提成为0），最后累加成为该笔订单的提成收益。收益计算中会扣除运费、退款、满减等金额，以最终成交价为准。",
    "Q_TGZQ_DSY": "Q：“推广赚钱”的收益何时到账？",
    "A_HYTGNDFX": "A：好友通过你的分享链接成功付款后，你可在销售中心的推广订单里看到这笔推广，状态为待结算，客户在确认收货后订单交易完成结算,这笔收益将自动转入你的个人账户，随时可提现。",
    "Q_LJKH_LJY": "Q：累计客户、累计邀请列表没头像昵称？",
    "A_WXYQZYGZ": "A：微信要求只有关注认证服务号才能获取头像昵称，店铺是认证服务号的客户关注店铺公众号，非认证服务号关注“云上订货”公众号后点击店铺任意商品详情页即可获取头像昵称。",
    "Q_WSMWASSG": "Q：为什么我按上述规则分享，没有拿到推广收益？",
    "A_1_HYKNBW": "A：1、好友可能并未与你建立客户关系（好友点击了其他销售员的链接进行注册或下单了）2、好友若在微信环境外（如手机默认浏览器）打开你的分享链接，若浏览器未开启cookie，也将无法记录客户关系，即无法记录推广订单3、上述都没问题时仍然没有记录推广订单，请联系工作人员",

    //

    "XiaoShouZhongXin": "销售中心",

    //generalize-goods

    "SPMC_GG_BH": "商品名称 / 规格 / 编号",
    "YuJiZhuan": "预计赚",

    //invitation-home

    "YaoQingKa": "邀请卡",
    "YNYQJR_TGY": "邀你一起加入，推广赢奖励",
    "DJBCDXC": "点击保存到相册",
    "JYQKFSGHY_": "将邀请卡发送给好友，推广店铺有回报",

    //join-home

    "HuanYingJiaRu": "欢迎加入",
    "YQNCW": "邀请你成为",
    "LiJiJiaRu": "立即加入",

    //order-statistics

    "YuJiYongJin": "预计佣金",
    "YongJin": "佣金",
    "YuJiJiangLi": "预计奖励",
    "JiangLi": "奖励",
    "SPTGDD": "商品推广订单",
    "YQJLDD": "邀请奖励订单",

    //performance-statistics

    "YeJiTongJi": "业绩统计",
    "LJKH_R_": "累计客户（人）",
    "SPYJ_Y_": "商品佣金（元）",
    "HanDaiJieSuan": "含待结算",
    "XGMCJS": "相关名词解释",
    "KeHu": "客户",
    "HFXYBDLKHG": "和分销员绑定了客户关系的买家或分销员",
    "YaoQing": "邀请",
    "FXYCGYQDXJ": "分销员成功邀请的下级分销员",
    "FXYTJKHGMH": "分销员推荐客户购买后，分销员可以获得的佣金",
    "XJFXYTGSPH": "下级分销员推广商品后，上级获得的奖励",

    //posters-promoting

    "NiCheng": "昵称",
    "HaiBaoTuiGuang": "海报推广",
    "JHBFSGHY_T": "将海报发送给好友，推广店铺有回报",

    //settlement-home

    "JieSuanZhongXin": "结算中心",
    "KTXJE": "可提现金额",
    "TiXianJiLu": "提现记录",

    //withdraw-account

    "KHRXMBNWK": "开户人姓名不能为空！",
    "KHHBNWK": "开户行不能为空！",
    "YHKHBNWK": "银行卡号不能为空！",
    "SFZTPBNWK": "身份证图片不能为空！",
    "YHKTPBNWK": "银行卡图片不能为空！",
    "BaoCunChengGong": "保存成功！",
    "SCSFZ": "上传身份证",
    "SCYHK": "上传银行卡",
    "BaoCun": "保存",
    "TiXianZhangHu": "提现账号",
    "TS_QTXZSXX": "提示：请填写真实信息，审核通过后才可提现",
    "KHRXM": "开户人姓名",
    "KaiHuHang": "开户行",
    "YinhangKaHao": "银行卡号",
    "QSRZSXM": "请输入真实姓名",
    "QSRKHHMC": "请输入开户行名称",
    "QSRYHKH": "请输入银行卡号",

    //withdraw-deposit

    "QXSZTXZH": "请先设置提现账号",
    "QuSheZhi": "去设置",
    "JEXY10Y_BKT": "金额小于10元，不可提现！",
    "JECGKTXJE": "金额超过可提现金额！",
    "CGDRKTXSX_": "超过当日可提现上限，单日提现上限为20000元！",
    "QueDingJiang": "确定将",
    "ZhuanDaoYuE": "转到余额?",
    "_JEDY10YSB": "1、金额低于10元时不可提现；",
    "_BCTXDZSJ": "2、本次提现到账时间为发起提现申请成功后的5个工作日内，单日提现上限为20000元；",
    "_GBSRWHSS": "3、该笔收入为含税收入，请自行前往相关税务机构进行个人所得税的申报与缴纳！",
    "_ZDYEKYYS": "4、转到余额可用于商城购物使用；",

    "TXSQCG_QDD": "提现申请成功，请等待审核",
    "JEDYKTXJE_": "金额大于可提现金额，不可转至余额！",
    "ZZYECG_QDG": "转账余额成功，请到个人中心查看！",
    "BenCiTiXian": "本次提现",
    "ZhuangDaoYuE": "转到余额",
    "TiXianDao": "提现到",
    "JEW0BKZZYE": "金额为0不可转至余额！",
    "DRTXSX2WY": "单日提现上限2万元",
    "QuanBuTiXian": "全部提现",
    "QueRenTiXian": "确认提现",

    //goods-filter-tab

    "ZuiChangGouMai": "最常购买",
    "MoRenPaiXu": "默认排序",
    "ZongHe": "综合",
    "FenLei": "分类",
    "XiaoLiangYouXian": "销量优先",
    "XiaoLiang": "销量",
    "JiaGe": "价格",
    "ShaiXuan": "筛选",
    "ZuiJinGouMai": "最近购买",
    "CuXiaoYouXian": "促销优先",
    "QuanBuFenLei": "全部分类",
    "ZhiKanCuXiao": "只看促销",
    "XuanZeFenLei": "选择分类",
    "QXZFL": "请选择分类",

    //goods-list-default

    "ZWXGSP": "暂无相关商品",

    //goods-brand-list

    "PinPaiHui": "品牌汇",

    //goods-classify-filter

    "TuiJianFenLei": "推荐分类",
    "ShangPinFenLei": "商品分类",
    "GengDuo": "更多",

    //goods-detail

    "DLZHBSDQQY": "登录账号不是当前企业客户账号",
    "GXNHQ": "恭喜您获取",
    "SZWSCJGH_C": "设置微商城价格后，才可分享",
    "JHDJSHS_": "距活动结束还剩:",
    "DLHKFX": "登录后可分享",
    "ZZHQXX_QSH": "正在获取信息，请稍候重试",
    "Zhang": "张",
    "Tian": "天",
    "QXZGGZQPD": "请选择规格再去配灯！",
    "Yuan": "元",
    "XS_F_M": "小时/分/秒",

    //integral

    "WoDeJiFen": "我的积分",
    "DaBaiLe": "打败了",
    "JiFen": "积分",
    "DeHuiYuan": "的会员",
    "ZhuanJiFen": "赚积分",
    "JiFenMingXi": "积分明细",
    "HuanLiPin": "换礼品",
    "CKGDHL": "查看更多好礼",
    "ChaDingDan": "查订单",

    //integral-convert

    "DHSLBNCG": "兑换数量不能超过",
    "DuiHuanShuLiang": "兑换数量",
    "SuoXuJiFen": "所需积分",

    //integral-detail

    "LiPinXiangQing": "礼品详情",
    "WoYaoDuiHuan": "我要兑换",
    "ShengYu": "剩余",
    "TuWenXiangQing": "图文详情",
    "Jian": "件",
    "YiDuiWan": "已兑完",

    //integral-filter

    "FenLeiShaiXuan": "分类筛选",
    "JiFenShaiXuan": "积分筛选",

    //integral-flow

    "JiFenShouRu": "积分收入",
    "JiFenZhiChu": "积分支出",

    //integral-logistics

    "DingDanGenZong": "订单跟踪",
    "WuLiuGongSi": "物流公司",
    "WuLiuDanHao": "物流单号",

    //integral-order

    "DingDanLieBiao": "订单列表",
    "YiFaHuo": "已发货",
    "JiFenDingDan": "积分订单",
    "ChaKanWuLiu": "查看物流",

    //integral-order-create

    "LPSLBZ_QCX": "礼品数量不足，请重新支付",
    "JiFenBuZu": "积分不足",
    "ZhiFuXinXi": "支付信息",
    "JiXuGuangGuang": "继续逛逛",
    "QTXSHXX": "请填写收货信息",
    "DuiHuanChengGong": "兑换成功",
    "LPDHQR": "礼品兑换确认",
    "SCCKJ": "市场参考价",
    "LiJiZhiFu": "立即支付",

    //integral-order-detail

    "DingDanXiangQing": "订单详情",
    "DingDanZhuangTai": "订单状态",
    "DingDanBianHao": "订单编号",
    "DuiHuanShiJian": "兑换时间",
    "ShouHuoXinXi": "收货信息",
    "HuaFeiJiFen": "花费积分",

    //integral-rule

    "QDZJF": "签到赚积分",
    "XDZJF": "下单赚积分",
    "1_MRQD_JL": "1、每日签到，奖励{num}积分",
    "2_LXQD3T_EW": "2、连续签到3天，额外奖励{num}积分",
    "3_LXQD7T_EW": "3、连续签到7天，额外奖励{num}积分",
    "DLZJF": "登录赚积分",

    "MRDLYSDHSC": "每日登录{name}商城，奖励{num}积分",
    "DDWCHKHDYD": "订单完成后可获得与订单金额*{num}倍的积分",

    //integral-rule-detail

    "GuiZe": "规则",

    //integral-sign

    "QianDaoYouLi": "签到有礼",
    "QianDaoGuiZe": "签到规则",

    "YLXQD": "已连续签到",
    "YLXQD1T": "已连续签到{num}天",
    "QDCG_NYJLX": "签到成功，您已经连续签到{num}天",
    "QDCG_BCHD1": "签到成功，本次获得{num}积分",
    "BCQDHD4JF_": "本次签到获得{num}积分，棒棒哒！",

    //

    "QSRBZ": "请输入备注",
    "DingDanZengPin": "订单赠品",
    "GuiGeBianHao": "规格编号",
    "GuiGe": "规格",

    //combined-pay

    "CDDWXFK": "此订单无需付款",
    "YHYEBZ": "用户余额不足！",
    "ZFJEBNW0": "支付金额不能为0！",
    "ZFJEBNDYDD": "支付金额不能大于订单待付金额",
    "DFKJE": "待付款金额",
    "FuKuanFangShi": "付款方式",
    "FuJian": "附件",
    "ZHYFZ": "帐号已复制",

    "GHSKZH": "更换收款账号",
    "SYXXZFQSCF": "使用线下支付请上传付款截图附件，以便财务确认款项！",
    "XXZF_BXXZS": "线下支付,必须选择收款账号",
    "DingDanZhiFu": "订单支付",
    "ZFFS_HDFK": "支付方式：货到付款",
    "BCFKJE": "本次付款金额",
    "YuE": "余额",
    "FuZhiZhangHao": "复制帐号",

    "WSZXCXZFPZ": "未设置小程序支付配置",
    "XCXZFZHJY": "小程序支付账号禁用",
    "SRZFJE": "输入支付金额",
    "FuKuanZhangHu": "付款账户",
    "QueRenZhiFu": "确认支付",
    "ShaoHouZhiFu": "稍后支付",

    //order

    "FKJLYTJ_DD": "付款记录已添加，等待财务审核",
    "JiXuGuang": "继续逛",
    "BenCiFuKuan": "本次付款",
    "FuKuanChengGong": "付款成功",
    "ZhiFuFangShi": "支付方式",
    "ZhiFuDingDan": "支付订单",

    //order-batch-pay

    "QXXZSXZFDD": "请先选择所需支付的订单",
    "PiLiangFuKuan": "批量付款",
    "FuKuan": "付款",
    "QuFuKuan": "去付款",

    //order-create-result

    "YingFuJinE": "应付金额",
    "XiaDanShiJian": "下单时间",

    //order-deliver

    "SFQRSH": "是否确认收货？",
    "DDQRSH": "订单确认收货",
    "DFHSP": "待发货商品",
    "ShangPinShuLiang": "商品数量",
    "ChuKuShiJian": "出库时间",
    "FaHuoShiJian": "发货时间",
    "WuLiuBeiZhu": "物流备注",
    "QueRenShouHuo": "确认收货",

    //

    "RYFK_QJSYG": "如已付款，请及时与管理员联系",
    "QSRQXYY": "请输入取消原因",
    "H_DDJZDGB_QJKF": "后，订单将自动关闭，请尽快付款",
    "TuiHuoQingKuang": "退货情况",
    "DingDanZongE": "订单总额",
    "DingDanBeiZhu": "订单备注",
    "FaHuoQingKuang": "发货情况",
    "DingDanFuJian": "订单附件",
    "ShenQingTuiHuo": "申请退货",
    "G1TDSHJL_QRS": "共{num}条待收货记录，确认收货吗？",
    "DaiXiaDan": "代下单",
    "DingDanHao": "订单号",
    "XiaDanFangShi": "下单方式",
    "TuiHuoDan": "退货单",
    "ShangPinZongE": "商品总额",
    "YunFei_ZongZhong": "运费(总重",
    "SF_SPWS": "税费(商品未税",
    "TePiJia": "特批价",
    "FuKuanQingKuang": "付款情况",
    "TiaoJiLu": "条记录",
    "ZaiLaiYiDan": "再来一单",
    "MuLiuXinXi": "物流信息",
    "QDSCGDD_": "确定删除该订单？",
    "YiQueRen": "已确认",
    "YiShouHuo": "已收货",
    "DaiFuJinE": "待付金额",
    "YiFuJinE": "已付金额",
    "ZanWuJiLu": "暂无记录",

    //

    "SPMC_DDH": "商品名称 / 订单号",
    "FuKuanZhuangTai": "付款状态",
    "FaHuoZhuangTai": "发货状态",
    "QiShiShiJian": "起始时间",
    "ZhongZhiShiJian": "终止时间",

    //order-list

    "CaoZuoChengGong": "操作成功",
    "ZBKGM": "暂不可购买",
    "DQDDSPYXJ": "当前订单商品已下架",
    "DQDDBFSPYXJ": "当前订单部分商品已下架",
    "JTJSJSP": "仅添加上架商品",
    "DingHuoDan": "订货单",

    //order-log

    "DingDanRiZhi": "订单日志",

    //order-logistics

    "FuZhiChengGong": "复制成功",
    "FuZhiShiBai": "复制失败",
    "FuZhi": "复制",
    "BoDa": "拨打",
    "WCWLDHXX": "无此物流单号信息",

    //order-pay

    "ZFCS_QCXXD": "支付超时，请重新下单",
    "YQYYCKZF": "已启用预存款支付",
    "BNDYDFKJE": "不能大于待付款金额",
    "ZFJEBNWK": "支付金额不能为空",
    "QXAPFK_FKH": "请先安排付款，付款后截图上传付款信息，以便财务确认款项",
    "DDTJCG_QJS": "订单提交成功，请及时支付",
    "QXZFKFS": "请选择付款方式",
    "SYYEZFH_HX": "使用余额支付后，还需支付",

    //

    "FuKuanJiLu": "付款记录",
    "ZWFKJL": "暂无付款记录",
    "FuKuanXiangQing": "付款详情",
    "FuKuanJinE": "付款金额",
    "ZhiDan": "制单",
    "ShenHe": "审核",
    "ZuoFei": "作废",
    "ZuoFeiYuanYin": "作废原因",
    "GLDHD": "关联订货单",
    "HeXiaoJinE": "核销金额",
    "HeXiaoZhuangTai": "核销状态",
    "DanJuZhuangTai": "单据状态",
    "KeHuMingCheng": "客户名称",
    "ZhangDanHao": "账单号",
    "ShouKuanZhangHao": "收款账户",
    "ShouKuanShiJian": "收款时间",
    "FuKuanPingZheng": "付款凭证",
    "GeFuJian": "个附件",

    //order-statistics

    "DingDanTongJi": "订单统计",

    "DingHuo0Bi": "订货{num}笔",

    //order-statistics-detail
    "DDTJMX": "订单统计明细",
    "AGGTJ": "按规格统计",
    "AFLTJ": "按分类统计",
    "DDJE_Y": "订单金额/元",
    "DHSP_Z": "订货商品/种",
    "DingHuoDan_Bi": "订货单/笔",
    "DingHuoShangPin": "订货商品",
    "JinE": "金额",

    //refund-list
    "TuiHuo": "退货",
    //refund-apply
    "THDHWBC_QD": "退货单还未保存，确定离开？",
    "QSRSQTHJE": "请输入申请退货金额",
    "QSRTHJE": "请输入退货金额",
    "QSRBZXX": "请输入备注信息",
    "YingTuiJinE": "应退金额",
    "TJTHSQ": "提交退货申请",
    "QXXZDHQD": "请先选择订货清单",
    "DingHuoQingDan": "订货清单",
    "SQTHJE": "申请退货金额",
    "DJXZSP": "点击选择商品",
    "TuiHuoJinE": "退货金额",

    //refund-detail
    "THDDXQ": "退货订单详情",
    "YiTuiHuo": "已退货",
    "YiTuiKuan": "已退款",
    "THDZT": "退货单状态",
    "TuiHuoDanHao": "退货单号",
    "TuiHuoShiJian": "退货时间",
    "TuiHuoCangKu": "退货仓库",
    "THLXR": "退货联系人",
    "TuiHuoQingDan": "退货清单",
    "TuiKuanZongE": "退款总额",
    "TuiKuanQingKuang": "退款情况",
    "DaiTuiJinE": "待退金额",
    "YiTuiJinE": "已退金额",

    //refund-product

    "SPMC_BH_GG": "商品名称 / 编号 / 规格编号 / 条形码",
    "GZD1TJG": "共找到1条结果",
    "JiaRuQingDan": "加入清单",

    //refund-result

    "ShenQingChengGong": "申请成功",
    "THDTJCG": "退货单提交成功",
    "ChaKanXiangQing": "查看详情",

    //goods-package-floor

    "HDWKS_WDZL": "活动未开始，晚点再来吧",
    "HDYJS_XCZD": "活动已结束，下次早点哦",
    "ZWSZBT": "暂未设置标题",
    "ChaKanGengDuo": "查看更多",

    //goods-promotion-floor

    "HCDZSJC": "缓存导致时间差",
    "DLCKCXJ": "登录查看促销价",
    "ZWSZCX": "暂未设置促销",
    "JuKaiShi": "距开始",
    "Song": "送",
    "JuJieShu": "距结束",
    "YiJieShu": "已结束",

    //search-floor

    "XiaoXi": "消息",
    "SaoMaXiaDan": "扫码下单",

    //home-page-custom

    "WZLCSJ": "未知楼层数据",

    //jump-error

    "QXZYSDHAPP": "请下载云上订货APP",
    "QMTYQYGLD": "全面体验企业管理端",
    "XZYSDHAPP": "下载云上订货APP",
    "HQGLDWZTY": "获取管理端完整体验",
    "JXTYDHD": "继续体验订货端",

    //notice-detail

    "GongGaoXiangQing": "公告详情",
    "GongGaoFuJian": "公告附件",

    //shop-error

    "NFWDYMBCZO": "你访问的页面不存在哦~",
    "KeNengYuanYin": "可能原因",
    "1_ZDZLSRCWD": "1.在地址栏输入错误地址;",
    "2_DJLGQLJ": "2.点击了过期链接。",

    //shop-index

    "GuanLiDuan": "管理端",
    "ZhuCe": "注册",
    "HYNTYYSDH": "欢迎您体验云上订货",
    "TYZHSJHDQG": "体验账号数据会定期更新，请勿输入重要信息",
    "TYZHZDNRSJ": "体验账号中的内容数据均为虚构，请勿输入重要信息",
    "ZHZCCG": "账号注册成功",
    "DengLuZhangHao": "登录账号",
    "CSMMW": "初始密码为",
    "GNFYHQL": "给您发优惠券啦",
    "Man1YuanKeYong": "满{num}元可用",
    "LQH1TNKY": "领券后{day}天内可用",
    "YiJianLingQu": "一键领取",
    "GXNHD1ZYHQ": "恭您获得{num}张优惠券",
    "Gong1Yuan": "共{num}元",
    "LiJiShiYong": "立即使用",

    //shop-login

    "NHWDL": "你还未登录",

    //shop-notice

    "ShangChengGongGao": "商城公告",
    "ZanWuGongGao": "暂无公告",
    "1GeFuJian": "{num}个附件",

    //deposit-detail

    "KouKuan": "扣款",
    "ChongZhi_Kuan": "充值",
    "KouKuanZuoFei": "扣款作废",
    "ChongZhiZuoFei": "充值作废",
    "ZhangHuMingXi": "账户明细",
    "ZhangHuYuE": "账户余额",
    "LiJiChongZhi": "立即充值",

    //deposit-recharge

    "CZJEBNXY1Y": "充值金额不能小于1元",
    "QSRZQDSZ": "请输入正确的数值",
    "ZDYJE": "自定义金额",
    "ZWKTXSCZGN": "暂未开通线上充值功能",
    "ShiFuJinE": "实付金额",
    "ZhangHuChongZhi": "账户充值",
    "QXZCZJE": "请选择充值金额",
    "QSRCZJE": "请输入充值金额",
    "QLXNDZSYWY": "请联系您的专属业务员充值",
    "ShouJia": "售价",
    "YiShouQing": "已售罄",
    "ChongZhiJinE": "充值金额",
    "QueRenFuKuan": "确认付款",

    //deposit-recharge-result

    "QSDDID": "缺少订单id",
    "ChongZhiChengGong": "充值成功",
    "ChongZhiShiBai": "充值失败",
    "CLZ_QSH...": "处理中，请稍后...",
    "ChongZhiFangShi": "充值方式",
    "ChongZhiShiJian": "充值时间",
    "JYLSH": "交易流水号",
    "FanHuiShangCheng": "返回商城",

    //recharge-online

    "ZFSB_QCS": "支付失败，请重试",
    "ZFYQX": "支付已取消",
    "ZFYC_QCS": "支付异常，请重试",

    //user

    "LingQuanZhongXin": "领券中心",
    "WeiShiYong": "未使用",
    "YiShiYong": "已使用",
    "ZWYHQ": "暂无优惠券",

    //keep-list

    "YiGouMai": "已购买",
    "ChangYongQingDan": "常用清单",
    "WoDeShouCang": "我的收藏",
    "QuGouWuChe": "去购物车",
    "GeShangPin": "个商品",

    //login

    "YunShangDingHuo": "云上订货",
    "QSRZH": "请输入账号!",
    "QSRMM": "请输入密码!",
    "QSRDLZH": "请输入登录账号",
    "JiZhuMiMa": "记住密码",
    "WangJiMiMa": "忘记密码?",
    "DengLu": "登录",
    "DLZHBCZ_QL": "登录账号不存在,请联系管理员开通",
    "GQYZHSBJY_": "该企业账号试被禁用,请联系云上订货",
    "GQYZHSYQJS_": "该企业账号试用期结束,请联系云上订货",
    "GQYZHYGQL_": "该企业账号已过期了,需要续费才能使用,请联系云上订货",
    "LiJiTiYan": "立即体验",

    //my-collect

    "YiChuChengGong": "移出成功",
    "QueHuo": "缺货",
    "YCSCJ": "移出收藏夹",

    //order-message

    "SheZhiChengGong": "设置成功",
    "ZWWDXX": "暂无未读消息",
    "QuanBuYiDu": "全部已读",
    "DingDanXiaoXi": "订单消息",

    //

    "YiQiang": "已抢",
    "LiJiLingQu": "立即领取",
    "LingQuanHou": "领券后",
    "TianNeiKeYong": "天内可用",

    //

    "QSRSJH": "请输入手机号",
    "QSRYZM": "请输入验证码",
    "QSRXMM": "请输入新密码",
    "QSRZQSJGS": "请输入正确手机格式",
    "ChongZhiMiMa": "重置密码",
    "QSRNDSJHM": "请输入您的手机号码",
    "QSRDXYZ": "请输入短信验证",
    "HQYZM": "获取验证码",
    "HKCXHQ": "后可重新获取",
    "QSR6_20WSZHZ": "请输入6-20位数字或字母的密码",

    //share-setting

    "QSRSPJGBL": "请输入商品价格比例",
    "SPJGBLBXDY": "商品价格比例必须大于或等于100，且小于999.99",
    "DPMCZBZCTS": "店铺名称暂不支持特殊符号",
    "LXRZBZCTSF": "联系人暂不支持特殊符号",
    "LXFSZBZCTS": "联系方式暂不支持特殊符号",
    "LXDZZBZCTS": "联系地址暂不支持特殊符号",
    "DPJJZBZCTS": "店铺简介暂不支持特殊符号",
    "QSRDPJJ_ZD": "请输入店铺简介，最多可输入50个字",
    "FenXiangSheZhi": "分享设置",
    "NDWSCSPJG": "您的微商城商品价格",
    "NDDHJ_": "您的订货价×",
    "LXXX_KBJ_": "联系信息(可编辑）",
    "DianPuMingCheng": "店铺名称",
    "JianJie": "简介",
    "QSRDPMC": "请输入店铺名称",
    "LianXiRen": "联系人",
    "QSRLXR": "请输入联系人",
    "LianXiFangShi": "联系方式",
    "QSRLXFS": "请输入联系方式",
    "LianXiDiZhi": "联系地址",
    "QSRLXDZ": "请输入联系地址",

    //user

    "WoDeDingDan": "我的订单",
    "ZuiJinLiuLan": "最近浏览",
    "ShouCangShangPin": "收藏商品",
    "BDYYZH_ZC": "绑定已有账号 | 注册新账号",
    "DL_ZC": "登录 | 注册",
    "BangDingShouJi": "绑定手机",
    "TS_BDSJHM_": "提示：绑定手机号码，账号更安全！",
    "ChaKanQuanBu": "查看全部",
    "ShouHuoDiZhi": "收货地址",
    "LianXiWoMen": "联系我们",
    "SheZhi": "设置",
    "QuQianDao": "去签到",
    "QianDao": "签到",
    "JiFenShangCheng": "积分商城",
    "TuiGuangShangPin": "推广商品",
    "QuChaKan": "去查看",
    "JiFenHuanLi": "积分换礼",
    "DYSPBQ": "打印商品标签",

    //user-about

    "GYYSDH": "关于云上订货",
    "YQHYSMEWM_": "邀请好友扫描二维码，直接下载安装",
    "DangQianBanBen": "当前版本",

    //user-address

    "ZWSHDZ": "暂无收货地址",
    "WoDeDiZhi": "我的地址",
    "ZhiNengShiBie": "智能识别",
    "ZTDZXXKZNS": "粘贴地址信息可智能识别姓名、电话、地址",
    "MoRen": "默认",
    //

    "QRSCDZ": "确认删除地址？",
    "SHRXM": "收货人姓名",
    "SJHMHGDDHZ": "手机号码或固定电话至少填写一个",
    "QSRSHRXM": "请输入收货人姓名",
    "ShouJiHaoMa": "手机号码",
    "GuDingDianHua": "固定电话",
    "QSRGDDH": "请输入固定电话",
    "SuoZaiDiQu": "所在地区",
    "QSRSZDQ": "请输入所在地区",
    "QSRXXDZ": "请输入详细地址!",
    "QSRZQDSJHM": "请输入正确的手机号码",
    "QSRZQDGDDH": "请输入正确的固定电话",
    "XiangXiDiZhi": "详细地址",
    "MoRenDiZhi": "默认地址",
    "SWMRDZ": "设为默认地址",
    "BCBSY": "保存并使用",

    //user-bing-one

    "QSRSJHM": "请输入手机号码",
    "GYHYZC": "该用户已注册",
    "GSJHMYJZCG": "该手机号码已经注册过",
    "QZJDLJK": "请直接登录即可",
    "QuDengLu": "去登录",
    "BDHKYTGSJH": "绑定后可以通过手机号进行登录，便于您找回密码，提高账户安全性",
    "_BDHKYTGSJ": "*绑定后可以通过手机号登录，便于您找回密码，提高账户安全性",
    "QSRSJYZM": "请输入手机验证码",
    "BDXSJ": "绑定新手机",
    "DXYZM": "短信验证码",
    "XiaYiBu": "下一步",
    "TGCBZ": "跳过此步骤",

    //user-bing-two

    "DBDSJHMBCZ": "待绑定手机号码不存在!",
    "QSRDLMM": "请输入登录密码!",
    "_GSJHMYBDY": "*该手机号码已绑定云上订货账号，验证手机登录密码，即可绑定当前帐号",
    "DQZHMMJTBW": "当前账号密码将同步为手机登录密码",
    "DangQianZhangHao": "当前账号",

    //

    "QDYJZ": "确定要将这",
    "JSPSCM": "件商品删除吗？",
    "ShanChuChengGong": "删除成功！",

    //user-info

    "SJGSCW": "手机格式错误",
    "YXGSCW": "邮箱格式错误",
    "WoDeZhangHao": "我的账号",
    "YouXiang": "邮箱",
    "ShouJi": "手机",
    "XingMing": "姓名",
    "XiuGaiTouXiang": "修改头像",
    "JiBenXinXi": "基本信息",
    "ZhangHaoAnQuan": "账号安全",
    "XiuGaiMiMa": "修改密码",
    "DianJiBangDing": "点击绑定",
    "RYDSHTY_QL": "若已丢失或停用，请立即更换，避免账户被盗",
    "WBZNDZHAQ_": "为保障您的账号安全，请绑定手机",
    "QSRNDXM": "请输入您的姓名",
    "QSRNDDH": "请输入您的电话",
    "QSRNDYX": "请输入您的邮箱",

    //user-setting

    "QCHCHXCXDL": "清除缓存后需重新登录",
    "QingChuHuanCun": "清除缓存",
    "QDYQCHCM": "确定要清除缓存吗？",
    "TuiChuDengLu": "退出登录",
    "ZhangHaoZhuXiao": "账号注销",
    "QieHuanZhangHao": "切换账号",

    //user-supplier

    "LianXi": "联系",
    "GongSiDianHua": "公司电话",
    "DiZhi": "地址",

    //vouchers-detail

    "DJQMX": "代金券明细",

    //vouchers-list

    "BuKeYong": "不可用",
    "KeYong": "可用",
    "ZWDJQ": "暂无代金券",
    "ZongEDu": "总额度",
    "FaFangShiJian": "发放时间",
    "EDYYW": "额度已用完",
    "QBSPKY": "全部商品可用",

    //vouchers-select-list

    "WDDJQ": "我的代金券",
    "KYDJQ": "可用代金券",
    "DJQKDK": "代金券可抵扣",
    "CKKYSP": "查看可用商品",
    "BKYDJQ": "不可用代金券",
    "BKYYY_ZWFH": "不可用原因：暂无符合条件商品",
    //goods-detail

    "DQSPWSCGGT": "当前商品未上传规格图，不支持配灯！",
    "BoFangShiPin": "播放视频",
    "Gong1GeGuiGe": "共{num}个规格",
    "YiXuanGuiGe": "已选规格",
    "XuanGuiGe": "选规格",
    "LingQuan": "领券",
    // "Jian":"减",
    "1ZhongCuXiao": "{num}种促销",
    "1ZhangKeYong": "{num}张可用",
    "ZuiGaoKeSheng": "最高可省",
    "ShangPinTaoCan": "商品套餐",
    "Gong1GeTaoCan": "共{num}个套餐",
    "ShangPinCanShu": "商品参数",
    "ZhanKai": "展开",
    "YiShouCang": "已收藏",
    "ShouCang": "收藏",
    "KeFu": "客服",
    "XiangQing": "详情",
    "TuiJian": "推荐",
    "BianHao": "编号",
    "ShangPinXinXi": "商品信息",
    "KLYHQ": "可领优惠券",
    "KuCunBuZu": "库存不足",
    "DuoGuiGe": "多规格",
    "YiShou": "已售",
    "SWBHZ_YS": "售完补货中，已售",
    "CuXiaoShangPin": "促销商品",

    //goods-search

    "NHWSRSSNR": "你还未输入搜索内容",
    "SouSuo": "搜索",
    "SSY1XGDSP": "搜索与{searchKey}相关的商品",
    "Yue1GeShangPin": "约{num}个商品",
    "ZuiJinSouSuo": "最近搜索",
    "QingChu": "清除",
    "ZWSSJL": "暂无搜索记录",

    //goods-property

    "ZGJGBNDYZD": "最高价格不能低于最低价格",
    "ShangPinBiaoQian": "商品标签",
    "BuGaoYu1": "不高于1",
    "BuDiYu1": "不低于1",
    "FengGe": "风格",

    //goods-promotion-list

    "JiJiangKaiShi": "即将开始",
    "QuanBuCuXiao": "全部促销",

    //goods-package-list

    "Gong1JianShangPin": "共{num}件商品",
    "Sheng": "省",

    //goods-package-detail

    "GTCZGWCZDS": "该套餐在购物车中的数量已达到限购量，不可加入购物车",
    "GTCKCBZ_BK": "该套餐库存不足，不可加入购物车",
    "JinSheng1Tao": "仅剩{num}套",
    "XianGou1Tao": "限购{num}套",
    "TaoCanXiangQing": "套餐详情",
    "DanMaiJia": "单买价",
    "TaoCanJia": "套餐价",
    "HDYJS": "活动已结束",

    //goods-message

    "WDL_QXDL": "未登录，请先登陆",

    //goods-list-label

    "XinPinShangShi": "新品上市",
    "WDLZH_ZWCX": "未登录账号，暂无促销活动！",
    "YiXiaShangPin": "以下商品",

    //goods-list
    "1ZhongGuiGe": "{num}种规格",
    "YouKuCun": "有库存",

    //goods-filter
    "BuGaoYu": "不高于",
    "BuDiYu": "不低于",
    "CuXiao": "促销",
    "ZDYXXZ3G": "最多允许选择3个",
    "GouMai": "购买",

    "Gong1Jian": "共{num}件",

    //缺失
    "YiChuShouCangJia": "移出收藏夹",
    "$": "￥",
    "$1": "￥{num}",
    "_8999_1Qi": "￥ 8999.1 起",
    "Ge": "个",
    "BaoZhuangFangShi": "包装方式",
    "QRSCSP_": "确认删除商品？",
    "JEWM_TMFRK": "将二维码/条码放入框内，即可自动扫描",
    "0ZSP_G0J": "0种商品，共0件",
    "JiuMiMa": "旧密码",
    "XMM_6_20WZ": "新密码（6-20位字母或数字）",
    "QueRenMiMa": "确认密码",

    "BDHKSYSJHD": "绑定后可使用手机号登陆，便于找回密码，提高账号安全性",
    "YanZhengMa": "验证码",
    "1MHKCXHQ": "1秒后可重新获取",
    "CSJHZ1MQFS": "此手机号在1秒前发送过验证码，请稍后重试",
    "GouMaiJiLu": "购买记录",
    "XinZengDiZhi": "新增地址",
    "LingShouJia": "零售价",
    "YouHuiJia": "优惠价",
    "ShangPinChuKu": "商品出库",
    "DengDaiShouHuo": "等待收货",
    "ShouHuoRen": "收货人",
    "PaiZhao": "拍照",
    "XiangCe": "相册",

    "TiYanGuan": "体验馆",
    "JingYingShiJian": "经营时间",
    "ZhanGuanDianHua": "展馆电话",
    "ZhanGuanDiZhi": "展馆地址",
    "SJHQZ_QSDZ": "数据获取中，请稍等再试！",
    "QXXZSF_": "请先选择省份!",
    "QuanBuShengFen": "全部省份",
    "QuanBuChengShi": "全部城市",
    "YingYeShiJian": "营业时间",
    "ChanPinBianHao": "产品编号",
    "DLXXYGQ_QC": "登录信息已过期，请重新登录",
    "Man999Jian100": "满{m}减{n}",

    "YiManZu": "已满足",
    "QDYCSP_": "确认移除商品？",
    "DGM10JZ1J": " 订购满10件赠1件 ",

    // route-fetch
    "XiaXianTongZhi": "下线通知",
    "NDZHYZQTSB": "您的账号已在其他设备登录，请重新登录。如非本人操作，请及时修改密码",
    "ManJiang": '满{target}件降{num}元',
    "ZGLXMJ": '再购{num}件立享【满{target}件降至{money_}元】',
    "ZGLXMZ": '再购{num}件立享【满{target}件每件{percent}折】 ',
    "QSRZQNR": '请输入正确内容',
    "NHYDDQKWJQ": '你还有{num}个订单共计{money}元未结清欠款结清后才可继续下单',

    //发票助手

    "FaPiaoZhuShou": "发票助手",
    "WoDeFaPiao": "我的发票",
    "FaPiaoXiangQing": "发票详情",
    "KaiPiaoShiJian": "开票时间",
    "DaiKaiFaPiao": "待开发票",
    "DKFPJE": "待开发票金额",
    "KaiPiaoJinE": "开票金额",
    "ZFYDWT_QCSCXZF": "支付遇到问题，请尝试重新支付或更换支付方",
    "QingXuanZhe": "请选择",

    "ShouXin": '授信',
    "LJSQSXED": "立即申请授信额度",
    "SXEDSHZ": "授信额度审核中",
    "SXCZ_XDCG": "授信充足，下单成功",
    "SXEDBZ_FKHFH": "授信额度不足，付款后发货",
    "CGJKZQ_FKFH": "超过借款周期，付款发货",
    "DDTJCG_XZZCZHYB": "订单提交成功，现在只差最后一步了！",

    "MianFeiLing": "免费领",
    "M_KMFLQ_HQ": "满{target}元可免费领取，还差{short}元",
    "YHDMFSP": "已获得免费商品",
    "JRMFL": "今日免费领",
    "LingGuangLe": "领光了",
    "KeLingQu": "可领取",
    "YuGuJia": "预估价",
    "GXNHQ_Z_Y_": "恭喜您获取{num}张{price}元{name}",
    "LXZSKF": "联系专属客服",
    "DPYDY_QSHX": "店铺已打烊，请稍后下单",
    "DaYangShiJian": "打烊时间",

    "ChuanHaoChaXun": '串号查询',
    'IMEI': '串号',

    "FanKuanYuE": "返款余额",
    "FanKuanZhiFu": "返款支付",
    "JingDongYiYunJia": "京东易云+",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "返款余额不足",
    "FanKuanZhangHu": "返款账户",
    "HaiXuZhiFu": "还需支付 {price}",
    // 20-11-11 add
    "QTXGSMC": "请填写公司名称",
    "QSCSFZZMZ": "请上传身份证正面照",
    "QSCSFZFMZ": "请上传身份证反面照",
    "QSCYYZZ": "请上传营业执照",
    "TJCG_QNXDDSH": "提交成功，请耐心等待审核",
    "SXSQ": "授信申请",
    "QYJBZL": "企业基本资料",
    "SQFRSFZZM": "上传法人身份证正面",
    "ZMSLT": "正面示例图",
    "SCFRSFZFM": "上传法人身份证反面",
    "FMSLT": "反面示例图",
    "QQBSFZSJWZ_WZQXKBB": "请确保身份证四角完整，文字清晰可辨别",
    "SCYYZZ": "上传营业执照",
    "ShengHeZhong": "审核中",
    "TiJiaoShenHe": "提交审核",
    "GSMC": "公司名称",
    "DDDKFQRBJQSH": "订单待客服确认报价请稍后",
    "XDTX": "下单提醒",
    "NH_GDDBH": "有部分商品价格待客服核实才能付款",
    "QRXD": "确认下单",
    "QRLY": "确认留言",
    "DaiHeJia": "待核价",

    "ZHJY": "账户结余",
    "YGTG": "员工推广",
    "YuanGong": "员工",
    "DuiZhanGJieSuan": "对账结算",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "账户结余 = 预存款余额 + 返款余额 + 退货待退款 - 订单应付款",
    "YCKYE": "预存款余额",
    "FKYE": "返款余额",
    "DDYFK": "订单应付款",
    "THDTK": "退货待付款",
    "YuCunKuanZuoFei": "预存款作废",
    "FanKuanZhangHuMingXi": "返款账户明细",
    "TKCZDFKZH": "退款充值到返款账户",
    "RMBJE": "人民币金额",

    // 阶梯递减运费相关
    "JuMianYunFei": "距免运费还差{gap}元",
    "YiManMianYunFei": "已满免运费条件",
    "ManYuanMianYunFei": "满{limit}元免运费",
    "MeiJianYYunFeiZ": "每减{unit}元运费增加{fee}元",
    "YunFeiShangXian": "运费上限{max}元",
    "PiPeiQuYu": "匹配区域：{region}",
    "AnDingDanJinEJieTi": "按订单金额阶梯递减",
    "JieTiYunFeiXiangQing": "阶梯运费详情",
    "ZaiGouMianYunFei": "再购{amount}元可免运费"

};
exports.default = zh_CN;

/***/ }),
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalComponent = undefined;

var _extends2 = __webpack_require__(53);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _createClass2 = __webpack_require__(36);

var _createClass3 = _interopRequireDefault(_createClass2);

var _classCallCheck2 = __webpack_require__(35);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(38);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(37);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(52);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _rmcDialog = __webpack_require__(371);

var _rmcDialog2 = _interopRequireDefault(_rmcDialog);

var _rmcFeedback = __webpack_require__(367);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ModalComponent = exports.ModalComponent = function (_React$Component) {
    (0, _inherits3['default'])(ModalComponent, _React$Component);

    function ModalComponent() {
        (0, _classCallCheck3['default'])(this, ModalComponent);
        return (0, _possibleConstructorReturn3['default'])(this, (ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).apply(this, arguments));
    }

    return ModalComponent;
}(React.Component);

var Modal = function (_ModalComponent) {
    (0, _inherits3['default'])(Modal, _ModalComponent);

    function Modal() {
        (0, _classCallCheck3['default'])(this, Modal);
        return (0, _possibleConstructorReturn3['default'])(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Modal, [{
        key: 'renderFooterButton',
        value: function renderFooterButton(button, prefixCls, i) {
            var buttonStyle = {};
            if (button.style) {
                buttonStyle = button.style;
                if (typeof buttonStyle === 'string') {
                    var styleMap = {
                        cancel: {},
                        'default': {},
                        destructive: { color: 'red' }
                    };
                    buttonStyle = styleMap[buttonStyle] || {};
                }
            }
            var onClickFn = function onClickFn(e) {
                e.preventDefault();
                if (button.onPress) {
                    button.onPress();
                }
            };
            return React.createElement(
                _rmcFeedback2['default'],
                { activeClassName: prefixCls + '-button-active', key: i },
                React.createElement(
                    'a',
                    { className: prefixCls + '-button', role: 'button', style: buttonStyle, onClick: onClickFn },
                    button.text || 'Button'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this,
                _classnames2;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                wrapClassName = _a.wrapClassName,
                transitionName = _a.transitionName,
                maskTransitionName = _a.maskTransitionName,
                style = _a.style,
                platform = _a.platform,
                _a$footer = _a.footer,
                footer = _a$footer === undefined ? [] : _a$footer,
                operation = _a.operation,
                animated = _a.animated,
                transparent = _a.transparent,
                popup = _a.popup,
                animationType = _a.animationType,
                restProps = __rest(_a, ["prefixCls", "className", "wrapClassName", "transitionName", "maskTransitionName", "style", "platform", "footer", "operation", "animated", "transparent", "popup", "animationType"]);
            var btnGroupClass = (0, _classnames4['default'])(prefixCls + '-button-group-' + (footer.length === 2 && !operation ? 'h' : 'v'), prefixCls + '-button-group-' + (operation ? 'operation' : 'normal'));
            var footerDom = footer.length ? React.createElement(
                'div',
                { className: btnGroupClass, role: 'group' },
                footer.map(function (button, i) {
                    return (
                        // tslint:disable-next-line:jsx-no-multiline-js
                        _this3.renderFooterButton(button, prefixCls, i)
                    );
                })
            ) : null;
            var transName = void 0;
            var maskTransName = void 0;
            if (animated) {
                // tslint:disable-next-line:prefer-conditional-expression
                if (transparent) {
                    transName = maskTransName = 'am-fade';
                } else {
                    transName = maskTransName = 'am-slide-up';
                }
                if (popup) {
                    transName = animationType === 'slide-up' ? 'am-slide-up' : 'am-slide-down';
                    maskTransName = 'am-fade';
                }
            }
            var wrapCls = (0, _classnames4['default'])(wrapClassName, (0, _defineProperty3['default'])({}, prefixCls + '-wrap-popup', popup));
            var cls = (0, _classnames4['default'])(className, (_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-transparent', transparent), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-popup', popup), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-popup-' + animationType, popup && animationType), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-android', platform === 'android'), _classnames2));
            return React.createElement(_rmcDialog2['default'], (0, _extends3['default'])({}, restProps, { prefixCls: prefixCls, className: cls, wrapClassName: wrapCls, transitionName: transitionName || transName, maskTransitionName: maskTransitionName || maskTransName, style: style, footer: footerDom }));
        }
    }]);
    return Modal;
}(ModalComponent);

exports['default'] = Modal;

Modal.defaultProps = {
    prefixCls: 'am-modal',
    transparent: false,
    popup: false,
    animationType: 'slide-down',
    animated: true,
    style: {},
    onShow: function onShow() {},

    footer: [],
    closable: false,
    operation: false,
    platform: 'ios'
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(251);
var enumBugKeys = __webpack_require__(156);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(665);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ColorUtil = exports.GoodsPriceUtil = exports.NumberUtil = exports.CheckUtil = exports.FormatUtil = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Created by Samj on 2017/7/18.
                                                                                                                                                                                                                                                                               */
// 中文


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _miment = __webpack_require__(684);

var _miment2 = _interopRequireDefault(_miment);

var _reactIntl = __webpack_require__(146);

var _DialogAction = __webpack_require__(382);

var _mathUtils = __webpack_require__(224);

var _mathUtils2 = _interopRequireDefault(_mathUtils);

var _storageUtil = __webpack_require__(50);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

var _constant = __webpack_require__(51);

var _checkUtil = __webpack_require__(223);

var _checkUtil2 = _interopRequireDefault(_checkUtil);

var _zh_CN = __webpack_require__(115);

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _es_ES = __webpack_require__(114);

var _es_ES2 = _interopRequireDefault(_es_ES);

var _en_US = __webpack_require__(113);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 英语
// 多语言 XIAOMI654321
var messages = {
    'zh': _zh_CN2.default,
    'es': _es_ES2.default,
    'en': _en_US2.default
};
var lang = _storageUtil2.default.getItem(_constant.SystemConst.lang) || 'zh';

function pad(num, length) {
    return (num + "0000000000000000").substr(0, length);
}

var FormatUtil = {
    //商品价格精度
    priceScale: function priceScale(value, scale) {
        if (isNaN(Number(value))) return;
        var currencySymbol = _storageUtil2.default.getItem(_constant.SystemConst.currencySymbol) || '￥';
        var s = scale || _storageUtil2.default.getItem(_constant.SystemConst.priceScale) || 2;
        var times = Math.pow(10, s);
        var s1 = value.toString();
        var valArr = s1.split(".");
        var m = valArr[1] ? valArr[1].length : 0;

        var priceZoom = s1 * Math.pow(10, m) * times / Math.pow(10, m);
        var des = parseInt(priceZoom + 0.5, 10) / times;
        return currencySymbol + +des.toFixed(s);
    },

    //商品价格精度
    priceScaleNoChar: function priceScaleNoChar(value, scale) {

        if (isNaN(Number(value))) return;
        var s = scale || _storageUtil2.default.getItem(_constant.SystemConst.priceScale) || 2;
        var times = Math.pow(10, s);
        var s1 = value.toString();
        var valArr = s1.split(".");
        var m = valArr[1] ? valArr[1].length : 0;
        var priceZoom = s1 * Math.pow(10, m) * times / Math.pow(10, m);
        var des = parseInt(priceZoom + 0.5, 10) / times;
        return +des.toFixed(s);
    },
    countScale: function countScale(value, scale) {
        if (_checkUtil2.default.isNumber(value)) {
            var s = scale ? scale : window.countScale ? window.countScale : _storageUtil2.default.getItem(_constant.SystemConst.countScale);
            var i, f;
            var arr = (value + '').split('.');
            if (arr.length == 2) {
                i = arr[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                f = pad(arr[1].substr(0, s), s);
                if (s == 0) {
                    return +i;
                } else {
                    return +(i + '.' + f);
                }
            } else {
                if (s === 0) {
                    return +arr[0].replace('null', 0);
                } else {
                    return +arr[0].replace('null', 0);
                }
            }
        } else {
            return '';
        }
    },

    date: function date(v) {
        if (!v) {
            return '';
        }
        return v.split(' ')[0].replace(new RegExp(/(-)/g), '-');
    },

    showStock: function showStock(stock) {
        var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        var type = _storageUtil2.default.getItem(_constant.SystemConst.stockShowType);
        var showStock = parseInt(stock / scale);
        switch (type) {
            case 1:
                if (lang === 'es') {
                    return showStock > 0 ? 'En stock' : 'Fuera de stock';
                } else {
                    return showStock > 0 ? '\u6709\u8D27' : '\u65E0\u8D27';
                }
            case 2:
                return showStock > 0 ? showStock : 0;
            default:
                return undefined;
        }
    },

    priceUnit: function priceUnit(price) {
        if (!price) return;
        if (price > 100000000) {
            return (price / 100000000).toFixed(2) + '亿';
        } else if (price > 10000000) {
            return (price / 10000000).toFixed(2) + '千万';
        } else if (price > 1000000) {
            return (price / 1000000).toFixed(2) + '百万';
        } else if (price > 10000) {
            return (price / 10000).toFixed(2) + '万';
        } else {
            return price.toFixed(2);
        }
    },
    countUnit: function countUnit(count) {
        if (!count) return;
        if (count > 100000000) {
            return (count / 100000000).toFixed(2) + '亿';
        } else if (count > 10000000) {
            return (count / 10000000).toFixed(2) + '千万';
        } else if (count > 1000000) {
            return (count / 1000000).toFixed(2) + '百万';
        } else if (count > 10000) {
            return (count / 10000).toFixed(2) + '万';
        } else {
            return count;
        }
    }
};
var NumberUtil = {

    //精度,默认两位
    scale: function scale(v) {
        var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

        if (_checkUtil2.default.isNumber(v)) {
            return Math.round(v * Math.pow(10, s)) / Math.pow(10, s);
        } else {
            return 0;
        }
    },
    toNumber: function toNumber(v) {
        return Number(v) || 0;
    },
    //v1+v2
    add: function add(v1, v2) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

        return NumberUtil.scale(v1, s) + NumberUtil.scale(v2, s);
    },
    // v1-v2
    sub: function sub(v1, v2) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

        return NumberUtil.scale(v1, s) - NumberUtil.scale(v2, s);
    },
    unsignSub: function unsignSub(v1, v2) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

        var result = NumberUtil.scale(v1, s) - NumberUtil.scale(v2, s);
        return result > 0 ? result : 0;
    },
    // v1*v2
    mul: function mul(v1, v2) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

        return NumberUtil.scale(v1, s) * NumberUtil.scale(v2, s);
    },

    // v1/v2
    div: function div(v1, v2) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

        return NumberUtil.scale(v1, s) / (NumberUtil.scale(v2, s) == 0 ? 1 : NumberUtil.scale(v2, s));
    }

};
var Util = {
    confirm: function confirm(content, option) {
        return (0, _DialogAction.ysConfirm)(content, option);
    },
    message: function message(_message, option) {
        return (0, _DialogAction.ysMessage)(_message, option);
    },
    title: function title(_title, content, option) {
        return (0, _DialogAction.ysTitle)(_title, content, option);
    },
    twoDecNumber: function twoDecNumber(num) {
        num = num.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        num = num.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        num = num.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        if (num.indexOf(".") < 0 && num != "") {
            //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            num = parseFloat(num);
        }
        return num;
    },
    toParse: function toParse(value) {
        var back = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // back ：错误返回值，默认返回对象
        switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
            case 'object':
                return value === null ? {} : value;
                break;
            default:
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return back;
                }
                break;
        }
    },
    formatTime: function formatTime(time, format) {
        //时间格式化
        return (0, _miment2.default)(time).format(format);
    },
    timeTranslate: function timeTranslate(timer) {
        if (!timer && timer !== 0 || timer < 0) return {};
        //计算出相差天数
        var days = Math.floor(timer / (24 * 3600 * 1000));
        //计算出相差小时数
        var leave1 = timer % (24 * 3600 * 1000); //计算天数后剩余毫秒数
        var hours = Math.floor(leave1 / (3600 * 1000));

        //计算出相差分钟数
        var leave2 = leave1 % (3600 * 1000);
        var minutes = Math.floor(leave2 / (60 * 1000));

        //计算出相差秒数
        var leave3 = leave2 % (60 * 1000);
        var seconds = Math.round(leave3 / 1000);
        //计算出剩余毫秒数
        var leave4 = leave3 % 1000;
        var msec = Math.round(leave4).toString().charAt(0);

        //字符串
        var time = '';

        if (days > 0) {
            time = '\u5269 <i>' + days + '</i> \u5929';
        } else if (hours > 0) {
            time = '\u5269 <i>' + hours + '</i> \u5C0F\u65F6';
        } else {
            time = '<i>' + minutes + '</i> \u5206 <i>' + seconds + '</i> \u79D2 <i>' + msec + '</i>';
        }

        return {
            d: days, //天
            h: this.comple(hours), //小时
            m: this.comple(minutes), //分钟
            s: this.comple(seconds), //秒
            ms: msec, //豪秒
            time: time
        };
    },
    datetimeFormat: function datetimeFormat(time) {
        var seconds = time / 1000;
        switch (true) {
            case seconds <= 60:
                return "刚刚";
            case seconds > 60 && seconds <= 3600:
                return Math.floor(seconds / 60) + "分钟前";
            case seconds > 3600 && seconds <= 3600 * 24:
                return Math.floor(seconds / 3600) + "小时前";
            case seconds > 3600 * 24 && seconds <= 3600 * 24 * 30:
                return Math.floor(seconds / (3600 * 24)) + "天前";
            case seconds > 3600 * 24 * 30 && seconds <= 3600 * 24 * 30 * 12:
                return Math.floor(seconds / (3600 * 24 * 30)) + "个月前";
            case seconds > 3600 * 24 * 30 * 12:
                return Math.floor(seconds / (3600 * 24 * 30 * 12)) + "年前";
            default:
                return "未知类型";
        }
    },
    comple: function comple(v) {
        return v >= 10 || v < 0 ? v : '0' + v;
    },
    formatIosTime: function formatIosTime(t) {
        return t.replace(/\-/g, "/");
    }
};

var GoodsPriceUtil = {
    getPrice: function getPrice(model, isLogin) {
        if (!model) {
            return;
        }
        if (model.client_price_ == -1) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DLCKJG', defaultValue: '\u767B\u5F55\u67E5\u770B\u4EF7\u683C' });
        }

        //没登录+不允许游客查看价格
        if (GoodsPriceUtil.shouldToLogin(model, isLogin)) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DLCKJG', defaultValue: '\u767B\u5F55\u67E5\u770B\u4EF7\u683C' });
        }
        var price = isLogin ? model.client_price_ : model.client_price_;
        var price_String = FormatUtil.priceScale(price);
        if (GoodsPriceUtil.isMorePrice(model, isLogin)) {
            price_String = FormatUtil.priceScale(GoodsPriceUtil.getMiniPrice(model, isLogin)) + " - " + FormatUtil.priceScale(GoodsPriceUtil.getMaxPrice(model, isLogin));
        }

        return price_String;
    },
    getPriceNoChar: function getPriceNoChar(model, isLogin, promotionInfo) {
        if (!model) {
            return;
        }
        if (model.client_price_ == -1) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DLCKJG', defaultValue: '\u767B\u5F55\u67E5\u770B\u4EF7\u683C' });
        }

        //没登录+不允许游客查看价格
        if (GoodsPriceUtil.shouldToLogin(model, isLogin)) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DLCKJG', defaultValue: '\u767B\u5F55\u67E5\u770B\u4EF7\u683C' });
        }
        var price = isLogin ? model.client_price_ : model.client_price_;
        var price_String = FormatUtil.priceScaleNoChar(price);
        if (GoodsPriceUtil.isMorePrice(model, isLogin, promotionInfo)) {
            if (GoodsPriceUtil.getMiniPrice(model, isLogin, promotionInfo) === FormatUtil.priceScaleNoChar(GoodsPriceUtil.getMaxPrice(model, isLogin, promotionInfo))) {
                price_String = GoodsPriceUtil.getMiniPrice(model, isLogin, promotionInfo);
            } else {
                price_String = FormatUtil.priceScaleNoChar(GoodsPriceUtil.getMiniPrice(model, isLogin, promotionInfo)) + " - " + FormatUtil.priceScaleNoChar(GoodsPriceUtil.getMaxPrice(model, isLogin, promotionInfo));
            }
        }

        return price_String;
    },

    getMiniPrice: function getMiniPrice(model, isLogin, promotionInfo) {
        if (!model) {
            return;
        }
        var priceArr = [];
        for (var index = 0; index < model.productList.length; index++) {
            var element = model.productList[index];
            var promotion = promotionInfo && promotionInfo[element.id_];
            var tmpPrice = element.client_price_;
            if (promotion && !promotion.is_stair_) {
                if (promotion.price_) {
                    tmpPrice = promotion.price_;
                }
                if (promotion.cuted_percent_) {
                    tmpPrice = _mathUtils2.default.mul(promotion.cuted_percent_ / 100, element.client_price_);
                }
            }
            //过滤0
            if (tmpPrice > 0) {
                priceArr.push(tmpPrice);
            }
        }

        var price = Math.min.apply(null, priceArr);
        return _mathUtils2.default.mul(price, model.unitScale || 1);
    },

    getMaxPrice: function getMaxPrice(model, isLogin, promotionInfo) {
        if (!model) {
            return;
        }
        var priceArr = [];

        for (var index = 0; index < model.productList.length; index++) {
            var element = model.productList[index];
            var promotion = promotionInfo && promotionInfo[element.id_];
            var tmpPrice = element.client_price_;
            if (promotion && !promotion.is_stair_) {
                if (promotion.price_) {
                    tmpPrice = promotion.price_;
                }
                if (promotion.cuted_percent_) {
                    tmpPrice = _mathUtils2.default.mul(promotion.cuted_percent_ / 100, element.client_price_);
                }
            }

            if (tmpPrice > 0) {
                priceArr.push(tmpPrice);
            }
        }
        var price = Math.max.apply(null, priceArr);
        return price * (model.unitScale || 1);
    },

    isMorePrice: function isMorePrice(model, isLogin, promotionInfo) {
        var isMorePrice = false;

        if (!model || !model.productList || model.productList.length == 1) {
            return isMorePrice;
        }

        var price = model.client_price_;
        for (var index = 0; index < model.productList.length; index++) {
            var element = model.productList[index];
            var promotion = promotionInfo && promotionInfo[element.id_];
            if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) !== 'object') return;
            if (!element) return;
            var tmpPrice = element.client_price_;
            if (promotion && !promotion.is_stair_) {
                if (promotion.price_) {
                    tmpPrice = promotion.price_;
                }
                if (promotion.cuted_percent_) {
                    tmpPrice = _mathUtils2.default.mul(promotion.cuted_percent_ / 100, element.client_price_);
                }
            }
            if (price != tmpPrice) {
                isMorePrice = true;
                break;
            }
        }
        return isMorePrice;
    },
    // 获取规格价格，用于购物车,订单
    getProductPrice: function getProductPrice(goods, product) {
        // 多单位指定价处理
        var _price = product.client_price_;
        if (goods.is_multi_unit_ && goods.unit_id_ !== (product.unitId || product.unit_id_)) {
            //unitId:加入购物车所选单位，spec.unit_id_：购物车订单列表规格所选单位
            (goods.multi_unit_.extend_units_ || []).map(function (unit, index) {
                if (unit.unit_id_ === (product.unitId || product.unit_id_)) {
                    switch (index) {
                        case 0:
                            _price = product.unit_price_ || _mathUtils2.default.mul(_price, unit.scale_ || 1);
                            break;
                        case 1:
                            _price = product.unit2_price_ || _mathUtils2.default.mul(_price, unit.scale_ || 1);
                            break;
                    }
                }
            });
        }
        return _price;
    },


    shouldToLogin: function shouldToLogin(model, isLogin) {
        if (!model) {
            return false;
        }
        if (!model.allow_client_price_ && !isLogin) {
            return true;
        }
        return false;
    }

};
var ColorUtil = {
    // 十六进制颜色转RGB
    colorRgb: function colorRgb(color, alpha) {
        var sColor = color.toLowerCase();
        // 十六进制颜色值的正则表达式
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        // 如果是16进制颜色
        if (sColor && reg.test(sColor)) {
            if (sColor.length === 4) {
                var sColorNew = "#";
                for (var i = 1; i < 4; i += 1) {
                    sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
                }
                sColor = sColorNew;
            }
            // 处理六位的颜色值
            var sColorChange = [];
            for (var _i = 1; _i < 7; _i += 2) {
                sColorChange.push(parseInt("0x" + sColor.slice(_i, _i + 2)));
            }
            if (typeof alpha === 'number') {
                sColorChange.push(alpha / 100);
                return "RGBA(" + sColorChange.join(",") + ")";
            }
            return "RGB(" + sColorChange.join(",") + ")";
        }
        return sColor;
    },
    getBackgroundColor: function getBackgroundColor(theme, alpha, gradual) {
        var rgbaAlpha = ColorUtil.colorRgb('#' + theme, alpha || '60');
        var rgba = ColorUtil.colorRgb('#' + theme, '100');
        return {
            // background: `linear-gradient(180deg,${rgbaAlpha} 0%, ${rgba}${gradual || 68}%, ${rgba}100%)`, // fix:YSDH-14560
            background: rgba
        };
    }
};

exports.default = Util;
exports.FormatUtil = FormatUtil;
exports.CheckUtil = _checkUtil2.default;
exports.NumberUtil = NumberUtil;
exports.GoodsPriceUtil = GoodsPriceUtil;
exports.ColorUtil = ColorUtil;

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = closest;
function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    var p = el;
    while (p) {
        if (matchesSelector.call(p, selector)) {
            return p;
        }
        p = p.parentElement;
    }
    return null;
}
module.exports = exports["default"];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Samj on 2017/7/21.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


//容器控件

var DialogContainer = function DialogContainer(Component) {
    return function (_React$Component) {
        _inherits(_class, _React$Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.state = {
                show: true
            };
            return _this;
        }

        _createClass(_class, [{
            key: 'dismiss',
            value: function dismiss() {
                var _this2 = this;

                this.setState({
                    show: false
                }, function () {
                    _this2.props.dispose();
                });
            }
        }, {
            key: 'cancel',
            value: function cancel(value) {
                var _this3 = this;

                this.setState({
                    show: false
                }, function () {
                    _this3.props.reject(value);
                });
            }
        }, {
            key: 'confirm',
            value: function confirm(value) {
                var _this4 = this;

                this.setState({
                    show: false
                }, function () {
                    _this4.props.resolve(value);
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, _extends({ confirm: this.confirm.bind(this), cancel: this.cancel.bind(this), dismiss: this.dismiss.bind(this), show: this.state.show }, this.props));
            }
        }]);

        return _class;
    }(_react2.default.Component);
};

exports.default = DialogContainer;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(389);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(388);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 154 */,
/* 155 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(98);
var dPs = __webpack_require__(410);
var enumBugKeys = __webpack_require__(156);
var IE_PROTO = __webpack_require__(161)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(245)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(404).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(62).f;
var has = __webpack_require__(61);
var TAG = __webpack_require__(82)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(162)('keys');
var uid = __webpack_require__(122);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(54);
var global = __webpack_require__(56);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(118) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(155);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(80);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(56);
var core = __webpack_require__(54);
var LIBRARY = __webpack_require__(118);
var wksExt = __webpack_require__(167);
var defineProperty = __webpack_require__(62).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(82);


/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _urlConfig = __webpack_require__(77);

var _urlConfig2 = _interopRequireDefault(_urlConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UA = localStorage.getItem('wkData-webUA') || window.navigator.userAgent;
var CheckUtil = {
    //检查账号
    isAccount: function isAccount() {
        return (/^([a-zA-Z0-9]|[@._]){6,20}$/.test(v)
        );
    },

    //检查密码
    isPassword: function isPassword(v) {
        return (/^([a-zA-Z0-9]|[@._]){6,20}$/.test(v)
        );
    },

    //是否数字
    isNumber: function isNumber(value) {
        return !isNaN(value);
    },
    //是否两位小数
    isTwoDecNumber: function isTwoDecNumber(v) {
        return (/^\d{0,8}\.{0,1}(\d{1,2})?$/.test(v)
        );
    },

    //是否Emoji表情
    hasEmoji: function hasEmoji(v) {
        return (/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|\uD83C[\uDC00-\uDFFF]/g.test(v)
        );
    },

    //保留两位小数
    twoDecNumber: function twoDecNumber(num) {
        num = num.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        num = num.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        num = num.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        if (num.indexOf(".") < 0 && num != "") {
            //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            num = parseFloat(num);
        }
        if (num === '.') {
            num = 0;
        }
        return num;
    },

    //检查体验企业
    isExperience: function isExperience(companyId) {
        var experienceCompanyIds = [118, 729, 724, 121, 128, 117, 124, 116, 119, 122, 123, 725];
        var isExperience = false;
        experienceCompanyIds.forEach(function (item) {
            if (item == companyId) {
                isExperience = true;
            }
        });
        return isExperience;
    },
    //是否对象
    isObject: function isObject(obj) {
        return obj !== null && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object';
    },
    //是否空对象
    isEmptyObject: function isEmptyObject(obj) {
        for (var key in obj) {
            return false;
        }
        return true;
    },
    //是否数组
    isArray: function isArray(obj) {
        return Array.isArray(obj);
    },
    //是否是空
    isNull: function isNull(arg) {
        return !arg && arg !== 0 && typeof arg !== 'undefined';
    },
    //检查是否空
    isUndefind: function isUndefind(v) {
        return v == undefined;
    },
    //验证手机
    isPhone: function isPhone(phone) {
        if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
            return false;
        } else {
            return true;
        }
    },

    //校验url格式
    isUrl: function isUrl(v) {
        return (/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(v)
        );
    },
    //校验邮箱格式
    isEmail: function isEmail(v) {
        return (/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(v)
        );
    },

    isEqualObj: function isEqualObj(objA, objB) {
        if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== 'object' || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== 'object' || objB === null) {
            return false;
        }
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
            return false;
        }
        for (var key in objA) {
            if (objA[key] !== objB[key]) {
                return false;
            }
        }
        return true;
    },
    //是否安卓
    isAndroid: UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1 || UA.indexOf('android') > -1,
    //是否IOS
    isIos: UA.indexOf('iphone') > -1 || UA.indexOf('mac') > -1 || UA.indexOf('iPhone') > -1,
    //是否手机
    isMobile: UA.match(/(iPhone|iPod|Android|ios)/i),
    //是否微信
    isWeiXin: /micromessenger/.test(UA.toLowerCase()),
    isSafari: UA.indexOf("Safari") > -1 && UA.indexOf("Chrome") < 0,
    //是否小程序
    isMiniProgram: window.__wxjs_environment == 'miniprogram',
    //是否第二正式环境
    isSecondUrl: window.location.href.indexOf("am." + _urlConfig2.default.getHost() + ".com") > -1,
    //是否第三正式环境
    isThirdUrl: window.location.href.indexOf("bm." + _urlConfig2.default.getHost() + ".com") > -1

};

exports.default = CheckUtil;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MathUtil = {
    uuid: function uuid(len, radix) {
        var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var chars = CHARS,
            uuid = [];
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (var i = 0; i < len; i++) {
                uuid[i] = chars[0 | Math.random() * radix];
            }
        } else {
            // rfc4122, version 4 form
            var r = void 0;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (var _i = 0; _i < 36; _i++) {
                if (!uuid[_i]) {
                    r = 0 | Math.random() * 16;
                    uuid[_i] = chars[_i === 19 ? r & 0x3 | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    },

    //除法
    div: function div(arg1, arg2) {
        return +(arg1 / arg2).toFixed(4);
    },

    // 乘法
    mul: function mul(arg1, arg2) {
        // 乘法运算
        if (!arg1) {
            arg1 = 0;
        }
        if (!arg2) {
            arg2 = 0;
        }
        var m = 0,
            s1 = arg1.toString(),
            s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        } catch (e) {}
        try {
            m += s2.split(".")[1].length;
        } catch (e) {}
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },

    // 加法
    plus: function plus(arg1, arg2) {
        // 加法运算
        var r1 = void 0,
            r2 = void 0,
            m = void 0;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return (this.mul(arg1, m) + this.mul(arg2, m)) / m;
    },

    // 减法
    minus: function minus(arg1, arg2) {
        // 减法运算
        var r1 = void 0,
            r2 = void 0,
            m = void 0,
            n = void 0;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        // 动态控制精度长度
        n = r1 >= r2 ? r1 : r2;
        return +((this.mul(arg1, m) - this.mul(arg2, m)) / m).toFixed(n);
    }
};
exports.default = MathUtil;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(639);

__webpack_require__(637);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(627),
      utf8 = __webpack_require__(241).utf8,
      isBuffer = __webpack_require__(680),
      bin = __webpack_require__(241).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeviceType = exports.PageType = exports.BehaviorEventType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * YunShl Behavior Tracker SDK
                                                                                                                                                                                                                                                                   * 行为追踪SDK - 用于商城前端埋点
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * 功能：
                                                                                                                                                                                                                                                                   * 1. 商品浏览追踪
                                                                                                                                                                                                                                                                   * 2. 搜索热词追踪
                                                                                                                                                                                                                                                                   * 3. 加购行为追踪
                                                                                                                                                                                                                                                                   * 4. 页面停留时长计算
                                                                                                                                                                                                                                                                   * 5. 批量上报功能
                                                                                                                                                                                                                                                                   */

var _storageUtil = __webpack_require__(50);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

var _constant = __webpack_require__(51);

var _appUtil = __webpack_require__(96);

var _appUtil2 = _interopRequireDefault(_appUtil);

var _urlConfig = __webpack_require__(77);

var _urlConfig2 = _interopRequireDefault(_urlConfig);

var _commonUtils = __webpack_require__(111);

var _md = __webpack_require__(226);

var _md2 = _interopRequireDefault(_md);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reqKey = "yunshang";
var API = _urlConfig2.default.getAPI();

// 事件类型常量
var BehaviorEventType = exports.BehaviorEventType = {
    GOODS_VIEW: 'goods_view', // 商品浏览
    PAGE_VIEW: 'page_view', // 页面浏览
    PAGE_STAY: 'page_stay', // 页面停留
    SEARCH: 'search', // 搜索
    ADD_TO_CART: 'add_to_cart', // 加购
    CART_MODIFY: 'cart_modify', // 购物车修改
    CART_DELETE: 'cart_delete', // 购物车删除
    ORDER_CREATE: 'order_create', // 下单
    GOODS_FAVORITE: 'goods_favorite' // 收藏
};

// 页面类型常量
var PageType = exports.PageType = {
    HOME: 1, // 首页
    CATEGORY: 2, // 分类页
    GOODS_DETAIL: 3, // 商品详情
    SEARCH_RESULT: 4 // 搜索结果
};

// 设备类型常量
var DeviceType = exports.DeviceType = {
    APP: 1,
    PC: 2,
    H5: 3,
    MINI_PROGRAM: 4
};

/**
 * YunShlTracker - 行为追踪SDK
 */
var YunShlTracker = {
    // 配置
    config: {
        apiUrl: '', // 上报API地址
        batchSize: 10, // 批量上报数量阈值
        flushInterval: 5000, // 上报间隔(ms)
        sessionTimeout: 30 * 60 * 1000, // 会话超时30分钟
        enabled: true, // 是否启用
        autoFlush: true // 是否自动上报（设为false可手动控制）
    },

    // 状态
    state: {
        sessionId: null, // 会话ID
        deviceId: null, // 设备ID
        userId: null, // 用户ID
        clientId: null, // 客户ID
        companyId: null, // 企业ID
        queue: [], // 待上报事件队列
        pageEnterTime: null, // 页面进入时间
        currentPage: null, // 当前页面信息
        flushTimer: null, // 上报定时器
        authFailed: false, // 认证失败标记(401时停止上报)
        networkFailCount: 0, // 网络失败计数
        maxNetworkFailCount: 3 // 最大网络失败次数
    },

    /**
     * 初始化SDK
     * @param {Object} options - 配置选项
     * @param {string} options.apiUrl - API地址
     * @param {number} options.batchSize - 批量上报数量
     * @param {number} options.flushInterval - 上报间隔
     * @param {boolean} options.enabled - 是否启用
     */
    init: function init() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.config = _extends({}, this.config, options);
        this.config.apiUrl = this.config.apiUrl || API + '/v1/shop/behavior';

        // 生成/恢复会话ID
        this._initSession();

        // 生成/恢复设备ID
        this._initDeviceId();

        // 获取用户信息
        this._loadUserInfo();

        // 绑定页面事件
        this._bindPageEvents();

        // 启动定时上报
        this._startFlushTimer();

        console.log('[YunShlTracker] initialized', {
            sessionId: this.state.sessionId,
            deviceId: this.state.deviceId,
            enabled: this.config.enabled
        });
    },


    /**
     * 设置用户信息（登录后调用）
     * @param {number} userId - 用户ID
     * @param {number} clientId - 客户ID
     * @param {number} companyId - 企业ID
     */
    setUser: function setUser(userId, clientId, companyId) {
        this.state.userId = userId;
        this.state.clientId = clientId;
        this.state.companyId = companyId;

        // 登录后重置认证失败状态并恢复上报
        if (this.state.authFailed || this.state.networkFailCount >= this.state.maxNetworkFailCount) {
            this.state.authFailed = false;
            this.state.networkFailCount = 0;
            this._startFlushTimer();
            console.log('[YunShlTracker] auth restored, resume tracking');
        }
    },


    /**
     * 追踪事件
     * @param {string} eventType - 事件类型
     * @param {Object} eventData - 事件数据
     */
    track: function track(eventType) {
        var eventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!this.config.enabled) return;

        // 动态获取最新的用户信息
        this._loadUserInfo();

        var event = {
            event_type: eventType,
            event_data: eventData,
            session_id: this.state.sessionId,
            device_id: this.state.deviceId,
            user_id: this.state.userId,
            client_id: this.state.clientId,
            company_id: this.state.companyId,
            device_type: this._getDeviceType(),
            timestamp: Date.now()
        };
        this.state.queue.push(event);

        // 达到批量数量立即上报
        if (this.state.queue.length >= this.config.batchSize) {
            this._flush();
        }
    },


    /**
     * 追踪商品浏览
     * @param {number} goodsId - 商品ID
     * @param {number} categoryId - 分类ID
     * @param {number} stayDuration - 停留时长(秒)
     */
    trackGoodsView: function trackGoodsView(goodsId, categoryId) {
        var stayDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        this.track(BehaviorEventType.GOODS_VIEW, {
            goods_id: goodsId,
            category_id: categoryId,
            page_type: PageType.GOODS_DETAIL,
            stay_duration: stayDuration
        });
    },


    /**
     * 追踪搜索
     * @param {string} keywords - 搜索关键词
     * @param {number} resultCount - 结果数量
     * @param {number} searchType - 搜索类型(1:关键词 2:VIN 3:车型)
     */
    trackSearch: function trackSearch(keywords, resultCount) {
        var searchType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

        this.track(BehaviorEventType.SEARCH, {
            keywords: keywords,
            result_count: resultCount,
            search_type: searchType
        });
    },


    /**
     * 追踪搜索点击
     * @param {string} keywords - 搜索关键词
     * @param {number} searchType - 搜索类型(1:关键词 2:VIN 3:车型)
     */
    trackSearchClick: function trackSearchClick(keywords) {
        var searchType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        this.track(BehaviorEventType.SEARCH, {
            keywords: keywords,
            search_type: searchType,
            has_click: 1
        });
    },


    /**
     * 追踪加购
     * @param {number} goodsId - 商品ID
     * @param {number} productId - 规格ID
     * @param {number} number - 数量
     * @param {number} price - 价格
     */
    trackAddToCart: function trackAddToCart(goodsId, productId, number, price) {
        this.track(BehaviorEventType.ADD_TO_CART, {
            goods_id: goodsId,
            product_id: productId,
            new_number: number,
            price: price,
            action_type: 1
        });
    },


    /**
     * 追踪购物车修改
     * @param {number} goodsId - 商品ID
     * @param {number} productId - 规格ID
     * @param {number} oldNumber - 原数量
     * @param {number} newNumber - 新数量
     * @param {number} price - 价格
     */
    trackCartModify: function trackCartModify(goodsId, productId, oldNumber, newNumber, price) {
        this.track(BehaviorEventType.CART_MODIFY, {
            goods_id: goodsId,
            product_id: productId,
            old_number: oldNumber,
            new_number: newNumber,
            price: price,
            action_type: 2
        });
    },


    /**
     * 追踪购物车删除
     * @param {number} goodsId - 商品ID
     * @param {number} productId - 规格ID
     * @param {number} number - 删除数量
     */
    trackCartDelete: function trackCartDelete(goodsId, productId, number) {
        this.track(BehaviorEventType.CART_DELETE, {
            goods_id: goodsId,
            product_id: productId,
            number: number,
            action_type: 3
        });
    },


    /**
     * 追踪下单
     * @param {number} orderId - 订单ID
     * @param {number} amount - 订单金额
     */
    trackOrderCreate: function trackOrderCreate(orderId, amount) {
        this.track(BehaviorEventType.ORDER_CREATE, {
            order_id: orderId,
            amount: amount
        });
    },


    /**
     * 追踪收藏
     * @param {number} goodsId - 商品ID
     * @param {boolean} isFavorite - 是否收藏
     */
    trackGoodsFavorite: function trackGoodsFavorite(goodsId) {
        this.track(BehaviorEventType.GOODS_FAVORITE, {
            goods_id: goodsId
        });
    },


    /**
     * 追踪页面浏览
     * @param {number} pageType - 页面类型
     * @param {string} pageUrl - 页面URL
     */
    trackPageView: function trackPageView(pageType, pageUrl) {
        this.track(BehaviorEventType.PAGE_VIEW, {
            page_type: pageType,
            page_url: pageUrl || window.location.pathname,
            referrer: document.referrer
        });
    },


    /**
     * 追踪页面停留时长
     * @param {number} pageType - 页面类型
     * @param {number} stayDuration - 停留时长(秒)
     */
    trackPageStay: function trackPageStay(pageType, stayDuration) {
        this.track(BehaviorEventType.PAGE_STAY, {
            page_type: pageType,
            stay_duration: stayDuration
        });
    },


    /**
     * 手动上报
     */
    flush: function flush() {
        this._flush();
    },


    /**
     * 设置启用状态
     * @param {boolean} enabled - 是否启用
     */
    setEnabled: function setEnabled(enabled) {
        this.config.enabled = enabled;
    },


    // ==================== 私有方法 ====================

    /**
     * 初始化会话
     */
    _initSession: function _initSession() {
        var sessionKey = '__ys_sid';
        var lastSessionTime = localStorage.getItem('__ys_sid_time');
        var now = Date.now();

        // 检查会话是否超时
        if (lastSessionTime && now - parseInt(lastSessionTime) < this.config.sessionTimeout) {
            this.state.sessionId = localStorage.getItem(sessionKey);
        }

        // 创建新会话
        if (!this.state.sessionId) {
            this.state.sessionId = this._generateId();
            localStorage.setItem(sessionKey, this.state.sessionId);
        }

        localStorage.setItem('__ys_sid_time', now.toString());
    },


    /**
     * 初始化设备ID
     */
    _initDeviceId: function _initDeviceId() {
        var deviceKey = '__ys_did';
        this.state.deviceId = localStorage.getItem(deviceKey) || this._generateId();
        localStorage.setItem(deviceKey, this.state.deviceId);
    },


    /**
     * 加载用户信息
     */
    _loadUserInfo: function _loadUserInfo() {
        var ysUser = _storageUtil2.default.getItem(_constant.SystemConst.mShop_user);
        if (ysUser) {
            this.state.userId = ysUser.id_;
            this.state.clientId = ysUser.client_id_;
            this.state.companyId = ysUser.company_id_;
        }
    },


    /**
     * 绑定页面事件
     */
    _bindPageEvents: function _bindPageEvents() {
        var self = this;

        // 页面可见性变化
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                self._recordPageStay();
            } else {
                self.state.pageEnterTime = Date.now();
            }
        });

        // 页面关闭前上报
        window.addEventListener('beforeunload', function () {
            self._recordPageStay();
            self._flush();
        });

        // 记录页面进入时间
        this.state.pageEnterTime = Date.now();
    },


    /**
     * 记录页面停留时长
     */
    _recordPageStay: function _recordPageStay() {
        if (this.state.pageEnterTime && this.state.currentPage) {
            var duration = Math.floor((Date.now() - this.state.pageEnterTime) / 1000);
            if (duration > 0) {
                this.trackPageStay(this.state.currentPage.pageType, duration);
            }
        }
    },


    /**
     * 启动定时上报
     */
    _startFlushTimer: function _startFlushTimer() {
        var _this = this;

        // 如果禁用自动上报，不启动定时器
        if (!this.config.autoFlush) return;

        if (this.state.flushTimer) {
            clearInterval(this.state.flushTimer);
        }
        this.state.flushTimer = setInterval(function () {
            _this._flush();
        }, this.config.flushInterval);
    },


    /**
     * 批量上报
     */
    _flush: function _flush() {
        // 认证失败或网络连续失败超过阈值时停止上报
        if (this.state.authFailed || this.state.networkFailCount >= this.state.maxNetworkFailCount) return;

        if (this.state.queue.length === 0) return;

        var events = this.state.queue.slice();
        this.state.queue = [];

        var data = {
            events: events,
            session_id: this.state.sessionId,
            device_id: this.state.deviceId,
            device_type: this._getDeviceType()
        };

        // 统一使用fetch上报，避免sendBeacon的CORS问题
        this._xhrFlush(data, events);
    },


    /**
     * XHR上报（降级方案）
     */
    _xhrFlush: function _xhrFlush(data, events) {
        var _this2 = this;

        var token = localStorage.getItem('token');
        var timestamp = _commonUtils.CommonUtil.getNonce();
        var nonce = _commonUtils.CommonUtil.getRandomParam();

        var headers = {
            'Content-Type': 'application/json;charset=utf-8',
            'yunshltoken': token ? JSON.parse(token) : '',
            'timestamp': timestamp,
            'nonce': nonce,
            'tokentype': _appUtil2.default.isApp ? 'APP' : this._isMobile() ? 'WEBAPP' : 'PC',
            'appsource': _appUtil2.default.isIos ? 'IOS' : _appUtil2.default.isAndroid ? 'ANDROID' : this._isMobile() ? 'WEBAPP' : 'PC'
        };

        // 签名
        var checkKey = reqKey + headers.yunshltoken + timestamp + nonce + JSON.stringify(data);
        headers.signnatrue = (0, _md2.default)(checkKey);

        fetch(this.config.apiUrl + '/track/batch', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        }).then(function (response) {
            if (response.ok) {
                console.log('[YunShlTracker] flush success, events:', events.length);
                // 上报成功，重置网络失败计数
                _this2.state.networkFailCount = 0;
            } else if (response.status === 401) {
                // 401认证失败，停止上报定时器，避免无限重试
                console.warn('[YunShlTracker] auth failed (401), stop tracking until login');
                _this2.state.authFailed = true;
                _this2.state.queue = []; // 清空队列，避免堆积
                if (_this2.state.flushTimer) {
                    clearInterval(_this2.state.flushTimer);
                    _this2.state.flushTimer = null;
                }
            } else {
                console.warn('[YunShlTracker] flush failed, status:', response.status);
                // 非401错误才恢复队列重试
                _this2.state.queue = events.concat(_this2.state.queue);
            }
        }).catch(function (err) {
            console.warn('[YunShlTracker] flush error:', err);
            // 网络错误时恢复队列并计数
            _this2.state.queue = events.concat(_this2.state.queue);
            _this2.state.networkFailCount++;
            // 连续失败超过阈值，停止上报
            if (_this2.state.networkFailCount >= _this2.state.maxNetworkFailCount) {
                console.warn('[YunShlTracker] network failed 3 times, stop tracking');
                if (_this2.state.flushTimer) {
                    clearInterval(_this2.state.flushTimer);
                    _this2.state.flushTimer = null;
                }
            }
        });
    },


    /**
     * 生成UUID
     */
    _generateId: function _generateId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
    },


    /**
     * 获取设备类型
     */
    _getDeviceType: function _getDeviceType() {
        var ua = navigator.userAgent;
        if (/miniProgram/i.test(ua)) return DeviceType.MINI_PROGRAM;
        if (_appUtil2.default.isApp) return DeviceType.APP;
        if (this._isMobile()) return DeviceType.H5;
        return DeviceType.PC;
    },


    /**
     * 判断是否移动端
     */
    _isMobile: function _isMobile() {
        return navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
    },


    /**
     * 获取页面类型
     */
    _getPageType: function _getPageType() {
        var path = window.location.pathname;
        if (/\/GoodsDetail/.test(path)) return PageType.GOODS_DETAIL;
        if (/\/GoodsSearchResult/.test(path)) return PageType.SEARCH_RESULT;
        if (/\/GoodsList|GoodsClassify/.test(path)) return PageType.CATEGORY;
        if (path === '/' || /\/ShopHome/.test(path)) return PageType.HOME;
        return 0;
    }
};

// 挂载到全局window对象，便于调试
if (typeof window !== 'undefined') {
    window.YunShlTracker = YunShlTracker;
}

exports.default = YunShlTracker;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shareMiniProgram = exports.wxScanQRCode = exports.pageShare = exports.goodsShare = exports.loadWxConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _weixinJsSdk = __webpack_require__(366);

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

var _routeFetch = __webpack_require__(94);

var _storageUtil = __webpack_require__(50);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

var _constant = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sha1 = __webpack_require__(683);

var ua = (localStorage.getItem('wkData-webUA') || window.navigator.userAgent).toLowerCase();

// 最好在在 router 的全局钩子里调用这个方法，每次页面的 URL 发生变化时，都需要重新获取微信分享参数
// 如果你的 router 使用的是 hash 形式，应该不用每次都重新获取微信分享参数
var loadWxConfig = function loadWxConfig() {
    //如果不是在微信
    if (ua.indexOf('micromessenger') < 0) return false;

    function buildSignature(noncestr, timestamp, ticket) {
        var url = location.href.split('#')[0];
        console.log('noncestr', noncestr);
        console.log('timestamp', timestamp);
        console.log('ticket', ticket);
        console.log('url', url);
        return sha1('jsapi_ticket=' + ticket + '&noncestr=' + noncestr + '&timestamp=' + timestamp + '&url=' + url);
    }

    var noncestr = Math.random().toString(32).substr(2);
    var timestamp = parseInt(new Date().getTime() / 1000);
    _routeFetch.System.getWxTicket({}, function (rs) {
        // console.log('rs', rs);
        if (rs.status === 1 && rs.data) {
            //生成微信加密
            _weixinJsSdk2.default.config({
                debug: false,
                appId: rs.data.appId,
                timestamp: timestamp,
                nonceStr: noncestr,
                signature: buildSignature(noncestr, timestamp, rs.data.ticket),
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'scanQRCode', 'updateAppMessageShareData', 'updateTimelineShareData'],
                openTagList: ['wx-open-launch-weapp']
            });
        }
    });
};

//分享商品详情重写
var goodsShare = function goodsShare(data) {
    if (ua.indexOf('android') > -1) {
        loadWxConfig();
    }

    setTimeout(function () {
        var user = _storageUtil2.default.getItem(_constant.SystemConst.mShop_user);
        var search = location.search;
        if (user) {
            search += '&c=' + user.client_id_;
        }
        var url_ = location.origin + location.pathname + search;
        var shareData = {
            title: data.name_,
            desc: _storageUtil2.default.getItem(_constant.SystemConst.companyName) + '\u6709\u4E00\u4E2A\u4E0D\u9519\u7684\u5546\u54C1\uFF0C\u5FEB\u6765\u770B\u4E00\u4E0B',
            imgUrl: data.main_img_ || _constant.SystemConst.shareDefaultLogo,
            link: url_
        };

        _weixinJsSdk2.default.ready(function (res) {
            // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
            _weixinJsSdk2.default.onMenuShareTimeline(_extends({}, shareData, {
                success: function success(res) {
                    console.log('success');
                }
            }));
            // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
            _weixinJsSdk2.default.onMenuShareAppMessage(_extends({}, shareData, {
                success: function success(res) {
                    console.log('success');
                }
            }));
            _weixinJsSdk2.default.onMenuShareQQ(_extends({}, shareData, {
                success: function success() {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function cancel() {
                    // 用户取消分享后执行的回调函数
                }
            }));
        });
    }, 1500);
};

//分享企业信息+当前url
var pageShare = function pageShare() {
    if (ua.indexOf('android') > -1) {
        loadWxConfig();
    }
    setTimeout(function () {
        var shopSetting = _storageUtil2.default.getItem(_constant.SystemConst.shopSetting) || {};
        var url_ = location.href;
        var shareData = {
            title: _storageUtil2.default.getItem(_constant.SystemConst.companyName),
            desc: shopSetting.share_introduce_ || '暂未设置',
            imgUrl: shopSetting.share_logo_ || _constant.SystemConst.shareDefaultLogo,
            link: url_
        };
        _weixinJsSdk2.default.ready(function (res) {
            // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
            _weixinJsSdk2.default.onMenuShareTimeline(_extends({}, shareData, {
                success: function success(res) {
                    console.log('success');
                }
            }));
            // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
            _weixinJsSdk2.default.onMenuShareAppMessage(_extends({}, shareData, {
                success: function success(res) {
                    console.log('success');
                }
            }));
            _weixinJsSdk2.default.onMenuShareQQ(_extends({}, shareData, {
                success: function success() {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function cancel() {
                    // 用户取消分享后执行的回调函数
                }
            }));
        });
    }, 1500);
};

// 微信扫一扫
var wxScanQRCode = function wxScanQRCode(callback) {
    _weixinJsSdk2.default.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function success(res) {
            var result = res.resultStr.split(","); // 当needResult 为 1 时，扫码返回的结果
            // alert("扫描结果：" + result);
            callback && callback(result[result.length - 1]);
        }

    });
    _weixinJsSdk2.default.error(function (res) {
        alert(JSON.stringify(res));
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });
};

// 分享小程序卡片（砍一刀专用）
var shareMiniProgram = function shareMiniProgram(data) {
    if (ua.indexOf('android') > -1) {
        loadWxConfig();
    }
    setTimeout(function () {
        _weixinJsSdk2.default.ready(function () {
            // 使用新接口更新分享内容
            _weixinJsSdk2.default.updateAppMessageShareData({
                title: data.title || '帮我砍一刀',
                desc: data.desc || '帮忙砍个价，谢谢啦！',
                link: data.link, // 小程序URL Link或H5链接
                imgUrl: data.imgUrl || _constant.SystemConst.shareDefaultLogo,
                success: function success() {
                    console.log('分享配置成功');
                    data.success && data.success();
                },
                fail: function fail(err) {
                    console.log('分享配置失败', err);
                    data.fail && data.fail(err);
                }
            });
        });
    }, 1500);
};

exports.loadWxConfig = loadWxConfig;
exports.goodsShare = goodsShare;
exports.pageShare = pageShare;
exports.wxScanQRCode = wxScanQRCode;
exports.shareMiniProgram = shareMiniProgram;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// ar_SA.js
var ar_SA = {
    "GuanShui": "‌رسوم جمركية‌",
    "ZiZhangHao": "حساب فرعي",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",
    //components
    "ShangeChuanYanZhengTuPian": "تحميل صورة التحقق",
    "ChuanHaoYanZheng": "تحقق من الرقم التسلسلي",
    "YanZhengChuanHao": "تحقق من الرقم التسلسلي",
    "Ci": "مرّة",
    "DingDanMan": "الطلب يصل إلى",
    "YuanZeng": "يوم تặng",
    "SCFJ_ZD4Z_DZBCG": "تحميل المرفقات، максимум 4 صور، لا تتجاوز كل صورة 3 ميجابايت",
    //ChatRoom
    "ZBZCBQFH": "لا يدعم رموز الابتسامات مؤقتًا",
    "FaSongLianJie": "إرسال الرابط",
    "YiChangXiaoXi": "رسالة غير طبيعية",
    "QingShuRu": "يرجى الإدخال",
    "FaSong": "إرسال",
    //DateSelector
    "DQSJXYKSSJ": "الوقت الحالي أقل من الوقت البدائي",
    "DQSJCGJSSJ": "الوقت الحالي يتجاوز الوقت النهائي",
    "QuXiao": "إلغاء",
    "NianYueRi": "سنة شهر يوم",
    "ShiFen": "ساعة دقيقة",
    "QueDing": "تأكيد",
    "Nian": "سنة",
    "Yue": "شهر",
    "Ri": "يوم",
    "Shi": "ساعة",
    "Fen": "دقيقة",
    //goods-list-card
    "Qi": "بدءًا من",
    //goods-promotion
    "1GeCuXiao": "{num} عرض ترويجي",
    "ChaKanZengPin": "عرض الهدايا",
    "JHDJSHS_1T": "باقي على انتهاء الحملة: {d} يوم {h} ساعة {m} دقيقة {s} ثانية",
    "YHGZ_ZPBKD": "قواعد الخصم: لا يمكن叠加 الحصول على الهدايا",
    "YHGZ_AZZGM": "قواعد الخصم: استمتع بالخصم حسب كمية الشراء النهائية",
    "GuanBi": "إغلاق",
    "Man1Song1": 'يصل إلى {mai} يقدم {song}',
    //group-filtrate
    "QuanBu": "الكل",
    "ZWXGSJ": "لا توجد بيانات ذات صلة",
    "ZuiDiJia": "أقل سعر",
    "ZuiGaoJia": "أعلى سعر",
    "LeiXing": "النوع",
    "PinPai": "العلامة التجارية",
    "BiaoQian": "الوسم",
    "JiaGeQuJian": "نطاق السعر",
    "SPMC_GG_BH_": "اسم المنتج / المواصفات / الرقم التسلسلي / الحرف الأول",
    "SPMC_GG_BH_G": "اسم المنتج / المواصفات / الرقم التسلسلي",
    "ZuHeShaiXuan": "تصفية المجموعة",
    "ChongZhi_CanShu": "إعادة تعيين",
    //image-upload
    "ZDKSC1ZTP": "يمكن تحميل صورة واحدة كحد أقصى",
    "ZYXSCTP": "يسمح فقط بتحميل الصور",
    "SCTPDXBYXC": "حجم الصورة المحملة لا يسمح أن يتجاوز 5 ميجابايت",
    "QBYCFSCTP_": "يرجى عدم تحميل الصورة مرة أخرى، أو يرجى التأكد من أن اسم الصورة فريد",
    "ShangChuanChengGong": "التحميل ناجح",
    "ZDKSC1Z": "يمكن تحميل واحد كحد أقصى",
    //keyboard
    "CCSLZDXZ": "يتجاوز الحد الأقصى لعدد",
    "QiDingLiang": "كمية البدء",
    "ShouQi": "اختباء",
    "ShanChu": "حذف",
    //MultiPicker
    "FanHui": "رجوع",
    //order-cart
    "Dai": "في انتظار",
    "YiQuXiao": "ملغى",
    "ZengPin": "هدية",
    "1Zhong": "{num} نوع",
    "1Jian": "{num} قطعة",
    "HeJi": "إجمالي",
    "DaiFu": "في انتظار الدفع",
    //order-promotion
    "_DDM1YZ1J_": "【الطلب يصل إلى {target} يورو يقدم {name} {number} قطعة】",
    "_DDM1YLJ1Y_": "【الطلب يصل إلى {m} يورو يخفض بـ {n} يورو】",
    "_DDM1YLX1Z_": "【الطلب يصل إلى {m} يورو يحصل على {n} نقطة】",
    "DingDanCuXiao": "العروض الترويجية للطلب",
    //page-ad
    "DLCKJG": "تسجيل الدخول لعرض السعر",
    //page-floating
    "DianPuZhuYe": "الصفحة الرئيسية المتجر",
    "GouWuChe": "عربة التسوق",
    "ZaiXianKeFu": "الدعم الفني عبر الإنترنت",
    "GeRenZhongXin": "المركز الشخصي",
    "LianXiDianHua": "رقم الاتصال",
    "FanHuiDingBu": "العودة إلى الأعلى",
    //page-null
    "ZBDYML": "لا يمكن العثور على الصفحة",
    "KNWZCW_HZY": "قد يكون عنوان URL خاطئًا، أو تم حذف الصفحة",
    "FanHuiShangJi": "العودة إلى المستوى العلوي",
    "FanHuiShouYe": "العودة إلى الصفحة الرئيسية",
    //product-edit
    "SPQDBNWK": "قائمة المنتجات لا يمكن أن تكون فارغة",
    "WoZhiDaoLe": "أعرف ذلك",
    "SFQRSCSP": "هل تريد بالتأكيد حذف المنتج",
    "QueRen": "تأكيد",
    "ZYXSRSZBQB": "يسمح فقط بإدخال الأرقام ولا تتجاوز 2 أرقام بعد العلامة العشرية",
    "ShangPinDanJia": "سعر الوحدة المنتج",
    "YSPYJ": "سعر المنتج الأصلي الأصلي",
    "QSRZDJG": "يرجى إدخال السعر المحدد",
    "ShuLiang": "الكمية",
    "DanWei": "الوحدة",
    "DanJia": "سعر الوحدة",
    "BeiZhu": "ملاحظة",
    "YiChuShangPin": "إزالة المنتج",
    "XiuGai": "تعديل",
    //yunshl
    "TPSLCCYXSZ": "عدد الصور يتجاوز القيمة المسموح بها!",
    "WJBDDY5M_QC": "لا يجوز أن يكون الحجم الكبير من الملف 5 ميجابايت، يرجى الاختيار مرة أخرى",
    "TPSCWC": "اكتمل تحميل الصورة",
    //BusinessFilter
    "_DGSLM1Z1_": "【كمية الطلب تصل إلى {target} تقدم {provide}】",
    "_M1JLXMJ1Y_": "【يصل إلى {target} يحصل على كل {cut_money_}】",
    "_DHJJZ1Y_": "【سعر الطلب يقل إلى {cuted_price_} يورو】",
    "_M1JLXMJ1Z_": "【يصل إلى {target} يحصل على كل {cut_percent_} نقطة】",
    "_YDHJD1Z_": "【سعر الطلب الأصلي يخصم بـ {cuted_percent_} نقطة】",
    "YuJiKaiShiFaHuo": "متوقع {date} بدء الشحن",
    "YuJi": "متوقع",
    "MMYDDR": "اليوم DD من شهر MM",
    "KaiShiFaHuo": "بدء الشحن",
    "_M1LXM1Y_": "【يصل إلى 1 يحصل على كل 1 يورو】",
    "_M1LXM1Z_": "【يصل إلى 1 يحصل على كل 1 نقطة】",
    "DaiQueRen": "في انتظار التأكيد",
    "DaiFaHuo": "في انتظار الشحن",
    "DaiShouHuo": "في انتظار الاستلام",
    "YiWanCheng": "مكتمل",
    "DaiFuKuan": "في انتظار الدفع",
    "YiFuKuan": "مدفوع",
    "YiZuoFei": "ملغى",
    "DaiShenHe": "في انتظار المراجعة",
    "DaiHeXiao": "في انتظار التحقق",
    "YiHeXiao": "تم التحقق",
    "XianXiaZhiFu": "الدفع офлайн",
    "ZhiNengDaoZhangShiBie": "التحويلات البنكية офлайн (التعرف الذكي على الوصول الأموال)",
    "WeiXinZhiFu": "الدفع عبر ويixin",
    "KQ-WeiXinZhiFu": "KQ (ويixin)",
    "KQ-ZFBZF": "KQ (الدفع عبر Али باي)",
    "KQZhiFu": "الدفع عبر KQ",
    "ZFBZF": "الدفع عبر Али باي",
    "YuEZhiFu": "الدفع من الرصيد",
    "HuoDaoFuKuan": "الدفع عند الاستلام",
    "DaiTuiHuo": "في انتظار الإرجاع",
    "DaiTuiKuan": "في انتظار الاسترجاع",
    "ChuangJianDingDan": "إنشاء طلب",
    "BianJiDingDan": "تعديل الطلب",
    "TiJiaoDingDan": "إرسال الطلب",
    "DingDanShenHe": "مراجعة الطلب",
    "CaiWuShenHe": "مراجعة المالية",
    "BoHui": "رفض",
    "TianJiaShouKuan": "إضافة تحصيل",
    "ZaiXianZhiFu": "الدفع عبر الإنترنت",
    "ShouKuanShenHe": "مراجعة التحصيل",
    "ShouKuanZuoFei": "ملغى التحصيل",
    "ChuKu": "الخروج من المخزن",
    "ChuKuShenHe": "مراجعة الخروج من المخزن",
    "FaHuo": "الشحن",
    "TianJiaWuLiu": "إضافة الشحن",
    "XiuGaiWuLiu": "تعديل الشحن",
    "ChuKuZuoFei": "ملغى الخروج من المخزن",
    "ShouHuo": "الاستلام",
    "DingDanHeZhun": "الموافقة على الطلب",
    "QuXiaoDingDan": "إلغاء الطلب",
    "CJTHD": "إنشاء طلب الإرجاع",
    "DaYin": "طباعة",
    "DaoChu": "تصدير",
    "DingDanWanCheng": "الطلب مكتمل ",
    "QiangZhiWanCheng": "إكمال قسري",
    "DingDanZuoFei": "ملغى الطلب",
    "MaiZeng": "شراء وتقديم",
    "ZhiJiang": "انخفاض مباشر",
    "DaZhe": "خصم",
    "YuShou": "الاست预订",
    "DingDanManZeng": "الطلب يصل إلى تقديم",
    "DingDanManJian": "الطلب يصل إلى تخفيض",
    "DingDanManZhe": "الطلب يصل إلى خصم",
    "XinRenQuan": "قسيمة الأعضاء الجدد",
    "ManJianQuan": "قسيمة التخفيض عند الوصول",
    "ShangPinQuan": "قسيمة المنتج",
    "DaiJieSuan": "في انتظار التسوية",
    "YiJieSuan": "تم التسوية",
    "QuanBuShangPin": "جميع المنتجات",
    "TuiJianShangPin": "المنتجات الموصى بها",
    "XinPin": "منتجات جديدة",
    "ReXiaoShangPin": "المنتجات הנ�قلة",
    "ChangYongShangPin": "المنتجات الشائعة الاستخدام",
    //BusinessUtil
    "DaiShouKuan": "في انتظار التحصيل",
    "BuFenShouKuan": "تحصيل جزئي",
    "YiShouKuan": "تم التحصيل",
    "BXYFP": "لا يحتاج إلى فاتورة",
    "ZZSPTFP": "فاتورة ضريبة القيمة المضافة العادية",
    "ZZSZYFP": "فاتورة ضريبة القيمة المضافة الخاصة",
    "QiTaFaPiao": "فواتير أخرى",
    "XianXia": "أوفلاين",
    "WeiXin": "ويixin",
    "ZhiFuBao": "أ Али باي",
    "YuCunKuan": "الودائع الستقبلية",
    "XianXiaZhuangZhang": "التحويلات البنكية офлайн",
    "XianShangZhiFu": "الدفع عبر الإنترنت (يدعم ويixin/أ Али باي/الدفع عبر جينغدونغ/الدفع عبر اللمس السحابي)",
    "YCKZF": "الدفع من الودائع الستقبلية",
    "DaiTiJiao": "في انتظار الإرسال",
    "KuaiDi": "البريد السريع",
    "SongHuoShangMen": "التسليم إلى الباب",
    "ShangMenZiQu": "الاستلام من المتجر",
    "WuLiuHuoYun": "نقل البضائع",
    "QiTa": "أخرى",
    //check-util
    "QSRBXY6WDM": "يرجى إدخال كلمة مرور لا تقل عن 6 أحرف",
    "QSRBDY20WDM": "يرجى إدخال كلمة مرور لا تزيد عن 20 حرفًا",
    "MMGSCW": "خطأ في تنسيق كلمة المرور",
    //common-utils
    "SJCW_QLXKF": "خطأ في البيانات، يرجى الاتصال بالدعم الفني",
    "ZBZCQD": "لا يدعم التوقيع مؤقتًا",
    "HuJiao": "اتصل",
    "DLZHBCZ": "حساب تسجيل الدخول غير موجود",
    "QLXGLYKT": "يرجى الاتصال بمدير النظام لفتح",
    "GQYZHBJY": "حساب الشركة المحظور",
    "QLXYSDH": "يرجى الاتصال بشراء عبر السحابة",
    "GQYZHSYQJS": "انتهى فترة تجربة حساب الشركة",
    "GQYZHYGQL": "انتهى صلاحية حساب الشركة",
    "XYXFCNSY": "تحتاج إلى التجديد لاستخدام",
    "GQYBCZCZH": "لا يوجد هذا الحساب في الشركة",
    "NDDHZHYBQY": "حساب الشراء الخاص بك تم حظره بواسطة الشركة 1، لا يمكن تسجيل الدخول. يرجى الاتصال بمدير النظام",
    "NYBSQY1DHZ": "أنت لست anymore عميل شريك لشركة 1، لا يمكن تسجيل الدخول. يرجى الاتصال بمدير النظام",
    "NDDPYBTY_B": "متجرك تم إيقافه، لا يمكن تسجيل الدخول. يرجى الاتصال بمدير النظام",
    "GZHWKTDSZB": "هذا الحساب لم يفتح وظيفة النسخة الخاصة بالديكورات الإضاءة. يرجى الاتصال بمدير النظام",
    "WXSQYZYGQ": "انتهت صلاحية التحقق من أذونات ويixin",
    "WXSQSB": "فشل авторизации ويixin",
    "WXSQSB_CWX": "فشل авторизации ويixin، رسالة الخطأ",
    "DengLuGuoQi": "انتهت صلاحية تسجيل الدخول",
    "DLGQ_QCXDL": "انتهت صلاحية تسجيل الدخول، يرجى تسجيل الدخول مرة أخرى",
    //data-constant
    "ShangJia": "على العرض",
    "YiXiaJia": "محذوف من العرض",
    "YiJinYong": "محظور",
    "YiQiYong": "مفعل",
    "YiTingYong": "موقوف",
    "KeHuZhuCe": "تسجيل العميل",
    "XinZengDaoRu": "إضافة وتحميل",
    "DDDSH": "في انتظار مراجعة الطلب",
    "DCWSH": "في انتظار مراجعة المالية",
    "DaiChuKu": "في انتظار الخروج من المخزن",
    "DCK_BF_": "في انتظار الخروج من المخزن (جزئي)",
    "DFH_BF_": "في انتظار الشحن (جزئي)",
    "DSH_BF_": "في انتظار الاستلام (جزئي)",
    "DSK_BF_": "في انتظار التحصيل (جزئي)",
    "WTHSQ": "لا يوجد طلب إرجاع",
    "THDSH": "الإرجاع في انتظار المراجعة",
    "THCLZ": "الإرجاع في المعالجة",
    "THYWC": "الإرجاع مكتمل",
    "DYDHD": "طباعة طلب الشراء",
    "DYFHD": "طباعة طلب الشحن",
    "DCDHD": "تصدير طلب الشراء",
    "DCFHDWE_P": "تصدير طلب الشحن إلى ملف Excel/PDF",
    "TuiDanZuoFei": "ملغى طلب الإرجاع",
    "DTHSH": "في انتظار مراجعة الإرجاع",
    "DaiRuKu": "في انتظار الدخول إلى المخزن",
    "DRK_BF_": "في انتظار الدخول إلى المخزن (جزئي)",
    "DFK_BF_": "في انتظار الدفع (جزئي)",
    "ChuangJianTuiDan": "إنشاء طلب إرجاع",
    "BianJiTuiDan": "تعديل طلب إرجاع",
    "TiJiaoTuiDan": "إرسال طلب إرجاع",
    "TuiHuoShenHe": "مراجعة الإرجاع",
    "RuKu": "الدخول إلى المخزن",
    "RuKuShenHe": "مراجعة الدخول إلى المخزن",
    "RuKuZuoFei": "ملغى الدخول إلى المخزن",
    "TianJiaFuKuan": "إضافة الدفع",
    "FuKuanZuoFei": "ملغى الدفع",
    "FuKuanShenHe": "مراجعة الدفع",
    "TuiDanWanCheng": "طلب الإرجاع مكتمل",
    "QiTaChuKu": "خروج آخر من المخزن",
    "XiaoShouChuKu": "خروج البيع من المخزن",
    "PanKuiChuKu": "خروج الخسائر من المخزن",
    "DiaoBoChuKu": "خروج النقل من المخزن",
    "CaiGouTuiHuo": "إرجاع المشتريات",
    "TuiHuoRuKu": "دخول الإرجاع إلى المخزن",
    "CaiGouRuKu": "دخول المشتريات إلى المخزن",
    "QiTaRuKu": "دخول آخر إلى المخزن",
    "PanYingRuKu": "دخول الأرباح من المخزن",
    "DiaoBoRuKu": "دخول النقل إلى المخزن",
    "CJCGD": "إنشاء طلب مشتريات",
    "BJCGD": "تعديل طلب مشتريات",
    "TJCGD": "إرسال طلب مشتريات",
    "CGDZF": "ملغى طلب المشتريات",
    "CGDWC": "طلب المشتريات مكتمل",
    "CGTHZF": "ملغى إرجاع المشتريات",
    "CGTHWC": "إرجاع المشتريات مكتمل",
    "THDDY": "طباعة طلب الإرجاع",
    "THDDC": "تصدير طلب الإرجاع",
    "CKDDY": "طباعة طلب الخروج من المخزن",
    "CKDDC": "تصدير طلب الخروج من المخزن",
    "GLDZH": "حساب端管理员",
    "DHDZH": "حساب端 الشراء",
    "ShenHeTongGuo": "المراجعة مكتملة",
    "SHBTG": "المراجعة غير مكتملة",
    "WuXuFaPiao": "لا تحتاج إلى فاتورة",
    "DaiKeXiaDan": "تقديم طلب نيابة عن العميل",
    "ZiZhuXiaDan": "تقديم طلب تلقائي",
    "PCShangCheng": "متجر РС",
    "APPShangCheng": "متجر APP",
    "TVShangCheng": "متجر TV",
    "WeiXinShangCheng": "متجر ويixin",
    "ShouJiShangCheng": "متجر جوال",
    "ADDXSMLTC": "العمولة حسب ربح البيع من الطلب",
    "ADDXSSRTC": "العمولة حسب إيراد البيع من الطلب",
    "AKHSSYG": "حسب الموظف الذي يتبع له العميل",
    "AnZhiDanRen": "حسب من أنشأ المستند",
    "ATHJEBLKCT": "扣除 مبلغ العمولة حسب نسبة مبلغ الإرجاع",
    "DDYTHBJXTC": "لا توجد عمولة إذا كان هناك إرجاع من الطلب",
    "DaiDaKuan": "في انتظار التحويل",
    "WeiKaiShi": "لم تبدأ بعد",
    "JinXingZhong": "جاري التنفيذ",
    "YiGuoQi": "منتهي الصلاحية",
    //Utils.js
    "YouHuo": "متوفر",
    "WuHuo": "غير متوفر",
    "Yi": "مليار",
    "QianWan": "مليون مائة ألف",
    "BaiWan": "مليون",
    "Wan": "ألف",
    "Sheng1Tian": "باقي 1 يوم",
    "Sheng1XiaoShi": "باقي 1 ساعة",
    "Miao": "ثانية",
    "1Miao": "1 ثانية",
    "GangGang": "الآن أضف",
    "1FenZhongQian": "منذ 1 دقيقة",
    "1XiaoShiQian": "منذ 1 ساعة",
    "1TianQian": "منذ 1 يوم",
    "1GeYueQian": "منذ 1 شهر",
    "1NianQian": "منذ 1 سنة",
    "WeiZhiLeiXing": "نوع غير معروف",
    //WechatUtil
    "YYGBCDSP_K": "هناك منتج جيد، تأكد من التفقد",
    "ZanWeiSheZhi": "لم يتم الإعداد بعد",
    //app
    "HQWXSQXX": "الحصول على معلومات أذونات ويixin",
    //flexible
    "JGJYYDMBQ": "سيتم ضبط نسبة التكبير بناءً على علامات meta الموجودة",
    //index
    "NLJZZ": "جاري التحميل",
    "": "المسارات",
    "ShangPinMingXi": "تفاصيل المنتج",
    "ShangPinLeiBie": "فئة المنتج",
    "QXZFPNR": "يرجى اختيار محتوى الفاتورة",
    "QXZFPLX": "يرجى اختيار نوع الفاتورة",
    "QTXFPTT": "يرجى إدخال عنوان الفاتورة",
    "FaPiaoTaiTou": "عنوان الفاتورة",
    "NSRSBH": "رقم الهوية الضريبية",
    "FaPiaoNeiRong": "محتوى الفاتورة",
    "FaPiaoXinXi": "معلومات الفاتورة",
    "KaiJuFaPiao": "إصدار الفاتورة",
    "FaPiaoLeiXing": "نوع الفاتورة",
    "Han": "يحتوي على",
    "WeiHan": "لا يحتوي على",
    "Shui": "ضريبة",
    "QSRFPTT": "يرجى إدخال عنوان الفاتورة",
    "QSRNSRSBH": "يرجى إدخال رقم الهوية الضريبية",
    //routes
    //cart-bill
    "YiManZu_Man": "لقد استوفى【يصل إلى",
    "ZaiGou": "اشتري مرة أخرى",
    "YMZ_DHJJZ": "لقد استوفى【سعر الطلب يقل إلى",
    "JianJiangZhi": "قطعة تنخفض إلى",
    "YMZ_YDHJD": "لقد استوفى【سعر الطلب الأصلي يخصم بـ",
    "JianMeiJian": "كل قطعة",
    "SYTCSLW0_WFJRGWC": "عدد الباقات المتبقية هو 0، لا يمكن إضافتها إلى عربة التسوق",
    "QingXuanXeShangPin": "يرجى اختيار المنتج!",
    "GSPYXJ": "هذا المنتج تم إزالته من العرض!",
    "ZJ2TN": "في آخر {day} أيام",
    "QDQCXJSP": "هل تريد بالتأكيد حذف المنتجات المحذوفة من العرض؟",
    "QingChuChengGong": "الحداثة ناجحة",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "لا يمكن إضافة المنتجات المجمعة إلى عربة التسوق، يرجى إلغاء المنتجات المجمعة ثم إضافتها إلى عربة التسوق!",
    "SPSLBN": "لا يمكن أن يكون عدد المنتجات",
    "TaoCanHan": "يحتوي الحزمة على",
    "TaoCan": "حزمة",
    "QHDSL": "يرجى التحقق من الكمية",
    "SPSLBNDY": "لا يمكن أن تكون كمية المنتج أقل من",
    "XianDingLiang": "حد الكمية",
    "YiRuShouCang": "إضافة إلى المفضلة",
    "QuanXuan": "اختر الكل",
    "JianZeng": "قطعة تقدم",
    "JianLiXiang_Man": "قطعة تحصل على【يصل إلى",
    "Yuan_": "يورو】",
    "Zhe_": "نقطة】",
    "KCBZ_WFJRGWC": "المخزون غير كافٍ، لا يمكن إضافتها إلى عربة التسوق",
    "XDJEDYDY": "مبلغ الطلب أكبر من أو يساوي",
    "WYXJHYSXDSP": "لا توجد منتجات محذوفة من العرض أو غير صالحة!",
    "DYQDL": "أقل من كمية البدء",
    "ZSPG1J": "{count} نوع من المنتجات، إجمالي {number} قطعة",
    "WanCheng": "إتمام",
    "BianJi": "تعديل",
    "You": "يوجد",
    "ZSPBFHYQ_W": "نوع من المنتجات لا يلبي المتطلبات، ولم يتم تحديدها، انقر لعرضها",
    "SPSLBNGY": "لا يمكن أن تكون كمية المنتج أكبر من",
    "JXDJ_CKXYGBFHYQSP": "انقر لاستكمال عرض المنتج التالي الذي لا يلبي المتطلبات",
    "XiaDan": "تقديم طلب",
    "JianJiang": "قطعة تنخفض",
    "QRYCSP": "هل تريد بالتأكيد إزالة المنتج؟",
    "QXZXDSP": "يرجى اختيار المنتجات التي سيتم طلبها",
    "KCBZ_QCXXZ": "المخزون غير كافٍ، يرجى الاختيار مرة أخرى!",
    "KuCun": "المخزون",
    "YCKXD": "يورو لكي يتم تقديم الطلب",
    "QDSCSP": "هل تريد بالتأكيد إضافة المنتج إلى المفضلة؟",
    "ShouCangChengGong": "الإضافة إلى المفضلة ناجحة",
    "GYXDL": "أكثر من حد الكمية",
    "LiSheng": "توفير فوري",
    "GWCHSKD_QGYGB": "عربة التسوق فارغة، تفضل بزيارة المتجر",
    "QuGuangGuang": "اذهب للتسوق",
    "QCXJSP": "حذف المنتجات المحذوفة من العرض",
    "ZongE": "إجمالي المبلغ",
    "YouHui": "خصم",
    //cart-list
    "QXZJHRQ": "يرجى اختيار تاريخ التسليم",
    "FuJiaFeiYong": "تكاليف إضافية",
    "ZhongShangPin_Gong": "نوع من المنتجات، إجمالي",
    "PeiSongShiJian": "وقت التسليم",
    "QXZPSSJ": "يرجى اختيار وقت التسليم",
    "DingDanJinE": "مبلغ الطلب",
    "SCFJ_ZD4Z": "تحميل المرفقات، максимум 4 صور، لا تتجاوز كل صورة 3 ميجابايت",
    "KeYongShangPin": "المنتجات المتوفرة",
    "ShiYongShuoMing": "تعليمات الاستخدام",
    "YouXiaoQi": "الصلاحية",
    "Man": "يصل إلى",
    "BZZBZCTSFH": "لا يدعم الرموز الخاصة في الملاحظات مؤقتًا",
    "QingXuanZe": "يرجى الاختيار",
    "KaiPiaoXuJia": "يتطلب تكلفة إضافية لتصدير الفاتورة",
    "GeDian": "نقاط",
    "KPXJ1GD": "يتطلب {num} نقاط إضافية لتصدير الفاتورة",
    "PeiSongFangShi": "طريقة التسليم",
    "ShangPinZongJia": "إجمالي سعر المنتج",
    "YouHuiQuan": "قسيمة الخصم",
    "ZhangKeXan": "يمكن اختيارها",
    "DDJEWMZ": "مبلغ الطلب لا يصل إلى",
    "WDYHQ": "قسائم الخصم الخاصة بي",
    "KYYHQ": "قسائم الخصم المتوفرة",
    "YuanKeYong": "يورو متوفر",
    "ChaKanDingDan": "عرض الطلب",
    "ShangPinHanShui": "المنتج يحتوي على ضريبة",
    "SPWHS": "المنتج لا يحتوي على ضريبة",
    "QueRenDingDan": "تأكيد الطلب",
    "XZSHDZ": "إضافة عنوان استلام جديد",
    "ShangPinQingDan": "قائمة المنتجات",
    "WKYYHQ": "لا توجد قسائم خصم متوفرة",
    "HuChi": "متنافس",
    "DaiJinQuan": "قسيمة نقدية",
    "YunFei": "تكلفة الشحن",
    "ShuiFei": "تكلفة الضريبة",
    "BKYYY": "سبب عدم التوفير",
    "YHQYGQ": "انتهت صلاحية قسيمة الخصم",
    "WDYHQSYSJ": "لم يصل وقت استخدام قسيمة الخصم بعد",
    "ZDSPJEWMZ": "مبلغ المنتج المحدد لا يصل إلى",
    "BKYYHQ": "قسائم الخصم غير المتوفرة",
    "YMZ_MYZJ_": "لقد استوفى【يصل إلى {m} يورو يقدم {n} قطعة】",
    "YMZ_MZ": "لقد استوفى【يصل إلى {m} يورو يقدم {n}】",
    "ZG222YX_M1000": "اشتري {money} يورو أخرى للحصول على【يصل إلى {target} يورو يقدم {num} قطعة】",
    "ZG2JX_MZ": "اشتري {num} قطعة أخرى للحصول على【يصل إلى {target} يورو يقدم {present}】",
    "YMZ_MYJY_": "لقد استوفى【يصل إلى {m} يورو يخفض بـ {n} يورو】",
    "ZGYX_MYJY_": "اشتري {m} يورو أخرى للحصول على【يصل إلى {n} يورو يخفض بـ {o} يورو】",
    "YMZ_MYZ_": "لقد استوفى【يصل إلى {m} يورو {n} نقطة】",
    "ZGYX_MYZ_": "اشتري {m} يورو أخرى للحصول على【يصل إلى {n} يورو {o} نقطة】",
    //cart-presale-order
    "QXZPSFS": "يرجى اختيار طريقة التسليم",
    "1ZSP_G": "1 نوع من المنتجات، إجمالي",
    "YSSP_YJ": "منتج مسبق البيع، متوقع",
    "JiaoHuoRiQi": "تاريخ التسليم",
    "GMJLY": "رسالة إلى البائع",
    //scan-to-cart
    "ZhengZaiChuLi...": "جاري المعالجة...",
    "FSCSP": "منتج غير متجر",
    "ZZCLTXM": "جاري معالجة الرمز الشريطي...",
    "SPTJCG": "تمت إضافة المنتج بنجاح",
    "QSTXM": "يرجى مسح الرمز الشريطي",
    "SFSCDQSP": "هل تريد حذف المنتج الحالي؟",
    "BQ_ZBDXGSP": "آسف، لا يمكن العثور على المنتج ذات الصلة",
    "XuanZeDanWei": "اختر الوحدة",
    "JRGWC": "إضافة إلى عربة التسوق",
    "QXXZDJRSP": "يرجى أولاً اختيار المنتجات التي سيتم إضافتها",
    "ZhengZaiChuLi": "جاري المعالجة",
    "JRGWCCG": "تمت إضافة إلى عربة التسوق بنجاح",
    "ZanWuShangPin": "لا توجد منتجات",
    //earn-brokerage-share
    "XTYJBNFZSP": "لقد نسخ النظام لك رابط المنتج تلقائيًا!",
    "NKYHDDYDYJ": "يمكنك الحصول على العمولة المقابلة. يمكن العثور على العمولة في \"أمي",
    "LiChaKan": "عرضه هنا",
    "WeiXinHaoYou": "أصدقاء ويixin",
    "ErWeiMa": "رمز QR",
    "CASBEWM": "اضغط مطولاً لتصفح الرمز QR",
    "FZSB_QCXFZ": "فشلت النسخ، يرجى النسخ مرة أخرى!",
    "TWEWM": "رمز QR النصي والصوري",
    "BCDXC": "حفظ في المعرض",
    "CATPBCDXC": "اضغط مطولاً على الصورة لحفظها في المعرض",
    "FuZhiLianJie": "نسخ الرابط",
    "FXZYJ": "مشاركة لتحصيل العمولة",
    "YJZGKZQYJ": "العمولة المتوقعة الأعلى التي يمكن تحصيلها",
    "PYTGNFXDYMCGGMH": "بعد أن يشتري صديقك بنجاح من الصفحة التي شاركتها، يمكنك الحصول على العمولة المقابلة. يمكن العثور على العمولة في \"أمي-{path}\"",
    //goods-share
    "FXSPGLSKH": "مشاركة المنتج بالعملاء التجزئة",
    "FXHJSCNZSD": "بعد المشاركة، سيتم إنشاء متجر وايب مخصص لك، يمكنك ضبط أسعار المنتجات في المتجر، ملء معلومات الاتصال بك، وجذب المشترين لشراء上门.",
    "WSCDQJG_ND": "السعر الحالي في متجر وايب: سعر الشراء الخاص بك ×",
    "DaiSheZhi": "في انتظار الإعداد",
    "PengYouQuan": "حساب الاصدقاء",
    "GGFXSZ": "تغيير إعدادات المشاركة",
    //wechat-login
    "QXSRZH": "يرجى أولاً إدخال الحساب",
    "MMGSCW_6_20W": "خطأ في تنسيق كلمة المرور (6-20 حرف أو رقم)",
    "BDYYZH": "ربط الحساب الموجود",
    "WXKJDL": "تسجيل الدخول السريع عبر ويixin",
    "BangDingZhangHao": "ربط الحساب",
    "YYZH_QDL": "لدي حساب، سأتسجّل الدخول",
    "ZCXZH": "تسجيل حساب جديد",
    "HuanYingNi": "مرحبًا بك",
    "ZH_SJHM": "حساب/رقم الجوال",
    "MiMa": "كلمة المرور",
    "QDLHCZ": "يرجى تسجيل الدخول قبل العملية",
    //add-to-cart
    "KCBZ_BNTJG": "المخزون غير كافٍ، لا يمكن إضافة المزيد",
    //combined-pay-online
    "ZhiFuChengGong": "الدفع ناجح!",
    "ZFSB_QCXCS": "فشل الدفع، يرجى المحاولة مرة أخرى!",
    "QXXZGG": "يرجى أولاً اختيار المواصفات",
    "SXGGX": "المواصفات المختارة تتطلب",
    "GMSLXYQDL_": "كمية الشراء أقل من كمية البدء، يرجى الشراء مرة أخرى!",
    "GMSLDYXDL_": "كمية الشراء أكبر من حد الكمية، يرجى الشراء مرة أخرى!",
    "ShangPinBianHao": "رقم المنتج",
    "QiDing": "بدء",
    "SXGGDGSLBK": "لا يمكن أن يتجاوز عدد الطلب للمواصفات المختارة",
    "KCBZ_BNTJ": "المخزون غير كافٍ، لا يمكن الإضافة",
    "QXXZSP": "يرجى أولاً اختيار المنتج",
    "SLBNW0": "الكمية لا يمكن أن تكون 0",
    "QXZGG": "يرجى اختيار المواصفات",
    "LiJiYuDing": "التحجيل الفوري",
    //nav
    "ShouYe": "الرئيسية",
    "ShangPin": "المنتجات",
    "DingDan": "الطلبات",
    "WoDe": "حسابي",
    //pay-online
    "ZhiFuQuXiao": "إلغاء الدفع",
    //account-log
    "ShangPinYongJin": "عمولة المنتج",
    // account-log（续）
    "YaoQingJiangLi": "مكافأة الدعوة",
    "TiXian": "السحب",
    "TiXianBoHui": "مرفوض السحب",
    "ZhuanWeiYuE": "تحويل إلى الرصيد",
    "Jin7Tian": "آخر 7 أيام",
    "Jin30Tian": "آخر 30 يومًا",
    "ShouZhiMingXi": "تفاصيل الدخل والنفقات",
    "ZanWuShuJu": "لا توجد بيانات بعد",
    // client-statistics
    "WoDeKeHu": "عملائي",
    "WoDeYaoQing": "دعواتي",
    // distribution-home
    "LeiJiKeHu": "العملاء المتراكمة",
    "LeiJiDingDan": "الطلبات المتراكمة",
    "YaoQingHaoYou": "دعوة الأصدقاء",
    "LeiJiYaoQing": "الدعوات المتراكمة",
    "LJSY_Y_": "الدخل المتراكم (اليورو)",
    "BHDJS": "يشمل التعادل في انتظار",
    "J7TSY_Y_": "الدخل في آخر 7 أيام (اليورو)",
    "J7TXZKH_R_": "العملاء الجدد في آخر 7 أيام (فرد)",
    "KTXYJ": "العمولة القابلة للسحب",
    "XYJYO": "تحتاج إلى المزيد من الجهد",
    "ChangJianWenTi": "الأسئلة المتكررة",
    "Q_ZMYJX_TG": "س: كيفية \"الترويج لجني الأرباح",
    "A_FXDPND_Z_": "ج: شارك رابط الصفحة التي تحمل أيقونة \"جني\" في المتجر لجذب الأصدقاء لالنقر عليها. عند التسجيل الأصدقاء (يتم ربط علاقة العميل عند التسجيل) أو تقديم الطلب (يتم ربط علاقة العميل عند تقديم الطلب) وشراء المنتجات التي تحمل أيقونة \"جني\" في المتجر، سيتم حسابها كدخل \"الترويج لجني الأرباح\" لك حسب طريقة حساب محددة.",
    "Q_RHJS_TGZ": "س: كيفية حساب دخل \"الترويج لجني الأرباح\"؟",
    "A_MGD_Z_TBD": "ج: كل منتج يحمل أيقونة \"جني\" له نسبة عمولة محددة. أما المنتجات التي لا تحمل هذه العلامة，则 تعني أنها لا تشارك في \"الترويج لجني الأرباح\". بعد أن يدفع الأصدقاء النقود بنجاح من خلال رابطك المشارك، سيتم حساب العمولة على انفراد حسب نسبة العمولة لكل منتج في الطلب (العمولة لمنتجات غير المشاركة تساوي 0)، ثم يُجمَع لتصبح دخل العمولة لهذا الطلب. يُخصم من حساب الدخل رسوم الشحن والاسترجاع والتخفيض عند الوصول وغيرها، وسيتم الاعتماد على سعر الصفقة النهائي.",
    "Q_TGZQ_DSY": "س: متى يصل دخل \"الترويج لجني الأرباح\"؟",
    "A_HYTGNDFX": "ج: بعد أن يدفع الأصدقاء النقود بنجاح من خلال رابطك المشارك، يمكنك رؤية هذا الترويج في طلبات الترويج في المركز البيعي، مع الحالة \"التعادل في انتظار\". عند التأكيد من العميل على الاستلام، تنتهي الصفقة والتحقق من الطلب، وسيتم تحويل هذا الدخل تلقائيًا إلى حسابك الشخصي، والذي يمكن سحبه في أي وقت.",
    "Q_LJKH_LJY": "س: لماذا لا توجد صور شخصية أو أسماء مستخدم في قائمة العملاء المتراكمة/الدعوات المتراكمة؟",
    "A_WXYQZYGZ": "ج: يتطلب وايixin متابعة حساب الخدمة المُصدق لالحصول على صور الشخصية والأسماء المستخدم. أما العملاء الذين أنشأ لهم المتجر حساب الخدمة المُصدق，则 يُرجى متابعة حساب المترجم الرسمي للمتجر. أما الذين لم يُصدق حساب الخدمة，则 يُرجى متابعة حساب \"شراء عبر السحابة\" الرسمي ثم النقر على أي صفحة تفاصيل منتج في المتجر للحصول على صور الشخصية والأسماء المستخدم.",
    "Q_WSMWASSG": "س: لماذا لا أحصل على دخل الترويج على الرغم من المشاركة حسب القواعد أعلاه؟",
    "A_1_HYKNBW": "ج: 1. قد لا يكون الأصدقاء قد أنشأوا علاقة عميل معك (قد النقر على رابط موظف مبيعات آخر للتسجيل أو تقديم الطلب) 2. إذا فتح الأصدقاء رابطك المشارك خارج بيئة وايixin (مثل متصفح الهاتف الافتراضي) ولم يُشغل المتصفح ملفات تعريف الارتباط (cookie)，则 لا يمكن تسجيل علاقة العميل، أي لا يمكن تسجيل طلب الترويج 3. إذا لم يتم تسجيل طلب الترويج على الرغم من صحة النقاط أعلاه، يُرجى الاتصال بالفريق الفني.",
    "XiaoShouZhongXin": "المركز البيعي",
    // generalize-goods
    "SPMC_GG_BH": "اسم المنتج / المواصفات / الرقم التسلسلي",
    "YuJiZhuan": "المتوقع لجني",
    // invitation-home
    "YaoQingKa": "كارت الدعوة",
    "YNYQJR_TGY": "دعوك للانضمام معنا لجني مكافآت الترويج",
    "DJBCDXC": "انقر لحفظ في الألبوم",
    "JYQKFSGHY_": "أرسل كارت الدعوة إلى الأصدقاء لجني مكافآت الترويج للمتجر",
    // join-home
    "HuanYingJiaRu": "مرحبًا بك في الانضمام",
    "YQNCW": "دعوك أن تكون",
    "LiJiJiaRu": "الانضمام الفوري",
    // order-statistics
    "YuJiYongJin": "العمولة المتوقعة",
    "YongJin": "العمولة",
    "YuJiJiangLi": "المكافأة المتوقعة",
    "JiangLi": "المكافأة",
    "SPTGDD": "طلبات الترويج للمنتجات",
    "YQJLDD": "طلبات مكافأة الدعوة",
    // performance-statistics
    "YeJiTongJi": "تحليل الأداء",
    "LJKH_R_": "العملاء المتراكمة (فرد)",
    "SPYJ_Y_": "عمولة المنتج (اليورو)",
    "HanDaiJieSuan": "يشمل التعادل في انتظار",
    "XGMCJS": "شرح المصطلحات ذات الصلة",
    "KeHu": "العميل",
    "HFXYBDLKHG": "المشترين أو الموزعين الذين أنشأوا علاقة عميل مع الموزع",
    "YaoQing": "الدعوة",
    "FXYCGYQDXJ": "الموزعون السفلي الذين أستطاع الموزع الدعوة إليهم بنجاح",
    "FXYTJKHGMH": "العمولة التي يمكن للموزع الحصول عليها بعد توصية العميل بالشراء",
    "XJFXYTGSPH": "المكافأة التي يحصل عليها الموزع الأعلى بعد ترويج المنتجات من قبل الموزع السفلي",
    // posters-promoting
    "NiCheng": "الاسم المستخدم",
    "HaiBaoTuiGuang": "الترويج بالملصق",
    "JHBFSGHY_T": "أرسل الملصق إلى الأصدقاء لجني مكافآت الترويج للمتجر",
    // settlement-home
    "JieSuanZhongXin": "المركز التعادل",
    "KTXJE": "المبلغ القابل للسحب",
    "TiXianJiLu": "سجل السحب",
    // withdraw-account
    "KHRXMBNWK": "لا يمكن أن يكون اسم صاحب الحساب فارغًا!",
    "KHHBNWK": "لا يمكن أن يكون банк الافتتاح فارغًا!",
    "YHKHBNWK": "لا يمكن أن يكون رقم البطاقة البنكية فارغًا!",
    "SFZTPBNWK": "لا يمكن أن تكون صورة البطاقة الشخصية فارغة!",
    "YHKTPBNWK": "لا يمكن أن تكون صورة البطاقة البنكية فارغة!",
    "BaoCunChengGong": "تم الحفظ بنجاح!",
    "SCSFZ": "تحميل البطاقة الشخصية",
    "SCYHK": "تحميل البطاقة البنكية",
    "BaoCun": "حفظ",
    "TiXianZhangHu": "حساب السحب",
    "TS_QTXZSXX": "ملاحظة: يرجى إدخال المعلومات الحقيقية. يمكن السحب فقط بعد الموافقة على المراجعة.",
    "KHRXM": "اسم صاحب الحساب",
    "KaiHuHang": "بنك الافتتاح",
    "YinhangKaHao": "رقم البطاقة البنكية",
    "QSRZSXM": "يرجى إدخال الاسم الحقيقي",
    "QSRKHHMC": "يرجى إدخال اسم банк الافتتاح",
    "QSRYHKH": "يرجى إدخال رقم البطاقة البنكية",
    // withdraw-deposit
    "QXSZTXZH": "يرجى ضبط حساب السحب أولاً",
    "QuSheZhi": "الانتقال إلى الضبط",
    "JEXY10Y_BKT": "المبلغ أقل من 10 يورو، لا يمكن السحب!",
    "JECGKTXJE": "المبلغ يتجاوز المبلغ القابل للسحب!",
    "CGDRKTXSX_": "يتجاوز الحد الأقصى للسحب في اليوم الواحد. الحد الأقصى للسحب في اليوم الواحد هو 20000 يورو!",
    "QueDingJiang": "هل أنت متأكد من تحويل",
    "ZhuanDaoYuE": "إلى الرصيد؟",
    "_JEDY10YSB": "1. لا يمكن السحب إذا كان المبلغ أقل من 10 يورو؛",
    "_BCTXDZSJ": "2. وقت وصول هذا السحب هو خلال 5 أيام عمل بعد نجاح تقديم طلب السحب. الحد الأقصى للسحب في اليوم الواحد هو 20000 يورو؛",
    "_GBSRWHSS": "3. هذا الدخل هو دخل ضريبي. يرجى tự بهاء إلى هيئة الضريبة ذات الصلة ل선언 ودفع ضريبة الدخل الشخصي بنفسك!",
    "_ZDYEKYYS": "4. يمكن استخدام التحويل إلى الرصيد للشراء في المتجر؛",
    "TXSQCG_QDD": "تم تقديم طلب السحب بنجاح. يرجى الانتظار لمراجعة",
    "JEDYKTXJE_": "المبلغ أكبر من المبلغ القابل للسحب، لا يمكن التحويل إلى الرصيد!",
    "ZZYECG_QDG": "تم التحويل إلى الرصيد بنجاح. يرجى الاطلاع على حسابك الشخصي!",
    "BenCiTiXian": "السحب هذا المرة",
    "ZhuangDaoYuE": "تحويل إلى الرصيد",
    "TiXianDao": "السحب إلى",
    "JEW0BKZZYE": "المبلغ يساوي 0، لا يمكن التحويل إلى الرصيد!",
    "DRTXSX2WY": "الحد الأقصى للسحب في اليوم الواحد هو 20000 يورو",
    "QuanBuTiXian": "سحب الكل",
    "QueRenTiXian": "تأكيد السحب",
    // goods-filter-tab
    "ZuiChangGouMai": "الأكثر شراءً",
    "MoRenPaiXu": "الترتيب الافتراضي",
    "ZongHe": "مجمل",
    "FenLei": "التصنيف",
    "XiaoLiangYouXian": "الأولوية لكمية البيع",
    "XiaoLiang": "كمية البيع",
    "JiaGe": "السعر",
    "ShaiXuan": "التصفية",
    "ZuiJinGouMai": "الأكثر حديثًا في الشراء",
    "CuXiaoYouXian": "الأولوية للعروض الترويجية",
    "QuanBuFenLei": "جميع التصنيفات",
    "ZhiKanCuXiao": "عرض العروض الترويجية فقط",
    "XuanZeFenLei": "اختيار التصنيف",
    "QXZFL": "يرجى اختيار التصنيف",
    // goods-list-default
    "ZWXGSP": "لا توجد منتجات ذات الصلة",
    // goods-brand-list
    "PinPaiHui": "مجموعة العلامات التجارية",
    // goods-classify-filter
    "TuiJianFenLei": "التصنيفات الموصى بها",
    "ShangPinFenLei": "تصنيفات المنتجات",
    "GengDuo": "المزيد",
    // goods-detail
    "DLZHBSDQQY": "حساب تسجيل الدخول ليس حساب عميل الشركة الحالية",
    "GXNHQ": "تهانينا! لقد حصلت على",
    "SZWSCJGH_C": "يمكن المشاركة فقط بعد ضبط سعر متجر وايب",
    "JHDJSHS_": "باقي على انتهاء الحملة:",
    "DLHKFX": "يمكن المشاركة بعد تسجيل الدخول",
    "ZZHQXX_QSH": "جاري الحصول على المعلومات. يرجى المحاولة لاحقًا",
    "Zhang": "ورقة",
    "Tian": "يوم",
    "QXZGGZQPD": "يرجى اختيار المواصفات قبل ضبط الأضواء!",
    "Yuan": "يورو",
    "XS_F_M": "ساعة/دقيقة/ثانية",
    // integral
    "WoDeJiFen": "نقاطي",
    "DaBaiLe": "تجاوز",
    "JiFen": "نقاط",
    "DeHuiYuan": "من الأعضاء",
    "ZhuanJiFen": "جني النقاط",
    "JiFenMingXi": "تفاصيل النقاط",
    "HuanLiPin": "استبدال بالهدايا",
    "CKGDHL": "عرض المزيد من الأهدايا الجيدة",
    "ChaDingDan": "التحقق من الطلبات",
    // integral-convert
    "DHSLBNCG": "لا يمكن أن تتجاوز كمية الاستبدال",
    "DuiHuoShuLiang": "كمية الاستبدال",
    "SuoXuJiFen": "النقاط المطلوبة",
    // integral-detail
    "LiPinXiangQing": "تفاصيل الهدية",
    "WoYaoDuiHuan": "أريد الاستبدال",
    "ShengYu": "المتبقي",
    "TuWenXiangQing": "تفاصيل النص والصورة",
    "Jian": "قطعة",
    "YiDuiWan": "مُستنفد الاستبدال",
    // integral-filter
    "FenLeiShaiXuan": "تصفية حسب التصنيف",
    "JiFenShaiXuan": "تصفية حسب النقاط",
    // integral-flow
    "JiFenShouRu": "دخل النقاط",
    "JiFenZhiChu": "مصروف النقاط",
    // integral-logistics
    "DingDanGenZong": "تتبع الطلب",
    "WuLiuGongSi": "شركة الشحن",
    "WuLiuDanHao": "رقم تعريف الشحن",
    // integral-order
    "DingDanLieBiao": "قائمة الطلبات",
    "YiFaHuo": "تم الشحن",
    "JiFenDingDan": "طلبات النقاط",
    "ChaKanWuLiu": "عرض الشحن",
    // integral-order-create
    "LPSLBZ_QCX": "كمية الهدية غير كافية. يرجى الدفع مرة أخرى",
    "JiFenBuZu": "نقاط غير كافية",
    "ZhiFuXinXi": "معلومات الدفع",
    "JiXuGuangGuang": "الاستمرار في التسوق",
    "QTXSHXX": "يرجى إدخال معلومات الاستلام",
    "DuiHuanChengGong": "تم الاستبدال بنجاح",
    "LPDHQR": "تأكيد استبدال الهدية",
    "SCCKJ": "سعر المرجع السوقي",
    "LiJiZhiFu": "الدفع الفوري",
    // integral-order-detail
    "DingDanXiangQing": "تفاصيل الطلب",
    "DingDanZhuangTai": "حالة الطلب",
    "DingDanBianHao": "رقم الطلب",
    "DuiHuanShiJian": "وقت الاستبدال",
    "ShouHuoXinXi": "معلومات الاستلام",
    "HuaFeiJiFen": "نقاط tiêu hao",
    // integral-rule
    "QDZJF": "جني النقاط من خلال التوقيع",
    "XDZJF": "جني النقاط من خلال تقديم الطلب",
    "1_MRQD_JL": "1. التوقيع اليومي، مكافأة {num} نقطة",
    "2_LXQD3T_EW": "2. التوقيع المتصل لمدة 3 أيام، مكافأة إضافية {num} نقطة",
    "3_LXQD7T_EW": "3. التوقيع المتصل لمدة 7 أيام، مكافأة إضافية {num} نقطة",
    "DLZJF": "جني النقاط من خلال تسجيل الدخول",
    "MRDLYSDHSC": "تسجيل الدخول اليومي إلى متجر {name}، مكافأة {num} نقطة",
    "DDWCHKHDYD": "يمكن الحصول على نقاط تساوي مبلغ الطلب × {num} بعد انتهاء الطلب",
    // integral-rule-detail
    "GuiZe": "القواعد",
    // integral-sign
    "QianDaoYouLi": "التوقيع مع مكافأة",
    "QianDaoGuiZe": "قواعد التوقيع",
    "YLXQD": "التوقيع المتصل لمدة",
    "YLXQD1T": "التوقيع المتصل لمدة {num} يومًا",
    "QDCG_NYJLX": "تم التوقيع بنجاح. لقد قمت بالتوقيع المتصل لمدة {num} يومًا",
    "QDCG_BCHD1": "تم التوقيع بنجاح. حصلت على {num} نقطة هذه المرة",
    "BCQDHD4JF_": "حصلت على {num} نقطة من التوقيع هذه المرة. جيد جدًا!",
    "QSRBZ": "يرجى إدخال الملاحظة",
    "DingDanZengPin": "هدية الطلب",
    "GuiGeBianHao": "رقم تعريف المواصفات",
    "GuiGe": "المواصفات",
    // combined-pay
    "CDDWXFK": "لا يحتاج هذا الطلب إلى دفع",
    "YHYEBZ": "رصيد المستخدم غير كافي!",
    "ZFJEBNW0": "لا يمكن أن يكون مبلغ الدفع 0!",
    "ZFJEBNDYDD": "لا يمكن أن يكون مبلغ الدفع أكبر من مبلغ الطلب المتبقي للدفع",
    "DFKJE": "مبلغ الدفع المتبقي",
    "FuKuanFangShi": "طريقة الدفع",
    "FuJian": "المرفقات",
    "ZHYFZ": "تم نسخ الحساب",
    "GHSKZH": "تغيير حساب التحصيل",
    "SYXXZFQSCF": "إذا استخدمت الدفع офлайн، يرجى تحميل لقطة شاشة الدفع لكي تتمكن فريق المالية من التأكد من المبلغ!",
    "XXZF_BXXZS": "الدفع офлайн، يجب اختيار حساب التحصيل",
    "DingDanZhiFu": "دفع الطلب",
    "ZFFS_HDFK": "طريقة الدفع: الدفع عند الاستلام",
    "BCFKJE": "مبلغ الدفع هذا المرة",
    "YuE": "الرصيد",
    "FuZhiZhangHao": "نسخ الحساب",
    "WSZXCXZFPZ": "لم يتم ضبط تكوين دفع التطبيق الصغير",
    "XCXZFZHJY": "حساب دفع التطبيق الصغير معطل",
    "SRZFJE": "إدخال مبلغ الدفع",
    "FuKuanZhangHu": "حساب الدفع",
    "QueRenZhiFu": "تأكيد الدفع",
    "ShaoHouZhiFu": "الدفع لاحقًا",
    // order
    "FKJLYTJ_DD": "تمت إضافة سجل الدفع. في انتظار مراجعة فريق المالية",
    "JiXuGuang": "الاستمرار في التسوق",
    "BenCiFuKuan": "الدفع هذا المرة",
    "FuKuanChengGong": "تم الدفع بنجاح",
    "ZhiFuFangShi": "طريقة الدفع",
    "ZhiFuDingDan": "دفع الطلب",
    // order-batch-pay
    "QXXZSXZFDD": "يرجى أولاً اختيار الطلبات التي تحتاج إلى دفع",
    "PiLiangFuKuan": "الدفع التجميعي",
    "FuKuan": "الدفع",
    "QuFuKuan": "الانتقال إلى الدفع",
    // order-create-result
    "YingFuJinE": "مبلغ الدفع المستحق",
    "XiaDanShiJian": "وقت تقديم الطلب",
    // order-deliver
    "SFQRSH": "هل أنت متأكد من تأكيد الاستلام؟",
    "DDQRSH": "تأكيد استلام الطلب",
    "DFHSP": "المنتجات في انتظار الشحن",
    "ShangPinShuLiang": "كمية المنتجات",
    "ChuKuShiJian": "وقت الخروج من المخزن",
    "FaHuoShiJian": "وقت الشحن",
    "WuLiuBeiZhu": "ملاحظة الشحن",
    "QueRenShouHuo": "تأكيد الاستلام",
    "RYFK_QJSYG": "إذا قمت بالدفع بالفعل، يرجى الاتصال بمدير النظام في الوقت المناسب",
    "QSRQXYY": "يرجى إدخال سبب الإلغاء",
    "H_DDJZDGB_QJKF": "بعد ذلك، سيتم إغلاق الطلب تلقائيًا. يرجى الدفع في الوقت المناسب",
    "TuiHuoQingKuang": "حالة الإرجاع",
    "DingDanZongE": "إجمالي مبلغ الطلب",
    "DingDanBeiZhu": "ملاحظة الطلب",
    "FaHuoQingKuang": "حالة الشحن",
    "DingDanFuJian": "مرفقات الطلب",
    "ShenQingTuiHuo": "تقديم طلب إرجاع",
    "G1TDSHJL_QRS": "إجمالي {num} سجل في انتظار الاستلام. هل أنت متأكد من تأكيد الاستلام؟",
    "DaiXiaDan": "تقديم الطلب نيابة عن",
    "DingDanHao": "رقم الطلب",
    "XiaDanFangShi": "طريقة تقديم الطلب",
    "TuiHuoDan": "طلب الإرجاع",
    "ShangPinZongE": "إجمالي مبلغ المنتج",
    "YunFei_ZongZhong": "رسوم الشحن (الوزن الإجمالي",
    "SF_SPWS": "الضريبة (المنتج غير مشمول الضريبة",
    "TePiJia": "سعر خاص",
    "FuKuanQingKuang": "حالة الدفع",
    "TiaoJiLu": "سجل",
    "ZaiLaiYiDan": "طلب آخر",
    "MuLiuXinXi": "معلومات الشحن",
    "QDSCGDD_": "هل أنت متأكد من حذف هذا الطلب؟",
    "YiQueRen": "تم التأكيد",
    "YiShouHuo": "تم الاستلام",
    "DaiFuJinE": "مبلغ الدفع المتبقي",
    "YiFuJinE": "مبلغ الدفع المُ dokon",
    "ZanWuJiLu": "لا توجد سجلات بعد",
    "SPMC_DDH": "اسم المنتج / رقم الطلب",
    "FuKuanZhuangTai": "حالة الدفع",
    "FaHuoZhuangTai": "حالة الشحن",
    "QiShiShiJian": "وقت البدء",
    "ZhongZhiShiJian": "وقت الانتهاء",
    // order-list
    "CaoZuoChengGong": "تمت العملية بنجاح",
    "ZBKGM": "لا يمكن الشراء مؤقتًا",
    "DQDDSPYXJ": "تم إزالة منتج الطلب الحالي من العرض",
    "DQDDBFSPYXJ": "تم إزالة بعض منتجات الطلب الحالي من العرض",
    "JTJSJSP": "إضافة المنتجات المعروضة فقط",
    "DingHuoDan": "طلب الشراء",
    // order-log
    "DingDanRiZhi": "سجل الطلب",
    // order-logistics
    "FuZhiChengGong": "تم النسخ بنجاح",
    "FuZhiShiBai": "فشل النسخ",
    "FuZhi": "نسخ",
    "BoDa": "الاتصال",
    "WCWLDHXX": "لا توجد معلومات لرقم تعريف الشحن هذا",
    // order-pay
    "ZFCS_QCXXD": "انتهت مهلة الدفع. يرجى تقديم الطلب مرة أخرى",
    "YQYYCKZF": "تم تمكين دفع الودائع الستقبلية",
    "BNDYDFKJE": "لا يمكن أن يكون أكبر من مبلغ الدفع المتبقي",
    "ZFJEBNWK": "لا يمكن أن يكون مبلغ الدفع فارغًا",
    "QXAPFK_FKH": "يرجى تنظيم الدفع أولاً. بعد الدفع، يرجى تحميل لقطة شاشة معلومات الدفع لكي تتمكن فريق المالية من التأكد من المبلغ",
    "DDTJCG_QJS": "تم تقديم الطلب بنجاح. يرجى الدفع في الوقت المناسب",
    "QXZFKFS": "يرجى اختيار طريقة الدفع",
    "SYYEZFH_HX": "بعد استخدام دفع الرصيد، لا يزال هناك مبلغ متبقي للدفع",
    "FuKuanJiLu": "سجل الدفع",
    "ZWFKJL": "لا توجد سجلات دفع بعد",
    "FuKuanXiangQing": "تفاصيل الدفع",
    "FuKuanJinE": "مبلغ الدفع",
    "ZhiDan": "إنشاء المستند",
    "ShenHe": "المراجعة",
    "ZuoFei": "الإلغاء",
    "ZuoFeiYuanYin": "سبب الإلغاء",
    "GLDHD": "طلب الشراء المتصل",
    "HeXiaoJinE": "مبلغ التحقق",
    "HeXiaoZhuangTai": "حالة التحقق",
    "DanJuZhuangTai": "حالة المستند",
    "KeHuMingCheng": "اسم العميل",
    "ZhangDanHao": "رقم الفاتورة",
    "ShouKuanZhangHao": "حساب التحصيل",
    "ShouKuanShiJian": "وقت التحصيل",
    "FuKuanPingZheng": "إثبات الدفع",
    "GeFuJian": "مرفق",
    // order-statistics
    "DingDanTongJi": "تحليل الطلبات",
    "DingHuo0Bi": "{num} طلب شراء",
    // order-statistics-detail
    "DDTJMX": "تفاصيل تحليل الطلب",
    "AGGTJ": "التحليل حسب المواصفات",
    "AFLTJ": "التحليل حسب التصنيف",
    "DDJE_Y": "مبلغ الطلب/يورو",
    "DHSP_Z": "منتج الشراء/نوع",
    "DingHuoDan_Bi": "طلب الشراء/طلب",
    "DingHuoShangPin": "منتج الشراء",
    "JinE": "المبلغ",
    // refund-list
    "TuiHuo": "الإرجاع",
    // refund-apply
    "THDHWBC_QD": "لم يتم حفظ طلب الإرجاع بعد. هل أنت متأكد من المغادرة؟",
    "QSRSQTHJE": "يرجى إدخال مبلغ طلب الإرجاع",
    "QSRTHJE": "يرجى إدخال مبلغ الإرجاع",
    "QSRBZXX": "يرجى إدخال معلومات الملاحظة",
    "YingTuiJinE": "مبلغ الاسترجاع المستحق",
    "TJTHSQ": "تقديم طلب الإرجاع",
    "QXXZDHQD": "يرجى أولاً اختيار قائمة طلب الشراء",
    "DingHuoQingDan": "قائمة طلب الشراء",
    "SQTHJE": "مبلغ طلب الإرجاع",
    "DJXZSP": "انقر لاختيار المنتج",
    "TuiHuoJinE": "مبلغ الإرجاع",
    // refund-detail
    "THDDXQ": "تفاصيل طلب الإرجاع",
    "YiTuiHuo": "تم الإرجاع",
    "YiTuiKuan": "تم الاسترجاع",
    "THDZT": "حالة طلب الإرجاع",
    "TuiHuoDanHao": "رقم طلب الإرجاع",
    "TuiHuoShiJian": "وقت الإرجاع",
    "TuiHuoCangKu": "مخزن الإرجاع",
    "THLXR": "جهة الاتصال للإرجاع",
    "TuiHuoQingDan": "قائمة الإرجاع",
    "TuiKuanZongE": "إجمالي مبلغ الاسترجاع",
    "TuiKuanQingKuang": "حالة الاسترجاع",
    "DaiTuiJinE": "مبلغ الاسترجاع المتبقي",
    "YiTuiJinE": "مبلغ الاسترجاع المُ dokon",
    // refund-product
    "SPMC_BH_GG": "اسم المنتج / الرقم التسلسلي / رقم تعريف المواصفات / الرمز الشريطي",
    "GZD1TJG": "تم العثور على 1 نتيجة",
    "JiaRuQingDan": "إضافة إلى القائمة",
    // refund-result
    "ShenQingChengGong": "تم تقديم الطلب بنجاح",
    "THDTJCG": "تم تقديم طلب الإرجاع بنجاح",
    "ChaKanXiangQing": "عرض التفاصيل",
    // goods-package-floor
    "HDWKS_WDZL": "لم تبدأ الحملة بعد. عاود الأتجاه لاحقًا",
    "HDYJS_XCZD": "انتهت الحملة. عاود الأتجاه مبكرًا في المرة القادمة",
    "ZWSZBT": "لم يتم ضبط العنوان مؤقتًا",
    "ChaKanGengDuo": "عرض المزيد",
    // goods-promotion-floor
    "HCDZSJC": "فارق وقت بسبب التخزين المؤقت (cache)",
    "DLCKCXJ": "تسجيل الدخول لعرض السعر الترويجي",
    "ZWSZCX": "لم يتم ضبط العروض الترويجية مؤقتًا",
    "JuKaiShi": "باقي على البدء",
    "Song": "تقديم",
    "JuJieShu": "باقي على الانتهاء",
    "YiJieShu": "انتهت",
    // search-floor
    "XiaoXi": "الرسائل",
    "SaoMaXiaDan": "مسح الرمز ل تقديم الطلب",
    // home-page-custom
    "WZLCSJ": "بيانات الطابق غير معروفة",
    // jump-error
    "QXZYSDHAPP": "يرجى تنزيل تطبيق شراء عبر السحابة",
    "QMTYQYGLD": "تجربة كاملة لمنصة إدارة الشركة",
    "XZYSDHAPP": "تنزيل تطبيق شراء عبر السحابة",
    "HQGLDWZTY": "الحصول على تجربة كاملة لمنصة الإدارة",
    "JXTYDHD": "الاستمرار في تجربة منصة الشراء",
    // notice-detail
    "GongGaoXiangQing": "تفاصيل الإعلان",
    "GongGaoFuJian": "مرفقات الإعلان",
    // shop-error
    "NFWDYMBCZO": "الصفحة التي تُحاول الوصول إليها غير موجودة~",
    "KeNengYuanYin": "أسباب محتملة",
    "1_ZDZLSRCWD": "1. إدخال عنوان خاطئ في شريط العنوان؛",
    "2_DJLGQLJ": "2. النقر على رابط منتهي الصلاحية.",
    // shop-index
    "GuanLiDuan": "النهاية الإدارية",
    "ZhuCe": "التسجيل",
    "HYNTYYSDH": "مرحبًا بك في تجربة شراء عبر السحابة",
    "TYZHSJHDQG": "يتم تحديث بيانات حساب التجربة بانتظام. يرجى عدم إدخال معلومات هامة",
    "TYZHZDNRSJ": "جميع بيانات المحتوى في حساب التجربة مزورة. يرجى عدم إدخال معلومات هامة",
    "ZHZCCG": "تم التسجيل بنجاح للحساب",
    "DengLuZhangHao": "حساب تسجيل الدخول",
    "CSMMW": "كلمة المرور الابتدائية هي",
    "GNFYHQL": "لقد أرسلنا لك قسيمة خصم",
    "Man1YuanKeYong": "يمكن استخدامها عند الوصول إلى {num} يورو",
    "LQH1TNKY": "يمكن استخدامها في غضون {day} أيام بعد استلامها",
    "YiJianLingQu": "الاستلام في نقر واحد",
    "GXNHD1ZYHQ": "تهانينا! لقد حصلت على {num} قسيمة خصم",
    "Gong1Yuan": "إجمالي {num} يورو",
    "LiJiShiYong": "الاستخدام الفوري",
    // shop-login
    "NHWDL": "لم تقم بتسجيل الدخول بعد",
    // shop-notice
    "ShangChengGongGao": "إعلانات المتجر",
    "ZanWuGongGao": "لا توجد إعلانات بعد",
    "1GeFuJian": "{num} مرفق",
    // deposit-detail
    "KouKuan": "الخصم",
    "ChongZhi_Kuan": "الإعادة الشحن",
    "KouKuanZuoFei": "الإلغاء الخصم",
    "ChongZhiZuoFei": "الإلغاء الإعادة الشحن",
    "ZhangHuMingXi": "تفاصيل الحساب",
    "ZhangHuYuE": "رصيد الحساب",
    "LiJiChongZhi": "الإعادة الشحن الفورية",
    // deposit-recharge
    "CZJEBNXY1Y": "لا يمكن أن يكون مبلغ الإعادة الشحن أقل من 1 يورو",
    "QSRZQDSZ": "يرجى إدخال قيمة صحيحة",
    "ZDYJE": "مبلغ مخصص",
    "ZWKTXSCZGN": "لم يتم تمكين وظيفة الإعادة الشحن عبر الإنترنت مؤقتًا",
    "ShiFuJinE": "مبلغ الدفع الفعلي",
    "ZhangHuChongZhi": "إعادة شحن الحساب",
    "QXZCZJE": "يرجى اختيار مبلغ الإعادة الشحن",
    "QSRCZJE": "يرجى إدخال مبلغ الإعادة الشحن",
    "QLXNDZSYWY": "يرجى الاتصال بموظف المبيعات الخاص بك لعادة الشحن",
    "ShouJia": "سعر البيع",
    "YiShouQing": "مُستنفد البيع",
    "ChongZhiJinE": "مبلغ الإعادة الشحن",
    "QueRenFuKuan": "تأكيد الدفع",
    // deposit-recharge-result
    "QSDDID": "نقص رقم تعريف الطلب",
    "ChongZhiChengGong": "تمت الإعادة الشحن بنجاح",
    "ChongZhiShiBai": "فشلت الإعادة الشحن",
    "CLZ_QSH...": "جاري المعالجة. يرجى الانتظار...",
    "ChongZhiFangShi": "طريقة الإعادة الشحن",
    "ChongZhiShiJian": "وقت الإعادة الشحن",
    "JYLSH": "رقم تعريف المعاملة",
    "FanHuiShangCheng": "العودة إلى المتجر",
    // recharge-online
    "ZFSB_QCS": "فشل الدفع. يرجى المحاولة مرة أخرى",
    "ZFYQX": "تم إلغاء الدفع",
    "ZFYC_QCS": "استثناء في الدفع. يرجى المحاولة مرة أخرى",
    // user
    "LingQuanZhongXin": "مركز استلام القسائم",
    "WeiShiYong": "غير مستخدم",
    "YiShiYong": "مستخدم",
    "ZWYHQ": "لا توجد قسائم خصم بعد",
    // keep-list
    "YiGouMai": "مُشترى",
    "ChangYongQingDan": "قائمة المستخدمة thường xuyên",
    "WoDeShouCang": "مُحفوظاتي",
    "QuGouWuChe": "الانتقال إلى عربة التسوق",
    "GeShangPin": "منتج",
    // login
    "YunShangDingHuo": "شراء عبر السحابة",
    "QSRZH": "يرجى إدخال الحساب!",
    "QSRMM": "يرجى إدخال كلمة المرور!",
    "QSRDLZH": "يرجى إدخال حساب تسجيل الدخول",
    "JiZhuMiMa": "تذكر كلمة المرور",
    "WangJiMiMa": "نسيت كلمة المرور؟",
    "DengLu": "تسجيل الدخول",
    "DLZHBCZ_QL": "حساب تسجيل الدخول غير موجود. يرجى الاتصال بمدير النظام لفتحه",
    "GQYZHSBJY_": "حساب الشركة معطل مؤقتًا. يرجى الاتصال بشراء عبر السحابة",
    "GQYZHSYQJS_": "انتهى فترة تجربة حساب الشركة. يرجى الاتصال بشراء عبر السحابة",
    "GQYZHYGQL_": "انتهى صلاحية حساب الشركة. يحتاج إلى التجديد لاستخدامه. يرجى الاتصال بشراء عبر السحابة",
    "LiJiTiYan": "التجربة الفورية",
    // my-collect
    "YiChuChengGong": "تمت الإزالة بنجاح",
    "QueHuo": "غير متوفر في المخزن",
    "YCSCJ": "الإزالة من المحفوظات",
    // order-message
    "SheZhiChengGong": "تم الضبط بنجاح",
    "ZWWDXX": "لا توجد رسائل غير مقروءة بعد",
    "QuanBuYiDu": "التحويل إلى مقروء ككل",
    "DingDanXiaoXi": "رسائل الطلب",
    "YiQiang": "مُن抢到",
    "LiJiLingQu": "الاستلام الفوري",
    "LingQuanHou": "بعد استلام القسيمة",
    "TianNeiKeYong": "يمكن استخدامها في غضون أيام",
    "QSRSJH": "يرجى إدخال رقم الجوال",
    "QSRYZM": "يرجى إدخال رمز التحقق",
    "QSRXMM": "يرجى إدخال كلمة المرور الجديدة",
    "QSRZQSJGS": "يرجى إدخال تنسيق رقم جوال صحيح",
    "ChongZhiMiMa": "إعادة ضبط كلمة المرور",
    "QSRNDSJHM": "يرجى إدخال رقم جوالك",
    "QSRDXYZ": "يرجى إدخال رمز التحقق عبر الرسالة القصيرة",
    "HQYZM": "الحصول على رمز التحقق",
    "HKCXHQ": "يمكن الحصول على رمز جديد بعد",
    "QSR6_20WSZHZ": "يرجى إدخال كلمة مرور من 6-20 حرف أو رقم",
    // share-setting
    "QSRSPJGBL": "يرجى إدخال نسبة سعر المنتج",
    "SPJGBLBXDY": "يجب أن تكون نسبة سعر المنتج أكبر من أو تساوي 100، وأقل من 999.99",
    "DPMCZBZCTS": "لا يدعم الرموز الخاصة في اسم المتجر مؤقتًا",
    "LXRZBZCTSF": "لا يدعم الرموز الخاصة في جهة الاتصال مؤقتًا",
    "LXFSZBZCTS": "لا يدعم الرموز الخاصة في طريقة الاتصال مؤقتًا",
    "LXDZZBZCTS": "لا يدعم الرموز الخاصة في عنوان الاتصال مؤقتًا",
    "DPJJZBZCTS": "لا يدعم الرموز الخاصة في وصف المتجر مؤقتًا",
    "QSRDPJJ_ZD": "يرجى إدخال وصف المتجر. الحد الأقصى لعدد الأحرف هو 50",
    "FenXiangSheZhi": "إعدادات المشاركة",
    "NDWSCSPJG": "سعر منتج متجر وايب الخاص بك",
    "NDDHJ_": "سعر شراء الخاص بك ×",
    "LXXX_KBJ_": "معلومات الاتصال (يمكن التعديل）",
    "DianPuMingCheng": "اسم المتجر",
    "JianJie": "الوصف",
    "QSRDPMC": "يرجى إدخال اسم المتجر",
    "LianXiRen": "جهة الاتصال",
    "QSRLXR": "يرجى إدخال جهة الاتصال",
    "LianXiFangShi": "طريقة الاتصال",
    "QSRLXFS": "يرجى إدخال طريقة الاتصال",
    "LianXiDiZhi": "عنوان الاتصال",
    "QSRLXDZ": "يرجى إدخال عنوان الاتصال",
    // user
    "WoDeDingDan": "طلباتي",
    "ZuiJinLiuLan": "الزيارات الأخيرة",
    "ShouCangShangPin": "منتجات محفوظة",
    "BDYYZH_ZC": "ربط الحساب الموجود | التسجيل للحساب الجديد",
    "DL_ZC": "تسجيل الدخول | التسجيل",
    "BangDingShouJi": "ربط الجوال",
    "TS_BDSJHM_": "ملاحظة: ربط رقم الجوال يجعل الحساب أكثر أمانًا!",
    "ChaKanQuanBu": "عرض الكل",
    "ShouHuoDiZhi": "عنوان الاستلام",
    "LianXiWoMen": "الاتصال بنا",
    "SheZhi": "الإعدادات",
    "QuQianDao": "الانتقال إلى التوقيع",
    "QianDao": "التوقيع",
    "JiFenShangCheng": "متجر النقاط",
    "TuiGuangShangPin": "ترويج المنتجات",
    "QuChaKan": "الانتقال لعرض",
    "JiFenHuanLi": "استبدال النقاط بالهدايا",
    "DYSPBQ": "طباعة علامة المنتج",
    // user-about
    "GYYSDH": "حول شراء عبر السحابة",
    "YQHYSMEWM_": "دعوة الأصدقاء لمسح الرمز الشريطي لتنزيل وتثبيت التطبيق مباشرة",
    "DangQianBanBen": "الإصدار الحالي",
    // user-address
    "ZWSHDZ": "لا توجد عناوين استلام بعد",
    "WoDeDiZhi": "عناويني",
    "ZhiNengShiBie": "التعرف الذكي",
    "ZTDZXXKZNS": "يمكن لمعلومات العنوان الملصقة التعرف على الاسم والهاتف والعنوان تلقائيًا",
    "MoRen": "الافتراضي",
    "QRSCDZ": "هل أنت متأكد من حذف العنوان؟",
    "SHRXM": "اسم المستلم",
    "SJHMHGDDHZ": "يجب إدخال رقم الجوال أو الهاتف الثابت على الأقل",
    "QSRSHRXM": "يرجى إدخال اسم المستلم",
    "ShouJiHaoMa": "رقم الجوال",
    "GuDingDianHua": "الهاتف الثابت",
    "QSRGDDH": "يرجى إدخال الهاتف الثابت",
    "SuoZaiDiQu": "المنطقة الموجودة فيها",
    "QSRSZDQ": "يرجى إدخال المنطقة الموجودة فيها",
    "QSRXXDZ": "يرجى إدخال العنوان التفصيلي!",
    "QSRZQDSJHM": "يرجى إدخال رقم جوال صحيح",
    "QSRZQDGDDH": "يرجى إدخال هاتف ثابت صحيح",
    "XiangXiDiZhi": "العنوان التفصيلي",
    "MoRenDiZhi": "العنوان الافتراضي",
    "SWMRDZ": "تعيين كعنوان افتراضي",
    "BCBSY": "الحفظ والاستخدام",
    // user-bing-one
    "QSRSJHM": "يرجى إدخال رقم الجوال",
    "GYHYZC": "هذا المستخدم مسجل بالفعل",
    "GSJHMYJZCG": "تم تسجيل هذا الرقم الجوال بالفعل",
    "QZJDLJK": "يرجى تسجيل الدخول مباشرة",
    "QuDengLu": "الانتقال إلى تسجيل الدخول",
    "BDHKYTGSJH": "بعد الربط، يمكن تسجيل الدخول من خلال رقم الجوال، مما يسهل استعادة كلمة المرور ورفع مستوى أمان الحساب",
    "_BDHKYTGSJ": "*بعد الربط، يمكن تسجيل الدخول من خلال رقم الجوال، مما يسهل استعادة كلمة المرور ورفع مستوى أمان الحساب",
    "QSRSJYZM": "يرجى إدخال رمز التحقق عبر الرسالة القصيرة",
    "BDXSJ": "ربط جوال جديد",
    "DXYZM": "رمز التحقق عبر الرسالة القصيرة",
    "XiaYiBu": "الخطوة التالية",
    "TGCBZ": "تخطي هذه الخطوة",
    // user-bing-two
    "DBDSJHMBCZ": "رقم الجوال الذي يُراد ربطه غير موجود!",
    "QSRDLMM": "يرجى إدخال كلمة المرور للدخول!",
    "_GSJHMYBDY": "*تم ربط هذا الرقم الجوال بحساب شراء عبر السحابة. يمكن ربطه بحساب الحالي بعد التحقق من كلمة المرور للدخول من الجوال",
    "DQZHMMJTBW": "سيتم مزامنة كلمة المرور لحساب الحالي مع كلمة المرور للدخول من الجوال",
    "DangQianZhangHao": "حساب الحالي",
    "QDYJZ": "هل أنت متأكد من حذف",
    "JSPSCM": "منتج؟",
    "ShanChuChengGong": "تم الحذف بنجاح!",
    // user-info
    "SJGSCW": "خطأ في تنسيق رقم الجوال",
    "YXGSCW": "خطأ في تنسيق البريد الإلكتروني",
    "WoDeZhangHao": "حسابي",
    "YouXiang": "البريد الإلكتروني",
    "ShouJi": "الجوال",
    "XingMing": "الاسم",
    "XiuGaiTouXiang": "تعديل الصورة الشخصية",
    "JiBenXinXi": "المعلومات الأساسية",
    "ZhangHaoAnQuan": "أمان الحساب",
    "XiuGaiMiMa": "تعديل كلمة المرور",
    "DianJiBangDing": "انقر لربط",
    "RYDSHTY_QL": "إذا فقدته أو توقف استخدامه، يرجى استبداله فورًا لمنع سرقة الحساب",
    "WBZNDZHAQ_": "للحفاظ على أمان حسابك، يرجى ربط الجوال",
    "QSRNDXM": "يرجى إدخال اسمك",
    "QSRNDDH": "يرجى إدخال هاتفك",
    "QSRNDYX": "يرجى إدخال بريدك الإلكتروني",
    // user-setting
    "QCHCHXCXDL": "يحتاج إلى تسجيل الدخول مرة أخرى بعد مسح التخزين المؤقت (cache)",
    "QingChuHuanCun": "مسح التخزين المؤقت (cache)",
    "QDYQCHCM": "هل أنت متأكد من مسح التخزين المؤقت (cache)؟",
    "TuiChuDengLu": "تسجيل الخروج",
    "ZhangHaoZhuXiao": "الغاء الحساب",
    "QieHuanZhangHao": "تبديل الحساب",
    // user-supplier
    "LianXi": "الاتصال",
    "GongSiDianHua": "هاتف الشركة",
    "DiZhi": "العنوان",
    // vouchers-detail
    "DJQMX": "تفاصيل قسيمة النقد",
    // vouchers-list
    "BuKeYong": "غير قابل للاستخدام",
    "KeYong": "قابل للاستخدام",
    "ZWDJQ": "لا توجد قسائم نقد بعد",
    "ZongEDu": "إجمالي الحد",
    "FaFangShiJian": "وقت التوزيع",
    "EDYYW": "مُستنفد الحد",
    "QBSPKY": "قابل للاستخدام لجميع المنتجات",
    // vouchers-select-list
    "WDDJQ": "قسائم النقد الخاصة بي",
    "KYDJQ": "قسائم النقد القابلة للاستخدام",
    "DJQKDK": "قسائم النقد القابلة للخصم",
    "CKKYSP": "عرض المنتجات القابلة للاستخدام",
    "BKYDJQ": "قسائم النقد غير القابلة للاستخدام",
    "BKYYY_ZWFH": "سبب عدم الاستخدام: لا توجد منتجات تفي بالشروط",
    // goods-detail
    "DQSPWSCGGT": "لم يتم تحميل صورة المواصفات لهذا المنتج. لا يدعم ضبط الأضواء!",
    "BoFangShiPin": "تشغيل الفيديو",
    "Gong1GeGuiGe": "إجمالي {num} مواصفات",
    "YiXuanGuiGe": "المواصفات المختارة",
    "XuanGuiGe": "اختيار المواصفات",
    "LingQuan": "استلام القسيمة",
    "1ZhongCuXiao": "{num} عروض ترويجية",
    "1ZhangKeYong": "{num} قسيمة قابلة للاستخدام",
    "ZuiGaoKeSheng": "الحد الأقصى للتوفير",
    "ShangPinTaoCan": "حزمة المنتج",
    "Gong1GeTaoCan": "إجمالي {num} حزمة",
    "ShangPinCanShu": "معلمات المنتج",
    "ZhanKai": "الانبساط",
    "YiShouCang": "مُحفوظ بالفعل",
    "ShouCang": "الحفظ",
    "KeFu": "الدعم الفني",
    "XiangQing": "التفاصيل",
    "TuiJian": "التوصية",
    "BianHao": "الرقم التسلسلي",
    "ShangPinXinXi": "معلومات المنتج",
    "KLYHQ": "قسائم خصم قابلة للاستلام",
    "KuCunBuZu": "مخزن غير كافي",
    "DuoGuiGe": "مواصفات متعددة",
    "YiShou": "مُباع",
    "SWBHZ_YS": "جاري إعادة التوريد. مُباع",
    "CuXiaoShangPin": "منتج ترويجي",
    // goods-search
    "NHWSRSSNR": "لم تقم بإدخال محتوى البحث بعد",
    "SouSuo": "البحث",
    "SSY1XGDSP": "البحث عن منتجات ذات صلة بـ {searchKey}",
    "Yue1GeShangPin": "حوالي {num} منتج",
    "ZuiJinSouSuo": "البحث الأخير",
    "QingChu": "مسح",
    "ZWSSJL": "لا توجد سجلات بحث بعد",
    // goods-property
    "ZGJGBNDYZD": "لا يمكن أن يكون السعر الأعلى أقل من السعر الأدنى",
    "ShangPinBiaoQian": "علامة المنتج",
    "BuGaoYu1": "لا يزيد عن 1",
    "BuDiYu1": "لا يقل عن 1",
    "FengGe": "النمط",
    // goods-promotion-list
    "JiJiangKaiShi": "سيبدأ قريبًا",
    "QuanBuCuXiao": "جميع العروض الترويجية",
    // goods-package-list
    "Gong1JianShangPin": "إجمالي {num} منتج",
    "Sheng": "التوفير",
    // goods-package-detail
    "GTCZGWCZDS": "قد بلغت كمية الحزمة في عربة التسوق الحد الأقصى للشراء. لا يمكن إضافتها إلى عربة التسوق",
    "GTCKCBZ_BK": "مخزن الحزمة غير كافي. لا يمكن إضافتها إلى عربة التسوق",
    "JinSheng1Tao": "متبقي {num} حزمة فقط",
    "XianGou1Tao": "الحد الأقصى للشراء: {num} حزمة",
    "TaoCanXiangQing": "تفاصيل الحزمة",
    "DanMaiJia": "سعر الشراء الفردي",
    "TaoCanJia": "سعر الحزمة",
    "HDYJS": "انتهت الحملة",
    // goods-message
    "WDL_QXDL": "لم تقم بالتسجيل الدخول بعد. يرجى تسجيل الدخول أولاً",
    // goods-list-label
    "XinPinShangShi": "منتجات جديدة تم الإطلاق",
    "WDLZH_ZWCX": "لم تقم بالتسجيل الدخول بعد. لا توجد عروض ترويجية بعد!",
    "YiXiaShangPin": "المنتجات التالية",
    // goods-list
    "1ZhongGuiGe": "{num} مواصفات",
    "YouKuCun": "موجود في المخزن",
    // goods-filter
    "BuGaoYu": "لا يزيد عن",
    "BuDiYu": "لا يقل عن",
    "CuXiao": "الترويج",
    "ZDYXXZ3G": "الحد الأقصى للاختيار هو 3",
    "GouMai": "الشراء",
    "Gong1Jian": "إجمالي {num} قطعة",
    //缺失
    "YiChuShouCangJia": "الإزالة من محفظتي",
    "$": "¥",
    "$1": "¥{num}",
    "_8999_1Qi": "¥ 8999.1 بدءًا من",
    "Ge": "عدد",
    "BaoZhuangFangShi": "طريقة التغليف",
    "QRSCSP_": "هل أنت متأكد من حذف المنتج؟",
    "JEWM_TMFRK": "ضع الرمز الشريطي/الرمز الستاتيكي في الإطار لتمكين المسح التلقائي",
    "0ZSP_G0J": "0 أنواع من المنتجات، إجمالي 0 قطعة",
    "JiuMiMa": "كلمة المرور القديمة",
    "XMM_6_20WZ": "كلمة المرور الجديدة (6-20 حرف أو رقم)",
    "QueRenMiMa": "تأكيد كلمة المرور",
    "BDHKSYSJHD": "بعد الربط، يمكن تسجيل الدخول من خلال رقم الجوال، مما يسهل استعادة كلمة المرور ورفع مستوى أمان الحساب",
    "YanZhengMa": "رمز التحقق",
    "1MHKCXHQ": "يمكن الحصول على رمز جديد بعد 1 ثانية",
    "CSJHZ1MQFS": "تم إرسال رمز تحقق إلى هذا الرقم الجوال قبل 1 ثانية. يرجى المحاولة لاحقًا",
    "GouMaiJiLu": "سجل الشراء",
    "XinZengDiZhi": "إضافة عنوان جديد",
    "LingShouJia": "سعر البيع بالتجزئة",
    "YouHuiJia": "سعر الخصم",
    "ShangPinChuKu": "المنتج يخرج من المخزن",
    "DengDaiShouHuo": "في انتظار الاستلام",
    "ShouHuoRen": "المستلم",
    "PaiZhao": "التقاط صورة",
    "XiangCe": "الألبوم",
    "TiYanGuan": "قاعة التجربة",
    "JingYingShiJian": "وقت التشغيل",
    "ZhanGuanDianHua": "هاتف المعرض",
    "ZhanGuanDiZhi": "عنوان المعرض",
    "SJHQZ_QSDZ": "جاري الحصول على البيانات. يرجى المحاولة لاحقًا!",
    "QXXZSF_": "يرجى أولاً اختيار المقام!",
    "QuanBuShengFen": "جميع المقامات",
    "QuanBuChengShi": "جميع المدن",
    "YingYeShiJian": "وقت التشغيل",
    "ChanPinBianHao": "رقم تعريف المنتج",
    "DLXXYGQ_QC": "انتهت صلاحية معلومات تسجيل الدخول. يرجى تسجيل الدخول مرة أخرى",
    "Man999Jian100": "يخفض بـ {n} عند الوصول إلى {m}",
    "YiManZu": "تم الاستيفاء",
    "QDYCSP_": "هل أنت متأكد من إزالة المنتج؟",
    "DGM10JZ1J": "  يقدم 1 قطعة عند شراء 10 قطع  ",
    "XiaXianTongZhi": "إشعار الخ下线",
    "NDZHYZQTSB": "تم تسجيل دخول حسابك على جهاز آخر. يرجى تسجيل الدخول مرة أخرى. إذا لم تكن أنت من قام بالعملية، يرجى تعديل كلمة المرور في الوقت المناسب",
    "ManJiang": "يخفض بـ {num} يورو عند الوصول إلى {target} قطعة",
    "ZGLXMJ": "اشتري {num} قطعة أخرى للحصول على \"يقل إلى {money_} يورو عند الوصول إلى {target} قطعة\"",
    "ZGLXMZ": "اشتري {num} قطعة أخرى للحصول على \"يخفض إلى {percent} نقطة لكل قطعة عند الوصول إلى {target} قطعة\" ",
    "QSRZQNR": "يرجى إدخال محتوى صحيح",
    "NHYDDQKWJQ": "لديك {num} طلبات بإجمالي مبلغ {money} يورو غير مُسددة. يجب تسديدها قبل أن تتمكن من تقديم طلبات أخرى",
    "FaPiaoZhuShou": "مساعد الفاتورة",
    "WoDeFaPiao": "فواتيري",
    "FaPiaoXiangQing": "تفاصيل الفاتورة",
    "KaiPiaoShiJian": "وقت إصدار الفاتورة",
    "DaiKaiFaPiao": "فواتير مُنتظرة للإصدار",
    "DKFPJE": "مبلغ الفواتير المُنتظرة للإصدار",
    "KaiPiaoJinE": "مبلغ الفاتورة",
    "ZFYDWT_QCSCXZF": "مشكلة في الدفع. يرجى المحاولة مرة أخرى أو تغيير طريقة الدفع",
    "QingXuanZhe": "يرجى الاختيار",
    "ShouXin": "الترخيص",
    "LJSQSXED": "طلب الحد الترخيصي الفوري",
    "SXEDSHZ": "الحد الترخيصي في انتظار المراجعة",
    "SXCZ_XDCG": "الحد الترخيصي كافي. تم تقديم الطلب بنجاح",
    "SXEDBZ_FKHFH": "الحد الترخيصي غير كافي.سيتم الشحن بعد الدفع",
    "CGJKZQ_FKFH": "تجاوز دورة القرض.سيتم الشحن بعد الدفع",
    "DDTJCG_XZZCZHYB": "تم تقديم الطلب بنجاح. مازلت في الحاجة إلى الخطوة الأخيرة!",
    "MianFeiLing": "الاستلام المجاني",
    "M_KMFLQ_HQ": "يمكن الاستلام المجاني عند الوصول إلى {target} يورو. يبقى {short} يورو",
    "YHDMFSP": "تم الحصول على منتج مجاني",
    "JRMFL": "الاستلام المجاني اليومي",
    "LingGuangLe": "مُستنفد الاستلام",
    "KeLingQu": "قابل للاستلام",
    "YuGuJia": "السعر المتوقع",
    "GXNHQ_Z_Y_": "تهانينا! لقد حصلت على {num} قسيمة من {price} يورو ({name})",
    "LXZSKF": "الاتصال بالدعم الفني الخاص",
    "DPYDY_QSHX": "المتجر مُغلق. يرجى تقديم الطلب لاحقًا",
    "DaYangShiJian": "وقت الإغلاق",
    // zh_CN.js（从1353行 key为"ChuanHaoChaXun" 开始逐行翻译）
    "ChuanHaoChaXun": "البحث عن الرقم التسلسلي",
    "IMEI": "الرقم التسلسلي",
    "FanKuanYuE": "الرصيد المسترد",
    "FanKuanZhiFu": "الدفع بالمسترد",
    "JingDongYiYunJia": "جينغدونغ إي يونج جيا",
    "MercadoPago": "ميركادو باجو",
    "FKYEBZ": "الرصيد المسترد غير كافٍ",
    "FanKuanZhangHu": "حساب المسترد",
    "HaiXuZhiFu": "لا يزال يحتاج إلى دفع {price}",
    "QTXGSMC": "الرجاء إدخال اسم الشركة",
    "QSCSFZZMZ": "الرجاء تحميل صورة واجهة بطاقة التعريف الشخصي",
    "QSCSFZFMZ": "الرجاء تحميل صورة ظهر بطاقة التعريف الشخصي",
    "QSCYYZZ": "الرجاء تحميل رخصة الأعمال",
    "TJCG_QNXDDSH": "تم الإرسال بنجاح، الرجاء الانتظار لمراجعة",
    "SXSQ": "طلب الاعتماد المالي",
    "QYJBZL": "البيانات الأساسية للشركة",
    "SQFRSFZZM": "تحميل صورة واجهة بطاقة تعريف صاحب الشركة",
    "ZMSLT": "مثال صورة الواجهة",
    "SCFRSFZFM": "تحميل صورة ظهر بطاقة تعريف صاحب الشركة",
    "FMSLT": "مثال صورة الظهر",
    "QQBSFZSJWZ_WZQXKBB": "الرجاء التأكد من سلامة زوايا بطاقة التعريف الشخصي ووضوح النصوص للتمييز",
    "SCYYZZ": "تحميل رخصة الأعمال",
    "ShengHeZhong": "في انتظار المراجعة",
    "TiJiaoShenHe": "إرسال للمراجعة",
    "GSMC": "اسم الشركة",
    "DDDKFQRBJQSH": "الطلب في انتظار تأكيد السعر من الدعم الفني، الرجاء الانتظار",
    "XDTX": "تنبيه تقديم الطلب",
    "NH_GDDBH": "بعض أسعار المنتجات في انتظار التحقق من الدعم الفني قبل الدفع",
    "QRXD": "تأكيد تقديم الطلب",
    "DaiHeJia": "في انتظار تحقق السعر",
    "ZHJY": "الرصيد الحالي للحساب",
    "YGTG": "الترويج من قبل الموظف",
    "YuanGong": "الموظف",
    "DuiZhanGJieSuan": "الميزانيات والتسوية",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "الرصيد الحالي للحساب = رصيد الودائع الافتتاحية + رصيد المسترد + المبلغ المسترد من الإرجاع في انتظار + المبلغ المستحق للدفع من الطلب",
    "YCKYE": "رصيد الودائع الافتتاحية",
    "FKYE": "رصيد المسترد",
    "DDYFK": "المبلغ المستحق للدفع من الطلب",
    "THDTK": "المبلغ المسترد من الإرجاع في انتظار",
    "YuCunKuanZuoFei": "إلغاء الودائع الافتتاحية",
    "FanKuanZhangHuMingXi": "تفاصيل حساب المسترد",
    "TKCZDFKZH": "إعادة شحن المبلغ المسترد إلى حساب المسترد",
    "RMBJE": "مبلغ الريمنبي"
};
exports.default = ar_SA;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// de_DE.js
var de_DE = {
    "GuanShui": "Zollabgabe‌",
    "ZiZhangHao": "Unterkonto",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",
    // components
    "ShangeChuanYanZhengTuPian": "Verifizierungsbild hochladen",
    "ChuanHaoYanZheng": "Seriennummer überprüfen",
    "YanZhengChuanHao": "Seriennummer verifizieren",
    "Ci": "Mal",
    "DingDanMan": "Bestellung ab",
    "YuanZeng": "Yuan geschenkt",
    "SCFJ_ZD4Z_DZBCG": "Anhänge hochladen, max. 4 Stück, einzeln nicht über 3M",

    // ChatRoom
    "ZBZCBQFH": "Emojis werden derzeit nicht unterstützt",
    "FaSongLianJie": "Link senden",
    "YiChangXiaoXi": "Ungewöhnliche Nachricht",
    "QingShuRu": "Bitte eingeben",
    "FaSong": "Senden",

    // DateSelector
    "DQSJXYKSSJ": "Aktuelle Zeit ist kleiner als Startzeit",
    "DQSJCGJSSJ": "Aktuelle Zeit überschreitet Endzeit",
    "QuXiao": "Abbrechen",
    "NianYueRi": "Jahr/Monat/Tag",
    "ShiFen": "Stunde/Minute",
    "QueDing": "Bestätigen",
    "Nian": "Jahr",
    "Yue": "Monat",
    "Ri": "Tag",
    "Shi": "Stunde",
    "Fen": "Minute",

    // goods-list-card
    "Qi": "ab",

    // goods-promotion
    "1GeCuXiao": "{num} Promotionen",
    "ChaKanZengPin": "Geschenke anzeigen",
    "JHDJSHS_1T": "Verbleibende Zeit bis zum Ende der Aktion: {d} Tage {h} Stunden {m} Minuten {s} Sekunden",
    "YHGZ_ZPBKD": "Rabattregeln: Geschenke können nicht kumuliert werden",
    "YHGZ_AZZGM": "Rabattregeln: Rabatt basierend auf der endgültigen Bestellmenge",
    "GuanBi": "Schließen",
    "Man1Song1": 'Ab {mai} erhält man {song}',

    // group-filtrate
    "QuanBu": "Alle",
    "ZWXGSJ": "Keine relevanten Daten",
    "ZuiDiJia": "Niedrigster Preis",
    "ZuiGaoJia": "Höchster Preis",
    "LeiXing": "Typ",
    "PinPai": "Marke",
    "BiaoQian": "Tag",
    "JiaGeQuJian": "Preisspanne",
    "SPMC_GG_BH_": "Produktname / Spezifikation / Artikelnummer / Anfangsbuchstabe",
    "SPMC_GG_BH_G": "Produktname / Spezifikation / Artikelnummer",
    "ZuHeShaiXuan": "Kombinierte Filterung",
    "ChongZhi_CanShu": "Zurücksetzen",

    // image-upload
    "ZDKSC1ZTP": "Maximal 1 Bild hochladbar",
    "ZYXSCTP": "Nur Bilder erlaubt",
    "SCTPDXBYXC": "Bildgröße darf 5M nicht überschreiten",
    "QBYCFSCTP_": "Bitte keine doppelten Uploads oder sicherstellen, dass Namen eindeutig sind",
    "ShangChuanChengGong": "Upload erfolgreich",
    "ZDKSC1Z": "Maximal 1 Stück hochladbar",

    // keyboard
    "CCSLZDXZ": "Maximalmenge überschritten",
    "QiDingLiang": "Mindestbestellmenge",
    "ShouQi": "Einklappen",
    "ShanChu": "Löschen",

    // MultiPicker
    "FanHui": "Zurück",

    // order-cart
    "Dai": "Ausstehend",
    "YiQuXiao": "Abgebrochen",
    "ZengPin": "Geschenk",
    "1Zhong": "{num} Arten",
    "1Jian": "{num} Stück",
    "HeJi": "Gesamt",
    "DaiFu": "Ausstehend",

    // order-promotion
    "_DDM1YZ1J_": "【Bestellung ab {target} Yuan erhält {name} {number} Stück】",
    "_DDM1YLJ1Y_": "【Bestellung ab {m} Yuan erhält {n} Yuan Rabatt】",
    "_DDM1YLX1Z_": "【Bestellung ab {m} Yuan erhält {n} % Rabatt】",
    "DingDanCuXiao": "Bestellungspromotion",

    // page-ad
    "DLCKJG": "Anmelden, um Preis zu sehen",

    // page-floating
    "DianPuZhuYe": "Geschäftshomepage",
    "GouWuChe": "Warenkorb",
    "ZaiXianKeFu": "Online-Kundenservice",
    "GeRenZhongXin": "Persönliches Zentrum",
    "LianXiDianHua": "Kontaktnummer",
    "FanHuiDingBu": "Zurück zum Anfang",

    // page-null
    "ZBDYML": "Seite nicht gefunden",
    "KNWZCW_HZY": "Vielleicht falsche URL oder Seite gelöscht",
    "FanHuiShangJi": "Zurück zur vorherigen Seite",
    "FanHuiShouYe": "Zurück zur Homepage",

    // product-edit
    "SPQDBNWK": "Produktliste darf nicht leer sein",
    "WoZhiDaoLe": "Ich verstehe",
    "SFQRSCSP": "Sind Sie sicher, dass Sie das Produkt löschen möchten?",
    "QueRen": "Bestätigen",
    "ZYXSRSZBQB": "Nur Zahlen erlaubt, maximal 2 Dezimalstellen",
    "ShangPinDanJia": "Produktpreis pro Einheit",
    "YSPYJ": "Ursprünglicher Grundpreis",
    "QSRZDJG": "Bitte angegebenen Preis eingeben",
    "ShuLiang": "Menge",
    "DanWei": "Einheit",
    "DanJia": "Preis pro Einheit",
    "BeiZhu": "Bemerkung",
    "YiChuShangPin": "Produkt entfernen",
    "XiuGai": "Bearbeiten",

    // yunshl
    "TPSLCCYXSZ": "Bildmenge überschreitet erlaubten Wert!",
    "WJBDDY5M_QC": "Datei darf 5M nicht überschreiten, bitte neu auswählen",
    "TPSCWC": "Bildupload abgeschlossen",

    // BusinessFilter
    "_DGSLM1Z1_": "【Bestellmenge ab {target} erhält {provide}】",
    "_M1JLXMJ1Y_": "【Ab {target} erhält man pro {cut_money_}】",
    "_DHJJZ1Y_": "【Bestellpreis reduziert auf {cuted_price_} Yuan】",
    "_M1JLXMJ1Z_": "【Ab {target} erhält man pro {cut_percent_} % Rabatt】",
    "_YDHJD1Z_": "【Ursprünglicher Bestellpreis mit {cuted_percent_} % Rabatt】",
    "YuJiKaiShiFaHuo": "Versand wird voraussichtlich ab {date} starten",
    "YuJi": "Voraussichtlich",
    "MMYDDR": "MM.TT",
    "KaiShiFaHuo": "Versand starten",
    "_M1LXM1Y_": "【Ab 1 erhält man pro 1 Yuan】",
    "_M1LXM1Z_": "【Ab 1 erhält man pro 1 % Rabatt】",
    "DaiQueRen": "Ausstehend bestätigen",
    "DaiFaHuo": "Ausstehend versenden",
    "DaiShouHuo": "Ausstehend empfangen",
    "YiWanCheng": "Abgeschlossen",
    "DaiFuKuan": "Ausstehend bezahlen",
    "YiFuKuan": "Bezahlt",
    "YiZuoFei": "Ungültig",
    "DaiShenHe": "Ausstehend prüfen",
    "DaiHeXiao": "Ausstehend abrechnen",
    "YiHeXiao": "Abgerechnet",
    "XianXiaZhiFu": "Offline-Zahlung",
    "ZhiNengDaoZhangShiBie": "Offline-Überweisung (intelligente Zahlungsbestätigung)",
    "WeiXinZhiFu": "WeChat-Zahlung",
    "KQ-WeiXinZhiFu": "Kuaiqian (WeChat)",
    "KQ-ZFBZF": "Kuaiqian (Alipay)",
    "KQZhiFu": "Kuaiqian-Zahlung",
    "ZFBZF": "Alipay-Zahlung",
    "YuEZhiFu": "Guthaben-Zahlung",
    "HuoDaoFuKuan": "Nachnahme",
    "DaiTuiHuo": "Ausstehend zurücksenden",
    "DaiTuiKuan": "Ausstehend rückerstatten",
    "ChuangJianDingDan": "Bestellung erstellen",
    "BianJiDingDan": "Bestellung bearbeiten",
    "TiJiaoDingDan": "Bestellung einreichen",
    "DingDanShenHe": "Bestellung prüfen",
    "CaiWuShenHe": "Finanzprüfung",
    "BoHui": "Ablehnen",
    "TianJiaShouKuan": "Einnahme hinzufügen",
    "ZaiXianZhiFu": "Online-Zahlung",
    "ShouKuanShenHe": "Einnahme prüfen",
    "ShouKuanZuoFei": "Einnahme stornieren",
    "ChuKu": "Auslagerung",
    "ChuKuShenHe": "Auslagerung prüfen",
    "FaHuo": "Versenden",
    "TianJiaWuLiu": "Logistik hinzufügen",
    "XiuGaiWuLiu": "Logistik bearbeiten",
    "ChuKuZuoFei": "Auslagerung stornieren",
    "ShouHuo": "Empfangen",
    "DingDanHeZhun": "Bestellung genehmigen",
    "QuXiaoDingDan": "Bestellung abbrechen",
    "CJTHD": "Rücksendungsformular erstellen",
    "DaYin": "Drucken",
    "DaoChu": "Exportieren",
    "DingDanWanCheng": "Bestellung abgeschlossen",
    "QiangZhiWanCheng": "Erzwingen Abschluss",
    "DingDanZuoFei": "Bestellung stornieren",
    "MaiZeng": "Kauf-Geschenk",
    "ZhiJiang": "Direkte Reduktion",
    "DaZhe": "Rabatt",
    "YuShou": "Vorverkauf",
    "DingDanManZeng": "Bestellung ab bestimmtem Betrag mit Geschenk",
    "DingDanManJian": "Bestellung ab bestimmtem Betrag mit Rabatt",
    "DingDanManZhe": "Bestellung ab bestimmtem Betrag mit Prozentsatzrabatt",
    "XinRenQuan": "Neukunden-Coupon",
    "ManJianQuan": "Rabatt-Coupon ab bestimmtem Betrag",
    "ShangPinQuan": "Produkt-Coupon",
    "DaiJieSuan": "Ausstehend abrechnen",
    "YiJieSuan": "Abgerechnet",
    "QuanBuShangPin": "Alle Produkte",
    "TuiJianShangPin": "Empfohlene Produkte",
    "XinPin": "Neue Produkte",
    "ReXiaoShangPin": "Beliebte Produkte",
    "ChangYongShangPin": "Übliche Produkte",

    // BusinessUtil
    "DaiShouKuan": "Ausstehend einnehmen",
    "BuFenShouKuan": "Teilweise eingnommen",
    "YiShouKuan": "Vollständig eingnommen",
    "BXYFP": "Keine Rechnung benötigt",
    "ZZSPTFP": "Allgemeine Steuerrechnung",
    "ZZSZYFP": "Sondersteuerrechnung",
    "QiTaFaPiao": "Andere Rechnungen",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Vorschussguthaben",
    "XianXiaZhuangZhang": "Offline-Überweisung",
    "XianShangZhiFu": "Online-Zahlung (unterstützt WeChat/Alipay/JD Pay/UnionPay)",
    "YCKZF": "Vorschussguthaben-Zahlung",
    "DaiTiJiao": "Ausstehend einreichen",
    "KuaiDi": "Express",
    "SongHuoShangMen": "Lieferung nach Hause",
    "ShangMenZiQu": "Abholung vor Ort",
    "WuLiuHuoYun": "Logistikfracht",
    "QiTa": "Andere",

    // check-util
    "QSRBXY6WDM": "Bitte Passwort mit mindestens 6 Zeichen eingeben",
    "QSRBDY20WDM": "Bitte Passwort mit maximal 20 Zeichen eingeben",
    "MMGSCW": "Falsches Passwortformat",

    // common-utils
    "SJCW_QLXKF": "Datenfehler, bitte Kontaktieren Sie den Kundenservice",
    "ZBZCQD": "Anmeldung wird derzeit nicht unterstützt",
    "HuJiao": "Anrufen",
    "DLZHBCZ": "Anmeldekonto existiert nicht",
    "QLXGLYKT": "Bitte Administrator um Freischaltung",
    "GQYZHBJY": "Dieses Unternehmenskonto ist gesperrt",
    "QLXYSDH": "Bitte Kontaktieren Sie Yunshang Order",
    "GQYZHSYQJS": "Probezeit des Unternehmenskontos abgelaufen",
    "GQYZHYGQL": "Dieses Unternehmenskonto ist abgelaufen",
    "XYXFCNSY": "Erneuerung erforderlich für Nutzung",
    "GQYBCZCZH": "Dieses Unternehmen hat dieses Konto nicht",
    "NDDHZHYBQY": "Ihr Bestellkonto wurde von Unternehmen 1 gesperrt, Anmeldung nicht möglich. Bitte Administrator kontaktieren",
    "NYBSQY1DHZ": "Sie sind kein Kooperationskunde von Unternehmen 1 mehr, Anmeldung nicht möglich. Bitte Administrator kontaktieren",
    "NDDPYBTY_B": "Ihr Geschäft ist deaktiviert, Anmeldung nicht möglich. Bitte Administrator kontaktieren",
    "GZHWKTDSZB": "Diese Funktion ist für dieses Konto nicht freigeschaltet. Bitte Administrator kontaktieren",
    "WXSQYZYGQ": "WeChat-Autorisierung abgelaufen",
    "WXSQSB": "WeChat-Autorisierung fehlgeschlagen",
    "WXSQSB_CWX": "WeChat-Autorisierung fehlgeschlagen, Fehlerinfo",
    "DengLuGuoQi": "Anmeldung abgelaufen",
    "DLGQ_QCXDL": "Anmeldung abgelaufen, bitte neu anmelden",

    // data-constant
    "ShangJia": "Online",
    "YiXiaJia": "Offline",
    "YiJinYong": "Deaktiviert",
    "YiQiYong": "Aktiviert",
    "YiTingYong": "Gestoppt",
    "KeHuZhuCe": "Kundenregistrierung",
    "XinZengDaoRu": "Neu hinzufügen/importieren",
    "DDDSH": "Ausstehend Bestellung prüfen",
    "DCWSH": "Ausstehend Finanzprüfung",
    "DaiChuKu": "Ausstehend auslagern",
    "DCK_BF_": "Ausstehend auslagern (teilweise)",
    "DFH_BF_": "Ausstehend versenden (teilweise)",
    "DSH_BF_": "Ausstehend empfangen (teilweise)",
    "DSK_BF_": "Ausstehend einnehmen (teilweise)",
    "WTHSQ": "Keine Rücksendungsanfrage",
    "THDSH": "Rücksendung ausstehend prüfen",
    "THCLZ": "Rücksendung in Bearbeitung",
    "THYWC": "Rücksendung abgeschlossen",
    "DYDHD": "Bestellformular drucken",
    "DYFHD": "Versandformular drucken",
    "DCDHD": "Bestellformular exportieren",
    "DCFHDWE_P": "Versandformular als Excel/PDF exportieren",
    "TuiDanZuoFei": "Rücksendungsformular stornieren",
    "DTHSH": "Ausstehend Rücksendung prüfen",
    "DaiRuKu": "Ausstehend einlagern",
    "DRK_BF_": "Ausstehend einlagern (teilweise)",
    "DFK_BF_": "Ausstehend bezahlen (teilweise)",
    "ChuangJianTuiDan": "Rücksendungsformular erstellen",
    "BianJiTuiDan": "Rücksendungsformular bearbeiten",
    "TiJiaoTuiDan": "Rücksendungsformular einreichen",
    "TuiHuoShenHe": "Rücksendung prüfen",
    "RuKu": "Einlagerung",
    "RuKuShenHe": "Einlagerung prüfen",
    "RuKuZuoFei": "Einlagerung stornieren",
    "TianJiaFuKuan": "Zahlung hinzufügen",
    "FuKuanZuoFei": "Zahlung stornieren",
    "FuKuanShenHe": "Zahlung prüfen",
    "TuiDanWanCheng": "Rücksendungsformular abgeschlossen",
    "QiTaChuKu": "Andere Auslagerung",
    "XiaoShouChuKu": "Verkaufsauslagerung",
    "PanKuiChuKu": "Verlustauslagerung",
    "DiaoBoChuKu": "Umverteilungslagerung",
    "CaiGouTuiHuo": "Einkaufsrücksendung",
    "TuiHuoRuKu": "Rücksendungseinlagerung",
    "CaiGouRuKu": "Einkaufeinlagerung",
    "QiTaRuKu": "Andere Einlagerung",
    "PanYingRuKu": "Gewinnlagerung",
    "DiaoBoRuKu": "Umverteilungseinlagerung",
    "CJCGD": "Einkaufsformular erstellen",
    "BJCGD": "Einkaufsformular bearbeiten",
    "TJCGD": "Einkaufsformular einreichen",
    "CGDZF": "Einkaufsformular stornieren",
    "CGDWC": "Einkaufsformular abgeschlossen",
    "CGTHZF": "Einkaufsrücksendung stornieren",
    "CGTHWC": "Einkaufsrücksendung abgeschlossen",
    "THDDY": "Rücksendungsformular drucken",
    "THDDC": "Rücksendungsformular exportieren",
    "CKDDY": "Auslagerungsformular drucken",
    "CKDDC": "Auslagerungsformular exportieren",
    "GLDZH": "Verwaltungsaccount",
    "DHDZH": "Bestellaccount",
    "ShenHeTongGuo": "Prüfung bestanden",
    "SHBTG": "Prüfung nicht bestanden",
    "WuXuFaPiao": "Keine Rechnung benötigt",
    "DaiKeXiaDan": "Bestellung für Kunden aufgeben",
    "ZiZhuXiaDan": "Selbstbestellung",
    "PCShangCheng": "PC-Shop",
    "APPShangCheng": "APP-Shop",
    "TVShangCheng": "TV-Shop",
    "WeiXinShangCheng": "WeChat-Shop",
    "ShouJiShangCheng": "Mobil-Shop",
    "ADDXSMLTC": "Provision nach Bruttogewinn",
    "ADDXSSRTC": "Provision nach Umsatz",
    "AKHSSYG": "Nach zuständigen Mitarbeiter",
    "AnZhiDanRen": "Nach Ersteller",
    "ATHJEBLKCT": "Provisionsabzug nach Rücksendungsbetrag",
    "DDYTHBJXTC": "Keine Provision bei Rücksendung",
    "DaiDaKuan": "Ausstehend überweisen",
    "WeiKaiShi": "Nicht gestartet",
    "JinXingZhong": "Läuft",
    "YiGuoQi": "Abgelaufen",

    // Utils.js
    "YouHuo": "Auf Lager",
    "WuHuo": "Ausverkauft",
    "Yi": "100 Millionen",
    "QianWan": "10 Millionen",
    "BaiWan": "Million",
    "Wan": "Tausend",
    "Sheng1Tian": "1 Tag übrig",
    "Sheng1XiaoShi": "1 Stunde übrig",
    "Miao": "Sekunde",
    "1Miao": "1 Sekunde",
    "GangGang": "Gerade eben",
    "1FenZhongQian": "1 Minute zuvor",
    "1XiaoShiQian": "1 Stunde zuvor",
    "1TianQian": "1 Tag zuvor",
    "1GeYueQian": "1 Monat zuvor",
    "1NianQian": "1 Jahr zuvor",
    "WeiZhiLeiXing": "Unbekannter Typ",

    // WechatUtil
    "YYGBCDSP_K": "Ein tolles Produkt, schau es dir an",
    "ZanWeiSheZhi": "Noch nicht eingestellt",

    // app
    "HQWXSQXX": "WeChat-Autorisierungsinfo abrufen",

    // flexible
    "JGJYYDMBQ": "Skalierungsfaktor basierend auf vorhandenen Meta-Tags einstellen",

    // index
    "NLJZZ": "Lädt...",
    "": "Routen",
    "ShangPinMingXi": "Produktdetails",
    "ShangPinLeiBie": "Produktkategorien",
    "QXZFPNR": "Bitte Rechnunginhalt auswählen",
    "QXZFPLX": "Bitte Rechnungstyp auswählen",
    "QTXFPTT": "Bitte Rechnungstitel eingeben",
    "FaPiaoTaiTou": "Rechnungstitel",
    "NSRSBH": "Steueridentifikationsnummer",
    "FaPiaoNeiRong": "Rechnunginhalt",
    "FaPiaoXinXi": "Rechnungsinfo",
    "KaiJuFaPiao": "Rechnung ausstellen",
    "FaPiaoLeiXing": "Rechnungstyp",
    "Han": "Enthält",
    "WeiHan": "Enthält nicht",
    "Shui": "Steuer",
    "QSRFPTT": "Bitte Rechnungstitel eingeben",
    "QSRNSRSBH": "Bitte Steueridentifikationsnummer eingeben",

    // routes
    // cart-bill
    "YiManZu_Man": "Erfüllt【ab",
    "ZaiGou": "Weiter einkaufen",
    "YMZ_DHJJZ": "Erfüllt【Bestellpreis reduziert auf",
    "JianJiangZhi": "Stück reduziert auf",
    "YMZ_YDHJD": "Erfüllt【Ursprünglicher Preis mit",
    "JianMeiJian": "Stück pro Stück",
    "SYTCSLW0_WFJRGWC": "Restmenge des Pakets ist 0, kann nicht in den Warenkorb gelegt werden",
    "QingXuanXeShangPin": "Bitte Produkte auswählen!",
    "GSPYXJ": "Dieses Produkt ist offline!",
    "ZJ2TN": "Innerhalb der letzten {day} Tage",
    "QDQCXJSP": "Sind Sie sicher, dass Sie offline Produkte löschen möchten?",
    "QingChuChengGong": "Löschung erfolgreich",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Paketprodukte können nicht in den Warenkorb gelegt werden, bitte Paketprodukte entfernen und dann in den Warenkorb legen!",
    "SPSLBN": "Produktmenge kann nicht",
    "TaoCanHan": "Paket enthält",
    "TaoCan": "Paket",
    "QHDSL": "Bitte Menge prüfen",
    "SPSLBNDY": "Produktmenge kann nicht weniger als",
    "XianDingLiang": "Maximalmenge",
    "YiRuShouCang": "Zur Sammlung hinzufügen",
    "QuanXuan": "Alles auswählen",
    "JianZeng": "Stück geschenkt",
    "JianLiXiang_Man": "Stück erhält【ab",
    "Yuan_": "Yuan】",
    "Zhe_": "% Rabatt】",
    "KCBZ_WFJRGWC": "Nicht genug Lagerbestand, kann nicht in den Warenkorb gelegt werden",
    "XDJEDYDY": "Bestellbetrag muss mindestens",
    "WYXJHYSXDSP": "Keine offline oder ungültigen Produkte!",
    "DYQDL": "Unter Mindestbestellmenge",
    "ZSPG1J": "{count} Produkte, insgesamt {number} Stück",
    "WanCheng": "Fertig",
    "BianJi": "Bearbeiten",
    "You": "Es gibt",
    "ZSPBFHYQ_W": "Produkte, die nicht den Anforderungen entsprechen, nicht markiert, klicken Sie zum Anzeigen",
    "SPSLBNGY": "Produktmenge kann nicht mehr als",
    "JXDJ_CKXYGBFHYQSP": "Weiter klicken, um nächstes ungeeignetes Produkt anzuzeigen",
    "XiaDan": "Bestellen",
    "JianJiang": "Stück reduziert",
    "QRYCSP": "Sind Sie sicher, dass Sie das Produkt entfernen möchten?",
    "QXZXDSP": "Bitte bestellte Produkte auswählen",
    "KCBZ_QCXXZ": "Nicht genug Lagerbestand, bitte neu auswählen!",
    "KuCun": "Lagerbestand",
    "YCKXD": "Yuan, um zu bestellen",
    "QDSCSP": "Sind Sie sicher, dass Sie das Produkt zur Sammlung hinzufügen möchten?",
    "ShouCangChengGong": "Zur Sammlung hinzugefügt",
    "GYXDL": "Über Maximalmenge",
    "LiSheng": "Sofort sparen",
    "GWCHSKD_QGYGB": "Der Warenkorb ist leer, gehen Sie einkaufen",
    "QuGuangGuang": "Einkaufen gehen",
    "QCXJSP": "Offline Produkte löschen",
    "ZongE": "Gesamtsumme",
    "YouHui": "Rabatt",
    //cart-list
    "QXZJHRQ": "Bitte Lieferdatum auswählen",
    "FuJiaFeiYong": "Zusatzkosten",
    "ZhongShangPin_Gong": "Produktarten, insgesamt",
    "PeiSongShiJian": "Lieferzeit",
    "QXZPSSJ": "Bitte Lieferzeit auswählen",
    "DingDanJinE": "Bestellbetrag",
    "SCFJ_ZD4Z": "Anhänge hochladen, max. 4 Stück, einzeln nicht über 3M",
    "KeYongShangPin": "Verfügbare Produkte",
    "ShiYongShuoMing": "Verwendungsanleitung",
    "YouXiaoQi": "Gültigkeit",
    "Man": "ab",
    "BZZBZCTSFH": "Bemerkungen unterstützen derzeit keine Sonderzeichen",
    "QingXuanZe": "Bitte auswählen",
    "KaiPiaoXuJia": "Rechnungserstellung kostet extra",
    "GeDian": "Prozentpunkte",
    "KPXJ1GD": "Rechnungserstellung kostet {num} Prozentpunkte extra",
    "PeiSongFangShi": "Lieferart",
    "ShangPinZongJia": "Gesamter Produktpreis",
    "YouHuiQuan": "Gutscheine",
    "ZhangKeXan": "{num} verfügbar",
    "DDJEWMZ": "Bestellbetrag nicht erreicht",
    "WDYHQ": "Meine Gutscheine",
    "KYYHQ": "Verwendbare Gutscheine",
    "YuanKeYong": "Yuan verwendbar",
    "ChaKanDingDan": "Bestellung anzeigen",
    "ShangPinHanShui": "Produkt enthält Steuer",
    "SPWHS": "Produkt enthält keine Steuer",
    "QueRenDingDan": "Bestellung bestätigen",
    "XZSHDZ": "Neue Lieferadresse hinzufügen",
    "ShangPinQingDan": "Produktliste",
    "WKYYHQ": "Keine verwendbaren Gutscheine",
    "HuChi": "Unverträglich",
    "DaiJinQuan": "Gutscheine",
    "YunFei": "Versandkosten",
    "ShuiFei": "Steuerkosten",
    "BKYYY": "Grund für Unverwendbarkeit",
    "YHQYGQ": "Gutschein abgelaufen",
    "WDYHQSYSJ": "Gutschein noch nicht verwendbar",
    "ZDSPJEWMZ": "Betrag für spezifische Produkte nicht erreicht",
    "BKYYHQ": "Unverwendbare Gutscheine",
    "YMZ_MYZJ_": "Bedingung erfüllt【ab {m} Yuan erhält {n} Stück】",
    "YMZ_MZ": "Bedingung erfüllt【ab {m} Yuan erhält {n}】",
    "ZG222YX_M1000": "Noch {money} Yuan einkaufen, um【ab {target} Yuan {num} Stück zu erhalten】",
    "ZG2JX_MZ": "Noch {num} Stück einkaufen, um【ab {target} Yuan {present} zu erhalten】",
    "YMZ_MYJY_": "Bedingung erfüllt【ab {m} Yuan {n} Yuan Rabatt】",
    "ZGYX_MYJY_": "Noch {m} Yuan einkaufen, um【ab {n} Yuan {o} Yuan Rabatt】",
    "YMZ_MYZ_": "Bedingung erfüllt【ab {m} Yuan {n} % Rabatt】",
    "ZGYX_MYZ_": "Noch {m} Yuan einkaufen, um【ab {n} Yuan {o} % Rabatt】",

    //cart-presale-order
    "QXZPSFS": "Bitte Lieferart auswählen",
    "1ZSP_G": "1 Produktart, insgesamt",
    "YSSP_YJ": "Vorpresprodukt, voraussichtlich",
    "JiaoHuoRiQi": "Lieferdatum",
    "GMJLY": "Nachricht an Verkäufer",

    //scan-to-cart
    "ZhengZaiChuLi...": "Verarbeitung...",
    "FSCSP": "Nicht im Shop liegendes Produkt",
    "ZZCLTXM": "Barcode wird verarbeitet...",
    "SPTJCG": "Produkt erfolgreich hinzugefügt",
    "QSTXM": "Bitte Barcode scannen",
    "SFSCDQSP": "Aktuelles Produkt löschen?",
    "BQ_ZBDXGSP": "Entschuldigung, kein zugehöriges Produkt gefunden",
    "XuanZeDanWei": "Einheit auswählen",
    "JRGWC": "In den Warenkorb",
    "QXXZDJRSP": "Bitte zu hinzufügende Produkte zuerst auswählen",
    "ZhengZaiChuLi": "Verarbeitung",
    "JRGWCCG": "Erfolgreich in den Warenkorb gelegt",
    "ZanWuShangPin": "Keine Produkte",

    //earn-brokerage-share
    "XTYJBNFZSP": "System hat Produktlink für Sie kopiert!",
    "NKYHDDYDYJ": "Sie können entsprechende Provision erhalten. Provision finden Sie in „Meine",
    "LiChaKan": "anzeigen",
    "WeiXinHaoYou": "WeChat-Freunde",
    "ErWeiMa": "QR-Code",
    "CASBEWM": "Längen Sie, um QR-Code zu erkennen",
    "FZSB_QCXFZ": "Kopieren fehlgeschlagen, bitte erneut versuchen!",
    "TWEWM": "Bild-Text-QR-Code",
    "BCDXC": "In Album speichern",
    "CATPBCDXC": "Längen Sie das Bild, um es im Album zu speichern",
    "FuZhiLianJie": "Link kopieren",
    "FXZYJ": "Teilen und Provision verdienen",
    "YJZGKZQYJ": "Maximal voraussichtliche Provision",
    "PYTGNFXDYMCGGMH": "Wenn Freunde über Ihre geteilte Seite erfolgreich einkaufen, erhalten Sie entsprechende Provision. Provision finden Sie in „Meine-{path}",

    //goods-share
    "FXSPGLSKH": "Produkt an Endverbraucher weitergeben",
    "FXHJSCNZSD": "Nach dem Teilen wird ein persönlicher mobiler Mini-Shop erstellt. Sie können Preise im Shop festlegen, Kontaktdaten eingeben und Verbraucher anlocken, vor Ort einzukaufen.",
    "WSCDQJG_ND": "Aktueller Preis im Mini-Shop: Ihr Bestellpreis ×",
    "DaiSheZhi": "Noch nicht eingestellt",
    "PengYouQuan": "Freundeskreis",
    "GGFXSZ": "Teileinstellungen ändern",

    //wechat-login
    "QXSRZH": "Bitte zuerst Konto eingeben",
    "MMGSCW_6_20W": "Falsches Passwortformat (6-20 Buchstaben oder Ziffern)",
    "BDYYZH": "Bestehendes Konto binden",
    "WXKJDL": "WeChat-Schnelllogin",
    "BangDingZhangHao": "Konto binden",
    "YYZH_QDL": "Bereits ein Konto, einloggen",
    "ZCXZH": "Neues Konto registrieren",
    "HuanYingNi": "Willkommen",
    "ZH_SJHM": "Konto/Handynummer",
    "MiMa": "Passwort",
    "QDLHCZ": "Bitte zuerst einloggen",

    //add-to-cart
    "KCBZ_BNTJG": "Nicht genug Lagerbestand, kann nicht mehr hinzugefügt werden",

    //combined-pay-online
    "ZhiFuChengGong": "Zahlung erfolgreich!",
    "ZFSB_QCXCS": "Zahlung fehlgeschlagen, bitte erneut versuchen!",
    "QXXZGG": "Bitte zuerst Spezifikation auswählen",
    "SXGGX": "Ausgewählte Spezifikation erfordert",
    "GMSLXYQDL_": "Kaufmenge unter Mindestbestellmenge, bitte erneut kaufen!",
    "GMSLDYXDL_": "Kaufmenge über Maximalmenge, bitte erneut kaufen!",
    "ShangPinBianHao": "Produktnummer",
    "QiDing": "Mindestbestellmenge",
    "SXGGDGSLBK": "Bestellmenge für ausgewählte Spezifikation darf nicht übersteigen",
    "KCBZ_BNTJ": "Nicht genug Lagerbestand, kann nicht hinzugefügt werden",
    "QXXZSP": "Bitte zuerst Produkt auswählen",
    "SLBNW0": "Menge darf nicht 0 sein",
    "QXZGG": "Bitte Spezifikation auswählen",
    "LiJiYuDing": "Sofort reservieren",

    //nav
    "ShouYe": "Startseite",
    "ShangPin": "Produkte",
    "DingDan": "Bestellungen",
    "WoDe": "Meine",

    //pay-online
    "ZhiFuQuXiao": "Zahlung abgebrochen",

    //account-log
    "ShangPinYongJin": "Produktprovision",
    "YaoQingJiangLi": "Einladungsbelohnung",
    "TiXian": "Abhebung",
    "TiXianBoHui": "Abhebung abgelehnt",
    "ZhuanWeiYuE": "In Guthaben umwandeln",
    "Jin7Tian": "Letzte 7 Tage",
    "Jin30Tian": "Letzte 30 Tage",
    "ShouZhiMingXi": "Einnahmen- und AusgabenDetails",
    "ZanWuShuJu": "Keine Daten",

    //client-statistics
    "WoDeKeHu": "Meine Kunden",
    "WoDeYaoQing": "Meine Einladungen",

    //distribution-home
    "LeiJiKeHu": "Kumulierte Kunden",
    "LeiJiDingDan": "Kumulierte Bestellungen",
    "YaoQingHaoYou": "Freunde einladen",
    "LeiJiYaoQing": "Kumulierte Einladungen",
    "LJSY_Y_": "Kumulierte Einnahmen (Yuan)",
    "BHDJS": "Enthält ausstehende Abrechnung",
    "J7TSY_Y_": "Einnahmen der letzten 7 Tage (Yuan)",
    "J7TXZKH_R_": "Neue Kunden in den letzten 7 Tagen (Personen)",
    "KTXYJ": "Abhebbare Provision",
    "XYJYO": "Noch mehr Mühe needed",
    "ChangJianWenTi": "Häufig gestellte Fragen",
    "Q_ZMYJX_TG": "F: Wie funktioniert „Werben und verdienen\"?",
    "A_FXDPND_Z_": "A: Teilen Sie Links von Seiten mit dem Symbol „Verdienen\"im Shop, locken Sie Freunde zum Klicken. Wenn Freunde sich registrieren (Kundenbeziehung: Registrierung = Bindung) oder bestellen (Kundenbeziehung: Bestellung = Bindung) und Produkte mit dem Symbol „Verdienen\"im Shop kaufen, werden dies nach einer bestimmten Berechnungsmethode als Ihre Einnahmen aus „Werben und verdienen\"gezählt.",
    "Q_RHJS_TGZ": "F: Wie werden Einnahmen aus „Werben und verdienen\"berechnet?",
    "A_MGD_Z_TBD": "A: Jedes Produkt mit dem Symbol „Verdienen\"hat einen bestimmten Prozentsatz. Ohne dieses Symbol nimmt das Produkt nicht an „Werben und verdienen\"teil. Nachdem Freunde über Ihren Link erfolgreich bezahlt haben, wird die Provision basierend auf dem Prozentsatz jedes Produkts in der Bestellung berechnet (Provision für nicht beteiligte Produkte ist 0) und schließlich summiert, um die Provision für diese Bestellung zu ermitteln. Bei der Berechnung werden Versandkosten, Rückerstattungen, Rabatte ab bestimmtem Betrag usw. abgezogen, der endgültige Verkaufspreis gilt.",
    "Q_TGZQ_DSY": "F: Wann werden Einnahmen aus „Werben und verdienen\"gutgeschrieben?",
    "A_HYTGNDFX": "A: Nachdem Freunde über Ihren Link erfolgreich bezahlt haben, sehen Sie diese Werbung in den Werbebestellungen im Vertriebszentrum mit dem Status „Ausstehend zur Abrechnung\". Nachdem der Kunde die Lieferung bestätigt und die Bestellung abgeschlossen und abgerechnet ist, werden diese Einnahmen automatisch auf Ihr persönliches Konto übertragen und können jederzeit abgehoben werden",
    "Q_LJKH_LJY": "F: Keine Avatare oder Namen in der Liste der kumulierten Kunden und Einladungen?",
    "A_WXYQZYGZ": "A: WeChat erfordert, dass nur das Folgen eines zertifizierten Dienstkontos Avatare und Namen ermöglicht. Kunden von Shops mit zertifiziertem Dienstkonto folgen dem offiziellen Konto des Shops. Nicht zertifizierte Dienstkonten folgen dem offiziellen Konto „Yunshang Order\"und klicken dann auf eine beliebige Produktdetailseite des Shops, um Avatare und Namen zu erhalten.",
    "Q_WSMWASSG": "F: Warum erhalte ich keine Werbeeinnahmen, obwohl ich gemäß den obigen Regeln geteilt habe?",
    "A_1_HYKNBW": "A: 1. Freunde haben möglicherweise keine Kundenbeziehung mit Ihnen hergestellt (Freunde klickten auf Links anderer Verkäufer zur Registrierung oder Bestellung) 2. Wenn Freunde Ihren Link außerhalb der WeChat-Umgebung öffnen (z. B. im Standardbrowser des Telefons) und der Browser keine Cookies aktiviert hat, kann die Kundenbeziehung nicht aufgezeichnet werden, dh keine Werbebestellungen 3. Wenn trotzdem keine Werbebestellungen aufgezeichnet werden, wenden Sie sich an das Personal",
    "XiaoShouZhongXin": "Vertriebszentrum",

    //generalize-goods
    "SPMC_GG_BH": "Produktname / Spezifikation / Nummer",
    "YuJiZhuan": "Voraussichtlich verdienen",

    //invitation-home
    "YaoQingKa": "Einladungskarte",
    "YNYQJR_TGY": "Treten Sie uns bei, werben und Belohnungen gewinnen",
    "DJBCDXC": "Klicken Sie, um im Album zu speichern",
    "JYQKFSGHY_": "Senden Sie die Einladungskarte an Freunde, um Belohnungen für das Werben des Shops zu erhalten",

    //join-home
    "HuanYingJiaRu": "Willkommen bei uns",
    "YQNCW": "Wir laden Sie ein, ein",
    "LiJiJiaRu": "Sofort beitreten",

    //order-statistics
    "YuJiYongJin": "Voraussichtliche Provision",
    "YongJin": "Provision",
    "YuJiJiangLi": "Voraussichtliche Belohnung",
    "JiangLi": "Belohnung",
    "SPTGDD": "Produktwerbebestellungen",
    "YQJLDD": "Einladungsbelohnungsbestellungen",

    //performance-statistics
    "YeJiTongJi": "Leistungsstatistik",
    "LJKH_R_": "Kumulierte Kunden (Personen)",
    "SPYJ_Y_": "Produktprovision (Yuan)",
    "HanDaiJieSuan": "Enthält ausstehende Abrechnung",
    "XGMCJS": "Erläuterung verwandter Begriffe",
    "KeHu": "Kunde",
    "HFXYBDLKHG": "Käufer oder Vermittler mit Kundenbeziehung zum Vermittler",
    "YaoQing": "Einladung",
    "FXYCGYQDXJ": "Unter Vermittler, die erfolgreich vom Vermittler eingeladen wurden",
    "FXYTJKHGMH": "Provision, die der Vermittler erhält, nachdem er einen Kunden zum Kauf empfohlen hat",
    "XJFXYTGSPH": "Belohnung für den oberen Vermittler, nachdem der untere Vermittler Produkte beworben hat",

    //posters-promoting
    "NiCheng": "Spitzname",
    "HaiBaoTuiGuang": "Plakatwerbung",
    "JHBFSGHY_T": "Senden Sie das Plakat an Freunde, um Belohnungen für das Werben des Shops zu erhalten",

    //settlement-home
    "JieSuanZhongXin": "Abrechnungszentrum",
    "KTXJE": "Abhebbarer Betrag",
    "TiXianJiLu": "Abhebungsaufzeichnungen",

    //withdraw-account
    "KHRXMBNWK": "Kontoinhaber-Name darf nicht leer sein!",
    "KHHBNWK": "Bank darf nicht leer sein!",
    "YHKHBNWK": "Kartennummer darf nicht leer sein!",
    "SFZTPBNWK": "Foto des Ausweises darf nicht leer sein!",
    "YHKTPBNWK": "Foto der Bankkarte darf nicht leer sein!",
    "BaoCunChengGong": "Erfolgreich gespeichert!",
    "SCSFZ": "Ausweis hochladen",
    "SCYHK": "Bankkarte hochladen",
    "BaoCun": "Speichern",
    "TiXianZhangHu": "Abhebekonto",
    "TS_QTXZSXX": "Hinweis: Bitte richtige Informationen eingeben, Abhebung nur nach Genehmigung möglich",
    "KHRXM": "Kontoinhaber-Name",
    "KaiHuHang": "Bank",
    "YinhangKaHao": "Bankkartennummer",
    "QSRZSXM": "Bitte richtigen Namen eingeben",
    "QSRKHHMC": "Bitte Banknamen eingeben",
    "QSRYHKH": "Bitte Bankkartennummer eingeben",

    //withdraw-deposit
    "QXSZTXZH": "Bitte zuerst Abhebekonto einrichten",
    "QuSheZhi": "Zur Einrichtung",
    "JEXY10Y_BKT": "Betrag unter 10 Yuan, Abhebung nicht möglich!",
    "JECGKTXJE": "Betrag übersteigt abhebbaren Betrag!",
    "CGDRKTXSX_": "Tägliches Abhebungslimit überschritten, tägliches Limit beträgt 20000 Yuan!",
    "QueDingJiang": "Sind Sie sicher, dass Sie",
    "ZhuanDaoYuE": "in Guthaben umwandeln möchten?",
    "_JEDY10YSB": "1. Beträge unter 10 Yuan können nicht abgehoben werden;",
    "_BCTXDZSJ": "2. Die Auszahlungszeit für diese Abhebung beträgt 5 Werktage ab erfolgreicher Einreichung der Abhebung, tägliches Limit beträgt 20000 Yuan;",
    "_GBSRWHSS": "3. Dieser Betrag ist versteuert, Sie sind selbst verantwortlich für die Deklaration und Zahlung der Einkommensteuer bei den zuständigen Behörden!",
    "_ZDYEKYYS": "4. Umgewandeltes Guthaben kann für Einkäufe im Shop verwendet werden;",
    "TXSQCG_QDD": "Abhebung beantragt, bitte auf Genehmigung warten",
    "JEDYKTXJE_": "Betrag übersteigt abhebbaren Betrag, kann nicht in Guthaben umgewandelt werden!",
    "ZZYECG_QDG": "Guthabenübertragung erfolgreich, bitte im persönlichen Zentrum überprüfen!",
    "BenCiTiXian": "Diese Abhebung",
    "ZhuangDaoYuE": "In Guthaben umwandeln",
    "TiXianDao": "Abheben auf",
    "JEW0BKZZYE": "Betrag 0 kann nicht in Guthaben umgewandelt werden!",
    "DRTXSX2WY": "Tägliches Abhebungslimit 20.000 Yuan",
    "QuanBuTiXian": "Ganzen Betrag abheben",
    "QueRenTiXian": "Abhebung bestätigen",

    //goods-filter-tab
    "ZuiChangGouMai": "Am häufigsten gekauft",
    "MoRenPaiXu": "StandardSortierung",
    "ZongHe": "Kombiniert",
    "FenLei": "Kategorie",
    "XiaoLiangYouXian": "Nach Verkaufszahl",
    "XiaoLiang": "Verkaufszahl",
    "JiaGe": "Preis",
    "ShaiXuan": "Filtern",
    "ZuiJinGouMai": "Kürzlich gekauft",
    "CuXiaoYouXian": "Nach Promotion",
    "QuanBuFenLei": "Alle Kategorien",
    "ZhiKanCuXiao": "Nur Promotionen",
    "XuanZeFenLei": "Kategorie auswählen",
    "QXZFL": "Bitte Kategorie auswählen",

    //goods-list-default
    "ZWXGSP": "Keine zugehörigen Produkte",

    //goods-brand-list
    "PinPaiHui": "Markensammlung",

    //goods-classify-filter
    "TuiJianFenLei": "Empfohlene Kategorien",
    "ShangPinFenLei": "Produktkategorien",
    "GengDuo": "Mehr",

    //goods-detail
    "DLZHBSDQQY": "Anmeldungskonto ist nicht das aktuelle Unternehmenskonto",
    "GXNHQ": "Glückwunsch, Sie erhalten",
    "SZWSCJGH_C": "Teilen nur möglich nach Einstellung des Mini-Shop-Preises",
    "JHDJSHS_": "Verbleibende Zeit bis zum Ende der Aktion:",
    "DLHKFX": "Teilen nach Anmeldung möglich",
    "ZZHQXX_QSH": "Informationen werden abgerufen, bitte später erneut versuchen",
    "Zhang": "Stück",
    "Tian": "Tag",
    "QXZGGZQPD": "Bitte zuerst Spezifikation auswählen, um Beleuchtung einzustellen!",
    "Yuan": "Yuan",
    "XS_F_M": "Stunden/Minuten/Sekunden",

    //integral
    "WoDeJiFen": "Meine Punkte",
    "DaBaiLe": "Hat",
    "JiFen": "Punkte",
    "DeHuiYuan": "der Mitglieder besiegt",
    "ZhuanJiFen": "Punkte verdienen",
    "JiFenMingXi": "PunkteDetails",
    "HuanLiPin": "Geschenke einlösen",
    "CKGDHL": "Mehr tolle Geschenke anzeigen",
    "ChaDingDan": "Bestellung überprüfen",

    //integral-convert
    "DHSLBNCG": "Anzahl der Einlösungen darf nicht übersteigen",
    "DuiHuanShuLiang": "Anzahl der Einlösungen",
    "SuoXuJiFen": "Benötigte Punkte",

    //integral-detail
    "LiPinXiangQing": "Geschenkd Details",
    "WoYaoDuiHuan": "Ich möchte einlösen",
    "ShengYu": "Verbleibend",
    "TuWenXiangQing": "Bild-Text-Details",
    "Jian": "Stück",
    "YiDuiWan": "Völlig eingelöst",

    //integral-filter
    "FenLeiShaiXuan": "Kategoriefilter",
    "JiFenShaiXuan": "Punktefilter",

    //integral-flow
    "JiFenShouRu": "Punkteeinnahmen",
    "JiFenZhiChu": "Punkteausgaben",

    //integral-logistics
    "DingDanGenZong": "Bestellungsverfolgung",
    "WuLiuGongSi": "Logistikfirma",
    "WuLiuDanHao": "Logistiknummer",

    //integral-order
    "DingDanLieBiao": "Bestellungsliste",
    "YiFaHuo": "Versendet",
    "JiFenDingDan": "Punktebestellung",
    "ChaKanWuLiu": "Logistik anzeigen",

    //integral-order-create
    "LPSLBZ_QCX": "Nicht genug Geschenke, bitte erneut bezahlen",
    "JiFenBuZu": "Nicht genug Punkte",
    "ZhiFuXinXi": "Zahlungsinformationen",
    "JiXuGuangGuang": "Weiter browsen",
    "QTXSHXX": "Bitte Lieferinformationen eingeben",
    "DuiHuanChengGong": "Erfolgreich eingelöst",
    "LPDHQR": "Geschenkeinlösung bestätigen",
    "SCCKJ": "Marktreferenzpreis",
    "LiJiZhiFu": "Sofort bezahlen",

    //integral-order-detail
    "DingDanXiangQing": "Bestellungsdetails",
    "DingDanZhuangTai": "Bestellungsstatus",
    "DingDanBianHao": "Bestellnummer",
    "DuiHuanShiJian": "Einlösungszeit",
    "ShouHuoXinXi": "Lieferinformationen",
    "HuaFeiJiFen": "Verwendete Punkte",

    //integral-rule
    "QDZJF": "Anmelden und Punkte verdienen",
    "XDZJF": "Bestellen und Punkte verdienen",
    "1_MRQD_JL": "1. Täglich anmelden, {num} Punkte erhalten",
    "2_LXQD3T_EW": "2. 3 Tage in Folge anmelden, extra {num} Punkte",
    "3_LXQD7T_EW": "3. 7 Tage in Folge anmelden, extra {num} Punkte",
    "DLZJF": "Anmelden und Punkte verdienen",
    "MRDLYSDHSC": "Täglich {name}-Shop besuchen, {num} Punkte erhalten",
    "DDWCHKHDYD": "Nach Abschluss der Bestellung Punkte entsprechend {num} × Bestellbetrag erhalten",

    //integral-rule-detail
    "GuiZe": "Regeln",

    //integral-sign
    "QianDaoYouLi": "Anmelden mit Belohnung",
    "QianDaoGuiZe": "AnmeldeRegeln",
    "YLXQD": "Kontinuierlich angemeldet",
    "YLXQD1T": "{num} Tage kontinuierlich angemeldet",
    "QDCG_NYJLX": "Anmeldung erfolgreich, Sie sind {num} Tage kontinuierlich angemeldet",
    "QDCG_BCHD1": "Anmeldung erfolgreich, Sie erhalten {num} Punkte",
    "BCQDHD4JF_": "Diese Anmeldung bringt {num} Punkte, toll!",
    "QSRBZ": "Bitte Bemerkung eingeben",
    "DingDanZengPin": "Bestellgeschenk",
    "GuiGeBianHao": "Spezifikationsnummer",
    "GuiGe": "Spezifikation",

    //combined-pay
    "CDDWXFK": "Diese Bestellung erfordert keine Zahlung",
    "YHYEBZ": "Benutzerguthaben unzureichend!",
    "ZFJEBNW0": "Zahlungsbetrag darf nicht 0 sein!",
    "ZFJEBNDYDD": "Zahlungsbetrag darf nicht höher als der ausstehende Bestellbetrag sein",
    "DFKJE": "Ausstehender Zahlungsbetrag",
    "FuKuanFangShi": "Zahlungsart",
    "FuJian": "Anhang",
    "ZHYFZ": "Konto kopiert",
    "GHSKZH": "Empfängerkonto wechseln",
    "SYXXZFQSCF": "Bei Offline-Zahlung bitte Zahlungsscreenshot hochladen, damit Finanz die Zahlung bestätigen kann!",
    "XXZF_BXXZS": "Offline-Zahlung, Empfängerkonto muss ausgewählt werden",
    "DingDanZhiFu": "Bestellung bezahlen",
    "ZFFS_HDFK": "Zahlungsart: Nachnahme",
    "BCFKJE": "Dieser Zahlungsbetrag",
    "YuE": "Guthaben",
    "FuZhiZhangHao": "Konto kopieren",
    "WSZXCXZFPZ": "Keine Mini-Programm-Zahlungskonfiguration",
    "XCXZFZHJY": "Mini-Programm-Zahlungskonto deaktiviert",
    "SRZFJE": "Zahlungsbetrag eingeben",
    "FuKuanZhangHu": "Zahlungskonto",
    "QueRenZhiFu": "Zahlung bestätigen",
    "ShaoHouZhiFu": "Später bezahlen",

    //order
    "FKJLYTJ_DD": "Zahlungsdatensatz hinzugefügt, warten auf Finanzprüfung",
    "JiXuGuang": "Weiter browsen",
    "BenCiFuKuan": "Diese Zahlung",
    "FuKuanChengGong": "Zahlung erfolgreich",
    "ZhiFuFangShi": "Zahlungsart",
    "ZhiFuDingDan": "Zahlungsbestellung",

    //order-batch-pay
    "QXXZSXZFDD": "Bitte zuerst zu zahlende Bestellungen auswählen",
    "PiLiangFuKuan": "Stapelzahlung",
    "FuKuan": "Bezahlen",
    "QuFuKuan": "Zur Zahlung",

    //order-create-result
    "YingFuJinE": "Zu zahlender Betrag",
    "XiaDanShiJian": "Bestellzeit",

    //order-deliver
    "SFQRSH": "Lieferung bestätigen?",
    "DDQRSH": "Bestellung bestätigen",
    "DFHSP": "Ausstehend zu versendende Produkte",
    "ShangPinShuLiang": "Produktmenge",
    "ChuKuShiJian": "Auslagerungszeit",
    "FaHuoShiJian": "Versandzeit",
    "WuLiuBeiZhu": "Logistikbemerkung",
    "QueRenShouHuo": "Lieferung bestätigen",
    "RYFK_QJSYG": "Wenn bereits bezahlt, bitte rechtzeitig mit dem Administrator联系",
    "QSRQXYY": "Bitte Grund für Stornierung eingeben",
    "H_DDJZDGB_QJKF": "später wird die Bestellung automatisch geschlossen, bitte so schnell wie möglich bezahlen",
    "TuiHuoQingKuang": "Rücksendungsstatus",
    "DingDanZongE": "Gesamter Bestellbetrag",
    "DingDanBeiZhu": "Bestellbemerkung",
    "FaHuoQingKuang": "Versandstatus",
    "DingDanFuJian": "Bestellungsanhänge",
    "ShenQingTuiHuo": "Rücksendung beantragen",
    "G1TDSHJL_QRS": "{num} ausstehende Lieferungen, Lieferung bestätigen?",
    "DaiXiaDan": "Bestellung für Kunden aufgeben",
    "DingDanHao": "Bestellnummer",
    "XiaDanFangShi": "Bestellart",
    "TuiHuoDan": "Rücksendungsformular",
    "ShangPinZongE": "Gesamter Produktbetrag",
    "YunFei_ZongZhong": "Versandkosten (Gesamtgewicht",
    "SF_SPWS": "Steuer (Produkt ohne Steuer",
    "TePiJia": "Sonderpreis",
    "FuKuanQingKuang": "Zahlungsstatus",
    "TiaoJiLu": "Einträge",
    "ZaiLaiYiDan": "Noch eine Bestellung",
    "MuLiuXinXi": "Logistikinformationen",
    "QDSCGDD_": "Diese Bestellung löschen?",
    "YiQueRen": "Bestätigt",
    "YiShouHuo": "Erhalten",
    "DaiFuJinE": "Ausstehender Betrag",
    "YiFuJinE": "Bezogener Betrag",
    "ZanWuJiLu": "Keine Einträge",
    "SPMC_DDH": "Produktname / Bestellnummer",
    "FuKuanZhuangTai": "Zahlungsstatus",
    "FaHuoZhuangTai": "Versandstatus",
    "QiShiShiJian": "Startzeit",
    "ZhongZhiShiJian": "Endzeit",

    //order-list
    "CaoZuoChengGong": "Operation erfolgreich",
    "ZBKGM": "Zurzeit nicht kaufbar",
    "DQDDSPYXJ": "Aktuelles Bestellprodukt ist offline",
    "DQDDBFSPYXJ": "Einige Produkte der aktuellen Bestellung sind offline",
    "JTJSJSP": "Nur online Produkte hinzufügen",
    "DingHuoDan": "Bestellformular",

    //order-log
    "DingDanRiZhi": "Bestellungsprotokoll",

    //order-logistics
    "FuZhiChengGong": "Erfolgreich kopiert",
    "FuZhiShiBai": "Kopieren fehlgeschlagen",
    "FuZhi": "Kopieren",
    "BoDa": "Anrufen",
    "WCWLDHXX": "Keine Informationen zu dieser Logistiknummer",

    //order-pay
    "ZFCS_QCXXD": "Zahlungszeitüberschreitung, bitte neue Bestellung aufgeben",
    "YQYYCKZF": "Vorschussguthaben-Zahlung aktiviert",
    "BNDYDFKJE": "Darf nicht höher als der ausstehende Betrag sein",
    "ZFJEBNWK": "Zahlungsbetrag darf nicht leer sein",
    "QXAPFK_FKH": "Bitte zuerst Zahlung arrangieren, nach Zahlung Screenshot hochladen, damit Finanz die Zahlung bestätigen kann",
    "DDTJCG_QJS": "Bestellung erfolgreich eingereicht, bitte rechtzeitig bezahlen",
    "QXZFKFS": "Bitte Zahlungsart auswählen",
    "SYYEZFH_HX": "Nach Guthaben-Zahlung bleibt zu bezahlen",
    "FuKuanJiLu": "Zahlungsaufzeichnungen",
    "ZWFKJL": "Keine Zahlungsaufzeichnungen",
    "FuKuanXiangQing": "Zahlungsdetails",
    "FuKuanJinE": "Zahlungsbetrag",
    "ZhiDan": "Ersteller",
    "ShenHe": "Prüfung",
    "ZuoFei": "Stornieren",
    "ZuoFeiYuanYin": "Grund für Stornierung",
    "GLDHD": "Verknüpftes Bestellformular",
    "HeXiaoJinE": "Abrechnungsbetrag",
    "HeXiaoZhuangTai": "Abrechnungsstatus",
    "DanJuZhuangTai": "Dokumentenstatus",
    "KeHuMingCheng": "Kundenname",
    "ZhangDanHao": "Rechnungsnummer",
    "ShouKuanZhangHao": "Empfängerkonto",
    "ShouKuanShiJian": "Eingangszeit",
    "FuKuanPingZheng": "Zahlungsnachweis",
    "GeFuJian": "Anhänge",

    //order-statistics
    "DingDanTongJi": "Bestellungsstatistik",
    "DingHuo0Bi": "{num} Bestellungen",

    //order-statistics-detail
    "DDTJMX": "Bestellungsstatistikdetails",
    "AGGTJ": "Nach Spezifikation",
    "AFLTJ": "Nach Kategorie",
    "DDJE_Y": "Bestellbetrag/Yuan",
    "DHSP_Z": "Bestellte Produkte/Arten",
    "DingHuoDan_Bi": "Bestellformulare/Stücke",
    "DingHuoShangPin": "Bestellte Produkte",
    "JinE": "Betrag",

    //refund-list
    "TuiHuo": "Rücksendung",

    //refund-apply
    "THDHWBC_QD": "Rücksendungsformular noch nicht gespeichert, sicher gehen?",
    "QSRSQTHJE": "Bitte beantragten Rücksendungsbetrag eingeben",
    "QSRTHJE": "Bitte Rücksendungsbetrag eingeben",
    "QSRBZXX": "Bitte Bemerkungen eingeben",
    "YingTuiJinE": "Zu rückerstattender Betrag",
    "TJTHSQ": "Rücksendungsantrag einreichen",
    "QXXZDHQD": "Bitte zuerst Bestellliste auswählen",
    "DingHuoQingDan": "Bestellliste",
    "SQTHJE": "Beantragter Rücksendungsbetrag",
    "DJXZSP": "Klicken Sie, um Produkte auszuwählen",
    "TuiHuoJinE": "Rücksendungsbetrag",

    //refund-detail
    "THDDXQ": "Rücksendungsdetails",
    "YiTuiHuo": "Zurückgesendet",
    "YiTuiKuan": "Rückerstattet",
    "THDZT": "Rücksendungsstatus",
    "TuiHuoDanHao": "Rücksendungsnummer",
    "TuiHuoShiJian": "Rücksendungszeit",
    "TuiHuoCangKu": "Rücksendungslager",
    "THLXR": "Rücksendungskontakt",
    "TuiHuoQingDan": "Rücksendungsliste",
    "TuiKuanZongE": "Gesamter Rückerstattungsbetrag",
    "TuiKuanQingKuang": "Rückerstattungsstatus",
    "DaiTuiJinE": "Ausstehender Rückerstattungsbetrag",
    "YiTuiJinE": "Rückerstatteter Betrag",

    //refund-product
    "SPMC_BH_GG": "Produktname / Nummer / Spezifikationsnummer / Barcode",
    "GZD1TJG": "1 Ergebnis gefunden",
    "JiaRuQingDan": "Zur Liste hinzufügen",

    //refund-result
    "ShenQingChengGong": "Antrag erfolgreich",
    "THDTJCG": "Rücksendungsformular erfolgreich eingereicht",
    "ChaKanXiangQing": "Details anzeigen",

    //goods-package-floor
    "HDWKS_WDZL": "Aktion noch nicht gestartet, später wiederkommen",
    "HDYJS_XCZD": "Aktion beendet, nächstes Mal früher kommen",
    "ZWSZBT": "Titel noch nicht eingestellt",
    "ChaKanGengDuo": "Mehr anzeigen",

    //goods-promotion-floor
    "HCDZSJC": "Zeitdifferenz durch Cache",
    "DLCKCXJ": "Anmelden, um Promotionspreis zu sehen",
    "ZWSZCX": "Keine Promotion eingestellt",
    "JuKaiShi": "Bis zum Start",
    "Song": "Geben",
    "JuJieShu": "Bis zum Ende",
    "YiJieShu": "Beendet",

    //search-floor
    "XiaoXi": "Nachrichten",
    "SaoMaXiaDan": "Scannen und bestellen",

    //home-page-custom
    "WZLCSJ": "Unbekannte Stockdaten",

    //jump-error
    "QXZYSDHAPP": "Bitte Yunshang Order APP herunterladen",
    "QMTYQYGLD": "Vollständige Unternehmensverwaltungserfahrung",
    "XZYSDHAPP": "Yunshang Order APP herunterladen",
    "HQGLDWZTY": "Vollständige Verwaltungsfunktionen erhalten",
    "JXTYDHD": "Bestellfunktion weiterverwenden",

    //notice-detail
    "GongGaoXiangQing": "Ankündigungsdetails",
    "GongGaoFuJian": "Ankündigungsanhänge",

    //shop-error
    "NFWDYMBCZO": "Die von Ihnen besuchte Seite existiert nicht~",
    "KeNengYuanYin": "Mögliche Gründe",
    "1_ZDZLSRCWD": "1. Falsche Adresse in der Adressleiste eingegeben;",
    "2_DJLGQLJ": "2. Abgelaufener Link geklickt.",

    //shop-index
    "GuanLiDuan": "Verwaltungsseite",
    "ZhuCe": "Registrieren",
    "HYNTYYSDH": "Willkommen bei Yunshang Order",
    "TYZHSJHDQG": "Testkonto-Daten werden regelmäßig aktualisiert, bitte keine wichtigen Informationen eingeben",
    "TYZHZDNRSJ": "Inhalte und Daten im Testkonto sind fiktiv, bitte keine wichtigen Informationen eingeben",
    "ZHZCCG": "Konto erfolgreich registriert",
    "DengLuZhangHao": "Anmeldekonto",
    "CSMMW": "Standardpasswort ist",
    "GNFYHQL": "Gutscheine wurden Ihnen gesendet",
    "Man1YuanKeYong": "Ab {num} Yuan verwendbar",
    "LQH1TNKY": "Verwendbar innerhalb von {day} Tagen nach Einlösung",
    "YiJianLingQu": "Ein Klick einlösen",
    "GXNHD1ZYHQ": "Glückwunsch, Sie erhalten {num} Gutscheine",
    "Gong1Yuan": "Insgesamt {num} Yuan",
    "LiJiShiYong": "Sofort verwenden",

    //shop-login
    "NHWDL": "Sie sind noch nicht angemeldet",

    //shop-notice
    "ShangChengGongGao": "Shopankündigungen",
    "ZanWuGongGao": "Keine Ankündigungen",
    "1GeFuJian": "{num} Anhänge",

    //deposit-detail
    "KouKuan": "Abzug",
    "ChongZhi_Kuan": "Aufladen",
    "KouKuanZuoFei": "Abzug storniert",
    "ChongZhiZuoFei": "Aufladung storniert",
    "ZhangHuMingXi": "Kontodetails",
    "ZhangHuYuE": "Kontoguthaben",
    "LiJiChongZhi": "Sofort aufladen",

    //deposit-recharge
    "CZJEBNXY1Y": "Aufladebetrag darf nicht weniger als 1 Yuan sein",
    "QSRZQDSZ": "Bitte richtigen Wert eingeben",
    "ZDYJE": "Benutzerdefinierter Betrag",
    "ZWKTXSCZGN": "Online-Aufladungsfunktion noch nicht verfügbar",
    "ShiFuJinE": "Tatsächlicher Zahlungsbetrag",
    "ZhangHuChongZhi": "Konto aufladen",
    "QXZCZJE": "Bitte Aufladebetrag auswählen",
    "QSRCZJE": "Bitte Aufladebetrag eingeben",
    "QLXNDZSYWY": "Bitte Ihren persönlichen Verkäufer zum Aufladen kontaktieren",
    "ShouJia": "Verkaufspreis",
    "YiShouQing": "Ausverkauft",
    "ChongZhiJinE": "Aufladebetrag",
    "QueRenFuKuan": "Zahlung bestätigen",

    //deposit-recharge-result
    "QSDDID": "Bestell-ID fehlt",
    "ChongZhiChengGong": "Aufladung erfolgreich",
    "ChongZhiShiBai": "Aufladung fehlgeschlagen",
    "CLZ_QSH...": "Verarbeitung, bitte warten...",
    "ChongZhiFangShi": "Aufladeart",
    "ChongZhiShiJian": "Aufladezeit",
    "JYLSH": "Transaktionsnummer",
    "FanHuiShangCheng": "Zurück zum Shop",

    //recharge-online
    "ZFSB_QCS": "Zahlung fehlgeschlagen, bitte erneut versuchen",
    "ZFYQX": "Zahlung abgebrochen",
    "ZFYC_QCS": "Zahlungsfehler, bitte erneut versuchen",

    //user
    "LingQuanZhongXin": "Gutscheinzentrum",
    "WeiShiYong": "Nicht verwendet",
    "YiShiYong": "Verwendet",
    "ZWYHQ": "Keine Gutscheine",

    //keep-list
    "YiGouMai": "Gekauft",
    "ChangYongQingDan": "Übliche Liste",
    "WoDeShouCang": "Meine Sammlung",
    "QuGouWuChe": "Zum Warenkorb",
    "GeShangPin": "Produkte",

    //login
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "Bitte Konto eingeben!",
    "QSRMM": "Bitte Passwort eingeben!",
    "QSRDLZH": "Bitte Anmeldekonto eingeben",
    "JiZhuMiMa": "Passwort merken",
    "WangJiMiMa": "Passwort vergessen?",
    "DengLu": "Anmelden",
    "DLZHBCZ_QL": "Anmeldekonto existiert nicht, bitte Administrator um Freischaltung",
    "GQYZHSBJY_": "Dieses Unternehmenskonto ist deaktiviert, bitte Yunshang Order kontaktieren",
    "GQYZHSYQJS_": "Testphase des Unternehmenskontos abgelaufen, bitte Yunshang Order kontaktieren",
    "GQYZHYGQL_": "Dieses Unternehmenskonto ist abgelaufen, Erneuerung erforderlich, bitte Yunshang Order kontaktieren",
    "LiJiTiYan": "Sofort testen",

    //my-collect
    "YiChuChengGong": "Erfolgreich entfernt",
    "QueHuo": "Nicht auf Lager",
    "YCSCJ": "Aus Sammlung entfernen",

    //order-message
    "SheZhiChengGong": "Einstellung erfolgreich",
    "ZWWDXX": "Keine ungelesenen Nachrichten",
    "QuanBuYiDu": "Alle als gelesen markieren",
    "DingDanXiaoXi": "Bestellungsnachrichten",
    "YiQiang": "Erhalten",
    "LiJiLingQu": "Sofort einlösen",
    "LingQuanHou": "Nach Einlösung des Gutscheins",
    "TianNeiKeYong": "innerhalb von Tagen verwendbar",
    "QSRSJH": "Bitte Handynummer eingeben",
    "QSRYZM": "Bitte Bestätigungscode eingeben",
    "QSRXMM": "Bitte neues Passwort eingeben",
    "QSRZQSJGS": "Bitte richtige Handyformat eingeben",
    "ChongZhiMiMa": "Passwort zurücksetzen",
    "QSRNDSJHM": "Bitte Ihre Handynummer eingeben",
    "QSRDXYZ": "Bitte SMS-Bestätigung eingeben",
    "HQYZM": "Bestätigungscode erhalten",
    "HKCXHQ": "erneut erhältlich nach",
    "QSR6_20WSZHZ": "Bitte Passwort aus 6-20 Ziffern oder Buchstaben eingeben",

    //share-setting
    "QSRSPJGBL": "Bitte Produktpreisprozentsatz eingeben",
    "SPJGBLBXDY": "Produktpreisprozentsatz muss ≥100 und <999.99 sein",
    "DPMCZBZCTS": "Shopname unterstützt derzeit keine Sonderzeichen",
    "LXRZBZCTSF": "Kontakt unterstützt derzeit keine Sonderzeichen",
    "LXFSZBZCTS": "Kontaktart unterstützt derzeit keine Sonderzeichen",
    "LXDZZBZCTS": "Kontaktadresse unterstützt derzeit keine Sonderzeichen",
    "DPJJZBZCTS": "Shopbeschreibung unterstützt derzeit keine Sonderzeichen",
    "QSRDPJJ_ZD": "Bitte Shopbeschreibung eingeben, max. 50 Zeichen",
    "FenXiangSheZhi": "Teileinstellungen",
    "NDWSCSPJG": "Ihr Mini-Shop-Produktpreis",
    "NDDHJ_": "Ihr Bestellpreis ×",
    "LXXX_KBJ_": "Kontaktinformationen (bearbeitbar)",
    "DianPuMingCheng": "Shopname",
    "JianJie": "Beschreibung",
    "QSRDPMC": "Bitte Shopname eingeben",
    "LianXiRen": "Kontaktperson",
    "QSRLXR": "Bitte Kontaktperson eingeben",
    "LianXiFangShi": "Kontaktart",
    "QSRLXFS": "Bitte Kontaktart eingeben",
    "LianXiDiZhi": "Kontaktadresse",
    "QSRLXDZ": "Bitte Kontaktadresse eingeben",

    //user
    "WoDeDingDan": "Meine Bestellungen",
    "ZuiJinLiuLan": "Kürzlich angesehen",
    "ShouCangShangPin": "Gespeicherte Produkte",
    "BDYYZH_ZC": "Bestehendes Konto binden | Neues Konto registrieren",
    "DL_ZC": "Anmelden | Registrieren",
    "BangDingShouJi": "Handy binden",
    "TS_BDSJHM_": "Hinweis: Handynummer binden erhöht die Konto­sicherheit!",
    "ChaKanQuanBu": "Alle anzeigen",
    "ShouHuoDiZhi": "Lieferadresse",
    "LianXiWoMen": "Kontaktieren Sie uns",
    "SheZhi": "Einstellungen",
    "QuQianDao": "Zum Anmelden",
    "QianDao": "Anmelden",
    "JiFenShangCheng": "Punkteshop",
    "TuiGuangShangPin": "Produkte bewerben",
    "QuChaKan": "Zur Ansicht",
    "JiFenHuanLi": "Punkte gegen Geschenke eintauschen",
    "DYSPBQ": "Produktetikett drucken",

    //user-about
    "GYYSDH": "Über Yunshang Order",
    "YQHYSMEWM_": "Freunde einladen, QR-Code scannen, direkt herunterladen und installieren",
    "DangQianBanBen": "Aktuelle Version",

    //user-address
    "ZWSHDZ": "Keine Lieferadresse",
    "WoDeDiZhi": "Meine Adressen",
    "ZhiNengShiBie": "Intelligente Erkennung",
    "ZTDZXXKZNS": "Adressinformationen einfügen, um Name, Telefon und Adresse intelligent zu erkennen",
    "MoRen": "Standard",
    "QRSCDZ": "Adresse löschen?",
    "SHRXM": "Empfängername",
    "SJHMHGDDHZ": "Mindestens Handy- oder Festnetznummer eingeben",
    "QSRSHRXM": "Bitte Empfängername eingeben",
    "ShouJiHaoMa": "Handynummer",
    "GuDingDianHua": "Festnetznummer",
    "QSRGDDH": "Bitte Festnetznummer eingeben",
    "SuoZaiDiQu": "Region",
    "QSRSZDQ": "Bitte Region eingeben",
    "QSRXXDZ": "Bitte detaillierte Adresse eingeben!",
    "QSRZQDSJHM": "Bitte richtige Handynummer eingeben",
    "QSRZQDGDDH": "Bitte richtige Festnetznummer eingeben",
    "XiangXiDiZhi": "Detaillierte Adresse",
    "MoRenDiZhi": "Standardadresse",
    "SWMRDZ": "Als Standardadresse festlegen",
    "BCBSY": "Speichern und verwenden",

    //user-bing-one
    "QSRSJHM": "Bitte Handynummer eingeben",
    "GYHYZC": "Dieser Benutzer ist bereits registriert",
    "GSJHMYJZCG": "Diese Handynummer ist bereits registriert",
    "QZJDLJK": "Direkt einloggen",
    "QuDengLu": "Zum Anmelden",
    "BDHKYTGSJH": "Nach dem Binden kann über die Handynummer eingeloggt werden, um das Passwort wiederzuerhalten und die Konto­sicherheit zu erhöhen",
    "_BDHKYTGSJ": "*Nach dem Binden kann über die Handynummer eingeloggt werden, um das Passwort wiederzuerhalten und die Konto­sicherheit zu erhöhen",
    "QSRSJYZM": "Bitte Handy-Bestätigungscode eingeben",
    "BDXSJ": "Neues Handy binden",
    "DXYZM": "SMS-Bestätigungscode",
    "XiaYiBu": "Weiter",
    "TGCBZ": "Diesen Schritt überspringen",

    //user-bing-two
    "DBDSJHMBCZ": "Zu bindende Handynummer existiert nicht!",
    "QSRDLMM": "Bitte AnmeldePasswort eingeben!",
    "_GSJHMYBDY": "*Diese Handynummer ist bereits an ein Yunshang Order-Konto gebunden, Handy-AnmeldePasswort überprüfen, um das aktuelle Konto zu binden",
    "DQZHMMJTBW": "Aktuelles KontoPasswort wird als Handy-AnmeldePasswort synchronisiert",
    "DangQianZhangHao": "Aktuelles Konto",
    "QDYJZ": "Sind Sie sicher, dass Sie diese",
    "JSPSCM": "Produkte löschen möchten?",
    "ShanChuChengGong": "Erfolgreich gelöscht!",

    //user-info
    "SJGSCW": "Falsches Handyformat",
    "YXGSCW": "Falsches E-Mail-Format",
    "WoDeZhangHao": "Mein Konto",
    "YouXiang": "E-Mail",
    "ShouJi": "Handy",
    "XingMing": "Name",
    "XiuGaiTouXiang": "Avatar bearbeiten",
    "JiBenXinXi": "Grundinformationen",
    "ZhangHaoAnQuan": "Konto­sicherheit",
    "XiuGaiMiMa": "Passwort bearbeiten",
    "DianJiBangDing": "Klicken Sie zum Binden",
    "RYDSHTY_QL": "Wenn verloren oder deaktiviert, sofort ersetzen, um Konto Diebstahl zu verhindern",
    "WBZNDZHAQ_": "Zur Sicherstellung Ihrer Konto­sicherheit, bitte Handy binden",
    "QSRNDXM": "Bitte Ihren Namen eingeben",
    "QSRNDDH": "Bitte Ihre Telefonnummer eingeben",
    "QSRNDYX": "Bitte Ihre E-Mail eingeben",

    //user-setting
    "QCHCHXCXDL": "Nach Cache-Löschung erneut einloggen",
    "QingChuHuanCun": "Cache löschen",
    "QDYQCHCM": "Sind Sie sicher, dass Sie den Cache löschen möchten?",
    "TuiChuDengLu": "Abmelden",
    "ZhangHaoZhuXiao": "Konto löschen",
    "QieHuanZhangHao": "Konto wechseln",

    //user-supplier
    "LianXi": "Kontakt",
    "GongSiDianHua": "Firmentelefon",
    "DiZhi": "Adresse",

    //vouchers-detail
    "DJQMX": "Gutscheindetails",

    //vouchers-list
    "BuKeYong": "Nicht verwendbar",
    "KeYong": "Verwendbar",
    "ZWDJQ": "Keine Gutscheine",
    "ZongEDu": "Gesamtwert",
    "FaFangShiJian": "Ausgabedatum",
    "EDYYW": "Guthaben aufgebraucht",
    "QBSPKY": "Für alle Produkte verwendbar",

    //vouchers-select-list
    "WDDJQ": "Meine Gutscheine",
    "KYDJQ": "Verwendbare Gutscheine",
    "DJQKDK": "Gutschein kann abziehen",
    "CKKYSP": "Verwendbare Produkte anzeigen",
    "BKYDJQ": "Unverwendbare Gutscheine",
    "BKYYY_ZWFH": "Grund für Unverwendbarkeit: Keine passenden Produkte",

    //goods-detail
    "DQSPWSCGGT": "Keine Spezifikationsbilder für dieses Produkt hochgeladen, Beleuchtungseinstellung nicht unterstützt!",
    "BoFangShiPin": "Video abspielen",
    "Gong1GeGuiGe": "Insgesamt {num} Spezifikationen",
    "YiXuanGuiGe": "Ausgewählte Spezifikation",
    "XuanGuiGe": "Spezifikation auswählen",
    "LingQuan": "Gutschein einlösen",
    "1ZhongCuXiao": "{num} Promotionen",
    "1ZhangKeYong": "{num} verfügbar",
    "ZuiGaoKeSheng": "Maximal sparen",
    "ShangPinTaoCan": "Produktpakete",
    "Gong1GeTaoCan": "Insgesamt {num} Pakete",
    "ShangPinCanShu": "Produktparameter",
    "ZhanKai": "Ausklappen",
    "YiShouCang": "Bereits gespeichert",
    "ShouCang": "Speichern",
    "KeFu": "Kundenservice",
    "XiangQing": "Details",
    "TuiJian": "Empfohlen",
    "BianHao": "Nummer",
    "ShangPinXinXi": "Produktinformationen",
    "KLYHQ": "Verfügbare Gutscheine",
    "KuCunBuZu": "Nicht genug Lagerbestand",
    "DuoGuiGe": "Mehrere Spezifikationen",
    "YiShou": "Verkauft",
    "SWBHZ_YS": "Nachbestellung läuft, verkauft",
    "CuXiaoShangPin": "Promotionsprodukt",

    //goods-search
    "NHWSRSSNR": "Noch kein Suchinhalt eingegeben",
    "SouSuo": "Suchen",
    "SSY1XGDSP": "Suche nach {searchKey}-related Produkten",
    "Yue1GeShangPin": "Ungefähr {num} Produkte",
    "ZuiJinSouSuo": "Kürzliche Suchen",
    "QingChu": "Löschen",
    "ZWSSJL": "Keine Suchgeschichte",

    //goods-property
    "ZGJGBNDYZD": "Höchster Preis darf nicht niedriger als niedrigster Preis sein",
    "ShangPinBiaoQian": "Produktetikett",
    "BuGaoYu1": "Nicht höher als 1",
    "BuDiYu1": "Nicht niedriger als 1",
    "FengGe": "Stil",

    //goods-promotion-list
    "JiJiangKaiShi": "Bald beginnen",
    "QuanBuCuXiao": "Alle Promotionen",

    //goods-package-list
    "Gong1JianShangPin": "Insgesamt {num} Produkte",
    "Sheng": "Sparen",

    //goods-package-detail
    "GTCZGWCZDS": "Anzahl der Pakete im Warenkorb hat das Kauflimit erreicht, kann nicht in den Warenkorb gelegt werden",
    "GTCKCBZ_BK": "Paketlagerbestand unzureichend, kann nicht in den Warenkorb gelegt werden",
    "JinSheng1Tao": "Nur noch {num} Sets",
    "XianGou1Tao": "Kauflimit {num} Sets",
    "TaoCanXiangQing": "Paketdetails",
    "DanMaiJia": "Einzelpreis",
    "TaoCanJia": "Paketpreis",
    "HDYJS": "Aktion beendet",

    //goods-message
    "WDL_QXDL": "Nicht angemeldet, bitte zuerst einloggen",

    //goods-list-label
    "XinPinShangShi": "Neue Produkte",
    "WDLZH_ZWCX": "Nicht angemeldet, keine Promotionen!",
    "YiXiaShangPin": "Folgende Produkte",

    //goods-list
    "1ZhongGuiGe": "{num} Spezifikationen",
    "YouKuCun": "Auf Lager",

    //goods-filter
    "BuGaoYu": "Nicht höher als",
    "BuDiYu": "Nicht niedriger als",
    "CuXiao": "Promotion",
    "ZDYXXZ3G": "Maximal 3 Auswahlen erlaubt",
    "GouMai": "Kaufen",
    "Gong1Jian": "Insgesamt {num} Stück",

    //缺失
    "YiChuShouCangJia": "Aus Sammlung entfernen",
    "$": "¥",
    "$1": "¥{num}",
    "_8999_1Qi": "¥ 8999.1 ab",
    "Ge": "Stück",
    "BaoZhuangFangShi": "Verpackungsart",
    "QRSCSP_": "Produkt löschen?",
    "JEWM_TMFRK": "QR-Code/Barcode in den Rahmen legen, um automatisch zu scannen",
    "0ZSP_G0J": "0 Produkte, insgesamt 0 Stück",
    "JiuMiMa": "Altes Passwort",
    "XMM_6_20WZ": "Neues Passwort (6-20 Buchstaben oder Ziffern)",
    "QueRenMiMa": "Passwort bestätigen",
    "BDHKSYSJHD": "Nach dem Binden kann mit der Handynummer eingeloggt werden, um das Passwort wiederzuerhalten und die Konto­sicherheit zu erhöhen",
    "YanZhengMa": "Bestätigungscode",
    "1MHKCXHQ": "Nach 1 Sekunde wieder erhältlich",
    "CSJHZ1MQFS": "Diese Handynummer hat vor 1 Sekunde einen Bestätigungscode erhalten, bitte später erneut versuchen",
    "GouMaiJiLu": "Kaufverlauf",
    "XinZengDiZhi": "Neue Adresse hinzufügen",
    "LingShouJia": "Verkaufspreis",
    "YouHuiJia": "Rabattpreis",
    "ShangPinChuKu": "Produktauslagerung",
    "DengDaiShouHuo": "Warten auf Lieferung",
    "ShouHuoRen": "Empfänger",
    "PaiZhao": "Foto aufnehmen",
    "XiangCe": "Album",
    "TiYanGuan": "Erlebnisraum",
    "JingYingShiJian": "Betriebszeit",
    "ZhanGuanDianHua": "Ausstellungsnummer",
    "ZhanGuanDiZhi": "Ausstellungsadresse",
    "SJHQZ_QSDZ": "Daten werden abgerufen, bitte später erneut versuchen!",
    "QXXZSF_": "Bitte zuerst Provinz auswählen!",
    "QuanBuShengFen": "Alle Provinzen",
    "QuanBuChengShi": "Alle Städte",
    "YingYeShiJian": "Öffnungszeiten",
    "ChanPinBianHao": "Produktnummer",
    "DLXXYGQ_QC": "Anmeldeinformationen abgelaufen, bitte erneut einloggen",
    "Man999Jian100": "Ab {m} Yuan {n} Yuan Rabatt",
    "YiManZu": "Bedingung erfüllt",
    "QDYCSP_": "Produkt entfernen?",
    "DGM10JZ1J": "Bestellung ab 10 Stück erhält 1 Stück kostenlos",
    "XiaXianTongZhi": "Offline-Benachrichtigung",
    "NDZHYZQTSB": "Ihr Konto wurde auf einem anderen Gerät eingeloggt, bitte erneut einloggen. Wenn es nicht Ihre Operation ist, ändern Sie das Passwort sofort",
    "ManJiang": "Ab {target} Stück {num} Yuan Rabatt",
    "ZGLXMJ": "Noch {num} Stück einkaufen, um【ab {target} Stück zu {money_} Yuan】zu erhalten",
    "ZGLXMZ": "Noch {num} Stück einkaufen, um【ab {target} Stück {percent} % Rabatt pro Stück】zu erhalten",
    "QSRZQNR": "Bitte richtigen Inhalt eingeben",
    "NHYDDQKWJQ": "Sie haben {num} Bestellungen mit insgesamt {money} Yuan ausstehenden Zahlungen. Neue Bestellungen nur nach Zahlung möglich",
    "FaPiaoZhuShou": "Rechnungsassistent",
    "WoDeFaPiao": "Meine Rechnungen",
    "FaPiaoXiangQing": "Rechnungsdetails",
    "KaiPiaoShiJian": "Rechnungsdatum",
    "DaiKaiFaPiao": "Ausstehende Rechnungen",
    "DKFPJE": "Ausstehender Rechnungsbetrag",
    "KaiPiaoJinE": "Rechnungsbetrag",
    "ZFYDWT_QCSCXZF": "Zahlungsproblem, bitte erneut versuchen oder Zahlungsanbieter wechseln",
    "QingXuanZhe": "Bitte auswählen",
    "ShouXin": "Kredit",
    "LJSQSXED": "Sofort Kreditlimit beantragen",
    "SXEDSHZ": "Kreditlimit wird geprüft",
    "SXCZ_XDCG": "Kredit ausreichend, Bestellung erfolgreich",
    "SXEDBZ_FKHFH": "Kreditlimit unzureichend, Lieferung nach Zahlung",
    "CGJKZQ_FKFH": "Kreditfrist überschritten, Lieferung nach Zahlung",
    "DDTJCG_XZZCZHYB": "Bestellung erfolgreich eingereicht, nur noch ein Schritt!",
    "MianFeiLing": "Kostenlos abholen",
    "M_KMFLQ_HQ": "Ab {target} Yuan kostenlos erhältlich, noch {short} Yuan fehlend",
    "YHDMFSP": "Kostenlose Produkte erhalten",
    "JRMFL": "Heute kostenlos abholen",
    "LingGuangLe": "Ausverkauft",
    "KeLingQu": "Erhältlich",
    "YuGuJia": "Schätzpreis",
    "GXNHQ_Z_Y_": "Glückwunsch, Sie erhalten {num} {price} Yuan {name}",
    "LXZSKF": "Persönlichen Kundenservice kontakt",
    // 从key为DPYDY_QSHX开始继续翻译
    "DPYDY_QSHX": "Geschäft ist geschlossen, bitte später bestellen",
    "DaYangShiJian": "Schließzeit",
    "ChuanHaoChaXun": "Seriennummer prüfen",
    "IMEI": "Seriennummer",
    "FanKuanYuE": "Rückerstattungsguthaben",
    "FanKuanZhiFu": "Rückerstattungszahlung",
    "JingDongYiYunJia": "JD YiYunJia",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "Rückerstattungsguthaben unzureichend",
    "FanKuanZhangHu": "Rückerstattungskonto",
    "HaiXuZhiFu": "Noch zu bezahlen {price}",
    "QTXGSMC": "Bitte Firmennamen eingeben",
    "QSCSFZZMZ": "Bitte Foto der Vorderseite des Ausweises hochladen",
    "QSCSFZFMZ": "Bitte Foto der Rückseite des Ausweises hochladen",
    "QSCYYZZ": "Bitte Handelsregisterfoto hochladen",
    "TJCG_QNXDDSH": "Eingereicht, bitte auf Prüfung warten",
    "SXSQ": "Kreditantrag",
    "QYJBZL": "Grunddaten des Unternehmens",
    "SQFRSFZZM": "Foto der Vorderseite des Identitätsausweises des Rechtsträgers hochladen",
    "ZMSLT": "Beispielfoto Vorderseite",
    "SCFRSFZFM": "Foto der Rückseite des Identitätsausweises des Rechtsträgers hochladen",
    "FMSLT": "Beispielfoto Rückseite",
    "QQBSFZSJWZ_WZQXKBB": "Stellen Sie sicher, dass alle Ecken des Ausweises sichtbar sind und der Text gut lesbar ist",
    "SCYYZZ": "Handelsregister hochladen",
    "ShengHeZhong": "In Prüfung",
    "TiJiaoShenHe": "Zur Prüfung einreichen",
    "GSMC": "Firmenname",
    "DDDKFQRBJQSH": "Bestellung wartet auf Preisbestätigung durch Kundenservice, bitte warten",
    "XDTX": "Bestellhinweis",
    "NH_GDDBH": "Einige Produktpreise warten auf Bestätigung durch den Kundenservice, bevor sie bezahlt werden können",
    "QRXD": "Bestellung bestätigen",
    "DaiHeJia": "Preis ausstehend bestätigen",
    "ZHJY": "Kontostand",
    "YGTG": "Mitarbeiterwerbung",
    "YuanGong": "Mitarbeiter",
    "DuiZhanGJieSuan": "Kontostellung und Abrechnung",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "Kontostand = Vorauszahlungsguthaben + Rückerstattungsguthaben + Rücksendungsrückerstattung ausstehend - zu zahlender Bestellbetrag",
    "YCKYE": "Vorauszahlungsguthaben",
    "FKYE": "Rückerstattungsguthaben",
    "DDYFK": "Zu zahlender Bestellbetrag",
    "THDTK": "Rücksendungsrückerstattung ausstehend",
    "YuCunKuanZuoFei": "Vorauszahlung storniert",
    "FanKuanZhangHuMingXi": "Details des Rückerstattungskontos",
    "TKCZDFKZH": "Rückerstattung auf das Rückerstattungskonto aufladen",
    "RMBJE": "Betrag in Yuan"
};
exports.default = de_DE;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// fr_FR.js 法语完整翻译（逐行对应，电商术语统一，格式与原文件一致）
var fr_FR = {
    "GuanShui": "Droit de douane‌",
    "ZiZhangHao": "Sous-compte",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",
    // components
    "ShangeChuanYanZhengTuPian": "Téléverser l'image de vérification",
    "ChuanHaoYanZheng": "Vérification du numéro de série",
    "YanZhengChuanHao": "Vérifier le numéro de série",
    "Ci": "fois",
    "DingDanMan": "Commande达到", // 保留"达到"体现中文电商"满"的核心含义，法语无完全对应单字，用"达到"更简洁
    "YuanZeng": "yuan offert",
    "SCFJ_ZD4Z_DZBCG": "Téléverser des pièces jointes, maximum 4 fichiers, chaque ne dépassant pas 3M",
    // ChatRoom
    "ZBZCBQFH": "Émojis non pris en charge temporairement",
    "FaSongLianJie": "Envoyer un lien",
    "YiChangXiaoXi": "Message anormal",
    "QingShuRu": "Veuillez saisir",
    "FaSong": "Envoyer",
    // DateSelector
    "DQSJXYKSSJ": "Heure actuelle inférieure à l'heure de début",
    "DQSJCGJSSJ": "Heure actuelle dépassant l'heure de fin",
    "QuXiao": "Annuler",
    "NianYueRi": "Année/Mois/Jour",
    "ShiFen": "Heure/Minute",
    "QueDing": "Confirmer",
    "Nian": "année",
    "Yue": "mois",
    "Ri": "jour",
    "Shi": "heure",
    "Fen": "minute",
    // goods-list-card
    "Qi": "à partir de",
    // goods-promotion
    "1GeCuXiao": "{num} promotions",
    "ChaKanZengPin": "Voir les cadeaux",
    "JHDJSHS_1T": "Temps restant avant la fin de l'événement : {d} jours {h} heures {m} minutes {s} secondes",
    "YHGZ_ZPBKD": "Règles de promotion : Les cadeaux ne peuvent pas être cumulés",
    "YHGZ_AZZGM": "Règles de promotion : Bénéficier de l'offre selon la quantité finale achetée",
    "GuanBi": "Fermer",
    "Man1Song1": '达到 {mai} offrir {song}',
    // group-filtrate
    "QuanBu": "Tous",
    "ZWXGSJ": "Aucune donnée pertinente pour le moment",
    "ZuiDiJia": "Prix le plus bas",
    "ZuiGaoJia": "Prix le plus élevé",
    "LeiXing": "Type",
    "PinPai": "Marque",
    "BiaoQian": "Étiquette",
    "JiaGeQuJian": "Plage de prix",
    "SPMC_GG_BH_": "Nom du produit / Spécification / Référence / Première lettre",
    "SPMC_GG_BH_G": "Nom du produit / Spécification / Référence",
    "ZuHeShaiXuan": "Filtrage combiné",
    "ChongZhi_CanShu": "Réinitialiser",
    // image-upload
    "ZDKSC1ZTP": "Maximum 1 image peut être téléversée",
    "ZYXSCTP": "Seules les images sont autorisées à être téléversées",
    "SCTPDXBYXC": "La taille de l'image téléversée ne peut pas dépasser 5M",
    "QBYCFSCTP_": "Veuillez ne pas téléverser de images dupliquées, ou assurez-vous que les noms d'images sont uniques",
    "ShangChuanChengGong": "Téléversement réussi",
    "ZDKSC1Z": "Maximum 1 peut être téléversé",
    // keyboard
    "CCSLZDXZ": "Dépassement de la limite maximale de quantité",
    "QiDingLiang": "Quantité minimale de commande",
    "ShouQi": "Réduire",
    "ShanChu": "Supprimer",
    // MultiPicker
    "FanHui": "Retourner",
    // order-cart
    "Dai": "En attente de",
    "YiQuXiao": "Annulé",
    "ZengPin": "Cadeau",
    "1Zhong": "{num} types",
    "1Jian": "{num} articles",
    "HeJi": "Total",
    "DaiFu": "En attente de paiement",
    // order-promotion
    "_DDM1YZ1J_": "【Commande达到 {target} yuan offrir {name} × {number} articles】",
    "_DDM1YLJ1Y_": "【Commande达到 {m} yuan réduire immédiatement {n} yuan】",
    "_DDM1YLX1Z_": "【Commande达到 {m} yuan bénéficier immédiatement de {n}% de remise】",
    "DingDanCuXiao": "Promotion de commande",
    // page-ad
    "DLCKJG": "Se connecter pour consulter le prix",
    // page-floating
    "DianPuZhuYe": "Page d'accueil du magasin",
    "GouWuChe": "Panier d'achat",
    "ZaiXianKeFu": "Service client en ligne",
    "GeRenZhongXin": "Espace personnel",
    "LianXiDianHua": "Téléphone de contact",
    "FanHuiDingBu": "Retourner en haut",
    // page-null
    "ZBDYML": "Page introuvable",
    "KNWZCW_HZY": "URL incorrecte possible, ou la page a été supprimée",
    "FanHuiShangJi": "Retourner à la page supérieure",
    "FanHuiShouYe": "Retourner à la page d'accueil",
    // product-edit
    "SPQDBNWK": "La liste de produits ne peut pas être vide",
    "WoZhiDaoLe": "Je sais",
    "SFQRSCSP": "Êtes-vous sûr de supprimer le produit ?",
    "QueRen": "Confirmer",
    "ZYXSRSZBQB": "Seulement les chiffres sont autorisés, avec un maximum de 2 décimales",
    "ShangPinDanJia": "Prix unitaire du produit",
    "YSPYJ": "Prix original du produit",
    "QSRZDJG": "Veuillez saisir le prix spécifié",
    "ShuLiang": "Quantité",
    "DanWei": "Unité",
    "DanJia": "Prix unitaire",
    "BeiZhu": "Remarques",
    "YiChuShangPin": "Supprimer le produit",
    "XiuGai": "Modifier",
    // yunshl
    "TPSLCCYXSZ": "Le nombre d'images dépasse la limite autorisée !",
    "WJBDDY5M_QC": "Le fichier ne peut pas être supérieur à 5M, veuillez重新sélectionner",
    "TPSCWC": "Téléversement des images terminé",
    // BusinessFilter
    "_DGSLM1Z1_": "【Quantité de commande达到 {target} offrir {provide}】",
    "_M1JLXMJ1Y_": "【达到 {target} bénéficier immédiatement de {cut_money_} par unité】",
    "_DHJJZ1Y_": "【Prix de commande réduit à {cuted_price_} yuan】",
    "_M1JLXMJ1Z_": "【达到 {target} bénéficier immédiatement de {cut_percent_}% de remise par unité】",
    "_YDHJD1Z_": "【Prix original de commande avec {cuted_percent_}% de remise】",
    "YuJiKaiShiFaHuo": "Expédition prévue pour commencer le {date}",
    "YuJi": "Prévu",
    "MMYDDR": "MM/JJ",
    "KaiShiFaHuo": "Commencer l'expédition",
    "_M1LXM1Y_": "【达到 1 bénéficier immédiatement de 1 yuan par unité】",
    "_M1LXM1Z_": "【达到 1 bénéficier immédiatement de 10% de remise par unité】",
    "DaiQueRen": "En attente de confirmation",
    "DaiFaHuo": "En attente d'expédition",
    "DaiShouHuo": "En attente de réception",
    "YiWanCheng": "Terminé",
    "DaiFuKuan": "En attente de paiement",
    "YiFuKuan": "Paié",
    "YiZuoFei": "Annulé",
    "DaiShenHe": "En attente d'examen",
    "DaiHeXiao": "En attente de vérification",
    "YiHeXiao": "Vérifié",
    "XianXiaZhiFu": "Paiement hors ligne",
    "ZhiNengDaoZhangShiBie": "Virement hors ligne (reconnaissance intelligente de règlement)",
    "WeiXinZhiFu": "WeChat Pay",
    "KQ-WeiXinZhiFu": "Kuaiqian (WeChat)",
    "KQ-ZFBZF": "Kuaiqian (Alipay)",
    "KQZhiFu": "Paiement Kuaiqian",
    "ZFBZF": "Alipay",
    "YuEZhiFu": "Paiement par solde",
    "HuoDaoFuKuan": "Paiement à la livraison",
    "DaiTuiHuo": "En attente de retour",
    "DaiTuiKuan": "En attente de remboursement",
    "ChuangJianDingDan": "Créer une commande",
    "BianJiDingDan": "Modifier une commande",
    "TiJiaoDingDan": "Soumettre une commande",
    "DingDanShenHe": "Examen de commande",
    "CaiWuShenHe": "Examen financier",
    "BoHui": "Rejeter",
    "TianJiaShouKuan": "Ajouter un règlement",
    "ZaiXianZhiFu": "Paiement en ligne",
    "ShouKuanShenHe": "Examen de règlement",
    "ShouKuanZuoFei": "Annuler le règlement",
    "ChuKu": "Sortie de stock",
    "ChuKuShenHe": "Examen de sortie de stock",
    "FaHuo": "Expédier",
    "TianJiaWuLiu": "Ajouter la logistique",
    "XiuGaiWuLiu": "Modifier la logistique",
    "ChuKuZuoFei": "Annuler la sortie de stock",
    "ShouHuo": "Recevoir les marchandises",
    "DingDanHeZhun": "Approuver la commande",
    "QuXiaoDingDan": "Annuler la commande",
    "CJTHD": "Créer un bon de retour",
    "DaYin": "Imprimer",
    "DaoChu": "Exporter",
    "DingDanWanCheng": "Commande terminée ",
    "QiangZhiWanCheng": "Forcer la terminaison",
    "DingDanZuoFei": "Annuler la commande",
    "MaiZeng": "Achat + Cadeau",
    "ZhiJiang": "Réduction directe",
    "DaZhe": "Remise",
    "YuShou": "Prévente",
    "DingDanManZeng": "Cadeau à partir de commande达到",
    "DingDanManJian": "Réduction à partir de commande达到",
    "DingDanManZhe": "Remise à partir de commande达到",
    "XinRenQuan": "Coupon nouveau client",
    "ManJianQuan": "Coupon de réduction à达到",
    "ShangPinQuan": "Coupon de produit",
    "DaiJieSuan": "En attente de règlement",
    "YiJieSuan": "Règlement terminé",
    "QuanBuShangPin": "Tous les produits",
    "TuiJianShangPin": "Produits recommandés",
    "XinPin": "Nouveaux produits",
    "ReXiaoShangPin": "Produits à forte vente",
    "ChangYongShangPin": "Produits fréquemment utilisés",
    // BusinessUtil
    "DaiShouKuan": "En attente de règlement",
    "BuFenShouKuan": "Règlement partiel",
    "YiShouKuan": "Règlement complet",
    "BXYFP": "Aucune facture nécessaire",
    "ZZSPTFP": "Facture VAT ordinaire",
    "ZZSZYFP": "Facture VAT spéciale",
    "QiTaFaPiao": "Autres factures",
    "XianXia": "Hors ligne",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Pré-dépôt",
    "XianXiaZhuangZhang": "Virement hors ligne",
    "XianShangZhiFu": "Paiement en ligne (supporte WeChat/Alipay/JD Pay/UnionPay Quick Pass)",
    "YCKZF": "Paiement par pré-dépôt",
    "DaiTiJiao": "En attente de soumission",
    "KuaiDi": "Livraison express",
    "SongHuoShangMen": "Livraison à domicile",
    "ShangMenZiQu": "Retrait sur place",
    "WuLiuHuoYun": "Logistique et fret",
    "QiTa": "Autre",
    // check-util
    "QSRBXY6WDM": "Veuillez saisir un mot de passe d'au moins 6 caractères",
    "QSRBDY20WDM": "Veuillez saisir un mot de passe d'au plus 20 caractères",
    "MMGSCW": "Format de mot de passe incorrect",
    // common-utils
    "SJCW_QLXKF": "Erreur de données, veuillez contacter le service client",
    "ZBZCQD": "Check-in non pris en charge temporairement",
    "HuJiao": "Appeler",
    "DLZHBCZ": "Compte de connexion n'existe pas",
    "QLXGLYKT": "Veuillez contacter l'administrateur pour activer",
    "GQYZHBJY": "Ce compte d'entreprise est désactivé",
    "QLXYSDH": "Veuillez contacter Yunshang Ordering",
    "GQYZHSYQJS": "La période d'essai de ce compte d'entreprise a expiré",
    "GQYZHYGQL": "Ce compte d'entreprise a expiré",
    "XYXFCNSY": "Renouvellement nécessaire pour utiliser",
    "GQYBCZCZH": "Ce compte n'existe pas dans l'entreprise",
    "NDDHZHYBQY": "Votre compte de commande a été désactivé par l'entreprise 1 et ne peut pas se connecter. Veuillez contacter l'administrateur",
    "NYBSQY1DHZ": "Vous n'êtes plus un client coopératif de l'entreprise 1 et ne peut pas se connecter. Veuillez contacter l'administrateur",
    "NDDPYBTY_B": "Votre magasin a été désactivé et ne peut pas se connecter. Veuillez contacter l'administrateur",
    "GZHWKTDSZB": "Ce compte n'a pas activé la fonction de version spéciale d'éclairage. Veuillez contacter l'administrateur",
    "WXSQYZYGQ": "Vérification d'autorisation WeChat expirée",
    "WXSQSB": "Échec d'autorisation WeChat",
    "WXSQSB_CWX": "Échec d'autorisation WeChat, message d'erreur",
    "DengLuGuoQi": "Connexion expirée",
    "DLGQ_QCXDL": "Connexion expirée, veuillez vous reconnecter",
    // data-constant
    "ShangJia": "Mise en vente",
    "YiXiaJia": "Retrait de vente",
    "YiJinYong": "Désactivé",
    "YiQiYong": "Activé",
    "YiTingYong": "Suspendu",
    "KeHuZhuCe": "Inscription client",
    "XinZengDaoRu": "Importation nouvelle",
    "DDDSH": "En attente d'examen de commande",
    "DCWSH": "En attente d'examen financier",
    "DaiChuKu": "En attente de sortie de stock",
    "DCK_BF_": "En attente de sortie de stock (partiel)",
    "DFH_BF_": "En attente d'expédition (partiel)",
    "DSH_BF_": "En attente de réception (partiel)",
    "DSK_BF_": "En attente de règlement (partiel)",
    "WTHSQ": "Aucune demande de retour",
    "THDSH": "Retour en attente d'examen",
    "THCLZ": "Retour en traitement",
    "THYWC": "Retour terminé",
    "DYDHD": "Imprimer le bon de commande",
    "DYFHD": "Imprimer le bon d'expédition",
    "DCDHD": "Exporter le bon de commande",
    "DCFHDWE_P": "Exporter le bon d'expédition en fichier Excel/PDF",
    "TuiDanZuoFei": "Annuler le bon de retour",
    "DTHSH": "Retour en attente d'examen",
    "DaiRuKu": "En attente d'entrée en stock",
    "DRK_BF_": "En attente d'entrée en stock (partiel)",
    "DFK_BF_": "En attente de paiement (partiel)",
    "ChuangJianTuiDan": "Créer un bon de retour",
    "BianJiTuiDan": "Modifier un bon de retour",
    "TiJiaoTuiDan": "Soumettre un bon de retour",
    "TuiHuoShenHe": "Examen de retour",
    "RuKu": "Entrée en stock",
    "RuKuShenHe": "Examen d'entrée en stock",
    "RuKuZuoFei": "Annuler l'entrée en stock",
    "TianJiaFuKuan": "Ajouter un paiement",
    "FuKuanZuoFei": "Annuler le paiement",
    "FuKuanShenHe": "Examen de paiement",
    "TuiDanWanCheng": "Bon de retour terminé",
    "QiTaChuKu": "Autre sortie de stock",
    "XiaoShouChuKu": "Sortie de stock pour vente",
    "PanKuiChuKu": "Sortie de stock pour perte d'inventaire",
    "DiaoBoChuKu": "Sortie de stock pour transfert",
    "CaiGouTuiHuo": "Retour d'achat",
    "TuiHuoRuKu": "Entrée en stock pour retour",
    "CaiGouRuKu": "Entrée en stock pour achat",
    "QiTaRuKu": "Autre entrée en stock",
    "PanYingRuKu": "Entrée en stock pour surplus d'inventaire",
    "DiaoBoRuKu": "Entrée en stock pour transfert",
    "CJCGD": "Créer un bon d'achat",
    "BJCGD": "Modifier un bon d'achat",
    "TJCGD": "Soumettre un bon d'achat",
    "CGDZF": "Annuler un bon d'achat",
    "CGDWC": "Bon d'achat terminé",
    "CGTHZF": "Annuler le retour d'achat",
    "CGTHWC": "Retour d'achat terminé",
    "THDDY": "Imprimer le bon de retour",
    "THDDC": "Exporter le bon de retour",
    "CKDDY": "Imprimer le bon de sortie de stock",
    "CKDDC": "Exporter le bon de sortie de stock",
    "GLDZH": "Compte administrateur",
    "DHDZH": "Compte de commande",
    "ShenHeTongGuo": "Examen approuvé",
    "SHBTG": "Examen non approuvé",
    "WuXuFaPiao": "Aucune facture nécessaire",
    "DaiKeXiaDan": "Passage de commande pour le client",
    "ZiZhuXiaDan": "Passage de commande autonome",
    "PCShangCheng": "Boutique PC",
    "APPShangCheng": "Boutique APP",
    "TVShangCheng": "Boutique TV",
    "WeiXinShangCheng": "Boutique WeChat",
    "ShouJiShangCheng": "Boutique mobile",
    "ADDXSMLTC": "Commission basée sur le bénéfice brut de vente de commande",
    "ADDXSSRTC": "Commission basée sur le chiffre d'affaires de commande",
    "AKHSSYG": "Par employé auquel le client appartient",
    "AnZhiDanRen": "Par créateur de document",
    "ATHJEBLKCT": "Deduction du montant de commission selon le ratio du montant de retour",
    "DDYTHBJXTC": "Aucune commission pour les commandes avec retour",
    "DaiDaKuan": "En attente de paiement",
    "WeiKaiShi": "Non démarré",
    "JinXingZhong": "En cours",
    "YiGuoQi": "Expiré",
    // Utils.js
    "YouHuo": "En stock",
    "WuHuo": "Hors stock",
    "Yi": "100 millions",
    "QianWan": "Dix millions",
    "BaiWan": "Million",
    "Wan": "Dix mille",
    "Sheng1Tian": "1 jour restant",
    "Sheng1XiaoShi": "1 heure restante",
    "Miao": "seconde(s)",
    "1Miao": "1 seconde",
    "GangGang": "À l'instant",
    "1FenZhongQian": "Il y a 1 minute",
    "1XiaoShiQian": "Il y a 1 heure",
    "1TianQian": "Il y a 1 jour",
    "1GeYueQian": "Il y a 1 mois",
    "1NianQian": "Il y a 1 an",
    "WeiZhiLeiXing": "Type inconnu",
    // WechatUtil
    "YYGBCDSP_K": "Un bon produit, venez jeter un œil",
    "ZanWeiSheZhi": "Non défini temporairement",
    // app
    "HQWXSQXX": "Obtenir les informations d'autorisation WeChat",
    // flexible
    "JGJYYDMBQ": "Le taux de zoom sera défini selon les balises meta existantes",
    // index
    "NLJZZ": "Chargement en cours...",
    "": "routes",
    "ShangPinMingXi": "Détails du produit",
    "ShangPinLeiBie": "Catégorie de produit",
    "QXZFPNR": "Veuillez sélectionner le contenu de facture",
    "QXZFPLX": "Veuillez sélectionner le type de facture",
    "QTXFPTT": "Veuillez remplir le titre de facture",
    "FaPiaoTaiTou": "Titre de facture",
    "NSRSBH": "Numéro d'identification fiscal",
    "FaPiaoNeiRong": "Contenu de facture",
    "FaPiaoXinXi": "Informations de facture",
    "KaiJuFaPiao": "Émettre une facture",
    "FaPiaoLeiXing": "Type de facture",
    "Han": "Incluant",
    "WeiHan": "Non incluant",
    "Shui": "Taxe",
    "QSRFPTT": "Veuillez saisir le titre de facture",
    "QSRNSRSBH": "Veuillez saisir le numéro d'identification fiscal",
    // routes
    // cart-bill
    "YiManZu_Man": "Déjà atteint 【达到",
    "ZaiGou": "Acheter davantage",
    "YMZ_DHJJZ": "Déjà atteint 【Prix de commande réduit à",
    "JianJiangZhi": "articles réduits à",
    "YMZ_YDHJD": "Déjà atteint 【Prix original de commande avec",
    "JianMeiJian": "articles, chaque article",
    "SYTCSLW0_WFJRGWC": "La quantité restante du套餐 est 0, impossible à ajouter au panier",
    "QingXuanXeShangPin": "Veuillez sélectionner des produits !",
    "GSPYXJ": "Ce produit a été retiré de vente !",
    "ZJ2TN": "Dans les {day} derniers jours",
    "QDQCXJSP": "Êtes-vous sûr de supprimer les produits retirés de vente ?",
    "QingChuChengGong": "Suppression réussie",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Les produits de套餐 ne peuvent pas être ajoutés au panier, veuillez annuler les produits de套餐 puis les déplacer dans le panier !",
    "SPSLBN": "La quantité de produit ne peut pas",
    "TaoCanHan": "套餐 inclut",
    "TaoCan": "套餐",
    "QHDSL": "Veuillez vérifier la quantité",
    "SPSLBNDY": "La quantité de produit ne peut pas être inférieure à",
    "XianDingLiang": "Quantité limitée",
    "YiRuShouCang": "Déplacer dans les favoris",
    "QuanXuan": "Sélectionner tout",
    "JianZeng": "articles offerts",
    "JianLiXiang_Man": "articles bénéficient de 【达到",
    "Yuan_": "yuan】",
    "Zhe_": "% de remise】",
    "KCBZ_WFJRGWC": "Stock insuffisant, impossible à ajouter au panier",
    "XDJEDYDY": "Le montant de commande est supérieur ou égal à",
    "WYXJHYSXDSP": "Aucun produit retiré de vente ou invalide !",
    "DYQDL": "Inférieur à la quantité minimale de commande",
    "ZSPG1J": "{count} types de produits, total {number} articles",
    "WanCheng": "Terminer",
    "BianJi": "Modifier",
    "You": "Il y a",
    "ZSPBFHYQ_W": "types de produits ne répondent pas aux exigences, non sélectionnés, cliquez pour consulter",
    "SPSLBNGY": "La quantité de produit ne peut pas être supérieure à",
    "JXDJ_CKXYGBFHYQSP": "Continuez de cliquer pour consulter le prochain produit ne répondant pas aux exigences",
    "XiaDan": "Passager une commande",
    "JianJiang": "articles réduits",
    "QRYCSP": "Confirmez-vous de supprimer le produit ?",
    "QXZXDSP": "Veuillez sélectionner les produits à commander",
    "KCBZ_QCXXZ": "Stock insuffisant, veuillez重新sélectionner !",
    "KuCun": "Stock",
    "YCKXD": "yuan pour passer une commande",
    "QDSCSP": "Confirmez-vous de mettre le produit dans les favoris ?",
    "ShouCangChengGong": "Ajout aux favoris réussi",
    "GYXDL": "Supérieur à la quantité limitée de commande",
    "LiSheng": "Économies immédiates",
    "GWCHSKD_QGYGB": "Le panier est encore vide, allez faire un tour !",
    "QuGuangGuang": "Aller faire un tour",
    "QCXJSP": "Supprimer les produits retirés de vente",
    "ZongE": "Montant total",
    "YouHui": "Promotion",
    // cart-list
    "QXZJHRQ": "Veuillez sélectionner la date de livraison",
    "FuJiaFeiYong": "Frais supplémentaires",
    "ZhongShangPin_Gong": "types de produits, total",
    "PeiSongShiJian": "Heure de livraison",
    "QXZPSSJ": "Veuillez sélectionner l'heure de livraison",
    "DingDanJinE": "Montant de commande",
    "SCFJ_ZD4Z": "Téléverser des pièces jointes, maximum 4 fichiers, chaque ne dépassant pas 3M",
    "KeYongShangPin": "Produits disponibles",
    "ShiYongShuoMing": "Instructions d'utilisation",
    "YouXiaoQi": "Période de validité",
    "Man": "达到",
    "BZZBZCTSFH": "Les remarques ne supportent pas les symboles spéciaux temporairement",
    "QingXuanZe": "Veuillez sélectionner",
    "KaiPiaoXuJia": "La facture nécessite un supplément de",
    "GeDian": "points",
    "KPXJ1GD": "La facture nécessite un supplément de {num} points",
    "PeiSongFangShi": "Mode de livraison",
    "ShangPinZongJia": "Prix total des produits",
    "YouHuiQuan": "Coupon",
    "ZhangKeXan": "exemplaires disponibles",
    "DDJEWMZ": "Montant de commande non atteint",
    "WDYHQ": "Mes coupons",
    "KYYHQ": "Coupons disponibles",
    "YuanKeYong": "yuan disponibles",
    "ChaKanDingDan": "Consulter la commande",
    "ShangPinHanShui": "Produits incluant la taxe",
    "SPWHS": "Produits non incluant la taxe",
    "QueRenDingDan": "Confirmer la commande",
    "XZSHDZ": "Ajouter une nouvelle adresse de livraison",
    "ShangPinQingDan": "Liste de produits",
    "WKYYHQ": "Aucun coupon disponible",
    "HuChi": "Mutuellement exclusif",
    "DaiJinQuan": "Bon d'achat",
    "YunFei": "Frais de livraison",
    "ShuiFei": "Frais de taxe",
    "BKYYY": "Raison d'indisponibilité",
    "YHQYGQ": "Coupon expiré",
    "WDYHQSYSJ": "La période d'utilisation du coupon n'est pas encore atteinte",
    "ZDSPJEWMZ": "Montant de produit spécifié non atteint",
    "BKYYHQ": "Coupons indisponibles",
    "YMZ_MYZJ_": "Déjà atteint 【达到 {m} yuan offrir {n} articles】",
    "YMZ_MZ": "Déjà atteint 【达到 {m} yuan offrir {n}】",
    "ZG222YX_M1000": "Achetez {money} yuan davantage pour bénéficier de 【达到 {target} yuan offrir {num} articles】",
    "ZG2JX_MZ": "Achetez {num} articles davantage pour bénéficier de 【达到 {target} yuan offrir {present}】",
    "YMZ_MYJY_": "Déjà atteint 【达到 {m} yuan réduire {n} yuan】",
    "ZGYX_MYJY_": "Achetez {m} yuan davantage pour bénéficier de 【达到 {n} yuan réduire {o} yuan】",
    "YMZ_MYZ_": "Déjà atteint 【达到 {m} yuan {n}% de remise】",
    "ZGYX_MYZ_": "Achetez {m} yuan davantage pour bénéficier de 【达到 {n} yuan {o}% de remise】",
    // cart-presale-order
    "QXZPSFS": "Veuillez sélectionner le mode de livraison",
    "1ZSP_G": "1 type de produit, total",
    "YSSP_YJ": "Produit en prévente, prévu",
    "JiaoHuoRiQi": "Date de livraison",
    "GMJLY": "Message pour le vendeur",
    // scan-to-cart
    "ZhengZaiChuLi...": "Traitement en cours...",
    "FSCSP": "Produits hors boutique",
    "ZZCLTXM": "Traitement du code-barres...",
    "SPTJCG": "Produit ajouté avec succès",
    "QSTXM": "Veuillez scanner le code-barres",
    "SFSCDQSP": "Êtes-vous sûr de supprimer le produit actuel ?",
    "BQ_ZBDXGSP": "Désolé, aucun produit pertinent trouvé",
    "XuanZeDanWei": "Sélectionner l'unité",
    "JRGWC": "Ajouter au panier",
    "QXXZDJRSP": "Veuillez d'abord sélectionner les produits à ajouter",
    "ZhengZaiChuLi": "Traitement en cours",
    "JRGWCCG": "Ajout au panier réussi",
    "ZanWuShangPin": "Aucun produit pour le moment",
    // earn-brokerage-share
    "XTYJBNFZSP": "Le système a copié le lien du produit pour vous !",
    "NKYHDDYDYJ": "Vous pouvez obtenir la commission correspondante. La commission peut être consultée dans \"Mes",
    "LiChaKan": "pour consulter",
    "WeiXinHaoYou": "Amis WeChat",
    "ErWeiMa": "Code QR",
    "CASBEWM": "Appuyez longuement pour identifier le code QR",
    "FZSB_QCXFZ": "Échec de copie, veuillez重新copier !",
    "TWEWM": "Code QR graphique",
    "BCDXC": "Enregistrer dans l'album",
    "CATPBCDXC": "Appuyez longuement sur l'image pour l'enregistrer dans l'album",
    "FuZhiLianJie": "Copier le lien",
    "FXZYJ": "Partager pour gagner de la commission",
    "YJZGKZQYJ": "Commission maximale prévue",
    "PYTGNFXDYMCGGMH": "Après que des amis aient acheté avec succès via la page que vous avez partagée, vous pouvez obtenir la commission correspondante. La commission peut être consultée dans \"Mes-{path}\"",
    // goods-share
    "FXSPGLSKH": "Partager les produits avec les clients détaillants",
    "FXHJSCNZSD": "Après le partage, votre boutique micro WeChat personnalisée sera générée. Vous pouvez définir les prix des produits dans la boutique, remplir vos informations de contact et attirer les consommateurs à acheter sur place.",
    "WSCDQJG_ND": "Prix actuel de la boutique micro WeChat : Votre prix de commande ×",
    "DaiSheZhi": "À définir",
    "PengYouQuan": "Moments",
    "GGFXSZ": "Modifier les paramètres de partage",
    // wechat-login
    "QXSRZH": "Veuillez d'abord saisir le compte",
    "MMGSCW_6_20W": "Format de mot de passe incorrect (6-20 caractères alphanumériques)",
    "BDYYZH": "Lier un compte existant",
    "WXKJDL": "Connexion rapide WeChat",
    "BangDingZhangHao": "Lier le compte",
    "YYZH_QDL": "Déjà un compte, aller se connecter",
    "ZCXZH": "Inscrire un nouveau compte",
    "HuanYingNi": "Bienvenue",
    "ZH_SJHM": "Compte/Numéro de téléphone",
    "MiMa": "Mot de passe",
    "QDLHCZ": "Veuillez vous connecter pour opérer",
    // add-to-cart
    "KCBZ_BNTJG": "Stock insuffisant, impossible d'ajouter davantage",
    // combined-pay-online
    "ZhiFuChengGong": "Paiement réussi !",
    "ZFSB_QCXCS": "Échec de paiement, veuillez重新essayer !",
    "QXXZGG": "Veuillez d'abord sélectionner les spécifications",
    "SXGGX": "Les spécifications sélectionnées nécessitent",
    "GMSLXYQDL_": "La quantité d'achat est inférieure à la quantité minimale de commande, veuillez重新acheter !",
    "GMSLDYXDL_": "La quantité d'achat est supérieure à la quantité limitée de commande, veuillez重新acheter !",
    "ShangPinBianHao": "Numéro de produit",
    "QiDing": "Commande minimale",
    "SXGGDGSLBK": "La quantité de commande pour les spécifications sélectionnées ne peut pas dépasser",
    "KCBZ_BNTJ": "Stock insuffisant, impossible à ajouter",
    "QXXZSP": "Veuillez d'abord sélectionner les produits",
    "SLBNW0": "La quantité ne peut pas être 0",
    "QXZGG": "Veuillez sélectionner les spécifications",
    "LiJiYuDing": "Réserver immédiatement",
    // nav
    "ShouYe": "Page d'accueil",
    "ShangPin": "Produits",
    "DingDan": "Commandes",
    "WoDe": "Mes",
    // pay-online
    "ZhiFuQuXiao": "Paiement annulé",
    // account-log
    "ShangPinYongJin": "Commission de produit",
    "YaoQingJiangLi": "Récompense d'invitation",
    "TiXian": "Retrait",
    "TiXianBoHui": "Retrait rejeté",
    "ZhuanWeiYuE": "Convertir en solde",
    "Jin7Tian": "Derniers 7 jours",
    "Jin30Tian": "Derniers 30 jours",
    "ShouZhiMingXi": "Détails des entrées et dépenses",
    "ZanWuShuJu": "Aucune donnée pour le moment",
    // client-statistics
    "WoDeKeHu": "Mes clients",
    "WoDeYaoQing": "Mes invitations",
    // distribution-home
    "LeiJiKeHu": "Clients cumulés",
    "LeiJiDingDan": "Commandes cumulées",
    "YaoQingHaoYou": "Inviter des amis",
    "LeiJiYaoQing": "Invitations cumulées",
    "LJSY_Y_": "Revenus cumulés (yuan)",
    "BHDJS": "Incluant le règlement en attente",
    "J7TSY_Y_": "Revenus des 7 derniers jours (yuan)",
    "J7TXZKH_R_": "Nouveaux clients des 7 derniers jours (personne(s))",
    "KTXYJ": "Commission retirable",
    "XYJYO": "Besoin de faire plus d'efforts",
    "ChangJianWenTi": "Questions fréquemment posées",
    "Q_ZMYJX_TG": "Q : Comment \"promouvoir pour gagner de l'argent\" ?",
    "A_FXDPND_Z_": "A : Partagez le lien de la page avec l'icône \"Gagner\" dans la boutique pour attirer les amis à cliquer. Si les amis s'inscrivent (relation client liée à l'inscription) ou passent une commande (relation client liée à la commande) et achètent des produits avec l'icône \"Gagner\" dans la boutique, cela sera compté comme vos revenus de \"promouvoir pour gagner\" selon une méthode de calcul déterminée.",
    "Q_RHJS_TGZ": "Q : Comment calculer les revenus de \"promouvoir pour gagner\" ?",
    "A_MGD_Z_TBD": "A : Chaque produit avec l'icône \"Gagner\" a un taux de commission déterminé ; les produits sans cette marque signifient qu'ils ne participent pas à \"promouvoir pour gagner\". Après que les amis aient effectué un paiement avec succès via votre lien partagé, les commissions seront calculées séparément selon le taux de commission de chaque produit dans la commande (commission 0 pour les produits non participants), puis sommées pour former les revenus de cette commande. Les frais de livraison, remboursements, réductions à达到, etc., seront déduits du calcul des revenus, et le prix de transaction final prévaudra.",
    "Q_TGZQ_DSY": "Q : Quand les revenus de \"promouvoir pour gagner\" arrivent-ils ?",
    "A_HYTGNDFX": "A : Après que les amis aient effectué un paiement avec succès via votre lien partagé, vous pouvez voir cette promotion dans les commandes promotionnelles du Centre de vente, avec le statut \"Règlement en attente\". Lorsque le client confirme la réception, la transaction de commande est terminée et réglementée, et ces revenus seront automatiquement transférés dans votre compte personnel, qui peut être retiré à tout moment.",
    "Q_LJKH_LJY": "Q : Pas d'avatar ou de pseudo dans la liste Clients cumulés/Invitations cumulées ?",
    "A_WXYQZYGZ": "A : WeChat exige de suivre le compte de service certifié pour obtenir l'avatar et le pseudo. Les clients dont la boutique est un compte de service certifié peuvent suivre le compte officiel de la boutique ; ceux dont la boutique n'est pas un compte de service certifié peuvent suivre le compte officiel \"Yunshang Ordering\", puis cliquer sur n'importe quelle page de détails de produit dans la boutique pour obtenir l'avatar et le pseudo.",
    "Q_WSMWASSG": "Q : Pourquoi je n'obtiens pas de revenus de promotion après avoir partagé selon les règles ci-dessus ?",
    "A_1_HYKNBW": "A : 1. Les amis n'ont peut-être pas établi de relation client avec vous (les amis ont cliqué sur le lien d'autres vendeurs pour s'inscrire ou passer une commande) ; 2. Si les amis ouvrent votre lien partagé hors de l'environnement WeChat (comme le navigateur par défaut du téléphone), si le navigateur n'active pas les cookies, la relation client ne peut pas être enregistrée, c'est-à-dire que la commande promotionnelle ne peut pas être enregistrée ; 3. Si la commande promotionnelle n'est toujours pas enregistrée lorsque les points ci-dessus sont corrects, veuillez contacter le personnel.",
    "XiaoShouZhongXin": "Centre de vente",
    // generalize-goods
    "SPMC_GG_BH": "Nom du produit / Spécification / Référence",
    "YuJiZhuan": "Gains prévus",
    // invitation-home
    "YaoQingKa": "Carte d'invitation",
    "YNYQJR_TGY": "Invitez-vous à rejoindre et gagner des récompenses par promotion",
    "DJBCDXC": "Cliquez pour enregistrer dans l'album",
    "JYQKFSGHY_": "Envoyez la carte d'invitation à des amis, la promotion de boutique apporte des récompenses",
    // join-home
    "HuanYingJiaRu": "Bienvenue à rejoindre",
    "YQNCW": "Vous êtes invité à devenir",
    "LiJiJiaRu": "Rejoindre immédiatement",
    // order-statistics
    "YuJiYongJin": "Commission prévue",
    "YongJin": "Commission",
    "YuJiJiangLi": "Récompense prévue",
    "JiangLi": "Récompense",
    "SPTGDD": "Commandes promotionnelles de produits",
    "YQJLDD": "Commandes de récompense d'invitation",
    // performance-statistics
    "YeJiTongJi": "Statistiques de performance",
    "LJKH_R_": "Clients cumulés (personne(s))",
    "SPYJ_Y_": "Commission de produit (yuan)",
    "HanDaiJieSuan": "Incluant le règlement en attente",
    "XGMCJS": "Explication des termes pertinents",
    "KeHu": "Client",
    "HFXYBDLKHG": "Acheteurs ou distributeurs liés à un distributeur par une relation client",
    "YaoQing": "Invitation",
    "FXYCGYQDXJ": "Distributeurs inférieurs invités avec succès par un distributeur",
    "FXYTJKHGMH": "Commission qu'un distributeur obtient après avoir recommandé un client pour acheter",
    "XJFXYTGSPH": "Récompense qu'un distributeur supérieur obtient après la promotion de produits par un distributeur inférieur",
    // posters-promoting
    "NiCheng": "Pseudo",
    "HaiBaoTuiGuang": "Promotion par affiche",
    "JHBFSGHY_T": "Envoyez l'affiche à des amis, la promotion de boutique apporte des récompenses",
    // settlement-home
    "JieSuanZhongXin": "Centre de règlement",
    "KTXJE": "Montant retirable",
    "TiXianJiLu": "Historique de retrait",
    // withdraw-account
    "KHRXMBNWK": "Le nom du titulaire du compte ne peut pas être vide !",
    "KHHBNWK": "La banque d'établissement ne peut pas être vide !",
    "YHKHBNWK": "Le numéro de carte bancaire ne peut pas être vide !",
    "SFZTPBNWK": "L'image de carte d'identité ne peut pas être vide !",
    "YHKTPBNWK": "L'image de carte bancaire ne peut pas être vide !",
    "BaoCunChengGong": "Enregistrement réussi !",
    "SCSFZ": "Téléverser la carte d'identité",
    "SCYHK": "Téléverser la carte bancaire",
    "BaoCun": "Enregistrer",
    "TiXianZhangHu": "Compte de retrait",
    "TS_QTXZSXX": "Remarque : Veuillez saisir des informations vraies, le retrait est autorisé uniquement après approbation.",
    "KHRXM": "Nom du titulaire du compte",
    "KaiHuHang": "Banque d'établissement",
    "YinhangKaHao": "Numéro de carte bancaire",
    "QSRZSXM": "Veuillez saisir le nom réel",
    "QSRKHHMC": "Veuillez saisir le nom de la banque d'établissement",
    "QSRYHKH": "Veuillez saisir le numéro de carte bancaire",
    // withdraw-deposit
    "QXSZTXZH": "Veuillez d'abord configurer le compte de retrait",
    "QuSheZhi": "Aller configurer",
    "JEXY10Y_BKT": "Montant inférieur à 10 yuan, retrait impossible !",
    "JECGKTXJE": "Montant dépassant le montant retirable !",
    "CGDRKTXSX_": "Dépassement de la limite de retrait journalière, la limite de retrait journalière est de 20000 yuan !",
    "QueDingJiang": "Confirmez-vous de convertir",
    "ZhuanDaoYuE": "en solde ?",
    "_JEDY10YSB": "1. Retrait impossible lorsque le montant est inférieur à 10 yuan ;",
    "_BCTXDZSJ": "2. Le délai de règlement de ce retrait est de 5 jours ouvrables après la réussite de la demande de retrait, la limite de retrait journalière est de 20000 yuan ;",
    "_GBSRWHSS": "3. Ces revenus sont des revenus imposables, veuillez vous rendre auprès des autorités fiscales pertinentes pour déclarer et payer l'impôt sur le revenu personnel par vous-même !",
    "_ZDYEKYYS": "4. La conversion en solde peut être utilisée pour les achats dans la boutique ;",
    "TXSQCG_QDD": "Demande de retrait réussie, veuillez attendre l'examen",
    "JEDYKTXJE_": "Montant supérieur au montant retirable, conversion en solde impossible !",
    "ZZYECG_QDG": "Conversion en solde réussie, veuillez consulter dans l'espace personnel !",
    "BenCiTiXian": "Retrait actuel",
    "ZhuangDaoYuE": "Convertir en solde",
    "TiXianDao": "Retirer sur",
    "JEW0BKZZYE": "Montant égal à 0, conversion en solde impossible !",
    "DRTXSX2WY": "Limite de retrait journalière de 20000 yuan",
    "QuanBuTiXian": "Retirer tout",
    "QueRenTiXian": "Confirmer le retrait",
    // goods-filter-tab
    "ZuiChangGouMai": "Achats les plus fréquents",
    "MoRenPaiXu": "Tri par défaut",
    "ZongHe": "Global",
    "FenLei": "Catégorie",
    "XiaoLiangYouXian": "Priorité à la vente",
    "XiaoLiang": "Ventes",
    "JiaGe": "Prix",
    "ShaiXuan": "Filtrer",
    "ZuiJinGouMai": "Achats récents",
    "CuXiaoYouXian": "Priorité à la promotion",
    "QuanBuFenLei": "Toutes les catégories",
    "ZhiKanCuXiao": "Consulter uniquement les promotions",
    "XuanZeFenLei": "Sélectionner une catégorie",
    "QXZFL": "Veuillez sélectionner une catégorie",
    // goods-list-default
    "ZWXGSP": "Aucun produit pertinent",
    // goods-brand-list
    "PinPaiHui": "Galerie de marques",
    // goods-classify-filter
    "TuiJianFenLei": "Catégories recommandées",
    "ShangPinFenLei": "Catégories de produits",
    "GengDuo": "Plus",
    // goods-detail
    "DLZHBSDQQY": "Le compte connecté n'est pas un client de l'entreprise actuelle",
    "GXNHQ": "Félicitations, vous avez obtenu",
    "SZWSCJGH_C": "Le partage est autorisé uniquement après la configuration du prix de la boutique micro WeChat",
    "JHDJSHS_": "Temps restant avant la fin de l'événement :",
    "DLHKFX": "Connexion requise pour partager",
    "ZZHQXX_QSH": "Obtention d'informations en cours, veuillez réessayer plus tard",
    "Zhang": "carton(s)",
    "Tian": "jour(s)",
    "QXZGGZQPD": "Veuillez sélectionner les spécifications avant de configurer les lampes !",
    "Yuan": "yuan",
    "XS_F_M": "heure(s)/minute(s)/seconde(s)",
    // integral
    "WoDeJiFen": "Mes points",
    "DaBaiLe": "Dépassé",
    "JiFen": "Points",
    "DeHuiYuan": "des membres",
    "ZhuanJiFen": "Gagner des points",
    "JiFenMingXi": "Détails des points",
    "HuanLiPin": "Échanger contre des cadeaux",
    "CKGDHL": "Consulter plus de bons cadeaux",
    "ChaDingDan": "Consulter les commandes",
    // integral-convert
    "DHSLBNCG": "La quantité d'échange ne peut pas dépasser",
    "DuiHuanShuLiang": "Quantité à échanger",
    "SuoXuJiFen": "Points nécessaires",
    // integral-detail
    "LiPinXiangQing": "Détails du cadeau",
    "WoYaoDuiHuan": "Je veux échanger",
    "ShengYu": "Restant",
    "TuWenXiangQing": "Détails graphiques et textuels",
    "Jian": "article(s)",
    "YiDuiWan": "Échangé complètement",
    // integral-filter
    "FenLeiShaiXuan": "Filtrer par catégorie",
    "JiFenShaiXuan": "Filtrer par points",
    // integral-flow
    "JiFenShouRu": "Entrées de points",
    "JiFenZhiChu": "Dépenses de points",
    // integral-logistics
    "DingDanGenZong": "Suivi de commande",
    "WuLiuGongSi": "Société de logistique",
    "WuLiuDanHao": "Numéro de suivi",
    // integral-order
    "DingDanLieBiao": "Liste de commandes",
    "YiFaHuo": "Expédié",
    "JiFenDingDan": "Commande de points",
    "ChaKanWuLiu": "Consulter la logistique",
    // integral-order-create
    "LPSLBZ_QCX": "Quantité de cadeaux insuffisante, veuillez重新payer",
    "JiFenBuZu": "Points insuffisants",
    "ZhiFuXinXi": "Informations de paiement",
    "JiXuGuangGuang": "Continuer à magasiner",
    "QTXSHXX": "Veuillez saisir les informations de réception",
    "DuiHuanChengGong": "Échange réussi",
    "LPDHQR": "Confirmation d'échange de cadeau",
    "SCCKJ": "Prix de référence du marché",
    "LiJiZhiFu": "Payer immédiatement",
    // integral-order-detail
    "DingDanXiangQing": "Détails de la commande",
    "DingDanZhuangTai": "Statut de la commande",
    "DingDanBianHao": "Numéro de commande",
    "DuiHuanShiJian": "Heure d'échange",
    "ShouHuoXinXi": "Informations de réception",
    "HuaFeiJiFen": "Points dépensés",
    // integral-rule
    "QDZJF": "Gagner des points par check-in",
    "XDZJF": "Gagner des points par commande",
    "1_MRQD_JL": "1. Check-in quotidien, récompense de {num} points",
    "2_LXQD3T_EW": "2. Check-in continu pendant 3 jours, récompense supplémentaire de {num} points",
    "3_LXQD7T_EW": "3. Check-in continu pendant 7 jours, récompense supplémentaire de {num} points",
    "DLZJF": "Gagner des points par connexion",
    "MRDLYSDHSC": "Connexion quotidienne au magasin {name}, récompense de {num} points",
    "DDWCHKHDYD": "Après la terminaison de la commande, vous pouvez obtenir des points égaux au montant de la commande × {num}",
    // integral-rule-detail
    "GuiZe": "Règles",
    // integral-sign
    "QianDaoYouLi": "Check-in avec récompense",
    "QianDaoGuiZe": "Règles de check-in",
    "YLXQD": "Check-in continu depuis",
    "YLXQD1T": "Check-in continu pendant {num} jours",
    "QDCG_NYJLX": "Check-in réussi, vous avez effectué un check-in continu pendant {num} jours",
    "QDCG_BCHD1": "Check-in réussi, vous obtenez {num} points cette fois",
    "BCQDHD4JF_": "Vous obtenez {num} points par ce check-in, bravo !",
    "QSRBZ": "Veuillez saisir une remarque",
    "DingDanZengPin": "Cadeau de commande",
    "GuiGeBianHao": "Numéro de spécification",
    "GuiGe": "Spécification",
    // combined-pay
    "CDDWXFK": "Cette commande ne nécessite pas de paiement",
    "YHYEBZ": "Solde de l'utilisateur insuffisant !",
    "ZFJEBNW0": "Le montant de paiement ne peut pas être 0 !",
    "ZFJEBNDYDD": "Le montant de paiement ne peut pas être supérieur au montant en attente de paiement de la commande",
    "DFKJE": "Montant en attente de paiement",
    "FuKuanFangShi": "Mode de paiement",
    "FuJian": "Pièces jointes",
    "ZHYFZ": "Compte copié",
    "GHSKZH": "Changer le compte de règlement",
    "SYXXZFQSCF": "Pour le paiement hors ligne, veuillez téléverser une capture d'écran du paiement pour que la finance confirme le montant !",
    "XXZF_BXXZS": "Paiement hors ligne, il faut sélectionner un compte de règlement",
    "DingDanZhiFu": "Paiement de commande",
    "ZFFS_HDFK": "Mode de paiement : Paiement à la livraison",
    "BCFKJE": "Montant de paiement actuel",
    "YuE": "Solde",
    "FuZhiZhangHao": "Copier le compte",
    "WSZXCXZFPZ": "Configuration de paiement de mini-programme non définie",
    "XCXZFZHJY": "Compte de paiement de mini-programme désactivé",
    "SRZFJE": "Saisir le montant de paiement",
    "FuKuanZhangHu": "Compte de paiement",
    "QueRenZhiFu": "Confirmer le paiement",
    "ShaoHouZhiFu": "Payer plus tard",
    // order
    "FKJLYTJ_DD": "L'historique de paiement a été ajouté, en attente d'examen de la finance",
    "JiXuGuang": "Continuer à magasiner",
    "BenCiFuKuan": "Paiement actuel",
    "FuKuanChengGong": "Paiement réussi",
    "ZhiFuFangShi": "Mode de paiement",
    "ZhiFuDingDan": "Payer la commande",
    // order-batch-pay
    "QXXZSXZFDD": "Veuillez d'abord sélectionner les commandes à payer",
    "PiLiangFuKuan": "Paiement en masse",
    "FuKuan": "Payer",
    "QuFuKuan": "Aller payer",
    // order-create-result
    "YingFuJinE": "Montant à payer",
    "XiaDanShiJian": "Heure de commande",
    // order-deliver
    "SFQRSH": "Êtes-vous sûr de confirmer la réception ?",
    "DDQRSH": "Confirmation de réception de commande",
    "DFHSP": "Produits en attente d'expédition",
    "ShangPinShuLiang": "Quantité de produits",
    "ChuKuShiJian": "Heure de sortie de stock",
    "FaHuoShiJian": "Heure d'expédition",
    "WuLiuBeiZhu": "Remarque de logistique",
    "QueRenShouHuo": "Confirmer la réception",
    "RYFK_QJSYG": "Si vous avez déjà payé, veuillez contacter l'administrateur en temps voulu",
    "QSRQXYY": "Veuillez saisir la raison d'annulation",
    "H_DDJZDGB_QJKF": ", la commande sera automatiquement fermée, veuillez payer en temps voulu",
    "TuiHuoQingKuang": "Situation de retour",
    "DingDanZongE": "Montant total de la commande",
    "DingDanBeiZhu": "Remarque de commande",
    "FaHuoQingKuang": "Situation d'expédition",
    "DingDanFuJian": "Pièces jointes de commande",
    "ShenQingTuiHuo": "Demander un retour",
    "G1TDSHJL_QRS": "Total {num} enregistrements en attente de réception, confirmez-vous la réception ?",
    "DaiXiaDan": "Commande en représentation",
    "DingDanHao": "Numéro de commande",
    "XiaDanFangShi": "Mode de commande",
    "TuiHuoDan": "Bon de retour",
    "ShangPinZongE": "Montant total de produits",
    "YunFei_ZongZhong": "Frais de livraison (poids total",
    "SF_SPWS": "Taxe (produit non taxé",
    "TePiJia": "Prix spécial",
    "FuKuanQingKuang": "Situation de paiement",
    "TiaoJiLu": "enregistrement(s)",
    "ZaiLaiYiDan": "Une autre commande",
    "MuLiuXinXi": "Informations de logistique",
    "QDSCGDD_": "Êtes-vous sûr de supprimer cette commande ?",
    "YiQueRen": "Confirmé",
    "YiShouHuo": "Reçu",
    "DaiFuJinE": "Montant en attente de paiement",
    "YiFuJinE": "Montant payé",
    "ZanWuJiLu": "Aucun enregistrement",
    "SPMC_DDH": "Nom du produit / Numéro de commande",
    "FuKuanZhuangTai": "Statut de paiement",
    "FaHuoZhuangTai": "Statut d'expédition",
    "QiShiShiJian": "Heure de début",
    "ZhongZhiShiJian": "Heure de fin",
    // order-list
    "CaoZuoChengGong": "Opération réussie",
    "ZBKGM": "Non achetable temporairement",
    "DQDDSPYXJ": "Le produit de la commande actuelle a été retiré de vente",
    "DQDDBFSPYXJ": "Certains produits de la commande actuelle ont été retirés de vente",
    "JTJSJSP": "Ajouter uniquement les produits en vente",
    "DingHuoDan": "Bon de commande",
    // order-log
    "DingDanRiZhi": "Journal de commande",
    // order-logistics
    "FuZhiChengGong": "Copie réussie",
    "FuZhiShiBai": "Échec de copie",
    "FuZhi": "Copier",
    "BoDa": "Appeler",
    "WCWLDHXX": "Aucune information sur ce numéro de suivi",
    // order-pay
    "ZFCS_QCXXD": "Paiement expiré, veuillez重新passer la commande",
    "YQYYCKZF": "Paiement par pré-dépôt activé",
    "BNDYDFKJE": "Ne peut pas être supérieur au montant en attente de paiement",
    "ZFJEBNWK": "Le montant de paiement ne peut pas être vide",
    "QXAPFK_FKH": "Veuillez d'abord organiser le paiement, après le paiement, téléversez une capture d'écran des informations de paiement pour que la finance confirme le montant",
    "DDTJCG_QJS": "Commande soumise avec succès, veuillez payer en temps voulu",
    "QXZFKFS": "Veuillez sélectionner le mode de paiement",
    "SYYEZFH_HX": "Après le paiement par solde, il reste à payer",
    // order-pay（续）
    "FuKuanJiLu": "Historique de paiement",
    "ZWFKJL": "Aucun historique de paiement",
    "FuKuanXiangQing": "Détails de paiement",
    "FuKuanJinE": "Montant de paiement",
    "ZhiDan": "Création de document",
    "ShenHe": "Examen",
    "ZuoFei": "Annulation",
    "ZuoFeiYuanYin": "Raison d'annulation",
    "GLDHD": "Bon de commande associé",
    "HeXiaoJinE": "Montant validé",
    "HeXiaoZhuangTai": "Statut de validation",
    "DanJuZhuangTai": "Statut de document",
    "KeHuMingCheng": "Nom du client",
    "ZhangDanHao": "Numéro de facture",
    "ShouKuanZhangHao": "Compte de règlement",
    "ShouKuanShiJian": "Heure de règlement",
    "FuKuanPingZheng": "Justificatif de paiement",
    "GeFuJian": "pièce(s) jointe(s)",
    // order-statistics
    "DingDanTongJi": "Statistiques de commandes",
    "DingHuo0Bi": "{num} commande(s)",
    // order-statistics-detail
    "DDTJMX": "Détails des statistiques de commandes",
    "AGGTJ": "Statistiques par spécification",
    "AFLTJ": "Statistiques par catégorie",
    "DDJE_Y": "Montant de commande / yuan",
    "DHSP_Z": "Produits commandés / type(s)",
    "DingHuoDan_Bi": "Bon de commande / unité(s)",
    "DingHuoShangPin": "Produits commandés",
    "JinE": "Montant",
    // refund-list
    "TuiHuo": "Retour",
    // refund-apply
    "THDHWBC_QD": "Bon de retour non enregistré, confirmez-vous la sortie ?",
    "QSRSQTHJE": "Veuillez saisir le montant de retour demandé",
    "QSRTHJE": "Veuillez saisir le montant de retour",
    "QSRBZXX": "Veuillez saisir une remarque",
    "YingTuiJinE": "Montant à rembourser",
    "TJTHSQ": "Envoyer la demande de retour",
    "QXXZDHQD": "Veuillez d'abord choisir la liste de commande",
    "DingHuoQingDan": "Liste de commande",
    "SQTHJE": "Montant de retour demandé",
    "DJXZSP": "Cliquez pour choisir le produit",
    "TuiHuoJinE": "Montant de retour",
    // refund-detail
    "THDDXQ": "Détails du bon de retour",
    "YiTuiHuo": "Retourné",
    "YiTuiKuan": "Remboursé",
    "THDZT": "Statut du bon de retour",
    "TuiHuoDanHao": "Numéro de bon de retour",
    "TuiHuoShiJian": "Heure de retour",
    "TuiHuoCangKu": "Entrepôt de retour",
    "THLXR": "Contact pour retour",
    "TuiHuoQingDan": "Liste de retour",
    "TuiKuanZongE": "Total de remboursement",
    "TuiKuanQingKuang": "Situation de remboursement",
    "DaiTuiJinE": "Montant à rembourser",
    "YiTuiJinE": "Montant remboursé",
    // refund-product
    "SPMC_BH_GG": "Nom du produit / Référence / Référence de spécification / Code-barres",
    "GZD1TJG": "1 résultat trouvé",
    "JiaRuQingDan": "Ajouter à la liste",
    // refund-result
    "ShenQingChengGong": "Demande enregistrée avec succès",
    "THDTJCG": "Bon de retour envoyé avec succès",
    "ChaKanXiangQing": "Voir les détails",
    // goods-package-floor
    "HDWKS_WDZL": "Événement non démarré, revenez plus tard",
    "HDYJS_XCZD": "Événement terminé, venez plus tôt la prochaine fois",
    "ZWSZBT": "Titre non défini temporairement",
    "ChaKanGengDuo": "Voir plus",
    // goods-promotion-floor
    "HCDZSJC": "Décalage horaire dû au cache",
    "DLCKCXJ": "Connexion requise pour consulter le prix promotionnel",
    "ZWSZCX": "Aucune promotion définie temporairement",
    "JuKaiShi": "Temps restant avant le démarrage",
    "Song": "Offert",
    "JuJieShu": "Temps restant avant la fin",
    "YiJieShu": "Terminé",
    // search-floor
    "XiaoXi": "Messages",
    "SaoMaXiaDan": "Passer une commande par scan",
    // home-page-custom
    "WZLCSJ": "Données d'étage inconnues",
    // jump-error
    "QXZYSDHAPP": "Veuillez télécharger l'APP Yunshang Ordering",
    "QMTYQYGLD": "Découvrir l'expérience complète de l'administration d'entreprise",
    "XZYSDHAPP": "Télécharger l'APP Yunshang Ordering",
    "HQGLDWZTY": "Obtenir l'expérience complète de l'administration",
    "JXTYDHD": "Continuer à utiliser la plateforme de commande",
    // notice-detail
    "GongGaoXiangQing": "Détails de l'annonce",
    "GongGaoFuJian": "Pièces jointes de l'annonce",
    // shop-error
    "NFWDYMBCZO": "La page que vous consultez n'existe pas ~",
    "KeNengYuanYin": "Raisons possibles",
    "1_ZDZLSRCWD": "1. Adresse incorrecte saisie dans la barre d'adresse ;",
    "2_DJLGQLJ": "2. Lien expiré cliqué.",
    // shop-index
    "GuanLiDuan": "Administration",
    "ZhuCe": "Inscription",
    "HYNTYYSDH": "Bienvenue à découvrir Yunshang Ordering",
    "TYZHSJHDQG": "Les données du compte d'essai sont mises à jour régulièrement, veuillez ne pas saisir d'informations sensibles",
    "TYZHZDNRSJ": "Les données du compte d'essai sont fictives, veuillez ne pas saisir d'informations sensibles",
    "ZHZCCG": "Inscription de compte réussie",
    "DengLuZhangHao": "Compte de connexion",
    "CSMMW": "Mot de passe initial :",
    "GNFYHQL": "Un coupon vous a été envoyé",
    "Man1YuanKeYong": "Utilisable à partir de {num} yuan",
    "LQH1TNKY": "Utilisable dans {day} jours après réception",
    "YiJianLingQu": "Réclamer en un clic",
    "GXNHD1ZYHQ": "Félicitations, vous avez obtenu {num} coupon(s)",
    "Gong1Yuan": "Total {num} yuan",
    "LiJiShiYong": "Utiliser immédiatement",
    // shop-login
    "NHWDL": "Vous n'êtes pas connecté",
    // shop-notice
    "ShangChengGongGao": "Annonces de la boutique",
    "ZanWuGongGao": "Aucune annonce temporairement",
    "1GeFuJian": "{num} pièce(s) jointe(s)",
    // deposit-detail
    "KouKuan": "Débit",
    "ChongZhi_Kuan": "Recharge",
    "KouKuanZuoFei": "Annulation de débit",
    "ChongZhiZuoFei": "Annulation de recharge",
    "ZhangHuMingXi": "Détails du compte",
    "ZhangHuYuE": "Solde du compte",
    "LiJiChongZhi": "Recharger immédiatement",
    // deposit-recharge
    "CZJEBNXY1Y": "Le montant de recharge ne peut pas être inférieur à 1 yuan",
    "QSRZQDSZ": "Veuillez saisir une valeur valide",
    "ZDYJE": "Montant personnalisé",
    "ZWKTXSCZGN": "Fonction de recharge en ligne non activée temporairement",
    "ShiFuJinE": "Montant réel à payer",
    "ZhangHuChongZhi": "Recharge de compte",
    "QXZCZJE": "Veuillez choisir le montant de recharge",
    "QSRCZJE": "Veuillez saisir le montant de recharge",
    "QLXNDZSYWY": "Veuillez contacter votre commercial dédié pour recharger",
    "ShouJia": "Prix de vente",
    "YiShouQing": "Épuisé",
    "ChongZhiJinE": "Montant de recharge",
    "QueRenFuKuan": "Confirmer le paiement",
    // deposit-recharge-result
    "QSDDID": "ID de commande manquant",
    "ChongZhiChengGong": "Recharge réussie",
    "ChongZhiShiBai": "Échec de recharge",
    "CLZ_QSH...": "Traitement en cours, veuillez patienter...",
    "ChongZhiFangShi": "Mode de recharge",
    "ChongZhiShiJian": "Heure de recharge",
    "JYLSH": "Numéro de transaction",
    "FanHuiShangCheng": "Retourner à la boutique",
    // recharge-online
    "ZFSB_QCS": "Échec de paiement, veuillez réessayer",
    "ZFYQX": "Paiement annulé",
    "ZFYC_QCS": "Anomalie de paiement, veuillez réessayer",
    // user
    "LingQuanZhongXin": "Centre de coupons",
    "WeiShiYong": "Non utilisé",
    "YiShiYong": "Utilisé",
    "ZWYHQ": "Aucun coupon temporairement",
    // keep-list
    "YiGouMai": "Acheté",
    "ChangYongQingDan": "Liste fréquemment utilisée",
    "WoDeShouCang": "Mes favoris",
    "QuGouWuChe": "Aller au panier",
    "GeShangPin": "produit(s)",
    // login
    "YunShangDingHuo": "Yunshang Ordering",
    "QSRZH": "Veuillez saisir le compte !",
    "QSRMM": "Veuillez saisir le mot de passe !",
    "QSRDLZH": "Veuillez saisir le compte de connexion",
    "JiZhuMiMa": "Se souvenir du mot de passe",
    "WangJiMiMa": "Mot de passe oublié ?",
    "DengLu": "Connexion",
    "DLZHBCZ_QL": "Compte de connexion n'existe pas, veuillez contacter l'administrateur pour l'activer",
    "GQYZHSBJY_": "Ce compte d'entreprise est désactivé, veuillez contacter Yunshang Ordering",
    "GQYZHSYQJS_": "La période d'essai du compte d'entreprise a expiré, veuillez contacter Yunshang Ordering",
    "GQYZHYGQL_": "Ce compte d'entreprise a expiré, un renouvellement est nécessaire pour l'utiliser, veuillez contacter Yunshang Ordering",
    "LiJiTiYan": "Essayer immédiatement",
    // my-collect
    "YiChuChengGong": "Suppression réussie",
    "QueHuo": "Hors stock",
    "YCSCJ": "Supprimer des favoris",
    // order-message
    "SheZhiChengGong": "Configuration réussie",
    "ZWWDXX": "Aucun message non lu temporairement",
    "QuanBuYiDu": "Tout marquer comme lu",
    "DingDanXiaoXi": "Messages de commande",
    "YiQiang": "A été pris",
    "LiJiLingQu": "Réclamer immédiatement",
    "LingQuanHou": "Après réception du coupon",
    "TianNeiKeYong": "utilisable dans {num} jour(s)",
    "QSRSJH": "Veuillez saisir le numéro de téléphone",
    "QSRYZM": "Veuillez saisir le code de vérification",
    "QSRXMM": "Veuillez saisir le nouveau mot de passe",
    "QSRZQSJGS": "Veuillez saisir un format de numéro de téléphone valide",
    "ChongZhiMiMa": "Réinitialiser le mot de passe",
    "QSRNDSJHM": "Veuillez saisir votre numéro de téléphone",
    "QSRDXYZ": "Veuillez saisir le code de vérification SMS",
    "HQYZM": "Obtenir le code de vérification",
    "HKCXHQ": "Réobtention possible dans {num} seconde(s)",
    "QSR6_20WSZHZ": "Veuillez saisir un mot de passe de 6-20 caractères alphanumériques",
    // share-setting
    "QSRSPJGBL": "Veuillez saisir le taux de prix du produit",
    "SPJGBLBXDY": "Le taux de prix du produit doit être supérieur ou égal à 100 et inférieur à 999,99",
    "DPMCZBZCTS": "Le nom de la boutique ne supporte pas les symboles spéciaux temporairement",
    "LXRZBZCTSF": "Le contact ne supporte pas les symboles spéciaux temporairement",
    "LXFSZBZCTS": "Le moyen de contact ne supporte pas les symboles spéciaux temporairement",
    "LXDZZBZCTS": "L'adresse de contact ne supporte pas les symboles spéciaux temporairement",
    "DPJJZBZCTS": "La description de la boutique ne supporte pas les symboles spéciaux temporairement",
    "QSRDPJJ_ZD": "Veuillez saisir la description de la boutique, maximum 50 caractères",
    "FenXiangSheZhi": "Configuration de partage",
    "NDWSCSPJG": "Prix des produits de votre boutique micro WeChat",
    "NDDHJ_": "Votre prix de commande ×",
    "LXXX_KBJ_": "Informations de contact (modifiables)",
    "DianPuMingCheng": "Nom de la boutique",
    "JianJie": "Description",
    "QSRDPMC": "Veuillez saisir le nom de la boutique",
    "LianXiRen": "Contact",
    "QSRLXR": "Veuillez saisir le contact",
    "LianXiFangShi": "Moyen de contact",
    "QSRLXFS": "Veuillez saisir le moyen de contact",
    "LianXiDiZhi": "Adresse de contact",
    "QSRLXDZ": "Veuillez saisir l'adresse de contact",
    // user（续）
    "WoDeDingDan": "Mes commandes",
    "ZuiJinLiuLan": "Dernières visites",
    "ShouCangShangPin": "Produits favoris",
    "BDYYZH_ZC": "Lier un compte existant | Inscrire un nouveau compte",
    "DL_ZC": "Connexion | Inscription",
    "BangDingShouJi": "Lier le téléphone",
    "TS_BDSJHM_": "Remarque : Liez votre numéro de téléphone pour renforcer la sécurité du compte !",
    "ChaKanQuanBu": "Voir tout",
    "ShouHuoDiZhi": "Adresse de livraison",
    "LianXiWoMen": "Nous contacter",
    "SheZhi": "Configuration",
    "QuQianDao": "Aller au check-in",
    "QianDao": "Check-in",
    "JiFenShangCheng": "Boutique de points",
    "TuiGuangShangPin": "Promouvoir des produits",
    "QuChaKan": "Aller consulter",
    "JiFenHuanLi": "Échanger des points contre des cadeaux",
    "DYSPBQ": "Imprimer l'étiquette du produit",
    // user-about
    "GYYSDH": "À propos de Yunshang Ordering",
    "YQHYSMEWM_": "Invitez vos amis à scanner le code QR pour télécharger et installer",
    "DangQianBanBen": "Version actuelle",
    // user-address
    "ZWSHDZ": "Aucune adresse de livraison temporairement",
    "WoDeDiZhi": "Mes adresses",
    "ZhiNengShiBie": "Reconnaissance intelligente",
    "ZTDZXXKZNS": "Collez les informations d'adresse pour reconnaître automatiquement le nom, le téléphone et l'adresse",
    "MoRen": "Par défaut",
    "QRSCDZ": "Confirmez-vous la suppression de l'adresse ?",
    "SHRXM": "Nom du destinataire",
    "SJHMHGDDHZ": "Au moins un numéro de téléphone portable ou fixe doit être saisi",
    "QSRSHRXM": "Veuillez saisir le nom du destinataire",
    "ShouJiHaoMa": "Numéro de téléphone portable",
    "GuDingDianHua": "Numéro de téléphone fixe",
    "QSRGDDH": "Veuillez saisir le numéro de téléphone fixe",
    "SuoZaiDiQu": "Région",
    "QSRSZDQ": "Veuillez saisir la région",
    "QSRXXDZ": "Veuillez saisir l'adresse détaillée !",
    "QSRZQDSJHM": "Veuillez saisir un numéro de téléphone portable valide",
    "QSRZQDGDDH": "Veuillez saisir un numéro de téléphone fixe valide",
    "XiangXiDiZhi": "Adresse détaillée",
    "MoRenDiZhi": "Adresse par défaut",
    "SWMRDZ": "Définir comme adresse par défaut",
    "BCBSY": "Enregistrer et utiliser",
    // user-bing-one
    "QSRSJHM": "Veuillez saisir le numéro de téléphone",
    "GYHYZC": "Ce compte utilisateur est déjà inscrit",
    "GSJHMYJZCG": "Ce numéro de téléphone est déjà inscrit",
    "QZJDLJK": "Veuillez vous connecter directement",
    "QuDengLu": "Aller se connecter",
    "BDHKYTGSJH": "Après liaison, vous pouvez vous connecter via le numéro de téléphone, ce qui facilite la récupération du mot de passe et améliore la sécurité du compte",
    "_BDHKYTGSJ": "*Après liaison, vous pouvez vous connecter via le numéro de téléphone, ce qui facilite la récupération du mot de passe et améliore la sécurité du compte",
    "QSRSJYZM": "Veuillez saisir le code de vérification SMS",
    "BDXSJ": "Lier un nouveau téléphone",
    "DXYZM": "Code de vérification SMS",
    "XiaYiBu": "Étape suivante",
    "TGCBZ": "Passer cette étape",
    // user-bing-two
    "DBDSJHMBCZ": "Le numéro de téléphone à lier n'existe pas !",
    "QSRDLMM": "Veuillez saisir le mot de passe de connexion !",
    "_GSJHMYBDY": "*Ce numéro de téléphone est déjà lié à un compte Yunshang Ordering, vérifiez le mot de passe de connexion du téléphone pour lier au compte actuel",
    "DQZHMMJTBW": "Le mot de passe du compte actuel sera synchronisé avec le mot de passe de connexion du téléphone",
    "DangQianZhangHao": "Compte actuel",
    "QDYJZ": "Confirmez-vous de supprimer",
    "JSPSCM": "produit(s) ?",
    "ShanChuChengGong": "Suppression réussie !",
    // user-info
    "SJGSCW": "Format de numéro de téléphone incorrect",
    "YXGSCW": "Format d'e-mail incorrect",
    "WoDeZhangHao": "Mon compte",
    "YouXiang": "E-mail",
    "ShouJi": "Téléphone",
    "XingMing": "Nom",
    "XiuGaiTouXiang": "Modifier l'avatar",
    "JiBenXinXi": "Informations de base",
    "ZhangHaoAnQuan": "Sécurité du compte",
    "XiuGaiMiMa": "Modifier le mot de passe",
    "DianJiBangDing": "Cliquez pour lier",
    "RYDSHTY_QL": "Si vous l'avez perdu ou désactivé, veuillez le remplacer immédiatement pour éviter le vol du compte",
    "WBZNDZHAQ_": "Pour garantir la sécurité de votre compte, veuillez lier votre téléphone",
    "QSRNDXM": "Veuillez saisir votre nom",
    "QSRNDDH": "Veuillez saisir votre numéro de téléphone",
    "QSRNDYX": "Veuillez saisir votre e-mail",
    // user-setting
    "QCHCHXCXDL": "Une nouvelle connexion est requise après la suppression du cache",
    "QingChuHuanCun": "Supprimer le cache",
    "QDYQCHCM": "Confirmez-vous la suppression du cache ?",
    "TuiChuDengLu": "Déconnexion",
    "ZhangHaoZhuXiao": "Désinscription du compte",
    "QieHuanZhangHao": "Changer de compte",
    // user-supplier
    "LianXi": "Contacter",
    "GongSiDianHua": "Téléphone de l'entreprise",
    "DiZhi": "Adresse",
    // vouchers-detail
    "DJQMX": "Détails du bon d'achat",
    // vouchers-list
    "BuKeYong": "Inutilisable",
    "KeYong": "Utilisable",
    "ZWDJQ": "Aucun bon d'achat temporairement",
    "ZongEDu": "Montant total",
    "FaFangShiJian": "Heure de distribution",
    "EDYYW": "Montant épuisé",
    "QBSPKY": "Utilisable pour tous les produits",
    // vouchers-select-list
    "WDDJQ": "Mes bons d'achat",
    "KYDJQ": "Bons d'achat utilisables",
    "DJQKDK": "Bons d'achat déductibles",
    "CKKYSP": "Voir les produits utilisables",
    "BKYDJQ": "Bons d'achat inutilisables",
    "BKYYY_ZWFH": "Raison d'inutilisabilité : Aucun produit correspondant",
    // goods-detail（续）
    "DQSPWSCGGT": "Aucune image de spécification n'a été téléversée pour ce produit, la configuration de lampes n'est pas supportée !",
    "BoFangShiPin": "Lire la vidéo",
    "Gong1GeGuiGe": "{num} spécification(s) au total",
    "YiXuanGuiGe": "Spécification sélectionnée",
    "XuanGuiGe": "Choisir la spécification",
    "LingQuan": "Réclamer le coupon",
    "1ZhongCuXiao": "{num} promotion(s)",
    "1ZhangKeYong": "{num} coupon(s) utilisable(s)",
    "ZuiGaoKeSheng": "Économies maximales",
    "ShangPinTaoCan": "Pack de produits",
    "Gong1GeTaoCan": "{num} pack(s) au total",
    "ShangPinCanShu": "Paramètres du produit",
    "ZhanKai": "Déplier",
    "YiShouCang": "Déjà dans les favoris",
    "ShouCang": "Ajouter aux favoris",
    "KeFu": "Service client",
    "XiangQing": "Détails",
    "TuiJian": "Recommandations",
    "BianHao": "Référence",
    "ShangPinXinXi": "Informations du produit",
    "KLYHQ": "Coupon(s) réclamable(s)",
    "KuCunBuZu": "Stock insuffisant",
    "DuoGuiGe": "Plusieurs spécifications",
    "YiShou": "Vendu",
    "SWBHZ_YS": "Réapprovisionnement en cours, vendu",
    "CuXiaoShangPin": "Produit en promotion",
    // goods-search
    "NHWSRSSNR": "Aucun contenu de recherche saisi",
    "SouSuo": "Rechercher",
    "SSY1XGDSP": "Rechercher des produits liés à {searchKey}",
    "Yue1GeShangPin": "Environ {num} produit(s)",
    "ZuiJinSouSuo": "Dernières recherches",
    "QingChu": "Supprimer",
    "ZWSSJL": "Aucun historique de recherche temporairement",
    // goods-property
    "ZGJGBNDYZD": "Le prix maximum ne peut pas être inférieur au prix minimum",
    "ShangPinBiaoQian": "Étiquette du produit",
    "BuGaoYu1": "Pas supérieur à 1",
    "BuDiYu1": "Pas inférieur à 1",
    "FengGe": "Style",
    // goods-promotion-list
    "JiJiangKaiShi": "Va démarrer",
    "QuanBuCuXiao": "Toutes les promotions",
    // goods-package-list
    "Gong1JianShangPin": "{num} produit(s) au total",
    "Sheng": "Économies",
    // goods-package-detail
    "GTCZGWCZDS": "La quantité du pack dans le panier a atteint la limite d'achat, impossible de l'ajouter",
    "GTCKCBZ_BK": "Le stock du pack est insuffisant, impossible de l'ajouter",
    "JinSheng1Tao": "{num} pack(s) restant(s)",
    "XianGou1Tao": "Limite d'achat : {num} pack(s)",
    "TaoCanXiangQing": "Détails du pack",
    "DanMaiJia": "Prix à l'unité",
    "TaoCanJia": "Prix du pack",
    "HDYJS": "Événement terminé",
    // goods-message
    "WDL_QXDL": "Non connecté, veuillez d'abord vous connecter",
    // goods-list-label
    "XinPinShangShi": "Nouveauté",
    "WDLZH_ZWCX": "Non connecté, aucune promotion temporairement !",
    "YiXiaShangPin": "Produits ci-dessous",
    // goods-list
    "1ZhongGuiGe": "{num} spécification(s)",
    "YouKuCun": "En stock",
    // goods-filter
    "BuGaoYu": "Pas supérieur à",
    "BuDiYu": "Pas inférieur à",
    "CuXiao": "Promotion",
    "ZDYXXZ3G": "Maximum 3 sélections autorisées",
    "GouMai": "Achat",
    "Gong1Jian": "{num} pièce(s) au total",
    // 缺失部分
    "YiChuShouCangJia": "Supprimer des favoris",
    "$": "￥",
    "$1": "￥{num}",
    "_8999_1Qi": "￥ 8999.1 et plus",
    "Ge": "unité(s)",
    "BaoZhuangFangShi": "Mode d'emballage",
    "QRSCSP_": "Confirmez-vous la suppression du produit ?",
    "JEWM_TMFRK": "Placez le code QR/barres dans le cadre pour le scan automatique",
    "0ZSP_G0J": "0 type de produit, 0 pièce au total",
    "JiuMiMa": "Ancien mot de passe",
    "XMM_6_20WZ": "Nouveau mot de passe (6-20 caractères alphanumériques)",
    "QueRenMiMa": "Confirmer le mot de passe",
    "BDHKSYSJHD": "Après liaison, vous pouvez vous connecter via le numéro de téléphone, ce qui facilite la récupération du mot de passe et améliore la sécurité du compte",
    "YanZhengMa": "Code de vérification",
    "1MHKCXHQ": "Réobtention possible dans 1 seconde",
    "CSJHZ1MQFS": "Un code de vérification a été envoyé à ce numéro il y a 1 seconde, veuillez réessayer plus tard",
    "GouMaiJiLu": "Historique d'achats",
    "XinZengDiZhi": "Ajouter une adresse",
    "LingShouJia": "Prix de détail",
    "YouHuiJia": "Prix promotionnel",
    "ShangPinChuKu": "Sortie de produit du stock",
    "DengDaiShouHuo": "Attente de réception",
    "ShouHuoRen": "Destinataire",
    "PaiZhao": "Prendre une photo",
    "XiangCe": "Album",
    "TiYanGuan": "Salle d'expérience",
    "JingYingShiJian": "Heures d'ouverture",
    "ZhanGuanDianHua": "Téléphone de la galerie",
    "ZhanGuanDiZhi": "Adresse de la galerie",
    "SJHQZ_QSDZ": "Récupération de données en cours, veuillez réessayer plus tard !",
    "QXXZSF_": "Veuillez d'abord choisir la province !",
    "QuanBuShengFen": "Toutes les provinces",
    "QuanBuChengShi": "Toutes les villes",
    "YingYeShiJian": "Heures d'activité",
    "ChanPinBianHao": "Référence du produit",
    "DLXXYGQ_QC": "Informations de connexion expirées, veuillez vous reconnecter",
    "Man999Jian100": "Réduction de {n} yuan à partir de {m} yuan",
    "YiManZu": "Condition atteinte",
    "QDYCSP_": "Confirmez-vous la suppression du produit ?",
    "DGM10JZ1J": "Commande de 10 pièces offerte 1 pièce",
    "XiaXianTongZhi": "Notification de mise hors ligne",
    "NDZHYZQTSB": "Votre compte est connecté sur un autre appareil, veuillez vous reconnecter. Si ce n'est pas vous, veuillez modifier votre mot de passe immédiatement",
    "ManJiang": "Réduction de {num} yuan à partir de {target} pièces",
    "ZGLXMJ": "Achetez {num} pièces davantage pour bénéficier de 【≥ {target} pièces à {money_} yuan】",
    "ZGLXMZ": "Achetez {num} pièces davantage pour bénéficier de 【≥ {target} pièces à {percent}%】",
    "QSRZQNR": "Veuillez saisir un contenu valide",
    "NHYDDQKWJQ": "Vous avez {num} commande(s) impayée(s) totalisant {money} yuan, veuillez régler avant de passer de nouvelles commandes",
    "FaPiaoZhuShou": "Assistant de facturation",
    "WoDeFaPiao": "Mes factures",
    "FaPiaoXiangQing": "Détails de la facture",
    "KaiPiaoShiJian": "Heure de facturation",
    "DaiKaiFaPiao": "Facture à émettre",
    "DKFPJE": "Montant de facture à émettre",
    "KaiPiaoJinE": "Montant de facture",
    "ZFYDWT_QCSCXZF": "Problème de paiement, veuillez réessayer ou changer de mode de paiement",
    "QingXuanZhe": "Veuillez choisir",
    "ShouXin": "Crédit",
    "LJSQSXED": "Demander immédiatement un plafond de crédit",
    "SXEDSHZ": "Plafond de crédit en cours d'examen",
    "SXCZ_XDCG": "Crédit suffisant, commande réussie",
    "SXEDBZ_FKHFH": "Crédit insuffisant, expédition après paiement",
    "CGJKZQ_FKFH": "Dépassement de la période de prêt, expédition après paiement",
    "DDTJCG_XZZCZHYB": "Commande soumise avec succès, il ne reste plus qu'une étape !",
    "MianFeiLing": "Réclamer gratuitement",
    "M_KMFLQ_HQ": "Gratuit à partir de {target} yuan, {short} yuan manquant(s)",
    "YHDMFSP": "Produit gratuit obtenu",
    "JRMFL": "Réclamation gratuite du jour",
    "LingGuangLe": "Épuisé",
    "KeLingQu": "Réclamable",
    "YuGuJia": "Prix estimé",
    "GXNHQ_Z_Y_": "Félicitations, vous avez obtenu {num} coupon(s) de {price} yuan ({name})",
    "LXZSKF": "Contacter le service client dédié",
    "DPYDY_QSHX": "Boutique fermée, veuillez passer commande plus tard",
    "DaYangShiJian": "Heure de fermeture",
    "ChuanHaoChaXun": "Recherche de numéro de série",
    "IMEI": "Numéro de série (IMEI)",
    "FanKuanYuE": "Solde de remboursement",
    "FanKuanZhiFu": "Paiement par remboursement",
    "JingDongYiYunJia": "JD Cloud+",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "Solde de remboursement insuffisant",
    "FanKuanZhangHu": "Compte de remboursement",
    "HaiXuZhiFu": "Il reste à payer {price}",
    "QTXGSMC": "Veuillez saisir le nom de l'entreprise",
    "QSCSFZZMZ": "Veuillez téléverser la photo recto de la carte d'identité",
    "QSCSFZFMZ": "Veuillez téléverser la photo verso de la carte d'identité",
    "QSCYYZZ": "Veuillez téléverser le certificat d'entreprise",
    "TJCG_QNXDDSH": "Soumission réussie, veuillez attendre l'examen",
    "SXSQ": "Demande de crédit",
    "QYJBZL": "Informations de base de l'entreprise",
    "SQFRSFZZM": "Téléverser la photo recto de la carte d'identité du responsable légal",
    "ZMSLT": "Exemple de recto",
    "SCFRSFZFM": "Téléverser la photo verso de la carte d'identité du responsable légal",
    "FMSLT": "Exemple de verso",
    "QQBSFZSJWZ_WZQXKBB": "Veuillez garantir que les quatre coins de la carte d'identité sont complets et que le texte est lisible",
    "SCYYZZ": "Téléverser le certificat d'entreprise",
    "ShengHeZhong": "En cours d'examen",
    "TiJiaoShenHe": "Envoyer pour examen",
    "GSMC": "Nom de l'entreprise",
    "DDDKFQRBJQSH": "La commande attend la confirmation du prix par le service client, veuillez patienter",
    "XDTX": "Notification de commande",
    "NH_GDDBH": "Certains produits ont un prix en attente de vérification, le paiement n'est autorisé qu'après vérification",
    "QRXD": "Confirmer la commande",
    "DaiHeJia": "Prix en attente de vérification",
    "ZHJY": "Solde du compte",
    "YGTG": "Promotion par employé",
    "YuanGong": "Employé",
    "DuiZhanGJieSuan": "Règlement et conciliation",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "Solde du compte = Solde de pré-dépôt + Solde de remboursement + Remboursement en attente - Montant dû de commande",
    "YCKYE": "Solde de pré-dépôt",
    "FKYE": "Solde de remboursement",
    "DDYFK": "Montant dû de commande",
    "THDTK": "Remboursement en attente",
    "YuCunKuanZuoFei": "Annulation de pré-dépôt",
    "FanKuanZhangHuMingXi": "Détails du compte de remboursement",
    "TKCZDFKZH": "Recharge du remboursement sur le compte de remboursement",
    "RMBJE": "Montant en RMB"
};
exports.default = fr_FR;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// id_ID.js
var id_ID = {
    "GuanShui": "‌Bea Cukai",
    "ZiZhangHao": "Subakun",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",
    //components
    "ShangeChuanYanZhengTuPian": "Unggah Gambar Verifikasi",
    "ChuanHaoYanZheng": "Verifikasi Nomor Seri",
    "YanZhengChuanHao": "Verifikasi Nomor Seri",
    "Ci": "kali",
    "DingDanMan": "Pesanan Lengkap",
    "YuanZeng": "Rp Bonus",
    "SCFJ_ZD4Z_DZBCG": "Unggah lampiran, maks 4 gambar, masing-masing ≤3MB",
    //ChatRoom
    "ZBZCBQFH": "Emoji tidak didukung",
    "FaSongLianJie": "Kirim Tautan",
    "YiChangXiaoXi": "Pesan tidak normal",
    "QingShuRu": "Silakan masukkan",
    "FaSong": "Kirim",
    //DateSelector
    "DQSJXYKSSJ": "Waktu sekarang sebelum waktu mulai",
    "DQSJCGJSSJ": "Waktu sekarang melebihi waktu akhir",
    "QuXiao": "Batal",
    "NianYueRi": "Tahun-Bulan-Tanggal",
    "ShiFen": "Jam-Menit",
    "QueDing": "Konfirmasi",
    "Nian": "Tahun",
    "Yue": "Bulan",
    "Ri": "Tanggal",
    "Shi": "Jam",
    "Fen": "Menit",
    //goods-list-card
    "Qi": "Mulai dari",
    //goods-promotion
    "1GeCuXiao": "{num} Promo",
    "ChaKanZengPin": "Lihat Hadiah",
    "JHDJSHS_1T": "Waktu tersisa: {d}hari {h}jam {m}menit {s}detik",
    "YHGZ_ZPBKD": "Ketentuan: Hadiah tidak bisa digabung",
    "YHGZ_AZZGM": "Ketentuan: Diskon kuantitas",
    "GuanBi": "Tutup",
    "Man1Song1": "Beli {mai} Dapat {song}",
    //group-filtrate
    "QuanBu": "Semua",
    "ZWXGSJ": "Tidak ada data terkait",
    "ZuiDiJia": "Harga Terendah",
    "ZuiGaoJia": "Harga Tertinggi",
    "LeiXing": "Tipe",
    "PinPai": "Merek",
    "BiaoQian": "Label",
    "JiaGeQuJian": "Rentang Harga",
    "SPMC_GG_BH_": "Nama Produk / Spesifikasi / Kode / Inisial",
    "SPMC_GG_BH_G": "Nama Produk / Spesifikasi / Kode",
    "ZuHeShaiXuan": "Filter Kombinasi",
    "ChongZhi_CanShu": "Reset",
    //image-upload
    "ZDKSC1ZTP": "Maks 1 gambar",
    "ZYXSCTP": "Hanya gambar",
    "SCTPDXBYXC": "Ukuran gambar ≤5MB",
    "QBYCFSCTP_": "Tidak boleh unggah duplikat",
    "ShangChuanChengGong": "Unggah berhasil",
    "ZDKSC1Z": "Maks 1",
    //keyboard
    "CCSLZDXZ": "Melebihi batas",
    "QiDingLiang": "Minimal pesan",
    "ShouQi": "Sembunyikan",
    "ShanChu": "Hapus",
    //MultiPicker
    "FanHui": "Kembali",
    //order-cart
    "Dai": "Agen",
    "YiQuXiao": "Dibatalkan",
    "ZengPin": "Hadiah",
    "1Zhong": "{num} jenis",
    "1Jian": "{num} buah",
    "HeJi": "Total",
    "DaiFu": "Belum dibayar",
    //order-promotion
    "_DDM1YZ1J_": "[Beli {target} Dapat {name}x{number}]",
    "_DDM1YLJ1Y_": "[Beli {m} Diskon {n}]",
    "_DDM1YLX1Z_": "[Beli {m} Diskon {n}%]",
    "DingDanCuXiao": "Promo Pesanan",
    //page-ad
    "DLCKJG": "Login untuk lihat harga",
    //page-floating
    "DianPuZhuYe": "Beranda Toko",
    "GouWuChe": "Keranjang",
    "ZaiXianKeFu": "Layanan Pelanggan",
    "GeRenZhongXin": "Profil Saya",
    "LianXiDianHua": "Hubungi",
    "FanHuiDingBu": "Kembali ke Atas",
    //page-null
    "ZBDYML": "Halaman tidak ditemukan",
    "KNWZCW_HZY": "URL salah atau halaman dihapus",
    "FanHuiShangJi": "Kembali",
    "FanHuiShouYe": "Kembali ke Beranda",
    //product-edit
    "SPQDBNWK": "Daftar produk kosong",
    "WoZhiDaoLe": "Mengerti",
    "SFQRSCSP": "Konfirmasi hapus produk?",
    "QueRen": "Konfirmasi",
    "ZYXSRSZBQB": "Hanya angka, maks 2 desimal",
    "ShangPinDanJia": "Harga satuan produk",
    "YSPYJ": "Harga asli",
    "QSRZDJG": "Masukkan harga yang valid",
    "ShuLiang": "Kuantitas",
    "DanWei": "Satuan",
    "DanJia": "Harga",
    "BeiZhu": "Catatan",
    "YiChuShangPin": "Hapus produk",
    "XiuGai": "Edit",
    //yunshl
    "TPSLCCYXSZ": "Jumlah gambar melebihi batas!",
    "WJBDDY5M_QC": "File ≤5MB, silakan pilih ulang",
    "TPSCWC": "Gambar berhasil diunggah",
    //BusinessFilter
    "_DGSLM1Z1_": "[Pesan {target} Dapat {provide}]",
    "_M1JLXMJ1Y_": "[Beli {target} Diskon {cut_money_}/unit]",
    "_DHJJZ1Y_": "[Harga turun jadi {cuted_price_}]",
    "_M1JLXMJ1Z_": "[Beli {target} Diskon {cut_percent_}%/unit]",
    "_YDHJD1Z_": "[Harga asli diskon {cuted_percent_}%]",
    "YuJiKaiShiFaHuo": "Perkiraan pengiriman: {date}",
    "YuJi": "Perkiraan",
    "MMYDDR": "BB/HH",
    "KaiShiFaHuo": "Mulai kirim",
    "_M1LXM1Y_": "[Beli 1 Diskon 1/unit]",
    "_M1LXM1Z_": "[Beli 1 Diskon 1%/unit]",
    "DaiQueRen": "Menunggu konfirmasi",
    "DaiFaHuo": "Menunggu pengiriman",
    "DaiShouHuo": "Menunggu diterima",
    "YiWanCheng": "Selesai",
    "DaiFuKuan": "Belum dibayar",
    "YiFuKuan": "Sudah dibayar",
    "YiZuoFei": "Dibatalkan",
    "DaiShenHe": "Menunggu verifikasi",
    "DaiHeXiao": "Belum digunakan",
    "YiHeXiao": "Sudah digunakan",
    "XianXiaZhiFu": "Pembayaran offline",
    "ZhiNengDaoZhangShiBie": "Transfer (verifikasi otomatis)",
    "WeiXinZhiFu": "WeChat Pay",
    "KQ-WeiXinZhiFu": "99Bill (WeChat)",
    "KQ-ZFBZF": "99Bill (Alipay)",
    "KQZhiFu": "99Bill Pay",
    "ZFBZF": "Alipay",
    "YuEZhiFu": "Bayar dengan saldo",
    "HuoDaoFuKuan": "Bayar saat terima",
    "DaiTuiHuo": "Menunggu retur",
    "DaiTuiKuan": "Menunggu refund",
    "ChuangJianDingDan": "Buat pesanan",
    "BianJiDingDan": "Edit pesanan",
    "TiJiaoDingDan": "Kirim pesanan",
    "DingDanShenHe": "Verifikasi pesanan",
    "CaiWuShenHe": "Verifikasi keuangan",
    "BoHui": "Tolak",
    "TianJiaShouKuan": "Tambahkan pembayaran",
    "ZaiXianZhiFu": "Bayar online",
    "ShouKuanShenHe": "Verifikasi pembayaran",
    "ShouKuanZuoFei": "Batalkan pembayaran",
    "ChuKu": "Keluar gudang",
    "ChuKuShenHe": "Verifikasi keluar gudang",
    "FaHuo": "Kirim barang",
    "TianJiaWuLiu": "Tambahkan logistik",
    "XiuGaiWuLiu": "Edit logistik",
    "ChuKuZuoFei": "Batalkan keluar gudang",
    "ShouHuo": "Diterima",
    "DingDanHeZhun": "Setujui pesanan",
    "QuXiaoDingDan": "Batalkan pesanan",
    "CJTHD": "Buat retur",
    "DaYin": "Cetak",
    "DaoChu": "Ekspor",
    "DingDanWanCheng": "Pesanan selesai",
    "QiangZhiWanCheng": "Selesaikan paksa",
    "DingDanZuoFei": "Batalkan pesanan",
    "MaiZeng": "Beli dapat hadiah",
    "ZhiJiang": "Potongan langsung",
    "DaZhe": "Diskon",
    "YuShou": "Pre-order",
    "DingDanManZeng": "Hadiah min. belanja",
    "DingDanManJian": "Potongan min. belanja",
    "DingDanManZhe": "Diskon% min. belanja",
    "XinRenQuan": "Kupon anggota baru",
    "ManJianQuan": "Kupon diskon",
    "ShangPinQuan": "Kupon produk",
    "DaiJieSuan": "Belum diselesaikan",
    "YiJieSuan": "Sudah diselesaikan",
    "QuanBuShangPin": "Semua produk",
    "TuiJianShangPin": "Produk rekomendasi",
    "XinPin": "Baru",
    "ReXiaoShangPin": "Populer",
    "ChangYongShangPin": "Sering dibeli",
    //BusinessUtil
    "DaiShouKuan": "Belum dibayar",
    "BuFenShouKuan": "Sebagian dibayar",
    "YiShouKuan": "Lunas",
    "BXYFP": "Tidak perlu faktur",
    "ZZSPTFP": "Faktur PPN biasa",
    "ZZSZYFP": "Faktur PPN khusus",
    "QiTaFaPiao": "Faktur lain",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Uang muka",
    "XianXiaZhuangZhang": "Transfer",
    "XianShangZhiFu": "Bayar online (WeChat/Alipay/JD/UnionPay)",
    "YCKZF": "Bayar dengan saldo",
    "DaiTiJiao": "Belum dikirim",
    "KuaiDi": "Ekspres",
    "SongHuoShangMen": "Pengiriman ke rumah",
    "ShangMenZiQu": "Ambil sendiri",
    "WuLiuHuoYun": "Pengiriman barang",
    "QiTa": "Lainnya",
    //check-util
    "QSRBXY6WDM": "Password ≥6 karakter",
    "QSRBDY20WDM": "Password ≤20 karakter",
    "MMGSCW": "Format password salah",
    //common-utils
    "SJCW_QLXKF": "Kesalahan data, hubungi dukungan",
    "ZBZCQD": "Pendaftaran tidak didukung",
    "HuJiao": "Telepon",
    "DLZHBCZ": "Akun tidak ada",
    "QLXGLYKT": "Hubungi admin untuk aktivasi",
    "GQYZHBJY": "Akun perusahaan dinonaktifkan",
    "QLXYSDH": "Hubungi YUNSHANG",
    "GQYZHSYQJS": "Masa percobaan habis",
    "GQYZHYGQL": "Akun kedaluwarsa",
    "XYXFCNSY": "Perlu perpanjangan",
    "GQYBCZCZH": "Akun perusahaan tidak valid",
    "NDDHZHYBQY": "Akun Anda dinonaktifkan oleh perusahaan",
    "NYBSQY1DHZ": "Bukan mitra lagi",
    "NDDPYBTY_B": "Toko ditangguhkan",
    "GZHWKTDSZB": "Modul tidak diaktifkan",
    "WXSQYZYGQ": "Verifikasi WeChat kedaluwarsa",
    "WXSQSB": "Verifikasi WeChat gagal",
    "WXSQSB_CWX": "Verifikasi WeChat gagal: {msg}",
    "DengLuGuoQi": "Login kedaluwarsa",
    "DLGQ_QCXDL": "Sesi habis, silakan login ulang",
    //data-constant
    "ShangJia": "Dijual",
    "YiXiaJia": "Tidak dijual",
    "YiJinYong": "Dinonaktifkan",
    "YiQiYong": "Diaktifkan",
    "YiTingYong": "Ditangguhkan",
    "KeHuZhuCe": "Pelanggan terdaftar",
    "XinZengDaoRu": "Impor",
    "DDDSH": "Menunggu verifikasi pesanan",
    "DCWSH": "Menunggu verifikasi keuangan",
    "DaiChuKu": "Menunggu keluar gudang",
    "DCK_BF_": "Menunggu keluar gudang (sebagian)",
    "DFH_BF_": "Menunggu pengiriman (sebagian)",
    "DSH_BF_": "Menunggu diterima (sebagian)",
    "DSK_BF_": "Belum dibayar (sebagian)",
    "WTHSQ": "Tidak ada permintaan retur",
    "THDSH": "Menunggu verifikasi retur",
    "THCLZ": "Sedang diproses",
    "THYWC": "Retur selesai",
    "DYDHD": "Cetak pesanan",
    "DYFHD": "Cetak faktur",
    "DCDHD": "Ekspor pesanan",
    "DCFHDWE_P": "Ekspor ke Excel/PDF",
    "TuiDanZuoFei": "Batalkan retur",
    "DTHSH": "Menunggu verifikasi retur",
    "DaiRuKu": "Menunggu masuk gudang",
    "DRK_BF_": "Menunggu masuk gudang (sebagian)",
    "DFK_BF_": "Belum dibayar (sebagian)",
    "ChuangJianTuiDan": "Buat retur",
    "BianJiTuiDan": "Edit retur",
    "TiJiaoTuiDan": "Kirim retur",
    "TuiHuoShenHe": "Verifikasi retur",
    "RuKu": "Masuk gudang",
    "RuKuShenHe": "Verifikasi masuk gudang",
    "RuKuZuoFei": "Batalkan masuk gudang",
    "TianJiaFuKuan": "Tambahkan pembayaran",
    "FuKuanZuoFei": "Batalkan pembayaran",
    "FuKuanShenHe": "Verifikasi pembayaran",
    "TuiDanWanCheng": "Retur selesai",
    "QiTaChuKu": "Keluar gudang lainnya",
    "XiaoShouChuKu": "Keluar gudang penjualan",
    "PanKuiChuKu": "Keluar gudang rugi",
    "DiaoBoChuKu": "Keluar gudang transfer",
    "CaiGouTuiHuo": "Retur pembelian",
    "TuiHuoRuKu": "Masuk gudang retur",
    "CaiGouRuKu": "Masuk gudang pembelian",
    "QiTaRuKu": "Masuk gudang lainnya",
    "PanYingRuKu": "Masuk gudang untung",
    "DiaoBoRuKu": "Masuk gudang transfer",
    "CJCGD": "Buat PO",
    "BJCGD": "Edit PO",
    "TJCGD": "Kirim PO",
    "CGDZF": "Batalkan PO",
    "CGDWC": "PO selesai",
    "CGTHZF": "Batalkan retur pembelian",
    "CGTHWC": "Retur pembelian selesai",
    "THDDY": "Cetak retur",
    "THDDC": "Ekspor retur",
    "CKDDY": "Cetak keluar gudang",
    "CKDDC": "Ekspor keluar gudang",
    "GLDZH": "Akun admin",
    "DHDZH": "Akun pesanan",
    "ShenHeTongGuo": "Lulus verifikasi",
    "SHBTG": "Gagal verifikasi",
    "WuXuFaPiao": "Tidak perlu faktur",
    "DaiKeXiaDan": "Dipesan oleh agen",
    "ZiZhuXiaDan": "Pesan sendiri",
    "PCShangCheng": "Toko PC",
    "APPShangCheng": "Toko App",
    "TVShangCheng": "Toko TV",
    "WeiXinShangCheng": "Toko WeChat",
    "ShouJiShangCheng": "Toko mobile",
    "ADDXSMLTC": "Komisi keuntungan",
    "ADDXSSRTC": "Komisi pendapatan",
    "AKHSSYG": "Berdasarkan agen penjualan",
    "AnZhiDanRen": "Berdasarkan pembuat",
    "ATHJEBLKCT": "Potong komisi berdasarkan nilai retur",
    "DDYTHBJXTC": "Tidak ada komisi untuk pesanan retur",
    "DaiDaKuan": "Belum dibayar",
    "WeiKaiShi": "Belum mulai",
    "JinXingZhong": "Sedang berjalan",
    "YiGuoQi": "Kedaluwarsa",
    //Utils.js
    "YouHuo": "Stok ada",
    "WuHuo": "Stok habis",
    "Yi": "Miliar",
    "QianWan": "10 juta",
    "BaiWan": "Juta",
    "Wan": "10 ribu",
    "Sheng1Tian": "Tersisa 1 hari",
    "Sheng1XiaoShi": "Tersisa 1 jam",
    "Miao": "Detik",
    "1Miao": "1 detik",
    "GangGang": "Baru saja",
    "1FenZhongQian": "1 menit lalu",
    "1XiaoShiQian": "1 jam lalu",
    "1TianQian": "1 hari lalu",
    "1GeYueQian": "1 bulan lalu",
    "1NianQian": "1 tahun lalu",
    "WeiZhiLeiXing": "Tipe tidak diketahui",
    //WechatUtil
    "YYGBCDSP_K": "Lihat produk ini!",
    "ZanWeiSheZhi": "Belum diatur",
    //app
    "HQWXSQXX": "Dapatkan info verifikasi WeChat",
    //flexible
    "JGJYYDMBQ": "Skala berdasarkan tag meta",
    //index
    "NLJZZ": "Memuat...",
    "": "routes",
    "ShangPinMingXi": "Detail Produk",
    "ShangPinLeiBie": "Kategori",
    "QXZFPNR": "Pilih konten faktur",
    "QXZFPLX": "Pilih jenis faktur",
    "QTXFPTT": "Masukkan judul faktur",
    "FaPiaoTaiTou": "Judul Faktur",
    "NSRSBH": "NPWP",
    "FaPiaoNeiRong": "Konten Faktur",
    "FaPiaoXinXi": "Info Faktur",
    "KaiJuFaPiao": "Buat Faktur",
    "FaPiaoLeiXing": "Jenis Faktur",
    "Han": "Termasuk",
    "WeiHan": "Tidak termasuk",
    "Shui": "Pajak",
    "QSRFPTT": "Masukkan judul faktur",
    "QSRNSRSBH": "Masukkan NPWP",
    //routes
    //cart-bill
    "YiManZu_Man": "Penuhi [Min",
    "ZaiGou": "Beli lagi",
    "YMZ_DHJJZ": "Penuhi [Harga pesanan turun jadi",
    "JianJiangZhi": "Turun jadi",
    "YMZ_YDHJD": "Penuhi [Harga asli diskon",
    "JianMeiJian": "Per item",
    "SYTCSLW0_WFJRGWC": "Stok paket habis, tidak bisa tambah ke keranjang",
    "QingXuanXeShangPin": "Pilih produk!",
    "GSPYXJ": "Produk ini tidak dijual lagi!",
    "ZJ2TN": "{day} hari lalu",
    "QDQCXJSP": "Konfirmasi hapus produk tidak dijual?",
    "QingChuChengGong": "Berhasil dihapus",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Produk paket tidak bisa ditambah ke keranjang!",
    "SPSLBN": "Kuantitas produk tidak bisa",
    "TaoCanHan": "Paket termasuk",
    "TaoCan": "Paket",
    "QHDSL": "Konfirmasi kuantitas",
    "SPSLBNDY": "Kuantitas produk tidak kurang dari",
    "XianDingLiang": "Batas pesanan",
    "YiRuShouCang": "Sudah disimpan",
    "QuanXuan": "Pilih semua",
    "JianZeng": "Hadiah",
    "JianLiXiang_Man": "item dengan min. beli",
    "Yuan_": "Rp]",
    "Zhe_": "% diskon]",
    "KCBZ_WFJRGWC": "Stok tidak cukup, tidak bisa tambah",
    "XDJEDYDY": "Nilai pesanan ≥",
    "WYXJHYSXDSP": "Tidak ada produk tidak dijual!",
    "DYQDL": "Di bawah jumlah minimal",
    "ZSPG1J": "{count} jenis produk",
    "WanCheng": "Selesai",
    "BianJi": "Edit",
    "You": "Ada",
    "ZSPBFHYQ_W": "{count} produk tidak memenuhi syarat",
    "SPSLBNGY": "Kuantitas produk tidak melebihi",
    "JXDJ_CKXYGBFHYQSP": "Geser untuk lihat produk selanjutnya",
    "XiaDan": "Pesan",
    "JianJiang": "Turun",
    "QRYCSP": "Konfirmasi hapus produk?",
    "QXZXDSP": "Pilih produk untuk dipesan",
    "KCBZ_QCXXZ": "Stok tidak cukup, silakan pilih ulang!",
    "KuCun": "Stok",
    "YCKXD": "Perlu bayar {price}",
    "QDSCSP": "Konfirmasi simpan produk?",
    "ShouCangChengGong": "Berhasil disimpan",
    "GYXDL": "Melebihi batas pesanan",
    "LiSheng": "Hemat",
    "GWCHSKD_QGYGB": "Keranjang kosong, ayo belanja",
    "QuGuangGuang": "Jelajahi",
    "QCXJSP": "Hapus produk tidak dijual",
    "ZongE": "Total",
    "YouHui": "Diskon",
    //cart-list
    "QXZJHRQ": "Pilih waktu pengiriman",
    "FuJiaFeiYong": "Biaya tambahan",
    "ZhongShangPin_Gong": "{count} jenis produk, total",
    "PeiSongShiJian": "Waktu pengiriman",
    "QXZPSSJ": "Pilih waktu pengiriman",
    "DingDanJinE": "Jumlah Pesanan",
    "SCFJ_ZD4Z": "Unggah lampiran, maks 4 gambar, masing-masing ≤3MB",
    "KeYongShangPin": "Produk Tersedia",
    "ShiYongShuoMing": "Instruksi Penggunaan",
    "YouXiaoQi": "Tanggal Kedaluwarsa",
    "Man": "Minimal",
    "BZZBZCTSFH": "Catatan tidak mendukung karakter khusus",
    "QingXuanZe": "Silakan pilih",
    "KaiPiaoXuJia": "Biaya Faktur",
    "GeDian": "Poin",
    "KPXJ1GD": "Biaya faktur {num} poin",
    "PeiSongFangShi": "Metode Pengiriman",
    "ShangPinZongJia": "Total Harga Produk",
    "YouHuiQuan": "Kupon",
    "ZhangKeXan": "Dapat dipilih",
    "DDJEWMZ": "Jumlah pesanan tidak mencapai",
    "WDYHQ": "Kupon Saya",
    "KYYHQ": "Kupon yang Dapat Digunakan",
    "YuanKeYong": "Rp yang dapat digunakan",
    "ChaKanDingDan": "Lihat Pesanan",
    "ShangPinHanShui": "Produk termasuk pajak",
    "SPWHS": "Produk tidak termasuk pajak",
    "QueRenDingDan": "Konfirmasi Pesanan",
    "XZSHDZ": "Tambahkan Alamat Baru",
    "ShangPinQingDan": "Daftar Produk",
    "WKYYHQ": "Tidak ada kupon yang dapat digunakan",
    "HuChi": "Eksklusif",
    "DaiJinQuan": "Kupon",
    "YunFei": "Biaya Pengiriman",
    "ShuiFei": "Pajak",
    "BKYYY": "Alasan tidak dapat digunakan",
    "YHQYGQ": "Kupon kedaluwarsa",
    "WDYHQSYSJ": "Belum mencapai waktu penggunaan",
    "ZDSPJEWMZ": "Nilai produk tidak mencapai",
    "BKYYHQ": "Kupon tidak dapat digunakan",
    "YMZ_MYZJ_": "Penuhi [Min Rp{m} Dapat {n} item]",
    "YMZ_MZ": "Penuhi [Min Rp{m} Dapat {n}]",
    "ZG222YX_M1000": "Beli tambahan Rp{money} Dapat [Min Rp{target} Dapat {num} item]",
    "ZG2JX_MZ": "Beli tambahan {num} item Dapat [Min Rp{target} Dapat {present}]",
    "YMZ_MYJY_": "Penuhi [Min Rp{m} Hemat Rp{n}]",
    "ZGYX_MYJY_": "Beli tambahan Rp{m} Dapat [Min Rp{n} Hemat Rp{o}]",
    "YMZ_MYZ_": "Penuhi [Min Rp{m} Diskon {n}%]",
    "ZGYX_MYZ_": "Beli tambahan Rp{m} Dapat [Min Rp{n} Diskon {o}%]",
    //cart-presale-order
    "QXZPSFS": "Silakan pilih metode pengiriman",
    "1ZSP_G": "1 jenis produk, total",
    "YSSP_YJ": "Pre-order, perkiraan",
    "JiaoHuoRiQi": "Tanggal Pengiriman",
    "GMJLY": "Catatan Pesanan",
    //scan-to-cart
    "ZhengZaiChuLi...": "Sedang memproses...",
    "FSCSP": "Bukan produk toko",
    "ZZCLTXM": "Sedang memproses barcode...",
    "SPTJCG": "Produk berhasil ditambahkan",
    "QSTXM": "Silakan pindai barcode",
    "SFSCDQSP": "Hapus produk saat ini?",
    "BQ_ZBDXGSP": "Maaf, produk tidak ditemukan",
    "XuanZeDanWei": "Pilih satuan",
    "JRGWC": "Tambahkan ke keranjang",
    "QXXZDJRSP": "Silakan pilih produk terlebih dahulu",
    "ZhengZaiChuLi": "Sedang memproses",
    "JRGWCCG": "Berhasil ditambahkan ke keranjang",
    "ZanWuShangPin": "Tidak ada produk",
    //earn-brokerage-share
    "XTYJBNFZSP": "Sistem telah menyalin tautan produk!",
    "NKYHDDYDYJ": "Anda mendapat komisi, lihat di \"Saya",
    "LiChaKan": "\"",
    "WeiXinHaoYou": "Teman WeChat",
    "ErWeiMa": "Kode QR",
    "CASBEWM": "Pindai Kode QR",
    "FZSB_QCXFZ": "Salin gagal, coba lagi!",
    "TWEWM": "Kode QR Teks+Gambar",
    "BCDXC": "Simpan ke album",
    "CATPBCDXC": "Tahan untuk menyimpan",
    "FuZhiLianJie": "Salin Tautan",
    "FXZYJ": "Bagikan untuk dapat komisi",
    "YJZGKZQYJ": "Perkiraan komisi maksimum",
    "PYTGNFXDYMCGGMH": "Saat teman membeli melalui tautan Anda, Anda dapat komisi",
    //goods-share
    "FXSPGLSKH": "Bagikan produk ke pelanggan",
    "FXHJSCNZSD": "Bagikan untuk buka toko mobile pribadi",
    "WSCDQJG_ND": "Harga toko mobile: Harga Anda ×",
    "DaiSheZhi": "Belum diatur",
    "PengYouQuan": "Momen",
    "GGFXSZ": "Pengaturan Berbagi",
    //wechat-login
    "QXSRZH": "Silakan masukkan akun",
    "MMGSCW_6_20W": "Format kata sandi salah (6-20 karakter)",
    "BDYYZH": "Ikat akun yang ada",
    "WXKJDL": "Login cepat WeChat",
    "BangDingZhangHao": "Ikat Akun",
    "YYZH_QDL": "Sudah punya akun? Login",
    "ZCXZH": "Daftar akun baru",
    "HuanYingNi": "Selamat datang",
    "ZH_SJHM": "Akun/Nomor Telepon",
    "MiMa": "Kata Sandi",
    "QDLHCZ": "Silakan login untuk melanjutkan",
    //add-to-cart
    "KCBZ_BNTJG": "Stok tidak cukup, tidak dapat ditambahkan",
    //combined-pay-online
    "ZhiFuChengGong": "Pembayaran berhasil!",
    "ZFSB_QCXCS": "Pembayaran gagal, silakan coba lagi!",
    "QXXZGG": "Silakan pilih spesifikasi terlebih dahulu",
    "SXGGX": "Harus pilih spesifikasi",
    "GMSLXYQDL_": "Kuantitas di bawah minimal, silakan beli lagi!",
    "GMSLDYXDL_": "Kuantitas melebihi batas, silakan beli lagi!",
    "ShangPinBianHao": "Kode Produk",
    "QiDing": "Minimal",
    "SXGGDGSLBK": "Kuantitas tidak melebihi",
    "KCBZ_BNTJ": "Stok tidak cukup, tidak dapat ditambahkan",
    "QXXZSP": "Silakan pilih produk terlebih dahulu",
    "SLBNW0": "Kuantitas tidak boleh 0",
    "QXZGG": "Silakan pilih spesifikasi",
    "LiJiYuDing": "Pre-order segera",
    //nav
    "ShouYe": "Beranda",
    "ShangPin": "Produk",
    "DingDan": "Pesanan",
    "WoDe": "Saya",
    //pay-online
    "ZhiFuQuXiao": "Pembayaran dibatalkan",
    //account-log
    "ShangPinYongJin": "Komisi Produk",
    "YaoQingJiangLi": "Hadiah Undangan",
    "TiXian": "Penarikan",
    "TiXianBoHui": "Penarikan ditolak",
    "ZhuanWeiYuE": "Transfer ke Saldo",
    "Jin7Tian": "7 hari terakhir",
    "Jin30Tian": "30 hari terakhir",
    "ShouZhiMingXi": "Detail Pendapatan & Pengeluaran",
    "ZanWuShuJu": "Tidak ada data",
    //client-statistics
    "WoDeKeHu": "Pelanggan Saya",
    "WoDeYaoQing": "Undangan Saya",
    //distribution-home
    "LeiJiKeHu": "Total Pelanggan",
    "LeiJiDingDan": "Total Pesanan",
    "YaoQingHaoYou": "Undang Teman",
    "LeiJiYaoQing": "Total Undangan",
    "LJSY_Y_": "Total Pendapatan (Rp)",
    "BHDJS": "Belum diselesaikan",
    "J7TSY_Y_": "Pendapatan 7 hari (Rp)",
    "J7TXZKH_R_": "Pelanggan baru 7 hari (orang)",
    "KTXYJ": "Komisi yang dapat ditarik",
    "XYJYO": "Perlu usaha lagi",
    "ChangJianWenTi": "Pertanyaan Umum",
    "Q_ZMYJX_TG": "T: Bagaimana cara \"Promosi Dapat Komisi\"?",
    "A_FXDPND_Z_": "J: Bagikan tautan dengan ikon \"Dapat\"",
    "Q_RHJS_TGZ": "T: Bagaimana komisi dihitung?",
    "A_MGD_Z_TBD": "J: Setiap produk memiliki rasio komisi",
    "Q_TGZQ_DSY": "T: Kapan komisi diterima?",
    "A_HYTGNDFX": "J: Setelah pelanggan konfirmasi penerimaan",
    "Q_LJKH_LJY": "T: Mengapa tidak ada avatar?",
    "A_WXYQZYGZ": "J: Harus ikuti akun layanan",
    "Q_WSMWASSG": "T: Mengapa tidak ada komisi?",
    "XiaoShouZhongXin": "Pusat Penjualan",
    //generalize-goods
    "SPMC_GG_BH": "Nama Produk / Spesifikasi / Kode",
    "YuJiZhuan": "Perkiraan Komisi",
    //invitation-home
    "YaoQingKa": "Kartu Undangan",
    "YNYQJR_TGY": "Undang bergabung, promosi dapat hadiah",
    "DJBCDXC": "Klik untuk simpan ke album",
    "JYQKFSGHY_": "Bagikan kartu ke teman",
    //join-home
    "HuanYingJiaRu": "Selamat datang bergabung",
    "YQNCW": "Undang Anda menjadi",
    "LiJiJiaRu": "Bergabung Sekarang",
    //order-statistics
    "YuJiYongJin": "Perkiraan Komisi",
    "YongJin": "Komisi",
    "YuJiJiangLi": "Perkiraan Hadiah",
    "JiangLi": "Hadiah",
    "SPTGDD": "Pesanan Promosi Produk",
    "YQJLDD": "Pesanan Hadiah Undangan",
    //performance-statistics
    "YeJiTongJi": "Statistik Kinerja",
    "LJKH_R_": "Total Pelanggan (orang)",
    "SPYJ_Y_": "Komisi Produk (Rp)",
    "HanDaiJieSuan": "Termasuk belum diselesaikan",
    "XGMCJS": "Definisi",
    "KeHu": "Pelanggan",
    "HFXYBDLKHG": "Pelanggan terkait",
    "YaoQing": "Undangan",
    "FXYCGYQDXJ": "Perwakilan undangan berhasil",
    "FXYTJKHGMH": "Komisi dari pelanggan undangan",
    "XJFXYTGSPH": "Hadiah dari perwakilan undangan",
    //posters-promoting
    "NiCheng": "Nama Panggilan",
    "HaiBaoTuiGuang": "Promosi Poster",
    "JHBFSGHY_T": "Bagikan poster ke teman",
    //settlement-home
    "JieSuanZhongXin": "Pusat Penyelesaian",
    "KTXJE": "Jumlah yang dapat ditarik",
    "TiXianJiLu": "Riwayat Penarikan",
    //withdraw-account
    "KHRXMBNWK": "Nama pemegang akun harus diisi!",
    "KHHBNWK": "Bank harus diisi!",
    "YHKHBNWK": "Nomor rekening harus diisi!",
    "SFZTPBNWK": "Harus unggah foto KTP!",
    "YHKTPBNWK": "Harus unggah foto kartu bank!",
    "BaoCunChengGong": "Berhasil disimpan!",
    "SCSFZ": "Unggah KTP",
    "SCYHK": "Unggah Kartu Bank",
    "BaoCun": "Simpan",
    "TiXianZhangHu": "Akun Penarikan",
    "TS_QTXZSXX": "Silakan berikan informasi asli",
    "KHRXM": "Nama Pemegang Akun",
    "KaiHuHang": "Bank",
    "YinhangKaHao": "Nomor Rekening",
    "QSRZSXM": "Silakan masukkan nama asli",
    "QSRKHHMC": "Silakan masukkan nama bank",
    "QSRYHKH": "Silakan masukkan nomor rekening",
    //withdraw-deposit
    "QXSZTXZH": "Silakan atur akun penarikan terlebih dahulu",
    "QuSheZhi": "Pengaturan",
    "JEXY10Y_BKT": "Jumlah di bawah Rp10 tidak dapat ditarik!",
    "JECGKTXJE": "Jumlah melebihi batas penarikan!",
    "CGDRKTXSX_": "Melebihi batas harian (Rp20.000)!",
    "QueDingJiang": "Konfirmasi Transfer",
    "ZhuanDaoYuE": "Ke saldo?",
    "_JEDY10YSB": "1. Jumlah di bawah Rp10 tidak dapat ditarik",
    "_BCTXDZSJ": "2. Waktu penerimaan: 5 hari kerja",
    "_GBSRWHSS": "3. Pendapatan ini termasuk pajak",
    "_ZDYEKYYS": "4. Saldo dapat digunakan untuk belanja",
    "TXSQCG_QDD": "Permintaan penarikan berhasil, tunggu verifikasi",
    "JEDYKTXJE_": "Jumlah melebihi saldo, tidak dapat transfer!",
    "ZZYECG_QDG": "Transfer ke saldo berhasil, lihat di profil",
    "BenCiTiXian": "Penarikan ini",
    "ZhuangDaoYuE": "Transfer ke Saldo",
    "TiXianDao": "Tarik ke",
    "JEW0BKZZYE": "Jumlah 0 tidak dapat ditransfer",
    "DRTXSX2WY": "Batas harian Rp20.000",
    "QuanBuTiXian": "Tarik semua",
    "QueRenTiXian": "Konfirmasi Penarikan",
    //goods-filter-tab
    "ZuiChangGouMai": "Sering Dibeli",
    "MoRenPaiXu": "Urutan default",
    "ZongHe": "Umum",
    "FenLei": "Kategori",
    "XiaoLiangYouXian": "Penjualan teratas",
    "XiaoLiang": "Penjualan",
    "JiaGe": "Harga",
    "ShaiXuan": "Filter",
    "ZuiJinGouMai": "Baru Dibeli",
    "CuXiaoYouXian": "Promosi teratas",
    "QuanBuFenLei": "Semua Kategori",
    "ZhiKanCuXiao": "Hanya promosi",
    "XuanZeFenLei": "Pilih Kategori",
    "QXZFL": "Silakan pilih kategori",
    //goods-list-default
    "ZWXGSP": "Tidak ada produk terkait",
    //goods-brand-list
    "PinPaiHui": "Merek",
    //goods-classify-filter
    "TuiJianFenLei": "Kategori Rekomendasi",
    "ShangPinFenLei": "Kategori Produk",
    "GengDuo": "Lebih banyak",
    //goods-detail
    "DLZHBSDQQY": "Akun bukan pelanggan perusahaan saat ini",
    "GXNHQ": "Selamat, Anda mendapat",
    "SZWSCJGH_C": "Atur harga sebelum berbagi",
    "JHDJSHS_": "Waktu tersisa:",
    "DLHKFX": "Login untuk berbagi",
    "ZZHQXX_QSH": "Sedang mengambil data",
    "Zhang": "lembar",
    "Tian": "hari",
    "QXZGGZQPD": "Silakan pilih spesifikasi terlebih dahulu",
    "Yuan": "Rp",
    "XS_F_M": "jam/mnt/dtk",
    //integral
    "WoDeJiFen": "Poin Saya",
    "DaBaiLe": "Lebih baik",
    "JiFen": "Poin",
    "DeHuiYuan": "Anggota",
    "ZhuanJiFen": "Dapatkan Poin",
    "JiFenMingXi": "Detail Poin",
    "HuanLiPin": "Tukar Hadiah",
    "CKGDHL": "Lihat lebih banyak hadiah",
    "ChaDingDan": "Periksa Pesanan",
    //integral-convert
    "DHSLBNCG": "Jumlah penukaran tidak melebihi",
    "DuiHuanShuLiang": "Jumlah Penukaran",
    "SuoXuJiFen": "Poin yang Dibutuhkan",
    //integral-detail
    "LiPinXiangQing": "Detail Hadiah",
    "WoYaoDuiHuan": "Saya ingin menukar",
    "ShengYu": "Tersisa",
    "TuWenXiangQing": "Detail",
    "Jian": "buah",
    "YiDuiWan": "Sudah ditukar",
    //integral-filter
    "FenLeiShaiXuan": "Filter Kategori",
    "JiFenShaiXuan": "Filter Poin",
    //integral-flow
    "JiFenShouRu": "Poin Masuk",
    "JiFenZhiChu": "Poin Keluar",
    //integral-logistics
    "DingDanGenZong": "Lacak Pesanan",
    "WuLiuGongSi": "Perusahaan Logistik",
    "WuLiuDanHao": "Nomor Resi",
    //integral-order
    "DingDanLieBiao": "Daftar Pesanan",
    "YiFaHuo": "Sudah Dikirim",
    "JiFenDingDan": "Pesanan Poin",
    "ChaKanWuLiu": "Lihat Logistik",
    //integral-order-create
    "LPSLBZ_QCX": "Stok hadiah tidak cukup",
    "JiFenBuZu": "Poin tidak cukup",
    "ZhiFuXinXi": "Informasi Pembayaran",
    "JiXuGuangGuang": "Belanja lagi",
    "QTXSHXX": "Silakan isi informasi penerimaan",
    "DuiHuanChengGong": "Penukaran berhasil",
    "LPDHQR": "Konfirmasi Penukaran Hadiah",
    "SCCKJ": "Harga referensi",
    "LiJiZhiFu": "Bayar Sekarang",
    //integral-order-detail
    "DingDanXiangQing": "Detail Pesanan",
    "DingDanZhuangTai": "Status Pesanan",
    "DingDanBianHao": "Nomor Pesanan",
    "DuiHuanShiJian": "Waktu Penukaran",
    "ShouHuoXinXi": "Informasi Penerima",
    "HuaFeiJiFen": "Poin Digunakan",
    //integral-rule
    "QDZJF": "Daftar dapat poin",
    "XDZJF": "Pesan dapat poin",
    "1_MRQD_JL": "1. Login harian: +{num} poin",
    "2_LXQD3T_EW": "2. Login berturut 3 hari: +{num} poin",
    "3_LXQD7T_EW": "3. Login berturut 7 hari: +{num} poin",
    "DLZJF": "Login dapat poin",
    "MRDLYSDHSC": "Login harian: +{num} poin",
    "DDWCHKHDYD": "Pesanan selesai: Poin = Jumlah Pesanan × {num}",
    //integral-rule-detail
    "GuiZe": "Aturan",
    //integral-sign
    "QianDaoYouLi": "Login dapat hadiah",
    "QianDaoGuiZe": "Aturan Login",
    "YLXQD": "Login berturut",
    "YLXQD1T": "Login {num} hari",
    "QDCG_NYJLX": "Berhasil! Login {num} hari",
    "QDCG_BCHD1": "Berhasil! Dapat {num} poin",
    "BCQDHD4JF_": "Dapat {num} poin, hebat!",
    "QSRBZ": "Silakan isi catatan",
    "DingDanZengPin": "Hadiah Pesanan",
    "GuiGeBianHao": "Kode Spesifikasi",
    "GuiGe": "Spesifikasi",
    //combined-pay
    "CDDWXFK": "Pesanan ini tidak perlu pembayaran",
    "YHYEBZ": "Saldo pengguna tidak cukup!",
    "ZFJEBNW0": "Jumlah pembayaran tidak boleh 0!",
    "ZFJEBNDYDD": "Melebihi jumlah terutang",
    "DFKJE": "Jumlah Terutang",
    "FuKuanFangShi": "Metode Pembayaran",
    "FuJian": "Lampiran",
    "ZHYFZ": "Salin Akun",
    "GHSKZH": "Ganti Akun Penerima",
    "SYXXZFQSCF": "Unggah bukti pembayaran untuk verifikasi",
    "XXZF_BXXZS": "Pilih akun penerima untuk pembayaran offline",
    "DingDanZhiFu": "Pembayaran Pesanan",
    "ZFFS_HDFK": "Metode: Bayar saat terima",
    "BCFKJE": "Jumlah pembayaran ini",
    "YuE": "Saldo",
    "FuZhiZhangHao": "Salin Akun",
    "WSZXCXZFPZ": "Pembayaran tidak diatur",
    "XCXZFZHJY": "Akun pembayaran dinonaktifkan",
    "SRZFJE": "Masukkan jumlah pembayaran",
    "FuKuanZhangHu": "Akun Pembayaran",
    "QueRenZhiFu": "Konfirmasi Pembayaran",
    "ShaoHouZhiFu": "Bayar nanti",
    //order
    "FKJLYTJ_DD": "Tambahkan catatan pembayaran, tunggu verifikasi",
    "JiXuGuang": "Belanja lagi",
    "BenCiFuKuan": "Pembayaran ini",
    "FuKuanChengGong": "Pembayaran berhasil",
    "ZhiFuFangShi": "Metode Pembayaran",
    "ZhiFuDingDan": "Bayar Pesanan",
    //order-batch-pay
    "QXXZSXZFDD": "Silakan pilih pesanan untuk dibayar",
    "PiLiangFuKuan": "Pembayaran Massal",
    "FuKuan": "Bayar",
    "QuFuKuan": "Ke Pembayaran",
    //order-create-result
    "YingFuJinE": "Jumlah yang Harus Dibayar",
    "XiaDanShiJian": "Waktu Pemesanan",
    //order-deliver
    "SFQRSH": "Konfirmasi penerimaan?",
    "DDQRSH": "Konfirmasi Pesanan Diterima",
    "DFHSP": "Produk menunggu pengiriman",
    "ShangPinShuLiang": "Jumlah Produk",
    "ChuKuShiJian": "Waktu Keluar Gudang",
    "FaHuoShiJian": "Waktu Pengiriman",
    "WuLiuBeiZhu": "Catatan Logistik",
    "QueRenShouHuo": "Konfirmasi Penerimaan",
    "RYFK_QJSYG": "Hubungi admin jika sudah bayar",
    "QSRQXYY": "Silakan masukkan alasan pembatalan",
    "H_DDJZDGB_QJKF": "Pesanan akan dibatalkan secara otomatis",
    "TuiHuoQingKuang": "Status Retur",
    "DingDanZongE": "Total Pesanan",
    "DingDanBeiZhu": "Catatan Pesanan",
    "FaHuoQingKuang": "Status Pengiriman",
    "DingDanFuJian": "Lampiran Pesanan",
    "ShenQingTuiHuo": "Ajukan Retur",
    "G1TDSHJL_QRS": "Konfirmasi penerimaan {num} pesanan?",
    "DaiXiaDan": "Dipesan oleh agen",
    "DingDanHao": "Nomor Pesanan",
    "XiaDanFangShi": "Metode Pemesanan",
    "TuiHuoDan": "Retur",
    "ShangPinZongE": "Total Produk",
    "YunFei_ZongZhong": "Biaya Pengiriman (Berat Total",
    "SF_SPWS": "Pajak (Produk belum kena pajak",
    "TePiJia": "Harga khusus",
    "FuKuanQingKuang": "Status Pembayaran",
    "TiaoJiLu": "Riwayat",
    "ZaiLaiYiDan": "Pesan lagi",
    "MuLiuXinXi": "Informasi Logistik",
    "QDSCGDD_": "Konfirmasi hapus pesanan?",
    "YiQueRen": "Dikonfirmasi",
    "YiShouHuo": "Diterima",
    "DaiFuJinE": "Belum dibayar",
    "YiFuJinE": "Sudah dibayar",
    "ZanWuJiLu": "Tidak ada riwayat",
    "SPMC_DDH": "Nama Produk / Nomor Pesanan",
    "FuKuanZhuangTai": "Status Pembayaran",
    "FaHuoZhuangTai": "Status Pengiriman",
    "QiShiShiJian": "Waktu Mulai",
    "ZhongZhiShiJian": "Waktu Berakhir",
    //order-list
    "CaoZuoChengGong": "Operasi berhasil",
    "ZBKGM": "Tidak bisa dibeli sekarang",
    "DQDDSPYXJ": "Produk dalam pesanan tidak dijual lagi",
    "DQDDBFSPYXJ": "Beberapa produk tidak dijual lagi",
    "JTJSJSP": "Tambahkan hanya produk yang tersedia",
    "DingHuoDan": "Pesanan pembelian",
    //order-log
    "DingDanRiZhi": "Log Pesanan",
    //order-logistics
    "FuZhiChengGong": "Salin berhasil",
    "FuZhiShiBai": "Salin gagal",
    "FuZhi": "Salin",
    "BoDa": "Telepon",
    "WCWLDHXX": "Tidak ada informasi logistik",
    //order-pay
    "ZFCS_QCXXD": "Waktu pembayaran habis, silakan pesan ulang",
    "YQYYCKZF": "Aktifkan pembayaran deposit",
    "BNDYDFKJE": "Tidak melebihi jumlah terutang",
    "ZFJEBNWK": "Jumlah pembayaran harus diisi",
    "QXAPFK_FKH": "Siapkan bukti pembayaran untuk verifikasi",
    "DDTJCG_QJS": "Pesanan berhasil, silakan segera bayar",
    "QXZFKFS": "Silakan pilih metode pembayaran",
    "SYYEZFH_HX": "Setelah bayar dengan saldo, perlu bayar tambahan",
    "FuKuanJiLu": "Riwayat Pembayaran",
    "ZWFKJL": "Tidak ada riwayat pembayaran",
    "FuKuanXiangQing": "Detail Pembayaran",
    "FuKuanJinE": "Jumlah Pembayaran",
    "ZhiDan": "Dibuat oleh",
    "ShenHe": "Verifikasi",
    "ZuoFei": "Dibatalkan",
    "ZuoFeiYuanYin": "Alasan pembatalan",
    "GLDHD": "Pesanan terkait",
    "HeXiaoJinE": "Jumlah yang diverifikasi",
    "HeXiaoZhuangTai": "Status Verifikasi",
    "DanJuZhuangTai": "Status Dokumen",
    "KeHuMingCheng": "Nama Pelanggan",
    "ZhangDanHao": "Nomor Tagihan",
    "ShouKuanZhangHao": "Akun Penerima",
    "ShouKuanShiJian": "Waktu Penerimaan",
    "FuKuanPingZheng": "Bukti Pembayaran",
    "GeFuJian": "Lampiran",
    //order-statistics
    "DingDanTongJi": "Statistik Pesanan",
    "DingHuo0Bi": "{num} pesanan",
    //order-statistics-detail
    "DDTJMX": "Detail Statistik",
    "AGGTJ": "Berdasarkan spesifikasi",
    "AFLTJ": "Berdasarkan kategori",
    "DDJE_Y": "Jumlah Pesanan/Rp",
    "DHSP_Z": "Produk Dipesan/Jenis",
    "DingHuoDan_Bi": "Pesanan/Lembar",
    "DingHuoShangPin": "Produk Dipesan",
    "JinE": "Jumlah",
    //refund-list
    "TuiHuo": "Retur",
    //refund-apply
    "THDHWBC_QD": "Retur belum disimpan, keluar?",
    "QSRSQTHJE": "Silakan masukkan jumlah retur",
    "QSRTHJE": "Silakan masukkan jumlah retur",
    "QSRBZXX": "Silakan masukkan catatan",
    "YingTuiJinE": "Jumlah yang harus dikembalikan",
    "TJTHSQ": "Kirim permintaan retur",
    "QXXZDHQD": "Silakan pilih item pesanan",
    "DingHuoQingDan": "Daftar Pesanan",
    "SQTHJE": "Jumlah permintaan retur",
    "DJXZSP": "Klik untuk pilih produk",
    "TuiHuoJinE": "Jumlah retur",
    //refund-detail
    "THDDXQ": "Detail Retur",
    "YiTuiHuo": "Sudah dikembalikan",
    "YiTuiKuan": "Sudah direfund",
    "THDZT": "Status Retur",
    "TuiHuoDanHao": "Nomor Retur",
    "TuiHuoShiJian": "Waktu Retur",
    "TuiHuoCangKu": "Gudang Retur",
    "THLXR": "Kontak Retur",
    "TuiHuoQingDan": "Daftar Retur",
    "TuiKuanZongE": "Total Refund",
    "TuiKuanQingKuang": "Status Refund",
    "DaiTuiJinE": "Belum dikembalikan",
    "YiTuiJinE": "Sudah dikembalikan",
    //refund-product
    "SPMC_BH_GG": "Nama Produk / Kode / Spesifikasi / Barcode",
    "GZD1TJG": "Ditemukan 1 hasil",
    "JiaRuQingDan": "Tambahkan ke daftar",
    //refund-result
    "ShenQingChengGong": "Permintaan berhasil",
    "THDTJCG": "Retur berhasil dikirim",
    "ChaKanXiangQing": "Lihat detail",
    //goods-package-floor
    "HDWKS_WDZL": "Acara belum dimulai",
    "HDYJS_XCZD": "Acara telah berakhir",
    "ZWSZBT": "Tidak ada judul",
    "ChaKanGengDuo": "Lihat lebih banyak",
    //goods-promotion-floor
    "HCDZSJC": "Perbedaan waktu karena cache",
    "DLCKCXJ": "Login untuk lihat harga khusus",
    "ZWSZCX": "Tidak ada promosi",
    "JuKaiShi": "Sebelum mulai",
    "Song": "Gratis",
    "JuJieShu": "Sebelum berakhir",
    "YiJieShu": "Telah berakhir",
    //search-floor
    "XiaoXi": "Pesan",
    "SaoMaXiaDan": "Pesan dengan pindai",
    //home-page-custom
    "WZLCSJ": "Data tidak diketahui",
    //jump-error
    "QXZYSDHAPP": "Unduh aplikasi YUNSHANG",
    "QMTYQYGLD": "Pengalaman manajemen lengkap",
    "XZYSDHAPP": "Unduh aplikasi YUNSHANG",
    "HQGLDWZTY": "Dapatkan pengalaman lengkap",
    "JXTYDHD": "Lanjutkan pemesanan",
    //notice-detail
    "GongGaoXiangQing": "Detail Pengumuman",
    "GongGaoFuJian": "Lampiran Pengumuman",
    //shop-error
    "NFWDYMBCZO": "Halaman tidak ditemukan",
    "KeNengYuanYin": "Kemungkinan penyebab",
    "1_ZDZLSRCWD": "1. URL salah",
    "2_DJLGQLJ": "2. Tautan kedaluwarsa",
    //shop-index
    "GuanLiDuan": "Manajemen",
    "ZhuCe": "Daftar",
    "HYNTYYSDH": "Selamat datang di YUNSHANG",
    "TYZHSJHDQG": "Data akun demo akan diperbarui",
    "TYZHZDNRSJ": "Data dalam akun demo adalah simulasi",
    "ZHZCCG": "Pendaftaran berhasil",
    "DengLuZhangHao": "Akun login",
    "CSMMW": "Password default",
    "GNFYHQL": "Anda mendapat kupon",
    "Man1YuanKeYong": "Min Rp{num} dapat digunakan",
    "LQH1TNKY": "Dapat digunakan dalam {day} hari",
    "YiJianLingQu": "Ambil segera",
    "GXNHD1ZYHQ": "Selamat, Anda mendapat kupon {num} Rp{price} {name}",
    "Gong1Yuan": "Total Rp{num}",
    "LiJiShiYong": "Gunakan segera",
    //shop-login
    "NHWDL": "Anda belum login",
    //shop-notice
    "ShangChengGongGao": "Pengumuman Toko",
    "ZanWuGongGao": "Tidak ada pengumuman",
    "1GeFuJian": "{num} lampiran",
    //deposit-detail
    "KouKuan": "Potongan",
    "ChongZhi_Kuan": "Isi ulang",
    "KouKuanZuoFei": "Batalkan potongan",
    "ChongZhiZuoFei": "Batalkan isi ulang",
    "ZhangHuMingXi": "Detail Akun",
    "ZhangHuYuE": "Saldo Akun",
    "LiJiChongZhi": "Isi ulang segera",
    //deposit-recharge
    "CZJEBNXY1Y": "Minimal isi ulang Rp1",
    "QSRZQDSZ": "Silakan masukkan nilai yang valid",
    "ZDYJE": "Jumlah kustom",
    "ZWKTXSCZGN": "Tidak dapat isi ulang online",
    "ShiFuJinE": "Jumlah pembayaran aktual",
    "ZhangHuChongZhi": "Isi ulang akun",
    "QXZCZJE": "Pilih jumlah isi ulang",
    "QSRCZJE": "Masukkan jumlah isi ulang",
    "QLXNDZSYWY": "Hubungi perwakilan penjualan",
    "ShouJia": "Harga jual",
    "YiShouQing": "Terjual habis",
    "ChongZhiJinE": "Jumlah isi ulang",
    "QueRenFuKuan": "Konfirmasi pembayaran",
    //deposit-recharge-result
    "QSDDID": "Tidak ada ID pesanan",
    "ChongZhiChengGong": "Isi ulang berhasil",
    "ChongZhiShiBai": "Isi ulang gagal",
    "CLZ_QSH...": "Memproses, harap tunggu sebentar...",
    "ChongZhiFangShi": "Metode isi ulang",
    "ChongZhiShiJian": "Waktu isi ulang",
    "JYLSH": "Nomor transaksi",
    "FanHuiShangCheng": "Kembali ke toko",
    //recharge-online
    "ZFSB_QCS": "Pembayaran gagal, coba lagi",
    "ZFYQX": "Pembayaran dibatalkan",
    "ZFYC_QCS": "Kesalahan pembayaran, coba lagi",
    //user
    "LingQuanZhongXin": "Pusat Kupon",
    "WeiShiYong": "Belum digunakan",
    "YiShiYong": "Sudah digunakan",
    "ZWYHQ": "Tidak ada kupon",
    //keep-list
    "YiGouMai": "Sudah dibeli",
    "ChangYongQingDan": "Daftar sering digunakan",
    "WoDeShouCang": "Favorit saya",
    "QuGouWuChe": "Ke keranjang",
    "GeShangPin": "Produk",
    //login
    "YunShangDingHuo": "YUNSHANG",
    "QSRZH": "Silakan masukkan akun!",
    "QSRMM": "Silakan masukkan password!",
    "QSRDLZH": "Silakan masukkan akun login",
    "JiZhuMiMa": "Ingat password",
    "WangJiMiMa": "Lupa password?",
    "DengLu": "Login",
    "DLZHBCZ_QL": "Akun tidak ada, hubungi admin",
    "GQYZHSBJY_": "Akun perusahaan dinonaktifkan",
    "GQYZHSYQJS_": "Masa percobaan habis",
    "GQYZHYGQL_": "Akun kedaluwarsa, perlu perpanjangan",
    "LiJiTiYan": "Coba sekarang",
    //my-collect
    "YiChuChengGong": "Berhasil dihapus",
    "QueHuo": "Stok habis",
    "YCSCJ": "Hapus dari favorit",
    //order-message
    "SheZhiChengGong": "Pengaturan berhasil",
    "ZWWDXX": "Tidak ada pesan belum dibaca",
    "QuanBuYiDu": "Tandai semua sebagai dibaca",
    "DingDanXiaoXi": "Pesan Pesanan",
    "YiQiang": "Sudah diambil",
    "LiJiLingQu": "Ambil sekarang",
    "LingQuanHou": "Setelah menerima kupon",
    "TianNeiKeYong": "dapat digunakan dalam {n} hari",
    "QSRSJH": "Masukkan nomor telepon",
    "QSRYZM": "Masukkan kode verifikasi",
    "QSRXMM": "Masukkan kata sandi baru",
    "QSRZQSJGS": "Masukkan format telepon yang benar",
    "ChongZhiMiMa": "Atur ulang kata sandi",
    "QSRNDSJHM": "Masukkan nomor telepon Anda",
    "QSRDXYZ": "Masukkan kode SMS",
    "HQYZM": "Dapatkan kode",
    "HKCXHQ": "Kirim ulang dalam {n}",
    "QSR6_20WSZHZ": "Kata sandi: 6-20 karakter (angka/huruf)",
    //share-setting
    "QSRSPJGBL": "Silakan masukkan rasio harga produk",
    "SPJGBLBXDY": "Rasio harus antara 100-999.99",
    "DPMCZBZCTS": "Nama toko tidak mendukung karakter khusus",
    "LXRZBZCTSF": "Nama kontak tidak mendukung karakter khusus",
    "LXFSZBZCTS": "Info kontak tidak mendukung karakter khusus",
    "LXDZZBZCTS": "Alamat tidak mendukung karakter khusus",
    "DPJJZBZCTS": "Deskripsi toko tidak mendukung karakter khusus",
    "QSRDPJJ_ZD": "Silakan masukkan deskripsi toko (maks 50 karakter)",
    "FenXiangSheZhi": "Pengaturan berbagi",
    "NDWSCSPJG": "Harga produk Anda",
    "NDDHJ_": "Harga pesanan Anda ×",
    "LXXX_KBJ_": "Info kontak (dapat diedit)",
    "DianPuMingCheng": "Nama Toko",
    "JianJie": "Deskripsi",
    "QSRDPMC": "Silakan masukkan nama toko",
    "LianXiRen": "Kontak",
    "QSRLXR": "Silakan masukkan nama kontak",
    "LianXiFangShi": "Metode kontak",
    "QSRLXFS": "Silakan masukkan info kontak",
    "LianXiDiZhi": "Alamat kontak",
    "QSRLXDZ": "Silakan masukkan alamat kontak",
    //user
    "WoDeDingDan": "Pesanan saya",
    "ZuiJinLiuLan": "Baru dilihat",
    "ShouCangShangPin": "Produk favorit",
    "BDYYZH_ZC": "Ikat akun yang ada | Daftar akun baru",
    "DL_ZC": "Login | Daftar",
    "BangDingShouJi": "Ikat nomor telepon",
    "TS_BDSJHM_": "Tips: Ikat nomor telepon untuk keamanan akun!",
    "ChaKanQuanBu": "Lihat semua",
    "ShouHuoDiZhi": "Alamat pengiriman",
    "LianXiWoMen": "Hubungi kami",
    "SheZhi": "Pengaturan",
    "QuQianDao": "Ke check-in",
    "QianDao": "Check-in",
    "JiFenShangCheng": "Toko Poin",
    "TuiGuangShangPin": "Promosikan produk",
    "QuChaKan": "Lihat",
    "JiFenHuanLi": "Tukar poin dengan hadiah",
    "DYSPBQ": "Cetak label produk",
    //user-about
    "GYYSDH": "Tentang YUNSHANG",
    "YQHYSMEWM_": "Undang teman untuk pindai QR Code dan unduh",
    "DangQianBanBen": "Versi saat ini",
    //user-address
    "ZWSHDZ": "Tidak ada alamat pengiriman",
    "WoDeDiZhi": "Alamat saya",
    "ZhiNengShiBie": "Pengenalan pintar",
    "ZTDZXXKZNS": "Tempel info alamat untuk pengenalan otomatis",
    "MoRen": "Default",
    "QRSCDZ": "Konfirmasi hapus alamat?",
    "SHRXM": "Nama penerima",
    "SJHMHGDDHZ": "Harus isi nomor telepon atau telepon rumah",
    "QSRSHRXM": "Silakan masukkan nama penerima",
    "ShouJiHaoMa": "Nomor telepon",
    "GuDingDianHua": "Telepon rumah",
    "QSRGDDH": "Silakan masukkan nomor telepon rumah",
    "SuoZaiDiQu": "Area",
    "QSRSZDQ": "Silakan pilih area",
    "QSRXXDZ": "Silakan masukkan alamat lengkap!",
    "QSRZQDSJHM": "Silakan masukkan nomor telepon yang valid",
    "QSRZQDGDDH": "Silakan masukkan nomor telepon rumah yang valid",
    "XiangXiDiZhi": "Alamat lengkap",
    "MoRenDiZhi": "Alamat default",
    "SWMRDZ": "Set sebagai default",
    "BCBSY": "Simpan dan gunakan",
    //user-bing-one
    "QSRSJHM": "Silakan masukkan nomor telepon",
    "GYHYZC": "Pengguna ini sudah terdaftar",
    "GSJHMYJZCG": "Nomor telepon ini sudah terdaftar",
    "QZJDLJK": "Silakan login langsung",
    "QuDengLu": "Ke login",
    "BDHKYTGSJH": "Ikat untuk login dengan nomor telepon",
    "_BDHKYTGSJ": "*Ikat untuk login dengan nomor telepon",
    "QSRSJYZM": "Silakan masukkan kode verifikasi SMS",
    "BDXSJ": "Ikat nomor telepon baru",
    "DXYZM": "Kode verifikasi SMS",
    "XiaYiBu": "Langkah selanjutnya",
    "TGCBZ": "Lewati langkah ini",
    //user-bing-two
    "DBDSJHMBCZ": "Nomor telepon yang ingin diikat tidak ada!",
    "QSRDLMM": "Silakan masukkan password!",
    "_GSJHMYBDY": "*Nomor telepon ini sudah terikat",
    "DQZHMMJTBW": "Password akun akan disinkronkan",
    "DangQianZhangHao": "Akun saat ini",
    "QDYJZ": "Konfirmasi hapus",
    "JSPSCM": "Produk ini?",
    "ShanChuChengGong": "Hapus berhasil!",
    //user-info
    "SJGSCW": "Format nomor telepon salah",
    "YXGSCW": "Format email salah",
    "WoDeZhangHao": "Akun saya",
    "YouXiang": "Email",
    "ShouJi": "Telepon",
    "XingMing": "Nama lengkap",
    "XiuGaiTouXiang": "Ubah foto profil",
    "JiBenXinXi": "Informasi dasar",
    "ZhangHaoAnQuan": "Keamanan akun",
    "XiuGaiMiMa": "Ubah password",
    "DianJiBangDing": "Klik untuk mengikat",
    "RYDSHTY_QL": "Jika hilang atau tidak digunakan, segera ubah",
    "WBZNDZHAQ_": "Ikat nomor telepon untuk keamanan",
    //user-setting
    "QCHCHXCXDL": "Hapus cache perlu login ulang",
    "QingChuHuanCun": "Hapus cache",
    "QDYQCHCM": "Konfirmasi hapus cache?",
    "TuiChuDengLu": "Logout",
    "ZhangHaoZhuXiao": "Hapus akun",
    "QieHuanZhangHao": "Ganti akun",
    //user-supplier
    "LianXi": "Kontak",
    "GongSiDianHua": "Telepon perusahaan",
    "DiZhi": "Alamat",
    //vouchers-detail
    "DJQMX": "Detail kupon",
    //vouchers-list
    "BuKeYong": "Tidak dapat digunakan",
    "KeYong": "Dapat digunakan",
    "ZWDJQ": "Tidak ada kupon",
    "ZongEDu": "Total nilai",
    "FaFangShiJian": "Waktu penerbitan",
    "EDYYW": "Nilai habis",
    //vouchers-select-list
    "WDDJQ": "Kupon saya",
    "KYDJQ": "Kupon yang dapat digunakan",
    "DJQKDK": "Kupon dapat dipotong",
    "CKKYSP": "Lihat produk yang berlaku",
    "BKYDJQ": "Kupon tidak dapat digunakan",
    "BKYYY_ZWFH": "Alasan: Tidak ada produk yang memenuhi syarat",
    //goods-detail
    "DQSPWSCGGT": "Produk ini tidak memiliki gambar spesifikasi",
    "BoFangShiPin": "Putar video",
    "Gong1GeGuiGe": "Total {num} spesifikasi",
    "YiXuanGuiGe": "Spesifikasi dipilih",
    "XuanGuiGe": "Pilih spesifikasi",
    "LingQuan": "Ambil kupon",
    "1ZhongCuXiao": "{num} promosi",
    "1ZhangKeYong": "{num} dapat digunakan",
    "ZuiGaoKeSheng": "Penghematan maksimum",
    "ShangPinTaoCan": "Paket produk",
    "Gong1GeTaoCan": "Total {num} paket",
    "ShangPinCanShu": "Parameter produk",
    "ZhanKai": "Perluas",
    "YiShouCang": "Sudah disimpan",
    "ShouCang": "Simpan",
    "KeFu": "Layanan pelanggan",
    "XiangQing": "Detail",
    "TuiJian": "Rekomendasi",
    "BianHao": "Kode",
    "ShangPinXinXi": "Informasi produk",
    "KLYHQ": "Dapat mengambil kupon",
    "KuCunBuZu": "Stok tidak cukup",
    "DuoGuiGe": "Multi-spesifikasi",
    "YiShou": "Terjual",
    "SWBHZ_YS": "Stok habis, terjual",
    "CuXiaoShangPin": "Produk promosi",
    //goods-search
    "NHWSRSSNR": "Anda belum memasukkan kata kunci pencarian",
    "SouSuo": "Cari",
    "SSY1XGDSP": "Cari produk terkait {searchKey}",
    "Yue1GeShangPin": "Sekitar {num} produk",
    "ZuiJinSouSuo": "Pencarian terbaru",
    "QingChu": "Hapus",
    "ZWSSJL": "Tidak ada riwayat pencarian",
    //goods-property
    "ZGJGBNDYZD": "Harga maksimum tidak boleh kurang dari",
    "ShangPinBiaoQian": "Label Produk",
    "BuGaoYu1": "Tidak lebih dari 1",
    "BuDiYu1": "Tidak kurang dari 1",
    "FengGe": "Gaya",

    //goods-promotion-list
    "JiJiangKaiShi": "Akan segera dimulai",
    "QuanBuCuXiao": "Semua Promosi",

    //goods-package-list
    "Gong1JianShangPin": "Total {num} produk",
    "Sheng": "Hemat",

    //goods-package-detail
    "GTCZGWCZDS": "Paket ini mencapai batas keranjang",
    "GTCKCBZ_BK": "Stok paket tidak cukup",
    "JinSheng1Tao": "Tinggal {num} set",
    "XianGou1Tao": "Beli maksimal {num} set",
    "TaoCanXiangQing": "Detail Paket",
    "DanMaiJia": "Harga satuan",
    "TaoCanJia": "Harga paket",
    "HDYJS": "Promosi telah berakhir",

    //goods-message
    "WDL_QXDL": "Belum login, silakan login",

    //goods-list-label
    "XinPinShangShi": "Produk baru",
    "WDLZH_ZWCX": "Belum login, tidak ada promosi",
    "YiXiaShangPin": "Produk di bawah",

    //goods-list
    "1ZhongGuiGe": "{num} spesifikasi",
    "YouKuCun": "Stok tersedia",

    //goods-filter
    "BuGaoYu": "Tidak lebih dari",
    "BuDiYu": "Tidak kurang dari",
    "CuXiao": "Promosi",
    "ZDYXXZ3G": "Pilih maksimal 3",
    "GouMai": "Beli",
    "Gong1Jian": "Total {num} item",

    //缺失
    "YiChuShouCangJia": "Hapus dari favorit",
    "$": "RM",
    "$1": "RM{num}",
    "_8999_1Qi": "Dari RM 8999.1",
    "Ge": "unit",
    "BaoZhuangFangShi": "Cara pengemasan",
    "QRSCSP_": "Konfirmasi hapus produk?",
    "JEWM_TMFRK": "Pindai kode QR/kode batang",
    "0ZSP_G0J": "0 jenis produk, 0 unit",
    "JiuMiMa": "Password lama",
    "XMM_6_20WZ": "Password baru (6-20 karakter)",
    "QueRenMiMa": "Konfirmasi password",
    "BDHKSYSJHD": "Ikat untuk login dengan nomor telepon",
    "YanZhengMa": "Kode verifikasi",
    "1MHKCXHQ": "Coba lagi dalam 1 detik",
    "CSJHZ1MQFS": "Kode sudah dikirim, coba sebentar lagi",
    "GouMaiJiLu": "Riwayat pembelian",
    "XinZengDiZhi": "Tambahkan alamat baru",
    "LingShouJia": "Harga eceran",
    "YouHuiJia": "Harga promo",
    "ShangPinChuKu": "Produk habis",
    "DengDaiShouHuo": "Menunggu pengiriman",
    "ShouHuoRen": "Penerima",
    "PaiZhao": "Ambil foto",
    "XiangCe": "Galeri",
    "TiYanGuan": "Galeri pameran",
    "JingYingShiJian": "Jam operasi",
    "ZhanGuanDianHua": "Telepon galeri",
    "ZhanGuanDiZhi": "Alamat galeri",
    "SJHQZ_QSDZ": "Sedang memuat, coba sebentar lagi",
    "QXXZSF_": "Silakan pilih provinsi terlebih dahulu!",
    "QuanBuShengFen": "Semua provinsi",
    "QuanBuChengShi": "Semua kota",
    "YingYeShiJian": "Jam operasi",
    "ChanPinBianHao": "Nomor produk",
    "DLXXYGQ_QC": "Sesi berakhir, silakan login kembali",
    "Man999Jian100": "Beli {m} hemat {n}",
    "YiManZu": "Sudah memenuhi",
    "QDYCSP_": "Konfirmasi hapus produk?",
    "DGM10JZ1J": "Beli 10 dapat 1 gratis",
    "XiaXianTongZhi": "Notifikasi offline",
    "NDZHYZQTSB": "Akun Anda login di perangkat lain",
    "ManJiang": 'Beli {target} hemat {num}',
    "ZGLXMJ": 'Beli {num} lagi hemat {money_}',
    "ZGLXMZ": 'Beli {num} lagi dapat diskon {percent}%',
    "QSRZQNR": 'Silakan masukkan konten yang benar',
    "NHYDDQKWJQ": 'Anda memiliki {num} pesanan tertunda',
    "FaPiaoZhuShou": "Asisten faktur",
    "WoDeFaPiao": "Faktur saya",
    "FaPiaoXiangQing": "Detail faktur",
    "KaiPiaoShiJian": "Waktu penerbitan faktur",
    "DaiKaiFaPiao": "Faktur belum diterbitkan",
    "DKFPJE": "Jumlah faktur tertunda",
    "KaiPiaoJinE": "Jumlah faktur",
    "ZFYDWT_QCSCXZF": "Masalah pembayaran, coba metode lain",
    "QingXuanZhe": "Silakan pilih",
    "ShouXin": 'Kredit',
    "LJSQSXED": "Ajukan kredit sekarang",
    "SXEDSHZ": "Kredit dalam peninjauan",
    "SXCZ_XDCG": "Kredit cukup, pesanan berhasil",
    "SXEDBZ_FKHFH": "Kredit tidak cukup, bayar sebelum pengiriman",
    "CGJKZQ_FKFH": "Melewati batas waktu, bayar sebelum pengiriman",
    "DDTJCG_XZZCZHYB": "Pesanan berhasil, tinggal langkah terakhir!",
    "MianFeiLing": "Dapatkan gratis",
    "M_KMFLQ_HQ": "Beli {target} dapat gratis, kurang {short}",
    "YHDMFSP": "Sudah mendapatkan produk gratis",
    "JRMFL": "Gratis hari ini",
    "LingGuangLe": "Habis",
    "KeLingQu": "Dapat diambil",
    "YuGuJia": "Perkiraan harga",
    "GXNHQ_Z_Y_": "Selamat, Anda dapat {num} kupon {price}RM {name}",
    "LXZSKF": "Hubungi perwakilan penjualan",
    "DPYDY_QSHX": "Toko tutup, silakan pesan nanti",
    "DaYangShiJian": "Jam tutup",
    "ChuanHaoChaXun": 'Cek nomor seri',
    'IMEI': 'Nomor seri',
    "FanKuanYuE": "Saldo pengembalian dana",
    "FanKuanZhiFu": "Bayar dengan pengembalian dana",
    "JingDongYiYunJia": "Jingdong Yiyun+",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "Saldo pengembalian dana tidak cukup",
    "FanKuanZhangHu": "Akun pengembalian dana",
    "HaiXuZhiFu": "Perlu membayar tambahan {price}",
    "QTXGSMC": "Silakan masukkan nama perusahaan",
    "QSCSFZZMZ": "Silakan unggah foto depan KTP",
    "QSCSFZFMZ": "Silakan unggah foto belakang KTP",
    "QSCYYZZ": "Silakan unggah izin usaha",
    "TJCG_QNXDDSH": "Kirim berhasil, tunggu peninjauan",
    "SXSQ": "Permohonan kredit",
    "QYJBZL": "Informasi dasar perusahaan",
    "SQFRSFZZM": "Unggah foto depan KTP",
    "ZMSLT": "Contoh depan",
    "SCFRSFZFM": "Unggah foto belakang KTP",
    "FMSLT": "Contoh belakang",
    "QQBSFZSJWZ_WZQXKBB": "Pastikan KTP jelas",
    "SCYYZZ": "Unggah izin usaha",
    "ShengHeZhong": "Dalam peninjauan",
    "TiJiaoShenHe": "Kirim untuk ditinjau",
    "GSMC": "Nama perusahaan",
    "DDDKFQRBJQSH": "Pesanan menunggu konfirmasi harga",
    "XDTX": "Pengingat pesanan",
    "NH_GDDBH": "Beberapa produk perlu konfirmasi harga",
    "QRXD": "Konfirmasi pesanan",
    "DaiHeJia": "Menunggu harga",
    "ZHJY": "Saldo akun",
    "YGTG": "Promosi karyawan",
    "YuanGong": "Karyawan",
    "DuiZhanGJieSuan": "Penyelesaian akun",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "Saldo = Deposit + Pengembalian dana + Retur tertunda - Belum dibayar",
    "YCKYE": "Saldo deposit",
    "FKYE": "Saldo pengembalian dana",
    "DDYFK": "Belum dibayar",
    "THDTK": "Retur tertunda",
    "YuCunKuanZuoFei": "Deposit dibatalkan",
    "FanKuanZhangHuMingXi": "Detail akun pengembalian dana",
    "TKCZDFKZH": "Isi ulang ke akun pengembalian dana",
    "RMBJE": "Jumlah RMB"
};
exports.default = id_ID;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
// ms_MY.js
var ms_MY = {
   "GuanShui": "Cukai impor",
   "ZiZhangHao": "Akaun anak",

   "ZHONGWEN": "Chinese",
   "YINGYU": "English",
   "XIBANYAYU": "Español",
   "DEYU": "Deutsch",
   "FAYU": "Français",
   "ALABOYU": "العربية",
   "EYU": "Русский",
   "MALAIYU": "Bahasa Malaysia",
   "YUENANYU": "Tiếng Việt",
   "TAIYU": "ภาษาไทย",
   "YINNIYU": "Bahasa Indonesia",
   //components
   "ShangeChuanYanZhengTuPian": "Muat Naik Gambar Pengesahan",
   "ChuanHaoYanZheng": "Pengesahan IMEI",
   "YanZhengChuanHao": "Sahkan IMEI",
   "Ci": "kali",
   "DingDanMan": "Pesanan penuh",
   "YuanZeng": "RM hadiah",
   "SCFJ_ZD4Z_DZBCG": "Muat naik lampiran, maks 4 imej, setiap ≤3MB",
   //ChatRoom
   "ZBZCBQFH": "Emoji tidak disokong",
   "FaSongLianJie": "Hantar pautan",
   "YiChangXiaoXi": "Mesej tidak normal",
   "QingShuRu": "Sila masukkan",
   "FaSong": "Hantar",
   //DateSelector
   "DQSJXYKSSJ": "Masa semasa lebih awal dari masa mula",
   "DQSJCGJSSJ": "Masa semasa melebihi masa tamat",
   "QuXiao": "Batal",
   "NianYueRi": "Tahun-Bulan-Hari",
   "ShiFen": "Jam-Minit",
   "QueDing": "Sahkan",
   "Nian": "Tahun",
   "Yue": "Bulan",
   "Ri": "Hari",
   "Shi": "Jam",
   "Fen": "Minit",
   //goods-list-card
   "Qi": "dari",
   //goods-promotion
   "1GeCuXiao": "{num} promosi",
   "ChaKanZengPin": "Lihat hadiah",
   "JHDJSHS_1T": "Baki masa: {d}H {h}J {m}M {s}S",
   "YHGZ_ZPBKD": "Peraturan: Hadiah tidak boleh digabungkan",
   "YHGZ_AZZGM": "Peraturan: Diskaun berdasarkan kuantiti akhir",
   "GuanBi": "Tutup",
   "Man1Song1": "Beli {mai} dapat {song} percuma",
   //group-filtrate
   "QuanBu": "Semua",
   "ZWXGSJ": "Tiada data berkaitan",
   "ZuiDiJia": "Harga terendah",
   "ZuiGaoJia": "Harga tertinggi",
   "LeiXing": "Jenis",
   "PinPai": "Jenama",
   "BiaoQian": "Tag",
   "JiaGeQuJian": "Julat harga",
   "SPMC_GG_BH_": "Nama produk / Spesifikasi / ID / Huruf awal",
   "SPMC_GG_BH_G": "Nama produk / Spesifikasi / ID",
   "ZuHeShaiXuan": "Penapisan gabungan",
   "ChongZhi_CanShu": "Tetap semula",
   //image-upload
   "ZDKSC1ZTP": "Maks 1 imej",
   "ZYXSCTP": "Hanya imej dibenarkan",
   "SCTPDXBYXC": "Saiz imej ≤5MB",
   "QBYCFSCTP_": "Tiada muat naik berganda",
   "ShangChuanChengGong": "Muat naik berjaya",
   "ZDKSC1Z": "Maks 1",
   //keyboard
   "CCSLZDXZ": "Melebihi had",
   "QiDingLiang": "Kuantiti minimum",
   "ShouQi": "Tutup",
   "ShanChu": "Padam",
   //MultiPicker
   "FanHui": "Kembali",
   //order-cart
   "Dai": "Ejen",
   "YiQuXiao": "Dibatalkan",
   "ZengPin": "Hadiah",
   "1Zhong": "{num} jenis",
   "1Jian": "{num} unit",
   "HeJi": "Jumlah",
   "DaiFu": "Menunggu pembayaran",
   //order-promotion
   "_DDM1YZ1J_": "[Beli {target} dapat {name}x{number}]",
   "_DDM1YLJ1Y_": "[Beli {m} jimat {n}]",
   "_DDM1YLX1Z_": "[Beli {m} dapat {n}% diskaun]",
   "DingDanCuXiao": "Promosi pesanan",
   //page-ad
   "DLCKJG": "Log masuk untuk lihat harga",
   //page-floating
   "DianPuZhuYe": "Laman utama kedai",
   "GouWuChe": "Troli",
   "ZaiXianKeFu": "Khidmat pelanggan",
   "GeRenZhongXin": "Profil",
   "LianXiDianHua": "Hubungi",
   "FanHuiDingBu": "Kembali ke atas",
   //page-null
   "ZBDYML": "Halaman tidak dijumpai",
   "KNWZCW_HZY": "URL salah atau halaman dipadam",
   "FanHuiShangJi": "Kembali",
   "FanHuiShouYe": "Ke laman utama",
   //product-edit
   "SPQDBNWK": "Senarai produk tidak boleh kosong",
   "WoZhiDaoLe": "Saya faham",
   "SFQRSCSP": "Sahkan padam produk?",
   "QueRen": "Sahkan",
   "ZYXSRSZBQB": "Hanya nombor, maks 2 perpuluhan",
   "ShangPinDanJia": "Harga unit",
   "YSPYJ": "Harga asal",
   "QSRZDJG": "Masukkan harga ditetapkan",
   "ShuLiang": "Kuantiti",
   "DanWei": "Unit",
   "DanJia": "Harga",
   "BeiZhu": "Catatan",
   "YiChuShangPin": "Alih keluar produk",
   "XiuGai": "Edit",
   //yunshl
   "TPSLCCYXSZ": "Bilangan imej melebihi had!",
   "WJBDDY5M_QC": "Fail ≤5MB, sila pilih semula",
   "TPSCWC": "Muat naik imej selesai",
   //BusinessFilter
   "_DGSLM1Z1_": "[Pesan {target} dapat {provide}]",
   "_M1JLXMJ1Y_": "[Beli {target} jimat {cut_money_}/unit]",
   "_DHJJZ1Y_": "[Harga turun ke {cuted_price_}]",
   "_M1JLXMJ1Z_": "[Beli {target} dapat {cut_percent_}% diskaun/unit]",
   "_YDHJD1Z_": "[Harga asal {cuted_percent_}% diskaun]",
   "YuJiKaiShiFaHuo": "Jangkaan penghantaran: {date}",
   "YuJi": "Dijangka",
   "MMYDDR": "BB/HH",
   "KaiShiFaHuo": "Mula penghantaran",
   "_M1LXM1Y_": "[Beli 1 jimat 1/unit]",
   "_M1LXM1Z_": "[Beli 1 dapat 1% diskaun/unit]",
   "DaiQueRen": "Menunggu pengesahan",
   "DaiFaHuo": "Menunggu penghantaran",
   "DaiShouHuo": "Menunggu penerimaan",
   "YiWanCheng": "Selesai",
   "DaiFuKuan": "Menunggu pembayaran",
   "YiFuKuan": "Telah dibayar",
   "YiZuoFei": "Dibatalkan",
   "DaiShenHe": "Menunggu semakan",
   "DaiHeXiao": "Menunggu pengesahan",
   "YiHeXiao": "Telah disahkan",
   "XianXiaZhiFu": "Pembayaran offline",
   "ZhiNengDaoZhangShiBie": "Pemindahan bank (pengesahan automatik)",
   "WeiXinZhiFu": "WeChat Pay",
   "KQ-WeiXinZhiFu": "99Bill (WeChat)",
   "KQ-ZFBZF": "99Bill (Alipay)",
   "KQZhiFu": "99Bill Pay",
   "ZFBZF": "Alipay",
   "YuEZhiFu": "Bayar dengan baki",
   "HuoDaoFuKuan": "Bayar upon delivery",
   "DaiTuiHuo": "Menunggu pulangan",
   "DaiTuiKuan": "Menunggu bayaran balik",
   "ChuangJianDingDan": "Buat pesanan",
   "BianJiDingDan": "Edit pesanan",
   "TiJiaoDingDan": "Hantar pesanan",
   "DingDanShenHe": "Semak pesanan",
   "CaiWuShenHe": "Semak kewangan",
   "BoHui": "Tolak",
   "TianJiaShouKuan": "Tambah pembayaran",
   "ZaiXianZhiFu": "Pembayaran online",
   "ShouKuanShenHe": "Semak pembayaran",
   "ShouKuanZuoFei": "Batalkan pembayaran",
   "ChuKu": "Keluar stok",
   "ChuKuShenHe": "Semak keluar stok",
   "FaHuo": "Hantar",
   "TianJiaWuLiu": "Tambah logistik",
   "XiuGaiWuLiu": "Edit logistik",
   "ChuKuZuoFei": "Batalkan keluar stok",
   "ShouHuo": "Terima",
   "DingDanHeZhun": "Pesanan diluluskan",
   "QuXiaoDingDan": "Batal pesanan",
   "CJTHD": "Buat pulangan",
   "DaYin": "Cetak",
   "DaoChu": "Eksport",
   "DingDanWanCheng": "Pesanan selesai",
   "QiangZhiWanCheng": "Selesai paksa",
   "DingDanZuoFei": "Batalkan pesanan",
   "MaiZeng": "Beli dapat hadiah",
   "ZhiJiang": "Diskaun terus",
   "DaZhe": "Diskaun",
   "YuShou": "Pra-pesanan",
   "DingDanManZeng": "Hadiah pesanan penuh",
   "DingDanManJian": "Diskaun pesanan penuh",
   "DingDanManZhe": "Diskaun % pesanan penuh",
   "XinRenQuan": "Kupon pengguna baru",
   "ManJianQuan": "Kupon diskaun",
   "ShangPinQuan": "Kupon produk",
   "DaiJieSuan": "Menunggu penyelesaian",
   "YiJieSuan": "Telah diselesaikan",
   "QuanBuShangPin": "Semua produk",
   "TuiJianShangPin": "Produk disyorkan",
   "XinPin": "Baru",
   "ReXiaoShangPin": "Popular",
   "ChangYongShangPin": "Kerap dibeli",
   //BusinessUtil
   "DaiShouKuan": "Menunggu pembayaran",
   "BuFenShouKuan": "Pembayaran separa",
   "YiShouKuan": "Telah dibayar",
   "BXYFP": "Tiada invois diperlukan",
   "ZZSPTFP": "Invois VAT biasa",
   "ZZSZYFP": "Invois VAT khas",
   "QiTaFaPiao": "Invois lain",
   "XianXia": "Offline",
   "WeiXin": "WeChat",
   "ZhiFuBao": "Alipay",
   "YuCunKuan": "Deposit",
   "XianXiaZhuangZhang": "Pemindahan bank",
   "XianShangZhiFu": "Pembayaran online (WeChat/Alipay/JD/UnionPay)",
   "YCKZF": "Bayar dengan baki",
   "DaiTiJiao": "Menunggu penghantaran",
   "KuaiDi": "Kurier",
   "SongHuoShangMen": "Penghantaran",
   "ShangMenZiQu": "Ambil sendiri",
   "WuLiuHuoYun": "Pengangkutan kargo",
   "QiTa": "Lain-lain",
   //check-util
   "QSRBXY6WDM": "Kata laluan ≥6 aksara",
   "QSRBDY20WDM": "Kata laluan ≤20 aksara",
   "MMGSCW": "Format kata laluan salah",
   //common-utils
   "SJCW_QLXKF": "Ralat data, hubungi sokongan",
   "ZBZCQD": "Daftar masuk tidak disokong",
   "HuJiao": "Panggil",
   "DLZHBCZ": "Akaun tidak wujud",
   "QLXGLYKT": "Hubungi admin untuk aktifkan",
   "GQYZHBJY": "Akaun syarikat dinyahaktifkan",
   "QLXYSDH": "Hubungi YUNSHANG",
   "GQYZHSYQJS": "Tempoh percubaan tamat",
   "GQYZHYGQL": "Akaun tamat tempoh",
   "XYXFCNSY": "Perlu diperbaharui",
   "GQYBCZCZH": "Akaun syarikat tidak sah",
   "NDDHZHYBQY": "Akaun anda dinyahaktifkan oleh syarikat",
   "NYBSQY1DHZ": "Bukan lagi rakan kongsi",
   "NDDPYBTY_B": "Kedai digantung",
   "GZHWKTDSZB": "Modul lampu tidak diaktifkan",
   "WXSQYZYGQ": "Pengesahan WeChat tamat tempoh",
   "WXSQSB": "Pengesahan WeChat gagal",
   "WXSQSB_CWX": "Pengesahan WeChat gagal: {msg}",
   "DengLuGuoQi": "Sesi tamat tempoh",
   "DLGQ_QCXDL": "Sesi tamat, sila log masuk semula",
   //data-constant
   "ShangJia": "Dijual",
   "YiXiaJia": "Tidak dijual",
   "YiJinYong": "Dinyahaktifkan",
   "YiQiYong": "Diaktifkan",
   "YiTingYong": "Digantung",
   "KeHuZhuCe": "Pelanggan berdaftar",
   "XinZengDaoRu": "Diimport",
   "DDDSH": "Menunggu semakan pesanan",
   "DCWSH": "Menunggu semakan kewangan",
   "DaiChuKu": "Menunggu keluar stok",
   "DCK_BF_": "Menunggu keluar stok (separa)",
   "DFH_BF_": "Menunggu penghantaran (separa)",
   "DSH_BF_": "Menunggu penerimaan (separa)",
   "DSK_BF_": "Menunggu pembayaran (separa)",
   "WTHSQ": "Tiada permintaan pulangan",
   "THDSH": "Pulangan menunggu semakan",
   "THCLZ": "Pemprosesan pulangan",
   "THYWC": "Pulangan selesai",
   "DYDHD": "Cetak pesanan",
   "DYFHD": "Cetak invois",
   "DCDHD": "Eksport pesanan",
   "DCFHDWE_P": "Eksport sebagai Excel/PDF",
   "TuiDanZuoFei": "Pulangan dibatalkan",
   "DTHSH": "Menunggu semakan pulangan",
   "DaiRuKu": "Menunggu masuk stok",
   "DRK_BF_": "Menunggu masuk stok (separa)",
   "DFK_BF_": "Menunggu pembayaran (separa)",
   "ChuangJianTuiDan": "Buat pulangan",
   "BianJiTuiDan": "Edit pulangan",
   "TiJiaoTuiDan": "Hantar pulangan",
   "TuiHuoShenHe": "Semak pulangan",
   "RuKu": "Masuk stok",
   "RuKuShenHe": "Semak masuk stok",
   "RuKuZuoFei": "Batalkan masuk stok",
   "TianJiaFuKuan": "Tambah pembayaran",
   "FuKuanZuoFei": "Batalkan pembayaran",
   "FuKuanShenHe": "Semak pembayaran",
   "TuiDanWanCheng": "Pulangan selesai",
   "QiTaChuKu": "Keluar stok lain",
   "XiaoShouChuKu": "Keluar stok jualan",
   "PanKuiChuKu": "Keluar stok kerugian",
   "DiaoBoChuKu": "Keluar stok pindahan",
   "CaiGouTuiHuo": "Pulangan pembelian",
   "TuiHuoRuKu": "Masuk stok pulangan",
   "CaiGouRuKu": "Masuk stok pembelian",
   "QiTaRuKu": "Masuk stok lain",
   "PanYingRuKu": "Masuk stok keuntungan",
   "DiaoBoRuKu": "Masuk stok pindahan",
   "CJCGD": "Buat pesanan pembelian",
   "BJCGD": "Edit pesanan pembelian",
   "TJCGD": "Hantar pesanan pembelian",
   "CGDZF": "Batalkan pesanan pembelian",
   "CGDWC": "Pesanan pembelian selesai",
   "CGTHZF": "Batalkan pulangan pembelian",
   "CGTHWC": "Pulangan pembelian selesai",
   "THDDY": "Cetak pulangan",
   "THDDC": "Eksport pulangan",
   "CKDDY": "Cetak keluar stok",
   "CKDDC": "Eksport keluar stok",
   "GLDZH": "Akaun pentadbiran",
   "DHDZH": "Akaun pesanan",
   "ShenHeTongGuo": "Diluluskan",
   "SHBTG": "Ditolak",
   "WuXuFaPiao": "Tiada invois diperlukan",
   "DaiKeXiaDan": "Pesanan oleh ejen",
   "ZiZhuXiaDan": "Pesanan sendiri",
   "PCShangCheng": "PC Mall",
   "APPShangCheng": "APP Mall",
   "TVShangCheng": "TV Mall",
   "WeiXinShangCheng": "WeChat Mall",
   "ShouJiShangCheng": "Mobile Mall",
   "ADDXSMLTC": "Komisen keuntungan jualan",
   "ADDXSSRTC": "Komisen hasil jualan",
   "AKHSSYG": "Mengikut wakil jualan",
   "AnZhiDanRen": "Mengikut pencipta",
   "ATHJEBLKCT": "Tolak komisen berdasarkan nilai pulangan",
   "DDYTHBJXTC": "Tiada komisen untuk pesanan pulangan",
   "DaiDaKuan": "Menunggu pembayaran",
   "WeiKaiShi": "Belum bermula",
   "JinXingZhong": "Sedang berjalan",
   "YiGuoQi": "Tamat tempoh",
   //Utils.js
   "YouHuo": "Ada stok",
   "WuHuo": "Tiada stok",
   "Yi": "Bilion",
   "QianWan": "10 Juta",
   "BaiWan": "Juta",
   "Wan": "Ribu",
   "Sheng1Tian": "Tinggal 1 hari",
   "Sheng1XiaoShi": "Tinggal 1 jam",
   "Miao": "Saat",
   "1Miao": "1 saat",
   "GangGang": "Baru sahaja",
   "1FenZhongQian": "1 minit lalu",
   "1XiaoShiQian": "1 jam lalu",
   "1TianQian": "1 hari lalu",
   "1GeYueQian": "1 bulan lalu",
   "1NianQian": "1 tahun lalu",
   "WeiZhiLeiXing": "Jenis tidak diketahui",
   //WechatUtil
   "YYGBCDSP_K": "Lihat produk hebat ini!",
   "ZanWeiSheZhi": "Belum ditetapkan",
   //app
   "HQWXSQXX": "Dapatkan maklumat pengesahan WeChat",
   //flexible
   "JGJYYDMBQ": "Skala berdasarkan tag meta",
   //index
   "NLJZZ": "Memuatkan...",
   "": "routes",
   "ShangPinMingXi": "Butiran produk",
   "ShangPinLeiBie": "Kategori",
   "QXZFPNR": "Sila pilih kandungan invois",
   "QXZFPLX": "Sila pilih jenis invois",
   "QTXFPTT": "Sila masukkan tajuk invois",
   "FaPiaoTaiTou": "Tajuk invois",
   "NSRSBH": "No. Pengenalan Cukai",
   "FaPiaoNeiRong": "Kandungan invois",
   "FaPiaoXinXi": "Maklumat invois",
   "KaiJuFaPiao": "Keluarkan invois",
   "FaPiaoLeiXing": "Jenis invois",
   "Han": "Termasuk",
   "WeiHan": "Tidak termasuk",
   "Shui": "Cukai",
   "QSRFPTT": "Sila masukkan tajuk invois",
   "QSRNSRSBH": "Sila masukkan No. Pengenalan Cukai",
   //routes
   //cart-bill
   "YiManZu_Man": "Telah memenuhi [min",
   "ZaiGou": "Beli lagi",
   "YMZ_DHJJZ": "Telah memenuhi [Harga pesanan turun ke",
   "JianJiangZhi": "unit turun ke",
   "YMZ_YDHJD": "Telah memenuhi [Harga asal diskaun",
   "JianMeiJian": "unit setiap",
   "SYTCSLW0_WFJRGWC": "Stok pakej habis, tidak boleh ditambah ke troli",
   "QingXuanXeShangPin": "Sila pilih produk!",
   "GSPYXJ": "Produk ini tidak dijual lagi!",
   "ZJ2TN": "{day} hari lepas",
   "QDQCXJSP": "Sahkan padam produk tidak dijual?",
   "QingChuChengGong": "Berjaya dipadam",
   "TCSPBKJRGWC_QQXTCSPZYRGW": "Produk pakej tidak boleh ditambah ke troli!",
   "SPSLBN": "Kuantiti produk tidak boleh",
   "TaoCanHan": "Pakej termasuk",
   "TaoCan": "Pakej",
   "QHDSL": "Sahkan kuantiti",
   "SPSLBNDY": "Kuantiti produk tidak boleh kurang dari",
   "XianDingLiang": "Had pesanan",
   "YiRuShouCang": "Tambah ke kegemaran",
   "QuanXuan": "Pilih semua",
   "JianZeng": "hadiah percuma",
   "JianLiXiang_Man": "unit nikmati [min",
   "Yuan_": "RM]",
   "Zhe_": "% diskaun]",
   "KCBZ_WFJRGWC": "Stok tidak cukup, tidak boleh ditambah",
   "XDJEDYDY": "Nilai pesanan ≥",
   "WYXJHYSXDSP": "Tiada produk tidak dijual!",
   "DYQDL": "Bawah kuantiti minimum",
   "ZSPG1J": "{count} jenis produk, jumlah {number} unit",
   "WanCheng": "Selesai",
   "BianJi": "Edit",
   "You": "Ada",
   "ZSPBFHYQ_W": "jenis produk tidak memenuhi syarat",
   "SPSLBNGY": "Kuantiti produk tidak boleh melebihi",
   "JXDJ_CKXYGBFHYQSP": "Lanjutkan untuk lihat produk seterusnya",
   "XiaDan": "Buat pesanan",
   "JianJiang": "unit turun",
   "QRYCSP": "Sahkan alih keluar produk?",
   "QXZXDSP": "Sila pilih produk untuk dipesan",
   "KCBZ_QCXXZ": "Stok tidak cukup, sila pilih semula!",
   "KuCun": "Stok",
   "YCKXD": "RM diperlukan untuk pesanan",
   "QDSCSP": "Sahkan simpan produk?",
   "ShouCangChengGong": "Berjaya disimpan",
   "GYXDL": "Melebihi had pesanan",
   "LiSheng": "Jimat",
   "GWCHSKD_QGYGB": "Troli masih kosong, pergi beli-belah",
   "QuGuangGuang": "Pergi beli-belah",
   "QCXJSP": "Padam produk tidak dijual",
   "ZongE": "Jumlah",
   "YouHui": "Diskaun",
   //cart-list
   "QXZJHRQ": "Sila pilih masa penghantaran",
   "FuJiaFeiYong": "Bayaran tambahan",
   "ZhongShangPin_Gong": "jenis produk, jumlah",
   "PeiSongShiJian": "Masa penghantaran",
   "QXZPSSJ": "Sila pilih masa penghantaran",
   "DingDanJinE": "Jumlah pesanan",
   "SCFJ_ZD4Z": "Muat naik lampiran, maks 4 imej, setiap ≤3MB",
   "KeYongShangPin": "Produk tersedia",
   "ShiYongShuoMing": "Arahan penggunaan",
   "YouXiaoQi": "Tempoh sah",
   "Man": "Min",
   "BZZBZCTSFH": "Catatan tidak menyokong aksara khas",
   "QingXuanZe": "Sila pilih",
   "KaiPiaoXuJia": "Bayaran invois",
   "GeDian": "mata",
   "KPXJ1GD": "Bayaran invois {num} mata",
   "PeiSongFangShi": "Kaedah penghantaran",
   "ShangPinZongJia": "Jumlah produk",
   "YouHuiQuan": "Kupon",
   "ZhangKeXan": "boleh dipilih",
   "DDJEWMZ": "Jumlah pesanan tidak memenuhi",
   "WDYHQ": "Kupon saya",
   "KYYHQ": "Kupon tersedia",
   "YuanKeYong": "RM tersedia",
   "ChaKanDingDan": "Lihat pesanan",
   "ShangPinHanShui": "Produk termasuk cukai",
   "SPWHS": "Produk tidak termasuk cukai",
   "QueRenDingDan": "Sahkan pesanan",
   "XZSHDZ": "Tambah alamat baru",
   "ShangPinQingDan": "Senarai produk",
   "WKYYHQ": "Tiada kupon tersedia",
   "HuChi": "Eksklusif",
   "DaiJinQuan": "Voucher",
   "YunFei": "Kos penghantaran",
   "ShuiFei": "Cukai",
   "BKYYY": "Sebab tidak tersedia",
   "YHQYGQ": "Kupon tamat tempoh",
   "WDYHQSYSJ": "Belum sampai masa penggunaan",
   "ZDSPJEWMZ": "Nilai produk tidak memenuhi",
   "BKYYHQ": "Kupon tidak tersedia",
   "YMZ_MYZJ_": "Telah memenuhi [min {m}RM hadiah {n}unit]",
   "YMZ_MZ": "Telah memenuhi [min {m}RM hadiah {n}]",
   "ZG222YX_M1000": "Beli lagi {money}RM nikmati [min {target}RM hadiah {num}unit]",
   "ZG2JX_MZ": "Beli lagi {num}unit nikmati [min {target}RM hadiah {present}]",
   "YMZ_MYJY_": "Telah memenuhi [min {m}RM jimat {n}RM]",
   "ZGYX_MYJY_": "Beli lagi {m}RM nikmati [min {n}RM jimat {o}RM]",
   "YMZ_MYZ_": "Telah memenuhi [min {m}RM {n}% diskaun]",
   "ZGYX_MYZ_": "Beli lagi {m}RM nikmati [min {n}RM {o}% diskaun]",
   //cart-presale-order
   "QXZPSFS": "Sila pilih kaedah penghantaran",
   "1ZSP_G": "1 jenis produk, jumlah",
   "YSSP_YJ": "Pra-pesanan, dijangkakan",
   "JiaoHuoRiQi": "Tarikh penghantaran",
   "GMJLY": "Tinggalkan mesej",
   //scan-to-cart
   "ZhengZaiChuLi...": "Memproses...",
   "FSCSP": "Bukan produk kedai",
   "ZZCLTXM": "Memproses kod bar...",
   "SPTJCG": "Produk berjaya ditambah",
   "QSTXM": "Sila imbas kod bar",
   "SFSCDQSP": "Padam produk semasa?",
   "BQ_ZBDXGSP": "Maaf, produk tidak dijumpai",
   "XuanZeDanWei": "Pilih unit",
   "JRGWC": "Tambah ke troli",
   "QXXZDJRSP": "Sila pilih produk terlebih dahulu",
   "ZhengZaiChuLi": "Memproses",
   "JRGWCCG": "Berjaya ditambah ke troli",
   "ZanWuShangPin": "Tiada produk",
   //earn-brokerage-share
   "XTYJBNFZSP": "Sistem telah menyalin pautan produk!",
   "NKYHDDYDYJ": "Anda dapat komisen. Lihat dalam \"Saya",
   "LiChaKan": "\"",
   "WeiXinHaoYou": "Rakan WeChat",
   "ErWeiMa": "Kod QR",
   "CASBEWM": "Imbas kod QR",
   "FZSB_QCXFZ": "Salin gagal, cuba lagi!",
   "TWEWM": "Kod QR teks+imej",
   "BCDXC": "Simpan ke galeri",
   "CATPBCDXC": "Tekan lama untuk simpan",
   "FuZhiLianJie": "Salin pautan",
   "FXZYJ": "Kongsi dapat komisen",
   "YJZGKZQYJ": "Anggaran komisen maksimum",
   "PYTGNFXDYMCGGMH": "Apabila rakan beli melalui pautan anda, anda dapat komisen",
   //goods-share
   "FXSPGLSKH": "Kongsi produk dengan pelanggan",
   "FXHJSCNZSD": "Kongsi untuk buat kedai mudah alih peribadi",
   "WSCDQJG_ND": "Harga kedai mudah alih: Harga anda ×",
   "DaiSheZhi": "Belum ditetapkan",
   "PengYouQuan": "Moment",
   "GGFXSZ": "Ubah tetapan kongsi",
   //wechat-login
   "QXSRZH": "Sila masukkan akaun",
   "MMGSCW_6_20W": "Format kata laluan salah (6-20 aksara)",
   "BDYYZH": "Ikut akaun sedia ada",
   "WXKJDL": "Log masuk pantas WeChat",
   "BangDingZhangHao": "Ikut akaun",
   "YYZH_QDL": "Ada akaun? Log masuk",
   "ZCXZH": "Daftar akaun baru",
   "HuanYingNi": "Selamat datang",
   "ZH_SJHM": "Akaun/No. telefon",
   "MiMa": "Kata laluan",
   "QDLHCZ": "Sila log masuk untuk operasi",
   //add-to-cart
   "KCBZ_BNTJG": "Stok tidak cukup, tidak boleh tambah lagi",
   //combined-pay-online
   "ZhiFuChengGong": "Pembayaran berjaya!",
   "ZFSB_QCXCS": "Pembayaran gagal, cuba lagi!",
   "QXXZGG": "Sila pilih spesifikasi dahulu",
   "SXGGX": "Spesifikasi pilihan perlu",
   "GMSLXYQDL_": "Kuantiti bawah minimum, sila beli semula!",
   "GMSLDYXDL_": "Kuantiti melebihi had, sila beli semula!",
   "ShangPinBianHao": "No. produk",
   "QiDing": "Minimum",
   "SXGGDGSLBK": "Kuantiti tidak boleh melebihi",
   "KCBZ_BNTJ": "Stok tidak cukup, tidak boleh tambah",
   "QXXZSP": "Sila pilih produk dahulu",
   "SLBNW0": "Kuantiti tidak boleh 0",
   "QXZGG": "Sila pilih spesifikasi",
   "LiJiYuDing": "Pra-pesanan segera",
   //nav
   "ShouYe": "Laman utama",
   "ShangPin": "Produk",
   "DingDan": "Pesanan",
   "WoDe": "Saya",
   //pay-online
   "ZhiFuQuXiao": "Pembayaran dibatalkan",
   //account-log
   "ShangPinYongJin": "Komisen produk",
   "YaoQingJiangLi": "Hadiah jemputan",
   "TiXian": "Keluarkan",
   "TiXianBoHui": "Keluaran ditolak",
   "ZhuanWeiYuE": "Tukar ke baki",
   "Jin7Tian": "7 hari lepas",
   "Jin30Tian": "30 hari lepas",
   "ShouZhiMingXi": "Butiran transaksi",
   "ZanWuShuJu": "Tiada data",
   //client-statistics
   "WoDeKeHu": "Pelanggan saya",
   "WoDeYaoQing": "Jemputan saya",
   //distribution-home
   "LeiJiKeHu": "Jumlah pelanggan",
   "LeiJiDingDan": "Jumlah pesanan",
   "YaoQingHaoYou": "Jemput rakan",
   "LeiJiYaoQing": "Jumlah jemputan",
   "LJSY_Y_": "Jumlah pendapatan (RM)",
   "BHDJS": "Termasuk menunggu penyelesaian",
   "J7TSY_Y_": "Pendapatan 7 hari (RM)",
   "J7TXZKH_R_": "Pelanggan baru 7 hari (orang)",
   "KTXYJ": "Komisen boleh dikeluarkan",
   "XYJYO": "Perlu usaha lagi",
   "ChangJianWenTi": "Soalan lazim",
   "Q_ZMYJX_TG": "Q: Bagaimana \"promosi dapat komisen\"",
   "A_FXDPND_Z_": "A: Kongsi pautan dengan ikon \"dapat\"",
   "Q_RHJS_TGZ": "Q: Bagaimana komisen dikira?",
   "A_MGD_Z_TBD": "A: Setiap produk ada kadar komisen",
   "Q_TGZQ_DSY": "Q: Bila komisen diterima?",
   "A_HYTGNDFX": "A: Selepas pelanggan sahkan penerimaan",
   "Q_LJKH_LJY": "Q: Mengapa tiada avatar?",
   "A_WXYQZYGZ": "A: Perlu ikuti akaun perkhidmatan",
   "Q_WSMWASSG": "Q: Mengapa tiada komisen?",
   "A_1_HYKNBW": "A：1、好友可能并未与你建立客户关系（好友点击了其他销售员的链接进行注册或下单了）2、好友若在微信环境外（如手机默认浏览器）打开你的分享链接，若浏览器未开启cookie，也将无法记录客户关系，即无法记录推广订单3、上述都没问题时仍然没有记录推广订单，请联系工作人员",
   "XiaoShouZhongXin": "Pusat jualan",
   //generalize-goods
   "SPMC_GG_BH": "Nama produk / Spesifikasi / No.",
   "YuJiZhuan": "Anggaran komisen",
   //invitation-home
   "YaoQingKa": "Kad jemputan",
   "YNYQJR_TGY": "Jemput sertai, promosi dapat hadiah",
   "DJBCDXC": "Klik simpan ke galeri",
   "JYQKFSGHY_": "Kongsi kad dengan rakan",
   //join-home
   "HuanYingJiaRu": "Selamat menyertai",
   "YQNCW": "Jemput anda menjadi",
   "LiJiJiaRu": "Sertai segera",
   //order-statistics
   "YuJiYongJin": "Anggaran komisen",
   "YongJin": "Komisen",
   "YuJiJiangLi": "Anggaran hadiah",
   "JiangLi": "Hadiah",
   "SPTGDD": "Pesanan promosi produk",
   "YQJLDD": "Pesanan hadiah jemputan",
   //performance-statistics
   "YeJiTongJi": "Statistik prestasi",
   "LJKH_R_": "Jumlah pelanggan (orang)",
   "SPYJ_Y_": "Komisen produk (RM)",
   "HanDaiJieSuan": "Termasuk menunggu penyelesaian",
   "XGMCJS": "Takrifan istilah",
   "KeHu": "Pelanggan",
   "HFXYBDLKHG": "Pelanggan yang dihubungkan",
   "YaoQing": "Jemputan",
   "FXYCGYQDXJ": "Ejen jemputan berjaya",
   "FXYTJKHGMH": "Komisen dari pelanggan jemputan",
   "XJFXYTGSPH": "Hadiah dari ejen jemputan",
   //posters-promoting
   "NiCheng": "Nama samaran",
   "HaiBaoTuiGuang": "Poster promosi",
   "JHBFSGHY_T": "Kongsi poster dengan rakan",
   //settlement-home
   "JieSuanZhongXin": "Pusat penyelesaian",
   "KTXJE": "Jumlah boleh dikeluarkan",
   "TiXianJiLu": "Rekod pengeluaran",
   //withdraw-account
   "KHRXMBNWK": "Nama pemegang akaun diperlukan!",
   "KHHBNWK": "Bank diperlukan!",
   "YHKHBNWK": "No. akaun diperlukan!",
   "SFZTPBNWK": "Gambar kad pengenalan diperlukan!",
   "YHKTPBNWK": "Gambar kad bank diperlukan!",
   "BaoCunChengGong": "Berjaya disimpan!",
   "SCSFZ": "Muat naik kad pengenalan",
   "SCYHK": "Muat naik kad bank",
   "BaoCun": "Simpan",
   "TiXianZhangHu": "Akaun pengeluaran",
   "TS_QTXZSXX": "Sila beri maklumat sebenar",
   "KHRXM": "Nama pemegang akaun",
   "KaiHuHang": "Bank",
   "YinhangKaHao": "No. akaun",
   "QSRZSXM": "Sila masukkan nama sebenar",
   "QSRKHHMC": "Sila masukkan nama bank",
   "QSRYHKH": "Sila masukkan no. akaun",
   //withdraw-deposit
   "QXSZTXZH": "Sila tetapkan akaun pengeluaran dahulu",
   "QuSheZhi": "Tetapkan",
   "JEXY10Y_BKT": "Jumlah bawah RM10, tidak boleh dikeluarkan!",
   "JECGKTXJE": "Jumlah melebihi had pengeluaran!",
   "CGDRKTXSX_": "Melebihi had harian (RM20000)!",
   "QueDingJiang": "Sahkan tukar",
   "ZhuanDaoYuE": "ke baki?",
   "_JEDY10YSB": "1. Jumlah bawah RM10 tidak boleh dikeluarkan",
   "_BCTXDZSJ": "2. Masa terima: 5 hari bekerja",
   "_GBSRWHSS": "3. Pendapatan ini termasuk cukai",
   "_ZDYEKYYS": "4. Baki boleh digunakan untuk beli-belah",
   "TXSQCG_QDD": "Permohonan pengeluaran berjaya, tunggu semakan",
   "JEDYKTXJE_": "Jumlah melebihi baki, tidak boleh tukar!",
   "ZZYECG_QDG": "Tukar ke baki berjaya, lihat dalam profil",
   "BenCiTiXian": "Pengeluaran ini",
   "ZhuangDaoYuE": "Tukar ke baki",
   "TiXianDao": "Keluarkan ke",
   "JEW0BKZZYE": "Jumlah 0 tidak boleh tukar",
   "DRTXSX2WY": "Had harian RM20000",
   "QuanBuTiXian": "Keluarkan semua",
   "QueRenTiXian": "Sahkan pengeluaran",
   //goods-filter-tab
   "ZuiChangGouMai": "Kerap dibeli",
   "MoRenPaiXu": "Susunan lalai",
   "ZongHe": "Keseluruhan",
   "FenLei": "Kategori",
   "XiaoLiangYouXian": "Keutamaan jualan",
   "XiaoLiang": "Jualan",
   "JiaGe": "Harga",
   "ShaiXuan": "Tapis",
   "ZuiJinGouMai": "Beli-belah terkini",
   "CuXiaoYouXian": "Keutamaan promosi",
   "QuanBuFenLei": "Semua kategori",
   "ZhiKanCuXiao": "Hanya promosi",
   "XuanZeFenLei": "Pilih kategori",
   "QXZFL": "Sila pilih kategori",
   //goods-list-default
   "ZWXGSP": "Tiada produk berkaitan",
   //goods-brand-list
   "PinPaiHui": "Jenama",
   //goods-classify-filter
   "TuiJianFenLei": "Kategori disyorkan",
   "ShangPinFenLei": "Kategori produk",
   "GengDuo": "Lagi",
   //goods-detail
   "DLZHBSDQQY": "Akaun bukan pelanggan syarikat semasa",
   "GXNHQ": "Tahniah, anda dapat",
   "SZWSCJGH_C": "Tetapkan harga sebelum kongsi",
   "JHDJSHS_": "Baki masa:",
   "DLHKFX": "Log masuk untuk kongsi",
   "ZZHQXX_QSH": "Sedang mendapatkan maklumat",
   "Zhang": "keping",
   "Tian": "hari",
   "QXZGGZQPD": "Sila pilih spesifikasi dahulu",
   "Yuan": "RM",
   "XS_F_M": "jam/minit/saat",
   //integral
   "WoDeJiFen": "Mata ganjaran saya",
   "DaBaiLe": "Lebih baik daripada",
   "JiFen": "mata",
   "DeHuiYuan": "ahli",
   "ZhuanJiFen": "Dapatkan mata",
   "JiFenMingXi": "Butiran mata",
   "HuanLiPin": "Tukar hadiah",
   "CKGDHL": "Lihat lebih banyak hadiah",
   "ChaDingDan": "Semak pesanan",
   //integral-convert
   "DHSLBNCG": "Kuantiti penukaran tidak boleh melebihi",
   "DuiHuanShuLiang": "Kuantiti penukaran",
   "SuoXuJiFen": "Mata diperlukan",
   //integral-detail
   "LiPinXiangQing": "Butiran hadiah",
   "WoYaoDuiHuan": "Saya nak tukar",
   "ShengYu": "Baki",
   "TuWenXiangQing": "Butiran",
   "Jian": "unit",
   "YiDuiWan": "Habis",
   //integral-filter
   "FenLeiShaiXuan": "Tapis kategori",
   "JiFenShaiXuan": "Tapis mata",
   //integral-flow
   "JiFenShouRu": "Masuk mata",
   "JiFenZhiChu": "Keluar mata",
   //integral-logistics
   "DingDanGenZong": "Jejak pesanan",
   "WuLiuGongSi": "Syarikat logistik",
   "WuLiuDanHao": "No. resit",
   //integral-order
   "DingDanLieBiao": "Senarai pesanan",
   "YiFaHuo": "Telah dihantar",
   "JiFenDingDan": "Pesanan mata",
   "ChaKanWuLiu": "Lihat logistik",
   //integral-order-create
   "LPSLBZ_QCX": "Stok hadiah tidak cukup",
   "JiFenBuZu": "Mata tidak cukup",
   "ZhiFuXinXi": "Maklumat pembayaran",
   "JiXuGuangGuang": "Terus beli-belah",
   "QTXSHXX": "Sila isi maklumat penerimaan",
   "DuiHuanChengGong": "Penukaran berjaya",
   "LPDHQR": "Pengesahan penukaran hadiah",
   "SCCKJ": "Harga rujukan",
   "LiJiZhiFu": "Bayar segera",
   //integral-order-detail
   "DingDanXiangQing": "Butiran pesanan",
   "DingDanZhuangTai": "Status pesanan",
   "DingDanBianHao": "No. pesanan",
   "DuiHuanShiJian": "Masa penukaran",
   "ShouHuoXinXi": "Maklumat penerimaan",
   "HuaFeiJiFen": "Mata digunakan",
   //integral-rule
   "QDZJF": "Daftar masuk dapat mata",
   "XDZJF": "Buat pesanan dapat mata",
   "1_MRQD_JL": "1. Daftar masuk harian: +{num} mata",
   "2_LXQD3T_EW": "2. 3 hari berturut: +{num} mata",
   "3_LXQD7T_EW": "3. 7 hari berturut: +{num} mata",
   "DLZJF": "Log masuk dapat mata",
   "MRDLYSDHSC": "Log masuk harian: +{num} mata",
   "DDWCHKHDYD": "Lengkapkan pesanan: Mata = Nilai pesanan × {num}",
   //integral-rule-detail
   "GuiZe": "Peraturan",
   //integral-sign
   "QianDaoYouLi": "Daftar masuk dapat hadiah",
   "QianDaoGuiZe": "Peraturan daftar masuk",
   "YLXQD": "Daftar masuk berturut",
   "YLXQD1T": "Daftar masuk {num} hari",
   "QDCG_NYJLX": "Berjaya! Daftar masuk {num} hari",
   "QDCG_BCHD1": "Berjaya! Dapat {num} mata",
   "BCQDHD4JF_": "Dapat {num} mata, hebat!",
   "QSRBZ": "Sila masukkan catatan",
   "DingDanZengPin": "Hadiah pesanan",
   "GuiGeBianHao": "No. spesifikasi",
   "GuiGe": "Spesifikasi",
   //combined-pay
   "CDDWXFK": "Pesanan ini tidak perlu bayaran",
   "YHYEBZ": "Baki pengguna tidak cukup!",
   "ZFJEBNW0": "Jumlah pembayaran tidak boleh 0!",
   "ZFJEBNDYDD": "Jumlah melebihi tunggakan",
   "DFKJE": "Jumlah tunggakan",
   "FuKuanFangShi": "Kaedah pembayaran",
   "FuJian": "Lampiran",
   "ZHYFZ": "Akaun disalin",
   "GHSKZH": "Tukar akaun penerima",
   "SYXXZFQSCF": "Muat naik bukti pembayaran untuk pengesahan",
   "XXZF_BXXZS": "Pilih akaun penerima untuk pembayaran offline",
   "DingDanZhiFu": "Pembayaran pesanan",
   "ZFFS_HDFK": "Kaedah: Bayar upon delivery",
   "BCFKJE": "Jumlah pembayaran ini",
   "YuE": "Baki",
   "FuZhiZhangHao": "Salin akaun",
   "WSZXCXZFPZ": "Konfigurasi pembayaran tidak ditetapkan",
   "XCXZFZHJY": "Akaun pembayaran dinyahaktifkan",
   "SRZFJE": "Masukkan jumlah pembayaran",
   "FuKuanZhangHu": "Akaun pembayaran",
   "QueRenZhiFu": "Sahkan pembayaran",
   "ShaoHouZhiFu": "Bayar kemudian",
   //order
   "FKJLYTJ_DD": "Rekod pembayaran ditambah, tunggu semakan",
   "JiXuGuang": "Terus beli-belah",
   "BenCiFuKuan": "Pembayaran ini",
   "FuKuanChengGong": "Pembayaran berjaya",
   "ZhiFuFangShi": "Kaedah pembayaran",
   "ZhiFuDingDan": "Bayar pesanan",
   //order-batch-pay
   "QXXZSXZFDD": "Sila pilih pesanan untuk dibayar",
   "PiLiangFuKuan": "Pembayaran pukal",
   "FuKuan": "Bayar",
   "QuFuKuan": "Pergi bayar",
   //order-create-result
   "YingFuJinE": "Jumlah perlu bayar",
   "XiaDanShiJian": "Masa pesanan",
   //order-deliver
   "SFQRSH": "Sahkan penerimaan?",
   "DDQRSH": "Sahkan penerimaan pesanan",
   "DFHSP": "Produk menunggu penghantaran",
   "ShangPinShuLiang": "Bilangan produk",
   "ChuKuShiJian": "Masa keluar stok",
   "FaHuoShiJian": "Masa penghantaran",
   "WuLiuBeiZhu": "Catatan logistik",
   "QueRenShouHuo": "Sahkan penerimaan",
   "RYFK_QJSYG": "Hubungi admin jika sudah bayar",
   "QSRQXYY": "Sila masukkan sebab pembatalan",
   "H_DDJZDGB_QJKF": "Pesanan akan dibatalkan secara automatik",
   "TuiHuoQingKuang": "Status pulangan",
   "DingDanZongE": "Jumlah pesanan",
   "DingDanBeiZhu": "Catatan pesanan",
   "FaHuoQingKuang": "Status penghantaran",
   "DingDanFuJian": "Lampiran pesanan",
   "ShenQingTuiHuo": "Mohon pulangan",
   "G1TDSHJL_QRS": "Sahkan penerimaan {num} pesanan?",
   "DaiXiaDan": "Pesanan oleh ejen",
   "DingDanHao": "No. pesanan",
   "XiaDanFangShi": "Kaedah pesanan",
   "TuiHuoDan": "Pulangan",
   "ShangPinZongE": "Jumlah produk",
   "YunFei_ZongZhong": "Kos penghantaran (berat",
   "SF_SPWS": "Cukai (produk belum cukai",
   "TePiJia": "Harga khas",
   "FuKuanQingKuang": "Status pembayaran",
   "TiaoJiLu": "rekod",
   "ZaiLaiYiDan": "Buat pesanan sama",
   "MuLiuXinXi": "Maklumat logistik",
   "QDSCGDD_": "Sahkan padam pesanan?",
   "YiQueRen": "Telah disahkan",
   "YiShouHuo": "Telah diterima",
   "DaiFuJinE": "Jumlah tunggakan",
   "YiFuJinE": "Jumlah telah bayar",
   "ZanWuJiLu": "Tiada rekod",
   "SPMC_DDH": "Nama produk / No. pesanan",
   "FuKuanZhuangTai": "Status pembayaran",
   "FaHuoZhuangTai": "Status penghantaran",
   "QiShiShiJian": "Masa mula",
   "ZhongZhiShiJian": "Masa tamat",
   //order-list
   "CaoZuoChengGong": "Operasi berjaya",
   "ZBKGM": "Tidak boleh beli sekarang",
   "DQDDSPYXJ": "Produk dalam pesanan tidak dijual",
   "DQDDBFSPYXJ": "Sebahagian produk tidak dijual",
   "JTJSJSP": "Hanya tambah produk tersedia",
   "DingHuoDan": "Pesanan pembelian",
   //order-log
   "DingDanRiZhi": "Log pesanan",
   //order-logistics
   "FuZhiChengGong": "Salin berjaya",
   "FuZhiShiBai": "Salin gagal",
   "FuZhi": "Salin",
   "BoDa": "Dail",
   "WCWLDHXX": "Tiada maklumat logistik",
   //order-pay
   "ZFCS_QCXXD": "Masa pembayaran tamat, sila buat pesanan baru",
   "YQYYCKZF": "Pembayaran deposit diaktifkan",
   "BNDYDFKJE": "Tidak boleh melebihi tunggakan",
   "ZFJEBNWK": "Jumlah pembayaran diperlukan",
   "QXAPFK_FKH": "Sediakan bukti pembayaran untuk pengesahan",
   "DDTJCG_QJS": "Pesanan berjaya, sila bayar segera",
   "QXZFKFS": "Sila pilih kaedah pembayaran",
   "SYYEZFH_HX": "Selepas bayar dengan baki, perlu bayar lagi",
   "FuKuanJiLu": "Rekod pembayaran",
   "ZWFKJL": "Tiada rekod pembayaran",
   "FuKuanXiangQing": "Butiran pembayaran",
   "FuKuanJinE": "Jumlah pembayaran",
   "ZhiDan": "Dibuat oleh",
   "ShenHe": "Semak",
   "ZuoFei": "Batal",
   "ZuoFeiYuanYin": "Sebab pembatalan",
   "GLDHD": "Pesanan berkaitan",
   "HeXiaoJinE": "Jumlah disahkan",
   "HeXiaoZhuangTai": "Status pengesahan",
   "DanJuZhuangTai": "Status dokumen",
   "KeHuMingCheng": "Nama pelanggan",
   "ZhangDanHao": "No. bil",
   "ShouKuanZhangHao": "Akaun penerima",
   "ShouKuanShiJian": "Masa penerimaan",
   "FuKuanPingZheng": "Bukti pembayaran",
   "GeFuJian": "lampiran",
   //order-statistics
   "DingDanTongJi": "Statistik pesanan",
   "DingHuo0Bi": "{num} pesanan",
   //order-statistics-detail
   "DDTJMX": "Butiran statistik",
   "AGGTJ": "Mengikut spesifikasi",
   "AFLTJ": "Mengikut kategori",
   "DDJE_Y": "Jumlah pesanan/RM",
   "DHSP_Z": "Produk pesanan/jenis",
   "DingHuoDan_Bi": "Pesanan/bil",
   "DingHuoShangPin": "Produk pesanan",
   "JinE": "Jumlah",
   //refund-list
   "TuiHuo": "Pulangan",
   //refund-apply
   "THDHWBC_QD": "Pulangan belum disimpan, keluar?",
   "QSRSQTHJE": "Sila masukkan jumlah pulangan",
   "QSRTHJE": "Sila masukkan jumlah pulangan",
   "QSRBZXX": "Sila masukkan catatan",
   "YingTuiJinE": "Jumlah patut dipulangkan",
   "TJTHSQ": "Hantar permohonan pulangan",
   "QXXZDHQD": "Sila pilih senarai pesanan",
   "DingHuoQingDan": "Senarai pesanan",
   "SQTHJE": "Jumlah permohonan pulangan",
   "DJXZSP": "Klik pilih produk",
   "TuiHuoJinE": "Jumlah pulangan",
   //refund-detail
   "THDDXQ": "Butiran pulangan",
   "YiTuiHuo": "Telah dipulangkan",
   "YiTuiKuan": "Telah dibayar balik",
   "THDZT": "Status pulangan",
   "TuiHuoDanHao": "No. pulangan",
   "TuiHuoShiJian": "Masa pulangan",
   "TuiHuoCangKu": "Gudang pulangan",
   "THLXR": "Orang hubungan pulangan",
   "TuiHuoQingDan": "Senarai pulangan",
   "TuiKuanZongE": "Jumlah bayaran balik",
   "TuiKuanQingKuang": "Status bayaran balik",
   "DaiTuiJinE": "Jumlah tunggakan",
   "YiTuiJinE": "Jumlah telah dibayar balik",
   //refund-product
   "SPMC_BH_GG": "Nama produk / No. / Spesifikasi / Kod bar",
   "GZD1TJG": "1 keputusan dijumpai",
   "JiaRuQingDan": "Tambah ke senarai",
   //refund-result
   "ShenQingChengGong": "Permohonan berjaya",
   "THDTJCG": "Pulangan berjaya dihantar",
   "ChaKanXiangQing": "Lihat butiran",
   //goods-package-floor
   "HDWKS_WDZL": "Aktiviti belum bermula",
   "HDYJS_XCZD": "Aktiviti tamat",
   "ZWSZBT": "Tiada tajuk",
   "ChaKanGengDuo": "Lihat lagi",
   //goods-promotion-floor
   "HCDZSJC": "Perbezaan masa disebabkan cache",
   "DLCKCXJ": "Log masuk untuk lihat harga promosi",
   "ZWSZCX": "Tiada promosi",
   "JuKaiShi": "Sebelum bermula",
   "Song": "Hadiah",
   "JuJieShu": "Sebelum tamat",
   "YiJieShu": "Telah tamat",
   //search-floor
   "XiaoXi": "Mesej",
   "SaoMaXiaDan": "Pesan dengan imbas",
   //home-page-custom
   "WZLCSJ": "Data tidak diketahui",
   //jump-error
   "QXZYSDHAPP": "Muat turun APP YUNSHANG",
   "QMTYQYGLD": "Pengalaman penuh pengurusan",
   "XZYSDHAPP": "Muat turun APP YUNSHANG",
   "HQGLDWZTY": "Dapatkan pengalaman penuh",
   "JXTYDHD": "Teruskan dengan pesanan",
   //notice-detail
   "GongGaoXiangQing": "Butiran pengumuman",
   "GongGaoFuJian": "Lampiran pengumuman",
   //shop-error
   "NFWDYMBCZO": "Halaman tidak dijumpai",
   "KeNengYuanYin": "Sebab mungkin",
   "1_ZDZLSRCWD": "1. URL salah",
   "2_DJLGQLJ": "2. Pautan tamat tempoh",
   //shop-index
   "GuanLiDuan": "Pentadbiran",
   "ZhuCe": "Daftar",
   "HYNTYYSDH": "Selamat datang ke YUNSHANG",
   "TYZHSJHDQG": "Data akaun percubaan akan dikemas kini",
   "TYZHZDNRSJ": "Data dalam akaun percubaan adalah simulasi",
   "ZHZCCG": "Pendaftaran berjaya",
   "DengLuZhangHao": "Akaun log masuk",
   "CSMMW": "Kata laluan lalai",
   "GNFYHQL": "Anda dapat kupon",
   "Man1YuanKeYong": "Min {num}RM boleh digunakan",
   "LQH1TNKY": "Sah {day} hari",
   "YiJianLingQu": "Dapatkan segera",
   "GXNHD1ZYHQ": "Tahniah, anda dapat {num} kupon {price}RM {name}",
   "Gong1Yuan": "Jumlah {num}RM",
   "LiJiShiYong": "Guna segera",
   //shop-login
   "NHWDL": "Anda belum log masuk",
   //shop-notice
   "ShangChengGongGao": "Pengumuman kedai",
   "ZanWuGongGao": "Tiada pengumuman",
   "1GeFuJian": "{num} lampiran",
   //deposit-detail
   "KouKuan": "Debit",
   "ChongZhi_Kuan": "Isi semula",
   "KouKuanZuoFei": "Debit dibatalkan",
   "ChongZhiZuoFei": "Isi semula dibatalkan",
   "ZhangHuMingXi": "Butiran akaun",
   "ZhangHuYuE": "Baki akaun",
   "LiJiChongZhi": "Isi semula segera",
   //deposit-recharge
   "CZJEBNXY1Y": "Jumlah isi semula minimum RM1",
   "QSRZQDSZ": "Sila masukkan nilai sah",
   "ZDYJE": "Jumlah tersuai",
   "ZWKTXSCZGN": "Isi semula online tidak tersedia",
   "ShiFuJinE": "Jumlah sebenar",
   "ZhangHuChongZhi": "Isi semula akaun",
   "QXZCZJE": "Pilih jumlah isi semula",
   "QSRCZJE": "Masukkan jumlah isi semula",
   "QLXNDZSYWY": "Hubungi wakil jualan",
   "ShouJia": "Harga jualan",
   "YiShouQing": "Habis dijual",
   "ChongZhiJinE": "Jumlah isi semula",
   "QueRenFuKuan": "Sahkan pembayaran",
   //deposit-recharge-result
   "QSDDID": "Tiada ID pesanan",
   "ChongZhiChengGong": "Isi semula berjaya",
   "ChongZhiShiBai": "Isi semula gagal",
   "CLZ_QSH...": "Memproses, sila tunggu...",
   "ChongZhiFangShi": "Kaedah isi semula",
   "ChongZhiShiJian": "Masa isi semula",
   "JYLSH": "No. transaksi",
   "FanHuiShangCheng": "Kembali ke kedai",
   //recharge-online
   "ZFSB_QCS": "Pembayaran gagal, cuba lagi",
   "ZFYQX": "Pembayaran dibatalkan",
   "ZFYC_QCS": "Ralat pembayaran, cuba lagi",
   //user
   "LingQuanZhongXin": "Pusat kupon",
   "WeiShiYong": "Belum digunakan",
   "YiShiYong": "Telah digunakan",
   "ZWYHQ": "Tiada kupon",
   //keep-list
   "YiGouMai": "Telah dibeli",
   "ChangYongQingDan": "Senarai kerap",
   "WoDeShouCang": "Kegemaran saya",
   "QuGouWuChe": "Ke troli",
   "GeShangPin": "produk",
   //login
   "YunShangDingHuo": "YUNSHANG",
   "QSRZH": "Sila masukkan akaun!",
   "QSRMM": "Sila masukkan kata laluan!",
   "QSRDLZH": "Sila masukkan akaun log masuk",
   "JiZhuMiMa": "Ingat kata laluan",
   "WangJiMiMa": "Lupa kata laluan?",
   "DengLu": "Log masuk",
   "DLZHBCZ_QL": "Akaun tidak wujud, hubungi admin",
   "GQYZHSBJY_": "Akaun syarikat dinyahaktifkan",
   "GQYZHSYQJS_": "Tempoh percubaan tamat",
   "GQYZHYGQL_": "Akaun tamat tempoh, perlu diperbaharui",
   "LiJiTiYan": "Cuba sekarang",
   //my-collect
   "YiChuChengGong": "Alih keluar berjaya",
   "QueHuo": "Stok habis",
   "YCSCJ": "Alih keluar dari kegemaran",
   //order-message
   "SheZhiChengGong": "Tetapan berjaya",
   "ZWWDXX": "Tiada mesej belum baca",
   "QuanBuYiDu": "Tanda semua sebagai dibaca",
   "DingDanXiaoXi": "Mesej pesanan",
   "YiQiang": "Telah diambil",
   "LiJiLingQu": "Dapatkan segera",
   "LingQuanHou": "Selepas menerima kupon",
   "TianNeiKeYong": "boleh digunakan dalam {n} hari",
   "QSRSJH": "Masukkan nombor telefon",
   "QSRYZM": "Masukkan kod pengesahan",
   "QSRXMM": "Masukkan kata laluan baru",
   "QSRZQSJGS": "Masukkan format telefon yang betul",
   "ChongZhiMiMa": "Tetapkan semula kata laluan",
   "QSRNDSJHM": "Masukkan nombor telefon anda",
   "QSRDXYZ": "Masukkan kod SMS",
   "HQYZM": "Dapatkan kod",
   "HKCXHQ": "Hantar semula dalam {n}",
   "QSR6_20WSZHZ": "Kata laluan: 6-20 aksara (nombor/huruf)",
   //share-setting
   "QSRSPJGBL": "Sila masukkan nisbah harga produk",
   "SPJGBLBXDY": "Nisbah mesti antara 100-999.99",
   "DPMCZBZCTS": "Nama kedai tidak menyokong aksara khas",
   "LXRZBZCTSF": "Nama hubungan tidak menyokong aksara khas",
   "LXFSZBZCTS": "Maklumat hubungan tidak menyokong aksara khas",
   "LXDZZBZCTS": "Alamat tidak menyokong aksara khas",
   "DPJJZBZCTS": "Penerangan kedai tidak menyokong aksara khas",
   "QSRDPJJ_ZD": "Sila masukkan penerangan kedai (maks 50 aksara)",
   "FenXiangSheZhi": "Tetapan kongsi",
   "NDWSCSPJG": "Harga produk anda",
   "NDDHJ_": "Harga pesanan anda ×",
   "LXXX_KBJ_": "Maklumat hubungan (boleh diedit)",
   "DianPuMingCheng": "Nama kedai",
   "JianJie": "Pengenalan",
   "QSRDPMC": "Sila masukkan nama kedai",
   "LianXiRen": "Orang hubungan",
   "QSRLXR": "Sila masukkan nama orang hubungan",
   "LianXiFangShi": "Cara hubungan",
   "QSRLXFS": "Sila masukkan maklumat hubungan",
   "LianXiDiZhi": "Alamat hubungan",
   "QSRLXDZ": "Sila masukkan alamat hubungan",
   //user
   "WoDeDingDan": "Pesanan saya",
   "ZuiJinLiuLan": "Baru dilihat",
   "ShouCangShangPin": "Produk disimpan",
   "BDYYZH_ZC": "Ikut akaun sedia ada | Daftar akaun baru",
   "DL_ZC": "Log Masuk | Daftar",
   "BangDingShouJi": "Ikat nombor telefon",
   "TS_BDSJHM_": "Petua: Ikat nombor telefon untuk keselamatan akaun!",
   "ChaKanQuanBu": "Lihat semua",
   "ShouHuoDiZhi": "Alamat penghantaran",
   "LianXiWoMen": "Hubungi kami",
   "SheZhi": "Tetapan",
   "QuQianDao": "Pergi daftar masuk",
   "QianDao": "Daftar masuk",
   "JiFenShangCheng": "Kedai mata ganjaran",
   "TuiGuangShangPin": "Promosi produk",
   "QuChaKan": "Pergi lihat",
   "JiFenHuanLi": "Tukar mata ganjaran",
   "DYSPBQ": "Cetak label produk",
   //user-about
   "GYYSDH": "Mengenai YUNSHANG",
   "YQHYSMEWM_": "Jemput rakan imbas kod QR untuk muat turun",
   "DangQianBanBen": "Versi semasa",
   //user-address
   "ZWSHDZ": "Tiada alamat penghantaran",
   "WoDeDiZhi": "Alamat saya",
   "ZhiNengShiBie": "Pengecaman pintar",
   "ZTDZXXKZNS": "Tampal maklumat alamat untuk pengecaman automatik",
   "MoRen": "Lalai",
   "QRSCDZ": "Sahkan padam alamat?",
   "SHRXM": "Nama penerima",
   "SJHMHGDDHZ": "Nombor telefon atau talian tetap diperlukan",
   "QSRSHRXM": "Sila masukkan nama penerima",
   "ShouJiHaoMa": "Nombor telefon",
   "GuDingDianHua": "Talian tetap",
   "QSRGDDH": "Sila masukkan nombor talian tetap",
   "SuoZaiDiQu": "Kawasan",
   "QSRSZDQ": "Sila masukkan kawasan",
   "QSRXXDZ": "Sila masukkan alamat terperinci!",
   "QSRZQDSJHM": "Sila masukkan nombor telefon yang sah",
   "QSRZQDGDDH": "Sila masukkan nombor talian tetap yang sah",
   "XiangXiDiZhi": "Alamat terperinci",
   "MoRenDiZhi": "Alamat lalai",
   "SWMRDZ": "Tetapkan sebagai lalai",
   "BCBSY": "Simpan & gunakan",
   //user-bing-one
   "QSRSJHM": "Sila masukkan nombor telefon",
   "GYHYZC": "Pengguna ini sudah berdaftar",
   "GSJHMYJZCG": "Nombor telefon sudah berdaftar",
   "QZJDLJK": "Sila log masuk terus",
   "QuDengLu": "Pergi log masuk",
   "BDHKYTGSJH": "Ikat untuk log masuk dengan nombor telefon",
   "_BDHKYTGSJ": "*Ikat untuk log masuk dengan nombor telefon",
   "QSRSJYZM": "Sila masukkan kod pengesahan SMS",
   "BDXSJ": "Ikat nombor telefon baru",
   "DXYZM": "Kod pengesahan SMS",
   "XiaYiBu": "Seterusnya",
   "TGCBZ": "Langkau langkah ini",
   //user-bing-two
   "DBDSJHMBCZ": "Nombor telefon belum diikat!",
   "QSRDLMM": "Sila masukkan kata laluan!",
   "_GSJHMYBDY": "*Nombor telefon sudah diikat",
   "DQZHMMJTBW": "Kata laluan akan diselaraskan",
   "DangQianZhangHao": "Akaun semasa",
   "QDYJZ": "Sahkan padam",
   "JSPSCM": "produk ini?",
   "ShanChuChengGong": "Padam berjaya!",
   //user-info
   "SJGSCW": "Format nombor telefon salah",
   "YXGSCW": "Format emel salah",
   "WoDeZhangHao": "Akaun saya",
   "YouXiang": "Emel",
   "ShouJi": "Telefon",
   "XingMing": "Nama penuh",
   "XiuGaiTouXiang": "Tukar gambar profil",
   "JiBenXinXi": "Maklumat asas",
   "ZhangHaoAnQuan": "Keselamatan akaun",
   "XiuGaiMiMa": "Tukar kata laluan",
   "DianJiBangDing": "Klik untuk ikat",
   "RYDSHTY_QL": "Jika hilang atau tidak digunakan, tukar segera",
   "WBZNDZHAQ_": "Ikat nombor telefon untuk keselamatan",
   "QSRNDXM": "Nhập họ tên của bạn",
   "QSRNDDH": "Nhập số điện thoại",
   "QSRNDYX": "Nhập email",
   //user-setting
   "QCHCHXCXDL": "Kosongkan cache memerlukan log masuk semula",
   "QingChuHuanCun": "Kosongkan cache",
   "QDYQCHCM": "Sahkan kosongkan cache?",
   "TuiChuDengLu": "Log keluar",
   "ZhangHaoZhuXiao": "Nyahdaftar akaun",
   "QieHuanZhangHao": "Tukar akaun",
   //user-supplier
   "LianXi": "Hubungi",
   "GongSiDianHua": "Telefon syarikat",
   "DiZhi": "Alamat",
   //vouchers-detail
   "DJQMX": "Butiran baucar",
   //vouchers-list
   "BuKeYong": "Tidak boleh digunakan",
   "KeYong": "Boleh digunakan",
   "ZWDJQ": "Tiada baucar",
   "ZongEDu": "Jumlah nilai",
   "FaFangShiJian": "Masa pengeluaran",
   "EDYYW": "Nilai sudah habis",
   //vouchers-select-list
   "WDDJQ": "Baucar saya",
   "KYDJQ": "Baucar boleh digunakan",
   "DJQKDK": "Baucar boleh potong",
   "CKKYSP": "Lihat produk tersedia",
   "BKYDJQ": "Baucar tidak boleh digunakan",
   "BKYYY_ZWFH": "Sebab: Tiada produk memenuhi syarat",
   //goods-detail
   "DQSPWSCGGT": "Produk ini tiada gambar spesifikasi",
   "BoFangShiPin": "Main video",
   "Gong1GeGuiGe": "Jumlah {num} spesifikasi",
   "YiXuanGuiGe": "Spesifikasi dipilih",
   "XuanGuiGe": "Pilih spesifikasi",
   "LingQuan": "Dapatkan kupon",
   "1ZhongCuXiao": "{num} promosi",
   "1ZhangKeYong": "{num} boleh digunakan",
   "ZuiGaoKeSheng": "Penjimatan maksimum",
   "ShangPinTaoCan": "Pakej produk",
   "Gong1GeTaoCan": "Jumlah {num} pakej",
   "ShangPinCanShu": "Spesifikasi produk",
   "ZhanKai": "Kembangkan",
   "YiShouCang": "Disimpan",
   "ShouCang": "Simpan",
   "KeFu": "Khidmat pelanggan",
   "XiangQing": "Butiran",
   "TuiJian": "Disyorkan",
   "BianHao": "Nombor",
   "ShangPinXinXi": "Maklumat produk",
   "KLYHQ": "Kupon boleh diperolehi",
   "KuCunBuZu": "Stok tidak cukup",
   "DuoGuiGe": "Pelbagai spesifikasi",
   "YiShou": "Terjual",
   "SWBHZ_YS": "Stok habis, terjual",
   "CuXiaoShangPin": "Produk promosi",
   //goods-search
   "NHWSRSSNR": "Anda belum memasukkan carian",
   "SouSuo": "Cari",
   "SSY1XGDSP": "Cari produk berkaitan {searchKey}",
   "Yue1GeShangPin": "Lebih kurang {num} produk",
   "ZuiJinSouSuo": "Carian terkini",
   "QingChu": "Kosongkan",
   "ZWSSJL": "Tiada rekod carian",
   //goods-property
   "ZGJGBNDYZD": "Harga maksimum tidak boleh lebih rendah",
   "ShangPinBiaoQian": "Tag produk",
   "BuGaoYu1": "Tidak lebih tinggi daripada 1",
   "BuDiYu1": "Tidak lebih rendah daripada 1",
   "FengGe": "Gaya",
   //goods-promotion-list
   "JiJiangKaiShi": "Akan bermula",
   "QuanBuCuXiao": "Semua promosi",
   //goods-package-list
   "Gong1JianShangPin": "Jumlah {num} produk",
   "Sheng": "Jimat",
   //goods-package-detail
   "GTCZGWCZDS": "Pakej ini mencapai had dalam troli",
   "GTCKCBZ_BK": "Stok pakej tidak cukup",
   "JinSheng1Tao": "Hanya tinggal {num} set",
   "XianGou1Tao": "Had pembelian {num} set",
   "TaoCanXiangQing": "Butiran pakej",
   "DanMaiJia": "Harga unit",
   "TaoCanJia": "Harga pakej",
   "HDYJS": "Promosi tamat",
   //goods-message
   "WDL_QXDL": "Belum log masuk, sila log masuk",
   //goods-list-label
   "XinPinShangShi": "Produk baru",
   "WDLZH_ZWCX": "Belum log masuk, tiada promosi",
   "YiXiaShangPin": "Produk berikut",
   //goods-list
   "1ZhongGuiGe": "{num} spesifikasi",
   "YouKuCun": "Ada stok",
   //goods-filter
   "BuGaoYu": "Tidak lebih tinggi daripada",
   "BuDiYu": "Tidak lebih rendah daripada",
   "CuXiao": "Promosi",
   "ZDYXXZ3G": "Maksimum pilih 3",
   "GouMai": "Beli",
   "Gong1Jian": "Jumlah {num} unit",
   //缺失
   "YiChuShouCangJia": "Alih keluar dari simpanan",
   "$": "RM",
   "$1": "RM{num}",
   "_8999_1Qi": "Dari RM 8999.1",
   "Ge": "unit",
   "BaoZhuangFangShi": "Cara pembungkusan",
   "QRSCSP_": "Sahkan padam produk?",
   "JEWM_TMFRK": "Imbas kod QR/kod bar",
   "0ZSP_G0J": "0 jenis produk, 0 unit",
   "JiuMiMa": "Kata laluan lama",
   "XMM_6_20WZ": "Kata laluan baru (6-20 aksara)",
   "QueRenMiMa": "Sahkan kata laluan",
   "BDHKSYSJHD": "Ikat untuk log masuk dengan nombor telefon",
   "YanZhengMa": "Kod pengesahan",
   "1MHKCXHQ": "Cuba semula dalam 1 saat",
   "CSJHZ1MQFS": "Kod sudah dihantar, cuba sebentar lagi",
   "GouMaiJiLu": "Rekod pembelian",
   "XinZengDiZhi": "Tambah alamat baru",
   "LingShouJia": "Harga runcit",
   "YouHuiJia": "Harga promosi",
   "ShangPinChuKu": "Produk keluar stok",
   "DengDaiShouHuo": "Menunggu penghantaran",
   "ShouHuoRen": "Penerima",
   "PaiZhao": "Ambil gambar",
   "XiangCe": "Galeri",
   "TiYanGuan": "Galeri pameran",
   "JingYingShiJian": "Waktu operasi",
   "ZhanGuanDianHua": "Telefon galeri",
   "ZhanGuanDiZhi": "Alamat galeri",
   "SJHQZ_QSDZ": "Sedang memuat, cuba sebentar lagi",
   "QXXZSF_": "Sila pilih wilayah dahulu!",
   "QuanBuShengFen": "Semua wilayah",
   "QuanBuChengShi": "Semua bandar",
   "YingYeShiJian": "Waktu operasi",
   "ChanPinBianHao": "Nombor produk",
   "DLXXYGQ_QC": "Sesi tamat, sila log masuk semula",
   "Man999Jian100": "Beli {m} jimat {n}",
   "YiManZu": "Telah memenuhi",
   "QDYCSP_": "Sahkan alih keluar produk?",
   "DGM10JZ1J": "Beli 10 dapat 1 percuma",
   "XiaXianTongZhi": "Notifikasi offline",
   "NDZHYZQTSB": "Akaun anda log masuk di peranti lain",
   "ManJiang": 'Beli {target} jimat {num}',
   "ZGLXMJ": 'Beli {num} lagi jimat {money_}',
   "ZGLXMZ": 'Beli {num} lagi dapat {percent}% diskaun',
   "QSRZQNR": 'Sila masukkan kandungan yang betul',
   "NHYDDQKWJQ": 'Anda ada {num} pesanan belum selesai',
   "FaPiaoZhuShou": "Pembantu invois",
   "WoDeFaPiao": "Invois saya",
   "FaPiaoXiangQing": "Butiran invois",
   "KaiPiaoShiJian": "Masa keluaran invois",
   "DaiKaiFaPiao": "Invois belum dikeluarkan",
   "DKFPJE": "Nilai invois belum dikeluarkan",
   "KaiPiaoJinE": "Nilai invois",
   "ZFYDWT_QCSCXZF": "Masalah pembayaran, cuba kaedah lain",
   "QingXuanZhe": "Sila pilih",
   "ShouXin": 'Kredit',
   "LJSQSXED": "Mohon kredit sekarang",
   "SXEDSHZ": "Kredit dalam semakan",
   "SXCZ_XDCG": "Kredit mencukupi, pesanan berjaya",
   "SXEDBZ_FKHFH": "Kredit tidak cukup, bayar sebelum hantar",
   "CGJKZQ_FKFH": "Lewat tempoh, bayar sebelum hantar",
   "DDTJCG_XZZCZHYB": "Pesanan berjaya, tinggal langkah terakhir!",
   "MianFeiLing": "Dapatkan percuma",
   "M_KMFLQ_HQ": "Beli {target} dapat percuma, kurang {short}",
   "YHDMFSP": "Sudah dapat produk percuma",
   "JRMFL": "Percuma hari ini",
   "LingGuangLe": "Habis",
   "KeLingQu": "Boleh dapat",
   "YuGuJia": "Anggaran harga",
   "GXNHQ_Z_Y_": "Tahniah, anda dapat {num} kupon {price}RM {name}",
   "LXZSKF": "Hubungi wakil jualan",
   "DPYDY_QSHX": "Kedai tutup, sila pesan nanti",
   "DaYangShiJian": "Waktu tutup",
   "ChuanHaoChaXun": 'Semak nombor siri',
   'IMEI': 'Nombor siri',
   "FanKuanYuE": "Baki rebat",
   "FanKuanZhiFu": "Bayar dengan rebat",
   "JingDongYiYunJia": "Jingdong Yiyun+",
   "MercadoPago": "MercadoPago",
   "FKYEBZ": "Baki rebat tidak cukup",
   "FanKuanZhangHu": "Akaun rebat",
   "HaiXuZhiFu": "Perlu bayar lagi {price}",
   "QTXGSMC": "Sila masukkan nama syarikat",
   "QSCSFZZMZ": "Sila muat naik kad pengenalan hadapan",
   "QSCSFZFMZ": "Sila muat naik kad pengenalan belakang",
   "QSCYYZZ": "Sila muat naik lesen perniagaan",
   "TJCG_QNXDDSH": "Hantar berjaya, tunggu semakan",
   "SXSQ": "Permohonan kredit",
   "QYJBZL": "Maklumat asas syarikat",
   "SQFRSFZZM": "Muat naik kad pengenalan hadapan",
   "ZMSLT": "Contoh hadapan",
   "SCFRSFZFM": "Muat naik kad pengenalan belakang",
   "FMSLT": "Contoh belakang",
   "QQBSFZSJWZ_WZQXKBB": "Pastikan kad pengenalan jelas",
   "SCYYZZ": "Muat naik lesen perniagaan",
   "ShengHeZhong": "Dalam semakan",
   "TiJiaoShenHe": "Hantar untuk semakan",
   "GSMC": "Nama syarikat",
   "DDDKFQRBJQSH": "Pesanan menunggu pengesahan harga",
   "XDTX": "Peringatan pesanan",
   "NH_GDDBH": "Sesetengah produk perlu pengesahan harga",
   "QRXD": "Sahkan pesanan",
   "DaiHeJia": "Menunggu pengesahan harga",
   "ZHJY": "Baki akaun",
   "YGTG": "Promosi pekerja",
   "YuanGong": "Pekerja",
   "DuiZhanGJieSuan": "Penyelesaian akaun",
   "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "Baki = Deposit + Rebate + Pulangan belum bayar - Belum bayar",
   "YCKYE": "Baki deposit",
   "FKYE": "Baki rebat",
   "DDYFK": "Belum bayar",
   "THDTK": "Pulangan belum bayar",
   "YuCunKuanZuoFei": "Deposit terbatal",
   "FanKuanZhangHuMingXi": "Butiran akaun rebat",
   "TKCZDFKZH": "Isi semula ke akaun rebat",
   "RMBJE": "Jumlah RMB"
};
exports.default = ms_MY;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// ru_RU.js
var ru_RU = {
    "GuanShui": "таможенная пошлина",
    "ZiZhangHao": "подкаунт",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",
    //components
    "ShangeChuanYanZhengTuPian": "Загрузить картинку для проверки",
    "ChuanHaoYanZheng": "Проверить серийный номер",
    "YanZhengChuanHao": "Проверить серийный номер",
    "Ci": "раз",
    "DingDanMan": "Заказ выполнен",
    "YuanZeng": "Бонус",
    "SCFJ_ZD4Z_DZBCG": "Макс. 4 вложения, каждое ≤3МБ",
    //ChatRoom
    "ZBZCBQFH": "Эмодзи не поддерживаются",
    "FaSongLianJie": "Отправить ссылку",
    "YiChangXiaoXi": "Некорректное сообщение",
    "QingShuRu": "Введите",
    "FaSong": "Отправить",
    //DateSelector
    "DQSJXYKSSJ": "Текущее время раньше начала",
    "DQSJCGJSSJ": "Текущее время позже окончания",
    "QuXiao": "Отмена",
    "NianYueRi": "Год-Месяц-День",
    "ShiFen": "Час-Минута",
    "QueDing": "Подтвердить",
    "Nian": "Год",
    "Yue": "Месяц",
    "Ri": "День",
    "Shi": "Час",
    "Fen": "Минута",
    //goods-list-card
    "Qi": "От",
    //goods-promotion
    "1GeCuXiao": "{num} акция",
    "ChaKanZengPin": "Посмотреть подарки",
    "JHDJSHS_1T": "Осталось: {d}д {h}ч {m}м {s}с",
    "YHGZ_ZPBKD": "Условие: подарки не суммируются",
    "YHGZ_AZZGM": "Условие: скидка за количество",
    "GuanBi": "Закрыть",
    "Man1Song1": "Купи {mai} Получи {song}",
    //group-filtrate
    "QuanBu": "Все",
    "ZWXGSJ": "Нет данных",
    "ZuiDiJia": "Мин. цена",
    "ZuiGaoJia": "Макс. цена",
    "LeiXing": "Тип",
    "PinPai": "Бренд",
    "BiaoQian": "Теги",
    "JiaGeQuJian": "Диапазон цен",
    "SPMC_GG_BH_": "Название / Спецификация / Код",
    "SPMC_GG_BH_G": "Название / Спецификация / Код",
    "ZuHeShaiXuan": "Комбинированный фильтр",
    "ChongZhi_CanShu": "Сбросить",
    //image-upload
    "ZDKSC1ZTP": "Макс. 1 изображение",
    "ZYXSCTP": "Только изображения",
    "SCTPDXBYXC": "Размер ≤5МБ",
    "QBYCFSCTP_": "Дубликаты запрещены",
    "ShangChuanChengGong": "Успешно загружено",
    "ZDKSC1Z": "Макс. 1",
    //keyboard
    "CCSLZDXZ": "Превышен лимит",
    "QiDingLiang": "Мин. количество",
    "ShouQi": "Свернуть",
    "ShanChu": "Удалить",
    //MultiPicker
    "FanHui": "Назад",
    //order-cart
    "Dai": "Агент",
    "YiQuXiao": "Отменен",
    "ZengPin": "Подарок",
    "1Zhong": "{num} тип",
    "1Jian": "{num} шт.",
    "HeJi": "Итого",
    "DaiFu": "Ожидает оплаты",
    //order-promotion
    "_DDM1YZ1J_": "[Купи {target} Получи {name}x{number}]",
    "_DDM1YLJ1Y_": "[Купи {m} Скидка {n}]",
    "_DDM1YLX1Z_": "[Купи {m} Скидка {n}%]",
    "DingDanCuXiao": "Акции заказа",
    //page-ad
    "DLCKJG": "Войдите для просмотра цены",
    //page-floating
    "DianPuZhuYe": "Главная магазина",
    "GouWuChe": "Корзина",
    "ZaiXianKeFu": "Поддержка",
    "GeRenZhongXin": "Мой профиль",
    "LianXiDianHua": "Контакты",
    "FanHuiDingBu": "В начало",
    //page-null
    "ZBDYML": "Страница не найдена",
    "KNWZCW_HZY": "Неверный URL или страница удалена",
    "FanHuiShangJi": "Назад",
    "FanHuiShouYe": "На главную",
    //product-edit
    "SPQDBNWK": "Нет товаров",
    "WoZhiDaoLe": "Понятно",
    "SFQRSCSP": "Удалить товар?",
    "QueRen": "Подтвердить",
    "ZYXSRSZBQB": "Только цифры, макс. 2 знака после запятой",
    "ShangPinDanJia": "Цена товара",
    "YSPYJ": "Оригинальная цена",
    "QSRZDJG": "Введите корректную цену",
    "ShuLiang": "Количество",
    "DanWei": "Единица",
    "DanJia": "Цена",
    "BeiZhu": "Примечание",
    "YiChuShangPin": "Удалить товар",
    "XiuGai": "Изменить",
    //yunshl
    "TPSLCCYXSZ": "Превышен лимит изображений!",
    "WJBDDY5M_QC": "Файл ≤5МБ, выберите другой",
    "TPSCWC": "Изображение загружено",
    //BusinessFilter
    "_DGSLM1Z1_": "[Закажи {target} Получи {provide}]",
    "_M1JLXMJ1Y_": "[Купи {target} Скидка {cut_money_}/шт.]",
    "_DHJJZ1Y_": "[Цена снижена до {cuted_price_}]",
    "_M1JLXMJ1Z_": "[Купи {target} Скидка {cut_percent_}%/шт.]",
    "_YDHJD1Z_": "[Оригинальная скидка {cuted_percent_}%]",
    "YuJiKaiShiFaHuo": "Ориентировочная отправка: {date}",
    "YuJi": "Ориентировочно",
    "MMYDDR": "ЧЧ:ММ",
    "KaiShiFaHuo": "Начало отправки",
    "_M1LXM1Y_": "[Купи 1 Скидка 1/шт.]",
    "_M1LXM1Z_": "[Купи 1 Скидка 1%/шт.]",
    "DaiQueRen": "Ожидает подтверждения",
    "DaiFaHuo": "Ожидает отправки",
    "DaiShouHuo": "Ожидает получения",
    "YiWanCheng": "Завершено",
    "DaiFuKuan": "Ожидает оплаты",
    "YiFuKuan": "Оплачено",
    "YiZuoFei": "Отменено",
    "DaiShenHe": "Ожидает проверки",
    "DaiHeXiao": "Не использовано",
    "YiHeXiao": "Использовано",
    "XianXiaZhiFu": "Офлайн-оплата",
    "ZhiNengDaoZhangShiBie": "Перевод (автоопределение)",
    "WeiXinZhiFu": "WeChat Pay",
    "KQ-WeiXinZhiFu": "99Bill (WeChat)",
    "KQ-ZFBZF": "99Bill (Alipay)",
    "KQZhiFu": "99Bill Pay",
    "ZFBZF": "Alipay",
    "YuEZhiFu": "Баланс",
    "HuoDaoFuKuan": "Оплата при получении",
    "DaiTuiHuo": "Ожидает возврата",
    "DaiTuiKuan": "Ожидает возврата средств",
    "ChuangJianDingDan": "Создать заказ",
    "BianJiDingDan": "Редактировать заказ",
    "TiJiaoDingDan": "Отправить заказ",
    "DingDanShenHe": "Проверка заказа",
    "CaiWuShenHe": "Финансовая проверка",
    "BoHui": "Отклонить",
    "TianJiaShouKuan": "Добавить платеж",
    "ZaiXianZhiFu": "Онлайн-оплата",
    "ShouKuanShenHe": "Проверка платежа",
    "ShouKuanZuoFei": "Аннулировать платеж",
    "ChuKu": "Отгрузка",
    "ChuKuShenHe": "Проверка отгрузки",
    "FaHuo": "Отправить",
    "TianJiaWuLiu": "Добавить логистику",
    "XiuGaiWuLiu": "Изменить логистику",
    "ChuKuZuoFei": "Аннулировать отгрузку",
    "ShouHuo": "Получено",
    "DingDanHeZhun": "Подтвердить заказ",
    "QuXiaoDingDan": "Отменить заказ",
    "CJTHD": "Создать возврат",
    "DaYin": "Печать",
    "DaoChu": "Экспорт",
    "DingDanWanCheng": "Завершить заказ",
    "QiangZhiWanCheng": "Принудительное завершение",
    "DingDanZuoFei": "Аннулировать заказ",
    "MaiZeng": "Купи + получи",
    "ZhiJiang": "Прямая скидка",
    "DaZhe": "Скидка",
    "YuShou": "Предзаказ",
    "DingDanManZeng": "Подарок за мин. сумму",
    "DingDanManJian": "Скидка за мин. сумму",
    "DingDanManZhe": "% скидки за мин. сумму",
    "XinRenQuan": "Купон для новых",
    "ManJianQuan": "Купон на скидку",
    "ShangPinQuan": "Товарный купон",
    "DaiJieSuan": "Не рассчитано",
    "YiJieSuan": "Рассчитано",
    "QuanBuShangPin": "Все товары",
    "TuiJianShangPin": "Рекомендуемые",
    "XinPin": "Новинки",
    "ReXiaoShangPin": "Популярные",
    "ChangYongShangPin": "Часто покупаемые",
    //BusinessUtil
    "DaiShouKuan": "Ожидает оплаты",
    "BuFenShouKuan": "Частично оплачено",
    "YiShouKuan": "Оплачено",
    "BXYFP": "Без чека",
    "ZZSPTFP": "Обычный НДС",
    "ZZSZYFP": "Специальный НДС",
    "QiTaFaPiao": "Другой чек",
    "XianXia": "Офлайн",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Депозит",
    "XianXiaZhuangZhang": "Перевод",
    "XianShangZhiFu": "Онлайн (WeChat/Alipay/JD/UnionPay)",
    "YCKZF": "Баланс",
    "DaiTiJiao": "Не отправлено",
    "KuaiDi": "Экспресс",
    "SongHuoShangMen": "Доставка",
    "ShangMenZiQu": "Самовывоз",
    "WuLiuHuoYun": "Грузоперевозки",
    "QiTa": "Другое",
    //check-util
    "QSRBXY6WDM": "Пароль ≥6 символов",
    "QSRBDY20WDM": "Пароль ≤20 символов",
    "MMGSCW": "Неверный формат пароля",
    //common-utils
    "SJCW_QLXKF": "Ошибка данных, свяжитесь с поддержкой",
    "ZBZCQD": "Регистрация не поддерживается",
    "HuJiao": "Звонок",
    "DLZHBCZ": "Аккаунт не существует",
    "QLXGLYKT": "Свяжитесь с администратором для активации",
    "GQYZHBJY": "Аккаунт компании отключен",
    "QLXYSDH": "Свяжитесь с YUNSHANG",
    "GQYZHSYQJS": "Пробный период истек",
    "GQYZHYGQL": "Аккаунт истек",
    "XYXFCNSY": "Требуется продление",
    "GQYBCZCZH": "Неверный аккаунт компании",
    "NDDHZHYBQY": "Ваш аккаунт отключен компанией",
    "NYBSQY1DHZ": "Больше не партнер",
    "NDDPYBTY_B": "Магазин приостановлен",
    "GZHWKTDSZB": "Модуль не активирован",
    "WXSQYZYGQ": "Проверка WeChat истекла",
    "WXSQSB": "Проверка WeChat не удалась",
    "WXSQSB_CWX": "Ошибка WeChat: {msg}",
    "DengLuGuoQi": "Время входа истекло",
    "DLGQ_QCXDL": "Сессия истекла, войдите снова",
    //data-constant
    "ShangJia": "В продаже",
    "YiXiaJia": "Снято с продажи",
    "YiJinYong": "Отключено",
    "YiQiYong": "Включено",
    "YiTingYong": "Приостановлено",
    "KeHuZhuCe": "Зарегистрированный клиент",
    "XinZengDaoRu": "Импорт",
    "DDDSH": "Ожидает проверки заказа",
    "DCWSH": "Ожидает финансовой проверки",
    "DaiChuKu": "Ожидает отгрузки",
    "DCK_BF_": "Ожидает отгрузки (частично)",
    "DFH_BF_": "Ожидает отправки (частично)",
    "DSH_BF_": "Ожидает получения (частично)",
    "DSK_BF_": "Не оплачено (частично)",
    "WTHSQ": "Нет запроса на возврат",
    "THDSH": "Ожидает проверки возврата",
    "THCLZ": "В обработке",
    "THYWC": "Возврат завершен",
    "DYDHD": "Печать заказа",
    "DYFHD": "Печать счета",
    "DCDHD": "Экспорт заказа",
    "DCFHDWE_P": "Экспорт в Excel/PDF",
    "TuiDanZuoFei": "Аннулировать возврат",
    "DTHSH": "Ожидает проверки возврата",
    "DaiRuKu": "Ожидает приема",
    "DRK_BF_": "Ожидает приема (частично)",
    "DFK_BF_": "Не оплачено (частично)",
    "ChuangJianTuiDan": "Создать возврат",
    "BianJiTuiDan": "Редактировать возврат",
    "TiJiaoTuiDan": "Отправить возврат",
    "TuiHuoShenHe": "Проверка возврата",
    "RuKu": "Прием",
    "RuKuShenHe": "Проверка приема",
    "RuKuZuoFei": "Аннулировать прием",
    "TianJiaFuKuan": "Добавить платеж",
    "FuKuanZuoFei": "Аннулировать платеж",
    "FuKuanShenHe": "Проверка платежа",
    "TuiDanWanCheng": "Возврат завершен",
    "QiTaChuKu": "Другая отгрузка",
    "XiaoShouChuKu": "Отгрузка продаж",
    "PanKuiChuKu": "Отгрузка убытков",
    "DiaoBoChuKu": "Перемещение",
    "CaiGouTuiHuo": "Возврат закупки",
    "TuiHuoRuKu": "Прием возврата",
    "CaiGouRuKu": "Прием закупки",
    "QiTaRuKu": "Другой прием",
    "PanYingRuKu": "Прием прибыли",
    "DiaoBoRuKu": "Прием перемещения",
    "CJCGD": "Создать PO",
    "BJCGD": "Редактировать PO",
    "TJCGD": "Отправить PO",
    "CGDZF": "Отменить PO",
    "CGDWC": "PO завершен",
    "CGTHZF": "Отменить возврат закупки",
    "CGTHWC": "Возврат закупки завершен",
    "THDDY": "Печать возврата",
    "THDDC": "Экспорт возврата",
    "CKDDY": "Печать отгрузки",
    "CKDDC": "Экспорт отгрузки",
    "GLDZH": "Админ аккаунт",
    "DHDZH": "Аккаунт заказа",
    "ShenHeTongGuo": "Проверено",
    "SHBTG": "Проверка не пройдена",
    "WuXuFaPiao": "Чек не нужен",
    "DaiKeXiaDan": "Заказано агентом",
    "ZiZhuXiaDan": "Самостоятельный заказ",
    "PCShangCheng": "PC магазин",
    "APPShangCheng": "App магазин",
    "TVShangCheng": "TV магазин",
    "WeiXinShangCheng": "WeChat магазин",
    "ShouJiShangCheng": "Мобильный магазин",
    "ADDXSMLTC": "Комиссия с прибыли",
    "ADDXSSRTC": "Комиссия с дохода",
    "AKHSSYG": "По агенту продаж",
    "AnZhiDanRen": "По создателю",
    "ATHJEBLKCT": "Вычет комиссии по сумме возврата",
    "DDYTHBJXTC": "Возвраты без комиссии",
    "DaiDaKuan": "Ожидает оплаты",
    "WeiKaiShi": "Не начато",
    "JinXingZhong": "В процессе",
    "YiGuoQi": "Истекло",
    //Utils.js
    "YouHuo": "В наличии",
    "WuHuo": "Нет в наличии",
    "Yi": "Млрд",
    "QianWan": "10 млн",
    "BaiWan": "Млн",
    "Wan": "10 тыс",
    "Sheng1Tian": "Остался 1 день",
    "Sheng1XiaoShi": "Остался 1 час",
    "Miao": "Секунда",
    "1Miao": "1 секунда",
    "GangGang": "Только что",
    "1FenZhongQian": "1 минуту назад",
    "1XiaoShiQian": "1 час назад",
    "1TianQian": "1 день назад",
    "1GeYueQian": "1 месяц назад",
    "1NianQian": "1 год назад",
    "WeiZhiLeiXing": "Неизвестный тип",
    //WechatUtil
    "YYGBCDSP_K": "Посмотрите этот товар!",
    "ZanWeiSheZhi": "Не настроено",
    //app
    "HQWXSQXX": "Получить информацию проверки WeChat",
    //flexible
    "JGJYYDMBQ": "Масштаб по метатегу",
    //index
    "NLJZZ": "Загрузка...",
    "": "routes",
    "ShangPinMingXi": "Детали товара",
    "ShangPinLeiBie": "Категория",
    "QXZFPNR": "Выберите содержание чека",
    "QXZFPLX": "Выберите тип чека",
    "QTXFPTT": "Введите заголовок чека",
    "FaPiaoTaiTou": "Заголовок чека",
    "NSRSBH": "ИНН",
    "FaPiaoNeiRong": "Содержание чека",
    "FaPiaoXinXi": "Информация о чеке",
    "KaiJuFaPiao": "Выписать чек",
    "FaPiaoLeiXing": "Тип чека",
    "Han": "Включая",
    "WeiHan": "Без",
    "Shui": "Налог",
    "QSRFPTT": "Введите заголовок чека",
    "QSRNSRSBH": "Введите ИНН",
    //routes
    //cart-bill
    "YiManZu_Man": "Достигнут [Мин",
    "ZaiGou": "Купить еще",
    "YMZ_DHJJZ": "Достигнут [Цена заказа снижена до",
    "JianJiangZhi": "Снижено до",
    "YMZ_YDHJD": "Достигнут [Оригинальная скидка",
    "JianMeiJian": "За шт.",
    "SYTCSLW0_WFJRGWC": "Нет запасов пакета, нельзя добавить в корзину",
    "QingXuanXeShangPin": "Выберите товары!",
    "GSPYXJ": "Этот товар больше не продается!",
    "ZJ2TN": "{day} дней назад",
    "QDQCXJSP": "Подтвердить удаление непродаваемых товаров?",
    "QingChuChengGong": "Успешно удалено",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Товары пакета нельзя добавить в корзину!",
    "SPSLBN": "Количество товара не может быть",
    "TaoCanHan": "Пакет включает",
    "TaoCan": "Пакет",
    "QHDSL": "Подтвердить количество",
    "SPSLBNDY": "Количество товара не менее",
    "XianDingLiang": "Лимит заказа",
    "YiRuShouCang": "В избранном",
    "QuanXuan": "Выбрать все",
    "JianZeng": "Подарок",
    "JianLiXiang_Man": "шт. при мин. покупке",
    "Yuan_": "¥]",
    "Zhe_": "% скидки]",
    "KCBZ_WFJRGWC": "Недостаточно запасов, нельзя добавить",
    "XDJEDYDY": "Сумма заказа ≥",
    "WYXJHYSXDSP": "Нет непродаваемых товаров!",
    "DYQDL": "Ниже мин. количества",
    "ZSPG1J": "{count} типов товаров",
    "WanCheng": "Готово",
    "BianJi": "Редактировать",
    "You": "Есть",
    "ZSPBFHYQ_W": "{count} товаров не соответствуют условиям",
    "SPSLBNGY": "Количество товара не превышает",
    "JXDJ_CKXYGBFHYQSP": "Прокрутите, чтобы увидеть больше товаров",
    "XiaDan": "Заказать",
    "JianJiang": "Снижение",
    "QRYCSP": "Подтвердить удаление товара?",
    "QXZXDSP": "Выберите товары для заказа",
    "KCBZ_QCXXZ": "Недостаточно запасов, выберите снова!",
    "KuCun": "Запасы",
    "YCKXD": "Нужно оплатить {price}",
    "QDSCSP": "Подтвердить сохранение товара?",
    "ShouCangChengGong": "Успешно сохранено",
    "GYXDL": "Превышен лимит заказа",
    "LiSheng": "Экономия",
    "GWCHSKD_QGYGB": "Корзина пуста, давайте за покупками",
    "QuGuangGuang": "Пойти смотреть",
    "QCXJSP": "Удалить непродаваемые товары",
    "ZongE": "Итого",
    "YouHui": "Скидка",
    //cart-list
    "QXZJHRQ": "Выберите время доставки",
    "FuJiaFeiYong": "Дополнительные расходы",
    "ZhongShangPin_Gong": "{count} типов товаров, всего",
    "PeiSongShiJian": "Время доставки",
    "QXZPSSJ": "Выберите время доставки",
    "DingDanJinE": "Сумма заказа",
    "SCFJ_ZD4Z": "Макс. 4 вложения, каждое ≤3МБ",
    "KeYongShangPin": "Доступные товары",
    "ShiYongShuoMing": "Инструкция по использованию",
    "YouXiaoQi": "Срок действия",
    "Man": "Мин.",
    "BZZBZCTSFH": "Примечания не поддерживают спецсимволы",
    "QingXuanZe": "Пожалуйста, выберите",
    "KaiPiaoXuJia": "Стоимость чека",
    "GeDian": "Баллы",
    "KPXJ1GD": "Стоимость чека {num} баллов",
    "PeiSongFangShi": "Способ доставки",
    "ShangPinZongJia": "Общая стоимость товаров",
    "YouHuiQuan": "Купон",
    "ZhangKeXan": "Можно выбрать",
    "DDJEWMZ": "Сумма заказа не достигла",
    "WDYHQ": "Мои купоны",
    "KYYHQ": "Доступные купоны",
    "YuanKeYong": "Доступно ¥",
    "ChaKanDingDan": "Посмотреть заказ",
    "ShangPinHanShui": "Товары с налогом",
    "SPWHS": "Товары без налога",
    "QueRenDingDan": "Подтвердить заказ",
    "XZSHDZ": "Добавить новый адрес",
    "ShangPinQingDan": "Список товаров",
    "WKYYHQ": "Нет доступных купонов",
    "HuChi": "Эксклюзивно",
    "DaiJinQuan": "Купон",
    "YunFei": "Доставка",
    "ShuiFei": "Налог",
    "BKYYY": "Причина недоступности",
    "YHQYGQ": "Купон истек",
    "WDYHQSYSJ": "Не достигнуто время использования",
    "ZDSPJEWMZ": "Стоимость товара не достигла",
    "BKYYHQ": "Купон недоступен",
    "YMZ_MYZJ_": "Достигнут [Мин. ¥{m} Получи {n} шт.]",
    "YMZ_MZ": "Достигнут [Мин. ¥{m} Получи {n}]",
    "ZG222YX_M1000": "Купить еще на ¥{money} Получи [Мин. ¥{target} Получи {num} шт.]",
    "ZG2JX_MZ": "Купить еще {num} шт. Получи [Мин. ¥{target} Получи {present}]",
    "YMZ_MYJY_": "Достигнут [Мин. ¥{m} Сэкономь ¥{n}]",
    "ZGYX_MYJY_": "Купить еще на ¥{m} Получи [Мин. ¥{n} Сэкономь ¥{o}]",
    "YMZ_MYZ_": "Достигнут [Мин. ¥{m} Скидка {n}%]",
    "ZGYX_MYZ_": "Купить еще на ¥{m} Получи [Мин. ¥{n} Скидка {o}%]",
    //cart-presale-order
    "QXZPSFS": "Выберите способ доставки",
    "1ZSP_G": "1 тип товара, всего",
    "YSSP_YJ": "Предзаказ, ориентировочно",
    "JiaoHuoRiQi": "Дата поставки",
    "GMJLY": "Примечание к заказу",
    //scan-to-cart
    "ZhengZaiChuLi...": "Обработка...",
    "FSCSP": "Не товар магазина",
    "ZZCLTXM": "Обработка штрихкода...",
    "SPTJCG": "Товар успешно добавлен",
    "QSTXM": "Отсканируйте штрихкод",
    "SFSCDQSP": "Удалить текущий товар?",
    "BQ_ZBDXGSP": "Извините, товар не найден",
    "XuanZeDanWei": "Выберите единицу",
    "JRGWC": "Добавить в корзину",
    "QXXZDJRSP": "Сначала выберите товар",
    "ZhengZaiChuLi": "Обработка",
    "JRGWCCG": "Успешно добавлено в корзину",
    "ZanWuShangPin": "Нет товаров",
    //earn-brokerage-share
    "XTYJBNFZSP": "Система скопировала ссылку на товар!",
    "NKYHDDYDYJ": "Вы получили комиссию, смотрите в \"Мои",
    "LiChaKan": "\"",
    "WeiXinHaoYou": "Друзья WeChat",
    "ErWeiMa": "QR-код",
    "CASBEWM": "Сканировать QR-код",
    "FZSB_QCXFZ": "Копирование не удалось, попробуйте снова!",
    "TWEWM": "Текст+Изображение QR-кода",
    "BCDXC": "Сохранить в альбом",
    "CATPBCDXC": "Нажмите и удерживайте для сохранения",
    "FuZhiLianJie": "Копировать ссылку",
    "FXZYJ": "Поделитесь, чтобы получить комиссию",
    "YJZGKZQYJ": "Максимальная комиссия",
    "PYTGNFXDYMCGGMH": "Когда друг покупает по вашей ссылке, вы получаете комиссию",
    //goods-share
    "FXSPGLSKH": "Поделиться товаром с клиентом",
    "FXHJSCNZSD": "Поделитесь, чтобы открыть мобильный магазин",
    "WSCDQJG_ND": "Цена в мобильном магазине: Ваша цена ×",
    "DaiSheZhi": "Не настроено",
    "PengYouQuan": "Моменты",
    "GGFXSZ": "Настройки обмена",
    //wechat-login
    "QXSRZH": "Введите аккаунт",
    "MMGSCW_6_20W": "Неверный формат пароля (6-20 символов)",
    "BDYYZH": "Привязать существующий аккаунт",
    "WXKJDL": "Быстрый вход WeChat",
    "BangDingZhangHao": "Привязать аккаунт",
    "YYZH_QDL": "Уже есть аккаунт? Войти",
    "ZCXZH": "Зарегистрировать новый аккаунт",
    "HuanYingNi": "Добро пожаловать",
    "ZH_SJHM": "Аккаунт/Телефон",
    "MiMa": "Пароль",
    "QDLHCZ": "Войдите, чтобы продолжить",
    //add-to-cart
    "KCBZ_BNTJG": "Недостаточно запасов, нельзя добавить",
    //combined-pay-online
    "ZhiFuChengGong": "Оплата успешна!",
    "ZFSB_QCXCS": "Оплата не удалась, попробуйте снова!",
    "QXXZGG": "Сначала выберите спецификацию",
    "SXGGX": "Необходимо выбрать спецификацию",
    "GMSLXYQDL_": "Количество ниже минимума, купите больше!",
    "GMSLDYXDL_": "Количество превышает лимит, купите меньше!",
    "ShangPinBianHao": "Код товара",
    "QiDing": "Мин.",
    "SXGGDGSLBK": "Количество не превышает",
    "KCBZ_BNTJ": "Недостаточно запасов, нельзя добавить",
    "QXXZSP": "Сначала выберите товар",
    "SLBNW0": "Количество не может быть 0",
    "QXZGG": "Выберите спецификацию",
    "LiJiYuDing": "Предзаказ сейчас",
    //nav
    "ShouYe": "Главная",
    "ShangPin": "Товары",
    "DingDan": "Заказы",
    "WoDe": "Мой",
    //pay-online
    "ZhiFuQuXiao": "Оплата отменена",
    //account-log
    "ShangPinYongJin": "Комиссия за товар",
    "YaoQingJiangLi": "Награда за приглашение",
    "TiXian": "Вывод",
    "TiXianBoHui": "Вывод отклонен",
    "ZhuanWeiYuE": "Перевести на баланс",
    "Jin7Tian": "Последние 7 дней",
    "Jin30Tian": "Последние 30 дней",
    "ShouZhiMingXi": "Детали доходов и расходов",
    "ZanWuShuJu": "Нет данных",
    //client-statistics
    "WoDeKeHu": "Мои клиенты",
    "WoDeYaoQing": "Мои приглашения",
    //distribution-home
    "LeiJiKeHu": "Всего клиентов",
    "LeiJiDingDan": "Всего заказов",
    "YaoQingHaoYou": "Пригласить друзей",
    "LeiJiYaoQing": "Всего приглашений",
    "LJSY_Y_": "Общий доход (¥)",
    "BHDJS": "Не завершено",
    "J7TSY_Y_": "Доход за 7 дней (¥)",
    "J7TXZKH_R_": "Новые клиенты за 7 дней (чел.)",
    "KTXYJ": "Комиссия к выводу",
    "XYJYO": "Нужно больше усилий",
    "ChangJianWenTi": "Частые вопросы",
    "Q_ZMYJX_TG": "В: Как работает \"Продвижение за комиссию\"?",
    "A_FXDPND_Z_": "О: Поделитесь ссылкой с иконкой \"Заработать\"",
    "Q_RHJS_TGZ": "В: Как рассчитывается комиссия?",
    "A_MGD_Z_TBD": "О: Каждый товар имеет свою ставку комиссии",
    "Q_TGZQ_DSY": "В: Когда я получу комиссию?",
    "A_HYTGNDFX": "О: После подтверждения получения клиентом",
    "Q_LJKH_LJY": "В: Почему нет аватара?",
    "A_WXYQZYGZ": "О: Нужно подписаться на сервисный аккаунт",
    "Q_WSMWASSG": "В: Почему нет комиссии?",
    "A_1_HYKNBW": "А:1.Друг, возможно, не установил с вами клиентские отношения (друг зарегистрировался или оформил заказ по ссылке другого продавца).2.Если друг открыл вашу ссылку вне среды WeChat (например, в браузере по умолчанию на телефоне) и в браузере отключены cookie, система не сможет зафиксировать клиентские отношения, то есть реферальный заказ.3.Если ни одна из этих проблем не возникает, но заказ всё равно не фиксируется, свяжитесь с сотрудниками поддержки.",
    "XiaoShouZhongXin": "Центр продаж",
    //generalize-goods
    "SPMC_GG_BH": "Название товара / Спецификация / Код",
    "YuJiZhuan": "Ожидаемая комиссия",
    //invitation-home
    "YaoQingKa": "Пригласительная карта",
    "YNYQJR_TGY": "Пригласите присоединиться, продвигайте и получайте награды",
    "DJBCDXC": "Нажмите, чтобы сохранить в альбом",
    "JYQKFSGHY_": "Поделитесь картой с друзьями",
    //join-home
    "HuanYingJiaRu": "Добро пожаловать",
    "YQNCW": "Приглашаем вас стать",
    "LiJiJiaRu": "Присоединиться сейчас",
    //order-statistics
    "YuJiYongJin": "Ожидаемая комиссия",
    "YongJin": "Комиссия",
    "YuJiJiangLi": "Ожидаемая награда",
    "JiangLi": "Награда",
    "SPTGDD": "Заказы по продвижению товаров",
    "YQJLDD": "Заказы по приглашениям",
    //performance-statistics
    "YeJiTongJi": "Статистика производительности",
    "LJKH_R_": "Всего клиентов (чел.)",
    "SPYJ_Y_": "Комиссия за товары (¥)",
    "HanDaiJieSuan": "Включая незавершенные",
    "XGMCJS": "Определение",
    "KeHu": "Клиент",
    "HFXYBDLKHG": "Связанные клиенты",
    "YaoQing": "Приглашение",
    "FXYCGYQDXJ": "Успешное приглашение",
    "FXYTJKHGMH": "Комиссия от приглашенных клиентов",
    "XJFXYTGSPH": "Награда за приглашение",
    //posters-promoting
    "NiCheng": "Никнейм",
    "HaiBaoTuiGuang": "Продвижение постера",
    "JHBFSGHY_T": "Поделитесь постером с друзьями",
    //settlement-home
    "JieSuanZhongXin": "Расчетный центр",
    "KTXJE": "Сумма к выводу",
    "TiXianJiLu": "История выводов",
    //withdraw-account
    "KHRXMBNWK": "Имя владельца обязательно!",
    "KHHBNWK": "Банк обязателен!",
    "YHKHBNWK": "Номер счета обязателен!",
    "SFZTPBNWK": "Загрузите фото ID!",
    "YHKTPBNWK": "Загрузите фото банковской карты!",
    "BaoCunChengGong": "Сохранено успешно!",
    "SCSFZ": "Загрузить ID",
    "SCYHK": "Загрузить банковскую карту",
    "BaoCun": "Сохранить",
    "TiXianZhangHu": "Счет для вывода",
    "TS_QTXZSXX": "Пожалуйста, предоставьте реальную информацию",
    "KHRXM": "Имя владельца",
    "KaiHuHang": "Банк",
    "YinhangKaHao": "Номер счета",
    "QSRZSXM": "Введите реальное имя",
    "QSRKHHMC": "Введите название банка",
    "QSRYHKH": "Введите номер счета",
    //withdraw-deposit
    "QXSZTXZH": "Сначала настройте счет для вывода",
    "QuSheZhi": "Настройки",
    "JEXY10Y_BKT": "Сумма ниже ¥10 не может быть выведена!",
    "JECGKTXJE": "Сумма превышает лимит вывода!",
    "CGDRKTXSX_": "Превышен дневной лимит (¥20,000)!",
    "QueDingJiang": "Подтвердить перевод",
    "ZhuanDaoYuE": "На баланс?",
    "_JEDY10YSB": "1. Сумма ниже ¥10 не может быть выведена",
    "_BCTXDZSJ": "2. Время получения: 5 рабочих дней",
    "_GBSRWHSS": "3. Этот доход включает налоги",
    "_ZDYEKYYS": "4. Баланс можно использовать для покупок",
    "TXSQCG_QDD": "Запрос на вывод успешен, ожидайте проверки",
    "JEDYKTXJE_": "Сумма превышает баланс, перевод невозможен!",
    "ZZYECG_QDG": "Перевод на баланс успешен, смотрите в профиле",
    "BenCiTiXian": "Этот вывод",
    "ZhuangDaoYuE": "Перевести на баланс",
    "TiXianDao": "Вывести на",
    "JEW0BKZZYE": "Сумма 0 не может быть переведена",
    "DRTXSX2WY": "Дневной лимит ¥20,000",
    "QuanBuTiXian": "Вывести все",
    "QueRenTiXian": "Подтвердить вывод",
    //goods-filter-tab
    "ZuiChangGouMai": "Часто покупаемые",
    "MoRenPaiXu": "По умолчанию",
    "ZongHe": "Все",
    "FenLei": "Категория",
    "XiaoLiangYouXian": "Лучшие продажи",
    "XiaoLiang": "Продажи",
    "JiaGe": "Цена",
    "ShaiXuan": "Фильтр",
    "ZuiJinGouMai": "Недавно купленные",
    "CuXiaoYouXian": "Лучшие акции",
    "QuanBuFenLei": "Все категории",
    "ZhiKanCuXiao": "Только акции",
    "XuanZeFenLei": "Выбрать категорию",
    "QXZFL": "Выберите категорию",
    //goods-list-default
    "ZWXGSP": "Нет связанных товаров",
    //goods-brand-list
    "PinPaiHui": "Бренды",
    //goods-classify-filter
    "TuiJianFenLei": "Рекомендуемые категории",
    "ShangPinFenLei": "Категории товаров",
    "GengDuo": "Еще",
    //goods-detail
    "DLZHBSDQQY": "Аккаунт не является текущим клиентом компании",
    "GXNHQ": "Поздравляем, вы получили",
    "SZWSCJGH_C": "Установите цену перед обменом",
    "JHDJSHS_": "Осталось времени:",
    "DLHKFX": "Войдите, чтобы поделиться",
    "ZZHQXX_QSH": "Получение данных",
    "Zhang": "шт.",
    "Tian": "дн.",
    "QXZGGZQPD": "Сначала выберите спецификацию",
    "Yuan": "¥",
    "XS_F_M": "ч/м/с",
    //integral
    "WoDeJiFen": "Мои баллы",
    "DaBaiLe": "Лучше",
    "JiFen": "Баллы",
    "DeHuiYuan": "Стать участником",
    "ZhuanJiFen": "Заработать баллы",
    "JiFenMingXi": "Детали баллов",
    "HuanLiPin": "Обменять подарки",
    "CKGDHL": "Посмотреть больше подарков",
    "ChaDingDan": "Проверить заказ",
    //integral-convert
    "DHSLBNCG": "Количество обмена не превышает",
    "DuiHuanShuLiang": "Количество обмена",
    "SuoXuJiFen": "Необходимые баллы",
    //integral-detail
    "LiPinXiangQing": "Детали подарка",
    "WoYaoDuiHuan": "Я хочу обменять",
    "ShengYu": "Осталось",
    "TuWenXiangQing": "Детали",
    "Jian": "шт.",
    "YiDuiWan": "Обменено",
    //integral-filter
    "FenLeiShaiXuan": "Фильтр категорий",
    "JiFenShaiXuan": "Фильтр баллов",
    //integral-flow
    "JiFenShouRu": "Поступление баллов",
    "JiFenZhiChu": "Расход баллов",
    //integral-logistics
    "DingDanGenZong": "Отслеживание заказа",
    "WuLiuGongSi": "Логистическая компания",
    "WuLiuDanHao": "Трек-номер",
    //integral-order
    "DingDanLieBiao": "Список заказов",
    "YiFaHuo": "Отправлено",
    "JiFenDingDan": "Заказы за баллы",
    "ChaKanWuLiu": "Проверить логистику",
    //integral-order-create
    "LPSLBZ_QCX": "Недостаточно подарков",
    "JiFenBuZu": "Недостаточно баллов",
    "ZhiFuXinXi": "Информация об оплате",
    "JiXuGuangGuang": "Продолжить покупки",
    "QTXSHXX": "Заполните информацию о доставке",
    "DuiHuanChengGong": "Обмен успешен",
    "LPDHQR": "Подтвердить обмен подарка",
    "SCCKJ": "Рекомендуемая цена",
    "LiJiZhiFu": "Оплатить сейчас",
    //integral-order-detail
    "DingDanXiangQing": "Детали заказа",
    "DingDanZhuangTai": "Статус заказа",
    "DingDanBianHao": "Номер заказа",
    "DuiHuanShiJian": "Время обмена",
    "ShouHuoXinXi": "Информация о доставке",
    "HuaFeiJiFen": "Использованные баллы",
    //integral-rule
    "QDZJF": "Заработать баллы за регистрацию",
    "XDZJF": "Заработать баллы за заказ",
    "1_MRQD_JL": "1. Ежедневный вход: +{num} баллов",
    "2_LXQD3T_EW": "2. 3 дня подряд: +{num} баллов",
    "3_LXQD7T_EW": "3. 7 дней подряд: +{num} баллов",
    "DLZJF": "Заработать баллы за вход",
    "MRDLYSDHSC": "Ежедневный вход: +{num} баллов",
    "DDWCHKHDYD": "Завершенный заказ: Баллы = Сумма заказа × {num}",
    //integral-rule-detail
    "GuiZe": "Правила",
    //integral-sign
    "QianDaoYouLi": "Вход за награды",
    "QianDaoGuiZe": "Правила входа",
    "YLXQD": "Подряд",
    "YLXQD1T": "{num} дней",
    "QDCG_NYJLX": "Успех! Вход {num} дней",
    "QDCG_BCHD1": "Успех! Получено {num} баллов",
    "BCQDHD4JF_": "Получено {num} баллов, отлично!",
    "QSRBZ": "Заполните примечание",
    "DingDanZengPin": "Подарок за заказ",
    "GuiGeBianHao": "Код спецификации",
    "GuiGe": "Спецификация",
    //combined-pay
    "CDDWXFK": "Этот заказ не требует оплаты",
    "YHYEBZ": "Недостаточно баланса!",
    "ZFJEBNW0": "Сумма оплаты не может быть 0!",
    "ZFJEBNDYDD": "Превышает задолженность",
    "DFKJE": "Задолженность",
    "FuKuanFangShi": "Способ оплаты",
    "FuJian": "Вложение",
    "ZHYFZ": "Копировать счет",
    "GHSKZH": "Изменить счет получателя",
    "SYXXZFQSCF": "Загрузите подтверждение оплаты для проверки",
    "XXZF_BXXZS": "Выберите счет получателя для офлайн-оплаты",
    "DingDanZhiFu": "Оплата заказа",
    "ZFFS_HDFK": "Способ: Оплата при получении",
    "BCFKJE": "Сумма этой оплаты",
    "YuE": "Баланс",
    "FuZhiZhangHao": "Копировать счет",
    "WSZXCXZFPZ": "Оплата не настроена",
    "XCXZFZHJY": "Счет оплаты отключен",
    "SRZFJE": "Введите сумму оплаты",
    "FuKuanZhangHu": "Счет оплаты",
    "QueRenZhiFu": "Подтвердить оплату",
    "ShaoHouZhiFu": "Оплатить позже",
    //order
    "FKJLYTJ_DD": "Добавлено примечание к оплате, ожидает проверки",
    "JiXuGuang": "Продолжить покупки",
    "BenCiFuKuan": "Эта оплата",
    "FuKuanChengGong": "Оплата успешна",
    "ZhiFuFangShi": "Способ оплаты",
    "ZhiFuDingDan": "Оплатить заказ",
    //order-batch-pay
    "QXXZSXZFDD": "Выберите заказы для оплаты",
    "PiLiangFuKuan": "Массовая оплата",
    "FuKuan": "Оплатить",
    "QuFuKuan": "К оплате",
    //order-create-result
    "YingFuJinE": "Сумма к оплате",
    "XiaDanShiJian": "Время заказа",
    //order-deliver
    "SFQRSH": "Подтвердить получение?",
    "DDQRSH": "Подтвердить получение заказа",
    "DFHSP": "Товары ожидают отправки",
    "ShangPinShuLiang": "Количество товаров",
    "ChuKuShiJian": "Время отгрузки",
    "FaHuoShiJian": "Время отправки",
    "WuLiuBeiZhu": "Примечание к логистике",
    "QueRenShouHuo": "Подтвердить получение",
    "RYFK_QJSYG": "Свяжитесь с администратором после оплаты",
    "QSRQXYY": "Укажите причину отмены",
    "H_DDJZDGB_QJKF": "Заказ будет автоматически отменен",
    "TuiHuoQingKuang": "Статус возврата",
    "DingDanZongE": "Общая сумма заказа",
    "DingDanBeiZhu": "Примечание к заказу",
    "FaHuoQingKuang": "Статус отправки",
    "DingDanFuJian": "Вложения заказа",
    "ShenQingTuiHuo": "Запросить возврат",
    "G1TDSHJL_QRS": "Подтвердить получение {num} заказов?",
    "DaiXiaDan": "Заказано агентом",
    "DingDanHao": "Номер заказа",
    "XiaDanFangShi": "Способ заказа",
    "TuiHuoDan": "Возврат",
    "ShangPinZongE": "Общая стоимость товаров",
    "YunFei_ZongZhong": "Доставка (Общий вес",
    "SF_SPWS": "Налог (Товары без налога",
    "TePiJia": "Специальная цена",
    "FuKuanQingKuang": "Статус оплаты",
    "TiaoJiLu": "История",
    "ZaiLaiYiDan": "Повторить заказ",
    "MuLiuXinXi": "Информация о логистике",
    "QDSCGDD_": "Подтвердить удаление заказа?",
    "YiQueRen": "Подтверждено",
    "YiShouHuo": "Получено",
    "DaiFuJinE": "Не оплачено",
    "YiFuJinE": "Оплачено",
    "ZanWuJiLu": "Нет истории",
    "SPMC_DDH": "Название товара / Номер заказа",
    "FuKuanZhuangTai": "Статус оплаты",
    "FaHuoZhuangTai": "Статус отправки",
    "QiShiShiJian": "Время начала",
    "ZhongZhiShiJian": "Время окончания",
    //order-list
    "CaoZuoChengGong": "Операция успешна",
    "ZBKGM": "Невозможно купить сейчас",
    "DQDDSPYXJ": "Товары в заказе больше не продаются",
    "DQDDBFSPYXJ": "Некоторые товары больше не продаются",
    "JTJSJSP": "Добавить только доступные товары",
    "DingHuoDan": "Заказ на покупку",
    //order-log
    "DingDanRiZhi": "Журнал заказов",
    //order-logistics
    "FuZhiChengGong": "Скопировано успешно",
    "FuZhiShiBai": "Ошибка копирования",
    "FuZhi": "Копировать",
    "BoDa": "Позвонить",
    "WCWLDHXX": "Нет информации о логистике",
    //order-pay
    "ZFCS_QCXXD": "Время оплаты истекло, повторите заказ",
    "YQYYCKZF": "Включить оплату депозитом",
    "BNDYDFKJE": "Не превышает задолженность",
    "ZFJEBNWK": "Сумма оплаты обязательна",
    "QXAPFK_FKH": "Подготовьте подтверждение оплаты для проверки",
    "DDTJCG_QJS": "Заказ успешен, оплатите сейчас",
    "QXZFKFS": "Выберите способ оплаты",
    "SYYEZFH_HX": "После оплаты балансом, доплатите",
    "FuKuanJiLu": "История платежей",
    "ZWFKJL": "Нет истории платежей",
    "FuKuanXiangQing": "Детали платежа",
    "FuKuanJinE": "Сумма платежа",
    "ZhiDan": "Создано",
    "ShenHe": "Проверка",
    "ZuoFei": "Отменено",
    "ZuoFeiYuanYin": "Причина отмены",
    "GLDHD": "Связанные заказы",
    "HeXiaoJinE": "Проверенная сумма",
    "HeXiaoZhuangTai": "Статус проверки",
    "DanJuZhuangTai": "Статус документа",
    "KeHuMingCheng": "Имя клиента",
    "ZhangDanHao": "Номер счета",
    "ShouKuanZhangHao": "Счет получателя",
    "ShouKuanShiJian": "Время получения",
    "FuKuanPingZheng": "Подтверждение оплаты",
    "GeFuJian": "Вложение",
    //order-statistics
    "DingDanTongJi": "Статистика заказов",
    "DingHuo0Bi": "{num} заказов",
    //order-statistics-detail
    "DDTJMX": "Детали статистики",
    "AGGTJ": "По спецификации",
    "AFLTJ": "По категории",
    "DDJE_Y": "Сумма заказа/¥",
    "DHSP_Z": "Заказанные товары/Типы",
    "DingHuoDan_Bi": "Заказов/Шт.",
    "DingHuoShangPin": "Заказанные товары",
    "JinE": "Сумма",
    //refund-list
    "TuiHuo": "Возврат",
    //refund-apply
    "THDHWBC_QD": "Возврат не сохранен, выйти?",
    "QSRSQTHJE": "Введите сумму возврата",
    "QSRTHJE": "Введите сумму возврата",
    "QSRBZXX": "Введите примечание",
    "YingTuiJinE": "Сумма к возврату",
    "TJTHSQ": "Отправить запрос на возврат",
    "QXXZDHQD": "Выберите пункты заказа",
    "DingHuoQingDan": "Список заказов",
    "SQTHJE": "Запрашиваемая сумма возврата",
    "DJXZSP": "Нажмите для выбора товаров",
    "TuiHuoJinE": "Сумма возврата",
    //refund-detail
    "THDDXQ": "Детали возврата",
    "YiTuiHuo": "Возвращено",
    "YiTuiKuan": "Возвращены средства",
    "THDZT": "Статус возврата",
    "TuiHuoDanHao": "Номер возврата",
    "TuiHuoShiJian": "Время возврата",
    "TuiHuoCangKu": "Склад возврата",
    "THLXR": "Контакт возврата",
    "TuiHuoQingDan": "Список возврата",
    "TuiKuanZongE": "Общая сумма возврата",
    "TuiKuanQingKuang": "Статус возврата средств",
    "DaiTuiJinE": "Ожидает возврата",
    "YiTuiJinE": "Возвращено",
    //refund-product
    "SPMC_BH_GG": "Название товара / Код / Спецификация / Штрихкод",
    "GZD1TJG": "Найдено 1 совпадение",
    "JiaRuQingDan": "Добавить в список",
    //refund-result
    "ShenQingChengGong": "Запрос успешен",
    "THDTJCG": "Запрос на возврат отправлен",
    "ChaKanXiangQing": "Посмотреть детали",
    //goods-package-floor
    "HDWKS_WDZL": "Мероприятие не началось",
    "HDYJS_XCZD": "Мероприятие завершено",
    "ZWSZBT": "Нет заголовка",
    "ChaKanGengDuo": "Посмотреть больше",
    //goods-promotion-floor
    "HCDZSJC": "Разница во времени из-за кэша",
    "DLCKCXJ": "Войдите, чтобы увидеть цену",
    "ZWSZCX": "Нет акций",
    "JuKaiShi": "До начала",
    "Song": "Подарок",
    "JuJieShu": "До окончания",
    "YiJieShu": "Завершено",
    //search-floor
    "XiaoXi": "Сообщение",
    "SaoMaXiaDan": "Заказ по сканированию",
    //home-page-custom
    "WZLCSJ": "Данные неизвестны",
    //jump-error
    "QXZYSDHAPP": "Скачать приложение YUNSHANG",
    "QMTYQYGLD": "Полный опыт управления",
    "XZYSDHAPP": "Скачать приложение YUNSHANG",
    "HQGLDWZTY": "Получить полный опыт",
    "JXTYDHD": "Продолжить заказ",
    //notice-detail
    "GongGaoXiangQing": "Детали уведомления",
    "GongGaoFuJian": "Вложение уведомления",
    //shop-error
    "NFWDYMBCZO": "Страница не найдена",
    "KeNengYuanYin": "Возможные причины",
    "1_ZDZLSRCWD": "1. Неверный URL",
    "2_DJLGQLJ": "2. Ссылка устарела",
    //shop-index
    "GuanLiDuan": "Управление",
    "ZhuCe": "Регистрация",
    "HYNTYYSDH": "Добро пожаловать в YUNSHANG",
    "TYZHSJHDQG": "Данные демо-аккаунта будут обновлены",
    "TYZHZDNRSJ": "Данные в демо-аккаунте имитируются",
    "ZHZCCG": "Регистрация успешна",
    "DengLuZhangHao": "Аккаунт для входа",
    "CSMMW": "Пароль по умолчанию",
    "GNFYHQL": "Вы получили купон",
    "Man1YuanKeYong": "Мин. ¥{num} для использования",
    "LQH1TNKY": "Действителен {day} дней",
    "YiJianLingQu": "Получить сейчас",
    "GXNHD1ZYHQ": "Поздравляем, вы получили {num} купонов ¥{price} {name}",
    "Gong1Yuan": "Всего ¥{num}",
    "LiJiShiYong": "Использовать сейчас",
    //shop-login
    "NHWDL": "Вы не вошли",
    //shop-notice
    "ShangChengGongGao": "Объявления магазина",
    "ZanWuGongGao": "Нет объявлений",
    "1GeFuJian": "{num} вложений",
    //deposit-detail
    "KouKuan": "Списание",
    "ChongZhi_Kuan": "Пополнение",
    "KouKuanZuoFei": "Отмена списания",
    "ChongZhiZuoFei": "Отмена пополнения",
    "ZhangHuMingXi": "Детали счета",
    "ZhangHuYuE": "Баланс счета",
    "LiJiChongZhi": "Пополнить сейчас",
    //deposit-recharge
    "CZJEBNXY1Y": "Мин. пополнение ¥1",
    "QSRZQDSZ": "Введите корректное значение",
    "ZDYJE": "Пользовательская сумма",
    "ZWKTXSCZGN": "Невозможно пополнить онлайн",
    "ShiFuJinE": "Фактическая сумма оплаты",
    "ZhangHuChongZhi": "Пополнение счета",
    "QXZCZJE": "Выберите сумму пополнения",
    "QSRCZJE": "Введите сумму пополнения",
    "QLXNDZSYWY": "Свяжитесь с торговым представителем",
    "ShouJia": "Цена продажи",
    "YiShouQing": "Распродано",
    "ChongZhiJinE": "Сумма пополнения",
    "QueRenFuKuan": "Подтвердить оплату",
    //deposit-recharge-result
    "QSDDID": "Нет ID заказа",
    "ChongZhiChengGong": "Пополнение успешно",
    "ChongZhiShiBai": "Ошибка пополнения",
    "CLZ_QSH...": "Обработка, подождите...",
    "ChongZhiFangShi": "Способ пополнения",
    "ChongZhiShiJian": "Время пополнения",
    "JYLSH": "Номер транзакции",
    "FanHuiShangCheng": "Вернуться в магазин",
    //recharge-online
    "ZFSB_QCS": "Ошибка оплаты, попробуйте снова",
    "ZFYQX": "Оплата отменена",
    "ZFYC_QCS": "Ошибка оплаты, попробуйте снова",
    //user
    "LingQuanZhongXin": "Центр купонов",
    "WeiShiYong": "Не использовано",
    "YiShiYong": "Использовано",
    "ZWYHQ": "Нет купонов",
    //keep-list
    "YiGouMai": "Куплено",
    "ChangYongQingDan": "Часто используемый список",
    "WoDeShouCang": "Мои избранные",
    "QuGouWuChe": "В корзину",
    "GeShangPin": "Товары",
    //login
    "YunShangDingHuo": "YUNSHANG",
    "QSRZH": "Введите аккаунт!",
    "QSRMM": "Введите пароль!",
    "QSRDLZH": "Введите аккаунт для входа",
    "JiZhuMiMa": "Запомнить пароль",
    "WangJiMiMa": "Забыли пароль?",
    "DengLu": "Войти",
    "DLZHBCZ_QL": "Аккаунт не существует, свяжитесь с администратором",
    "GQYZHSBJY_": "Аккаунт компании отключен",
    "GQYZHSYQJS_": "Пробный период истек",
    "GQYZHYGQL_": "Аккаунт истек, требуется продление",
    "LiJiTiYan": "Попробовать сейчас",
    //my-collect
    "YiChuChengGong": "Успешно удалено",
    "QueHuo": "Нет в наличии",
    "YCSCJ": "Удалить из избранного",
    //order-message
    "SheZhiChengGong": "Настройки успешны",
    "ZWWDXX": "Нет непрочитанных сообщений",
    "QuanBuYiDu": "Отметить все как прочитанные",
    "DingDanXiaoXi": "Сообщения заказа",
    "YiQiang": "Уже взято",
    "LiJiLingQu": "Получить сейчас",
    "LingQuanHou": "После получения купона",
    "TianNeiKeYong": "действителен в течение {n} дней",
    "QSRSJH": "Введите номер телефона",
    "QSRYZM": "Введите код подтверждения",
    "QSRXMM": "Введите новый пароль",
    "QSRZQSJGS": "Введите корректный номер телефона",
    "ChongZhiMiMa": "Сбросить пароль",
    "QSRNDSJHM": "Введите ваш номер телефона",
    "QSRDXYZ": "Введите SMS-код",
    "HQYZM": "Получить код",
    "HKCXHQ": "Повторная отправка через {n}",
    "QSR6_20WSZHZ": "Пароль: 6-20 символов (цифры/буквы)",
    //share-setting
    "QSRSPJGBL": "Введите коэффициент цены товара",
    "SPJGBLBXDY": "Коэффициент должен быть 100-999.99",
    "DPMCZBZCTS": "Название магазина не поддерживает спецсимволы",
    "LXRZBZCTSF": "Имя контакта не поддерживает спецсимволы",
    "LXFSZBZCTS": "Контактная информация не поддерживает спецсимволы",
    "LXDZZBZCTS": "Адрес не поддерживает спецсимволы",
    "DPJJZBZCTS": "Описание магазина не поддерживает спецсимволы",
    "QSRDPJJ_ZD": "Введите описание магазина (макс. 50 символов)",
    "FenXiangSheZhi": "Настройки обмена",
    "NDWSCSPJG": "Ваша цена товара",
    "NDDHJ_": "Ваша цена заказа ×",
    "LXXX_KBJ_": "Контактная информация (можно редактировать)",
    "DianPuMingCheng": "Название магазина",
    "JianJie": "Описание",
    "QSRDPMC": "Введите название магазина",
    "LianXiRen": "Контакт",
    "QSRLXR": "Введите имя контакта",
    "LianXiFangShi": "Способ связи",
    "QSRLXFS": "Введите контактную информацию",
    "LianXiDiZhi": "Контактный адрес",
    "QSRLXDZ": "Введите контактный адрес",
    //user
    "WoDeDingDan": "Мои заказы",
    "ZuiJinLiuLan": "Недавно просмотренные",
    "ShouCangShangPin": "Избранные товары",
    "BDYYZH_ZC": "Привязать существующий аккаунт | Регистрация",
    "DL_ZC": "Войти | Зарегистрироваться",
    "BangDingShouJi": "Привязать телефон",
    "TS_BDSJHM_": "Совет: Привяжите телефон для безопасности!",
    "ChaKanQuanBu": "Посмотреть все",
    "ShouHuoDiZhi": "Адрес доставки",
    "LianXiWoMen": "Связаться с нами",
    "SheZhi": "Настройки",
    "QuQianDao": "К отметке",
    "QianDao": "Отметка",
    "JiFenShangCheng": "Магазин баллов",
    "TuiGuangShangPin": "Продвигать товары",
    "QuChaKan": "Посмотреть",
    "JiFenHuanLi": "Обмен баллов на подарки",
    "DYSPBQ": "Печать этикеток товаров",
    //user-about
    "GYYSDH": "О YUNSHANG",
    "YQHYSMEWM_": "Пригласите друзей отсканировать QR-код",
    "DangQianBanBen": "Текущая версия",
    //user-address
    "ZWSHDZ": "Нет адресов доставки",
    "WoDeDiZhi": "Мои адреса",
    "ZhiNengShiBie": "Умное распознавание",
    "ZTDZXXKZNS": "Вставьте информацию об адресе для распознавания",
    "MoRen": "По умолчанию",
    "QRSCDZ": "Подтвердить удаление адреса?",
    "SHRXM": "Имя получателя",
    "SJHMHGDDHZ": "Требуется телефон или домашний телефон",
    "QSRSHRXM": "Введите имя получателя",
    "ShouJiHaoMa": "Номер телефона",
    "GuDingDianHua": "Домашний телефон",
    "QSRGDDH": "Введите домашний телефон",
    "SuoZaiDiQu": "Регион",
    "QSRSZDQ": "Выберите регион",
    "QSRXXDZ": "Введите полный адрес!",
    "QSRZQDSJHM": "Введите действительный номер телефона",
    "QSRZQDGDDH": "Введите действительный домашний телефон",
    "XiangXiDiZhi": "Полный адрес",
    "MoRenDiZhi": "Адрес по умолчанию",
    "SWMRDZ": "Установить по умолчанию",
    "BCBSY": "Сохранить и использовать",
    //user-bing-one
    "QSRSJHM": "Введите номер телефона",
    "GYHYZC": "Пользователь уже зарегистрирован",
    "GSJHMYJZCG": "Этот номер уже зарегистрирован",
    "QZJDLJK": "Пожалуйста, войдите напрямую",
    "QuDengLu": "К входу",
    "BDHKYTGSJH": "Привязка для входа по телефону",
    "_BDHKYTGSJ": "*Привязка для входа по телефону",
    "QSRSJYZM": "Введите SMS-код",
    "BDXSJ": "Привязать новый телефон",
    "DXYZM": "SMS-код",
    "XiaYiBu": "Далее",
    "TGCBZ": "Пропустить",
    //user-bing-two
    "DBDSJHMBCZ": "Номер для привязки не существует!",
    "QSRDLMM": "Введите пароль!",
    "_GSJHMYBDY": "*Этот номер уже привязан",
    "DQZHMMJTBW": "Пароль аккаунта будет синхронизирован",
    "DangQianZhangHao": "Текущий аккаунт",
    "QDYJZ": "Подтвердить удаление",
    "JSPSCM": "Этот товар?",
    "ShanChuChengGong": "Успешно удалено!",
    //user-info
    "SJGSCW": "Неверный формат номера",
    "YXGSCW": "Неверный формат email",
    "WoDeZhangHao": "Мой аккаунт",
    "YouXiang": "Email",
    "ShouJi": "Телефон",
    "XingMing": "Полное имя",
    "XiuGaiTouXiang": "Изменить аватар",
    "JiBenXinXi": "Основная информация",
    "ZhangHaoAnQuan": "Безопасность аккаунта",
    "XiuGaiMiMa": "Изменить пароль",
    "DianJiBangDing": "Нажмите для привязки",
    "RYDSHTY_QL": "Если утерян или не используется, немедленно измените",
    "WBZNDZHAQ_": "Привяжите телефон для безопасности",
    "QSRNDXM": "请输入您的姓名",
    "QSRNDDH": "请输入您的电话",
    "QSRNDYX": "请输入您的邮箱",
    //user-setting
    "QCHCHXCXDL": "Очистка кэша требует повторного входа",
    "QingChuHuanCun": "Очистить кэш",
    "QDYQCHCM": "Подтвердить очистку кэша?",
    "TuiChuDengLu": "Выйти",
    "ZhangHaoZhuXiao": "Удалить аккаунт",
    "QieHuanZhangHao": "Сменить аккаунт",
    //user-supplier
    "LianXi": "Контакт",
    "GongSiDianHua": "Телефон компании",
    "DiZhi": "Адрес",
    //vouchers-detail
    "DJQMX": "Детали купона",
    //vouchers-list
    "BuKeYong": "Недоступно",
    "KeYong": "Доступно",
    "ZWDJQ": "Нет купонов",
    "ZongEDu": "Общая сумма",
    "FaFangShiJian": "Время выдачи",
    "EDYYW": "Срок действия истек",
    //vouchers-select-list
    "WDDJQ": "Мои купоны",
    "KYDJQ": "Доступные купоны",
    "DJQKDK": "Купон можно использовать",
    "CKKYSP": "Посмотреть подходящие товары",
    "BKYDJQ": "Купон недоступен",
    "BKYYY_ZWFH": "Причина: Нет подходящих товаров",
    //goods-detail
    "DQSPWSCGGT": "У этого товара нет изображений спецификаций",
    "BoFangShiPin": "Воспроизвести видео",
    "Gong1GeGuiGe": "Всего {num} спецификаций",
    "YiXuanGuiGe": "Выбрана спецификация",
    "XuanGuiGe": "Выбрать спецификацию",
    "LingQuan": "Получить купон",
    "1ZhongCuXiao": "{num} акций",
    "1ZhangKeYong": "{num} доступно",
    "ZuiGaoKeSheng": "Максимальная экономия",
    "ShangPinTaoCan": "Набор товаров",
    "Gong1GeTaoCan": "Всего {num} наборов",
    "ShangPinCanShu": "Параметры товара",
    "ZhanKai": "Развернуть",
    "YiShouCang": "В избранном",
    "ShouCang": "В избранное",
    "KeFu": "Поддержка",
    "XiangQing": "Детали",
    "TuiJian": "Рекомендации",
    "BianHao": "Код",
    "ShangPinXinXi": "Информация о товаре",
    "KLYHQ": "Можно получить купон",
    "KuCunBuZu": "Недостаточно запасов",
    "DuoGuiGe": "Многовариантный",
    "YiShou": "Продано",
    "SWBHZ_YS": "Нет запасов, распродано",
    "CuXiaoShangPin": "Товар по акции",
    //goods-search
    "NHWSRSSNR": "Вы не ввели ключевые слова",
    "SouSuo": "Поиск",
    "SSY1XGDSP": "Поиск товаров по {searchKey}",
    "Yue1GeShangPin": "Около {num} товаров",
    "ZuiJinSouSuo": "Недавний поиск",
    "QingChu": "Очистить",
    "ZWSSJL": "Нет истории поиска",
    //goods-property
    "ZGJGBNDYZD": "Максимальная цена не может быть ниже",
    "ShangPinBiaoQian": "Метки товара",
    "BuGaoYu1": "Не более 1",
    "BuDiYu1": "Не менее 1",
    "FengGe": "Стиль",
    //goods-promotion-list
    "JiJiangKaiShi": "Скоро начнется",
    "QuanBuCuXiao": "Все акции",
    //goods-package-list
    "Gong1JianShangPin": "Всего {num} товаров",
    "Sheng": "Экономия",
    //goods-package-detail
    "GTCZGWCZDS": "Этот набор достиг лимита корзины",
    "GTCKCBZ_BK": "Недостаточно запасов набора",
    "JinSheng1Tao": "Осталось {num} наборов",
    "XianGou1Tao": "Максимум {num} наборов",
    "TaoCanXiangQing": "Детали набора",
    "DanMaiJia": "Цена за единицу",
    "TaoCanJia": "Цена набора",
    "HDYJS": "Акция закончилась",
    //goods-message
    "WDL_QXDL": "Не вошли, войдите",
    //goods-list-label
    "XinPinShangShi": "Новинки",
    "WDLZH_ZWCX": "Не вошли, нет акций",
    "YiXiaShangPin": "Товары ниже",
    //goods-list
    "1ZhongGuiGe": "{num} спецификаций",
    "YouKuCun": "В наличии",
    //goods-filter
    "BuGaoYu": "Не более",
    "BuDiYu": "Не менее",
    "CuXiao": "Акция",
    "ZDYXXZ3G": "Выберите до 3",
    "GouMai": "Купить",
    "Gong1Jian": "Всего {num} единиц",
    // Дополнительные ключи
    "YiChuShouCangJia": "Удалить из избранного",
    "$": "¥",
    "$1": "¥{num}",
    "_8999_1Qi": "От ¥8999.1",
    "Ge": "шт.",
    "BaoZhuangFangShi": "Способ упаковки",
    "QRSCSP_": "Подтвердить удаление товара?",
    "JEWM_TMFRK": "Сканировать QR/штрих-код",
    "0ZSP_G0J": "0 видов товаров, 0 единиц",
    "JiuMiMa": "Старый пароль",
    "XMM_6_20WZ": "Новый пароль (6-20 символов)",
    "QueRenMiMa": "Подтвердить пароль",
    "BDHKSYSJHD": "Привязка для входа по телефону",
    "YanZhengMa": "Код подтверждения",
    "1MHKCXHQ": "Повторить через 1 секунду",
    "CSJHZ1MQFS": "Код отправлен, повторите позже",
    "GouMaiJiLu": "История покупок",
    "XinZengDiZhi": "Добавить новый адрес",
    "LingShouJia": "Розничная цена",
    "YouHuiJia": "Цена со скидкой",
    "ShangPinChuKu": "Товар отсутствует",
    "DengDaiShouHuo": "Ожидает доставки",
    "ShouHuoRen": "Получатель",
    "PaiZhao": "Сфотографировать",
    "XiangCe": "Галерея",
    "TiYanGuan": "Выставочный зал",
    "JingYingShiJian": "Часы работы",
    "ZhanGuanDianHua": "Телефон выставочного зала",
    "ZhanGuanDiZhi": "Адрес выставочного зала",
    "SJHQZ_QSDZ": "Загрузка, подождите...",
    "QXXZSF_": "Сначала выберите провинцию!",
    "QuanBuShengFen": "Все провинции",
    "QuanBuChengShi": "Все города",
    "YingYeShiJian": "Часы работы",
    "ChanPinBianHao": "Артикул товара",
    "DLXXYGQ_QC": "Сессия истекла, войдите снова",
    "Man999Jian100": "Купи {m} сэкономь {n}",
    "YiManZu": "Достигнуто",
    "QDYCSP_": "Подтвердить удаление товара?",
    "DGM10JZ1J": "Купи 10 получи 1 бесплатно",
    "XiaXianTongZhi": "Уведомление о выходе из сети",
    "NDZHYZQTSB": "Ваш аккаунт вошел на другом устройстве",
    "ManJiang": 'Купи {target} сэкономь {num}',
    "ZGLXMJ": 'Купи еще {num} сэкономь {money_}',
    "ZGLXMZ": 'Купи еще {num} получи скидку {percent}%',
    "QSRZQNR": 'Введите корректные данные',
    "NHYDDQKWJQ": 'У вас {num} ожидающих заказов',
    "FaPiaoZhuShou": "Помощник по счетам",
    "WoDeFaPiao": "Мои счета",
    "FaPiaoXiangQing": "Детали счета",
    "KaiPiaoShiJian": "Время выставления счета",
    "DaiKaiFaPiao": "Счет не выставлен",
    "DKFPJE": "Сумма ожидающих счетов",
    "KaiPiaoJinE": "Сумма счета",
    "ZFYDWT_QCSCXZF": "Проблема с оплатой, попробуйте другой способ",
    "QingXuanZhe": "Пожалуйста, выберите",
    "ShouXin": 'Кредит',
    "LJSQSXED": "Подать заявку на кредит",
    "SXEDSHZ": "Кредит на рассмотрении",
    "SXCZ_XDCG": "Кредита достаточно, заказ успешен",
    "SXEDBZ_FKHFH": "Недостаточно кредита, оплатите перед отправкой",
    "CGJKZQ_FKFH": "Просрочено, оплатите перед отправкой",
    "DDTJCG_XZZCZHYB": "Заказ успешен, остался последний шаг!",
    "MianFeiLing": "Бесплатно",
    "M_KMFLQ_HQ": "Купи {target} получи бесплатно, осталось {short}",
    "YHDMFSP": "Уже получили бесплатный товар",
    "JRMFL": "Бесплатно сегодня",
    "LingGuangLe": "Распродано",
    "KeLingQu": "Можно получить",
    "YuGuJia": "Ориентировочная цена",
    "GXNHQ_Z_Y_": "Поздравляем, вы получили {num} купонов ¥{price} {name}",
    "LXZSKF": "Связаться с торговым представителем",
    "DPYDY_QSHX": "Магазин закрыт, закажите позже",
    "DaYangShiJian": "Время закрытия",
    "ChuanHaoChaXun": 'Проверить серийный номер',
    'IMEI': 'Серийный номер',
    "FanKuanYuE": "Баланс возврата",
    "FanKuanZhiFu": "Оплатить возвратом",
    "JingDongYiYunJia": "Jingdong Yiyun+",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "Недостаточно средств для возврата",
    "FanKuanZhangHu": "Счет возврата",
    "HaiXuZhiFu": "Нужно доплатить {price}",
    "QTXGSMC": "Введите название компании",
    "QSCSFZZMZ": "Загрузите лицевую сторону ID",
    "QSCSFZFMZ": "Загрузите обратную сторону ID",
    "QSCYYZZ": "Загрузите лицензию",
    "TJCG_QNXDDSH": "Успешно отправлено, ожидайте проверки",
    "SXSQ": "Запрос кредита",
    "QYJBZL": "Базовая информация компании",
    "SQFRSFZZM": "Загрузите лицевую сторону ID",
    "ZMSLT": "Пример лицевой стороны",
    "SCFRSFZFM": "Загрузите обратную сторону ID",
    "FMSLT": "Пример обратной стороны",
    "QQBSFZSJWZ_WZQXKBB": "Убедитесь, что ID четкий",
    "SCYYZZ": "Загрузите лицензию",
    "ShengHeZhong": "На рассмотрении",
    "TiJiaoShenHe": "Отправить на проверку",
    "GSMC": "Название компании",
    "DDDKFQRBJQSH": "Заказ ожидает подтверждения цены",
    "XDTX": "Напоминание о заказе",
    "NH_GDDBH": "Некоторые товары требуют подтверждения цены",
    "QRXD": "Подтвердить заказ",
    "DaiHeJia": "Ожидает цены",
    "ZHJY": "Баланс счета",
    "YGTG": "Продвижение сотрудников",
    "YuanGong": "Сотрудник",
    "DuiZhanGJieSuan": "Расчет счета",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "Баланс = Депозит + Возврат + Ожидающий возврат - Неоплаченные заказы",
    "YCKYE": "Баланс депозита",
    "FKYE": "Баланс возврата",
    "DDYFK": "Неоплаченные заказы",
    "THDTK": "Ожидающий возврат",
    "YuCunKuanZuoFei": "Депозит отменен",
    "FanKuanZhangHuMingXi": "Детали счета возврата",
    "TKCZDFKZH": "Пополнить счет возврата",
    "RMBJE": "Сумма в RMB"
};
exports.default = ru_RU;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// th_TH.js
var th_TH = {
    "GuanShui": "‌ภาษีศุลกากร",
    "ZiZhangHao": "บัญชีย่อย",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",
    //components
    "ShangeChuanYanZhengTuPian": "อัปโหลดรูปภาพยืนยัน",
    "ChuanHaoYanZheng": "ตรวจสอบหมายเลขซีเรียล",
    "YanZhengChuanHao": "ยืนยันหมายเลขซีเรียล",
    "Ci": "ครั้ง",
    "DingDanMan": "คำสั่งซื้อเต็ม",
    "YuanZeng": "บาท ของแถม",
    "SCFJ_ZD4Z_DZBCG": "อัปโหลดไฟล์แนบ สูงสุด 4 รูป แต่ละรูป ≤3MB",
    //ChatRoom
    "ZBZCBQFH": "ไม่รองรับอีโมจิ",
    "FaSongLianJie": "ส่งลิงก์",
    "YiChangXiaoXi": "ข้อความผิดปกติ",
    "QingShuRu": "กรุณากรอก",
    "FaSong": "ส่ง",
    //DateSelector
    "DQSJXYKSSJ": "เวลาปัจจุบันก่อนเวลาเริ่มต้น",
    "DQSJCGJSSJ": "เวลาปัจจุบันเกินเวลาสิ้นสุด",
    "QuXiao": "ยกเลิก",
    "NianYueRi": "ปี-เดือน-วัน",
    "ShiFen": "ชั่วโมง-นาที",
    "QueDing": "ยืนยัน",
    "Nian": "ปี",
    "Yue": "เดือน",
    "Ri": "วัน",
    "Shi": "ชั่วโมง",
    "Fen": "นาที",
    //goods-list-card
    "Qi": "เริ่มต้น",
    //goods-promotion
    "1GeCuXiao": "{num} โปรโมชัน",
    "ChaKanZengPin": "ดูของแถม",
    "JHDJSHS_1T": "เวลาที่เหลือ: {d}วัน {h}ชม. {m}นาที {s}วิ",
    "YHGZ_ZPBKD": "เงื่อนไข: ของแถมใช้ร่วมกันไม่ได้",
    "YHGZ_AZZGM": "เงื่อนไข: ส่วนลดตามจำนวน",
    "GuanBi": "ปิด",
    "Man1Song1": "ซื้อ {mai} แถม {song}",
    //group-filtrate
    "QuanBu": "ทั้งหมด",
    "ZWXGSJ": "ไม่มีข้อมูลที่เกี่ยวข้อง",
    "ZuiDiJia": "ราคาต่ำสุด",
    "ZuiGaoJia": "ราคาสูงสุด",
    "LeiXing": "ประเภท",
    "PinPai": "แบรนด์",
    "BiaoQian": "แท็ก",
    "JiaGeQuJian": "ช่วงราคา",
    "SPMC_GG_BH_": "ชื่อสินค้า / สเปก / รหัส / ตัวอักษรแรก",
    "SPMC_GG_BH_G": "ชื่อสินค้า / สเปก / รหัส",
    "ZuHeShaiXuan": "ตัวกรองรวม",
    "ChongZhi_CanShu": "รีเซ็ต",
    //image-upload
    "ZDKSC1ZTP": "สูงสุด 1 รูป",
    "ZYXSCTP": "รูปภาพเท่านั้น",
    "SCTPDXBYXC": "ขนาดรูป ≤5MB",
    "QBYCFSCTP_": "ไม่อนุญาตอัปโหลดซ้ำ",
    "ShangChuanChengGong": "อัปโหลดสำเร็จ",
    "ZDKSC1Z": "สูงสุด 1",
    //keyboard
    "CCSLZDXZ": "เกินขีดจำกัด",
    "QiDingLiang": "จำนวนขั้นต่ำ",
    "ShouQi": "ปิด",
    "ShanChu": "ลบ",
    //MultiPicker
    "FanHui": "กลับ",
    //order-cart
    "Dai": "ตัวแทน",
    "YiQuXiao": "ยกเลิกแล้ว",
    "ZengPin": "ของแถม",
    "1Zhong": "{num} ประเภท",
    "1Jian": "{num} ชิ้น",
    "HeJi": "รวม",
    "DaiFu": "รอชำระเงิน",
    //order-promotion
    "_DDM1YZ1J_": "[ซื้อ {target} แถม {name}x{number}]",
    "_DDM1YLJ1Y_": "[ซื้อ {m} ลด {n}]",
    "_DDM1YLX1Z_": "[ซื้อ {m} ลด {n}%]",
    "DingDanCuXiao": "โปรโมชันคำสั่งซื้อ",
    //page-ad
    "DLCKJG": "เข้าสู่ระบบเพื่อดูราคา",
    //page-floating
    "DianPuZhuYe": "หน้าหลักร้านค้า",
    "GouWuChe": "ตะกร้า",
    "ZaiXianKeFu": "บริการลูกค้า",
    "GeRenZhongXin": "โปรไฟล์",
    "LianXiDianHua": "ติดต่อ",
    "FanHuiDingBu": "กลับด้านบน",
    //page-null
    "ZBDYML": "ไม่พบหน้า",
    "KNWZCW_HZY": "URL ผิดหรือหน้าถูกลบ",
    "FanHuiShangJi": "กลับ",
    "FanHuiShouYe": "กลับหน้าหลัก",
    //product-edit
    "SPQDBNWK": "รายการสินค้าว่างเปล่า",
    "WoZhiDaoLe": "เข้าใจแล้ว",
    "SFQRSCSP": "ยืนยันลบสินค้า?",
    "QueRen": "ยืนยัน",
    "ZYXSRSZBQB": "ตัวเลขเท่านั้น สูงสุด 2 ทศนิยม",
    "ShangPinDanJia": "ราคาต่อหน่วย",
    "YSPYJ": "ราคาดั้งเดิม",
    "QSRZDJG": "กรอกราคาที่ตั้ง",
    "ShuLiang": "จำนวน",
    "DanWei": "หน่วย",
    "DanJia": "ราคา",
    "BeiZhu": "หมายเหตุ",
    "YiChuShangPin": "นำสินค้าออก",
    "XiuGai": "แก้ไข",
    //yunshl
    "TPSLCCYXSZ": "จำนวนรูปเกินจำกัด!",
    "WJBDDY5M_QC": "ไฟล์ ≤5MB กรุณาเลือกใหม่",
    "TPSCWC": "อัปโหลดรูปเสร็จ",
    //BusinessFilter
    "_DGSLM1Z1_": "[สั่งซื้อ {target} แถม {provide}]",
    "_M1JLXMJ1Y_": "[ซื้อ {target} ลด {cut_money_}/หน่วย]",
    "_DHJJZ1Y_": "[ราคาลดเหลือ {cuted_price_}]",
    "_M1JLXMJ1Z_": "[ซื้อ {target} ลด {cut_percent_}%/หน่วย]",
    "_YDHJD1Z_": "[ราคาดั้งเดิมลด {cuted_percent_}%]",
    "YuJiKaiShiFaHuo": "คาดการณ์จัดส่ง: {date}",
    "YuJi": "คาดการณ์",
    "MMYDDR": "BB/HH",
    "KaiShiFaHuo": "เริ่มจัดส่ง",
    "_M1LXM1Y_": "[ซื้อ 1 ลด 1/หน่วย]",
    "_M1LXM1Z_": "[ซื้อ 1 ลด 1%/หน่วย]",
    "DaiQueRen": "รอยืนยัน",
    "DaiFaHuo": "รอจัดส่ง",
    "DaiShouHuo": "รอรับสินค้า",
    "YiWanCheng": "เสร็จสมบูรณ์",
    "DaiFuKuan": "รอชำระเงิน",
    "YiFuKuan": "ชำระเงินแล้ว",
    "YiZuoFei": "ยกเลิกแล้ว",
    "DaiShenHe": "รอตรวจสอบ",
    "DaiHeXiao": "รอการใช้งาน",
    "YiHeXiao": "ใช้งานแล้ว",
    "XianXiaZhiFu": "ชำระเงินออฟไลน์",
    "ZhiNengDaoZhangShiBie": "โอนเงิน (ยืนยันอัตโนมัติ)",
    "WeiXinZhiFu": "WeChat Pay",
    "KQ-WeiXinZhiFu": "99Bill (WeChat)",
    "KQ-ZFBZF": "99Bill (Alipay)",
    "KQZhiFu": "99Bill Pay",
    "ZFBZF": "Alipay",
    "YuEZhiFu": "ชำระด้วยยอดเงิน",
    "HuoDaoFuKuan": "ชำระเมื่อได้รับสินค้า",
    "DaiTuiHuo": "รอคืนสินค้า",
    "DaiTuiKuan": "รอคืนเงิน",
    "ChuangJianDingDan": "สร้างคำสั่งซื้อ",
    "BianJiDingDan": "แก้ไขคำสั่งซื้อ",
    "TiJiaoDingDan": "ส่งคำสั่งซื้อ",
    "DingDanShenHe": "ตรวจสอบคำสั่งซื้อ",
    "CaiWuShenHe": "ตรวจสอบการเงิน",
    "BoHui": "ปฏิเสธ",
    "TianJiaShouKuan": "เพิ่มการชำระเงิน",
    "ZaiXianZhiFu": "ชำระเงินออนไลน์",
    "ShouKuanShenHe": "ตรวจสอบการชำระเงิน",
    "ShouKuanZuoFei": "ยกเลิกการชำระเงิน",
    "ChuKu": "ออกจากคลัง",
    "ChuKuShenHe": "ตรวจสอบการออกคลัง",
    "FaHuo": "จัดส่ง",
    "TianJiaWuLiu": "เพิ่มข้อมูลขนส่ง",
    "XiuGaiWuLiu": "แก้ไขข้อมูลขนส่ง",
    "ChuKuZuoFei": "ยกเลิกการออกคลัง",
    "ShouHuo": "รับสินค้า",
    "DingDanHeZhun": "อนุมัติคำสั่งซื้อ",
    "QuXiaoDingDan": "ยกเลิกคำสั่งซื้อ",
    "CJTHD": "สร้างคืนสินค้า",
    "DaYin": "พิมพ์",
    "DaoChu": "ส่งออก",
    "DingDanWanCheng": "คำสั่งซื้อเสร็จสมบูรณ์",
    "QiangZhiWanCheng": "เสร็จสมบูรณ์แบบบังคับ",
    "DingDanZuoFei": "ยกเลิกคำสั่งซื้อ",
    "MaiZeng": "ซื้อแถมฟรี",
    "ZhiJiang": "ลดทันที",
    "DaZhe": "ส่วนลด",
    "YuShou": "พรีออเดอร์",
    "DingDanManZeng": "แถมเมื่อสั่งซื้อครบ",
    "DingDanManJian": "ลดเมื่อสั่งซื้อครบ",
    "DingDanManZhe": "ส่วนลด% เมื่อสั่งซื้อครบ",
    "XinRenQuan": "คูปองสมาชิกใหม่",
    "ManJianQuan": "คูปองส่วนลด",
    "ShangPinQuan": "คูปองสินค้า",
    "DaiJieSuan": "รอการชำระ",
    "YiJieSuan": "ชำระแล้ว",
    "QuanBuShangPin": "สินค้าทั้งหมด",
    "TuiJianShangPin": "สินค้าแนะนำ",
    "XinPin": "ใหม่",
    "ReXiaoShangPin": "ยอดนิยม",
    "ChangYongShangPin": "ซื้อบ่อย",
    //BusinessUtil
    "DaiShouKuan": "รอรับเงิน",
    "BuFenShouKuan": "รับเงินบางส่วน",
    "YiShouKuan": "รับเงินแล้ว",
    "BXYFP": "ไม่ต้องการใบแจ้งหนี้",
    "ZZSPTFP": "ใบแจ้งหนี้ VAT ทั่วไป",
    "ZZSZYFP": "ใบแจ้งหนี้ VAT พิเศษ",
    "QiTaFaPiao": "ใบแจ้งหนี้อื่น",
    "XianXia": "ออฟไลน์",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "เงินมัดจำ",
    "XianXiaZhuangZhang": "โอนเงิน",
    "XianShangZhiFu": "ชำระออนไลน์ (WeChat/Alipay/JD/UnionPay)",
    "YCKZF": "ชำระด้วยยอดเงิน",
    "DaiTiJiao": "รอส่ง",
    "KuaiDi": "จัดส่งด่วน",
    "SongHuoShangMen": "ส่งถึงบ้าน",
    "ShangMenZiQu": "รับเอง",
    "WuLiuHuoYun": "ขนส่งสินค้า",
    "QiTa": "อื่น",
    //check-util
    "QSRBXY6WDM": "รหัสผ่าน ≥6 ตัวอักษร",
    "QSRBDY20WDM": "รหัสผ่าน ≤20 ตัวอักษร",
    "MMGSCW": "รูปแบบรหัสผ่านไม่ถูกต้อง",
    //common-utils
    "SJCW_QLXKF": "ข้อผิดพลาดข้อมูล ติดต่อฝ่ายสนับสนุน",
    "ZBZCQD": "ไม่รองรับการลงทะเบียน",
    "HuJiao": "โทร",
    "DLZHBCZ": "บัญชีไม่มีอยู่",
    "QLXGLYKT": "ติดต่อแอดมินเพื่อเปิดใช้งาน",
    "GQYZHBJY": "บัญชีบริษัทถูกปิดใช้งาน",
    "QLXYSDH": "ติดต่อ YUNSHANG",
    "GQYZHSYQJS": "หมดระยะทดลองใช้",
    "GQYZHYGQL": "บัญชีหมดอายุ",
    "XYXFCNSY": "ต้องต่ออายุ",
    "GQYBCZCZH": "บัญชีบริษัทไม่ถูกต้อง",
    "NDDHZHYBQY": "บัญชีของคุณถูกปิดใช้งานโดยบริษัท",
    "NYBSQY1DHZ": "ไม่ใช่พาร์ทเนอร์อีกต่อไป",
    "NDDPYBTY_B": "ร้านค้าถูกระงับ",
    "GZHWKTDSZB": "โมดูลไฟไม่เปิดใช้งาน",
    "WXSQYZYGQ": "การตรวจสอบ WeChat หมดอายุ",
    "WXSQSB": "การตรวจสอบ WeChat ล้มเหลว",
    "WXSQSB_CWX": "การตรวจสอบ WeChat ล้มเหลว: {msg}",
    "DengLuGuoQi": "เข้าสู่ระบบหมดอายุ",
    "DLGQ_QCXDL": "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่",
    //data-constant
    "ShangJia": "วางขาย",
    "YiXiaJia": "ไม่วางขาย",
    "YiJinYong": "ปิดใช้งาน",
    "YiQiYong": "เปิดใช้งาน",
    "YiTingYong": "ถูกระงับ",
    "KeHuZhuCe": "ลูกค้าลงทะเบียน",
    "XinZengDaoRu": "นำเข้า",
    "DDDSH": "รอตรวจสอบคำสั่งซื้อ",
    "DCWSH": "รอตรวจสอบการเงิน",
    "DaiChuKu": "รอออกคลัง",
    "DCK_BF_": "รอออกคลัง (บางส่วน)",
    "DFH_BF_": "รอจัดส่ง (บางส่วน)",
    "DSH_BF_": "รอรับสินค้า (บางส่วน)",
    "DSK_BF_": "รอชำระเงิน (บางส่วน)",
    "WTHSQ": "ไม่มีการขอคืน",
    "THDSH": "รอตรวจสอบคืนสินค้า",
    "THCLZ": "กำลังดำเนินการคืน",
    "THYWC": "คืนสินค้าเสร็จสมบูรณ์",
    "DYDHD": "พิมพ์คำสั่งซื้อ",
    "DYFHD": "พิมพ์ใบแจ้งหนี้",
    "DCDHD": "ส่งออกคำสั่งซื้อ",
    "DCFHDWE_P": "ส่งออกเป็น Excel/PDF",
    "TuiDanZuoFei": "ยกเลิกการคืน",
    "DTHSH": "รอตรวจสอบคืนสินค้า",
    "DaiRuKu": "รอเข้าคลัง",
    "DRK_BF_": "รอเข้าคลัง (บางส่วน)",
    "DFK_BF_": "รอชำระเงิน (บางส่วน)",
    "ChuangJianTuiDan": "สร้างคืนสินค้า",
    "BianJiTuiDan": "แก้ไขคืนสินค้า",
    "TiJiaoTuiDan": "ส่งคืนสินค้า",
    "TuiHuoShenHe": "ตรวจสอบคืนสินค้า",
    "RuKu": "เข้าคลัง",
    "RuKuShenHe": "ตรวจสอบการเข้าคลัง",
    "RuKuZuoFei": "ยกเลิกการเข้าคลัง",
    "TianJiaFuKuan": "เพิ่มการชำระเงิน",
    "FuKuanZuoFei": "ยกเลิกการชำระเงิน",
    "FuKuanShenHe": "ตรวจสอบการชำระเงิน",
    "TuiDanWanCheng": "คืนสินค้าเสร็จสมบูรณ์",
    "QiTaChuKu": "ออกคลังอื่น",
    "XiaoShouChuKu": "ออกคลังขาย",
    "PanKuiChuKu": "ออกคลังขาดทุน",
    "DiaoBoChuKu": "ออกคลังโอนย้าย",
    "CaiGouTuiHuo": "คืนสินค้าซื้อ",
    "TuiHuoRuKu": "เข้าคลังคืนสินค้า",
    "CaiGouRuKu": "เข้าคลังซื้อ",
    "QiTaRuKu": "เข้าคลังอื่น",
    "PanYingRuKu": "เข้าคลังกำไร",
    "DiaoBoRuKu": "เข้าคลังโอนย้าย",
    "CJCGD": "สร้างคำสั่งซื้อซื้อ",
    "BJCGD": "แก้ไขคำสั่งซื้อซื้อ",
    "TJCGD": "ส่งคำสั่งซื้อซื้อ",
    "CGDZF": "ยกเลิกคำสั่งซื้อซื้อ",
    "CGDWC": "คำสั่งซื้อซื้อเสร็จสมบูรณ์",
    "CGTHZF": "ยกเลิกคืนสินค้าซื้อ",
    "CGTHWC": "คืนสินค้าซื้อเสร็จสมบูรณ์",
    "THDDY": "พิมพ์คืนสินค้า",
    "THDDC": "ส่งออกคืนสินค้า",
    "CKDDY": "พิมพ์ออกคลัง",
    "CKDDC": "ส่งออกออกคลัง",
    "GLDZH": "บัญชีผู้ดูแล",
    "DHDZH": "บัญชีคำสั่งซื้อ",
    "ShenHeTongGuo": "ผ่านการตรวจสอบ",
    "SHBTG": "ไม่ผ่านการตรวจสอบ",
    "WuXuFaPiao": "ไม่ต้องการใบแจ้งหนี้",
    "DaiKeXiaDan": "สั่งซื้อโดยตัวแทน",
    "ZiZhuXiaDan": "สั่งซื้อด้วยตนเอง",
    "PCShangCheng": "ร้านค้า PC",
    "APPShangCheng": "ร้านค้าแอป",
    "TVShangCheng": "ร้านค้า TV",
    "WeiXinShangCheng": "ร้านค้า WeChat",
    "ShouJiShangCheng": "ร้านค้าโมบาย",
    "ADDXSMLTC": "คอมมิชชั่นกำไร",
    "ADDXSSRTC": "คอมมิชชั่นรายได้",
    "AKHSSYG": "ตามตัวแทนขาย",
    "AnZhiDanRen": "ตามผู้สร้าง",
    "ATHJEBLKCT": "หักคอมมิชชั่นตามมูลค่าคืน",
    "DDYTHBJXTC": "ไม่มีคอมมิชชั่นสำหรับคำสั่งซื้อคืน",
    "DaiDaKuan": "รอชำระ",
    "WeiKaiShi": "ยังไม่เริ่ม",
    "JinXingZhong": "กำลังดำเนินการ",
    "YiGuoQi": "หมดอายุ",
    //Utils.js
    "YouHuo": "มีสต็อก",
    "WuHuo": "ไม่มีสต็อก",
    "Yi": "พันล้าน",
    "QianWan": "สิบล้าน",
    "BaiWan": "ล้าน",
    "Wan": "หมื่น",
    "Sheng1Tian": "เหลือ 1 วัน",
    "Sheng1XiaoShi": "เหลือ 1 ชั่วโมง",
    "Miao": "วินาที",
    "1Miao": "1 วินาที",
    "GangGang": "เมื่อกี้",
    "1FenZhongQian": "1 นาทีที่แล้ว",
    "1XiaoShiQian": "1 ชั่วโมงที่แล้ว",
    "1TianQian": "1 วันที่แล้ว",
    "1GeYueQian": "1 เดือนที่แล้ว",
    "1NianQian": "1 ปีที่แล้ว",
    "WeiZhiLeiXing": "ประเภทไม่ทราบ",
    //WechatUtil
    "YYGBCDSP_K": "ดูสินค้านี้!",
    "ZanWeiSheZhi": "ยังไม่ได้ตั้งค่า",
    //app
    "HQWXSQXX": "รับข้อมูลตรวจสอบ WeChat",
    //flexible
    "JGJYYDMBQ": "สเกลตามแท็กเมตา",
    //index
    "NLJZZ": "กำลังโหลด...",
    "": "routes",
    "ShangPinMingXi": "รายละเอียดสินค้า",
    "ShangPinLeiBie": "หมวดหมู่",
    "QXZFPNR": "กรุณาเลือกเนื้อหาใบแจ้งหนี้",
    "QXZFPLX": "กรุณาเลือกประเภทใบแจ้งหนี้",
    "QTXFPTT": "กรุณากรอกหัวข้อใบแจ้งหนี้",
    "FaPiaoTaiTou": "หัวข้อใบแจ้งหนี้",
    "NSRSBH": "เลขประจำตัวผู้เสียภาษี",
    "FaPiaoNeiRong": "เนื้อหาใบแจ้งหนี้",
    "FaPiaoXinXi": "ข้อมูลใบแจ้งหนี้",
    "KaiJuFaPiao": "ออกใบแจ้งหนี้",
    "FaPiaoLeiXing": "ประเภทใบแจ้งหนี้",
    "Han": "รวม",
    "WeiHan": "ไม่รวม",
    "Shui": "ภาษี",
    "QSRFPTT": "กรุณากรอกหัวข้อใบแจ้งหนี้",
    "QSRNSRSBH": "กรุณากรอกเลขประจำตัวผู้เสียภาษี",
    //routes
    //cart-bill
    "YiManZu_Man": "ตรงตาม [ขั้นต่ำ",
    "ZaiGou": "ซื้อเพิ่ม",
    "YMZ_DHJJZ": "ตรงตาม [ราคาคำสั่งซื้อลดเหลือ",
    "JianJiangZhi": "ลดเหลือ",
    "YMZ_YDHJD": "ตรงตาม [ราคาดั้งเดิมลด",
    "JianMeiJian": "ต่อชิ้น",
    "SYTCSLW0_WFJRGWC": "สต็อกแพ็คเกจหมด ไม่สามารถเพิ่มในตะกร้า",
    "QingXuanXeShangPin": "กรุณาเลือกสินค้า!",
    "GSPYXJ": "สินค้านี้ไม่วางขายแล้ว!",
    "ZJ2TN": "{day} วันที่แล้ว",
    "QDQCXJSP": "ยืนยันลบสินค้าไม่วางขาย?",
    "QingChuChengGong": "ลบสำเร็จ",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "สินค้าแพ็คเกจไม่สามารถเพิ่มในตะกร้า!",
    "SPSLBN": "จำนวนสินค้าไม่สามารถ",
    "TaoCanHan": "แพ็คเกจรวม",
    "TaoCan": "แพ็คเกจ",
    "QHDSL": "ยืนยันจำนวน",
    "SPSLBNDY": "จำนวนสินค้าไม่ต่ำกว่า",
    "XianDingLiang": "จำกัดการสั่งซื้อ",
    "YiRuShouCang": "เพิ่มในรายการโปรด",
    "QuanXuan": "เลือกทั้งหมด",
    "JianZeng": "ของแถม",
    "JianLiXiang_Man": "ชิ้น เมื่อซื้อขั้นต่ำ",
    "Yuan_": "บาท]",
    "Zhe_": "% ส่วนลด]",
    "KCBZ_WFJRGWC": "สต็อกไม่เพียงพอ ไม่สามารถเพิ่ม",
    "XDJEDYDY": "มูลค่าคำสั่งซื้อ ≥",
    "WYXJHYSXDSP": "ไม่มีสินค้าไม่วางขาย!",
    "DYQDL": "ต่ำกว่าจำนวนขั้นต่ำ",
    "ZSPG1J": "{count} ประเภทสินค้า รวม",
    "WanCheng": "เสร็จสมบูรณ์",
    "BianJi": "แก้ไข",
    "You": "มี",
    "ZSPBFHYQ_W": "สินค้า {count} ประเภทไม่ตรงเงื่อนไข",
    "SPSLBNGY": "จำนวนสินค้าไม่เกิน",
    "JXDJ_CKXYGBFHYQSP": "เลื่อนลงเพื่อดูสินค้าต่อไป",
    "XiaDan": "สั่งซื้อ",
    "JianJiang": "ลดลง",
    "QRYCSP": "ยืนยันนำสินค้าออก?",
    "QXZXDSP": "กรุณาเลือกสินค้าสำหรับสั่งซื้อ",
    "KCBZ_QCXXZ": "สต็อกไม่เพียงพอ กรุณาเลือกใหม่!",
    "KuCun": "สต็อก",
    "YCKXD": "ต้องชำระ {price}",
    "QDSCSP": "ยืนยันบันทึกสินค้า?",
    "ShouCangChengGong": "บันทึกสำเร็จ",
    "GYXDL": "เกินขีดจำกัดการสั่งซื้อ",
    "LiSheng": "ประหยัด",
    "GWCHSKD_QGYGB": "ตะกร้าว่างเปล่า ไปช้อปปิ้งกัน",
    "QuGuangGuang": "ไปช้อปปิ้ง",
    "QCXJSP": "ลบสินค้าไม่วางขาย",
    "ZongE": "ยอดรวม",
    "YouHui": "ส่วนลด",
    //cart-list
    "QXZJHRQ": "กรุณาเลือกเวลาจัดส่ง",
    "FuJiaFeiYong": "ค่าบริการเพิ่มเติม",
    "ZhongShangPin_Gong": "สินค้า {count} ประเภท รวม",
    "PeiSongShiJian": "เวลาจัดส่ง",
    "QXZPSSJ": "กรุณาเลือกเวลาจัดส่ง",
    "DingDanJinE": "ยอดสั่งซื้อ",
    "SCFJ_ZD4Z": "อัปโหลดไฟล์แนบ สูงสุด 4 รูป แต่ละรูป ≤3MB",
    "KeYongShangPin": "สินค้าพร้อมใช้งาน",
    "ShiYongShuoMing": "คำแนะนำการใช้งาน",
    "YouXiaoQi": "วันหมดอายุ",
    "Man": "ขั้นต่ำ",
    "BZZBZCTSFH": "หมายเหตุไม่รองรับอักขระพิเศษ",
    "QingXuanZe": "กรุณาเลือก",
    "KaiPiaoXuJia": "ค่าธรรมเนียมใบแจ้งหนี้",
    "GeDian": "แต้ม",
    "KPXJ1GD": "ค่าธรรมเนียมใบแจ้งหนี้ {num} แต้ม",
    "PeiSongFangShi": "วิธีการจัดส่ง",
    "ShangPinZongJia": "ราคาสินค้ารวม",
    "YouHuiQuan": "คูปอง",
    "ZhangKeXan": "สามารถเลือก",
    "DDJEWMZ": "ยอดสั่งซื้อไม่ถึง",
    "WDYHQ": "คูปองของฉัน",
    "KYYHQ": "คูปองที่ใช้ได้",
    "YuanKeYong": "บาท ที่ใช้ได้",
    "ChaKanDingDan": "ดูคำสั่งซื้อ",
    "ShangPinHanShui": "สินค้ารวมภาษี",
    "SPWHS": "สินค้าไม่รวมภาษี",
    "QueRenDingDan": "ยืนยันคำสั่งซื้อ",
    "XZSHDZ": "เพิ่มที่อยู่ใหม่",
    "ShangPinQingDan": "รายการสินค้า",
    "WKYYHQ": "ไม่มีคูปองที่ใช้ได้",
    "HuChi": "เฉพาะ",
    "DaiJinQuan": "คูปอง",
    "YunFei": "ค่าจัดส่ง",
    "ShuiFei": "ภาษี",
    "BKYYY": "เหตุผลไม่สามารถใช้",
    "YHQYGQ": "คูปองหมดอายุ",
    "WDYHQSYSJ": "ยังไม่ถึงเวลาที่ใช้ได้",
    "ZDSPJEWMZ": "มูลค่าสินค้าไม่ถึง",
    "BKYYHQ": "คูปองไม่สามารถใช้",
    "YMZ_MYZJ_": "ตรงตาม [ขั้นต่ำ {m}บาท แถม {n}ชิ้น]",
    "YMZ_MZ": "ตรงตาม [ขั้นต่ำ {m}บาท แถม {n}]",
    "ZG222YX_M1000": "ซื้อเพิ่ม {money}บาท รับ [ขั้นต่ำ {target}บาท แถม {num}ชิ้น]",
    "ZG2JX_MZ": "ซื้อเพิ่ม {num}ชิ้น รับ [ขั้นต่ำ {target}บาท แถม {present}]",
    "YMZ_MYJY_": "ตรงตาม [ขั้นต่ำ {m}บาท ประหยัด {n}บาท]",
    "ZGYX_MYJY_": "ซื้อเพิ่ม {m}บาท รับ [ขั้นต่ำ {n}บาท ประหยัด {o}บาท]",
    "YMZ_MYZ_": "ตรงตาม [ขั้นต่ำ {m}บาท {n}% ส่วนลด]",
    "ZGYX_MYZ_": "ซื้อเพิ่ม {m}บาท รับ [ขั้นต่ำ {n}บาท {o}% ส่วนลด]",
    //cart-presale-order
    "QXZPSFS": "กรุณาเลือกวิธีการจัดส่ง",
    "1ZSP_G": "สินค้า 1 ประเภท รวม",
    "YSSP_YJ": "พรีออเดอร์ คาดการณ์",
    "JiaoHuoRiQi": "วันจัดส่ง",
    "GMJLY": "ฝากข้อความ",
    //scan-to-cart
    "ZhengZaiChuLi...": "กำลังประมวลผล...",
    "FSCSP": "ไม่ใช่สินค้าร้าน",
    "ZZCLTXM": "กำลังประมวลผลบาร์โค้ด...",
    "SPTJCG": "เพิ่มสินค้าสำเร็จ",
    "QSTXM": "กรุณาสแกนบาร์โค้ด",
    "SFSCDQSP": "ลบสินค้าปัจจุบัน?",
    "BQ_ZBDXGSP": "ขออภัย ไม่พบสินค้า",
    "XuanZeDanWei": "เลือกหน่วย",
    "JRGWC": "เพิ่มในตะกร้า",
    "QXXZDJRSP": "กรุณาเลือกสินค้าก่อน",
    "ZhengZaiChuLi": "กำลังประมวลผล",
    "JRGWCCG": "เพิ่มในตะกร้าสำเร็จ",
    "ZanWuShangPin": "ไม่มีสินค้า",
    //earn-brokerage-share
    "XTYJBNFZSP": "ระบบคัดลอกลิงก์สินค้าแล้ว!",
    "NKYHDDYDYJ": "คุณได้รับคอมมิชชัน ดูใน \"ฉัน",
    "LiChaKan": "\"",
    "WeiXinHaoYou": "เพื่อน WeChat",
    "ErWeiMa": "QR Code",
    "CASBEWM": "สแกน QR Code",
    "FZSB_QCXFZ": "คัดลอกไม่สำเร็จ ลองอีกครั้ง!",
    "TWEWM": "QR Code ข้อความ+รูปภาพ",
    "BCDXC": "บันทึกลงอัลบั้ม",
    "CATPBCDXC": "กดค้างเพื่อบันทึก",
    "FuZhiLianJie": "คัดลอกลิงก์",
    "FXZYJ": "แชร์รับคอมมิชชัน",
    "YJZGKZQYJ": "คอมมิชชันสูงสุดโดยประมาณ",
    "PYTGNFXDYMCGGMH": "เมื่อเพื่อนซื้อผ่านลิงก์คุณ คุณจะได้รับคอมมิชชัน",
    //goods-share
    "FXSPGLSKH": "แชร์สินค้ากับลูกค้า",
    "FXHJSCNZSD": "แชร์เพื่อสร้างร้านค้าโมบายส่วนตัว",
    "WSCDQJG_ND": "ราคาร้านโมบาย: ราคาคุณ ×",
    "DaiSheZhi": "ยังไม่ได้ตั้งค่า",
    "PengYouQuan": "โมเมนต์",
    "GGFXSZ": "ตั้งค่าการแชร์",
    //wechat-login
    "QXSRZH": "กรุณากรอกบัญชี",
    "MMGSCW_6_20W": "รูปแบบรหัสผ่านไม่ถูกต้อง (6-20 ตัวอักษร)",
    "BDYYZH": "ผูกบัญชีที่มีอยู่",
    "WXKJDL": "เข้าสู่ระบบด่วน WeChat",
    "BangDingZhangHao": "ผูกบัญชี",
    "YYZH_QDL": "มีบัญชีอยู่แล้ว? เข้าสู่ระบบ",
    "ZCXZH": "ลงทะเบียนบัญชีใหม่",
    "HuanYingNi": "ยินดีต้อนรับ",
    "ZH_SJHM": "บัญชี/หมายเลขโทรศัพท์",
    "MiMa": "รหัสผ่าน",
    "QDLHCZ": "กรุณาเข้าสู่ระบบเพื่อดำเนินการ",
    //add-to-cart
    "KCBZ_BNTJG": "สต็อกไม่เพียงพอ ไม่สามารถเพิ่มได้",
    //combined-pay-online
    "ZhiFuChengGong": "ชำระเงินสำเร็จ!",
    "ZFSB_QCXCS": "ชำระเงินไม่สำเร็จ ลองอีกครั้ง!",
    "QXXZGG": "กรุณาเลือกสเปกก่อน",
    "SXGGX": "ต้องเลือกสเปก",
    "GMSLXYQDL_": "จำนวนต่ำกว่าขั้นต่ำ กรุณาซื้อใหม่!",
    "GMSLDYXDL_": "จำนวนเกินขีดจำกัด กรุณาซื้อใหม่!",
    "ShangPinBianHao": "หมายเลขสินค้า",
    "QiDing": "ขั้นต่ำ",
    "SXGGDGSLBK": "จำนวนไม่เกิน",
    "KCBZ_BNTJ": "สต็อกไม่เพียงพอ ไม่สามารถเพิ่ม",
    "QXXZSP": "กรุณาเลือกสินค้าก่อน",
    "SLBNW0": "จำนวนไม่เป็น 0",
    "QXZGG": "กรุณาเลือกสเปก",
    "LiJiYuDing": "พรีออเดอร์ทันที",
    //nav
    "ShouYe": "หน้าหลัก",
    "ShangPin": "สินค้า",
    "DingDan": "คำสั่งซื้อ",
    "WoDe": "ฉัน",
    //pay-online
    "ZhiFuQuXiao": "ยกเลิกการชำระเงิน",
    //account-log
    "ShangPinYongJin": "คอมมิชชันสินค้า",
    "YaoQingJiangLi": "รางวัลการเชิญ",
    "TiXian": "ถอน",
    "TiXianBoHui": "ปฏิเสธการถอน",
    "ZhuanWeiYuE": "โอนเป็นยอดเงิน",
    "Jin7Tian": "7 วันที่ผ่านมา",
    "Jin30Tian": "30 วันที่ผ่านมา",
    "ShouZhiMingXi": "รายละเอียดรายรับรายจ่าย",
    "ZanWuShuJu": "ไม่มีข้อมูล",
    //client-statistics
    "WoDeKeHu": "ลูกค้าของฉัน",
    "WoDeYaoQing": "การเชิญของฉัน",
    //distribution-home
    "LeiJiKeHu": "ลูกค้ารวม",
    "LeiJiDingDan": "คำสั่งซื้อรวม",
    "YaoQingHaoYou": "เชิญเพื่อน",
    "LeiJiYaoQing": "การเชิญรวม",
    "LJSY_Y_": "รายได้รวม (บาท)",
    "BHDJS": "รวมรอการชำระ",
    "J7TSY_Y_": "รายได้ 7 วัน (บาท)",
    "J7TXZKH_R_": "ลูกค้าใหม่ 7 วัน (คน)",
    "KTXYJ": "คอมมิชชันที่ถอนได้",
    "XYJYO": "ต้องพยายามอีก",
    "ChangJianWenTi": "คำถามที่พบบ่อย",
    "Q_ZMYJX_TG": "ถาม: \"โปรโมทรับคอมมิชชัน\" ทำงานอย่างไร",
    "A_FXDPND_Z_": "ตอบ: แชร์ลิงก์ที่มีไอคอน \"รับ\"",
    "Q_RHJS_TGZ": "ถาม: คอมมิชชันคำนวณอย่างไร?",
    "A_MGD_Z_TBD": "ตอบ: แต่ละสินค้ามีอัตราคอมมิชชัน",
    "Q_TGZQ_DSY": "ถาม: เมื่อไหร่จะได้รับคอมมิชชัน?",
    "A_HYTGNDFX": "ตอบ: หลังจากลูกค้ายืนยันการรับสินค้า",
    "Q_LJKH_LJY": "ถาม: ทำไมไม่มีอวาตาร์?",
    "A_WXYQZYGZ": "ตอบ: ต้องติดตามบัญชีบริการ",
    "Q_WSMWASSG": "ถาม: ทำไมไม่มีคอมมิชชัน?",
    "XiaoShouZhongXin": "ศูนย์ขาย",
    //generalize-goods
    "SPMC_GG_BH": "ชื่อสินค้า / สเปก / หมายเลข",
    "YuJiZhuan": "คอมมิชชันโดยประมาณ",
    //invitation-home
    "YaoQingKa": "บัตรเชิญ",
    "YNYQJR_TGY": "เชิญเข้าร่วม โปรโมทรับรางวัล",
    "DJBCDXC": "คลิกบันทึกลงอัลบั้ม",
    "JYQKFSGHY_": "แชร์บัตรกับเพื่อน",
    //join-home
    "HuanYingJiaRu": "ยินดีต้อนรับเข้าร่วม",
    "YQNCW": "เชิญคุณเป็น",
    "LiJiJiaRu": "เข้าร่วมทันที",
    //order-statistics
    "YuJiYongJin": "คอมมิชชันโดยประมาณ",
    "YongJin": "คอมมิชชัน",
    "YuJiJiangLi": "รางวัลโดยประมาณ",
    "JiangLi": "รางวัล",
    "SPTGDD": "คำสั่งซื้อโปรโมทสินค้า",
    "YQJLDD": "คำสั่งซื้อรางวัลการเชิญ",
    //performance-statistics
    "YeJiTongJi": "สถิติประสิทธิภาพ",
    "LJKH_R_": "ลูกค้ารวม (คน)",
    "SPYJ_Y_": "คอมมิชชันสินค้า (บาท)",
    "HanDaiJieSuan": "รวมรอการชำระ",
    "XGMCJS": "คำจำกัดความ",
    "KeHu": "ลูกค้า",
    "HFXYBDLKHG": "ลูกค้าที่เชื่อมโยง",
    "YaoQing": "การเชิญ",
    "FXYCGYQDXJ": "ตัวแทนเชิญสำเร็จ",
    "FXYTJKHGMH": "คอมมิชชันจากลูกค้าเชิญ",
    "XJFXYTGSPH": "รางวัลจากตัวแทนเชิญ",
    //posters-promoting
    "NiCheng": "ชื่อเล่น",
    "HaiBaoTuiGuang": "โปรโมทโปสเตอร์",
    "JHBFSGHY_T": "แชร์โปสเตอร์กับเพื่อน",
    //settlement-home
    "JieSuanZhongXin": "ศูนย์ชำระ",
    "KTXJE": "จำนวนที่ถอนได้",
    "TiXianJiLu": "ประวัติการถอน",
    //withdraw-account
    "KHRXMBNWK": "ต้องกรอกชื่อผู้ถือบัญชี!",
    "KHHBNWK": "ต้องกรอกธนาคาร!",
    "YHKHBNWK": "ต้องกรอกเลขบัญชี!",
    "SFZTPBNWK": "ต้องอัปโหลดรูปบัตรประชาชน!",
    "YHKTPBNWK": "ต้องอัปโหลดรูปบัตรธนาคาร!",
    "BaoCunChengGong": "บันทึกสำเร็จ!",
    "SCSFZ": "อัปโหลดบัตรประชาชน",
    "SCYHK": "อัปโหลดบัตรธนาคาร",
    "BaoCun": "บันทึก",
    "TiXianZhangHu": "บัญชีถอน",
    "TS_QTXZSXX": "กรุณาให้ข้อมูลจริง",
    "KHRXM": "ชื่อผู้ถือบัญชี",
    "KaiHuHang": "ธนาคาร",
    "YinhangKaHao": "เลขบัญชี",
    "QSRZSXM": "กรุณากรอกชื่อจริง",
    "QSRKHHMC": "กรุณากรอกชื่อธนาคาร",
    "QSRYHKH": "กรุณากรอกเลขบัญชี",
    //withdraw-deposit
    "QXSZTXZH": "กรุณาตั้งค่าบัญชีถอนก่อน",
    "QuSheZhi": "ตั้งค่า",
    "JEXY10Y_BKT": "จำนวนต่ำกว่า 10 บาท ถอนไม่ได้!",
    "JECGKTXJE": "จำนวนเกินขีดจำกัดการถอน!",
    "CGDRKTXSX_": "เกินขีดจำกัดรายวัน (20,000 บาท)!",
    "QueDingJiang": "ยืนยันการโอน",
    "ZhuanDaoYuE": "เป็นยอดเงิน?",
    "_JEDY10YSB": "1. จำนวนต่ำกว่า 10 บาท ถอนไม่ได้",
    "_BCTXDZSJ": "2. เวลารับ: 5 วันทำการ",
    "_GBSRWHSS": "3. รายได้นี้รวมภาษี",
    "_ZDYEKYYS": "4. ยอดเงินใช้ช้อปปิ้งได้",
    "TXSQCG_QDD": "คำขอการถอนสำเร็จ รอตรวจสอบ",
    "JEDYKTXJE_": "จำนวนเกินยอดเงิน ไม่สามารถโอน!",
    "ZZYECG_QDG": "โอนเป็นยอดเงินสำเร็จ ดูในโปรไฟล์",
    "BenCiTiXian": "การถอนนี้",
    "ZhuangDaoYuE": "โอนเป็นยอดเงิน",
    "TiXianDao": "ถอนไปยัง",
    "JEW0BKZZYE": "จำนวน 0 ไม่สามารถโอน",
    "DRTXSX2WY": "ขีดจำกัดรายวัน 20,000 บาท",
    "QuanBuTiXian": "ถอนทั้งหมด",
    "QueRenTiXian": "ยืนยันการถอน",
    //goods-filter-tab
    "ZuiChangGouMai": "ซื้อบ่อย",
    "MoRenPaiXu": "เรียงตามค่าเริ่มต้น",
    "ZongHe": "โดยรวม",
    "FenLei": "หมวดหมู่",
    "XiaoLiangYouXian": "ยอดขายก่อน",
    "XiaoLiang": "ยอดขาย",
    "JiaGe": "ราคา",
    "ShaiXuan": "กรอง",
    "ZuiJinGouMai": "ซื้อล่าสุด",
    "CuXiaoYouXian": "โปรโมชันก่อน",
    "QuanBuFenLei": "หมวดหมู่ทั้งหมด",
    "ZhiKanCuXiao": "โปรโมชันเท่านั้น",
    "XuanZeFenLei": "เลือกหมวดหมู่",
    "QXZFL": "กรุณาเลือกหมวดหมู่",
    //goods-list-default
    "ZWXGSP": "ไม่มีสินค้าที่เกี่ยวข้อง",
    //goods-brand-list
    "PinPaiHui": "แบรนด์",
    //goods-classify-filter
    "TuiJianFenLei": "หมวดหมู่แนะนำ",
    "ShangPinFenLei": "หมวดหมู่สินค้า",
    "GengDuo": "เพิ่มเติม",
    //goods-detail
    "DLZHBSDQQY": "บัญชีไม่ใช่ลูกค้าบริษัทปัจจุบัน",
    "GXNHQ": "ยินดีด้วย คุณได้รับ",
    "SZWSCJGH_C": "ตั้งราคาก่อนแชร์",
    "JHDJSHS_": "เวลาที่เหลือ:",
    "DLHKFX": "เข้าสู่ระบบเพื่อแชร์",
    "ZZHQXX_QSH": "กำลังรับข้อมูล",
    "Zhang": "แผ่น",
    "Tian": "วัน",
    "QXZGGZQPD": "กรุณาเลือกสเปกก่อน",
    "Yuan": "บาท",
    "XS_F_M": "ชม./น./วิ",
    //integral
    "WoDeJiFen": "คะแนนของฉัน",
    "DaBaiLe": "ดีกว่า",
    "JiFen": "คะแนน",
    "DeHuiYuan": "สมาชิก",
    "ZhuanJiFen": "รับคะแนน",
    "JiFenMingXi": "รายละเอียดคะแนน",
    "HuanLiPin": "แลกของรางวัล",
    "CKGDHL": "ดูของรางวัลเพิ่มเติม",
    "ChaDingDan": "ตรวจสอบคำสั่งซื้อ",
    //integral-convert
    "DHSLBNCG": "จำนวนแลกไม่เกิน",
    "DuiHuanShuLiang": "จำนวนแลก",
    "SuoXuJiFen": "คะแนนที่ต้องการ",
    //integral-detail
    "LiPinXiangQing": "รายละเอียดของรางวัล",
    "WoYaoDuiHuan": "ฉันต้องการแลก",
    "ShengYu": "เหลือ",
    "TuWenXiangQing": "รายละเอียด",
    "Jian": "ชิ้น",
    "YiDuiWan": "แลกหมด",
    //integral-filter
    "FenLeiShaiXuan": "กรองหมวดหมู่",
    "JiFenShaiXuan": "กรองคะแนน",
    //integral-flow
    "JiFenShouRu": "รับคะแนน",
    "JiFenZhiChu": "ใช้คะแนน",
    //integral-logistics
    "DingDanGenZong": "ติดตามคำสั่งซื้อ",
    "WuLiuGongSi": "บริษัทขนส่ง",
    "WuLiuDanHao": "หมายเลขพัสดุ",
    //integral-order
    "DingDanLieBiao": "รายการคำสั่งซื้อ",
    "YiFaHuo": "จัดส่งแล้ว",
    "JiFenDingDan": "คำสั่งซื้อคะแนน",
    "ChaKanWuLiu": "ดูการขนส่ง",
    //integral-order-create
    "LPSLBZ_QCX": "สต็อกของรางวัลไม่เพียงพอ",
    "JiFenBuZu": "คะแนนไม่เพียงพอ",
    "ZhiFuXinXi": "ข้อมูลการชำระเงิน",
    "JiXuGuangGuang": "ช้อปปิ้งต่อ",
    "QTXSHXX": "กรุณากรอกข้อมูลการรับสินค้า",
    "DuiHuanChengGong": "แลกสำเร็จ",
    "LPDHQR": "ยืนยันการแลกของรางวัล",
    "SCCKJ": "ราคาอ้างอิง",
    "LiJiZhiFu": "ชำระทันที",
    //integral-order-detail
    "DingDanXiangQing": "รายละเอียดคำสั่งซื้อ",
    "DingDanZhuangTai": "สถานะคำสั่งซื้อ",
    "DingDanBianHao": "หมายเลขคำสั่งซื้อ",
    "DuiHuanShiJian": "เวลาแลก",
    "ShouHuoXinXi": "ข้อมูลการรับสินค้า",
    "HuaFeiJiFen": "คะแนนที่ใช้",
    //integral-rule
    "QDZJF": "ลงทะเบียนรับคะแนน",
    "XDZJF": "สั่งซื้อรับคะแนน",
    "1_MRQD_JL": "1. เข้าสู่ระบบทุกวัน: +{num} คะแนน",
    "2_LXQD3T_EW": "2. เข้าสู่ระบบต่อเนื่อง 3 วัน: +{num} คะแนน",
    "3_LXQD7T_EW": "3. เข้าสู่ระบบต่อเนื่อง 7 วัน: +{num} คะแนน",
    "DLZJF": "เข้าสู่ระบบรับคะแนน",
    "MRDLYSDHSC": "เข้าสู่ระบบทุกวัน: +{num} คะแนน",
    "DDWCHKHDYD": "สั่งซื้อสำเร็จ: คะแนน = ยอดสั่งซื้อ × {num}",
    //integral-rule-detail
    "GuiZe": "กฎ",
    //integral-sign
    "QianDaoYouLi": "เข้าสู่ระบบรับรางวัล",
    "QianDaoGuiZe": "กฎการเข้าสู่ระบบ",
    "YLXQD": "เข้าสู่ระบบต่อเนื่อง",
    "YLXQD1T": "เข้าสู่ระบบ {num} วัน",
    "QDCG_NYJLX": "สำเร็จ! เข้าสู่ระบบ {num} วัน",
    "QDCG_BCHD1": "สำเร็จ! ได้รับ {num} คะแนน",
    "BCQDHD4JF_": "ได้รับ {num} คะแนน เยี่ยมมาก!",
    "QSRBZ": "กรุณากรอกหมายเหตุ",
    "DingDanZengPin": "ของแถมคำสั่งซื้อ",
    "GuiGeBianHao": "หมายเลขสเปก",
    "GuiGe": "สเปก",
    //combined-pay
    "CDDWXFK": "คำสั่งซื้อนี้ไม่ต้องชำระเงิน",
    "YHYEBZ": "ยอดเงินผู้ใช้ไม่เพียงพอ!",
    "ZFJEBNW0": "ยอดชำระไม่สามารถเป็น 0!",
    "ZFJEBNDYDD": "ยอดเกินยอดค้างชำระ",
    "DFKJE": "ยอดค้างชำระ",
    "FuKuanFangShi": "วิธีการชำระเงิน",
    "FuJian": "ไฟล์แนบ",
    "ZHYFZ": "คัดลอกบัญชี",
    "GHSKZH": "เปลี่ยนบัญชีผู้รับ",
    "SYXXZFQSCF": "อัปโหลดหลักฐานการชำระเงินเพื่อยืนยัน",
    "XXZF_BXXZS": "เลือกบัญชีผู้รับสำหรับชำระเงินออฟไลน์",
    "DingDanZhiFu": "ชำระเงินคำสั่งซื้อ",
    "ZFFS_HDFK": "วิธีการ: ชำระเงินเมื่อได้รับสินค้า",
    "BCFKJE": "ยอดชำระครั้งนี้",
    "YuE": "ยอดเงิน",
    "FuZhiZhangHao": "คัดลอกบัญชี",
    "WSZXCXZFPZ": "ไม่ได้ตั้งค่าการชำระเงิน",
    "XCXZFZHJY": "บัญชีชำระเงินถูกปิดใช้งาน",
    "SRZFJE": "กรอกยอดชำระเงิน",
    "FuKuanZhangHu": "บัญชีชำระเงิน",
    "QueRenZhiFu": "ยืนยันการชำระเงิน",
    "ShaoHouZhiFu": "ชำระทีหลัง",
    //order
    "FKJLYTJ_DD": "เพิ่มบันทึกการชำระเงิน รอการตรวจสอบ",
    "JiXuGuang": "ช้อปปิ้งต่อ",
    "BenCiFuKuan": "ชำระเงินครั้งนี้",
    "FuKuanChengGong": "ชำระเงินสำเร็จ",
    "ZhiFuFangShi": "วิธีการชำระเงิน",
    "ZhiFuDingDan": "ชำระเงินคำสั่งซื้อ",
    //order-batch-pay
    "QXXZSXZFDD": "กรุณาเลือกคำสั่งซื้อที่จะชำระ",
    "PiLiangFuKuan": "ชำระเงินเป็นชุด",
    "FuKuan": "ชำระเงิน",
    "QuFuKuan": "ไปชำระเงิน",
    //order-create-result
    "YingFuJinE": "ยอดที่ต้องชำระ",
    "XiaDanShiJian": "เวลาสั่งซื้อ",
    //order-deliver
    "SFQRSH": "ยืนยันการรับสินค้า?",
    "DDQRSH": "ยืนยันการรับคำสั่งซื้อ",
    "DFHSP": "สินค้ารอจัดส่ง",
    "ShangPinShuLiang": "จำนวนสินค้า",
    "ChuKuShiJian": "เวลาออกจากคลัง",
    "FaHuoShiJian": "เวลาจัดส่ง",
    "WuLiuBeiZhu": "หมายเหตุการขนส่ง",
    "QueRenShouHuo": "ยืนยันการรับสินค้า",
    "RYFK_QJSYG": "ติดต่อผู้ดูแลระบบหากชำระเงินแล้ว",
    "QSRQXYY": "กรุณากรอกเหตุผลการยกเลิก",
    "H_DDJZDGB_QJKF": "คำสั่งซื้อจะถูกยกเลิกอัตโนมัติ",
    "TuiHuoQingKuang": "สถานะการคืนสินค้า",
    "DingDanZongE": "ยอดรวมคำสั่งซื้อ",
    "DingDanBeiZhu": "หมายเหตุคำสั่งซื้อ",
    "FaHuoQingKuang": "สถานะการจัดส่ง",
    "DingDanFuJian": "ไฟล์แนบคำสั่งซื้อ",
    "ShenQingTuiHuo": "ขอคืนสินค้า",
    "G1TDSHJL_QRS": "ยืนยันการรับสินค้า {num} คำสั่งซื้อ?",
    "DaiXiaDan": "สั่งซื้อโดยตัวแทน",
    "DingDanHao": "หมายเลขคำสั่งซื้อ",
    "XiaDanFangShi": "วิธีการสั่งซื้อ",
    "TuiHuoDan": "คืนสินค้า",
    "ShangPinZongE": "ยอดรวมสินค้า",
    "YunFei_ZongZhong": "ค่าขนส่ง (น้ำหนัก",
    "SF_SPWS": "ภาษี (สินค้ายังไม่เสียภาษี",
    "TePiJia": "ราคาพิเศษ",
    "FuKuanQingKuang": "สถานะการชำระเงิน",
    "TiaoJiLu": "บันทึก",
    "ZaiLaiYiDan": "สั่งซื้อซ้ำ",
    "MuLiuXinXi": "ข้อมูลการขนส่ง",
    "QDSCGDD_": "ยืนยันการลบคำสั่งซื้อ?",
    "YiQueRen": "ยืนยันแล้ว",
    "YiShouHuo": "รับสินค้าแล้ว",
    "DaiFuJinE": "ยอดค้างชำระ",
    "YiFuJinE": "ยอดชำระแล้ว",
    "ZanWuJiLu": "ไม่มีบันทึก",
    "SPMC_DDH": "ชื่อสินค้า / หมายเลขคำสั่งซื้อ",
    "FuKuanZhuangTai": "สถานะการชำระเงิน",
    "FaHuoZhuangTai": "สถานะการจัดส่ง",
    "QiShiShiJian": "เวลาเริ่มต้น",
    "ZhongZhiShiJian": "เวลาสิ้นสุด",
    //order-list
    "CaoZuoChengGong": "ดำเนินการสำเร็จ",
    "ZBKGM": "ไม่สามารถซื้อตอนนี้",
    "DQDDSPYXJ": "สินค้าในคำสั่งซื้อไม่วางขายแล้ว",
    "DQDDBFSPYXJ": "สินค้าบางรายการไม่วางขายแล้ว",
    "JTJSJSP": "เพิ่มเฉพาะสินค้าที่มี",
    "DingHuoDan": "คำสั่งซื้อซื้อ",
    //order-log
    "DingDanRiZhi": "บันทึกคำสั่งซื้อ",
    //order-logistics
    "FuZhiChengGong": "คัดลอกสำเร็จ",
    "FuZhiShiBai": "คัดลอกไม่สำเร็จ",
    "FuZhi": "คัดลอก",
    "BoDa": "โทร",
    "WCWLDHXX": "ไม่มีข้อมูลการขนส่ง",
    //order-pay
    "ZFCS_QCXXD": "หมดเวลาชำระเงิน กรุณาสั่งซื้อใหม่",
    "YQYYCKZF": "เปิดใช้งานการชำระมัดจำ",
    "BNDYDFKJE": "ไม่เกินยอดค้างชำระ",
    "ZFJEBNWK": "ต้องกรอกยอดชำระ",
    "QXAPFK_FKH": "เตรียมหลักฐานการชำระเงินเพื่อยืนยัน",
    "DDTJCG_QJS": "สั่งซื้อสำเร็จ กรุณาชำระเงินทันที",
    "QXZFKFS": "กรุณาเลือกวิธีการชำระเงิน",
    "SYYEZFH_HX": "หลังจากชำระด้วยยอดเงิน ต้องชำระเพิ่ม",
    "FuKuanJiLu": "บันทึกการชำระเงิน",
    "ZWFKJL": "ไม่มีบันทึกการชำระเงิน",
    "FuKuanXiangQing": "รายละเอียดการชำระเงิน",
    "FuKuanJinE": "ยอดชำระ",
    "ZhiDan": "สร้างโดย",
    "ShenHe": "ตรวจสอบ",
    "ZuoFei": "ยกเลิก",
    "ZuoFeiYuanYin": "เหตุผลการยกเลิก",
    "GLDHD": "คำสั่งซื้อที่เกี่ยวข้อง",
    "HeXiaoJinE": "ยอดที่ตรวจสอบแล้ว",
    "HeXiaoZhuangTai": "สถานะการตรวจสอบ",
    "DanJuZhuangTai": "สถานะเอกสาร",
    "KeHuMingCheng": "ชื่อลูกค้า",
    "ZhangDanHao": "หมายเลขบิล",
    "ShouKuanZhangHao": "บัญชีผู้รับ",
    "ShouKuanShiJian": "เวลารับเงิน",
    "FuKuanPingZheng": "หลักฐานการชำระเงิน",
    "GeFuJian": "ไฟล์แนบ",
    //order-statistics
    "DingDanTongJi": "สถิติคำสั่งซื้อ",
    "DingHuo0Bi": "{num} คำสั่งซื้อ",
    //order-statistics-detail
    "DDTJMX": "รายละเอียดสถิติ",
    "AGGTJ": "ตามสเปก",
    "AFLTJ": "ตามหมวดหมู่",
    "DDJE_Y": "ยอดคำสั่งซื้อ/บาท",
    "DHSP_Z": "สินค้าที่สั่ง/ประเภท",
    "DingHuoDan_Bi": "คำสั่งซื้อ/ใบ",
    "DingHuoShangPin": "สินค้าที่สั่ง",
    "JinE": "ยอดเงิน",
    //refund-list
    "TuiHuo": "คืนสินค้า",
    //refund-apply
    "THDHWBC_QD": "คืนสินค้ายังไม่บันทึก ออก?",
    "QSRSQTHJE": "กรุณากรอกยอดคืนสินค้า",
    "QSRTHJE": "กรุณากรอกยอดคืนสินค้า",
    "QSRBZXX": "กรุณากรอกหมายเหตุ",
    "YingTuiJinE": "ยอดที่ควรคืน",
    "TJTHSQ": "ส่งคำขอคืนสินค้า",
    "QXXZDHQD": "กรุณาเลือกรายการคำสั่งซื้อ",
    "DingHuoQingDan": "รายการคำสั่งซื้อ",
    "SQTHJE": "ยอดคำขอคืนสินค้า",
    "DJXZSP": "คลิกเลือกสินค้า",
    "TuiHuoJinE": "ยอดคืนสินค้า",
    //refund-detail
    "THDDXQ": "รายละเอียดคืนสินค้า",
    "YiTuiHuo": "คืนสินค้าแล้ว",
    "YiTuiKuan": "คืนเงินแล้ว",
    "THDZT": "สถานะคืนสินค้า",
    "TuiHuoDanHao": "หมายเลขคืนสินค้า",
    "TuiHuoShiJian": "เวลาคืนสินค้า",
    "TuiHuoCangKu": "คลังคืนสินค้า",
    "THLXR": "ผู้ติดต่อคืนสินค้า",
    "TuiHuoQingDan": "รายการคืนสินค้า",
    "TuiKuanZongE": "ยอดคืนเงินทั้งหมด",
    "TuiKuanQingKuang": "สถานะคืนเงิน",
    "DaiTuiJinE": "ยอดค้างคืน",
    "YiTuiJinE": "ยอดคืนแล้ว",
    //refund-product
    "SPMC_BH_GG": "ชื่อสินค้า / หมายเลข / สเปก / บาร์โค้ด",
    "GZD1TJG": "พบ 1 ผลลัพธ์",
    "JiaRuQingDan": "เพิ่มในรายการ",
    //refund-result
    "ShenQingChengGong": "ส่งคำขอสำเร็จ",
    "THDTJCG": "ส่งคืนสินค้าสำเร็จ",
    "ChaKanXiangQing": "ดูรายละเอียด",
    //goods-package-floor
    "HDWKS_WDZL": "กิจกรรมยังไม่เริ่ม",
    "HDYJS_XCZD": "กิจกรรมสิ้นสุดแล้ว",
    "ZWSZBT": "ไม่มีหัวข้อ",
    "ChaKanGengDuo": "ดูเพิ่มเติม",
    //goods-promotion-floor
    "HCDZSJC": "ความแตกต่างของเวลาเนื่องจากแคช",
    "DLCKCXJ": "เข้าสู่ระบบเพื่อดูราคาพิเศษ",
    "ZWSZCX": "ไม่มีโปรโมชัน",
    "JuKaiShi": "ก่อนเริ่ม",
    "Song": "แถม",
    "JuJieShu": "ก่อนสิ้นสุด",
    "YiJieShu": "สิ้นสุดแล้ว",
    //search-floor
    "XiaoXi": "ข้อความ",
    "SaoMaXiaDan": "สั่งซื้อด้วยการสแกน",
    //home-page-custom
    "WZLCSJ": "ไม่ทราบข้อมูล",
    //jump-error
    "QXZYSDHAPP": "ดาวน์โหลดแอป YUNSHANG",
    "QMTYQYGLD": "ประสบการณ์การจัดการเต็มรูปแบบ",
    "XZYSDHAPP": "ดาวน์โหลดแอป YUNSHANG",
    "HQGLDWZTY": "รับประสบการณ์เต็มรูปแบบ",
    "JXTYDHD": "ดำเนินการสั่งซื้อต่อ",
    //notice-detail
    "GongGaoXiangQing": "รายละเอียดประกาศ",
    "GongGaoFuJian": "ไฟล์แนบประกาศ",
    //shop-error
    "NFWDYMBCZO": "ไม่พบหน้า",
    "KeNengYuanYin": "สาเหตุที่เป็นไปได้",
    "1_ZDZLSRCWD": "1. URL ผิด",
    "2_DJLGQLJ": "2. ลิงก์หมดอายุ",
    //shop-index
    "GuanLiDuan": "ฝ่ายจัดการ",
    "ZhuCe": "ลงทะเบียน",
    "HYNTYYSDH": "ยินดีต้อนรับสู่ YUNSHANG",
    "TYZHSJHDQG": "ข้อมูลบัญชีทดลองจะได้รับการอัปเดต",
    "TYZHZDNRSJ": "ข้อมูลในบัญชีทดลองเป็นการจำลอง",
    "ZHZCCG": "ลงทะเบียนสำเร็จ",
    "DengLuZhangHao": "บัญชีเข้าสู่ระบบ",
    "CSMMW": "รหัสผ่านเริ่มต้น",
    "GNFYHQL": "คุณได้รับคูปอง",
    "Man1YuanKeYong": "ขั้นต่ำ {num} บาท ใช้ได้",
    "LQH1TNKY": "ใช้งานได้ {day} วัน",
    "YiJianLingQu": "รับทันที",
    "GXNHD1ZYHQ": "ยินดีด้วย คุณได้รับคูปอง {num} {price} บาท {name}",
    "Gong1Yuan": "รวม {num} บาท",
    "LiJiShiYong": "ใช้ทันที",
    //shop-login
    "NHWDL": "คุณยังไม่ได้เข้าสู่ระบบ",
    //shop-notice
    "ShangChengGongGao": "ประกาศร้านค้า",
    "ZanWuGongGao": "ไม่มีประกาศ",
    "1GeFuJian": "{num} ไฟล์แนบ",
    //deposit-detail
    "KouKuan": "หักเงิน",
    "ChongZhi_Kuan": "เติมเงิน",
    "KouKuanZuoFei": "ยกเลิกการหักเงิน",
    "ChongZhiZuoFei": "ยกเลิกการเติมเงิน",
    "ZhangHuMingXi": "รายละเอียดบัญชี",
    "ZhangHuYuE": "ยอดเงินในบัญชี",
    "LiJiChongZhi": "เติมเงินทันที",
    //deposit-recharge
    "CZJEBNXY1Y": "ยอดเติมขั้นต่ำ 1 บาท",
    "QSRZQDSZ": "กรุณากรอกค่าที่ถูกต้อง",
    "ZDYJE": "ยอดกำหนดเอง",
    "ZWKTXSCZGN": "ไม่สามารถเติมเงินออนไลน์",
    "ShiFuJinE": "ยอดชำระจริง",
    "ZhangHuChongZhi": "เติมเงินบัญชี",
    "QXZCZJE": "เลือกยอดเติม",
    "QSRCZJE": "กรอกยอดเติม",
    "QLXNDZSYWY": "ติดต่อตัวแทนขาย",
    "ShouJia": "ราคาขาย",
    "YiShouQing": "ขายหมด",
    "ChongZhiJinE": "ยอดเติม",
    "QueRenFuKuan": "ยืนยันการชำระเงิน",
    //deposit-recharge-result
    "QSDDID": "ไม่มีรหัสคำสั่งซื้อ",
    "ChongZhiChengGong": "เติมเงินสำเร็จ",
    "ChongZhiShiBai": "เติมเงินไม่สำเร็จ",
    "CLZ_QSH...": "กำลังประมวลผล กรุณารอสักครู่...",
    "ChongZhiFangShi": "วิธีการเติมเงิน",
    "ChongZhiShiJian": "เวลาเติมเงิน",
    "JYLSH": "หมายเลขธุรกรรม",
    "FanHuiShangCheng": "กลับไปที่ร้านค้า",
    //recharge-online
    "ZFSB_QCS": "ชำระเงินไม่สำเร็จ ลองอีกครั้ง",
    "ZFYQX": "ยกเลิกการชำระเงิน",
    "ZFYC_QCS": "ข้อผิดพลาดในการชำระเงิน ลองอีกครั้ง",
    //user
    "LingQuanZhongXin": "ศูนย์คูปอง",
    "WeiShiYong": "ยังไม่ได้ใช้",
    "YiShiYong": "ใช้แล้ว",
    "ZWYHQ": "ไม่มีคูปอง",
    //keep-list
    "YiGouMai": "ซื้อแล้ว",
    "ChangYongQingDan": "รายการที่ใช้บ่อย",
    "WoDeShouCang": "รายการโปรดของฉัน",
    "QuGouWuChe": "ไปที่ตะกร้า",
    "GeShangPin": "สินค้า",
    //login
    "YunShangDingHuo": "YUNSHANG",
    "QSRZH": "กรุณากรอกบัญชี!",
    "QSRMM": "กรุณากรอกรหัสผ่าน!",
    "QSRDLZH": "กรุณากรอกบัญชีเข้าสู่ระบบ",
    "JiZhuMiMa": "จำรหัสผ่าน",
    "WangJiMiMa": "ลืมรหัสผ่าน?",
    "DengLu": "เข้าสู่ระบบ",
    "DLZHBCZ_QL": "บัญชีไม่มีอยู่ ติดต่อผู้ดูแล",
    "GQYZHSBJY_": "บัญชีบริษัทถูกปิดใช้งาน",
    "GQYZHSYQJS_": "หมดระยะเวลาทดลอง",
    "GQYZHYGQL_": "บัญชีหมดอายุ ต้องต่ออายุ",
    "LiJiTiYan": "ทดลองทันที",
    //my-collect
    "YiChuChengGong": "นำออกสำเร็จ",
    "QueHuo": "สินค้าหมด",
    "YCSCJ": "นำออกจากรายการโปรด",
    //order-message
    "SheZhiChengGong": "ตั้งค่าสำเร็จ",
    "ZWWDXX": "ไม่มีข้อความที่ยังไม่ได้อ่าน",
    "QuanBuYiDu": "ทำเครื่องหมายว่าอ่านทั้งหมด",
    "DingDanXiaoXi": "ข้อความคำสั่งซื้อ",
    "YiQiang": "已抢",
    "LiJiLingQu": "立即领取",
    "LingQuanHou": "领券后",
    "TianNeiKeYong": "天内可用",
    "QSRSJH": "请输入手机号",
    "QSRYZM": "请输入验证码",
    "QSRXMM": "请输入新密码",
    "QSRZQSJGS": "请输入正确手机格式",
    "ChongZhiMiMa": "重置密码",
    "QSRNDSJHM": "请输入您的手机号码",
    "QSRDXYZ": "请输入短信验证",
    "HQYZM": "获取验证码",
    "HKCXHQ": "后可重新获取",
    "QSR6_20WSZHZ": "请输入6-20位数字或字母的密码",
    //share-setting
    "QSRSPJGBL": "กรุณากรอกอัตราส่วนราคาสินค้า",
    "SPJGBLBXDY": "อัตราส่วนต้องอยู่ระหว่าง 100-999.99",
    "DPMCZBZCTS": "ชื่อร้านไม่รองรับอักขระพิเศษ",
    "LXRZBZCTSF": "ชื่อผู้ติดต่อไม่รองรับอักขระพิเศษ",
    "LXFSZBZCTS": "ข้อมูลติดต่อไม่รองรับอักขระพิเศษ",
    "LXDZZBZCTS": "ที่อยู่ไม่รองรับอักขระพิเศษ",
    "DPJJZBZCTS": "คำอธิบายร้านไม่รองรับอักขระพิเศษ",
    "QSRDPJJ_ZD": "กรุณากรอกคำอธิบายร้าน (สูงสุด 50 ตัวอักษร)",
    "FenXiangSheZhi": "ตั้งค่าการแบ่งปัน",
    "NDWSCSPJG": "ราคาสินค้าของคุณ",
    "NDDHJ_": "ราคาคำสั่งซื้อของคุณ ×",
    "LXXX_KBJ_": "ข้อมูลติดต่อ (แก้ไขได้)",
    "DianPuMingCheng": "ชื่อร้าน",
    "JianJie": "คำอธิบาย",
    "QSRDPMC": "กรุณากรอกชื่อร้าน",
    "LianXiRen": "ผู้ติดต่อ",
    "QSRLXR": "กรุณากรอกชื่อผู้ติดต่อ",
    "LianXiFangShi": "วิธีการติดต่อ",
    "QSRLXFS": "กรุณากรอกข้อมูลติดต่อ",
    "LianXiDiZhi": "ที่อยู่ติดต่อ",
    "QSRLXDZ": "กรุณากรอกที่อยู่ติดต่อ",
    //user
    "WoDeDingDan": "คำสั่งซื้อของฉัน",
    "ZuiJinLiuLan": "ดูล่าสุด",
    "ShouCangShangPin": "สินค้าที่บันทึก",
    "BDYYZH_ZC": "ผูกบัญชีที่มี | ลงทะเบียนบัญชีใหม่",
    "DL_ZC": "เข้าสู่ระบบ | ลงทะเบียน",
    "BangDingShouJi": "ผูกหมายเลขโทรศัพท์",
    "TS_BDSJHM_": "คำแนะนำ: ผูกหมายเลขโทรศัพท์เพื่อความปลอดภัยของบัญชี!",
    "ChaKanQuanBu": "ดูทั้งหมด",
    "ShouHuoDiZhi": "ที่อยู่จัดส่ง",
    "LianXiWoMen": "ติดต่อเรา",
    "SheZhi": "ตั้งค่า",
    "QuQianDao": "ไปลงชื่อ",
    "QianDao": "ลงชื่อ",
    "JiFenShangCheng": "ร้านค้าคะแนน",
    "TuiGuangShangPin": "โปรโมตสินค้า",
    "QuChaKan": "ไปดู",
    "JiFenHuanLi": "แลกคะแนนเป็นรางวัล",
    "DYSPBQ": "พิมพ์ป้ายสินค้า",
    //user-about
    "GYYSDH": "เกี่ยวกับ YUNSHANG",
    "YQHYSMEWM_": "เชิญชวนเพื่อนสแกน QR Code เพื่อดาวน์โหลด",
    "DangQianBanBen": "เวอร์ชันปัจจุบัน",
    //user-address
    "ZWSHDZ": "ไม่มีที่อยู่จัดส่ง",
    "WoDeDiZhi": "ที่อยู่ของฉัน",
    "ZhiNengShiBie": "จดจำอัจฉริยะ",
    "ZTDZXXKZNS": "วางข้อมูลที่อยู่เพื่อจดจำอัตโนมัติ",
    "MoRen": "ค่าเริ่มต้น",
    "QRSCDZ": "ยืนยันลบที่อยู่?",
    "SHRXM": "ชื่อผู้รับ",
    "SJHMHGDDHZ": "ต้องกรอกหมายเลขโทรศัพท์หรือโทรศัพท์บ้าน",
    "QSRSHRXM": "กรุณากรอกชื่อผู้รับ",
    "ShouJiHaoMa": "หมายเลขโทรศัพท์",
    "GuDingDianHua": "โทรศัพท์บ้าน",
    "QSRGDDH": "กรุณากรอกหมายเลขโทรศัพท์บ้าน",
    "SuoZaiDiQu": "พื้นที่",
    "QSRSZDQ": "กรุณาเลือกพื้นที่",
    "QSRXXDZ": "กรุณากรอกที่อยู่โดยละเอียด!",
    "QSRZQDSJHM": "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    "QSRZQDGDDH": "กรุณากรอกหมายเลขโทรศัพท์บ้านที่ถูกต้อง",
    "XiangXiDiZhi": "ที่อยู่โดยละเอียด",
    "MoRenDiZhi": "ที่อยู่เริ่มต้น",
    "SWMRDZ": "ตั้งเป็นค่าเริ่มต้น",
    "BCBSY": "บันทึกและใช้",
    //user-bing-one
    "QSRSJHM": "กรุณากรอกหมายเลขโทรศัพท์",
    "GYHYZC": "ผู้ใช้นี้ลงทะเบียนแล้ว",
    "GSJHMYJZCG": "หมายเลขโทรศัพท์นี้ลงทะเบียนแล้ว",
    "QZJDLJK": "กรุณาเข้าสู่ระบบโดยตรง",
    "QuDengLu": "ไปเข้าสู่ระบบ",
    "BDHKYTGSJH": "ผูกเพื่อเข้าสู่ระบบด้วยหมายเลขโทรศัพท์",
    "_BDHKYTGSJ": "*ผูกเพื่อเข้าสู่ระบบด้วยหมายเลขโทรศัพท์",
    "QSRSJYZM": "กรุณากรอกรหัสยืนยัน SMS",
    "BDXSJ": "ผูกหมายเลขโทรศัพท์ใหม่",
    "DXYZM": "รหัสยืนยัน SMS",
    "XiaYiBu": "ขั้นตอนต่อไป",
    "TGCBZ": "ข้ามขั้นตอนนี้",
    //user-bing-two
    "DBDSJHMBCZ": "หมายเลขโทรศัพท์ที่ต้องการผูกไม่มีอยู่!",
    "QSRDLMM": "กรุณากรอกรหัสผ่าน!",
    "_GSJHMYBDY": "*หมายเลขโทรศัพท์นี้ถูกผูกแล้ว",
    "DQZHMMJTBW": "รหัสผ่านบัญชีจะถูกซิงค์",
    "DangQianZhangHao": "บัญชีปัจจุบัน",
    "QDYJZ": "ยืนยันการลบ",
    "JSPSCM": "สินค้านี้?",
    "ShanChuChengGong": "ลบสำเร็จ!",
    //user-info
    "SJGSCW": "รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง",
    "YXGSCW": "รูปแบบอีเมลไม่ถูกต้อง",
    "WoDeZhangHao": "บัญชีของฉัน",
    "YouXiang": "อีเมล",
    "ShouJi": "โทรศัพท์",
    "XingMing": "ชื่อเต็ม",
    "XiuGaiTouXiang": "เปลี่ยนรูปโปรไฟล์",
    "JiBenXinXi": "ข้อมูลพื้นฐาน",
    "ZhangHaoAnQuan": "ความปลอดภัยบัญชี",
    "XiuGaiMiMa": "เปลี่ยนรหัสผ่าน",
    "DianJiBangDing": "คลิกเพื่อผูก",
    "RYDSHTY_QL": "หากสูญหายหรือไม่ได้ใช้ ให้เปลี่ยนทันที",
    "WBZNDZHAQ_": "ผูกหมายเลขโทรศัพท์เพื่อความปลอดภัย",
    //user-setting
    "QCHCHXCXDL": "ล้างแคชต้องเข้าสู่ระบบใหม่",
    "QingChuHuanCun": "ล้างแคช",
    "QDYQCHCM": "ยืนยันล้างแคช?",
    "TuiChuDengLu": "ออกจากระบบ",
    "ZhangHaoZhuXiao": "ยกเลิกบัญชี",
    "QieHuanZhangHao": "สลับบัญชี",
    //user-supplier
    "LianXi": "ติดต่อ",
    "GongSiDianHua": "โทรศัพท์บริษัท",
    "DiZhi": "ที่อยู่",
    //vouchers-detail
    "DJQMX": "รายละเอียดคูปอง",
    //vouchers-list
    "BuKeYong": "ไม่สามารถใช้ได้",
    "KeYong": "สามารถใช้ได้",
    "ZWDJQ": "ไม่มีคูปอง",
    "ZongEDu": "ยอดรวม",
    "FaFangShiJian": "เวลาออก",
    "EDYYW": "ยอดหมดแล้ว",
    //vouchers-select-list
    "WDDJQ": "คูปองของฉัน",
    "KYDJQ": "คูปองที่ใช้ได้",
    "DJQKDK": "คูปองสามารถหักได้",
    "CKKYSP": "ดูสินค้าที่ใช้ได้",
    "BKYDJQ": "คูปองไม่สามารถใช้ได้",
    "BKYYY_ZWFH": "เหตุผล: ไม่มีสินค้าที่ตรงเงื่อนไข",
    //goods-detail
    "DQSPWSCGGT": "สินค้านี้ไม่มีรูปสเปก",
    "BoFangShiPin": "เล่นวิดีโอ",
    "Gong1GeGuiGe": "ทั้งหมด {num} สเปก",
    "YiXuanGuiGe": "สเปกที่เลือก",
    "XuanGuiGe": "เลือกสเปก",
    "LingQuan": "รับคูปอง",
    "1ZhongCuXiao": "{num} โปรโมชัน",
    "1ZhangKeYong": "{num} ใช้ได้",
    "ZuiGaoKeSheng": "ประหยัดสูงสุด",
    "ShangPinTaoCan": "แพ็คเกจสินค้า",
    "Gong1GeTaoCan": "ทั้งหมด {num} แพ็คเกจ",
    "ShangPinCanShu": "พารามิเตอร์สินค้า",
    "ZhanKai": "ขยาย",
    "YiShouCang": "บันทึกแล้ว",
    "ShouCang": "บันทึก",
    "KeFu": "บริการลูกค้า",
    "XiangQing": "รายละเอียด",
    "TuiJian": "แนะนำ",
    "BianHao": "หมายเลข",
    "ShangPinXinXi": "ข้อมูลสินค้า",
    "KLYHQ": "สามารถรับคูปอง",
    "KuCunBuZu": "สต็อกไม่เพียงพอ",
    "DuoGuiGe": "หลายสเปก",
    "YiShou": "ขายแล้ว",
    "SWBHZ_YS": "สต็อกหมด ขายแล้ว",
    "CuXiaoShangPin": "สินค้าโปรโมชัน",
    //goods-search
    "NHWSRSSNR": "คุณยังไม่ได้ป้อนคำค้นหา",
    "SouSuo": "ค้นหา",
    "SSY1XGDSP": "ค้นหาสินค้าที่เกี่ยวข้องกับ {searchKey}",
    "Yue1GeShangPin": "สินค้าประมาณ {num} รายการ",
    "ZuiJinSouSuo": "ค้นหาล่าสุด",
    "QingChu": "ล้าง",
    "ZWSSJL": "ไม่มีประวัติการค้นหา",
    //goods-property
    "ZGJGBNDYZD": "ราคาสูงสุดต้องไม่ต่ำกว่า",
    "ShangPinBiaoQian": "แท็กสินค้า",
    "BuGaoYu1": "ไม่สูงกว่า 1",
    "BuDiYu1": "ไม่ต่ำกว่า 1",
    "FengGe": "สไตล์",
    //goods-promotion-list
    "JiJiangKaiShi": "จะเริ่มเร็วๆ นี้",
    "QuanBuCuXiao": "โปรโมชันทั้งหมด",
    //goods-package-list
    "Gong1JianShangPin": "สินค้าทั้งหมด {num} รายการ",
    "Sheng": "ประหยัด",
    //goods-package-detail
    "GTCZGWCZDS": "แพ็คเกจนี้ถึงขีดจำกัดในตะกร้า",
    "GTCKCBZ_BK": "สต็อกแพ็คเกจไม่เพียงพอ",
    "JinSheng1Tao": "เหลือเพียง {num} ชุด",
    "XianGou1Tao": "ซื้อได้สูงสุด {num} ชุด",
    "TaoCanXiangQing": "รายละเอียดแพ็คเกจ",
    "DanMaiJia": "ราคาขายเดี่ยว",
    "TaoCanJia": "ราคาแพ็คเกจ",
    "HDYJS": "โปรโมชันสิ้นสุดแล้ว",
    //goods-message
    "WDL_QXDL": "ยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบ",
    //goods-list-label
    "XinPinShangShi": "สินค้ามาใหม่",
    "WDLZH_ZWCX": "ยังไม่ได้เข้าสู่ระบบ ไม่มีโปรโมชัน",
    "YiXiaShangPin": "สินค้าด้านล่าง",
    //goods-list
    "1ZhongGuiGe": "{num} สเปก",
    "YouKuCun": "มีสต็อก",
    //goods-filter
    "BuGaoYu": "ไม่สูงกว่า",
    "BuDiYu": "ไม่ต่ำกว่า",
    "CuXiao": "โปรโมชัน",
    "ZDYXXZ3G": "เลือกได้สูงสุด 3 รายการ",
    "GouMai": "ซื้อ",
    "Gong1Jian": "ทั้งหมด {num} ชิ้น",
    "YiChuShouCangJia": "นำออกจากรายการโปรด",
    "$": "บาท",
    "$1": "{num} บาท",
    "_8999_1Qi": "เริ่มต้นที่ 8999.1 บาท",
    "Ge": "ชิ้น",
    "BaoZhuangFangShi": "วิธีการบรรจุ",
    "QRSCSP_": "ยืนยันลบสินค้า?",
    "JEWM_TMFRK": "สแกน QR Code/บาร์โค้ด",
    "0ZSP_G0J": "สินค้า 0 รายการ ทั้งหมด 0 ชิ้น",
    "JiuMiMa": "รหัสผ่านเก่า",
    "XMM_6_20WZ": "รหัสผ่านใหม่ (6-20 ตัวอักษร)",
    "QueRenMiMa": "ยืนยันรหัสผ่าน",
    "BDHKSYSJHD": "ผูกเพื่อเข้าสู่ระบบด้วยหมายเลขโทรศัพท์",
    "YanZhengMa": "รหัสยืนยัน",
    "1MHKCXHQ": "ลองอีกครั้งใน 1 วินาที",
    "CSJHZ1MQFS": "ส่งรหัสไปแล้ว รอสักครู่",
    "GouMaiJiLu": "ประวัติการซื้อ",
    "XinZengDiZhi": "เพิ่มที่อยู่ใหม่",
    "LingShouJia": "ราคาขายปลีก",
    "YouHuiJia": "ราคาพิเศษ",
    "ShangPinChuKu": "สินค้าออกจากคลัง",
    "DengDaiShouHuo": "รอรับสินค้า",
    "ShouHuoRen": "ผู้รับ",
    "PaiZhao": "ถ่ายรูป",
    "XiangCe": "อัลบั้ม",
    "TiYanGuan": "แกลเลอรี่",
    "JingYingShiJian": "เวลาทำการ",
    "ZhanGuanDianHua": "โทรศัพท์แกลเลอรี่",
    "ZhanGuanDiZhi": "ที่อยู่แกลเลอรี่",
    "SJHQZ_QSDZ": "กำลังรับข้อมูล รอสักครู่",
    "QXXZSF_": "กรุณาเลือกจังหวัดก่อน!",
    "QuanBuShengFen": "ทุกจังหวัด",
    "QuanBuChengShi": "ทุกเมือง",
    "YingYeShiJian": "เวลาทำการ",
    "ChanPinBianHao": "หมายเลขสินค้า",
    "DLXXYGQ_QC": "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่",
    "Man999Jian100": "ซื้อ {m} ชิ้น ประหยัด {n}",
    "YiManZu": "ตรงตามเงื่อนไขแล้ว",
    "QDYCSP_": "ยืนยันนำสินค้าออก?",
    "DGM10JZ1J": "ซื้อ 10 ชิ้น แถม 1 ชิ้น",
    "XiaXianTongZhi": "แจ้งเตือนออฟไลน์",
    "NDZHYZQTSB": "บัญชีของคุณเข้าสู่ระบบบนอุปกรณ์อื่น",
    "ManJiang": 'ซื้อ {target} ชิ้น ลด {num}',
    "ZGLXMJ": 'ซื้ออีก {num} ชิ้น ลดเหลือ {money_}',
    "ZGLXMZ": 'ซื้ออีก {num} ชิ้น ลด {percent}%',
    "QSRZQNR": 'กรุณากรอกเนื้อหาที่ถูกต้อง',
    "NHYDDQKWJQ": 'คุณมี {num} คำสั่งซื้อค้างชำระ',
    "FaPiaoZhuShou": "ตัวช่วยใบแจ้งหนี้",
    "WoDeFaPiao": "ใบแจ้งหนี้ของฉัน",
    "FaPiaoXiangQing": "รายละเอียดใบแจ้งหนี้",
    "KaiPiaoShiJian": "เวลาออกใบแจ้งหนี้",
    "DaiKaiFaPiao": "รอออกใบแจ้งหนี้",
    "DKFPJE": "ยอดรอออกใบแจ้งหนี้",
    "KaiPiaoJinE": "ยอดใบแจ้งหนี้",
    "ZFYDWT_QCSCXZF": "ปัญหาการชำระเงิน ลองวิธีอื่น",
    "QingXuanZhe": "กรุณาเลือก",
    "ShouXin": 'เครดิต',
    "LJSQSXED": "สมัครเครดิตทันที",
    "SXEDSHZ": "เครดิตกำลังตรวจสอบ",
    "SXCZ_XDCG": "เครดิตเพียงพอ สั่งซื้อสำเร็จ",
    "SXEDBZ_FKHFH": "เครดิตไม่เพียงพอ ชำระก่อนส่ง",
    "CGJKZQ_FKFH": "เกินระยะเวลาเครดิต ชำระก่อนส่ง",
    "DDTJCG_XZZCZHYB": "สั่งซื้อสำเร็จ เหลือขั้นตอนสุดท้าย!",
    "MianFeiLing": "รับฟรี",
    "M_KMFLQ_HQ": "ซื้อ {target} รับฟรี ขาดอีก {short}",
    "YHDMFSP": "ได้รับสินค้าฟรีแล้ว",
    "JRMFL": "รับฟรีวันนี้",
    "LingGuangLe": "หมดแล้ว",
    "KeLingQu": "สามารถรับได้",
    "YuGuJia": "ราคาโดยประมาณ",
    "GXNHQ_Z_Y_": "ยินดีด้วย คุณได้รับ {num} คูปอง {price} บาท {name}",
    "LXZSKF": "ติดต่อตัวแทน",
    "DPYDY_QSHX": "ร้านปิดแล้ว สั่งซื้อภายหลัง",
    "DaYangShiJian": "เวลาปิดร้าน",
    "ChuanHaoChaXun": 'ตรวจสอบหมายเลขซีเรียล',
    'IMEI': 'หมายเลขซีเรียล',
    "FanKuanYuE": "ยอดคืนเงิน",
    "FanKuanZhiFu": "ชำระด้วยคืนเงิน",
    "JingDongYiYunJia": "Jingdong Yiyun+",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "ยอดคืนเงินไม่เพียงพอ",
    "FanKuanZhangHu": "บัญชีคืนเงิน",
    "HaiXuZhiFu": "ต้องชำระเพิ่ม {price}",
    "QTXGSMC": "กรุณากรอกชื่อบริษัท",
    "QSCSFZZMZ": "กรุณาอัปโหลดรูปบัตรประชาชนด้านหน้า",
    "QSCSFZFMZ": "กรุณาอัปโหลดรูปบัตรประชาชนด้านหลัง",
    "QSCYYZZ": "กรุณาอัปโหลดใบอนุญาตธุรกิจ",
    "TJCG_QNXDDSH": "ส่งสำเร็จ รอการตรวจสอบ",
    "SXSQ": "สมัครเครดิต",
    "QYJBZL": "ข้อมูลบริษัท",
    "SQFRSFZZM": "อัปโหลดรูปบัตรประชาชนด้านหน้า",
    "ZMSLT": "ตัวอย่างด้านหน้า",
    "SCFRSFZFM": "อัปโหลดรูปบัตรประชาชนด้านหลัง",
    "FMSLT": "ตัวอย่างด้านหลัง",
    "QQBSFZSJWZ_WZQXKBB": "ตรวจสอบให้ชัดเจน",
    "SCYYZZ": "อัปโหลดใบอนุญาตธุรกิจ",
    "ShengHeZhong": "กำลังตรวจสอบ",
    "TiJiaoShenHe": "ส่งตรวจสอบ",
    "GSMC": "ชื่อบริษัท",
    "DDDKFQRBJQSH": "คำสั่งซื้อรอการยืนยันราคา",
    "XDTX": "แจ้งเตือนการสั่งซื้อ",
    "NH_GDDBH": "สินค้าบางรายการต้องยืนยันราคา",
    "QRXD": "ยืนยันการสั่งซื้อ",
    "DaiHeJia": "รอการกำหนดราคา",
    "ZHJY": "ยอดคงเหลือบัญชี",
    "YGTG": "โปรโมชันพนักงาน",
    "YuanGong": "พนักงาน",
    "DuiZhanGJieSuan": "การชำระบัญชี",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "ยอดคงเหลือ = เงินฝาก + คืนเงิน + คืนสินค้ารอคืน - ยอดค้างชำระ",
    "YCKYE": "ยอดเงินฝาก",
    "FKYE": "ยอดคืนเงิน",
    "DDYFK": "ยอดค้างชำระ",
    "THDTK": "คืนสินค้ารอคืน",
    "YuCunKuanZuoFei": "เงินฝากถูกยกเลิก",
    "FanKuanZhangHuMingXi": "รายละเอียดบัญชีคืนเงิน",
    "TKCZDFKZH": "เติมเงินเข้าบัญชีคืนเงิน",
    "RMBJE": "จำนวนเงิน RMB"
};
exports.default = th_TH;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// vi_VN.js
var vi_VN = {
    "GuanShui": "Thuế hải quan",
    "ZiZhangHao": "tài khoản con",

    "ZHONGWEN": "Chinese",
    "YINGYU": "English",
    "XIBANYAYU": "Español",
    "DEYU": "Deutsch",
    "FAYU": "Français",
    "ALABOYU": "العربية",
    "EYU": "Русский",
    "MALAIYU": "Bahasa Malaysia",
    "YUENANYU": "Tiếng Việt",
    "TAIYU": "ภาษาไทย",
    "YINNIYU": "Bahasa Indonesia",
    //components
    "ShangeChuanYanZhengTuPian": "Upload Verification Image",
    "ChuanHaoYanZheng": "Serial Number Verification",
    "YanZhengChuanHao": "Verify Serial Number",
    "Ci": "time",
    "DingDanMan": "Order over",
    "YuanZeng": "yuan gift",
    "SCFJ_ZD4Z_DZBCG": "Upload attachments, maximum 4, each not exceeding 3M",
    //ChatRoom
    "ZBZCBQFH": "Emoticons are not supported temporarily",
    "FaSongLianJie": "Send Link",
    "YiChangXiaoXi": "Abnormal Message",
    "QingShuRu": "Please enter",
    "FaSong": "Send",
    //DateSelector
    "DQSJXYKSSJ": "Current time is less than start time",
    "DQSJCGJSSJ": "Current time exceeds end time",
    "QuXiao": "Cancel",
    "NianYueRi": "Year Month Day",
    "ShiFen": "Hour Minute",
    "QueDing": "Confirm",
    "Nian": "year",
    "Yue": "month",
    "Ri": "day",
    "Shi": "hour",
    "Fen": "minute",
    //goods-list-card
    "Qi": "starting from",
    //goods-promotion
    "1GeCuXiao": "{num} promotions",
    "ChaKanZengPin": "View Gifts",
    "JHDJSHS_1T": "Time left until the end of the event: {d} days {h} hours {m} minutes {s} seconds",
    "YHGZ_ZPBKD": "Preference rules: Gifts cannot be obtained叠加 (叠加: stacked)",
    "YHGZ_AZZGM": "Preference rules: Enjoy discounts according to the final purchase quantity",
    "GuanBi": "Close",
    "Man1Song1": 'Buy {mai} get {song} free',
    //group-filtrate
    "QuanBu": "All",
    "ZWXGSJ": "No relevant data",
    "ZuiDiJia": "Lowest Price",
    "ZuiGaoJia": "Highest Price",
    "LeiXing": "Type",
    "PinPai": "Brand",
    "BiaoQian": "Tag",
    "JiaGeQuJian": "Price Range",
    "SPMC_GG_BH_": "Product Name / Specification / Number / First Letter",
    "SPMC_GG_BH_G": "Product Name / Specification / Number",
    "ZuHeShaiXuan": "Combination Filter",
    "ChongZhi_CanShu": "Reset",
    //image-upload
    "ZDKSC1ZTP": "Maximum 1 image can be uploaded",
    "ZYXSCTP": "Only images are allowed to be uploaded",
    "SCTPDXBYXC": "Uploaded image size cannot exceed 5M",
    "QBYCFSCTP_": "Please do not upload duplicate images, or ensure image names are unique",
    "ShangChuanChengGong": "Upload Successful",
    "ZDKSC1Z": "Maximum 1 can be uploaded",
    //keyboard
    "CCSLZDXZ": "Exceeds maximum quantity limit",
    "QiDingLiang": "Minimum Order Quantity",
    "ShouQi": "Retract",
    "ShanChu": "Delete",
    //MultiPicker
    "FanHui": "Return",
    //order-cart
    "Dai": "pending",
    "YiQuXiao": "Cancelled",
    "ZengPin": "Gift",
    "1Zhong": "{num} types",
    "1Jian": "{num} pieces",
    "HeJi": "Total",
    "DaiFu": "Pending Payment",
    //order-promotion
    "_DDM1YZ1J_": "【Order over {target} yuan, get {name} {number} pieces as gift】",
    "_DDM1YLJ1Y_": "【Order over {m} yuan, get {n} yuan off】",
    "_DDM1YLX1Z_": "【Order over {m} yuan, enjoy {n}% discount】",
    "DingDanCuXiao": "Order Promotion",
    //page-ad
    "DLCKJG": "Log in to view price",
    //page-floating
    "DianPuZhuYe": "Store Homepage",
    "GouWuChe": "Shopping Cart",
    "ZaiXianKeFu": "Online Customer Service",
    "GeRenZhongXin": "Personal Center",
    "LianXiDianHua": "Contact Phone",
    "FanHuiDingBu": "Back to Top",
    //page-null
    "ZBDYML": "Page not found",
    "KNWZCW_HZY": "Possible wrong URL, or the page has been deleted",
    "FanHuiShangJi": "Return to Previous Level",
    "FanHuiShouYe": "Return to Homepage",
    //product-edit
    "SPQDBNWK": "Product list cannot be empty",
    "WoZhiDaoLe": "I see",
    "SFQRSCSP": "Are you sure to delete the product",
    "QueRen": "Confirm",
    "ZYXSRSZBQB": "Only numbers are allowed and no more than 2 decimal places",
    "ShangPinDanJia": "Product Unit Price",
    "YSPYJ": "Original Product Original Price",
    "QSRZDJG": "Please enter the specified price",
    "ShuLiang": "Quantity",
    "DanWei": "Unit",
    "DanJia": "Unit Price",
    "BeiZhu": "Remarks",
    "YiChuShangPin": "Remove Product",
    "XiuGai": "Edit",
    //yunshl
    "TPSLCCYXSZ": "Number of images exceeds allowed value!",
    "WJBDDY5M_QC": "File cannot be larger than 5m, please reselect",
    "TPSCWC": "Image upload completed",
    //BusinessFilter
    "_DGSLM1Z1_": "【Order quantity over {target}, get {provide} as gift】",
    "_M1JLXMJ1Y_": "【Over {target}, enjoy {cut_money_} per】",
    "_DHJJZ1Y_": "【Order price reduced to {cuted_price_} yuan】",
    "_M1JLXMJ1Z_": "【Over {target}, enjoy {cut_percent_}% discount per】",
    "_YDHJD1Z_": "【Original order price with {cuted_percent_}% discount】",
    "YuJiKaiShiFaHuo": "Estimated to start shipping on {date}",
    "YuJi": "Estimated",
    "MMYDDR": "MM月DD日 (MM month DD day)",
    "KaiShiFaHuo": "Start Shipping",
    "_M1LXM1Y_": "【Over 1, enjoy 1 yuan per】",
    "_M1LXM1Z_": "【Over 1, enjoy 10% discount per】",
    "DaiQueRen": "Pending Confirmation",
    "DaiFaHuo": "Pending Shipment",
    "DaiShouHuo": "Pending Receipt",
    "YiWanCheng": "Completed",
    "DaiFuKuan": "Pending Payment",
    "YiFuKuan": "Paid",
    "YiZuoFei": "Voided",
    "DaiShenHe": "Pending Review",
    "DaiHeXiao": "Pending Verification",
    "YiHeXiao": "Verified",
    "XianXiaZhiFu": "Offline Payment",
    "ZhiNengDaoZhangShiBie": "Offline Remittance (Intelligent Payment Recognition)",
    "WeiXinZhiFu": "WeChat Payment",
    "KQ-WeiXinZhiFu": "Kuaiqian (WeChat)",
    "KQ-ZFBZF": "Kuaiqian (Alipay)",
    "KQZhiFu": "Kuaiqian Payment",
    "ZFBZF": "Alipay Payment",
    "YuEZhiFu": "Balance Payment",
    "HuoDaoFuKuan": "Cash on Delivery",
    "DaiTuiHuo": "Pending Return",
    "DaiTuiKuan": "Pending Refund",
    "ChuangJianDingDan": "Create Order",
    "BianJiDingDan": "Edit Order",
    "TiJiaoDingDan": "Submit Order",
    "DingDanShenHe": "Order Review",
    "CaiWuShenHe": "Financial Review",
    "BoHui": "Reject",
    "TianJiaShouKuan": "Add Payment Received",
    "ZaiXianZhiFu": "Online Payment",
    "ShouKuanShenHe": "Payment Review",
    "ShouKuanZuoFei": "Void Payment",
    "ChuKu": "Outbound",
    "ChuKuShenHe": "Outbound Review",
    "FaHuo": "Ship",
    "TianJiaWuLiu": "Add Logistics",
    "XiuGaiWuLiu": "Edit Logistics",
    "ChuKuZuoFei": "Void Outbound",
    "ShouHuo": "Receive Goods",
    "DingDanHeZhun": "Order Approval",
    "QuXiaoDingDan": "Cancel Order",
    "CJTHD": "Create Return Order",
    "DaYin": "Print",
    "DaoChu": "Export",
    "DingDanWanCheng": "Order Completed ",
    "QiangZhiWanCheng": "Force Complete",
    "DingDanZuoFei": "Void Order",
    "MaiZeng": "Buy One Get One Free",
    "ZhiJiang": "Direct Reduction",
    "DaZhe": "Discount",
    "YuShou": "Pre-sale",
    "DingDanManZeng": "Order Full Gift",
    "DingDanManJian": "Order Full Reduction",
    "DingDanManZhe": "Order Full Discount",
    "XinRenQuan": "New User Coupon",
    "ManJianQuan": "Full Reduction Coupon",
    "ShangPinQuan": "Product Coupon",
    "DaiJieSuan": "Pending Settlement",
    "YiJieSuan": "Settled",
    "QuanBuShangPin": "All Products",
    "TuiJianShangPin": "Recommended Products",
    "XinPin": "New Products",
    "ReXiaoShangPin": "Hot-selling Products",
    "ChangYongShangPin": "Frequently Used Products",
    //BusinessUtil
    "DaiShouKuan": "Pending Receipt",
    "BuFenShouKuan": "Partial Receipt",
    "YiShouKuan": "Received Payment",
    "BXYFP": "No need for invoice",
    "ZZSPTFP": "Value-added Tax Ordinary Invoice",
    "ZZSZYFP": "Value-added Tax Special Invoice",
    "QiTaFaPiao": "Other Invoices",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Pre-deposit",
    "XianXiaZhuangZhang": "Offline Transfer",
    "XianShangZhiFu": "Online Payment (supports WeChat/Alipay/JD Pay/UnionPay)",
    "YCKZF": "Pre-deposit Payment",
    "DaiTiJiao": "Pending Submission",
    "KuaiDi": "Express",
    "SongHuoShangMen": "Home Delivery",
    "ShangMenZiQu": "Self-pickup",
    "WuLiuHuoYun": "Logistics Freight",
    "QiTa": "Other",
    //check-util
    "QSRBXY6WDM": "Please enter a password of no less than 6 digits",
    "QSRBDY20WDM": "Please enter a password of no more than 20 digits",
    "MMGSCW": "Incorrect password format",
    //common-utils
    "SJCW_QLXKF": "Data error, please contact customer service",
    "ZBZCQD": "Check-in is not supported temporarily",
    "HuJiao": "Call",
    "DLZHBCZ": "Login account does not exist",
    "QLXGLYKT": "Please contact the administrator to activate",
    "GQYZHBJY": "This enterprise account is disabled",
    "QLXYSDH": "Please contact Yunshang Ordering",
    "GQYZHSYQJS": "The trial period of this enterprise account has ended",
    "GQYZHYGQL": "This enterprise account has expired",
    "XYXFCNSY": "Need to renew to use",
    "GQYBCZCZH": "This enterprise does not have this account",
    "NDDHZHYBQY": "Your ordering account has been disabled by Enterprise 1 and cannot log in. Please contact the administrator",
    "NYBSQY1DHZ": "You are no longer a cooperative customer of Enterprise 1 and cannot log in. Please contact the administrator",
    "NDDPYBTY_B": "Your store has been suspended and cannot log in. Please contact the administrator",
    "GZHWKTDSZB": "This account has not activated the Lighting Special Edition function. Please contact the administrator",
    "WXSQYZYGQ": "WeChat authorization verification has expired",
    "WXSQSB": "WeChat authorization failed",
    "WXSQSB_CWX": "WeChat authorization failed, error message",
    "DengLuGuoQi": "Login expired",
    "DLGQ_QCXDL": "Login expired, please log in again",
    //data-constant
    "ShangJia": "On Shelf",
    "YiXiaJia": "Off Shelf",
    "YiJinYong": "Disabled",
    "YiQiYong": "Enabled",
    "YiTingYong": "Suspended",
    "KeHuZhuCe": "Customer Registration",
    "XinZengDaoRu": "New Import",
    "DDDSH": "Pending Order Review",
    "DCWSH": "Pending Financial Review",
    "DaiChuKu": "Pending Outbound",
    "DCK_BF_": "Pending Outbound (Partial)",
    "DFH_BF_": "Pending Shipment (Partial)",
    "DSH_BF_": "Pending Receipt (Partial)",
    "DSK_BF_": "Pending Payment (Partial)",
    "WTHSQ": "No Return Application",
    "THDSH": "Return Pending Review",
    "THCLZ": "Return Processing",
    "THYWC": "Return Completed",
    "DYDHD": "Print Order Form",
    "DYFHD": "Print Shipping Form",
    "DCDHD": "Export Order Form",
    "DCFHDWE_P": "Export Shipping Form as Excel/PDF file",
    "TuiDanZuoFei": "Void Return Order",
    "DTHSH": "Pending Return Review",
    "DaiRuKu": "Pending Inbound",
    "DRK_BF_": "Pending Inbound (Partial)",
    "DFK_BF_": "Pending Payment (Partial)",
    "ChuangJianTuiDan": "Create Return Order",
    "BianJiTuiDan": "Edit Return Order",
    "TiJiaoTuiDan": "Submit Return Order",
    "TuiHuoShenHe": "Return Review",
    "RuKu": "Inbound",
    "RuKuShenHe": "Inbound Review",
    "RuKuZuoFei": "Void Inbound",
    "TianJiaFuKuan": "Add Payment",
    "FuKuanZuoFei": "Void Payment",
    "FuKuanShenHe": "Payment Review",
    "TuiDanWanCheng": "Return Order Completed",
    "QiTaChuKu": "Other Outbound",
    "XiaoShouChuKu": "Sales Outbound",
    "PanKuiChuKu": "Inventory Shortage Outbound",
    "DiaoBoChuKu": "Transfer Outbound",
    "CaiGouTuiHuo": "Purchase Return",
    "TuiHuoRuKu": "Return Inbound",
    "CaiGouRuKu": "Purchase Inbound",
    "QiTaRuKu": "Other Inbound",
    "PanYingRuKu": "Inventory Surplus Inbound",
    "DiaoBoRuKu": "Transfer Inbound",
    "CJCGD": "Create Purchase Order",
    "BJCGD": "Edit Purchase Order",
    "TJCGD": "Submit Purchase Order",
    "CGDZF": "Void Purchase Order",
    "CGDWC": "Purchase Order Completed",
    "CGTHZF": "Void Purchase Return",
    "CGTHWC": "Purchase Return Completed",
    "THDDY": "Print Return Order",
    "THDDC": "Export Return Order",
    "CKDDY": "Print Outbound Order",
    "CKDDC": "Export Outbound Order",
    "GLDZH": "Admin Account",
    "DHDZH": "Ordering Account",
    "ShenHeTongGuo": "Review Passed",
    "SHBTG": "Review Not Passed",
    "WuXuFaPiao": "No Need for Invoice",
    "DaiKeXiaDan": "Place Order on Behalf of Customer",
    "ZiZhuXiaDan": "Self-ordering",
    "PCShangCheng": "PC Mall",
    "APPShangCheng": "APP Mall",
    "TVShangCheng": "TV Mall",
    "WeiXinShangCheng": "WeChat Mall",
    "ShouJiShangCheng": "Mobile Mall",
    "ADDXSMLTC": "Commission based on order sales gross profit",
    "ADDXSSRTC": "Commission based on order sales revenue",
    "AKHSSYG": "By customer's affiliated employee",
    "AnZhiDanRen": "By order creator",
    "ATHJEBLKCT": "Deduct commission amount by return amount ratio",
    "DDYTHBJXTC": "No commission for orders with returns",
    "DaiDaKuan": "Pending Payment Transfer",
    "WeiKaiShi": "Not Started",
    "JinXingZhong": "In Progress",
    "YiGuoQi": "Expired",
    //Utils.js
    "YouHuo": "In Stock",
    "WuHuo": "Out of Stock",
    "Yi": "100 million",
    "QianWan": "10 million",
    "BaiWan": "1 million",
    "Wan": "10 thousand",
    "Sheng1Tian": "1 day left",
    "Sheng1XiaoShi": "1 hour left",
    "Miao": "second",
    "1Miao": "1 second",
    "GangGang": "Just now",
    "1FenZhongQian": "1 minute ago",
    "1XiaoShiQian": "1 hour ago",
    "1TianQian": "1 day ago",
    "1GeYueQian": "1 month ago",
    "1NianQian": "1 year ago",
    "WeiZhiLeiXing": "Unknown Type",
    //WechatUtil
    "YYGBCDSP_K": "There's a good product, come and take a look",
    "ZanWeiSheZhi": "Not set yet",
    //app
    "HQWXSQXX": "Obtain WeChat authorization information",
    //flexible
    "JGJYYDMBQ": "Will set the zoom ratio according to existing meta tags",
    //index
    "NLJZZ": "Loading",
    "": "routes",
    "ShangPinMingXi": "Product Details",
    "ShangPinLeiBie": "Product Category",
    "QXZFPNR": "Please select invoice content",
    "QXZFPLX": "Please select invoice type",
    "QTXFPTT": "Please fill in the invoice title",
    "FaPiaoTaiTou": "Invoice Title",
    "NSRSBH": "Taxpayer Identification Number",
    "FaPiaoNeiRong": "Invoice Content",
    "FaPiaoXinXi": "Invoice Information",
    "KaiJuFaPiao": "Issue Invoice",
    "FaPiaoLeiXing": "Invoice Type",
    "Han": "Including",
    "WeiHan": "Not Including",
    "Shui": "Tax",
    "QSRFPTT": "Please enter invoice title",
    "QSRNSRSBH": "Please enter taxpayer identification number",
    //routes
    //cart-bill
    "YiManZu_Man": "Already met [Over",
    "ZaiGou": "Buy more",
    "YMZ_DHJJZ": "Already met [Order price reduced to",
    "JianJiangZhi": "pieces reduced to",
    "YMZ_YDHJD": "Already met [Original order price with",
    "JianMeiJian": "pieces each",
    "SYTCSLW0_WFJRGWC": "Remaining package quantity is 0, cannot add to cart",
    "QingXuanXeShangPin": "Please select products!",
    "GSPYXJ": "This product has been removed from the shelf!",
    "ZJ2TN": "Within the last {day} days",
    "QDQCXJSP": "Are you sure to clear off-shelf products?",
    "QingChuChengGong": "Clear successful",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Package products cannot be added to cart, please cancel package products before adding to cart!",
    "SPSLBN": "Product quantity cannot",
    "TaoCanHan": "Package includes",
    "TaoCan": "Package",
    "QHDSL": "Please check the quantity",
    "SPSLBNDY": "Product quantity cannot be less than",
    "XianDingLiang": "Limited quantity",
    "YiRuShouCang": "Add to favorites",
    "QuanXuan": "Select All",
    "JianZeng": "pieces as gift",
    "JianLiXiang_Man": "pieces enjoy [Over",
    "Yuan_": "yuan]",
    "Zhe_": "discount]",
    "KCBZ_WFJRGWC": "Insufficient inventory, cannot add to cart",
    "XDJEDYDY": "Order amount is greater than or equal to",
    "WYXJHYSXDSP": "No off-shelf or invalid products!",
    "DYQDL": "Less than minimum order quantity",
    "ZSPG1J": "{count} types of products, total {number} pieces",
    "WanCheng": "Complete",
    "BianJi": "Edit",
    "You": "There are",
    "ZSPBFHYQ_W": "types of products that do not meet the requirements, not selected, click to view",
    "SPSLBNGY": "Product quantity cannot be more than",
    "JXDJ_CKXYGBFHYQSP": "Continue clicking to view the next product that does not meet the requirements",
    "XiaDan": "Place Order",
    "JianJiang": "pieces reduced by",
    "QRYCSP": "Confirm to remove the product?",
    "QXZXDSP": "Please select products to order",
    "KCBZ_QCXXZ": "Insufficient inventory, please reselect!",
    "KuCun": "Inventory",
    "YCKXD": "yuan to place order",
    "QDSCSP": "Confirm to favorite the product?",
    "ShouCangChengGong": "Favorite successful",
    "GYXDL": "More than limited quantity",
    "LiSheng": "Instant Savings",
    "GWCHSKD_QGYGB": "Shopping cart is empty, go take a look",
    "QuGuangGuang": "Go shopping",
    "QCXJSP": "Clear off-shelf products",
    "ZongE": "Total Amount",
    "YouHui": "Discount",
    //cart-list
    "QXZJHRQ": "Please select delivery time",
    "FuJiaFeiYong": "Additional Fees",
    "ZhongShangPin_Gong": "types of products, total",
    "PeiSongShiJian": "Delivery Time",
    "QXZPSSJ": "Please select delivery time",
    "DingDanJinE": "Order Amount",
    "SCFJ_ZD4Z": "Upload attachments, maximum 4, each not exceeding 3M",
    "KeYongShangPin": "Available Products",
    "ShiYongShuoMing": "Instructions for Use",
    "YouXiaoQi": "Validity Period",
    "Man": "Over",
    "BZZBZCTSFH": "Remarks do not support special characters temporarily",
    "QingXuanZe": "Please select",
    "KaiPiaoXuJia": "Need to add for invoicing",
    "GeDian": "points",
    "KPXJ1GD": "Need to add {num} points for invoicing",
    "PeiSongFangShi": "Delivery Method",
    "ShangPinZongJia": "Total Product Price",
    "YouHuiQuan": "Coupon",
    "ZhangKeXan": "pieces optional",
    "DDJEWMZ": "Order amount not met",
    "WDYHQ": "My Coupons",
    "KYYHQ": "Available Coupons",
    "YuanKeYong": "yuan available",
    "ChaKanDingDan": "View Order",
    "ShangPinHanShui": "Product includes tax",
    "SPWHS": "Product does not include tax",
    "QueRenDingDan": "Confirm Order",
    "XZSHDZ": "Add Shipping Address",
    "ShangPinQingDan": "Product List",
    "WKYYHQ": "No available coupons",
    "HuChi": "Mutually Exclusive",
    "DaiJinQuan": "Voucher",
    "YunFei": "Freight",
    "ShuiFei": "Tax Fee",
    "BKYYY": "Unavailable Reason",
    "YHQYGQ": "Coupon expired",
    "WDYHQSYSJ": "Coupon not yet available",
    "ZDSPJEWMZ": "Specified product amount not met",
    "BKYYHQ": "Unavailable Coupons",
    "YMZ_MYZJ_": "Already met [Over {m} yuan, get {n} pieces as gift]",
    "YMZ_MZ": "Already met [Over {m} yuan, get {n} as gift]",
    "ZG222YX_M1000": "Buy more {money} yuan to enjoy [Over {target} yuan, get {num} pieces as gift]",
    "ZG2JX_MZ": "Buy more {num} pieces to enjoy [Over {target} yuan, get {present} as gift]",
    "YMZ_MYJY_": "Already met [Over {m} yuan, reduce {n} yuan]",
    "ZGYX_MYJY_": "Buy more {m} yuan to enjoy [Over {n} yuan, reduce {o} yuan]",
    "YMZ_MYZ_": "Already met [Over {m} yuan, {n}% discount]",
    "ZGYX_MYZ_": "Buy more {m} yuan to enjoy [Over {n} yuan, {o}% discount]",
    //cart-presale-order
    "QXZPSFS": "Please select delivery method",
    "1ZSP_G": "1 type of product, total",
    "YSSP_YJ": "Pre-sale product, estimated",
    "JiaoHuoRiQi": "Delivery Date",
    "GMJLY": "Leave a message to the seller",
    //scan-to-cart
    "ZhengZaiChuLi...": "Processing...",
    "FSCSP": "Non-mall Product",
    "ZZCLTXM": "Processing barcode...",
    "SPTJCG": "Product added successfully",
    "QSTXM": "Please scan barcode",
    "SFSCDQSP": "Do you want to delete the current product?",
    "BQ_ZBDXGSP": "Sorry, no related products found",
    "XuanZeDanWei": "Select Unit",
    "JRGWC": "Add to Cart",
    "QXXZDJRSP": "Please select products to add first",
    "ZhengZaiChuLi": "Processing",
    "JRGWCCG": "Added to cart successfully",
    "ZanWuShangPin": "No products yet",
    //earn-brokerage-share
    "XTYJBNFZSP": "The system has helped you copy the product link!",
    "NKYHDDYDYJ": "You can get the corresponding commission. The commission can be found in \"My",
    "LiChaKan": "to view",
    "WeiXinHaoYou": "WeChat Friends",
    "ErWeiMa": "QR Code",
    "CASBEWM": "Long press to identify QR code",
    "FZSB_QCXFZ": "Copy failed, please re-copy!",
    "TWEWM": "Graphic QR Code",
    "BCDXC": "Save to Album",
    "CATPBCDXC": "Long press the image to save to album",
    "FuZhiLianJie": "Copy Link",
    "FXZYJ": "Share to Earn Commission",
    "YJZGKZQYJ": "Estimated maximum commission available",
    "PYTGNFXDYMCGGMH": "After friends successfully purchase through the page you shared, you can get the corresponding commission. The commission can be viewed in \"My-{path}\"",
    //goods-share
    "FXSPGLSKH": "Share products to retail customers",
    "FXHJSCNZSD": "After sharing, your exclusive mobile micro-mall will be generated. You can set the prices of products in the mall, fill in your contact information, and attract consumers to purchase on-site.",
    "WSCDQJG_ND": "Current price of micro-mall: Your order price ×",
    "DaiSheZhi": "To be set",
    "PengYouQuan": "Moments",
    "GGFXSZ": "Change Sharing Settings",
    //wechat-login
    "QXSRZH": "Please enter account first",
    "MMGSCW_6_20W": "Incorrect password format (6-20 letters or numbers)",
    "BDYYZH": "Bind existing account",
    "WXKJDL": "WeChat Quick Login",
    "BangDingZhangHao": "Bind Account",
    "YYZH_QDL": "Already have an account, go to login",
    "ZCXZH": "Register new account",
    "HuanYingNi": "Welcome",
    "ZH_SJHM": "Account/Phone Number",
    "MiMa": "Password",
    "QDLHCZ": "Please log in to operate",
    //add-to-cart
    "KCBZ_BNTJG": "Insufficient inventory, cannot add more",
    //combined-pay-online
    "ZhiFuChengGong": "Payment successful!",
    "ZFSB_QCXCS": "Payment failed, please try again!",
    "QXXZGG": "Please select specifications first",
    "SXGGX": "Selected specifications require",
    "GMSLXYQDL_": "Purchase quantity is less than minimum order quantity, please repurchase!",
    "GMSLDYXDL_": "Purchase quantity is more than limited quantity, please repurchase!",
    "ShangPinBianHao": "Product Number",
    "QiDing": "Minimum Order",
    "SXGGDGSLBK": "Order quantity for selected specifications cannot exceed",
    "KCBZ_BNTJ": "Insufficient inventory, cannot add",
    "QXXZSP": "Please select product first",
    "SLBNW0": "Quantity cannot be 0",
    "QXZGG": "Please select specifications",
    "LiJiYuDing": "Book Now",
    //nav
    "ShouYe": "Home",
    "ShangPin": "Products",
    "DingDan": "Orders",
    "WoDe": "My",
    //pay-online
    "ZhiFuQuXiao": "Payment Cancelled",
    //account-log
    "ShangPinYongJin": "Product Commission",
    "YaoQingJiangLi": "Thưởng mời mời",
    "TiXian": "Rút tiền",
    "TiXianBoHui": "Rút tiền bị từ chối",
    "ZhuanWeiYuE": "Chuyển thành số dư",
    "Jin7Tian": "7 ngày gần đây",
    "Jin30Tian": "30 ngày gần đây",
    "ShouZhiMingXi": "Chi tiết thu chi",
    "ZanWuShuJu": "Chưa có dữ liệu",
    //client-statistics
    "WoDeKeHu": "Khách hàng của tôi",
    "WoDeYaoQing": "Lời mời của tôi",
    //distribution-home
    "LeiJiKeHu": "Khách hàng tổng cộng",
    "LeiJiDingDan": "Đơn hàng tổng cộng",
    "YaoQingHaoYou": "Mời bạn bè",
    "LeiJiYaoQing": "Lời mời tổng cộng",
    "LJSY_Y_": "Tổng doanh thu (CNY)",
    "BHDJS": "Bao gồm chờ thanh toán",
    "J7TSY_Y_": "Doanh thu 7 ngày gần đây (CNY)",
    "J7TXZKH_R_": "Khách hàng mới 7 ngày gần đây (người)",
    "KTXYJ": "Hoa hồng có thể rút",
    "XYJYO": "Cần cố gắng hơn nhé",
    "ChangJianWenTi": "Câu hỏi thường gặp",
    "Q_ZMYJX_TG": "Q: Làm thế nào để \"tiếp thị kiếm tiền\"",
    "A_FXDPND_Z_": "A: Chia sẻ liên kết trang có biểu tượng \"kiếm\" trong cửa hàng, thu hút bạn bè nhấp vào. Bạn bè đăng ký (mối quan hệ khách hàng được thiết lập là liên kết ngay khi đăng ký) hoặc đặt hàng (mối quan hệ khách hàng được thiết lập là liên kết khi đặt hàng) và mua sản phẩm có biểu tượng \"kiếm\" trong cửa hàng, sẽ được tính làm doanh thu \"tiếp thị kiếm tiền\" theo phương pháp tính nhất định.",
    "Q_RHJS_TGZ": "Q: Làm thế nào tính doanh thu \"tiếp thị kiếm tiền\"?",
    "A_MGD_Z_TBD": "A: Mỗi sản phẩm có biểu tượng \"kiếm\" đều có tỷ lệ hoa hồng nhất định; sản phẩm không có dấu này không tham gia \"tiếp thị kiếm tiền\". Sau khi bạn bè thanh toán thành công qua liên kết chia sẻ của bạn, hoa hồng sẽ được tính theo tỷ lệ của từng sản phẩm trong đơn hàng (hoa hồng không tham gia tiếp thị là 0), sau đó cộng lại thành doanh thu của đơn hàng này. Doanh thu sẽ trừ đi phí vận chuyển, hoàn trả, giảm giá khi đủ điều kiện v.v., tính theo giá cuối cùng.",
    "Q_TGZQ_DSY": "Q: Doanh thu \"tiếp thị kiếm tiền\" đến tài khoản khi nào?",
    "A_HYTGNDFX": "A: Sau khi bạn bè thanh toán thành công qua liên kết chia sẻ của bạn, bạn có thể xem đơn tiếp thị này trong đơn hàng tiếp thị của trung tâm bán hàng, trạng thái là chờ thanh toán. Khi khách hàng xác nhận nhận hàng, giao dịch đơn hàng hoàn tất thanh toán, doanh thu này sẽ tự động chuyển vào tài khoản cá nhân của bạn, có thể rút tiền bất kỳ lúc nào.",
    "Q_LJKH_LJY": "Q: Danh sách khách hàng tổng cộng, lời mời tổng cộng không có ảnh đại diện và tên?",
    "A_WXYQZYGZ": "A: WeChat yêu cầu chỉ có khi theo dõi tài khoản dịch vụ được xác thực mới có thể lấy ảnh đại diện và tên. Khách hàng của cửa hàng là tài khoản dịch vụ được xác thực thì theo dõi tài khoản công khai của cửa hàng; nếu không phải tài khoản dịch vụ được xác thực thì theo dõi tài khoản công khai \"Yunshang Order\" và nhấp vào bất kỳ trang chi tiết sản phẩm nào của cửa hàng để lấy ảnh đại diện và tên.",
    "Q_WSMWASSG": "Q: Tại sao tôi chia sẻ theo quy tắc trên nhưng không nhận được doanh thu tiếp thị?",
    "A_1_HYKNBW": "A: 1. Bạn bè có thể chưa thiết lập mối quan hệ khách hàng với bạn (bạn bè đã nhấp vào liên kết của nhân viên bán hàng khác để đăng ký hoặc đặt hàng) 2. Nếu bạn bè mở liên kết chia sẻ của bạn ngoài môi trường WeChat (như trình duyệt mặc định của điện thoại), nếu trình duyệt không bật cookie, cũng sẽ không thể ghi lại mối quan hệ khách hàng, tức không thể ghi lại đơn tiếp thị 3. Nếu vẫn không có đơn tiếp thị sau khi kiểm tra các trường hợp trên, vui lòng liên hệ nhân viên.",
    //
    "XiaoShouZhongXin": "Trung tâm bán hàng",
    //generalize-goods
    "SPMC_GG_BH": "Tên sản phẩm / Quy cách / Mã số",
    "YuJiZhuan": "Dự kiến kiếm được",
    //invitation-home
    "YaoQingKa": "Thẻ mời",
    "YNYQJR_TGY": "Mời bạn tham gia cùng, tiếp thị để nhận thưởng",
    "DJBCDXC": "Nhấp để lưu vào álbum",
    "JYQKFSGHY_": "Gửi thẻ mời cho bạn bè, tiếp thị cửa hàng có phần thưởng",
    //join-home
    "HuanYingJiaRu": "Chào mừng tham gia",
    "YQNCW": "Mời bạn trở thành",
    "LiJiJiaRu": "Tham gia ngay",
    //order-statistics
    "YuJiYongJin": "Dự kiến hoa hồng",
    "YongJin": "Hoa hồng",
    "YuJiJiangLi": "Dự kiến thưởng",
    "JiangLi": "Thưởng",
    "SPTGDD": "Đơn hàng tiếp thị sản phẩm",
    "YQJLDD": "Đơn hàng thưởng mời mời",
    //performance-statistics
    "YeJiTongJi": "Thống kê业績",
    "LJKH_R_": "Khách hàng tổng cộng (người)",
    "SPYJ_Y_": "Hoa hồng sản phẩm (CNY)",
    "HanDaiJieSuan": "Bao gồm chờ thanh toán",
    "XGMCJS": "Giải thích thuật ngữ liên quan",
    "KeHu": "Khách hàng",
    "HFXYBDLKHG": "Người mua hoặc nhân viên phân phối đã liên kết mối quan hệ khách hàng với nhân viên phân phối",
    "YaoQing": "Lời mời",
    "FXYCGYQDXJ": "Nhân viên phân phối cấp dưới được nhân viên phân phối mời thành công",
    "FXYTJKHGMH": "Hoa hồng mà nhân viên phân phối có thể nhận được sau khi giới thiệu khách hàng mua hàng",
    "XJFXYTGSPH": "Thưởng mà cấp trên nhận được sau khi nhân viên phân phối cấp dưới tiếp thị sản phẩm",
    //posters-promoting
    "NiCheng": "Biệt danh",
    "HaiBaoTuiGuang": "Tiếp thị poster",
    "JHBFSGHY_T": "Gửi poster cho bạn bè, tiếp thị cửa hàng có phần thưởng",
    //settlement-home
    "JieSuanZhongXin": "Trung tâm thanh toán",
    "KTXJE": "Số tiền có thể rút",
    "TiXianJiLu": "Lịch sử rút tiền",
    //withdraw-account
    "KHRXMBNWK": "Tên chủ tài khoản không được để trống!",
    "KHHBNWK": "Ngân hàng phát hành không được để trống!",
    "YHKHBNWK": "Số tài khoản ngân hàng không được để trống!",
    "SFZTPBNWK": "Hình ảnh CCCD không được để trống!",
    "YHKTPBNWK": "Hình ảnh thẻ ngân hàng không được để trống!",
    "BaoCunChengGong": "Lưu thành công!",
    "SCSFZ": "Tải lên CCCD",
    "SCYHK": "Tải lên thẻ ngân hàng",
    "BaoCun": "Lưu",
    "TiXianZhangHu": "Tài khoản rút tiền",
    "TS_QTXZSXX": "Lưu ý: Vui lòng điền thông tin thực tế, có thể rút tiền sau khi phê duyệt thành công",
    "KHRXM": "Tên chủ tài khoản",
    "KaiHuHang": "Ngân hàng phát hành",
    "YinhangKaHao": "Số tài khoản ngân hàng",
    "QSRZSXM": "Vui lòng nhập tên thật",
    "QSRKHHMC": "Vui lòng nhập tên ngân hàng phát hành",
    "QSRYHKH": "Vui lòng nhập số tài khoản ngân hàng",
    //withdraw-deposit
    "QXSZTXZH": "Vui lòng thiết lập tài khoản rút tiền trước",
    "QuSheZhi": "Đi thiết lập",
    "JEXY10Y_BKT": "Số tiền nhỏ hơn 10 yuan, không thể rút!",
    "JECGKTXJE": "Số tiền vượt quá số tiền có thể rút!",
    "CGDRKTXSX_": "Vượt quá giới hạn rút tiền trong ngày, giới hạn rút tiền trong ngày là 20000 yuan!",
    "QueDingJiang": "Xác nhận sẽ",
    "ZhuanDaoYuE": "chuyển sang số dư?",
    "_JEDY10YSB": "1. Không thể rút tiền khi số tiền dưới 10 yuan;",
    "_BCTXDZSJ": "2. Thời gian đến账 của lần rút tiền này là trong 5 ngày làm việc kể từ khi gửi yêu cầu rút tiền thành công, giới hạn rút tiền trong ngày là 20000 yuan;",
    "_GBSRWHSS": "3. Doanh thu này là doanh thu có thuế, vui lòng tự đến cơ quan thuế liên quan để khai báo và nộp thuế thu nhập cá nhân!",
    "_ZDYEKYYS": "4. Chuyển sang số dư có thể dùng để mua sắm trong商城;",
    "TXSQCG_QDD": "Yêu cầu rút tiền thành công, vui lòng đợi phê duyệt",
    "JEDYKTXJE_": "Số tiền lớn hơn số tiền có thể rút, không thể chuyển sang số dư!",
    "ZZYECG_QDG": "Chuyển số dư thành công, vui lòng kiểm tra ở trung tâm cá nhân!",
    "BenCiTiXian": "Lần rút tiền này",
    "ZhuangDaoYuE": "Chuyển sang số dư",
    "TiXianDao": "Rút tiền đến",
    "JEW0BKZZYE": "Số tiền là 0 không thể chuyển sang số dư!",
    "DRTXSX2WY": "Giới hạn rút tiền trong ngày 20.000 yuan",
    "QuanBuTiXian": "Rút tất cả",
    "QueRenTiXian": "Xác nhận rút tiền",
    //goods-filter-tab
    "ZuiChangGouMai": "Mua thường xuyên nhất",
    "MoRenPaiXu": "Sắp xếp mặc định",
    "ZongHe": "Tổng hợp",
    "FenLei": "Danh mục",
    "XiaoLiangYouXian": "Ưu tiên doanh số",
    "XiaoLiang": "Doanh số",
    "JiaGe": "Giá",
    "ShaiXuan": "Lọc",
    "ZuiJinGouMai": "Mua gần đây",
    "CuXiaoYouXian": "Ưu tiên khuyến mãi",
    "QuanBuFenLei": "Tất cả danh mục",
    "ZhiKanCuXiao": "Chỉ xem khuyến mãi",
    "XuanZeFenLei": "Chọn danh mục",
    "QXZFL": "Vui lòng chọn danh mục",
    //goods-list-default
    "ZWXGSP": "Không có sản phẩm liên quan",
    //goods-brand-list
    "PinPaiHui": "Tổng hợp thương hiệu",
    //goods-classify-filter
    "TuiJianFenLei": "Danh mục đề xuất",
    "ShangPinFenLei": "Danh mục sản phẩm",
    "GengDuo": "Thêm",
    //goods-detail
    "DLZHBSDQQY": "Tài khoản đăng nhập không phải là tài khoản khách hàng doanh nghiệp hiện tại",
    "GXNHQ": "Chúc mừng bạn nhận được",
    "SZWSCJGH_C": "Chỉ có thể chia sẻ sau khi thiết lập giá cửa hàng mini program",
    "JHDJSHS_": "Còn lại đến khi kết thúc hoạt động:",
    "DLHKFX": "Đăng nhập để chia sẻ",
    "ZZHQXX_QSH": "Đang lấy thông tin, vui lòng thử lại sau",
    "Zhang": "Chỉ",
    "Tian": "Ngày",
    "QXZGGZQPD": "Vui lòng chọn quy cách trước khi phối đèn!",
    "Yuan": "Yuan",
    "XS_F_M": "Giờ/phút/giây",
    //integral
    "WoDeJiFen": "Điểm của tôi",
    "DaBaiLe": "Đã đánh bại",
    "JiFen": "Điểm",
    "DeHuiYuan": "thành viên",
    "ZhuanJiFen": "Kiếm điểm",
    "JiFenMingXi": "Chi tiết điểm",
    "HuanLiPin": "Đổi quà",
    "CKGDHL": "Xem thêm quà tốt",
    "ChaDingDan": "Kiểm tra đơn hàng",
    //integral-convert
    "DHSLBNCG": "Số lượng đổi không được vượt quá",
    "DuiHuanShuLiang": "Số lượng đổi",
    "SuoXuJiFen": "Điểm cần thiết",
    //integral-detail
    "LiPinXiangQing": "Chi tiết quà",
    "WoYaoDuiHuan": "Tôi muốn đổi",
    "ShengYu": "Còn lại",
    "TuWenXiangQing": "Chi tiết hình văn",
    "Jian": "Cái",
    "YiDuiWan": "Đã đổi xong",
    //integral-filter
    "FenLeiShaiXuan": "Lọc theo danh mục",
    "JiFenShaiXuan": "Lọc theo điểm",
    //integral-flow
    "JiFenShouRu": "Thu nhập điểm",
    "JiFenZhiChu": "Chi tiêu điểm",
    //integral-logistics
    "DingDanGenZong": "Theo dõi đơn hàng",
    "WuLiuGongSi": "Công ty logistics",
    "WuLiuDanHao": "Số hóa đơn logistics",
    //integral-order
    "DingDanLieBiao": "Danh sách đơn hàng",
    "YiFaHuo": "Đã gửi hàng",
    "JiFenDingDan": "Đơn hàng điểm",
    "ChaKanWuLiu": "Xem logistics",
    //integral-order-create
    "LPSLBZ_QCX": "Số lượng quà không đủ, vui lòng thanh toán lại",
    "JiFenBuZu": "Điểm không đủ",
    "ZhiFuXinXi": "Thông tin thanh toán",
    "JiXuGuangGuang": "Tiếp tục mua sắm",
    "QTXSHXX": "Vui lòng điền thông tin nhận hàng",
    "DuiHuanChengGong": "Đổi thành công",
    "LPDHQR": "Xác nhận đổi quà",
    "SCCKJ": "Giá tham khảo thị trường",
    "LiJiZhiFu": "Thanh toán ngay",
    //integral-order-detail
    "DingDanXiangQing": "Chi tiết đơn hàng",
    "DingDanZhuangTai": "Trạng thái đơn hàng",
    "DingDanBianHao": "Mã đơn hàng",
    "DuiHuanShiJian": "Thời gian đổi",
    "ShouHuoXinXi": "Thông tin nhận hàng",
    "HuaFeiJiFen": "Điểm tiêu tốn",
    //integral-rule
    "QDZJF": "Check-in để kiếm điểm",
    "XDZJF": "Đặt hàng để kiếm điểm",
    "1_MRQD_JL": "1. Check-in hàng ngày, thưởng {num} điểm",
    "2_LXQD3T_EW": "2. Check-in liên tục 3 ngày, thưởng thêm {num} điểm",
    "3_LXQD7T_EW": "3. Check-in liên tục 7 ngày, thưởng thêm {num} điểm",
    "DLZJF": "Đăng nhập để kiếm điểm",
    "MRDLYSDHSC": "Đăng nhập {name}商城 hàng ngày, thưởng {num} điểm",
    "DDWCHKHDYD": "Sau khi đơn hàng hoàn tất, có thể nhận được điểm gấp {num} lần số tiền đơn hàng",
    //integral-rule-detail
    "GuiZe": "Quy tắc",
    //integral-sign
    "QianDaoYouLi": "Check-in có quà",
    "QianDaoGuiZe": "Quy tắc check-in",
    "YLXQD": "Đã check-in liên tục",
    "YLXQD1T": "Đã check-in liên tục {num} ngày",
    "QDCG_NYJLX": "Check-in thành công, bạn đã check-in liên tục {num} ngày",
    "QDCG_BCHD1": "Check-in thành công, lần này nhận {num} điểm",
    "BCQDHD4JF_": "Lần check-in này nhận {num} điểm, tuyệt vời!",
    //
    "QSRBZ": "Vui lòng nhập ghi chú",
    "DingDanZengPin": "Quà tặng đơn hàng",
    "GuiGeBianHao": "Mã quy cách",
    "GuiGe": "Quy cách",
    //combined-pay
    "CDDWXFK": "Đơn hàng này không cần thanh toán",
    "YHYEBZ": "Số dư người dùng không đủ!",
    "ZFJEBNW0": "Số tiền thanh toán không được là 0!",
    "ZFJEBNDYDD": "Số tiền thanh toán không được lớn hơn số tiền cần thanh toán của đơn hàng",
    "DFKJE": "Số tiền cần thanh toán",
    "FuKuanFangShi": "Phương thức thanh toán",
    "FuJian": "Tệp đính kèm",
    "ZHYFZ": "Tài khoản đã sao chép",
    "GHSKZH": "Thay đổi tài khoản nhận tiền",
    "SYXXZFQSCF": "Nếu sử dụng thanh toán trực tiếp, vui lòng tải lên ảnh chụp màn hình thanh toán để tài chính xác nhận số tiền!",
    "XXZF_BXXZS": "Thanh toán trực tiếp, phải chọn tài khoản nhận tiền",
    "DingDanZhiFu": "Thanh toán đơn hàng",
    "ZFFS_HDFK": "Phương thức thanh toán: Thanh toán khi nhận hàng",
    "BCFKJE": "Số tiền thanh toán lần này",
    "YuE": "Số dư",
    "FuZhiZhangHao": "Sao chép tài khoản",
    "WSZXCXZFPZ": "Chưa thiết lập cấu hình thanh toán mini program",
    "XCXZFZHJY": "Tài khoản thanh toán mini program bị vô hiệu hóa",
    "SRZFJE": "Nhập số tiền thanh toán",
    "FuKuanZhangHu": "Tài khoản thanh toán",
    "QueRenZhiFu": "Xác nhận thanh toán",
    "ShaoHouZhiFu": "Thanh toán sau",
    //order
    "FKJLYTJ_DD": "Lịch sử thanh toán đã được thêm, đợi tài chính phê duyệt",
    "JiXuGuang": "Tiếp tục mua sắm",
    "BenCiFuKuan": "Thanh toán lần này",
    "FuKuanChengGong": "Thanh toán thành công",
    "ZhiFuFangShi": "Phương thức thanh toán",
    "ZhiFuDingDan": "Đơn hàng thanh toán",
    //order-batch-pay
    "QXXZSXZFDD": "Vui lòng chọn đơn hàng cần thanh toán trước",
    "PiLiangFuKuan": "Thanh toán hàng loạt",
    "FuKuan": "Thanh toán",
    "QuFuKuan": "Đi thanh toán",
    //order-create-result
    "YingFuJinE": "Số tiền phải trả",
    "XiaDanShiJian": "Thời gian đặt hàng",
    //order-deliver
    "SFQRSH": "Xác nhận nhận hàng chứ?",
    "DDQRSH": "Xác nhận nhận hàng đơn",
    "DFHSP": "Sản phẩm chờ gửi",
    "ShangPinShuLiang": "Số lượng sản phẩm",
    "ChuKuShiJian": "Thời gian xuất kho",
    "FaHuoShiJian": "Thời gian gửi hàng",
    "WuLiuBeiZhu": "Ghi chú logistics",
    "QueRenShouHuo": "Xác nhận nhận hàng",
    //
    "RYFK_QJSYG": "Nếu đã thanh toán, vui lòng liên hệ quản trị viên kịp thời",
    "QSRQXYY": "Vui lòng nhập lý do hủy",
    "H_DDJZDGB_QJKF": "sau đó, đơn hàng sẽ tự động đóng, vui lòng thanh toán sớm",
    "TuiHuoQingKuang": "Tình trạng trả hàng",
    "DingDanZongE": "Tổng số tiền đơn hàng",
    "DingDanBeiZhu": "Ghi chú đơn hàng",
    "FaHuoQingKuang": "Tình trạng gửi hàng",
    "DingDanFuJian": "Tệp đính kèm đơn hàng",
    "ShenQingTuiHuo": "Yêu cầu trả hàng",
    "G1TDSHJL_QRS": "Tổng cộng {num} bản ghi chờ nhận hàng, xác nhận nhận hàng chứ?",
    "DaiXiaDan": "Đặt hàng thay",
    "DingDanHao": "Số đơn hàng",
    "XiaDanFangShi": "Phương thức đặt hàng",
    "TuiHuoDan": "Đơn trả hàng",
    "ShangPinZongE": "Tổng số tiền sản phẩm",
    "YunFei_ZongZhong": "Phí vận chuyển (tổng trọng lượng",
    "SF_SPWS": "Thuế (sản phẩm không có thuế",
    "TePiJia": "Giá đặc biệt",
    "FuKuanQingKuang": "Tình trạng thanh toán",
    "TiaoJiLu": "bản ghi",
    "ZaiLaiYiDan": "Đặt hàng lại",
    "MuLiuXinXi": "Thông tin logistics",
    "QDSCGDD_": "Xác nhận xóa đơn hàng này?",
    "YiQueRen": "Đã xác nhận",
    "YiShouHuo": "Đã nhận hàng",
    "DaiFuJinE": "Số tiền chờ trả",
    "YiFuJinE": "Số tiền đã trả",
    "ZanWuJiLu": "Không có bản ghi",
    //
    "SPMC_DDH": "Tên sản phẩm / Số đơn hàng",
    "FuKuanZhuangTai": "Trạng thái thanh toán",
    "FaHuoZhuangTai": "Trạng thái gửi hàng",
    "QiShiShiJian": "Thời gian bắt đầu",
    "ZhongZhiShiJian": "Thời gian kết thúc",
    //order-list
    "CaoZuoChengGong": "Thao tác thành công",
    "ZBKGM": "Tạm không thể mua",
    "DQDDSPYXJ": "Sản phẩm đơn hàng hiện tại đã được下架",
    "DQDDBFSPYXJ": "Một số sản phẩm của đơn hàng hiện tại đã được下架",
    "JTJSJSP": "Chỉ thêm sản phẩm上架",
    "DingHuoDan": "Đơn đặt hàng",
    //order-log
    "DingDanRiZhi": "Nhật ký đơn hàng",
    //order-logistics
    "FuZhiChengGong": "Sao chép thành công",
    "FuZhiShiBai": "Sao chép thất bại",
    "FuZhi": "Sao chép",
    "BoDa": "Gọi",
    "WCWLDHXX": "Không có thông tin số hóa đơn logistics này",
    //order-pay
    "ZFCS_QCXXD": "Hết thời gian thanh toán, vui lòng đặt hàng lại",
    "YQYYCKZF": "Đã kích hoạt thanh toán tiền gửi trước",
    "BNDYDFKJE": "Không được lớn hơn số tiền cần thanh toán",
    "ZFJEBNWK": "Số tiền thanh toán không được để trống",
    "QXAPFK_FKH": "Vui lòng sắp xếp thanh toán trước, sau khi thanh toán, chụp màn hình và tải lên thông tin thanh toán để tài chính xác nhận số tiền",
    "DDTJCG_QJS": "Đơn hàng提交 thành công, vui lòng thanh toán kịp thời",
    "QXZFKFS": "Vui lòng chọn phương thức thanh toán",
    "SYYEZFH_HX": "Sau khi sử dụng số dư thanh toán, vẫn cần thanh toán",
    //
    "FuKuanJiLu": "Lịch sử thanh toán",
    "ZWFKJL": "Không có lịch sử thanh toán",
    "FuKuanXiangQing": "Chi tiết thanh toán",
    "FuKuanJinE": "Số tiền thanh toán",
    "ZhiDan": "Lập đơn",
    "ShenHe": "Phê duyệt",
    "ZuoFei": "Hủy bỏ",
    "ZuoFeiYuanYin": "Lý do hủy bỏ",
    "GLDHD": "Liên kết đơn đặt hàng",
    "HeXiaoJinE": "Số tiền核销",
    "HeXiaoZhuangTai": "Trạng thái核销",
    "DanJuZhuangTai": "Trạng thái đơn",
    "KeHuMingCheng": "Tên khách hàng",
    "ZhangDanHao": "Số hóa đơn",
    "ShouKuanZhangHao": "Tài khoản nhận tiền",
    "ShouKuanShiJian": "Thời gian nhận tiền",
    "FuKuanPingZheng": "Bằng chứng thanh toán",
    "GeFuJian": "tệp đính kèm",
    //order-statistics
    "DingDanTongJi": "Thống kê đơn hàng",
    "DingHuo0Bi": "Đặt hàng {num}笔",
    //order-statistics-detail
    "DDTJMX": "Chi tiết thống kê đơn hàng",
    "AGGTJ": "Thống kê theo quy cách",
    "AFLTJ": "Thống kê theo danh mục",
    "DDJE_Y": "Số tiền đơn hàng/yuan",
    "DHSP_Z": "Sản phẩm đặt hàng/loại",
    "DingHuoDan_Bi": "Đơn đặt hàng/笔",
    "DingHuoShangPin": "Sản phẩm đặt hàng",
    "JinE": "Số tiền",
    //refund-list
    "TuiHuo": "Trả hàng",
    //refund-apply
    "THDHWBC_QD": "Đơn trả hàng chưa được lưu, xác nhận rời đi?",
    "QSRSQTHJE": "Vui lòng nhập số tiền yêu cầu trả hàng",
    "QSRTHJE": "Vui lòng nhập số tiền trả hàng",
    "QSRBZXX": "Vui lòng nhập thông tin ghi chú",
    "YingTuiJinE": "Số tiền phải trả lại",
    "TJTHSQ": "Gửi yêu cầu trả hàng",
    "QXXZDHQD": "Vui lòng chọn danh sách đặt hàng trước",
    "DingHuoQingDan": "Danh sách đặt hàng",
    "SQTHJE": "Số tiền yêu cầu trả hàng",
    "DJXZSP": "Nhấp để chọn sản phẩm",
    "TuiHuoJinE": "Số tiền trả hàng",
    //refund-detail
    "THDDXQ": "Chi tiết đơn trả hàng",
    "YiTuiHuo": "Đã trả hàng",
    "YiTuiKuan": "Đã hoàn tiền",
    "THDZT": "Trạng thái đơn trả hàng",
    "TuiHuoDanHao": "Số đơn trả hàng",
    "TuiHuoShiJian": "Thời gian trả hàng",
    "TuiHuoCangKu": "Kho trả hàng",
    "THLXR": "Người liên hệ trả hàng",
    "TuiHuoQingDan": "Danh sách trả hàng",
    "TuiKuanZongE": "Tổng số tiền hoàn lại",
    "TuiKuanQingKuang": "Tình trạng hoàn tiền",
    "DaiTuiJinE": "Số tiền chờ hoàn",
    "YiTuiJinE": "Số tiền đã hoàn",
    //refund-product
    "SPMC_BH_GG": "Tên sản phẩm / Mã số / Mã quy cách / Mã vạch",
    "GZD1TJG": "Tổng cộng tìm thấy 1 kết quả",
    "JiaRuQingDan": "Thêm vào danh sách",
    //refund-result
    "ShenQingChengGong": "Yêu cầu thành công",
    "THDTJCG": "Đơn trả hàng提交 thành công",
    "ChaKanXiangQing": "Xem chi tiết",
    //goods-package-floor
    "HDWKS_WDZL": "Hoạt động chưa bắt đầu, đến sau nhé",
    "HDYJS_XCZD": "Hoạt động đã kết thúc, đến sớm hơn lần sau nhé",
    "ZWSZBT": "Tạm chưa thiết lập tiêu đề",
    "ChaKanGengDuo": "Xem thêm",
    //goods-promotion-floor
    "HCDZSJC": "Chênh lệch thời gian do bộ nhớ cache",
    "DLCKCXJ": "Đăng nhập để xem giá khuyến mãi",
    "ZWSZCX": "Tạm chưa thiết lập khuyến mãi",
    "JuKaiShi": "Còn lại đến khi bắt đầu",
    "Song": "Tặng",
    "JuJieShu": "Còn lại đến khi kết thúc",
    "YiJieShu": "Đã kết thúc",
    //search-floor
    "XiaoXi": "Thông báo",
    "SaoMaXiaDan": "Quét mã để đặt hàng",
    //home-page-custom
    "WZLCSJ": "Dữ liệu tầng未知",
    //jump-error
    "QXZYSDHAPP": "Vui lòng tải ứng dụng Yunshang Order",
    "QMTYQYGLD": "Trải nghiệm đầy đủ端 quản lý doanh nghiệp",
    "XZYSDHAPP": "Tải ứng dụng Yunshang Order",
    "HQGLDWZTY": "Nhận trải nghiệm đầy đủ端 quản lý",
    "JXTYDHD": "Tiếp tục trải nghiệm端 đặt hàng",
    //notice-detail
    "GongGaoXiangQing": "Chi tiết thông báo",
    "GongGaoFuJian": "Tệp đính kèm thông báo",
    //shop-error
    "NFWDYMBCZO": "Trang bạn truy cập không tồn tại哦~",
    "KeNengYuanYin": "Lý do có thể",
    "1_ZDZLSRCWD": "1. Nhập địa chỉ sai trong thanh địa chỉ;",
    "2_DJLGQLJ": "2. Nhấp vào liên kết đã hết hạn.",
    //shop-index
    "GuanLiDuan": "端 quản lý",
    "ZhuCe": "Đăng ký",
    "HYNTYYSDH": "Chào mừng bạn trải nghiệm Yunshang Order",
    "TYZHSJHDQG": "Dữ liệu tài khoản trải nghiệm sẽ được cập nhật định kỳ, vui lòng không nhập thông tin quan trọng",
    "TYZHZDNRSJ": "Nội dung và dữ liệu trong tài khoản trải nghiệm đều là giả, vui lòng không nhập thông tin quan trọng",
    "ZHZCCG": "Đăng ký tài khoản thành công",
    "DengLuZhangHao": "Tài khoản đăng nhập",
    "CSMMW": "Mật khẩu ban đầu là",
    "GNFYHQL": "Đã gửi phiếu giảm giá cho bạn",
    "Man1YuanKeYong": "Có thể sử dụng khi đủ {num} yuan",
    "LQH1TNKY": "Có thể sử dụng trong {day} ngày sau khi nhận phiếu",
    "YiJianLingQu": "Nhận ngay",
    "GXNHD1ZYHQ": "Chúc mừng bạn nhận được {num} phiếu giảm giá",
    "Gong1Yuan": "Tổng cộng {num} yuan",
    "LiJiShiYong": "Sử dụng ngay",
    //shop-login
    "NHWDL": "Bạn chưa đăng nhập",
    //shop-notice
    "ShangChengGongGao": "Thông báo商城",
    "ZanWuGongGao": "Không có thông báo",
    "1GeFuJian": "{num} tệp đính kèm",
    //deposit-detail
    "KouKuan": "Trừ tiền",
    "ChongZhi_Kuan": "Nạp tiền",
    "KouKuanZuoFei": "Hủy bỏ trừ tiền",
    "ChongZhiZuoFei": "Hủy bỏ nạp tiền",
    "ZhangHuMingXi": "Chi tiết tài khoản",
    "ZhangHuYuE": "Số dư tài khoản",
    "LiJiChongZhi": "Nạp tiền ngay",
    //deposit-recharge
    "CZJEBNXY1Y": "Số tiền nạp không được nhỏ hơn 1 yuan",
    "QSRZQDSZ": "Vui lòng nhập giá trị chính xác",
    "ZDYJE": "Số tiền tùy chỉnh",
    "ZWKTXSCZGN": "Tạm chưa mở chức năng nạp tiền trực tuyến",
    "ShiFuJinE": "Số tiền thực tế thanh toán",
    "ZhangHuChongZhi": "Nạp tiền vào tài khoản",
    "QXZCZJE": "Vui lòng chọn số tiền nạp",
    "QSRCZJE": "Vui lòng nhập số tiền nạp",
    "QLXNDZSYWY": "Vui lòng liên hệ nhân viên bán hàng专属 của bạn để nạp tiền",
    "ShouJia": "Giá bán",
    "YiShouQing": "Đã bán hết",
    "ChongZhiJinE": "Số tiền nạp",
    "QueRenFuKuan": "Xác nhận thanh toán",
    //deposit-recharge-result
    "QSDDID": "Thiếu id đơn hàng",
    "ChongZhiChengGong": "Nạp tiền thành công",
    "ChongZhiShiBai": "Nạp tiền thất bại",
    "CLZ_QSH...": "Đang xử lý, vui lòng đợi sau...",
    "ChongZhiFangShi": "Phương thức nạp tiền",
    "ChongZhiShiJian": "Thời gian nạp tiền",
    "JYLSH": "Số流水 giao dịch",
    "FanHuiShangCheng": "Quay lại商城",
    //recharge-online
    "ZFSB_QCS": "Thanh toán thất bại, vui lòng thử lại",
    "ZFYQX": "Thanh toán đã bị hủy",
    "ZFYC_QCS": "Thanh toán có异常, vui lòng thử lại",
    //user
    "LingQuanZhongXin": "Trung tâm nhận phiếu",
    "WeiShiYong": "Chưa sử dụng",
    "YiShiYong": "Đã sử dụng",
    "ZWYHQ": "Không có phiếu giảm giá",
    //keep-list
    "YiGouMai": "Đã mua",
    "ChangYongQingDan": "Danh sách thường dùng",
    "WoDeShouCang": "Bộ sưu tập của tôi",
    "QuGouWuChe": "Đi giỏ hàng",
    "GeShangPin": "sản phẩm",
    //login
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "Vui lòng nhập tài khoản!",
    "QSRMM": "Vui lòng nhập mật khẩu!",
    "QSRDLZH": "Vui lòng nhập tài khoản đăng nhập",
    "JiZhuMiMa": "Nhớ mật khẩu",
    "WangJiMiMa": "Quên mật khẩu?",
    "DengLu": "Đăng nhập",
    "DLZHBCZ_QL": "Tài khoản đăng nhập không tồn tại, vui lòng liên hệ quản trị viên để mở",
    "GQYZHSBJY_": "Tài khoản doanh nghiệp này bị vô hiệu hóa, vui lòng liên hệ Yunshang Order",
    "GQYZHSYQJS_": "Thời gian dùng thử tài khoản doanh nghiệp này đã kết thúc, vui lòng liên hệ Yunshang Order",
    "GQYZHYGQL_": "Tài khoản doanh nghiệp này đã hết hạn, cần gia hạn để sử dụng, vui lòng liên hệ Yunshang Order",
    "LiJiTiYan": "Trải nghiệm ngay",
    //my-collect
    "YiChuChengGong": "Xóa thành công",
    "QueHuo": "Hết hàng",
    "YCSCJ": "Xóa khỏi bộ sưu tập",
    //order-message
    "SheZhiChengGong": "Thiết lập thành công",
    "ZWWDXX": "Không có thông báo chưa đọc",
    "QuanBuYiDu": "Tất cả đã đọc",
    "DingDanXiaoXi": "Thông báo đơn hàng",
    //
    "YiQiang": "Đã抢",
    "LiJiLingQu": "Nhận ngay",
    "LingQuanHou": "Sau khi nhận phiếu",
    "TianNeiKeYong": "có thể sử dụng trong ngày",
    //
    "QSRSJH": "Vui lòng nhập số điện thoại",
    "QSRYZM": "Vui lòng nhập mã xác nhận",
    "QSRXMM": "Vui lòng nhập mật khẩu mới",
    "QSRZQSJGS": "Vui lòng nhập định dạng số điện thoại chính xác",
    "ChongZhiMiMa": "Đặt lại mật khẩu",
    "QSRNDSJHM": "Vui lòng nhập số điện thoại của bạn",
    "QSRDXYZ": "Vui lòng nhập mã xác nhận tin nhắn",
    "HQYZM": "Lấy mã xác nhận",
    "HKCXHQ": "có thể lấy lại sau",
    "QSR6_20WSZHZ": "Vui lòng nhập mật khẩu 6-20 ký tự số hoặc chữ",
    //share-setting
    "QSRSPJGBL": "Vui lòng nhập tỷ lệ giá sản phẩm",
    "SPJGBLBXDY": "Tỷ lệ giá sản phẩm phải lớn hơn hoặc bằng 100, và nhỏ hơn 999.99",
    "DPMCZBZCTS": "Tên cửa hàng tạm không hỗ trợ ký tự đặc biệt",
    "LXRZBZCTSF": "Người liên hệ tạm không hỗ trợ ký tự đặc biệt",
    "LXFSZBZCTS": "Phương thức liên hệ tạm không hỗ trợ ký tự đặc biệt",
    "LXDZZBZCTS": "Địa chỉ liên hệ tạm không hỗ trợ ký tự đặc biệt",
    "DPJJZBZCTS": "Giới thiệu cửa hàng tạm không hỗ trợ ký tự đặc biệt",
    "QSRDPJJ_ZD": "Vui lòng nhập giới thiệu cửa hàng, tối đa 50 ký tự",
    "FenXiangSheZhi": "Thiết lập chia sẻ",
    "NDWSCSPJG": "Giá sản phẩm cửa hàng mini program của bạn",
    "NDDHJ_": "Giá đặt hàng của bạn ×",
    "LXXX_KBJ_": "Thông tin liên hệ (có thể chỉnh sửa）",
    "DianPuMingCheng": "Tên cửa hàng",
    "JianJie": "Giới thiệu",
    "QSRDPMC": "Vui lòng nhập tên cửa hàng",
    "LianXiRen": "Người liên hệ",
    "QSRLXR": "Vui lòng nhập người liên hệ",
    "LianXiFangShi": "Phương thức liên hệ",
    "QSRLXFS": "Vui lòng nhập phương thức liên hệ",
    "LianXiDiZhi": "Địa chỉ liên hệ",
    "QSRLXDZ": "Vui lòng nhập địa chỉ liên hệ",
    //user
    "WoDeDingDan": "Đơn hàng của tôi",
    "ZuiJinLiuLan": "Xem gần đây",
    "ShouCangShangPin": "Sản phẩm được lưu",
    "BDYYZH_ZC": "Liên kết tài khoản đã có | Đăng ký tài khoản mới",
    "DL_ZC": "Đăng nhập | Đăng ký",
    "BangDingShouJi": "Liên kết điện thoại",
    "TS_BDSJHM_": "Lưu ý: Liên kết số điện thoại, tài khoản an toàn hơn!",
    "ChaKanQuanBu": "Xem tất cả",
    "ShouHuoDiZhi": "Địa chỉ nhận hàng",
    "LianXiWoMen": "Liên hệ chúng tôi",
    "SheZhi": "Thiết lập",
    "QuQianDao": "Đi check-in",
    "QianDao": "Check-in",
    "JiFenShangCheng": "商城 điểm",
    "TuiGuangShangPin": "Tiếp thị sản phẩm",
    "QuChaKan": "Đi xem",
    "JiFenHuanLi": "Đổi quà bằng điểm",
    "DYSPBQ": "In nhãn sản phẩm",
    //user-about
    "GYYSDH": "Về Yunshang Order",
    "YQHYSMEWM_": "Mời bạn bè quét mã QR, tải và cài đặt trực tiếp",
    "DangQianBanBen": "Phiên bản hiện tại",
    //user-address
    "ZWSHDZ": "Không có địa chỉ nhận hàng",
    "WoDeDiZhi": "Địa chỉ của tôi",
    "ZhiNengShiBie": "Nhận dạng thông minh",
    "ZTDZXXKZNS": "Dán thông tin địa chỉ có thể nhận dạng tự động tên, số điện thoại, địa chỉ",
    "MoRen": "Mặc định",
    "QRSCDZ": "Xác nhận xóa địa chỉ?",
    "SHRXM": "Tên người nhận",
    "SJHMHGDDHZ": "Ít nhất phải điền một trong số điện thoại hoặc điện thoại cố định",
    "QSRSHRXM": "Vui lòng nhập tên người nhận",
    "ShouJiHaoMa": "Số điện thoại",
    "GuDingDianHua": "Điện thoại cố định",
    "QSRGDDH": "Vui lòng nhập điện thoại cố định",
    "SuoZaiDiQu": "Khu vực ở",
    "QSRSZDQ": "Vui lòng nhập khu vực ở",
    "QSRXXDZ": "Vui lòng nhập địa chỉ chi tiết!",
    "QSRZQDSJHM": "Vui lòng nhập số điện thoại chính xác",
    "QSRZQDGDDH": "Vui lòng nhập điện thoại cố định chính xác",
    "XiangXiDiZhi": "Địa chỉ chi tiết",
    "MoRenDiZhi": "Địa chỉ mặc định",
    "SWMRDZ": "Đặt làm địa chỉ mặc định",
    "BCBSY": "Lưu và sử dụng",
    //user-bing-one
    "QSRSJHM": "Vui lòng nhập số điện thoại",
    "GYHYZC": "Người dùng này đã đăng ký",
    "GSJHMYJZCG": "Số điện thoại này đã được đăng ký",
    "QZJDLJK": "Vui lòng đăng nhập trực tiếp",
    "QuDengLu": "Đi đăng nhập",
    "BDHKYTGSJH": "Sau khi liên kết, có thể đăng nhập qua số điện thoại, tiện lợi cho bạn lấy lại mật khẩu, tăng độ an toàn của tài khoản",
    "_BDHKYTGSJ": "*Sau khi liên kết, có thể đăng nhập qua số điện thoại, tiện lợi cho bạn lấy lại mật khẩu, tăng độ an toàn của tài khoản",
    "QSRSJYZM": "Vui lòng nhập mã xác nhận điện thoại",
    "BDXSJ": "Liên kết điện thoại mới",
    "DXYZM": "Mã xác nhận tin nhắn",
    "XiaYiBu": "Bước tiếp theo",
    "TGCBZ": "Bỏ qua bước này",
    //user-bing-two
    "DBDSJHMBCZ": "Số điện thoại待绑定 không tồn tại!",
    "QSRDLMM": "Vui lòng nhập mật khẩu đăng nhập!",
    "_GSJHMYBDY": "*Số điện thoại này đã liên kết với tài khoản Yunshang Order, xác minh mật khẩu đăng nhập điện thoại, có thể liên kết với tài khoản hiện tại",
    "DQZHMMJTBW": "Mật khẩu tài khoản hiện tại sẽ được đồng bộ thành mật khẩu đăng nhập điện thoại",
    "DangQianZhangHao": "Tài khoản hiện tại",
    "QDYJZ": "Xác nhận muốn将这",
    "JSPSCM": "sản phẩm xóa chứ?",
    "ShanChuChengGong": "Xóa thành công！",
    //user-info
    "SJGSCW": "Lỗi định dạng điện thoại",
    "YXGSCW": "Lỗi định dạng email",
    "WoDeZhangHao": "Tài khoản của tôi",
    "YouXiang": "Email",
    "ShouJi": "Điện thoại",
    "XingMing": "Tên",
    "XiuGaiTouXiang": "Chỉnh sửa ảnh đại diện",
    "JiBenXinXi": "Thông tin cơ bản",
    "ZhangHaoAnQuan": "An toàn tài khoản",
    "XiuGaiMiMa": "Chỉnh sửa mật khẩu",
    "DianJiBangDing": "Nhấp để liên kết",
    "RYDSHTY_QL": "Nếu bị mất hoặc không dùng nữa, vui lòng thay đổi ngay lập tức, tránh tài khoản bị xâm phạm",
    "WBZNDZHAQ_": "Để đảm bảo an toàn tài khoản của bạn, vui lòng liên kết điện thoại",
    "QSRNDXM": "Vui lòng nhập tên của bạn",
    "QSRNDDH": "Vui lòng nhập số điện thoại của bạn",
    "QSRNDYX": "Vui lòng nhập email của bạn",
    //user-setting
    "QCHCHXCXDL": "Cần đăng nhập lại sau khi xóa cache",
    "QingChuHuanCun": "Xóa cache",
    "QDYQCHCM": "Xác nhận xóa cache?",
    "TuiChuDengLu": "Đăng xuất",
    "ZhangHaoZhuXiao": "Hủy tài khoản",
    "QieHuanZhangHao": "Chuyển tài khoản",
    //user-supplier
    "LianXi": "Liên hệ",
    "GongSiDianHua": "Số điện thoại công ty",
    "DiZhi": "Địa chỉ",
    //vouchers-detail
    "DJQMX": "Chi tiết phiếu giảm giá",
    //vouchers-list
    "BuKeYong": "Không thể sử dụng",
    "KeYong": "Có thể sử dụng",
    "ZWDJQ": "Không có phiếu giảm giá",
    "ZongEDu": "Tổng mức độ",
    "FaFangShiJian": "Thời gian phát hành",
    "EDYYW": "Mức độ đã hết",
    "QBSPKY": "Tất cả sản phẩm có thể sử dụng",
    //vouchers-select-list
    "WDDJQ": "Phiếu giảm giá của tôi",
    "KYDJQ": "Phiếu giảm giá có thể sử dụng",
    "DJQKDK": "Phiếu giảm giá có thể giảm",
    "CKKYSP": "Xem sản phẩm có thể sử dụng",
    "BKYDJQ": "Phiếu giảm giá không thể sử dụng",
    "BKYYY_ZWFH": "Lý do không thể sử dụng: Không có sản phẩm phù hợp",
    //goods-detail
    "DQSPWSCGGT": "Sản phẩm hiện tại chưa tải lên hình quy cách, không hỗ trợ phối đèn！",
    "BoFangShiPin": "Phát video",
    "Gong1GeGuiGe": "Tổng cộng {num} quy cách",
    "YiXuanGuiGe": "Quy cách đã chọn",
    "XuanGuiGe": "Chọn quy cách",
    "LingQuan": "Nhận phiếu",
    // "Jian":"减",
    "1ZhongCuXiao": "{num} loại khuyến mãi",
    "1ZhangKeYong": "{num} cái có thể sử dụng",
    "ZuiGaoKeSheng": "Tiết kiệm tối đa",
    "ShangPinTaoCan": "Gói sản phẩm",
    "Gong1GeTaoCan": "Tổng cộng {num} gói",
    "ShangPinCanShu": "Thông số sản phẩm",
    "ZhanKai": "Mở rộng",
    "YiShouCang": "Đã lưu",
    "ShouCang": "Lưu",
    "KeFu": "客服",
    "XiangQing": "Chi tiết",
    "TuiJian": "Đề xuất",
    "BianHao": "Mã số",
    "ShangPinXinXi": "Thông tin sản phẩm",
    "KLYHQ": "Có thể nhận phiếu giảm giá",
    "KuCunBuZu": "Kho không đủ",
    "DuoGuiGe": "Nhiều quy cách",
    "YiShou": "Đã bán",
    "SWBHZ_YS": "Đang bổ sung hàng sau khi bán hết, đã bán",
    "CuXiaoShangPin": "Sản phẩm khuyến mãi",
    //goods-search
    "NHWSRSSNR": "Bạn chưa nhập nội dung tìm kiếm",
    "SouSuo": "Tìm kiếm",
    "SSY1XGDSP": "Tìm sản phẩm liên quan đến {searchKey}",
    "Yue1GeShangPin": "Khoảng {num} sản phẩm",
    "ZuiJinSouSuo": "Tìm kiếm gần đây",
    "QingChu": "Xóa",
    "ZWSSJL": "Không có lịch sử tìm kiếm",
    //goods-property
    "ZGJGBNDYZD": "Giá cao nhất không được thấp hơn giá thấp nhất",
    "ShangPinBiaoQian": "Nhãn sản phẩm",
    "BuGaoYu1": "Không cao hơn 1",
    "BuDiYu1": "Không thấp hơn 1",
    "FengGe": "Phong cách",
    //goods-promotion-list
    "JiJiangKaiShi": "Sắp bắt đầu",
    "QuanBuCuXiao": "Tất cả khuyến mãi",
    //goods-package-list
    "Gong1JianShangPin": "Tổng cộng {num} sản phẩm",
    "Sheng": "Tiết kiệm",
    //goods-package-detail
    "GTCZGWCZDS": "Số lượng gói này trong giỏ hàng đã đạt đến giới hạn mua, không thể thêm vào giỏ hàng",
    "GTCKCBZ_BK": "Kho gói này không đủ, không thể thêm vào giỏ hàng",
    "JinSheng1Tao": "Chỉ còn lại {num} gói",
    "XianGou1Tao": "Giới hạn mua {num} gói",
    "TaoCanXiangQing": "Chi tiết gói",
    "DanMaiJia": "Giá bán lẻ",
    "TaoCanJia": "Giá gói",
    "HDYJS": "Hoạt động đã kết thúc",
    //goods-message
    "WDL_QXDL": "Chưa đăng nhập, vui lòng đăng nhập trước",
    //goods-list-label
    "XinPinShangShi": "Sản phẩm mới ra mắt",
    "WDLZH_ZWCX": "Chưa đăng nhập tài khoản, không có hoạt động khuyến mãi！",
    "YiXiaShangPin": "Sản phẩm sau đây",
    //goods-list
    "1ZhongGuiGe": "{num} loại quy cách",
    "YouKuCun": "Có hàng trong kho",
    //goods-filter
    "BuGaoYu": "Không cao hơn",
    "BuDiYu": "Không thấp hơn",
    "CuXiao": "Khuyến mãi",
    "ZDYXXZ3G": "Tối đa cho phép chọn 3",
    "GouMai": "Mua",
    "Gong1Jian": "Tổng cộng {num} cái",
    //缺失
    "YiChuShouCangJia": "Xóa khỏi bộ sưu tập",
    "$": "¥",
    "$1": "¥{num}",
    "_8999_1Qi": "¥ 8999.1起",
    "Ge": "cái",
    "BaoZhuangFangShi": "Phương thức đóng gói",
    "QRSCSP_": "Xác nhận xóa sản phẩm？",
    "JEWM_TMFRK": "Đặt mã QR/mã vạch vào khung, sẽ quét tự động",
    "0ZSP_G0J": "0 loại sản phẩm, tổng cộng 0 cái",
    "JiuMiMa": "Mật khẩu cũ",
    "XMM_6_20WZ": "Mật khẩu mới（6-20 ký tự chữ hoặc số）",
    "QueRenMiMa": "Xác nhận mật khẩu",
    "BDHKSYSJHD": "Sau khi liên kết, có thể đăng nhập bằng số điện thoại, tiện lợi cho lấy lại mật khẩu, tăng độ an toàn của tài khoản",
    "YanZhengMa": "Mã xác nhận",
    "1MHKCXHQ": "Có thể lấy lại sau 1 giây",
    "CSJHZ1MQFS": "Số điện thoại này đã gửi mã xác nhận trước 1 giây, vui lòng thử lại sau",
    "GouMaiJiLu": "Lịch sử mua",
    "XinZengDiZhi": "Thêm địa chỉ mới",
    "LingShouJia": "Giá bán lẻ",
    "YouHuiJia": "Giá ưu đãi",
    "ShangPinChuKu": "Xuất kho sản phẩm",
    "DengDaiShouHuo": "Chờ nhận hàng",
    "ShouHuoRen": "Người nhận",
    "PaiZhao": "Chụp ảnh",
    "XiangCe": "Album",
    "TiYanGuan": "Trung tâm trải nghiệm",
    "JingYingShiJian": "Thời gian kinh doanh",
    "ZhanGuanDianHua": "Số điện thoại trưng bày",
    "ZhanGuanDiZhi": "Địa chỉ trưng bày",
    "SJHQZ_QSDZ": "Đang lấy dữ liệu, vui lòng thử lại sau！",
    "QXXZSF_": "Vui lòng chọn tỉnh trước!",
    "QuanBuShengFen": "Tất cả tỉnh",
    "QuanBuChengShi": "Tất cả thành phố",
    "YingYeShiJian": "Thời gian hoạt động",
    "ChanPinBianHao": "Mã sản phẩm",
    "DLXXYGQ_QC": "Thông tin đăng nhập đã hết hạn, vui lòng đăng nhập lại",
    "Man999Jian100": "Giảm {n} khi đủ {m}",
    "YiManZu": "Đã đạt điều kiện",
    "QDYCSP_": "Xác nhận xóa sản phẩm？",
    "DGM10JZ1J": " Đặt hàng đủ 10 cái tặng 1 cái ",
    // route-fetch
    "XiaXianTongZhi": "Thông báo offline",
    "NDZHYZQTSB": "Tài khoản của bạn đã đăng nhập trên thiết bị khác, vui lòng đăng nhập lại. Nếu không phải hoạt động của bạn, vui lòng thay đổi mật khẩu kịp thời",
    "ManJiang": 'Giảm {num} yuan khi đủ {target} cái',
    "ZGLXMJ": 'Mua thêm {num} cái để được "giảm至 {money_} yuan khi đủ {target} cái"',
    "ZGLXMZ": 'Mua thêm {num} cái để được "chiết khấu {percent} khi đủ {target} cái" ',
    "QSRZQNR": 'Vui lòng nhập nội dung chính xác',
    "NHYDDQKWJQ": 'Bạn còn {num} đơn hàng tổng cộng {money} yuan chưa thanh toán nợ, thanh toán xong mới có thể đặt hàng tiếp',
    //发票助手
    "FaPiaoZhuShou": "Trợ lý hóa đơn",
    "WoDeFaPiao": "Hóa đơn của tôi",
    "FaPiaoXiangQing": "Chi tiết hóa đơn",
    "KaiPiaoShiJian": "Thời gian phát hóa đơn",
    "DaiKaiFaPiao": "Hóa đơn chờ phát",
    "DKFPJE": "Số tiền hóa đơn chờ phát",
    "KaiPiaoJinE": "Số tiền phát hóa đơn",
    "ZFYDWT_QCSCXZF": "Có vấn đề với thanh toán, vui lòng thử lại hoặc đổi phương thức thanh toán",
    "QingXuanZhe": "Vui lòng chọn",
    "ShouXin": 'Tín dụng',
    "LJSQSXED": "Yêu cầu hạn mức tín dụng ngay",
    "SXEDSHZ": "Hạn mức tín dụng đang được phê duyệt",
    "SXCZ_XDCG": "Tín dụng đủ, đặt hàng thành công",
    "SXEDBZ_FKHFH": "Hạn mức tín dụng không đủ, gửi hàng sau khi thanh toán",
    "CGJKZQ_FKFH": "Vượt quá kỳ hạn vay, gửi hàng sau khi thanh toán",
    "DDTJCG_XZZCZHYB": "Đơn hàng提交 thành công, chỉ còn bước cuối cùng！",
    "MianFeiLing": "Nhận miễn phí",
    "M_KMFLQ_HQ": "Có thể nhận miễn phí khi đủ {target} yuan, còn thiếu {short} yuan",
    "YHDMFSP": "Đã nhận sản phẩm miễn phí",
    "JRMFL": "Nhận miễn phí hôm nay",
    "LingGuangLe": "Đã nhận hết",
    "KeLingQu": "Có thể nhận",
    "YuGuJia": "Dự giá",
    "GXNHQ_Z_Y_": "Chúc mừng bạn nhận được {num} {price} yuan {name}",
    "LXZSKF": "Liên hệ客服专属",
    "DPYDY_QSHX": "Cửa hàng đã đóng, vui lòng đặt hàng sau",
    "DaYangShiJian": "Thời gian đóng cửa",
    "ChuanHaoChaXun": 'Tra cứu串号',
    'IMEI': '串号',
    "FanKuanYuE": "Số dư hoàn lại",
    "FanKuanZhiFu": "Thanh toán hoàn lại",
    "JingDongYiYunJia": "Jingdong YiYun+",
    "MercadoPago": "MercadoPago",
    "FKYEBZ": "Số dư hoàn lại không đủ",
    "FanKuanZhangHu": "Tài khoản hoàn lại",
    "HaiXuZhiFu": "Còn cần thanh toán {price}",
    // 20-11-11 add
    "QTXGSMC": "Vui lòng điền tên công ty",
    "QSCSFZZMZ": "Vui lòng tải lên ảnh正面 CCCD",
    "QSCSFZFMZ": "Vui lòng tải lên ảnh反面 CCCD",
    "QSCYYZZ": "Vui lòng tải lên giấy phép kinh doanh",
    "TJCG_QNXDDSH": "提交 thành công, vui lòng đợi phê duyệt kiên nhẫn",
    "SXSQ": "Yêu cầu tín dụng",
    "QYJBZL": "Thông tin cơ bản doanh nghiệp",
    "SQFRSFZZM": "Tải lên ảnh正面 CCCD chủ doanh nghiệp",
    "ZMSLT": "Ảnh ví dụ正面",
    "SCFRSFZFM": "Tải lên ảnh反面 CCCD chủ doanh nghiệp",
    "FMSLT": "Ảnh ví dụ反面",
    "QQBSFZSJWZ_WZQXKBB": "Vui lòng đảm bảo bốn góc CCCD hoàn chỉnh, chữ rõ ràng có thể nhận dạng",
    "SCYYZZ": "Tải lên giấy phép kinh doanh",
    "ShengHeZhong": "Đang phê duyệt",
    "TiJiaoShenHe": "Gửi phê duyệt",
    "GSMC": "Tên công ty",
    "DDDKFQRBJQSH": "Đơn hàng chờ客服 xác nhận báo giá vui lòng đợi sau",
    "XDTX": "Thông báo đặt hàng",
    "NH_GDDBH": "Một số sản phẩm có giá chờ客服 xác thực mới có thể thanh toán",
    "QRXD": "Xác nhận đặt hàng",
    "DaiHeJia": "Chờ kiểm tra giá",
    "ZHJY": "Còn lại tài khoản",
    "YGTG": "Tiếp thị nhân viên",
    "YuanGong": "Nhân viên",
    "DuiZhanGJieSuan": "Đối soát và thanh toán",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK": "Còn lại tài khoản = Số dư tiền gửi trước + Số dư hoàn lại + Trả hàng chờ hoàn tiền - Đơn hàng phải thanh toán",
    "YCKYE": "Số dư tiền gửi trước",
    "FKYE": "Số dư hoàn lại",
    "DDYFK": "Đơn hàng phải thanh toán",
    "THDTK": "Trả hàng chờ thanh toán",
    "YuCunKuanZuoFei": "Hủy bỏ tiền gửi trước",
    "FanKuanZhangHuMingXi": "Chi tiết tài khoản hoàn lại",
    "TKCZDFKZH": "Hoàn tiền nạp vào tài khoản hoàn lại",
    "RMBJE": "Số tiền RMB"
};
exports.default = vi_VN;

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(307);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Shop = exports.Shop = {
    path: '/shop',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(1).then((function (require) {
            return cb(null, __webpack_require__(374).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var ShopPage = exports.ShopPage = {
    path: '/shop/page',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function (require) {
            return cb(null, __webpack_require__(374).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsList = exports.GoodsList = {
    path: '/shop/GoodsList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(15).then((function (require) {
            return cb(null, __webpack_require__(947).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsDetail = exports.GoodsDetail = {
    path: '/shop/GoodsDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(0).then((function (require) {
            return cb(null, __webpack_require__(907).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsSearch = exports.GoodsSearch = {
    path: '/shop/GoodsSearch',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(98).then((function (require) {
            return cb(null, __webpack_require__(954).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsMessage = exports.GoodsMessage = {
    path: '/shop/GoodsMessage',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(72).then((function (require) {
            return cb(null, __webpack_require__(948).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsSearchResult = exports.GoodsSearchResult = {
    path: '/shop/GoodsSearchResult',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(19).then((function (require) {
            return cb(null, __webpack_require__(953).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsListLabel = exports.GoodsListLabel = {
    path: '/shop/GoodsListLabel',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(22).then((function (require) {
            return cb(null, __webpack_require__(946).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsPromotionList = exports.GoodsPromotionList = {
    path: '/shop/GoodsPromotionList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(10).then((function (require) {
            return cb(null, __webpack_require__(951).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsPackageList = exports.GoodsPackageList = {
    path: '/shop/GoodsPackageList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(33).then((function (require) {
            return cb(null, __webpack_require__(950).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsPackageDetail = exports.GoodsPackageDetail = {
    path: '/shop/GoodsPackageDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(20).then((function (require) {
            return cb(null, __webpack_require__(949).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var CartList = exports.CartList = {
    path: '/shop/CartList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(9).then((function (require) {
            return cb(null, __webpack_require__(911).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var CartOrderPlatform = exports.CartOrderPlatform = {
    path: '/shop/CartOrderPlatform',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(17).then((function (require) {
            return cb(null, __webpack_require__(912).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var CartOrder = exports.CartOrder = {
    path: '/shop/CartOrder',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(16).then((function (require) {
            return cb(null, __webpack_require__(913).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var OrderCreateResult = exports.OrderCreateResult = {
    path: '/shop/OrderCreateResult',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(118).then((function (require) {
            return cb(null, __webpack_require__(969).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var cartPresaleOrder = exports.cartPresaleOrder = {
    path: '/shop/cartPresaleOrder',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(23).then((function (require) {
            return cb(null, __webpack_require__(914).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var OrderPay = exports.OrderPay = {
    path: '/shop/OrderPay',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(30).then((function (require) {
            return cb(null, __webpack_require__(972).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var OrderList = exports.OrderList = {
    path: '/shop/OrderList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(3).then((function (require) {
            return cb(null, __webpack_require__(971));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var OrderBatchPay = exports.OrderBatchPay = {
    path: '/shop/OrderBatchPay',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(5).then((function (require) {
            return cb(null, __webpack_require__(968));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var OrderDetail = exports.OrderDetail = {
    path: '/shop/OrderDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(21).then((function (require) {
            return cb(null, __webpack_require__(970));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

/*我的*/
var UserInfo = exports.UserInfo = {
    path: '/shop/UserInfo',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(48).then((function (require) {
            return cb(null, __webpack_require__(1015));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserAddress = exports.UserAddress = {
    path: '/shop/UserAddress',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(37).then((function (require) {
            return cb(null, __webpack_require__(906).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserAddressEdit = exports.UserAddressEdit = {
    path: '/shop/UserAddressEdit',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(53).then((function (require) {
            return cb(null, __webpack_require__(827).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserSetting = exports.UserSetting = {
    path: '/shop/UserSetting',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(101).then((function (require) {
            return cb(null, __webpack_require__(1021).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var MyCollect = exports.MyCollect = {
    path: '/shop/MyCollect',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(6).then((function (require) {
            return cb(null, __webpack_require__(1003).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var KeepList = exports.KeepList = {
    path: '/shop/KeepList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(7).then((function (require) {
            return cb(null, __webpack_require__(1002).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var UserSupplier = exports.UserSupplier = {
    path: '/shop/UserSupplier',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(36).then((function (require) {
            return cb(null, __webpack_require__(1023));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserAbout = exports.UserAbout = {
    path: '/shop/UserAbout',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(94).then((function (require) {
            return cb(null, __webpack_require__(1009));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var User = exports.User = {
    path: '/shop/User',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(29).then((function (require) {
            return cb(null, __webpack_require__(1024).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsProperty = exports.GoodsProperty = {
    path: '/shop/GoodsProperty',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(121).then((function (require) {
            return cb(null, __webpack_require__(952).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var ShopError = exports.ShopError = {
    path: '/shop/ShopError',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(113).then((function (require) {
            return cb(null, __webpack_require__(986).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var JumpError = exports.JumpError = {
    path: '/shop/JumpError',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(96).then((function (require) {
            return cb(null, __webpack_require__(984).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var ShopNotice = exports.ShopNotice = {
    path: '/shop/ShopNotice',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(12).then((function (require) {
            return cb(null, __webpack_require__(987).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var NoticeDetail = exports.NoticeDetail = {
    path: '/shop/NoticeDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(114).then((function (require) {
            return cb(null, __webpack_require__(985).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var OrderMessage = exports.OrderMessage = {
    path: '/shop/OrderMessage',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(79).then((function (require) {
            return cb(null, __webpack_require__(1004).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var PaySuccess = exports.PaySuccess = {
    path: '/shop/PaySuccess',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(82).then((function (require) {
            return cb(null, __webpack_require__(976).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var OtherPaySuccess = exports.OtherPaySuccess = {
    path: '/shop/OtherPaySuccess',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(116).then((function (require) {
            return cb(null, __webpack_require__(975).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var UserBing = exports.UserBing = {
    path: '/shop/UserBing',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(106).then((function (require) {
            return cb(null, __webpack_require__(1010).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserBingTwo = exports.UserBingTwo = {
    path: '/shop/UserBingTwo',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(105).then((function (require) {
            return cb(null, __webpack_require__(1011).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var GoodsClassifyFilter = exports.GoodsClassifyFilter = {
    path: '/shop/GoodsClassifyFilter',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(63).then((function (require) {
            return cb(null, __webpack_require__(944).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsGroupClassifyFilter = exports.GoodsGroupClassifyFilter = {
    path: '/shop/GoodsGroupClassifyFilter',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(27).then((function (require) {
            return cb(null, __webpack_require__(945).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var GoodsBrandList = exports.GoodsBrandList = {
    path: '/shop/GoodsBrandList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(68).then((function (require) {
            return cb(null, __webpack_require__(943).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var CouponList = exports.CouponList = {
    path: '/shop/CouponList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(64).then((function (require) {
            return cb(null, __webpack_require__(992).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var ReceiveCoupon = exports.ReceiveCoupon = {
    path: '/shop/ReceiveCoupon',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(11).then((function (require) {
            return cb(null, __webpack_require__(1005).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 对账结算列表
var SettleAccountsDetail = exports.SettleAccountsDetail = {
    path: '/shop/SettleAccountsDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(108).then((function (require) {
            return cb(null, __webpack_require__(1007).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 返款账户明细
var BackAccountDetail = exports.BackAccountDetail = {
    path: '/shop/BackAccountDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(78).then((function (require) {
            return cb(null, __webpack_require__(1006).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 预存款详情
var DepositDetail = exports.DepositDetail = {
    path: '/shop/DepositDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(80).then((function (require) {
            return cb(null, __webpack_require__(994).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 预存款充值
var DepositRecharge = exports.DepositRecharge = {
    path: '/shop/DepositRecharge',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(8).then((function (require) {
            return cb(null, __webpack_require__(996).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 预存款充值结果
var DepositRechargeResult = exports.DepositRechargeResult = {
    path: '/shop/DepositRechargeResult',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(88).then((function (require) {
            return cb(null, __webpack_require__(995).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var OrderStatistics = exports.OrderStatistics = {
    path: '/shop/OrderStatistics',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(117).then((function (require) {
            return cb(null, __webpack_require__(974).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var OrderStatisticsDetail = exports.OrderStatisticsDetail = {
    path: '/shop/OrderStatisticsDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(60).then((function (require) {
            return cb(null, __webpack_require__(973).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 分享设置
var ShareSetting = exports.ShareSetting = {
    path: '/shop/ShareSetting',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(107).then((function (require) {
            return cb(null, __webpack_require__(1008).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

//商城首页
var Integral = exports.Integral = {
    path: '/shop/integral',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(13).then((function (require) {
            return cb(null, __webpack_require__(965));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//商城首页
var IntegralList = exports.IntegralList = {
    path: '/shop/IntegralList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(65).then((function (require) {
            return cb(null, __webpack_require__(957));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//积分商品详情
var IntegralDetail = exports.IntegralDetail = {
    path: '/shop/IntegralDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(24).then((function (require) {
            return cb(null, __webpack_require__(955));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//积分明细
var IntegralFlow = exports.IntegralFlow = {
    path: '/shop/IntegralFlow',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(61).then((function (require) {
            return cb(null, __webpack_require__(956));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//赚积分
var IntegralRule = exports.IntegralRule = {
    path: '/shop/IntegralRule',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(119).then((function (require) {
            return cb(null, __webpack_require__(963));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//赚积分规则
var IntegralRuleDetail = exports.IntegralRuleDetail = {
    path: '/shop/IntegralRuleDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(120).then((function (require) {
            return cb(null, __webpack_require__(962));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//订单确认
var IntegralOrderCreate = exports.IntegralOrderCreate = {
    path: '/shop/IntegralOrderCreate',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(34).then((function (require) {
            return cb(null, __webpack_require__(959));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//积分商城订单列表
var IntegralOrder = exports.IntegralOrder = {
    path: '/shop/IntegralOrder',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(71).then((function (require) {
            return cb(null, __webpack_require__(961));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//积分商城订单详情
var IntegralOrderDetail = exports.IntegralOrderDetail = {
    path: '/shop/IntegralOrderDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(100).then((function (require) {
            return cb(null, __webpack_require__(960));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//积分商城订单跟踪
var IntegralLogistics = exports.IntegralLogistics = {
    path: '/shop/IntegralLogistics',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(92).then((function (require) {
            return cb(null, __webpack_require__(958));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
//积分商城签到有礼
var IntegralSign = exports.IntegralSign = {
    path: '/shop/IntegralSign',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(14).then((function (require) {
            return cb(null, __webpack_require__(964));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 退货申请
var RefundApply = exports.RefundApply = {
    path: '/shop/RefundApply',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(18).then((function (require) {
            return cb(null, __webpack_require__(977).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 退货申请-结果页
var RefundResult = exports.RefundResult = {
    path: '/shop/RefundResult',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(85).then((function (require) {
            return cb(null, __webpack_require__(981).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 退货申请-列表页
var RefundList = exports.RefundList = {
    path: '/shop/RefundList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(4).then((function (require) {
            return cb(null, __webpack_require__(979).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 退货申请-详情页
var RefundDetail = exports.RefundDetail = {
    path: '/shop/RefundDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(28).then((function (require) {
            return cb(null, __webpack_require__(978).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 退货申请-商品页
var RefundProduct = exports.RefundProduct = {
    path: '/shop/RefundProduct',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(35).then((function (require) {
            return cb(null, __webpack_require__(980).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 合并支付
var CombinedPay = exports.CombinedPay = {
    path: '/shop/CombinedPay',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(47).then((function (require) {
            return cb(null, __webpack_require__(967).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 合并支付成功
var CombinedPaySuccess = exports.CombinedPaySuccess = {
    path: '/shop/CombinedPaySuccess',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(73).then((function (require) {
            return cb(null, __webpack_require__(966).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 销售中心
var DistributionHome = exports.DistributionHome = {
    path: '/shop/DistributionHome',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(26).then((function (require) {
            return cb(null, __webpack_require__(926).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 业绩统计
var PerformanceStatistics = exports.PerformanceStatistics = {
    path: '/shop/PerformanceStatistics',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(89).then((function (require) {
            return cb(null, __webpack_require__(931).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 客户统计
var ClientStatistics = exports.ClientStatistics = {
    path: '/shop/ClientStatistics',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(49).then((function (require) {
            return cb(null, __webpack_require__(925).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 订单统计
var ClientOrderStatistics = exports.ClientOrderStatistics = {
    path: '/shop/ClientOrderStatistics',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(70).then((function (require) {
            return cb(null, __webpack_require__(930).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 推广商品
var GeneralizeGoods = exports.GeneralizeGoods = {
    path: '/shop/GeneralizeGoods',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(57).then((function (require) {
            return cb(null, __webpack_require__(927).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 结算中心
var SettlementHome = exports.SettlementHome = {
    path: '/shop/SettlementHome',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(87).then((function (require) {
            return cb(null, __webpack_require__(933).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 提现
var WithdrawDeposit = exports.WithdrawDeposit = {
    path: '/shop/WithdrawDeposit',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(123).then((function (require) {
            return cb(null, __webpack_require__(935).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 提现账户
var WithdrawAccount = exports.WithdrawAccount = {
    path: '/shop/WithdrawAccount',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(42).then((function (require) {
            return cb(null, __webpack_require__(934).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 收支明细
var AccountLog = exports.AccountLog = {
    path: '/shop/AccountLog',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(76).then((function (require) {
            return cb(null, __webpack_require__(924).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 提现记录
var WithdrawLog = exports.WithdrawLog = {
    path: '/shop/WithdrawLog',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(75).then((function (require) {
            return cb(null, __webpack_require__(936).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 加盟落地页
var JoinHome = exports.JoinHome = {
    path: '/join',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(99).then((function (require) {
            return cb(null, __webpack_require__(929).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 邀请卡
var InvitationHome = exports.InvitationHome = {
    path: '/shop/InvitationHome',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(41).then((function (require) {
            return cb(null, __webpack_require__(928).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 海报推广
var PostersPromoting = exports.PostersPromoting = {
    path: '/shop/PostersPromoting',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(40).then((function (require) {
            return cb(null, __webpack_require__(932).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 最近浏览
var UserFootprint = exports.UserFootprint = {
    path: '/shop/UserFootprint',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(31).then((function (require) {
            return cb(null, __webpack_require__(1014).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 扫码加入购物车
var ScanToCart = exports.ScanToCart = {
    path: '/shop/ScanToCart',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(2).then((function (require) {
            return cb(null, __webpack_require__(373).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 扫码加入购物车(ios兼容)
var ScanToCartIos = exports.ScanToCartIos = {
    path: '/shop/shop/ScanToCart',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function (require) {
            return cb(null, __webpack_require__(373).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 串号扫码
var GoodsSnScan = exports.GoodsSnScan = {
    path: '/shop/GoodsSnScan',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(122).then((function (require) {
            return cb(null, __webpack_require__(939).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 代金券
var VouchersList = exports.VouchersList = {
    path: '/shop/VouchersList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(69).then((function (require) {
            return cb(null, __webpack_require__(1026).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var VouchersDetail = exports.VouchersDetail = {
    path: '/shop/VouchersDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(77).then((function (require) {
            return cb(null, __webpack_require__(1025).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var ExperienceList = exports.ExperienceList = {
    path: '/shop/ExperienceList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(59).then((function (require) {
            return cb(null, __webpack_require__(938).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var ExperienceDetail = exports.ExperienceDetail = {
    path: '/shop/ExperienceDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(45).then((function (require) {
            return cb(null, __webpack_require__(937).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 定制首页
var Custom = exports.Custom = {
    path: '/shop/Custom',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(67).then((function (require) {
            return cb(null, __webpack_require__(923).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 定制搜索
var CustomSearch = exports.CustomSearch = {
    path: '/shop/Custom/Search',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(39).then((function (require) {
            return cb(null, __webpack_require__(922).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 定制规格
var CustomGoods = exports.CustomGoods = {
    path: '/shop/Custom/Goods',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(62).then((function (require) {
            return cb(null, __webpack_require__(921).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 语言设置(未使用)
var LangSetting = exports.LangSetting = {
    path: '/shop/LangSetting',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(103).then((function (require) {
            return cb(null, __webpack_require__(1017).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 申请授信
var ClientCreditApply = exports.ClientCreditApply = {
    path: '/shop/ClientCreditApply',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(46).then((function (require) {
            return cb(null, __webpack_require__(988).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 授信管理
var ClientCreditList = exports.ClientCreditList = {
    path: '/shop/ClientCreditList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(81).then((function (require) {
            return cb(null, __webpack_require__(990).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 授信管理
var ClientCreditContract = exports.ClientCreditContract = {
    path: '/shop/ClientCreditContract',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(112).then((function (require) {
            return cb(null, __webpack_require__(989).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 发票管理
var InvoiceAssistantList = exports.InvoiceAssistantList = {
    path: '/shop/InvoiceAssistantList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(55).then((function (require) {
            return cb(null, __webpack_require__(1000).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 发票管理
var InvoiceAssistantDetail = exports.InvoiceAssistantDetail = {
    path: '/shop/InvoiceAssistantDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(90).then((function (require) {
            return cb(null, __webpack_require__(999).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 串号查询
var GoodsSnVerifyRecord = exports.GoodsSnVerifyRecord = {
    path: '/shop/VerifyRecord',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(44).then((function (require) {
            return cb(null, __webpack_require__(942).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 串号查询
var GoodsSnSearch = exports.GoodsSnSearch = {
    path: '/shop/GoodsSnSearch',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(86).then((function (require) {
            return cb(null, __webpack_require__(940).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var GoodsSnVerify = exports.GoodsSnVerify = {
    path: '/shop/GoodsSnVerify',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(54).then((function (require) {
            return cb(null, __webpack_require__(941).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 账号注销
var UserLogOff = exports.UserLogOff = {
    path: '/shop/UserLogOff',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(66).then((function (require) {
            return cb(null, __webpack_require__(1018).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 存货管理
var ConsignGoodsList = exports.ConsignGoodsList = {
    path: '/shop/ConsignGoodsList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(51).then((function (require) {
            return cb(null, __webpack_require__(915).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 存货
var ConsignStock = exports.ConsignStock = {
    path: '/shop/ConsignStock',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(38).then((function (require) {
            return cb(null, __webpack_require__(917).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 提货
var ConsignPickUp = exports.ConsignPickUp = {
    path: '/shop/ConsignPickUp',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(25).then((function (require) {
            return cb(null, __webpack_require__(916).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 提货记录
var ConsignPickUpRecord = exports.ConsignPickUpRecord = {
    path: '/shop/ConsignPickUpRecord',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(50).then((function (require) {
            return cb(null, __webpack_require__(919).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 提货申请
var ConsignPickUpSuccess = exports.ConsignPickUpSuccess = {
    path: '/shop/ConsignPickUpSuccess',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(83).then((function (require) {
            return cb(null, __webpack_require__(920).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 提货单详情
var ConsignPickUpDetail = exports.ConsignPickUpDetail = {
    path: '/shop/ConsignPickUpDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(32).then((function (require) {
            return cb(null, __webpack_require__(918).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 子账户
var UserSubAccount = exports.UserSubAccount = {
    path: '/shop/UserSubAccount',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(93).then((function (require) {
            return cb(null, __webpack_require__(1022).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 员工推广
var EmployeePromotion = exports.EmployeePromotion = {
    path: '/shop/EmployeePromotion',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(110).then((function (require) {
            return cb(null, __webpack_require__(998).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
// 铺货上报
var DistributionReport = exports.DistributionReport = {
    path: '/shop/DistributionReport',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(56).then((function (require) {
            return cb(null, __webpack_require__(997).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserCredit = exports.UserCredit = {
    path: '/shop/UserCredit',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(43).then((function (require) {
            return cb(null, __webpack_require__(1013));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserQuotationList = exports.UserQuotationList = {
    path: '/shop/UserQuotationList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(58).then((function (require) {
            return cb(null, __webpack_require__(1020));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var CustomerServiceCenter = exports.CustomerServiceCenter = {
    path: '/user/ServiceCenter',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(95).then((function (require) {
            return cb(null, __webpack_require__(993).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserMessage = exports.UserMessage = {
    path: '/shop/UserMessage',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(102).then((function (require) {
            return cb(null, __webpack_require__(1019).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var UserCooperate = exports.UserCooperate = {
    path: '/shop/UserCooperate',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(104).then((function (require) {
            return cb(null, __webpack_require__(1012));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var JoinApply = exports.JoinApply = {
    path: '/shop/JoinApply',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(109).then((function (require) {
            return cb(null, __webpack_require__(1001));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};
var CooperateApply = exports.CooperateApply = {
    path: '/shop/CooperateApply',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(111).then((function (require) {
            return cb(null, __webpack_require__(991));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 防伪码查询
var SecurityCodeSearch = exports.SecurityCodeSearch = {
    path: '/shop/SecurityCodeSearch',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(97).then((function (require) {
            return cb(null, __webpack_require__(983).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var SecurityCodeScan = exports.SecurityCodeScan = {
    path: '/shop/SecurityCodeScan',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(115).then((function (require) {
            return cb(null, __webpack_require__(982).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var UserInquiry = exports.UserInquiry = {
    path: '/shop/UserInquiry',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(52).then((function (require) {
            return cb(null, __webpack_require__(1016));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var MyBargainList = exports.MyBargainList = {
    path: '/shop/MyBargainList',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(91).then((function (require) {
            return cb(null, __webpack_require__(910).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var MyBargainDetail = exports.MyBargainDetail = {
    path: '/shop/MyBargainDetail',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(84).then((function (require) {
            return cb(null, __webpack_require__(908).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

var BargainHelp = exports.BargainHelp = {
    path: '/shop/BargainHelp',
    getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(74).then((function (require) {
            return cb(null, __webpack_require__(909).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

// 自提点选择
// export const PickUpStationList = {
//     path: '/user/PickUpStationList',
//     getComponent(nextState, cb) {
//         require.ensure([], (require) => {
//             return cb(null, require('../routes/user/pick-up-station-list').default);
//         }, "PickUpStationList")
//     }
// };

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(396), __esModule: true };

/***/ }),
/* 240 */,
/* 241 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 243 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(400);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var document = __webpack_require__(56).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(55) && !__webpack_require__(99)(function () {
  return Object.defineProperty(__webpack_require__(245)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(243);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(118);
var $export = __webpack_require__(78);
var redefine = __webpack_require__(252);
var hide = __webpack_require__(79);
var Iterators = __webpack_require__(157);
var $iterCreate = __webpack_require__(406);
var setToStringTag = __webpack_require__(160);
var getPrototypeOf = __webpack_require__(412);
var ITERATOR = __webpack_require__(82)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(120);
var createDesc = __webpack_require__(121);
var toIObject = __webpack_require__(81);
var toPrimitive = __webpack_require__(165);
var has = __webpack_require__(61);
var IE8_DOM_DEFINE = __webpack_require__(246);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(55) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(251);
var hiddenKeys = __webpack_require__(156).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(61);
var toIObject = __webpack_require__(81);
var arrayIndexOf = __webpack_require__(402)(false);
var IE_PROTO = __webpack_require__(161)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(79);


/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(672)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(811);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import './HdDialog.scss';
var HdDialog = function (_React$Component) {
    _inherits(HdDialog, _React$Component);

    function HdDialog(props) {
        _classCallCheck(this, HdDialog);

        var _this = _possibleConstructorReturn(this, (HdDialog.__proto__ || Object.getPrototypeOf(HdDialog)).call(this, props));

        _this.state = {
            options: _this.props.options
        };
        return _this;
    }

    //组件接收到新的props时调用，并将其作为参数nextProps使用，此时可以更改组件props及state。


    _createClass(HdDialog, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.options.type == 'msg' || nextProps.options.type == 'success') {
                clearTimeout(this.timer);
                this.timer = setTimeout(function () {
                    _this2.props.hideDialog();
                }, 1800);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // 如果存在this.timer，则使用clearTimeout清空。
            // 如果你使用多个timer，那么用多个变量，或者用个数组来保存引用，然后逐个clear
            this.timer && clearTimeout(this.timer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.options.type == 'confirm') {
                return _react2.default.createElement(
                    'section',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'header',
                            { className: 'dialog-header' },
                            this.props.options.title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: this.props.options.content } })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-operate' },
                            this.props.options.cancelTxt && _react2.default.createElement(
                                'button',
                                { className: this.props.options.cancelClass || "cancel",
                                    onClick: this.props.options.cancel || this.props.hideDialog.bind(this) },
                                this.props.options.cancelTxt || '取消'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: this.props.options.confirmClass || "confirm",
                                    onClick: this.props.options.confirm },
                                this.props.options.confirmTxt || '确定'
                            )
                        )
                    ),
                    _react2.default.createElement('div', { className: 'dialog-mask', onClick: function onClick() {
                            return _this3.props.hideDialog();
                        } })
                );
            } else if (this.props.options.type == 'msg') {
                return _react2.default.createElement(
                    'section',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog-msg' },
                        this.props.options.content
                    )
                );
            } else if (this.props.options.type == 'success') {
                return _react2.default.createElement(Success, { content: this.props.options.content });
            } else {
                return null;
            }
        }
    }]);

    return HdDialog;
}(_react2.default.Component);

module.exports = HdDialog;

//成功提示
var Success = function Success(props) {
    return _react2.default.createElement(
        'div',
        { className: 'dialog-success' },
        _react2.default.createElement('img', { src: __webpack_require__(368), alt: '' }),
        _react2.default.createElement(
            'p',
            null,
            props.content
        )
    );
};

/***/ }),
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(783);


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var o=String(e).split("."),r=Number(o[0])==e&&o[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":r>=3&&r<=10?"few":r>=11&&r<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},"year-short":{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},"month-short":{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},"day-short":{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},"hour-short":{displayName:"Std.",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Std.",other:"in {0} Std."},past:{one:"vor {0} Std.",other:"vor {0} Std."}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},"minute-short":{displayName:"Min.",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Min.",other:"in {0} Min."},past:{one:"vor {0} Min.",other:"vor {0} Min."}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}},"second-short":{displayName:"Sek.",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sek.",other:"in {0} Sek."},past:{one:"vor {0} Sek.",other:"vor {0} Sek."}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.id=a())}(this,function(){"use strict";return[{locale:"id",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"tahun",relative:{0:"tahun ini",1:"tahun depan","-1":"tahun lalu"},relativeTime:{future:{other:"dalam {0} tahun"},past:{other:"{0} tahun yang lalu"}}},"year-short":{displayName:"thn.",relative:{0:"tahun ini",1:"tahun depan","-1":"tahun lalu"},relativeTime:{future:{other:"dlm {0} thn"},past:{other:"{0} thn lalu"}}},month:{displayName:"bulan",relative:{0:"bulan ini",1:"bulan berikutnya","-1":"bulan lalu"},relativeTime:{future:{other:"dalam {0} bulan"},past:{other:"{0} bulan yang lalu"}}},"month-short":{displayName:"bln.",relative:{0:"bulan ini",1:"bulan berikutnya","-1":"bulan lalu"},relativeTime:{future:{other:"dlm {0} bln"},past:{other:"{0} bln lalu"}}},day:{displayName:"hari",relative:{0:"hari ini",1:"besok",2:"lusa","-2":"kemarin dulu","-1":"kemarin"},relativeTime:{future:{other:"dalam {0} hari"},past:{other:"{0} hari yang lalu"}}},"day-short":{displayName:"h",relative:{0:"hari ini",1:"besok",2:"lusa","-2":"kemarin dulu","-1":"kemarin"},relativeTime:{future:{other:"dalam {0} h"},past:{other:"{0} h lalu"}}},hour:{displayName:"Jam",relative:{0:"jam ini"},relativeTime:{future:{other:"dalam {0} jam"},past:{other:"{0} jam yang lalu"}}},"hour-short":{displayName:"jam",relative:{0:"jam ini"},relativeTime:{future:{other:"dalam {0} jam"},past:{other:"{0} jam lalu"}}},minute:{displayName:"menit",relative:{0:"menit ini"},relativeTime:{future:{other:"dalam {0} menit"},past:{other:"{0} menit yang lalu"}}},"minute-short":{displayName:"mnt.",relative:{0:"menit ini"},relativeTime:{future:{other:"dlm {0} mnt"},past:{other:"{0} mnt lalu"}}},second:{displayName:"detik",relative:{0:"sekarang"},relativeTime:{future:{other:"dalam {0} detik"},past:{other:"{0} detik yang lalu"}}},"second-short":{displayName:"dtk.",relative:{0:"sekarang"},relativeTime:{future:{other:"dlm {0} dtk"},past:{other:"{0} dtk lalu"}}}}}]});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ms=a())}(this,function(){"use strict";return[{locale:"ms",pluralRuleFunction:function(e,a){return a&&1==e?"one":"other"},fields:{year:{displayName:"tahun",relative:{0:"tahun ini",1:"tahun depan","-1":"tahun lalu"},relativeTime:{future:{other:"dalam {0} tahun"},past:{other:"{0} tahun lalu"}}},"year-short":{displayName:"thn",relative:{0:"thn ini",1:"thn depan","-1":"thn lepas"},relativeTime:{future:{other:"dalam {0} thn"},past:{other:"{0} thn lalu"}}},month:{displayName:"bulan",relative:{0:"bulan ini",1:"bulan depan","-1":"bulan lalu"},relativeTime:{future:{other:"dalam {0} bulan"},past:{other:"{0} bulan lalu"}}},"month-short":{displayName:"bln",relative:{0:"bln ini",1:"bln depan","-1":"bln lalu"},relativeTime:{future:{other:"dlm {0} bln"},past:{other:"{0} bln lalu"}}},day:{displayName:"hari",relative:{0:"hari ini",1:"esok",2:"lusa","-2":"kelmarin","-1":"semalam"},relativeTime:{future:{other:"dalam {0} hari"},past:{other:"{0} hari lalu"}}},"day-short":{displayName:"hari",relative:{0:"hari ini",1:"esok",2:"lusa","-2":"kelmarin","-1":"semlm"},relativeTime:{future:{other:"dlm {0} hari"},past:{other:"{0} hari lalu"}}},hour:{displayName:"jam",relative:{0:"jam ini"},relativeTime:{future:{other:"dalam {0} jam"},past:{other:"{0} jam lalu"}}},"hour-short":{displayName:"jam",relative:{0:"jam ini"},relativeTime:{future:{other:"dlm {0} jam"},past:{other:"{0} jam lalu"}}},minute:{displayName:"minit",relative:{0:"pada minit ini"},relativeTime:{future:{other:"dalam {0} minit"},past:{other:"{0} minit lalu"}}},"minute-short":{displayName:"min",relative:{0:"pada minit ini"},relativeTime:{future:{other:"dlm {0} min"},past:{other:"{0} min lalu"}}},second:{displayName:"saat",relative:{0:"sekarang"},relativeTime:{future:{other:"dalam {0} saat"},past:{other:"{0} saat lalu"}}},"second-short":{displayName:"saat",relative:{0:"sekarang"},relativeTime:{future:{other:"dlm {0} saat"},past:{other:"{0} saat lalu"}}}}},{locale:"ms-Arab",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"ms-BN",parentLocale:"ms"},{locale:"ms-SG",parentLocale:"ms"}]});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ru=a())}(this,function(){"use strict";return[{locale:"ru",pluralRuleFunction:function(e,a){var t=String(e).split("."),r=t[0],o=!t[1],n=r.slice(-1),l=r.slice(-2);return a?"other":o&&1==n&&11!=l?"one":o&&n>=2&&n<=4&&(l<12||l>14)?"few":o&&0==n||o&&n>=5&&n<=9||o&&l>=11&&l<=14?"many":"other"},fields:{year:{displayName:"год",relative:{0:"в этом году",1:"в следующем году","-1":"в прошлом году"},relativeTime:{future:{one:"через {0} год",few:"через {0} года",many:"через {0} лет",other:"через {0} года"},past:{one:"{0} год назад",few:"{0} года назад",many:"{0} лет назад",other:"{0} года назад"}}},"year-short":{displayName:"г.",relative:{0:"в этом г.",1:"в след. г.","-1":"в прошлом г."},relativeTime:{future:{one:"через {0} г.",few:"через {0} г.",many:"через {0} л.",other:"через {0} г."},past:{one:"{0} г. назад",few:"{0} г. назад",many:"{0} л. назад",other:"{0} г. назад"}}},month:{displayName:"месяц",relative:{0:"в этом месяце",1:"в следующем месяце","-1":"в прошлом месяце"},relativeTime:{future:{one:"через {0} месяц",few:"через {0} месяца",many:"через {0} месяцев",other:"через {0} месяца"},past:{one:"{0} месяц назад",few:"{0} месяца назад",many:"{0} месяцев назад",other:"{0} месяца назад"}}},"month-short":{displayName:"мес.",relative:{0:"в этом мес.",1:"в следующем мес.","-1":"в прошлом мес."},relativeTime:{future:{one:"через {0} мес.",few:"через {0} мес.",many:"через {0} мес.",other:"через {0} мес."},past:{one:"{0} мес. назад",few:"{0} мес. назад",many:"{0} мес. назад",other:"{0} мес. назад"}}},day:{displayName:"день",relative:{0:"сегодня",1:"завтра",2:"послезавтра","-2":"позавчера","-1":"вчера"},relativeTime:{future:{one:"через {0} день",few:"через {0} дня",many:"через {0} дней",other:"через {0} дня"},past:{one:"{0} день назад",few:"{0} дня назад",many:"{0} дней назад",other:"{0} дня назад"}}},"day-short":{displayName:"дн.",relative:{0:"сегодня",1:"завтра",2:"послезавтра","-2":"позавчера","-1":"вчера"},relativeTime:{future:{one:"через {0} дн.",few:"через {0} дн.",many:"через {0} дн.",other:"через {0} дн."},past:{one:"{0} дн. назад",few:"{0} дн. назад",many:"{0} дн. назад",other:"{0} дн. назад"}}},hour:{displayName:"час",relative:{0:"в этот час"},relativeTime:{future:{one:"через {0} час",few:"через {0} часа",many:"через {0} часов",other:"через {0} часа"},past:{one:"{0} час назад",few:"{0} часа назад",many:"{0} часов назад",other:"{0} часа назад"}}},"hour-short":{displayName:"ч",relative:{0:"в этот час"},relativeTime:{future:{one:"через {0} ч.",few:"через {0} ч.",many:"через {0} ч.",other:"через {0} ч."},past:{one:"{0} ч. назад",few:"{0} ч. назад",many:"{0} ч. назад",other:"{0} ч. назад"}}},minute:{displayName:"минута",relative:{0:"в эту минуту"},relativeTime:{future:{one:"через {0} минуту",few:"через {0} минуты",many:"через {0} минут",other:"через {0} минуты"},past:{one:"{0} минуту назад",few:"{0} минуты назад",many:"{0} минут назад",other:"{0} минуты назад"}}},"minute-short":{displayName:"мин.",relative:{0:"в эту минуту"},relativeTime:{future:{one:"через {0} мин.",few:"через {0} мин.",many:"через {0} мин.",other:"через {0} мин."},past:{one:"{0} мин. назад",few:"{0} мин. назад",many:"{0} мин. назад",other:"{0} мин. назад"}}},second:{displayName:"секунда",relative:{0:"сейчас"},relativeTime:{future:{one:"через {0} секунду",few:"через {0} секунды",many:"через {0} секунд",other:"через {0} секунды"},past:{one:"{0} секунду назад",few:"{0} секунды назад",many:"{0} секунд назад",other:"{0} секунды назад"}}},"second-short":{displayName:"сек.",relative:{0:"сейчас"},relativeTime:{future:{one:"через {0} сек.",few:"через {0} сек.",many:"через {0} сек.",other:"через {0} сек."},past:{one:"{0} сек. назад",few:"{0} сек. назад",many:"{0} сек. назад",other:"{0} сек. назад"}}}}},{locale:"ru-BY",parentLocale:"ru"},{locale:"ru-KG",parentLocale:"ru"},{locale:"ru-KZ",parentLocale:"ru"},{locale:"ru-MD",parentLocale:"ru"},{locale:"ru-UA",parentLocale:"ru"}]});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.th=t())}(this,function(){"use strict";return[{locale:"th",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},"year-short":{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ใน {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},month:{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} เดือน"},past:{other:"{0} เดือนที่ผ่านมา"}}},"month-short":{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ใน {0} เดือน"},past:{other:"{0} เดือนที่แล้ว"}}},day:{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ในอีก {0} วัน"},past:{other:"{0} วันที่ผ่านมา"}}},"day-short":{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ใน {0} วัน"},past:{other:"{0} วันที่แล้ว"}}},hour:{displayName:"ชั่วโมง",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ในอีก {0} ชั่วโมง"},past:{other:"{0} ชั่วโมงที่ผ่านมา"}}},"hour-short":{displayName:"ชม.",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ใน {0} ชม."},past:{other:"{0} ชม. ที่แล้ว"}}},minute:{displayName:"นาที",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ในอีก {0} นาที"},past:{other:"{0} นาทีที่ผ่านมา"}}},"minute-short":{displayName:"น.",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ใน {0} นาที"},past:{other:"{0} นาทีที่แล้ว"}}},second:{displayName:"วินาที",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ในอีก {0} วินาที"},past:{other:"{0} วินาทีที่ผ่านมา"}}},"second-short":{displayName:"วิ",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ใน {0} วินาที"},past:{other:"{0} วินาทีที่แล้ว"}}}}}]});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.vi=t())}(this,function(){"use strict";return[{locale:"vi",pluralRuleFunction:function(e,t){return t&&1==e?"one":"other"},fields:{year:{displayName:"Năm",relative:{0:"năm nay",1:"năm sau","-1":"năm ngoái"},relativeTime:{future:{other:"sau {0} năm nữa"},past:{other:"{0} năm trước"}}},"year-short":{displayName:"Năm",relative:{0:"năm nay",1:"năm sau","-1":"năm ngoái"},relativeTime:{future:{other:"sau {0} năm nữa"},past:{other:"{0} năm trước"}}},month:{displayName:"Tháng",relative:{0:"tháng này",1:"tháng sau","-1":"tháng trước"},relativeTime:{future:{other:"sau {0} tháng nữa"},past:{other:"{0} tháng trước"}}},"month-short":{displayName:"Tháng",relative:{0:"tháng này",1:"tháng sau","-1":"tháng trước"},relativeTime:{future:{other:"sau {0} tháng nữa"},past:{other:"{0} tháng trước"}}},day:{displayName:"Ngày",relative:{0:"Hôm nay",1:"Ngày mai",2:"Ngày kia","-2":"Hôm kia","-1":"Hôm qua"},relativeTime:{future:{other:"sau {0} ngày nữa"},past:{other:"{0} ngày trước"}}},"day-short":{displayName:"Ngày",relative:{0:"Hôm nay",1:"Ngày mai",2:"Ngày kia","-2":"Hôm kia","-1":"Hôm qua"},relativeTime:{future:{other:"sau {0} ngày nữa"},past:{other:"{0} ngày trước"}}},hour:{displayName:"Giờ",relative:{0:"giờ này"},relativeTime:{future:{other:"sau {0} giờ nữa"},past:{other:"{0} giờ trước"}}},"hour-short":{displayName:"Giờ",relative:{0:"giờ này"},relativeTime:{future:{other:"sau {0} giờ nữa"},past:{other:"{0} giờ trước"}}},minute:{displayName:"Phút",relative:{0:"phút này"},relativeTime:{future:{other:"sau {0} phút nữa"},past:{other:"{0} phút trước"}}},"minute-short":{displayName:"Phút",relative:{0:"phút này"},relativeTime:{future:{other:"sau {0} phút nữa"},past:{other:"{0} phút trước"}}},second:{displayName:"Giây",relative:{0:"bây giờ"},relativeTime:{future:{other:"sau {0} giây nữa"},past:{other:"{0} giây trước"}}},"second-short":{displayName:"Giây",relative:{0:"bây giờ"},relativeTime:{future:{other:"sau {0} giây nữa"},past:{other:"{0} giây trước"}}}}}]});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classnames2 = __webpack_require__(52);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _rmcNotification = __webpack_require__(807);

var _rmcNotification2 = _interopRequireDefault(_rmcNotification);

var _icon = __webpack_require__(369);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SHORT = 3;
var _config = {
    duration: SHORT,
    mask: true
};
var messageInstance = void 0;
var messageNeedHide = void 0;
var prefixCls = 'am-toast';
function getMessageInstance(mask, callback) {
    var _classnames;

    _rmcNotification2['default'].newInstance({
        prefixCls: prefixCls,
        style: {},
        transitionName: 'am-fade',
        className: (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-mask', mask), (0, _defineProperty3['default'])(_classnames, prefixCls + '-nomask', !mask), _classnames))
    }, function (notification) {
        return callback && callback(notification);
    });
}
function notice(content, type) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config.duration;
    var _onClose = arguments[3];
    var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _config.mask;

    var iconTypes = {
        info: '',
        success: 'success',
        fail: 'fail',
        offline: 'dislike',
        loading: 'loading'
    };
    var iconType = iconTypes[type];
    messageNeedHide = false;
    getMessageInstance(mask, function (notification) {
        if (!notification) {
            return;
        }
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        }
        if (messageNeedHide) {
            notification.destroy();
            messageNeedHide = false;
            return;
        }
        messageInstance = notification;
        notification.notice({
            duration: duration,
            style: {},
            content: !!iconType ? React.createElement(
                'div',
                { className: prefixCls + '-text ' + prefixCls + '-text-icon', role: 'alert', 'aria-live': 'assertive' },
                React.createElement(_icon2['default'], { type: iconType, size: 'lg' }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-text-info' },
                    content
                )
            ) : React.createElement(
                'div',
                { className: prefixCls + '-text', role: 'alert', 'aria-live': 'assertive' },
                React.createElement(
                    'div',
                    null,
                    content
                )
            ),
            closable: true,
            onClose: function onClose() {
                if (_onClose) {
                    _onClose();
                }
                notification.destroy();
                notification = null;
                messageInstance = null;
            }
        });
    });
}
exports['default'] = {
    SHORT: SHORT,
    LONG: 8,
    show: function show(content, duration, mask) {
        return notice(content, 'info', duration, function () {}, mask);
    },
    info: function info(content, duration, onClose, mask) {
        return notice(content, 'info', duration, onClose, mask);
    },
    success: function success(content, duration, onClose, mask) {
        return notice(content, 'success', duration, onClose, mask);
    },
    fail: function fail(content, duration, onClose, mask) {
        return notice(content, 'fail', duration, onClose, mask);
    },
    offline: function offline(content, duration, onClose, mask) {
        return notice(content, 'offline', duration, onClose, mask);
    },
    loading: function loading(content, duration, onClose, mask) {
        return notice(content, 'loading', duration, onClose, mask);
    },
    hide: function hide() {
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        } else {
            messageNeedHide = true;
        }
    },
    config: function config() {
        var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _conf$duration = conf.duration,
            duration = _conf$duration === undefined ? SHORT : _conf$duration,
            mask = conf.mask;

        _config.duration = duration;
        if (mask === false) {
            _config.mask = false;
        }
    }
};
module.exports = exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(225);

__webpack_require__(370);

__webpack_require__(638);

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(377);

var _alert2 = _interopRequireDefault(_alert);

var _Modal = __webpack_require__(117);

var _Modal2 = _interopRequireDefault(_Modal);

var _operation = __webpack_require__(378);

var _operation2 = _interopRequireDefault(_operation);

var _prompt = __webpack_require__(379);

var _prompt2 = _interopRequireDefault(_prompt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Modal2['default'].alert = _alert2['default'];
_Modal2['default'].prompt = _prompt2['default'];
_Modal2['default'].operation = _operation2['default'];
exports['default'] = _Modal2['default'];
module.exports = exports['default'];

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(225);

__webpack_require__(636);

/***/ }),
/* 366 */
/***/ (function(module, exports) {

!(function(e, n) {
  module.exports = n(e);
})(window, function(o, e) {
  if (!o.jWeixin) {
    var n,
      c = {
        config: "preVerifyJSAPI",
        onMenuShareTimeline: "menu:share:timeline",
        onMenuShareAppMessage: "menu:share:appmessage",
        onMenuShareQQ: "menu:share:qq",
        onMenuShareWeibo: "menu:share:weiboApp",
        onMenuShareQZone: "menu:share:QZone",
        previewImage: "imagePreview",
        getLocation: "geoLocation",
        openProductSpecificView: "openProductViewWithPid",
        addCard: "batchAddCard",
        openCard: "batchViewCard",
        chooseWXPay: "getBrandWCPayRequest",
        openEnterpriseRedPacket: "getRecevieBizHongBaoRequest",
        startSearchBeacons: "startMonitoringBeacons",
        stopSearchBeacons: "stopMonitoringBeacons",
        onSearchBeacons: "onBeaconsInRange",
        consumeAndShareCard: "consumedShareCard",
        openAddress: "editAddress"
      },
      a = (function() {
        var e = {};
        for (var n in c) e[c[n]] = n;
        return e;
      })(),
      i = o.document,
      t = i.title,
      r = navigator.userAgent.toLowerCase(),
      s = navigator.platform.toLowerCase(),
      d = !(!s.match("mac") && !s.match("win")),
      u = -1 != r.indexOf("wxdebugger"),
      l = -1 != r.indexOf("micromessenger"),
      p = -1 != r.indexOf("android"),
      f = -1 != r.indexOf("iphone") || -1 != r.indexOf("ipad"),
      m = (n =
        r.match(/micromessenger\/(\d+\.\d+\.\d+)/) ||
        r.match(/micromessenger\/(\d+\.\d+)/))
        ? n[1]
        : "",
      g = {
        initStartTime: L(),
        initEndTime: 0,
        preVerifyStartTime: 0,
        preVerifyEndTime: 0
      },
      h = {
        version: 1,
        appId: "",
        initTime: 0,
        preVerifyTime: 0,
        networkType: "",
        isPreVerifyOk: 1,
        systemType: f ? 1 : p ? 2 : -1,
        clientVersion: m,
        url: encodeURIComponent(location.href)
      },
      v = {},
      S = { _completes: [] },
      y = { state: 0, data: {} };
    O(function() {
      g.initEndTime = L();
    });
    var I = !1,
      _ = [],
      w = {
        config: function(e) {
          B("config", (v = e));
          var t = !1 !== v.check;
          O(function() {
            if (t)
              M(
                c.config,
                {
                  verifyJsApiList: C(v.jsApiList),
                  verifyOpenTagList: C(v.openTagList)
                },
                (function() {
                  (S._complete = function(e) {
                    (g.preVerifyEndTime = L()), (y.state = 1), (y.data = e);
                  }),
                    (S.success = function(e) {
                      h.isPreVerifyOk = 0;
                    }),
                    (S.fail = function(e) {
                      S._fail ? S._fail(e) : (y.state = -1);
                    });
                  var t = S._completes;
                  return (
                    t.push(function() {
                      !(function() {
                        if (
                          !(
                            d ||
                            u ||
                            v.debug ||
                            m < "6.0.2" ||
                            h.systemType < 0
                          )
                        ) {
                          var i = new Image();
                          (h.appId = v.appId),
                            (h.initTime = g.initEndTime - g.initStartTime),
                            (h.preVerifyTime =
                              g.preVerifyEndTime - g.preVerifyStartTime),
                            w.getNetworkType({
                              isInnerInvoke: !0,
                              success: function(e) {
                                h.networkType = e.networkType;
                                var n =
                                  "https://open.weixin.qq.com/sdk/report?v=" +
                                  h.version +
                                  "&o=" +
                                  h.isPreVerifyOk +
                                  "&s=" +
                                  h.systemType +
                                  "&c=" +
                                  h.clientVersion +
                                  "&a=" +
                                  h.appId +
                                  "&n=" +
                                  h.networkType +
                                  "&i=" +
                                  h.initTime +
                                  "&p=" +
                                  h.preVerifyTime +
                                  "&u=" +
                                  h.url;
                                i.src = n;
                              }
                            });
                        }
                      })();
                    }),
                    (S.complete = function(e) {
                      for (var n = 0, i = t.length; n < i; ++n) t[n]();
                      S._completes = [];
                    }),
                    S
                  );
                })()
              ),
                (g.preVerifyStartTime = L());
            else {
              y.state = 1;
              for (var e = S._completes, n = 0, i = e.length; n < i; ++n)
                e[n]();
              S._completes = [];
            }
          }),
            w.invoke ||
              ((w.invoke = function(e, n, i) {
                o.WeixinJSBridge && WeixinJSBridge.invoke(e, x(n), i);
              }),
              (w.on = function(e, n) {
                o.WeixinJSBridge && WeixinJSBridge.on(e, n);
              }));
        },
        ready: function(e) {
          0 != y.state ? e() : (S._completes.push(e), !l && v.debug && e());
        },
        error: function(e) {
          m < "6.0.2" || (-1 == y.state ? e(y.data) : (S._fail = e));
        },
        checkJsApi: function(e) {
          M(
            "checkJsApi",
            { jsApiList: C(e.jsApiList) },
            ((e._complete = function(e) {
              if (p) {
                var n = e.checkResult;
                n && (e.checkResult = JSON.parse(n));
              }
              e = (function(e) {
                var n = e.checkResult;
                for (var i in n) {
                  var t = a[i];
                  t && ((n[t] = n[i]), delete n[i]);
                }
                return e;
              })(e);
            }),
            e)
          );
        },
        onMenuShareTimeline: function(e) {
          P(
            c.onMenuShareTimeline,
            {
              complete: function() {
                M(
                  "shareTimeline",
                  {
                    title: e.title || t,
                    desc: e.title || t,
                    img_url: e.imgUrl || "",
                    link: e.link || location.href,
                    type: e.type || "link",
                    data_url: e.dataUrl || ""
                  },
                  e
                );
              }
            },
            e
          );
        },
        onMenuShareAppMessage: function(n) {
          P(
            c.onMenuShareAppMessage,
            {
              complete: function(e) {
                "favorite" === e.scene
                  ? M("sendAppMessage", {
                      title: n.title || t,
                      desc: n.desc || "",
                      link: n.link || location.href,
                      img_url: n.imgUrl || "",
                      type: n.type || "link",
                      data_url: n.dataUrl || ""
                    })
                  : M(
                      "sendAppMessage",
                      {
                        title: n.title || t,
                        desc: n.desc || "",
                        link: n.link || location.href,
                        img_url: n.imgUrl || "",
                        type: n.type || "link",
                        data_url: n.dataUrl || ""
                      },
                      n
                    );
              }
            },
            n
          );
        },
        onMenuShareQQ: function(e) {
          P(
            c.onMenuShareQQ,
            {
              complete: function() {
                M(
                  "shareQQ",
                  {
                    title: e.title || t,
                    desc: e.desc || "",
                    img_url: e.imgUrl || "",
                    link: e.link || location.href
                  },
                  e
                );
              }
            },
            e
          );
        },
        onMenuShareWeibo: function(e) {
          P(
            c.onMenuShareWeibo,
            {
              complete: function() {
                M(
                  "shareWeiboApp",
                  {
                    title: e.title || t,
                    desc: e.desc || "",
                    img_url: e.imgUrl || "",
                    link: e.link || location.href
                  },
                  e
                );
              }
            },
            e
          );
        },
        onMenuShareQZone: function(e) {
          P(
            c.onMenuShareQZone,
            {
              complete: function() {
                M(
                  "shareQZone",
                  {
                    title: e.title || t,
                    desc: e.desc || "",
                    img_url: e.imgUrl || "",
                    link: e.link || location.href
                  },
                  e
                );
              }
            },
            e
          );
        },
        updateTimelineShareData: function(e) {
          M(
            "updateTimelineShareData",
            { title: e.title, link: e.link, imgUrl: e.imgUrl },
            e
          );
        },
        updateAppMessageShareData: function(e) {
          M(
            "updateAppMessageShareData",
            { title: e.title, desc: e.desc, link: e.link, imgUrl: e.imgUrl },
            e
          );
        },
        startRecord: function(e) {
          M("startRecord", {}, e);
        },
        stopRecord: function(e) {
          M("stopRecord", {}, e);
        },
        onVoiceRecordEnd: function(e) {
          P("onVoiceRecordEnd", e);
        },
        playVoice: function(e) {
          M("playVoice", { localId: e.localId }, e);
        },
        pauseVoice: function(e) {
          M("pauseVoice", { localId: e.localId }, e);
        },
        stopVoice: function(e) {
          M("stopVoice", { localId: e.localId }, e);
        },
        onVoicePlayEnd: function(e) {
          P("onVoicePlayEnd", e);
        },
        uploadVoice: function(e) {
          M(
            "uploadVoice",
            {
              localId: e.localId,
              isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            },
            e
          );
        },
        downloadVoice: function(e) {
          M(
            "downloadVoice",
            {
              serverId: e.serverId,
              isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            },
            e
          );
        },
        translateVoice: function(e) {
          M(
            "translateVoice",
            {
              localId: e.localId,
              isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            },
            e
          );
        },
        chooseImage: function(e) {
          M(
            "chooseImage",
            {
              scene: "1|2",
              count: e.count || 9,
              sizeType: e.sizeType || ["original", "compressed"],
              sourceType: e.sourceType || ["album", "camera"]
            },
            ((e._complete = function(e) {
              if (p) {
                var n = e.localIds;
                try {
                  n && (e.localIds = JSON.parse(n));
                } catch (e) {}
              }
            }),
            e)
          );
        },
        getLocation: function(e) {},
        previewImage: function(e) {
          M(c.previewImage, { current: e.current, urls: e.urls }, e);
        },
        uploadImage: function(e) {
          M(
            "uploadImage",
            {
              localId: e.localId,
              isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            },
            e
          );
        },
        downloadImage: function(e) {
          M(
            "downloadImage",
            {
              serverId: e.serverId,
              isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            },
            e
          );
        },
        getLocalImgData: function(e) {
          !1 === I
            ? ((I = !0),
              M(
                "getLocalImgData",
                { localId: e.localId },
                ((e._complete = function(e) {
                  if (((I = !1), 0 < _.length)) {
                    var n = _.shift();
                    wx.getLocalImgData(n);
                  }
                }),
                e)
              ))
            : _.push(e);
        },
        getNetworkType: function(e) {
          M(
            "getNetworkType",
            {},
            ((e._complete = function(e) {
              e = (function(e) {
                var n = e.errMsg;
                e.errMsg = "getNetworkType:ok";
                var i = e.subtype;
                if ((delete e.subtype, i)) e.networkType = i;
                else {
                  var t = n.indexOf(":"),
                    o = n.substring(t + 1);
                  switch (o) {
                    case "wifi":
                    case "edge":
                    case "wwan":
                      e.networkType = o;
                      break;
                    default:
                      e.errMsg = "getNetworkType:fail";
                  }
                }
                return e;
              })(e);
            }),
            e)
          );
        },
        openLocation: function(e) {
          M(
            "openLocation",
            {
              latitude: e.latitude,
              longitude: e.longitude,
              name: e.name || "",
              address: e.address || "",
              scale: e.scale || 28,
              infoUrl: e.infoUrl || ""
            },
            e
          );
        },
        getLocation: function(e) {
          M(
            c.getLocation,
            { type: (e = e || {}).type || "wgs84" },
            ((e._complete = function(e) {
              delete e.type;
            }),
            e)
          );
        },
        hideOptionMenu: function(e) {
          M("hideOptionMenu", {}, e);
        },
        showOptionMenu: function(e) {
          M("showOptionMenu", {}, e);
        },
        closeWindow: function(e) {
          M("closeWindow", {}, (e = e || {}));
        },
        hideMenuItems: function(e) {
          M("hideMenuItems", { menuList: e.menuList }, e);
        },
        showMenuItems: function(e) {
          M("showMenuItems", { menuList: e.menuList }, e);
        },
        hideAllNonBaseMenuItem: function(e) {
          M("hideAllNonBaseMenuItem", {}, e);
        },
        showAllNonBaseMenuItem: function(e) {
          M("showAllNonBaseMenuItem", {}, e);
        },
        scanQRCode: function(e) {
          M(
            "scanQRCode",
            {
              needResult: (e = e || {}).needResult || 0,
              scanType: e.scanType || ["qrCode", "barCode"]
            },
            ((e._complete = function(e) {
              if (f) {
                var n = e.resultStr;
                if (n) {
                  var i = JSON.parse(n);
                  e.resultStr = i && i.scan_code && i.scan_code.scan_result;
                }
              }
            }),
            e)
          );
        },
        openAddress: function(e) {
          M(
            c.openAddress,
            {},
            ((e._complete = function(e) {
              e = (function(e) {
                return (
                  (e.postalCode = e.addressPostalCode),
                  delete e.addressPostalCode,
                  (e.provinceName = e.proviceFirstStageName),
                  delete e.proviceFirstStageName,
                  (e.cityName = e.addressCitySecondStageName),
                  delete e.addressCitySecondStageName,
                  (e.countryName = e.addressCountiesThirdStageName),
                  delete e.addressCountiesThirdStageName,
                  (e.detailInfo = e.addressDetailInfo),
                  delete e.addressDetailInfo,
                  e
                );
              })(e);
            }),
            e)
          );
        },
        openProductSpecificView: function(e) {
          M(
            c.openProductSpecificView,
            {
              pid: e.productId,
              view_type: e.viewType || 0,
              ext_info: e.extInfo
            },
            e
          );
        },
        addCard: function(e) {
          for (var n = e.cardList, i = [], t = 0, o = n.length; t < o; ++t) {
            var r = n[t],
              a = { card_id: r.cardId, card_ext: r.cardExt };
            i.push(a);
          }
          M(
            c.addCard,
            { card_list: i },
            ((e._complete = function(e) {
              var n = e.card_list;
              if (n) {
                for (var i = 0, t = (n = JSON.parse(n)).length; i < t; ++i) {
                  var o = n[i];
                  (o.cardId = o.card_id),
                    (o.cardExt = o.card_ext),
                    (o.isSuccess = !!o.is_succ),
                    delete o.card_id,
                    delete o.card_ext,
                    delete o.is_succ;
                }
                (e.cardList = n), delete e.card_list;
              }
            }),
            e)
          );
        },
        chooseCard: function(e) {
          M(
            "chooseCard",
            {
              app_id: v.appId,
              location_id: e.shopId || "",
              sign_type: e.signType || "SHA1",
              card_id: e.cardId || "",
              card_type: e.cardType || "",
              card_sign: e.cardSign,
              time_stamp: e.timestamp + "",
              nonce_str: e.nonceStr
            },
            ((e._complete = function(e) {
              (e.cardList = e.choose_card_info), delete e.choose_card_info;
            }),
            e)
          );
        },
        openCard: function(e) {
          for (var n = e.cardList, i = [], t = 0, o = n.length; t < o; ++t) {
            var r = n[t],
              a = { card_id: r.cardId, code: r.code };
            i.push(a);
          }
          M(c.openCard, { card_list: i }, e);
        },
        consumeAndShareCard: function(e) {
          M(
            c.consumeAndShareCard,
            { consumedCardId: e.cardId, consumedCode: e.code },
            e
          );
        },
        chooseWXPay: function(e) {
          M(c.chooseWXPay, V(e), e);
        },
        openEnterpriseRedPacket: function(e) {
          M(c.openEnterpriseRedPacket, V(e), e);
        },
        startSearchBeacons: function(e) {
          M(c.startSearchBeacons, { ticket: e.ticket }, e);
        },
        stopSearchBeacons: function(e) {
          M(c.stopSearchBeacons, {}, e);
        },
        onSearchBeacons: function(e) {
          P(c.onSearchBeacons, e);
        },
        openEnterpriseChat: function(e) {
          M(
            "openEnterpriseChat",
            { useridlist: e.userIds, chatname: e.groupName },
            e
          );
        },
        launchMiniProgram: function(e) {
          M(
            "launchMiniProgram",
            {
              targetAppId: e.targetAppId,
              path: (function(e) {
                if ("string" == typeof e && 0 < e.length) {
                  var n = e.split("?")[0],
                    i = e.split("?")[1];
                  return (n += ".html"), void 0 !== i ? n + "?" + i : n;
                }
              })(e.path),
              envVersion: e.envVersion
            },
            e
          );
        },
        openBusinessView: function(e) {
          M(
            "openBusinessView",
            {
              businessType: e.businessType,
              queryString: e.queryString || "",
              envVersion: e.envVersion
            },
            ((e._complete = function(n) {
              if (p) {
                var e = n.extraData;
                if (e)
                  try {
                    n.extraData = JSON.parse(e);
                  } catch (e) {
                    n.extraData = {};
                  }
              }
            }),
            e)
          );
        },
        miniProgram: {
          navigateBack: function(e) {
            (e = e || {}),
              O(function() {
                M(
                  "invokeMiniProgramAPI",
                  { name: "navigateBack", arg: { delta: e.delta || 1 } },
                  e
                );
              });
          },
          navigateTo: function(e) {
            O(function() {
              M(
                "invokeMiniProgramAPI",
                { name: "navigateTo", arg: { url: e.url } },
                e
              );
            });
          },
          redirectTo: function(e) {
            O(function() {
              M(
                "invokeMiniProgramAPI",
                { name: "redirectTo", arg: { url: e.url } },
                e
              );
            });
          },
          switchTab: function(e) {
            O(function() {
              M(
                "invokeMiniProgramAPI",
                { name: "switchTab", arg: { url: e.url } },
                e
              );
            });
          },
          reLaunch: function(e) {
            O(function() {
              M(
                "invokeMiniProgramAPI",
                { name: "reLaunch", arg: { url: e.url } },
                e
              );
            });
          },
          postMessage: function(e) {
            O(function() {
              M(
                "invokeMiniProgramAPI",
                { name: "postMessage", arg: e.data || {} },
                e
              );
            });
          },
          getEnv: function(e) {
            O(function() {
              e({ miniprogram: "miniprogram" === o.__wxjs_environment });
            });
          }
        }
      },
      T = 1,
      k = {};
    return (
      i.addEventListener(
        "error",
        function(e) {
          if (!p) {
            var n = e.target,
              i = n.tagName,
              t = n.src;
            if ("IMG" == i || "VIDEO" == i || "AUDIO" == i || "SOURCE" == i)
              if (-1 != t.indexOf("wxlocalresource://")) {
                e.preventDefault(), e.stopPropagation();
                var o = n["wx-id"];
                if ((o || ((o = T++), (n["wx-id"] = o)), k[o])) return;
                (k[o] = !0),
                  wx.ready(function() {
                    wx.getLocalImgData({
                      localId: t,
                      success: function(e) {
                        n.src = e.localData;
                      }
                    });
                  });
              }
          }
        },
        !0
      ),
      i.addEventListener(
        "load",
        function(e) {
          if (!p) {
            var n = e.target,
              i = n.tagName;
            n.src;
            if ("IMG" == i || "VIDEO" == i || "AUDIO" == i || "SOURCE" == i) {
              var t = n["wx-id"];
              t && (k[t] = !1);
            }
          }
        },
        !0
      ),
      e && (o.wx = o.jWeixin = w),
      w
    );
  }
  function M(n, e, i) {
    o.WeixinJSBridge
      ? WeixinJSBridge.invoke(n, x(e), function(e) {
          A(n, e, i);
        })
      : B(n, i);
  }
  function P(n, i, t) {
    o.WeixinJSBridge
      ? WeixinJSBridge.on(n, function(e) {
          t && t.trigger && t.trigger(e), A(n, e, i);
        })
      : B(n, t || i);
  }
  function x(e) {
    return (
      ((e = e || {}).appId = v.appId),
      (e.verifyAppId = v.appId),
      (e.verifySignType = "sha1"),
      (e.verifyTimestamp = v.timestamp + ""),
      (e.verifyNonceStr = v.nonceStr),
      (e.verifySignature = v.signature),
      e
    );
  }
  function V(e) {
    return {
      timeStamp: e.timestamp + "",
      nonceStr: e.nonceStr,
      package: e.package,
      paySign: e.paySign,
      signType: e.signType || "SHA1"
    };
  }
  function A(e, n, i) {
    ("openEnterpriseChat" != e && "openBusinessView" !== e) ||
      (n.errCode = n.err_code),
      delete n.err_code,
      delete n.err_desc,
      delete n.err_detail;
    var t = n.errMsg;
    t ||
      ((t = n.err_msg),
      delete n.err_msg,
      (t = (function(e, n) {
        var i = e,
          t = a[i];
        t && (i = t);
        var o = "ok";
        if (n) {
          var r = n.indexOf(":");
          "confirm" == (o = n.substring(r + 1)) && (o = "ok"),
            "failed" == o && (o = "fail"),
            -1 != o.indexOf("failed_") && (o = o.substring(7)),
            -1 != o.indexOf("fail_") && (o = o.substring(5)),
            ("access denied" !=
              (o = (o = o.replace(/_/g, " ")).toLowerCase()) &&
              "no permission to execute" != o) ||
              (o = "permission denied"),
            "config" == i && "function not exist" == o && (o = "ok"),
            "" == o && (o = "fail");
        }
        return (n = i + ":" + o);
      })(e, t)),
      (n.errMsg = t)),
      (i = i || {})._complete && (i._complete(n), delete i._complete),
      (t = n.errMsg || ""),
      v.debug && !i.isInnerInvoke && alert(JSON.stringify(n));
    var o = t.indexOf(":");
    switch (t.substring(o + 1)) {
      case "ok":
        i.success && i.success(n);
        break;
      case "cancel":
        i.cancel && i.cancel(n);
        break;
      default:
        i.fail && i.fail(n);
    }
    i.complete && i.complete(n);
  }
  function C(e) {
    if (e) {
      for (var n = 0, i = e.length; n < i; ++n) {
        var t = e[n],
          o = c[t];
        o && (e[n] = o);
      }
      return e;
    }
  }
  function B(e, n) {
    if (!(!v.debug || (n && n.isInnerInvoke))) {
      var i = a[e];
      i && (e = i),
        n && n._complete && delete n._complete,
        console.log('"' + e + '",', n || "");
    }
  }
  function L() {
    return new Date().getTime();
  }
  function O(e) {
    l &&
      (o.WeixinJSBridge
        ? e()
        : i.addEventListener &&
          i.addEventListener("WeixinJSBridgeReady", e, !1));
  }
});


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__ = __webpack_require__(804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__["a"]; });


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/my_account_authentication_icon_authentication_ok.png";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(53);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(35);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(36);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(38);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(37);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(52);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _loadSprite = __webpack_require__(376);

var _loadSprite2 = _interopRequireDefault(_loadSprite);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Icon = function (_React$Component) {
    (0, _inherits3['default'])(Icon, _React$Component);

    function Icon() {
        (0, _classCallCheck3['default'])(this, Icon);
        return (0, _possibleConstructorReturn3['default'])(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Icon, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _loadSprite2['default'])();
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                type = _a.type,
                className = _a.className,
                size = _a.size,
                restProps = __rest(_a, ["type", "className", "size"]);
            var cls = (0, _classnames2['default'])(className, 'am-icon', 'am-icon-' + type, 'am-icon-' + size);
            return React.createElement(
                'svg',
                (0, _extends3['default'])({ className: cls }, restProps),
                React.createElement('use', { xlinkHref: '#' + type })
            );
        }
    }]);
    return Icon;
}(React.Component);

exports['default'] = Icon;

Icon.defaultProps = {
    size: 'md'
};
module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(635);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dialog__ = __webpack_require__(802);








function noop() {}
var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.createPortal;
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var DialogWrap = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DialogWrap, _React$Component);

    function DialogWrap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DialogWrap);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DialogWrap.__proto__ || Object.getPrototypeOf(DialogWrap)).apply(this, arguments));

        _this.saveRef = function (node) {
            if (IS_REACT_16) {
                _this._component = node;
            }
        };
        _this.getComponent = function (visible) {
            var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props);
            ['visible', 'onAnimateLeave'].forEach(function (key) {
                if (props.hasOwnProperty(key)) {
                    delete props[key];
                }
            });
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { visible: visible, onAnimateLeave: _this.removeContainer, ref: _this.saveRef }));
        };
        _this.removeContainer = function () {
            if (_this.container) {
                if (!IS_REACT_16) {
                    __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.unmountComponentAtNode(_this.container);
                }
                _this.container.parentNode.removeChild(_this.container);
                _this.container = null;
            }
        };
        _this.getContainer = function () {
            if (!_this.container) {
                var container = document.createElement('div');
                var containerId = _this.props.prefixCls + '-container-' + new Date().getTime();
                container.setAttribute('id', containerId);
                document.body.appendChild(container);
                _this.container = container;
            }
            return _this.container;
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DialogWrap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.visible) {
                this.componentDidUpdate();
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref) {
            var visible = _ref.visible;

            return !!(this.props.visible || visible);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.visible) {
                if (!IS_REACT_16) {
                    this.renderDialog(false);
                } else {
                    // TODO for react@16 createPortal animation
                    this.removeContainer();
                }
            } else {
                this.removeContainer();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!IS_REACT_16) {
                this.renderDialog(this.props.visible);
            }
        }
    }, {
        key: 'renderDialog',
        value: function renderDialog(visible) {
            __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.getComponent(visible), this.getContainer());
        }
    }, {
        key: 'render',
        value: function render() {
            if (!CAN_USE_DOM) {
                return null;
            }
            var visible = this.props.visible;

            if (IS_REACT_16 && (visible || this._component)) {
                return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.createPortal(this.getComponent(visible), this.getContainer());
            }
            return null;
        }
    }]);

    return DialogWrap;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (DialogWrap);

DialogWrap.defaultProps = {
    visible: false,
    prefixCls: 'rmc-dialog',
    onClose: noop
};

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["b"] = (cssAnimation);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* tslint:disable:max-line-length */
// inspried by https://github.com/kisenka/svg-sprite-loader/blob/master/runtime/browser-sprite.js
// Much simplified, do make sure run this after document ready
var svgSprite = function svgSprite(contents) {
    return '\n  <svg\n    xmlns="http://www.w3.org/2000/svg"\n    xmlns:xlink="http://www.w3.org/1999/xlink"\n    id="__ANTD_MOBILE_SVG_SPRITE_NODE__"\n    style="display:none;overflow:hidden;width:0;height:0"\n  >\n    <defs>\n      ' + contents + '\n    </defs>\n  </svg>\n';
};
// both minified by https://github.com/svg/svgo
var icons = {
    check: '<svg viewBox="0 0 44 44"><path fill-rule="evenodd" d="M34.538 8L38 11.518 17.808 32 8 22.033l3.462-3.518 6.346 6.45z"/></svg>',
    'check-circle': '<svg viewBox="0 0 48 48"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zM13.1 23.2l-2.2 2.1 10 9.9L38.1 15l-2.2-2-15.2 17.8-7.6-7.6z" fill-rule="evenodd"/></svg>',
    'check-circle-o': '<svg viewBox="0 0 48 48"><g fill-rule="evenodd"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z"/><path d="M12.2 23.2L10 25.3l10 9.9L37.2 15 35 13 19.8 30.8z"/></g></svg>',
    cross: '<svg viewBox="0 0 44 44"><path fill-rule="evenodd" d="M24.008 21.852l8.97-8.968L31.092 11l-8.97 8.968L13.157 11l-1.884 1.884 8.968 8.968-9.24 9.24 1.884 1.885 9.24-9.24 9.24 9.24 1.885-1.884-9.24-9.24z"/></svg>',
    'cross-circle': '<svg viewBox="0 0 48 48"><g fill-rule="evenodd"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z"/><path d="M24.34 22.22l-7.775-7.775a1.5 1.5 0 1 0-2.12 2.12l7.773 7.775-7.774 7.775a1.5 1.5 0 1 0 2.12 2.12l7.775-7.773 7.774 7.774a1.5 1.5 0 1 0 2.12-2.12L26.46 24.34l7.774-7.774a1.5 1.5 0 1 0-2.12-2.12l-7.776 7.773z"/></g></svg>',
    'cross-circle-o': '<svg viewBox="0 0 48 48"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.353-25.77l-7.593-7.593c-.797-.8-1.538-.822-2.263-.207-.724.614-.56 1.617-.124 2.067l7.852 7.847-7.72 7.723c-.727.728-.56 1.646-.066 2.177.493.532 1.553.683 2.31-.174l7.588-7.584 7.644 7.623c.796.798 1.608.724 2.21.145.605-.58.72-1.442-.074-2.24l-7.657-7.67 7.545-7.52c.81-.697.9-1.76.297-2.34-.92-.885-1.85-.338-2.264.078l-7.685 7.667z" fill-rule="evenodd"/></svg>',
    // Todo: simplify direction to 2, use css transform
    left: '<svg viewBox="0 0 44 44"><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M16.247 21.4L28.48 9.165l2.12 2.12-10.117 10.12L30.6 31.524l-2.12 2.12-12.233-12.232.007-.006z"/></svg>',
    right: '<svg viewBox="0 0 44 44"><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M30.6 21.4L18.37 9.165l-2.12 2.12 10.117 10.12-10.118 10.118 2.12 2.12 12.234-12.232-.005-.006z"/></svg>',
    down: '<svg viewBox="0 0 44 44"><path d="M22.355 28.237l-11.483-10.9c-.607-.576-1.714-.396-2.48.41l.674-.71c-.763.802-.73 2.07-.282 2.496l11.37 10.793-.04.04 2.088 2.195L23.3 31.52l12.308-11.682c.447-.425.48-1.694-.282-2.496l.674.71c-.766-.806-1.873-.986-2.48-.41L22.355 28.237z" fill-rule="evenodd"/></svg>',
    up: '<svg viewBox="0 0 44 44"><path fill="none" d="M-1-1h46v46H-1z"/><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M23.417 14.23L11.184 26.46l2.12 2.12 10.12-10.117 10.118 10.118 2.12-2.12L23.43 14.228l-.006.005z"/></svg>',
    loading: '<svg viewBox="0 -2 59.75 60.25"><path fill="#ccc" d="M29.69-.527C14.044-.527 1.36 12.158 1.36 27.806S14.043 56.14 29.69 56.14c15.65 0 28.334-12.686 28.334-28.334S45.34-.527 29.69-.527zm.185 53.75c-14.037 0-25.417-11.38-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.38 25.417 25.417-11.38 25.416-25.417 25.416z"/><path fill="none" stroke="#108ee9" stroke-width="3" stroke-linecap="round" stroke-miterlimit="10" d="M56.587 29.766c.37-7.438-1.658-14.7-6.393-19.552"/></svg>',
    search: '<svg viewBox="0 0 44 44"><path d="M32.98 29.255l8.915 8.293L39.603 40l-8.86-8.242a15.952 15.952 0 0 1-10.753 4.147C11.16 35.905 4 28.763 4 19.952 4 11.142 11.16 4 19.99 4s15.99 7.142 15.99 15.952c0 3.472-1.112 6.685-3 9.303zm.05-9.21c0 7.123-5.7 12.918-12.88 12.918-7.176 0-13.015-5.795-13.015-12.918 0-7.12 5.84-12.917 13.017-12.917 7.178 0 12.88 5.797 12.88 12.917z" fill-rule="evenodd"/></svg>',
    ellipsis: '<svg viewBox="0 0 44 44"><circle cx="21.888" cy="22" r="4.045"/><circle cx="5.913" cy="22" r="4.045"/><circle cx="37.863" cy="22" r="4.045"/></svg>',
    'ellipsis-circle': '<svg viewBox="0 0 44 44"><g fill-rule="evenodd"><path d="M22.13.11C10.05.11.255 9.902.255 21.983S10.05 43.86 22.13 43.86s21.875-9.795 21.875-21.876S34.21.11 22.13.11zm0 40.7c-10.396 0-18.825-8.43-18.825-18.826S11.735 3.16 22.13 3.16c10.396 0 18.825 8.428 18.825 18.824S32.525 40.81 22.13 40.81z"/><circle cx="21.888" cy="22.701" r="2.445"/><circle cx="12.23" cy="22.701" r="2.445"/><circle cx="31.546" cy="22.701" r="2.445"/></g></svg>',
    'exclamation-circle': '<svg viewBox="0 0 64 64"><path d="M59.58 40.89L41.193 9.11C39.135 5.382 35.723 3 31.387 3c-3.11 0-6.52 2.382-8.58 6.11L4.42 40.89c-2.788 4.635-3.126 8.81-1.225 12.22C5.015 56.208 7.572 58 13 58h36.773c5.428 0 9.21-1.792 11.03-4.89 1.9-3.41 1.565-7.583-1.224-12.22zm-2.452 11c-.635 1.694-3.802 2.443-7.354 2.443H13c-3.59 0-5.493-.75-6.13-2.444-1.71-2.41-1.374-5.263 0-8.557l18.387-31.777c2.116-3.168 4.394-4.89 6.13-4.89 2.96 0 5.238 1.722 7.354 4.89l18.387 31.777c1.374 3.294 1.713 6.146 0 8.556zm-25.74-33c-.405 0-1.227.835-1.227 2.443v15.89c0 1.608.823 2.444 1.227 2.444 1.628 0 2.452-.836 2.452-2.445v-15.89c0-1.607-.825-2.443-2.453-2.443zm0 23.22c-.405 0-1.227.79-1.227 1.223v2.445c0 .434.823 1.222 1.227 1.222 1.628 0 2.452-.788 2.452-1.222v-2.445c0-.434-.825-1.222-2.453-1.222z" fill-rule="evenodd"/></svg>',
    'info-circle': '<svg viewBox="0 0 44 44"><circle cx="13.828" cy="19.63" r="1.938"/><circle cx="21.767" cy="19.63" r="1.938"/><circle cx="29.767" cy="19.63" r="1.938"/><path d="M22.102 4.16c-9.918 0-17.958 7.147-17.958 15.962 0 4.935 2.522 9.345 6.48 12.273v5.667l.04.012a2.627 2.627 0 1 0 4.5 1.455h.002l5.026-3.54c.628.06 1.265.094 1.91.094 9.92 0 17.96-7.146 17.96-15.96C40.06 11.306 32.02 4.16 22.1 4.16zm-.04 29.902c-.902 0-1.78-.08-2.642-.207l-5.882 4.234c-.024.024-.055.04-.083.06l-.008.005a.51.51 0 0 1-.284.095.525.525 0 0 1-.525-.525l.005-6.375c-3.91-2.516-6.456-6.544-6.456-11.1 0-7.628 7.107-13.812 15.875-13.812s15.875 6.184 15.875 13.812-7.107 13.812-15.875 13.812z"/></svg>',
    'question-circle': '<svg viewBox="0 0 44 44"><g fill-rule="evenodd"><path d="M21.186 3c-10.853 0-19.36 8.506-19.36 19.358C1.827 32.494 10.334 41 21.187 41c10.133 0 18.64-8.506 18.64-18.642C39.827 11.506 31.32 3 21.187 3m15.64 19c0 8.823-7.178 16-16 16s-16-7.177-16-16 7.178-16 16-16 16 7.177 16 16z"/><path d="M22.827 31.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m4-15.48c0 .957-.203 1.822-.61 2.593-.427.792-1.117 1.612-2.073 2.457-.867.734-1.453 1.435-1.754 2.096-.302.7-.453 1.693-.453 2.98a.828.828 0 0 1-.823.854.828.828 0 0 1-.584-.22.877.877 0 0 1-.24-.635c0-1.305.168-2.38.506-3.227.336-.883.93-1.682 1.78-2.4 1.01-.883 1.71-1.692 2.1-2.428.336-.645.503-1.38.503-2.21-.02-.935-.3-1.7-.85-2.288-.655-.717-1.62-1.075-2.897-1.075-1.506 0-2.596.535-3.27 1.6-.46.754-.688 1.645-.688 2.677a.92.92 0 0 1-.266.66.747.747 0 0 1-.56.25.73.73 0 0 1-.584-.194c-.16-.164-.24-.393-.24-.69 0-1.82.585-3.272 1.755-4.357C18.645 11.486 19.928 11 21.434 11h.293c1.452 0 2.638.414 3.56 1.24 1.028.903 1.54 2.163 1.54 3.78z"/></g></svg>',
    voice: '<svg viewBox="0 0 38 33"><g fill-rule="evenodd"><path d="M17.838 28.8c-.564-.468-1.192-.983-1.836-1.496-4.244-3.385-5.294-3.67-6.006-3.67-.014 0-.027.005-.04.005-.015 0-.028-.006-.042-.006H3.562c-.734 0-.903-.203-.903-.928v-12.62c0-.49.057-.8.66-.8H9.1c.694 0 1.76-.28 6.4-3.63.83-.596 1.638-1.196 2.337-1.722V28.8zM19.682.19c-.463-.22-1.014-.158-1.417.157-.02.016-1.983 1.552-4.152 3.125C10.34 6.21 9.243 6.664 9.02 6.737H3.676c-.027 0-.053.003-.08.004H1.183c-.608 0-1.1.487-1.1 1.086V25.14c0 .598.492 1.084 1.1 1.084h8.71c.22.08 1.257.55 4.605 3.24 1.947 1.562 3.694 3.088 3.712 3.103.25.22.568.333.89.333.186 0 .373-.038.55-.116.48-.213.79-.684.79-1.204V1.38c0-.506-.294-.968-.758-1.19z" mask="url(#mask-2)"/><path d="M31.42 16.475c0-3.363-1.854-6.297-4.606-7.876-.125-.067-.42-.193-.625-.193-.613 0-1.11.488-1.11 1.09 0 .404.22.764.55.952 2.13 1.19 3.566 3.44 3.566 6.024 0 2.627-1.486 4.913-3.677 6.087-.32.19-.53.54-.53.935 0 .602.495 1.09 1.106 1.09.26.002.568-.15.568-.15 2.835-1.556 4.754-4.538 4.754-7.96" mask="url(#mask-4)"/><path d="M30.14 3.057c-.205-.122-.41-.22-.658-.22-.608 0-1.1.485-1.1 1.084 0 .434.26.78.627.978 4.042 2.323 6.76 6.636 6.76 11.578 0 4.938-2.715 9.248-6.754 11.572-.354.19-.66.55-.66.993 0 .6.494 1.085 1.102 1.085.243 0 .438-.092.65-.213 4.692-2.695 7.848-7.7 7.848-13.435 0-5.723-3.142-10.718-7.817-13.418" mask="url(#mask-6)"/></g></svg>',
    plus: '<svg viewBox="0 0 30 30"><path d="M14 14H0v2h14v14h2V16h14v-2H16V0h-2v14z" fill-rule="evenodd"/></svg>',
    minus: '<svg viewBox="0 0 30 2"><path d="M0 0h30v2H0z" fill-rule="evenodd"/></svg>',
    dislike: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path fill="#FFF" d="M47 22h2v6h-2zm-24 0h2v6h-2z"/><path d="M21 51s4.6-7 15-7 15 7 15 7" stroke="#FFF" stroke-width="2"/></g></svg>',
    fail: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path d="M22 22l28.304 28.304m-28.304 0L50.304 22" stroke="#FFF" stroke-width="2"/></g></svg>',
    success: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path stroke="#FFF" stroke-width="2" d="M19 34.54l11.545 11.923L52.815 24"/></g></svg>'
};
var renderSvgSprite = function renderSvgSprite() {
    var symbols = Object.keys(icons).map(function (iconName) {
        var svgContent = icons[iconName].split('svg')[1];
        return '<symbol id=' + iconName + svgContent + 'symbol>';
    }).join('');
    return svgSprite(symbols);
};
var loadSprite = function loadSprite() {
    if (!document) {
        return;
    }
    var existing = document.getElementById('__ANTD_MOBILE_SVG_SPRITE_NODE__');
    var mountNode = document.body;
    if (!existing) {
        mountNode.insertAdjacentHTML('afterbegin', renderSvgSprite());
    }
};
exports['default'] = loadSprite;
module.exports = exports['default'];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = alert;

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(23);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(151);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(117);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function alert(title, message) {
    var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [{ text: '确定' }];
    var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ios';

    var closed = false;
    if (!title && !message) {
        // console.log('Must specify either an alert title, or message, or both');
        return {
            close: function close() {}
        };
    }
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    var prefixCls = 'am-modal';
    function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.' + prefixCls + '-footer');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(
        _Modal2['default'],
        { visible: true, transparent: true, title: title, transitionName: 'am-zoom', closable: false, maskClosable: false, footer: footer, maskTransitionName: 'am-fade', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } },
        React.createElement(
            'div',
            { className: prefixCls + '-alert-content' },
            message
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = operation;

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(23);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(151);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(117);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function operation() {
    var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{ text: '确定' }];
    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ios';

    var closed = false;
    var prefixCls = 'am-modal';
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.am-modal-footer');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(_Modal2['default'], { visible: true, operation: true, transparent: true, prefixCls: prefixCls, transitionName: 'am-zoom', closable: false, maskClosable: true, onClose: close, footer: footer, maskTransitionName: 'am-fade', className: 'am-modal-operation', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } }), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = prompt;

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(23);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(151);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(117);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function prompt(title, message, callbackOrActions) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var placeholders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ['', ''];
    var platform = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'ios';

    var closed = false;
    defaultValue = typeof defaultValue === 'string' ? defaultValue : typeof defaultValue === 'number' ? '' + defaultValue : '';
    if (!callbackOrActions) {
        // console.log('Must specify callbackOrActions');
        return {
            close: function close() {}
        };
    }
    var prefixCls = 'am-modal';
    var data = {
        text: defaultValue
    };
    function onChange(e) {
        var target = e.target;
        var inputType = target.getAttribute('type');
        if (inputType !== null) {
            data[inputType] = target.value;
        }
    }
    // hotfix issue: https://github.com/ant-design/ant-design-mobile/issues/2177
    function onClick(e) {
        var target = e.currentTarget || e.target;
        if (target) {
            target.focus();
        }
    }
    function onBlurFixWechat() {
        // https://github.com/ant-design/ant-design-mobile/issues/3137
        if (/MicroMessenger/.test(navigator.userAgent)) {
            document.body.scrollTop = document.body.scrollTop;
        }
    }
    var inputDom = void 0;
    var focusFn = function focusFn(input) {
        setTimeout(function () {
            if (input) {
                input.focus();
            }
        }, 500);
    };
    switch (type) {
        case 'login-password':
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'text', defaultValue: data.text, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'password', defaultValue: data.password, onClick: onClick, onChange: onChange, placeholder: placeholders[1], onBlur: onBlurFixWechat })
                    )
                )
            );
            break;
        case 'secure-text':
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'password', defaultValue: data.password, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                )
            );
            break;
        case 'default':
        default:
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'text', defaultValue: data.text, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                )
            );
    }
    var content = React.createElement(
        'div',
        null,
        message,
        inputDom
    );
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    function handleConfirm(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        var _data$text = data.text,
            text = _data$text === undefined ? '' : _data$text,
            _data$password = data.password,
            password = _data$password === undefined ? '' : _data$password;

        var callbackArgs = type === 'login-password' ? [text, password] : type === 'secure-text' ? [password] : [text];
        return callback.apply(undefined, callbackArgs);
    }
    var actions = void 0;
    if (typeof callbackOrActions === 'function') {
        actions = [{
            text: '取消',
            onPress: function onPress() {}
        }, {
            text: '确定',
            onPress: function onPress() {
                handleConfirm(callbackOrActions);
            }
        }];
    } else {
        actions = callbackOrActions.map(function (item) {
            return {
                text: item.text,
                onPress: function onPress() {
                    return handleConfirm(item.onPress);
                }
            };
        });
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    function onWrapTouchStart(e) {
        // exclude input element for focus
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.' + prefixCls + '-content');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(
        _Modal2['default'],
        { visible: true, transparent: true, prefixCls: prefixCls, title: title, closable: false, maskClosable: false, transitionName: 'am-zoom', footer: footer, maskTransitionName: 'am-fade', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } },
        React.createElement(
            'div',
            { className: prefixCls + '-propmt-content' },
            content
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(23);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(95);

var _reactAddonsCssTransitionGroup = __webpack_require__(350);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactIntl = __webpack_require__(146);

var _classnames = __webpack_require__(52);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(349);

var _routeConfig = __webpack_require__(238);

var ShopRoute = _interopRequireWildcard(_routeConfig);

var _routeFetch = __webpack_require__(94);

var _BusinessUtil = __webpack_require__(112);

var _appUtil = __webpack_require__(96);

var _appUtil2 = _interopRequireDefault(_appUtil);

var _storageUtil = __webpack_require__(50);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

var _constant = __webpack_require__(51);

var _commonUtils = __webpack_require__(111);

var _WechatUtil = __webpack_require__(228);

var _HdDialog = __webpack_require__(346);

var _HdDialog2 = _interopRequireDefault(_HdDialog);

var _yunshlTracker = __webpack_require__(227);

var _yunshlTracker2 = _interopRequireDefault(_yunshlTracker);

var _zh = __webpack_require__(361);

var _zh2 = _interopRequireDefault(_zh);

var _es = __webpack_require__(354);

var _es2 = _interopRequireDefault(_es);

var _en = __webpack_require__(353);

var _en2 = _interopRequireDefault(_en);

var _de = __webpack_require__(352);

var _de2 = _interopRequireDefault(_de);

var _fr = __webpack_require__(355);

var _fr2 = _interopRequireDefault(_fr);

var _ar = __webpack_require__(351);

var _ar2 = _interopRequireDefault(_ar);

var _ru = __webpack_require__(358);

var _ru2 = _interopRequireDefault(_ru);

var _ms = __webpack_require__(357);

var _ms2 = _interopRequireDefault(_ms);

var _vi = __webpack_require__(360);

var _vi2 = _interopRequireDefault(_vi);

var _th = __webpack_require__(359);

var _th2 = _interopRequireDefault(_th);

var _id = __webpack_require__(356);

var _id2 = _interopRequireDefault(_id);

var _zh_CN = __webpack_require__(115);

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _es_ES = __webpack_require__(114);

var _es_ES2 = _interopRequireDefault(_es_ES);

var _en_US = __webpack_require__(113);

var _en_US2 = _interopRequireDefault(_en_US);

var _de_DE = __webpack_require__(230);

var _de_DE2 = _interopRequireDefault(_de_DE);

var _fr_FR = __webpack_require__(231);

var _fr_FR2 = _interopRequireDefault(_fr_FR);

var _ar_SA = __webpack_require__(229);

var _ar_SA2 = _interopRequireDefault(_ar_SA);

var _ru_RU = __webpack_require__(234);

var _ru_RU2 = _interopRequireDefault(_ru_RU);

var _ms_MY = __webpack_require__(233);

var _ms_MY2 = _interopRequireDefault(_ms_MY);

var _vi_VN = __webpack_require__(236);

var _vi_VN2 = _interopRequireDefault(_vi_VN);

var _th_TH = __webpack_require__(235);

var _th_TH2 = _interopRequireDefault(_th_TH);

var _id_ID = __webpack_require__(232);

var _id_ID2 = _interopRequireDefault(_id_ID);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_zh2.default), _toConsumableArray(_es2.default), _toConsumableArray(_en2.default), _toConsumableArray(_de2.default), _toConsumableArray(_fr2.default), _toConsumableArray(_ar2.default), _toConsumableArray(_ru2.default), _toConsumableArray(_ms2.default), _toConsumableArray(_vi2.default), _toConsumableArray(_th2.default), _toConsumableArray(_id2.default))); // 引入多语言环境的数据

// 中文
// 西班牙语
// 英语
// 德语
// 法语
// 阿拉伯语
// 俄语
// 马来语
// 越南语
// 泰语
// 印尼语


// 多语言 XIAOMI654321
var messages = {
    'zh': _zh_CN2.default,
    'es': _es_ES2.default,
    'en': _en_US2.default,
    'de': _de_DE2.default,
    'fr': _fr_FR2.default,
    'ar': _ar_SA2.default,
    'ru': _ru_RU2.default,
    'ms': _ms_MY2.default,
    'vi': _vi_VN2.default,
    'th': _th_TH2.default,
    'id': _id_ID2.default
};
// 消息提示时间
window.ToastDuration = 1.2;
// 获取账号中心信息
var initAuth = function initAuth() {
    // app 版本 17620387339
    if (_appUtil2.default.isApp) {
        _commonUtils.InitUtil.cleanShopCache();
    }
    var query = _commonUtils.CommonUtil.getSearchFromUrl();
    var companyId = _storageUtil2.default.getItem(_constant.SystemConst.companyId);
    // 新公司清除所有缓存
    if (query.companyId && query.companyId != companyId) {
        localStorage.clear();
        sessionStorage.clear();
        window.indexedDB.deleteDatabase('YunshlDB');
    }
    // webapp登陆跳转
    if (query.auth_code_) {
        var auth_code_ = JSON.parse(Base64.decode(query.auth_code_));
        // 本地保存登录信息
        _commonUtils.CommonUtil.saveStorageFormLogin(auth_code_);
        delete query.auth_code_;
        _reactRouter.browserHistory.replaceState(null, location.pathname, query);
    }
    // 分享人
    if (query.u) {
        _storageUtil2.default.setItem(_constant.SystemConst.shareUserId, query.u, true);
    }
    //分享客户
    if (query.c) {
        _storageUtil2.default.setItem(_constant.SystemConst.shareClientId, query.c, true);
    }
    // 删除微信设置信息
    _storageUtil2.default.delItem(_constant.SystemConst.wechatData);
};
// 初始化数据
initAuth();

var shopComponent = (_temp = _class = function (_React$Component) {
    _inherits(shopComponent, _React$Component);

    function shopComponent(props) {
        _classCallCheck(this, shopComponent);

        var _this = _possibleConstructorReturn(this, (shopComponent.__proto__ || Object.getPrototypeOf(shopComponent)).call(this, props));

        _initialiseProps.call(_this);

        var lang = _storageUtil2.default.getItem(_constant.SystemConst.lang);
        _this.state = {
            options: {},
            isLogin: false,
            homePageLoaded: false,
            baseSetting: {},
            lang: lang || 'zh' // 本地语言
        };
        return _this;
    }

    _createClass(shopComponent, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            var _this2 = this;

            _storageUtil2.default.delItem('stopRemind');
            var query = this.props.location.query;
            var companyId = query.companyId ? parseInt(query.companyId) : _storageUtil2.default.getItem(_constant.SystemConst.companyId);
            // 获取登陆用户信息
            var ysUser = _storageUtil2.default.getItem(_constant.SystemConst.mShop_user);
            var companyTheme = _storageUtil2.default.getItem(_constant.SystemConst.companyTheme);
            if (query.code) {
                //state参数有带V的字符的,是微信授权的-- 没带V的不用进入跑接口,以防在做微信支付也需要用到返回的code时,报code已使用的错误
                if (query.state && query.state.indexOf('V') > -1) {
                    console.log('获取微信授权信息', query.code);
                    if (!query.order_) {
                        // 获取微信授权信息
                        // InitUtil.getWechatUserInfo(query.code, companyId).then(rs => {
                        //     if (ysUser) {
                        //         this.getLoginData();
                        //     }
                        // });
                    }
                }
            }

            // 设置主题色
            _commonUtils.CommonUtil.setTheme(companyTheme || ysUser && ysUser.company_theme_ || 'ffb919');
            // 不存在companyId，跳转登陆
            if (!companyId) {
                // Util.message(`缺少企业id,${location.href}`);
                return;
            }

            // 判断是否体验企业
            var isExperience = _BusinessUtil.BusinessUtil.checkExperience(companyId) ? 1 : 0;
            // 设置体验账号信息
            _storageUtil2.default.setItem(_constant.SystemConst.isExperience, isExperience);
            // 更新企业id
            _storageUtil2.default.setItem(_constant.SystemConst.companyId, companyId);

            // 体验账号,没有登陆人或者登录人id不等于url新id
            if (isExperience && (!ysUser || ysUser.company_id_ !== companyId)) {
                // 自动登陆体验账号，获取公司设置信息
                _commonUtils.CommonUtil.toShopExperience();
            }
            // 性能优化：API请求并行化，使用Promise.all同时发起多个请求
            Promise.all([_commonUtils.InitUtil.getCompany(companyId), _commonUtils.InitUtil.getApplicationStatus(companyId) ? Promise.resolve() : Promise.resolve(), _commonUtils.CommonUtil.initCompanySettingAsync(companyId, _storageUtil2.default.getItem(_constant.SystemConst.platformCompanyId)), ysUser && !query.code ? this.getLoginDataAsync() : Promise.resolve()]).then(function (results) {
                var rs = results[0];
                if (rs && rs.status === 1) {
                    if (!rs.data.allow_visitor_ && !isExperience && !ysUser) {
                        // 非体验账号不允许游客访问，退出登陆端
                        _BusinessUtil.BusinessUtil.toLogout();
                        return;
                    }
                    _storageUtil2.default.setItem(_constant.SystemConst.companyName, rs.data.name_);
                    _storageUtil2.default.setItem(_constant.SystemConst.companyTheme, rs.data.theme_);
                    // 是否开启国家省市县
                    _storageUtil2.default.setItem(_constant.SystemConst.enableGlobal, rs.data.enable_global_);
                    _storageUtil2.default.setItem(_constant.SystemConst.switchLanguageType, rs.data.switch_language_type_);
                    // 商城货币类型
                    // StorageUtil.setItem(SystemConst.currencySymbol, rs.data.currency_type_ || "¥");
                    document.title = rs.data.shop_home_title_ || rs.data.name_;

                    // 检查用户是否微信绑定
                    if (!query.code && !query.order_) {
                        // CommonUtil.toWechatBind();
                    }
                    console.log('getCompany===========>', rs.data);
                    // 设置国际语言
                    _this2.changeLang(rs.data.language_type_);
                    _storageUtil2.default.setItem(_constant.SystemConst.languageType, rs.data.language_type_);
                    _storageUtil2.default.setItem(_constant.SystemConst.rmbExchangeRate, rs.data.rmb_exchange_rate_);
                    _commonUtils.CommonUtil.setTheme(rs.data.theme_);
                    _commonUtils.CommonUtil.setStatisticalCode(rs.data.view_count_url_);
                }
            }).catch(function (error) {
                console.error('初始化请求失败:', error);
            });
            // 获取应用状态（以下请求不依赖上面的结果，可独立执行）
            if (ysUser) {
                _commonUtils.InitUtil.getMsgSettingByCompanyId(companyId);
                // 获取客服列表
                _commonUtils.InitUtil.getCustomerServiceList();
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this3 = this;

            //处理微信分享
            (0, _WechatUtil.loadWxConfig)();
            // 统计代码
            this.createAnalyzeCode();
            // 初始化行为追踪SDK
            this.initBehaviorTracker();
            // 更新页面展示类型和页面滚动节点
            window.addEventListener("setItemEvent", function (e) {
                if (e.key === _constant.SystemConst.BaseSetting) {
                    _this3.setState({
                        baseSetting: JSON.parse(e.newValue)
                    });
                }
            });
        }

        // 初始化行为追踪SDK

    }, {
        key: "initBehaviorTracker",
        value: function initBehaviorTracker() {
            var ysUser = _storageUtil2.default.getItem(_constant.SystemConst.mShop_user) || {};
            var companyId = _storageUtil2.default.getItem(_constant.SystemConst.companyId);
            _yunshlTracker2.default.init({
                batchSize: 10,
                flushInterval: 5000
            });
            // 设置用户信息
            _yunshlTracker2.default.setUser(ysUser.id_, ysUser.client_id_, companyId || ysUser.company_id_);
        }
        /**
         * 异步版本的getLoginData（性能优化：返回Promise）
         * @returns Promise
         */

        // 切换语言

    }, {
        key: "toLogout",
        value: function toLogout() {
            //退出到app
            _routeFetch.System.logout(null, function (response) {
                if (response.status === 1) {
                    _BusinessUtil.BusinessUtil.toLogout();
                }
            });
        }
    }, {
        key: "toRegister",
        value: function toRegister() {
            //退出到app
            _BusinessUtil.BusinessUtil.toLogout('register', true);
        }

        //隐藏弹窗

    }, {
        key: "hideDialog",
        value: function hideDialog() {
            this.setState({ options: {} });
        }
    }, {
        key: "setConfirm",
        value: function setConfirm(obj) {
            this.setState({
                options: _extends({
                    type: "confirm"
                }, obj)
            });
        }

        //跳转

    }, {
        key: "toLink",
        value: function toLink(name, query, state) {
            this.props.history.pushState(state, name, query);
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                baseSetting = _state.baseSetting,
                lang = _state.lang;

            var parents = _extends({}, this.state, {
                changeLang: this.changeLang,
                setConfirm: function setConfirm(obj) {
                    return _this4.setConfirm(obj);
                },
                toLogout: function toLogout() {
                    return _this4.toLogout();
                },
                toLogin: function toLogin() {
                    return _this4.toLogin();
                },
                hideDialog: function hideDialog() {
                    return _this4.hideDialog();
                },
                toRegister: function toRegister() {
                    return _this4.toRegister();
                },
                toLink: function toLink(name, query, state) {
                    return _this4.toLink(name, query, state);
                },
                changeHomePageLoaded: function changeHomePageLoaded(v) {
                    return _this4.changeHomePageLoaded(v);
                }
            });
            var _props = this.props,
                children = _props.children,
                location = _props.location;

            var interval = 500;
            // 获取动画名称
            var transitionName = _commonUtils.CommonUtil.getTransitionName(location);

            var pageCls = (0, _classnames2.default)({
                'page-ios': _appUtil2.default.isIos,
                'page': !_appUtil2.default.isIos,
                'font-reset': baseSetting.font_style_ === 'bold'
            });
            return _react2.default.createElement(
                "section",
                { className: pageCls },
                _react2.default.createElement(
                    _reactIntl.IntlProvider,
                    { locale: lang, messages: messages[lang] || messages['zh'] },
                    _react2.default.createElement(
                        _reactAddonsCssTransitionGroup2.default,
                        {
                            component: "section",
                            transitionName: transitionName,
                            transitionEnterTimeout: interval,
                            transitionLeaveTimeout: interval },
                        _react2.default.createElement(
                            "div",
                            { key: location.pathname + location.search },
                            _react2.default.cloneElement(children || null, parents)
                        )
                    )
                ),
                _react2.default.createElement(_HdDialog2.default, { options: this.state.options, hideDialog: function hideDialog() {
                        return _this4.hideDialog();
                    } })
            );
        }
    }]);

    return shopComponent;
}(_react2.default.Component), _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.createAnalyzeCode = function () {
        var companyId = _storageUtil2.default.getItem(_constant.SystemConst.companyId);
        if (companyId === 205) {
            var hm = document.createElement("script");
            hm.src = "https://s5.cnzz.com/z_stat.php?id=1277658265&web_id=1277658265";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        }
    };

    this.getLoginData = function () {
        _commonUtils.InitUtil.getCartNumber();
        _commonUtils.InitUtil.getClientInfo();
    };

    this.getLoginDataAsync = function () {
        return new Promise(function (resolve) {
            _commonUtils.InitUtil.getCartNumber();
            _commonUtils.InitUtil.getClientInfo();
            resolve();
        });
    };

    this.changeLang = function (lang) {
        _storageUtil2.default.setItem(_constant.SystemConst.lang, lang);
        _this5.setState({
            lang: lang
        });
    };
}, _temp);

// 页面离开记录上一次路由

var onLeave = function onLeave(prevState) {
    sessionStorage.setItem('prevLocation', JSON.stringify({
        pathname: prevState.location.pathname,
        query: prevState.location.query,
        search: prevState.location.search
    }));
    // 设置公司title
    document.title = _storageUtil2.default.getItem(_constant.SystemConst.companyName);
};
var onEnter = function onEnter(nextState, replaceState) {
    var _nextState$location = nextState.location,
        state = _nextState$location.state,
        pathname = _nextState$location.pathname,
        query = _nextState$location.query,
        action = _nextState$location.action;

    var localHistory = _storageUtil2.default.getItem(_constant.SystemConst.localHistory, true) || [];
    var historyLen = localHistory.length;
    if (!query.companyId) {
        // 获取本地companyId
        var companyId = _storageUtil2.default.getItem(_constant.SystemConst.companyId);
        if (companyId) {
            replaceState(state, pathname, _extends({}, query, {
                companyId: companyId
            }));
        }
    }
    // 相同路由splice替换
    if (historyLen > 0 && pathname === localHistory[historyLen - 1].pathname) {
        localHistory.splice(historyLen - 1, 1, { state: state, pathname: pathname, query: query });
    } else {
        localHistory.push({ state: state, pathname: pathname, query: query });
        // 只记录12个路由
        if (historyLen > 12) {
            localHistory.shift();
        }
    }
    _storageUtil2.default.setItem(_constant.SystemConst.localHistory, localHistory, true);
};
//遍历返回的route对象，并封装childRoutes所需数组返回
var getChildRoutes = function getChildRoutes(ChildRoute) {
    var _arr = [];
    for (var key in ChildRoute) {
        ChildRoute[key].onLeave = onLeave;
        ChildRoute[key].onEnter = onEnter;
        _arr.push(ChildRoute[key]);
    }
    return _arr;
};
var rootRoute = [{
    path: '/',
    component: shopComponent,
    indexRoute: ShopRoute.Shop,
    childRoutes: getChildRoutes(ShopRoute)
}, {
    path: '/GoodsDetail',
    component: shopComponent,
    indexRoute: ShopRoute.GoodsDetail
}, {
    path: 'shop',
    component: shopComponent,
    indexRoute: ShopRoute.Shop,
    childRoutes: getChildRoutes(ShopRoute)
}];
//  启动项目
var initApp = function initApp() {
    _reactDom2.default.render(_react2.default.createElement(_reactRouter.Router, { routes: rootRoute, history: _reactRouter.browserHistory }), document.getElementById('YsApp'), function () {
        if (window.__YSHL_BOOT_READY__) {
            window.__YSHL_BOOT_READY__();
        }
    });
};

// 启动app
initApp();

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(195);

var _DialogContainer = __webpack_require__(152);

var _DialogContainer2 = _interopRequireDefault(_DialogContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDialog = function (_React$Component) {
    _inherits(ConfirmDialog, _React$Component);

    function ConfirmDialog() {
        _classCallCheck(this, ConfirmDialog);

        return _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).apply(this, arguments));
    }

    _createClass(ConfirmDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$confirmLabel = _props.confirmLabel,
                confirmLabel = _props$confirmLabel === undefined ? '确定' : _props$confirmLabel,
                _props$cancelLabel = _props.cancelLabel,
                cancelLabel = _props$cancelLabel === undefined ? '取消' : _props$cancelLabel,
                show = _props.show,
                title = _props.title,
                content = _props.content,
                confirm = _props.confirm,
                dismiss = _props.dismiss,
                cancel = _props.cancel;

            return _react2.default.createElement(
                'section',
                { className: show ? 'dis-show' : 'dis-hide' },
                _react2.default.createElement(
                    'div',
                    { className: 'dialog' },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-main' },
                            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: content } })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog-operate' },
                        _react2.default.createElement(
                            'button',
                            { className: 'cancel',
                                onClick: function onClick() {
                                    return cancel();
                                } },
                            cancelLabel
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'confirm',
                                onClick: function onClick() {
                                    return confirm();
                                } },
                            confirmLabel
                        )
                    )
                ),
                _react2.default.createElement('div', { className: 'dialog-mask', onClick: function onClick() {
                        return cancel();
                    } })
            );
        }
    }]);

    return ConfirmDialog;
}(_react2.default.Component);

ConfirmDialog.propTypes = {
    confirmLabel: _propTypes2.default.string,
    cancelLabel: _propTypes2.default.string,
    title: _propTypes2.default.string,
    show: _propTypes2.default.boolean,
    content: _propTypes2.default.string,
    confirm: _propTypes2.default.func, // called when ok button is clicked.
    cancel: _propTypes2.default.func, // called when cancel button is clicked.
    dismiss: _propTypes2.default.func // called when backdrop is clicked or escaped.
};

exports.default = (0, _DialogContainer2.default)(ConfirmDialog);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Created by Samj on 2017/7/21.
                                                                                                                                                                                                                                                                   */


exports.ysConfirm = ysConfirm;
exports.ysMessage = ysMessage;
exports.ysTitle = ysTitle;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(23);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ConfirmDialog = __webpack_require__(381);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _MessageDialog = __webpack_require__(383);

var _MessageDialog2 = _interopRequireDefault(_MessageDialog);

var _TitleDialog = __webpack_require__(384);

var _TitleDialog2 = _interopRequireDefault(_TitleDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//创建对话框容器
var CreateContainer = function CreateContainer(Component, type) {
    return function (props) {
        var wrapper = document.body.appendChild(document.createElement('div'));

        //创建容器回调
        var promise = new Promise(function (resolve, reject) {
            try {
                _reactDom2.default.render(_react2.default.createElement(Component, _extends({
                    resolve: resolve,
                    reject: reject,
                    dispose: dispose
                }, props)), wrapper);
                if (type == 'message') {
                    setTimeout(function () {
                        dispose();
                    });
                }
            } catch (e) {
                throw e;
            }
        });

        function dispose() {
            setTimeout(function () {
                _reactDom2.default.unmountComponentAtNode(wrapper);
                setTimeout(function () {
                    return wrapper.remove();
                });
            }, 2000);
        }

        return promise.then(function (result) {
            dispose();
            return result;
        }, function (result) {
            dispose();
            return Promise.reject(result);
        });
    };
};

var confirmContainer = CreateContainer(_ConfirmDialog2.default);

function ysConfirm(content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return confirmContainer(_extends({ content: content }, options));
}

var messageContainer = CreateContainer(_MessageDialog2.default, 'message');

function ysMessage(content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return messageContainer(_extends({ content: content }, options));
}

var titleContainer = CreateContainer(_TitleDialog2.default);

function ysTitle(title, content) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return titleContainer(_extends({ title: title, content: content }, options));
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(195);

var _DialogContainer = __webpack_require__(152);

var _DialogContainer2 = _interopRequireDefault(_DialogContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageDialog = function (_React$Component) {
    _inherits(MessageDialog, _React$Component);

    function MessageDialog() {
        _classCallCheck(this, MessageDialog);

        return _possibleConstructorReturn(this, (MessageDialog.__proto__ || Object.getPrototypeOf(MessageDialog)).apply(this, arguments));
    }

    _createClass(MessageDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                show = _props.show,
                title = _props.title,
                content = _props.content;

            return _react2.default.createElement(
                'section',
                { className: show ? 'dis-show' : 'dis-hide' },
                _react2.default.createElement(
                    'div',
                    { className: 'dialog-msg' },
                    _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: content } })
                )
            );
        }
    }]);

    return MessageDialog;
}(_react2.default.Component);

MessageDialog.propTypes = {
    title: _propTypes2.default.string,
    show: _propTypes2.default.boolean,
    content: _propTypes2.default.string
};

exports.default = (0, _DialogContainer2.default)(MessageDialog);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(195);

var _DialogContainer = __webpack_require__(152);

var _DialogContainer2 = _interopRequireDefault(_DialogContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleDialog = function (_React$Component) {
    _inherits(TitleDialog, _React$Component);

    function TitleDialog() {
        _classCallCheck(this, TitleDialog);

        return _possibleConstructorReturn(this, (TitleDialog.__proto__ || Object.getPrototypeOf(TitleDialog)).apply(this, arguments));
    }

    _createClass(TitleDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$confirmLabel = _props.confirmLabel,
                confirmLabel = _props$confirmLabel === undefined ? '确定' : _props$confirmLabel,
                cancelLabel = _props.cancelLabel,
                show = _props.show,
                title = _props.title,
                content = _props.content,
                confirm = _props.confirm,
                cancel = _props.cancel;

            return _react2.default.createElement(
                'section',
                { className: show ? 'dis-show' : 'dis-hide' },
                _react2.default.createElement(
                    'div',
                    { className: 'dialog dialog-tips dialog-width-big' },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-main' },
                            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: content } })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog-operate' },
                        cancelLabel && _react2.default.createElement(
                            'button',
                            { className: 'cancel',
                                onClick: function onClick() {
                                    return cancel();
                                } },
                            cancelLabel
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'confirm',
                                onClick: function onClick() {
                                    return confirm();
                                } },
                            confirmLabel
                        )
                    )
                ),
                _react2.default.createElement('div', { className: 'dialog-mask' })
            );
        }
    }]);

    return TitleDialog;
}(_react2.default.Component);

TitleDialog.propTypes = {
    confirmLabel: _propTypes2.default.string,
    cancelLabel: _propTypes2.default.string,
    title: _propTypes2.default.string,
    show: _propTypes2.default.boolean,
    content: _propTypes2.default.string,
    confirm: _propTypes2.default.func, // called when ok button is clicked.
    cancel: _propTypes2.default.func // called when ok button is clicked.
};

exports.default = (0, _DialogContainer2.default)(TitleDialog);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(395), __esModule: true };

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(397), __esModule: true };

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(398), __esModule: true };

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(399), __esModule: true };

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 391 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(242);
} catch (err) {
  var index = __webpack_require__(242);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 393 */,
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(418);
module.exports = __webpack_require__(54).Object.assign;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(419);
var $Object = __webpack_require__(54).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(420);
var $Object = __webpack_require__(54).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(421);
module.exports = __webpack_require__(54).Object.setPrototypeOf;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(424);
__webpack_require__(422);
__webpack_require__(425);
__webpack_require__(426);
module.exports = __webpack_require__(54).Symbol;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(423);
__webpack_require__(427);
module.exports = __webpack_require__(167).f('iterator');


/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(81);
var toLength = __webpack_require__(416);
var toAbsoluteIndex = __webpack_require__(415);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(119);
var gOPS = __webpack_require__(159);
var pIE = __webpack_require__(120);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(56).document;
module.exports = document && document.documentElement;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(243);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(158);
var descriptor = __webpack_require__(121);
var setToStringTag = __webpack_require__(160);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(79)(IteratorPrototype, __webpack_require__(82)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(122)('meta');
var isObject = __webpack_require__(80);
var has = __webpack_require__(61);
var setDesc = __webpack_require__(62).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(99)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(55);
var getKeys = __webpack_require__(119);
var gOPS = __webpack_require__(159);
var pIE = __webpack_require__(120);
var toObject = __webpack_require__(164);
var IObject = __webpack_require__(247);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(99)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(62);
var anObject = __webpack_require__(98);
var getKeys = __webpack_require__(119);

module.exports = __webpack_require__(55) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(81);
var gOPN = __webpack_require__(250).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(61);
var toObject = __webpack_require__(164);
var IE_PROTO = __webpack_require__(161)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(80);
var anObject = __webpack_require__(98);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(244)(Function.call, __webpack_require__(249).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(163);
var defined = __webpack_require__(155);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(163);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(163);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(401);
var step = __webpack_require__(407);
var Iterators = __webpack_require__(157);
var toIObject = __webpack_require__(81);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(248)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(78);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(409) });


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(78);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(158) });


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(78);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(55), 'Object', { defineProperty: __webpack_require__(62).f });


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(78);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(413).set });


/***/ }),
/* 422 */
/***/ (function(module, exports) {



/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(414)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(248)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(56);
var has = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(55);
var $export = __webpack_require__(78);
var redefine = __webpack_require__(252);
var META = __webpack_require__(408).KEY;
var $fails = __webpack_require__(99);
var shared = __webpack_require__(162);
var setToStringTag = __webpack_require__(160);
var uid = __webpack_require__(122);
var wks = __webpack_require__(82);
var wksExt = __webpack_require__(167);
var wksDefine = __webpack_require__(166);
var enumKeys = __webpack_require__(403);
var isArray = __webpack_require__(405);
var anObject = __webpack_require__(98);
var isObject = __webpack_require__(80);
var toObject = __webpack_require__(164);
var toIObject = __webpack_require__(81);
var toPrimitive = __webpack_require__(165);
var createDesc = __webpack_require__(121);
var _create = __webpack_require__(158);
var gOPNExt = __webpack_require__(411);
var $GOPD = __webpack_require__(249);
var $GOPS = __webpack_require__(159);
var $DP = __webpack_require__(62);
var $keys = __webpack_require__(119);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(250).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(120).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(118)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(79)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166)('asyncIterator');


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166)('observable');


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(417);
var global = __webpack_require__(56);
var hide = __webpack_require__(79);
var Iterators = __webpack_require__(157);
var TO_STRING_TAG = __webpack_require__(82)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 629 */,
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(150);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(631));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(150);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(289));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(150);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(289));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, exports) {

if (navigator && navigator.userAgent) {
  // 检测浏览器版本，并设置 window.__disableNativeFetch 来决定是否开启 fetch
  var userAgent = navigator.userAgent || "";
  var appVersion = navigator.appVersion || "";
  var vendor = navigator.vendor || "";

  var ua = (userAgent + ' ' + appVersion + ' ' + vendor).toLowerCase();

  var match = /(chrome)[ \/]([\w.]+)/.exec(ua)
        || /(webkit)[ \/]([\w.]+)/.exec(ua)
        || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua)
        || /(msie) ([\w.]+)/.exec(ua)
        || /(trident)(?:.*? rv:([\w.]+)|)/.exec(ua)
        || ua.indexOf("compatible") < 0
        && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];

  var engine = match[0];
  var mainVersion = match[2].split('.')[0];

  // chrome 内核版本大于 46， firefox 版本大于39 才开启 fetch
  if (engine.indexOf('chrome') === 0 && mainVersion >= 46) {
    window.__disableNativeFetch = false;
  } else if (engine.indexOf('mozilla') === 0 && mainVersion >= 39) {
    window.__disableNativeFetch = false;
  } else {
    window.__disableNativeFetch = true;
  }
}


/***/ }),
/* 653 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  // if __disableNativeFetch is set to true, the it will always polyfill fetch
  // with Ajax.
  if (!self.__disableNativeFetch && self.fetch) {
    return
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)

    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var list = this.map[name]
    if (!list) {
      list = []
      this.map[name] = list
    }
    list.push(value)
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    var values = this.map[normalizeName(name)]
    return values ? values[0] : null
  }

  Headers.prototype.getAll = function(name) {
    return this.map[normalizeName(name)] || []
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = [normalizeValue(value)]
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    Object.getOwnPropertyNames(this.map).forEach(function(name) {
      this.map[name].forEach(function(value) {
        callback.call(thisArg, value, name, this)
      }, this)
    }, this)
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    reader.readAsArrayBuffer(blob)
    return fileReaderReady(reader)
  }

  function readBlobAsText(blob, options) {
    var reader = new FileReader()
    var contentType = options.headers.map['content-type'] ? options.headers.map['content-type'].toString() : ''
    var regex = /charset\=[0-9a-zA-Z\-\_]*;?/
    var _charset = blob.type.match(regex) || contentType.match(regex)
    var args = [blob]

    if(_charset) {
      args.push(_charset[0].replace(/^charset\=/, '').replace(/;$/, ''))
    }

    reader.readAsText.apply(reader, args)
    return fileReaderReady(reader)
  }

  var support = {
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob();
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  function Body() {
    this.bodyUsed = false


    this._initBody = function(body, options) {
      this._bodyInit = body
      if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
        this._options = options
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (!body) {
        this._bodyText = ''
      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
        // Only support ArrayBuffers for POST method.
        // Receiving ArrayBuffers happens via Blobs, instead.
      } else {
        throw new Error('unsupported BodyInit type')
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        return this.blob().then(readBlobAsArrayBuffer)
      }

      this.text = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return readBlobAsText(this._bodyBlob, this._options)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as text')
        } else {
          return Promise.resolve(this._bodyText)
        }
      }
    } else {
      this.text = function() {
        var rejected = consumed(this)
        return rejected ? rejected : Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body
    if (Request.prototype.isPrototypeOf(input)) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = input
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body, options)
  }

  Request.prototype.clone = function() {
    return new Request(this)
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function headers(xhr) {
    var head = new Headers()
    var pairs = xhr.getAllResponseHeaders().trim().split('\n')
    pairs.forEach(function(header) {
      var split = header.trim().split(':')
      var key = split.shift().trim()
      var value = split.join(':').trim()
      head.append(key, value)
    })
    return head
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this._initBody(bodyInit, options)
    this.type = 'default'
    this.status = options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = options.statusText
    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
    this.url = options.url || ''
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request
      if (Request.prototype.isPrototypeOf(input) && !init) {
        request = input
      } else {
        request = new Request(input, init)
      }

      var xhr = new XMLHttpRequest()

      function responseURL() {
        if ('responseURL' in xhr) {
          return xhr.responseURL
        }

        // Avoid security warnings on getResponseHeader when not allowed by CORS
        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
          return xhr.getResponseHeader('X-Request-URL')
        }

        return;
      }

      var __onLoadHandled = false;

      function onload() {
        if (xhr.readyState !== 4) {
          return
        }
        var status = (xhr.status === 1223) ? 204 : xhr.status
        if (status < 100 || status > 599) {
          if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
          reject(new TypeError('Network request failed'))
          return
        }
        var options = {
          status: status,
          statusText: xhr.statusText,
          headers: headers(xhr),
          url: responseURL()
        }
        var body = 'response' in xhr ? xhr.response : xhr.responseText;

        if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
        resolve(new Response(body, options))
      }
      xhr.onreadystatechange = onload;
      xhr.onload = onload;
      xhr.onerror = function() {
        if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      // `withCredentials` should be setted after calling `.open` in IE10
      // http://stackoverflow.com/a/19667959/1219343
      try {
        if (request.credentials === 'include') {
          if ('withCredentials' in xhr) {
            xhr.withCredentials = true;
          } else {
            console && console.warn && console.warn('withCredentials is not supported, you can ignore this warning');
          }
        }
      } catch (e) {
        console && console.warn && console.warn('set withCredentials error:' + e);
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true

  // Support CommonJS
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = self.fetch;
  }
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(667)['default'];
exports['default'] = exports;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(300), src$es5$$ = __webpack_require__(671), src$compiler$$ = __webpack_require__(668), intl$messageformat$parser$$ = __webpack_require__(666);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(300);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(669), src$en$$ = __webpack_require__(670);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(678)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(812);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(299);
var diff_1 = __webpack_require__(675);
var es5_1 = __webpack_require__(677);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(674);
var en_1 = __webpack_require__(676);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 679 */,
/* 680 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 681 */,
/* 682 */,
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * [js-sha1]{@link https://github.com/emn178/js-sha1}
 *
 * @version 0.6.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
/*jslint bitwise: true */
(function() {
  'use strict';

  var root = typeof window === 'object' ? window : {};
  var NODE_JS = !root.JS_SHA1_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  }
  var COMMON_JS = !root.JS_SHA1_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD = "function" === 'function' && __webpack_require__(810);
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  var createOutputMethod = function (outputType) {
    return function (message) {
      return new Sha1(true).update(message)[outputType]();
    };
  };

  var createMethod = function () {
    var method = createOutputMethod('hex');
    if (NODE_JS) {
      method = nodeWrap(method);
    }
    method.create = function () {
      return new Sha1();
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type);
    }
    return method;
  };

  var nodeWrap = function (method) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash('sha1').update(message, 'utf8').digest('hex');
      } else if (message.constructor === ArrayBuffer) {
        message = new Uint8Array(message);
      } else if (message.length === undefined) {
        return method(message);
      }
      return crypto.createHash('sha1').update(new Buffer(message)).digest('hex');
    };
    return nodeMethod;
  };

  function Sha1(sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    this.h0 = 0x67452301;
    this.h1 = 0xEFCDAB89;
    this.h2 = 0x98BADCFE;
    this.h3 = 0x10325476;
    this.h4 = 0xC3D2E1F0;

    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
  }

  Sha1.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString = typeof(message) !== 'string';
    if (notString && message.constructor === root.ArrayBuffer) {
      message = new Uint8Array(message);
    }
    var code, index = 0, i, length = message.length || 0, blocks = this.blocks;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if(notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Sha1.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
  };

  Sha1.prototype.hash = function () {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4;
    var f, j, t, blocks = this.blocks;

    for(j = 16; j < 80; ++j) {
      t = blocks[j - 3] ^ blocks[j - 8] ^ blocks[j - 14] ^ blocks[j - 16];
      blocks[j] =  (t << 1) | (t >>> 31);
    }

    for(j = 0; j < 20; j += 5) {
      f = (b & c) | ((~b) & d);
      t = (a << 5) | (a >>> 27);
      e = t + f + e + 1518500249 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = (a & b) | ((~a) & c);
      t = (e << 5) | (e >>> 27);
      d = t + f + d + 1518500249 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = (e & a) | ((~e) & b);
      t = (d << 5) | (d >>> 27);
      c = t + f + c + 1518500249 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = (d & e) | ((~d) & a);
      t = (c << 5) | (c >>> 27);
      b = t + f + b + 1518500249 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = (c & d) | ((~c) & e);
      t = (b << 5) | (b >>> 27);
      a = t + f + a + 1518500249 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    for(; j < 40; j += 5) {
      f = b ^ c ^ d;
      t = (a << 5) | (a >>> 27);
      e = t + f + e + 1859775393 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = a ^ b ^ c;
      t = (e << 5) | (e >>> 27);
      d = t + f + d + 1859775393 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = e ^ a ^ b;
      t = (d << 5) | (d >>> 27);
      c = t + f + c + 1859775393 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = d ^ e ^ a;
      t = (c << 5) | (c >>> 27);
      b = t + f + b + 1859775393 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = c ^ d ^ e;
      t = (b << 5) | (b >>> 27);
      a = t + f + a + 1859775393 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    for(; j < 60; j += 5) {
      f = (b & c) | (b & d) | (c & d);
      t = (a << 5) | (a >>> 27);
      e = t + f + e - 1894007588 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = (a & b) | (a & c) | (b & c);
      t = (e << 5) | (e >>> 27);
      d = t + f + d - 1894007588 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = (e & a) | (e & b) | (a & b);
      t = (d << 5) | (d >>> 27);
      c = t + f + c - 1894007588 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = (d & e) | (d & a) | (e & a);
      t = (c << 5) | (c >>> 27);
      b = t + f + b - 1894007588 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = (c & d) | (c & e) | (d & e);
      t = (b << 5) | (b >>> 27);
      a = t + f + a - 1894007588 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    for(; j < 80; j += 5) {
      f = b ^ c ^ d;
      t = (a << 5) | (a >>> 27);
      e = t + f + e - 899497514 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = a ^ b ^ c;
      t = (e << 5) | (e >>> 27);
      d = t + f + d - 899497514 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = e ^ a ^ b;
      t = (d << 5) | (d >>> 27);
      c = t + f + c - 899497514 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = d ^ e ^ a;
      t = (c << 5) | (c >>> 27);
      b = t + f + b - 899497514 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = c ^ d ^ e;
      t = (b << 5) | (b >>> 27);
      a = t + f + a - 899497514 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
  };

  Sha1.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;

    return HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
           HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
           HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
           HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
           HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
           HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
           HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
           HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
           HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
           HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
           HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
           HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
           HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F] +
           HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
           HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
           HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
           HEX_CHARS[(h4 >> 28) & 0x0F] + HEX_CHARS[(h4 >> 24) & 0x0F] +
           HEX_CHARS[(h4 >> 20) & 0x0F] + HEX_CHARS[(h4 >> 16) & 0x0F] +
           HEX_CHARS[(h4 >> 12) & 0x0F] + HEX_CHARS[(h4 >> 8) & 0x0F] +
           HEX_CHARS[(h4 >> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F];
  };

  Sha1.prototype.toString = Sha1.prototype.hex;

  Sha1.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;

    return [
      (h0 >> 24) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 8) & 0xFF, h0 & 0xFF,
      (h1 >> 24) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 8) & 0xFF, h1 & 0xFF,
      (h2 >> 24) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 8) & 0xFF, h2 & 0xFF,
      (h3 >> 24) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 8) & 0xFF, h3 & 0xFF,
      (h4 >> 24) & 0xFF, (h4 >> 16) & 0xFF, (h4 >> 8) & 0xFF, h4 & 0xFF
    ];
  };

  Sha1.prototype.array = Sha1.prototype.digest;

  Sha1.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(20);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    return buffer;
  };

  var exports = createMethod();

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha1 = exports;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return exports;
      }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148), __webpack_require__(116)))

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// polyfill
Object.setPrototypeOf = Object.setPrototypeOf || function (obj, proto) {
  // eslint-disable-next-line
  obj.__proto__ = proto;
  return obj;
};

/**
 * Miment 对象
 */
function Miment() {
  // 兼容苹果系统不识别 2018-01-01 的问题
  if (typeof arguments[0] === 'string') arguments[0] = arguments[0].replace(/-/g, '/');
  // bind 属于 Function.prototype
  // 接收参数形如 object, param1, params2...
  var dateInst = new (Function.prototype.bind.apply(Date, [Date].concat(Array.prototype.slice.call(arguments))))();
  // 更改原型指向，否则无法调用 Miment 原型上的方法
  // ES6 方案中，这里就是 [[prototype]] 隐式原型对象，在没有标准以前就是 __proto__
  Object.setPrototypeOf(dateInst, Miment.prototype);
  // 原型重新指回 Date
  Object.setPrototypeOf(Miment.prototype, Date.prototype);
  return dateInst;
}

// 转换成星期的数组
var weekArray = ['日', '一', '二', '三', '四', '五', '六'];

// 格式化时间
function format() {
  var formatter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD hh:mm:ss';
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var year = void 0,
      month = void 0,
      day = void 0,
      hour = void 0,
      minute = void 0,
      second = void 0,
      weekDay = void 0,
      millisecond = void 0;

  if (distance) {
    var dtBegin = void 0,
        dtEnd = void 0;
    if (this.__distance_begin__ > this.__distance_end__) {
      dtBegin = Miment(this.__distance_begin__);
      dtEnd = Miment(this.__distance_end__);
    } else {
      dtBegin = Miment(this.__distance_end__);
      dtEnd = Miment(this.__distance_begin__);
    }
    // 时间差的格式化
    year = dtBegin.getFullYear() - dtEnd.getFullYear();
    month = dtBegin.getMonth() - dtEnd.getMonth();
    day = dtBegin.getDate() - dtEnd.getDate();
    hour = dtBegin.getHours() - dtEnd.getHours();
    minute = dtBegin.getMinutes() - dtEnd.getMinutes();
    second = dtBegin.getSeconds() - dtEnd.getSeconds();
    weekDay = Math.abs(dtBegin.getDay() - dtEnd.getDay());
    millisecond = Math.abs(dtBegin.getMilliseconds() - dtEnd.getMilliseconds());
    if (millisecond < 0) {
      millisecond += 1000;
      second--;
    }
    if (second < 0) {
      second += 60;
      minute--;
    }
    if (minute < 0) {
      minute += 60;
      hour--;
    }
    if (hour < 0) {
      hour += 24;
      day--;
    }
    if (day < 0) {
      day += dtEnd.daysInMonth();
      month--;
    }
    if (month < 0) {
      month += 12;
      year--;
    }
  } else {
    // 普通的格式化
    year = this.getFullYear();
    month = this.getMonth() + 1;
    day = this.getDate();
    hour = this.getHours();
    minute = this.getMinutes();
    second = this.getSeconds();
    weekDay = this.getDay();
    millisecond = this.getMilliseconds();
  }
  // 替换并返回格式化后的值
  formatter = formatter.replace('YYYY', year).replace('MM', String(month)[1] ? month : '0' + month).replace('DD', String(day)[1] ? day : '0' + day).replace('hh', String(hour)[1] ? hour : '0' + hour).replace('mm', String(minute)[1] ? minute : '0' + minute).replace('ss', String(second)[1] ? second : '0' + second).replace('SSS', millisecond).replace('ww', weekDay);
  formatter = distance ? formatter.replace('WW', weekDay) : formatter.replace('WW', weekArray[weekDay]);
  return formatter;
}

// 将时间转换为 JSON 对象
function json() {
  var year = this.getFullYear();
  var month = this.getMonth() + 1;
  var date = this.getDate();

  var hour = this.getHours();
  var minute = this.getMinutes();
  var second = this.getSeconds();
  var day = this.getDay();
  var millisecond = this.getMilliseconds();
  return {
    year: year,
    month: month,
    date: date,
    hour: hour,
    minute: minute,
    second: second,
    day: day,
    millisecond: millisecond
  };
}

// 获取
function _get(unit) {
  switch (unit) {
    case 'YYYY':
      return this.getFullYear();
    case 'MM':
      return this.getMonth() + 1;
    case 'DD':
      return this.getDate();
    case 'hh':
      return this.getHours();
    case 'mm':
      return this.getMinutes();
    case 'ss':
      return this.getSeconds();
    case 'ww':
    case 'WW':
      return this.getDay();
    case 'SSS':
      return this.getMilliseconds();
  }
  return '00';
}

function get(unit) {
  var res = String(_get.call(this, unit));
  return res[1] || unit == 'SSS' || unit == 'millisecond' ? res : '0' + res;
}

// 转换为时间戳
function stamp() {
  return this.valueOf();
}

// 计算2个时间的毫秒差
function diff(dt1, dt2) {
  if (dt2) {
    return Miment(dt1).valueOf() - Miment(dt2).valueOf();
  } else {
    return this.valueOf() - Miment(dt1).valueOf();
  }
}

// 获取当前月的天数
function daysInMonth() {
  var year = this.getFullYear();
  var month = this.getMonth() + 1;
  var date = Miment(year, month, 0);
  return date.getDate();
}

// 判断当前时间是否早于 参数里的时间
function isBefore(dt) {
  return this.valueOf() < Miment(dt).valueOf();
}

// 判断当前时间是否晚于 参数里的时间
function isAfter(dt) {
  return this.valueOf() > Miment(dt).valueOf();
}

// 判断当前时间是否在 参数里的2个时间之间
function isBetween(dt1, dt2) {
  dt1 = Miment(dt1).valueOf();
  dt2 = Miment(dt2).valueOf();
  var dt = this.valueOf();
  return dt1 > dt && dt2 < dt || dt1 < dt && dt2 > dt;
}

// 内部方法 计算时间
function _calculateTime(amount, unit, isSet) {
  switch (unit) {
    case 'YY':
    case 'YYYY':
      amount = isSet ? amount : this.getFullYear() + amount;
      this.setFullYear(amount);
      break;
    case 'MM':
      amount = isSet ? amount - 1 : this.getMonth() + amount;
      this.setMonth(amount);
      break;
    case 'DD':
      amount = isSet ? amount : this.getDate() + amount;
      this.setDate(amount);
      break;
    case 'hh':
      amount = isSet ? amount : this.getHours() + amount;
      this.setHours(amount);
      break;
    case 'mm':
      amount = isSet ? amount : this.getMinutes() + amount;
      this.setMinutes(amount);
      break;
    case 'ss':
      amount = isSet ? amount : this.getSeconds() + amount;
      this.setSeconds(amount);
      break;
    case 'SSS':
      amount = isSet ? amount : this.getMilliseconds() + amount;
      this.setMilliseconds(amount);
      break;
    case 'ww':
    case 'WW':
      if (isSet) {
        this.setMonth(0);
        this.setDate(1);
        this.setDate(amount * 7);
        firstDayOfWeek.call(this);
      } else {
        this.setDate(this.getDate() + amount * 7);
      }
      break;
  }
}

// 增加或减少时间
function add(amount, unit) {
  if (!amount) amount = 0;
  _calculateTime.call(this, amount, unit);
  return this;
}

// 增加或减少时间
function sub(amount, unit) {
  if (!amount) amount = 0;
  _calculateTime.call(this, -amount, unit);
  return this;
}
// 设置时间
function set(amount, unit) {
  if (!amount) amount = 0;
  _calculateTime.call(this, amount, unit, true);
  return this;
}
// 计算两个时间距离
function distance(dt1, dt2) {
  var dtBegin = void 0,
      dtEnd = void 0;
  if (dt2) {
    dtBegin = Miment(dt1).valueOf();
    dtEnd = Miment(dt2).valueOf();
  } else {
    dtBegin = this.valueOf();
    dtEnd = Miment(dt1).valueOf();
  }
  var m = Miment(dtBegin - dtEnd);
  m.__distance_begin__ = dtBegin;
  m.__distance_end__ = dtEnd;
  return m;
}

// 获取每个月的第一天
function firstDay() {
  var year = this.getFullYear();
  var month = this.getMonth();
  return Miment(year, month, 1);
}

// 获取每个月的最后一天
function lastDay() {
  var year = this.getFullYear();
  var month = this.getMonth() + 1;
  return Miment(year, month, 0);
}

// 获取本周的第一天（周日）
function firstDayOfWeek() {
  this.setDate(this.getDate() - this.getDay());
  return this;
}

Miment.prototype.format = format;
Miment.prototype.stamp = stamp;
Miment.prototype.json = json;
Miment.prototype.get = get;
Miment.prototype.diff = diff;

Miment.prototype.isBefore = isBefore;
Miment.prototype.isAfter = isAfter;
Miment.prototype.isBetween = isBetween;

Miment.prototype.daysInMonth = daysInMonth;

Miment.prototype.add = add;
Miment.prototype.sub = sub;
Miment.prototype.set = set;
Miment.prototype.distance = distance;

Miment.prototype.firstDay = firstDay;
Miment.prototype.lastDay = lastDay;
Miment.prototype.firstDayOfWeek = firstDayOfWeek;

var miment = Miment;

module.exports = miment;
//# sourceMappingURL=miment.js.map


/***/ }),
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(306);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(307);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["b"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["d"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["e"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(329);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(785);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(784);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(337);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(630);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(632);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(634);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(633);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(23);

var _PropTypes = __webpack_require__(337);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(391);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(345);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(786);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_animate__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LazyRenderBox__ = __webpack_require__(803);








function noop() {}

var Dialog = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

    function Dialog() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).apply(this, arguments));

        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var footer = void 0;
            if (props.footer) {
                footer = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-footer', ref: function ref(el) {
                        return _this.footerRef = el;
                    } }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-header', ref: function ref(el) {
                        return _this.headerRef = el;
                    } }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-title' }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: prefixCls + '-close-x' }));
            }
            var transitionName = _this.getTransitionName();
            var dialogElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LazyRenderBox__["a" /* default */], { key: "dialog-element", role: "document", ref: function ref(el) {
                    return _this.dialogRef = el;
                }, style: props.style || {}, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-content' }, closer, header, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-body', style: props.bodyStyle, ref: function ref(el) {
                    return _this.bodyRef = el;
                } }, props.children), footer));
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_rc_animate__["a" /* default */], { key: "dialog", showProp: "visible", onAppear: _this.onAnimateAppear, onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, dialogElement);
        };
        _this.onAnimateAppear = function () {
            document.body.style.overflow = 'hidden';
        };
        _this.onAnimateLeave = function () {
            document.body.style.overflow = '';
            if (_this.wrapRef) {
                _this.wrapRef.style.display = 'none';
            }
            if (_this.props.onAnimateLeave) {
                _this.props.onAnimateLeave();
            }
            if (_this.props.afterClose) {
                _this.props.afterClose();
            }
        };
        _this.close = function (e) {
            if (_this.props.onClose) {
                _this.props.onClose(e);
            }
        };
        _this.onMaskClick = function (e) {
            if (e.target === e.currentTarget) {
                _this.close(e);
            }
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Dialog, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // fix: react@16 no dismissing animation
            document.body.style.overflow = '';
            if (this.wrapRef) {
                this.wrapRef.style.display = 'none';
            }
        }
    }, {
        key: 'getZIndexStyle',
        value: function getZIndexStyle() {
            var style = {};
            var props = this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        }
    }, {
        key: 'getWrapStyle',
        value: function getWrapStyle() {
            var wrapStyle = this.props.wrapStyle || {};
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getZIndexStyle(), wrapStyle);
        }
    }, {
        key: 'getMaskStyle',
        value: function getMaskStyle() {
            var maskStyle = this.props.maskStyle || {};
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getZIndexStyle(), maskStyle);
        }
    }, {
        key: 'getMaskTransitionName',
        value: function getMaskTransitionName() {
            var props = this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        }
    }, {
        key: 'getTransitionName',
        value: function getTransitionName() {
            var props = this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        }
    }, {
        key: 'getMaskElement',
        value: function getMaskElement() {
            var props = this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = this.getMaskTransitionName();
                maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LazyRenderBox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: this.getMaskStyle(), key: "mask-element", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_rc_animate__["a" /* default */], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props;
            var prefixCls = props.prefixCls,
                maskClosable = props.maskClosable;

            var style = this.getWrapStyle();
            if (props.visible) {
                style.display = null;
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", null, this.getMaskElement(), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: function ref(el) {
                    return _this2.wrapRef = el;
                }, onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title, style: style }, props.wrapProps), this.getDialogElement()));
        }
    }]);

    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

Dialog.defaultProps = {
    afterClose: noop,
    className: '',
    mask: true,
    visible: false,
    closable: true,
    maskClosable: true,
    prefixCls: 'rmc-dialog',
    onClose: noop
};

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







var LazyRenderBox = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LazyRenderBox, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return !!nextProps.hiddenClassName || !!nextProps.visible;
        }
    }, {
        key: "render",
        value: function render() {
            var className = this.props.className;
            if (!!this.props.hiddenClassName && !this.props.visible) {
                className += " " + this.props.hiddenClassName;
            }
            var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
            delete props.hiddenClassName;
            delete props.visible;
            props.className = className;
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props));
        }
    }]);

    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);








var TouchFeedback = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TouchFeedback, _React$Component);

    function TouchFeedback() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TouchFeedback);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.triggerEvent('TouchStart', true, e);
        };
        _this.onTouchMove = function (e) {
            _this.triggerEvent('TouchMove', false, e);
        };
        _this.onTouchEnd = function (e) {
            _this.triggerEvent('TouchEnd', false, e);
        };
        _this.onTouchCancel = function (e) {
            _this.triggerEvent('TouchCancel', false, e);
        };
        _this.onMouseDown = function (e) {
            // pc simulate mobile
            _this.triggerEvent('MouseDown', true, e);
        };
        _this.onMouseUp = function (e) {
            _this.triggerEvent('MouseUp', false, e);
        };
        _this.onMouseLeave = function (e) {
            _this.triggerEvent('MouseLeave', false, e);
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TouchFeedback, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(type, isActive, ev) {
            var eventType = 'on' + type;
            var children = this.props.children;

            if (children.props[eventType]) {
                children.props[eventType](ev);
            }
            if (isActive !== this.state.active) {
                this.setState({
                    active: isActive
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                activeClassName = _props.activeClassName,
                activeStyle = _props.activeStyle;

            var events = disabled ? undefined : {
                onTouchStart: this.onTouchStart,
                onTouchMove: this.onTouchMove,
                onTouchEnd: this.onTouchEnd,
                onTouchCancel: this.onTouchCancel,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            var child = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle !== false) {
                    if (activeStyle) {
                        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeStyle);
                    }
                    className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, activeClassName);
                }
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className,
                    style: style }, events));
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, events);
        }
    }]);

    return TouchFeedback;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TouchFeedback);

TouchFeedback.defaultProps = {
    disabled: false
};

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Notice = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, '' + componentClass, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, componentClass + '-closable', props.closable), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Notice.propTypes = {
  duration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Notice);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notice__ = __webpack_require__(805);















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      _this.setState(function (previousState) {
        var notices = previousState.notices;
        if (!notices.filter(function (v) {
          return v.key === key;
        }).length) {
          return {
            notices: notices.concat(notice)
          };
        }
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var noticeNodes = this.state.notices.map(function (notice) {
        var onClose = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__Notice__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            prefixCls: props.prefixCls
          }, notice, {
            onClose: onClose
          }),
          notice.content
        );
      });
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["a" /* default */],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object
};
Notification.defaultProps = {
  prefixCls: 'rmc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['getContainer']);

  var div = void 0;
  if (getContainer) {
    div = getContainer();
  } else {
    div = document.createElement('div');
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },

      component: notification,
      destroy: function destroy() {
        __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unmountComponentAtNode(div);
        if (!getContainer) {
          document.body.removeChild(div);
        }
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Notification, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { ref: ref })), div);
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(806);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 808 */,
/* 809 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 810 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 811 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 812 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 813 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 814 */,
/* 815 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(809);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/home_icon_null_data.png";

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAYAAACHD21cAAAAAXNSR0IArs4c6QAAAMFJREFUOBGd1DsOwyAMANAAuU+XTlG3nqDq1hkOBYK1W9UTdM3WE1VAcaRETcLHrgeMLJ7wYLlzzh2MMUNHDB5C6GOMT2vtmWK5UuqdwNV7f6dgNv+itT6l+0MIcZNSvuZ6KS8QHlDwClLwDmJxFmJwEbZwFdZwE5YwCuYwGv5ixtiFQ+Gf6LFoM1UjqtUNmua4CXMIuqzCEqrCGirCFspCDNpBLFpBClogFQHkaa8eU0YvKUAQMHIfGNq02capgjy+wyJ/TEovuXwAAAAASUVORK5CYII="

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAx1JREFUWAntl8trU0EUxvM2ARUVFVNQUMH2D9BFd0VsY9ok7gRRcVeRig8UdeHOXREUX+g/0FLUTUnaBBfxAbbg0o0KCrZSCy50YYykefg7mhvatPfOTAjZeC+czuN835lvzj2ZO/V43MfNgJsBNwP/dwa8rW4/n89vLRQKR+GnsG4sWqvVfnq93i/Yc/pPE4nEq1bjWzxjgQgLIOwKAa4iYqMVaK0WoXns/NDQ0Nu1/DpzRgKz2eyWpaWlxwQ+KMFZfJJmnHYGW4xEIhuKxWI3wlPVanUY3ybsF3YqmUw+oTV+tAVOTU2tq1QqeVboRcxnv99/LB6Pz9itmE6nN+O7i9jjtFU4KV55xg5vN++zczTPk5GbzPVi730+3wEnccJFzHfsBNhRhrLOWC6X2yk+k0dLIIF7yMQZsvCbBVODg4PfdBcBew1eVuqV8rihy7NwWgIJfAGCn4XuUPAfLLJOC6cWDAYvgq0g8iSb3a7DszBKgQSVOpWjxEP/kUU0aWOx2DvwLzAfm02acJUCKfYuhEXJxEdq6pNJ8OVYSuOZjIm1f/m8qq8UGAgEuupB5lXBFP458bPRqAK3wq0UuALdhgEZNFpTCS6Xywt1XcZHRNN+dsmYDC42zTsOlQKpuwWCfmXne6nHPY7RHJyco4fq7lkH2CqXUiDiarDkkya7P70qgsaEnKPA+uCXQ6FQVoPSgCgFCpJz7DaNnGPnMpnMvgZbowPHy9FyC6if/vjAwIBVMhrsf58gJbB+jj1kgTCvapLv8jYlqQ5gQ6PwDjP8EQ6Hr+vyLJxWBgXM5eASjVwOuhH5Znp6Wr7Ltg+vdTc1m0HcZQHxeif6+/vnbAk2Du3bjPDXum5xAI8hYhYBi9TX+lKp1MOt5wjws1gEK2EhTESO8KN7IH3dx0igBDW8sL7moB9GcB9Zvyd8U5HGAmUReZqu/PIr3UEmiwiYp31JO0G2Gld+anGkFZEtC/yr0vBPKyI7KlD2s1wk9Zvk+pZ22qf2r9gpiIkPQfelDrECPMd/ukzith1LnXY8OW3fhBvQzYCbATcDHcjAH5GaNp244Qv5AAAAAElFTkSuQmCC"

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQFJREFUOBFjYBgFjKAgWLhwofTfv3/Zk5KS7hEbJDNnzmRlYmIyZgJpYGRk/PDnz5+W+fPnSxBjwP///0EWT/z3798vsAtAmoCuEP758+cUoGRGenr6R3wGAW1vZ2Zm3pOSkrIX7AKQ4vj4+LcsLCxlQNdMBbqEA5cBs2bNKgHKnQNpBqmBGwDiAMPgMdCQtt+/f09ZtWoVM0gMGQA1JwBd+BXowtUwcRQDQIJAQ64BnTf3w4cPvTBFIBqo2QeoWRaoeTqyOE420J/es2fPrgcpmDNnjjXQgD5siuGBiE0SaEAc0FZtIBZKS0tLB4bPP2zq8IoBbffdtm0bO15FQ1sSACZpZjVjdEu9AAAAAElFTkSuQmCC"

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAPZJREFUOBFjYBgFBENg1qxZftu2bWPHpZAJlwRIfObMmfH///+3efz48RQgjVUtVkGoZm9GRkb59PT0MmZm5gWzZ8/uwWcZitzcuXMtgU6fgCwI5PsAXVSLLAZiY7hg3rx5Wn///k0WEBAoRlaclpa2Beiix0BDMpHFUQwAapb98+dPFSsra05YWNhfZIUgNtCQBUBDuIGGhMLk4AYsXLhQGKi5CxhY2YmJiT9gCtBpoCGgsDCaM2eOM0iOEUQsWrSI+8ePH7OBNhcBNb8AieEDQEsYgWEyFahmDtgFQAEBoNOqidEMMhio9j+QymdiYmID8Yc4AAB+0VqZr6W4WwAAAABJRU5ErkJggg=="

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/dialog-box-icon-icon-succeed.png";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/lntegral_icon_fail.png";

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAAbJJREFUOBGdk81KQlEQgO/1plhaiCvd9BRuIhcZiGWCQRBWYkiLnqmikiJBohahkhBIdZMin6JFuBGLvFGU2DfSlTK1ckDn78w3c+aoms1mrxRFufN4PAmfz/eGPbAUi8Wher2+CWDcwtd9s9mMVSqVw3K5bB2UCkMzDOOA+qSqqoYFiWMUSESBZ6Trf+ECzeVy++hFWEVuv6QKBJidbickgrhHTqczFggE3v/SgBoL0D30CufPvV5vmJU+yyoUIC9utztKtzPcBZqkOahJrp8IlDdKCZTaS5vNNidQqWlNbBaXSqXharWaxZ/mk4lEIlLQMPNftUCZdAe9SlznlrMMWDfPfANLkAccYdc5CqZw08ATnXByKpNuk0+SK7lcrhm/3/+E35bWKtoehlzFarVGKLjAXWYquWr7nECJbZFL8rnuBiWutAvEMSUUChnAw/g6oHg+n98V+Cd0A71G4xtN00Kdk5qMH6swE6L5tTh5yFNAk4BShF6x19G3drs9iDxid5W+YKnQdX20VqsVMCfEp0HZ4XAEeagH8XvJr2ApZBVjjUbjGKj8M+d50FovoBn/AKCh1ZG8buKZAAAAAElFTkSuQmCC"

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAAaZJREFUOBGNkltLAmEQhtutyFqLLqXfIRSUgnag1ItuSjphBVJ/qYsyMrGIDsa6aTd7swiRP8QbzUIhtN3t+UTDytMH4+zOzPvMtzNKQwMcTdOmTNO8kyRplPL1UCj01k8m9yswDGMSaIa6Rdu2vfhnXden++mkXgUAnNVqNQNwntue4z+pP8ZeHQ7HMue9m74rOJvNKvV6/QmYR5bli0AgcADETqfTJ8SiNHohvkL8oxO84yiaUE1AASQEFG9hdjAYPMKfkptlRFkxqoHA+Xx+gpuqCL0AkoAiAtoSN+FR3mPYXLlcznSC/xpFLpcbLxaLKgI/ds32dwCZPP87NJYZyxk+QtJwOp1rPp+v0ir8GQWLcpRKpUcSfmA3FO52gwoxOYuvOeQxji2wZE2MUOTEaYAFtFKppOi+ROxWUZRtun81Knr8CDhftY9PoPXUarW0GKWQSPz5xyzLeiCxSsE90M1BoO390A4zljh+C4bucrlCI0Avm9AUgbDb7e5703Zo43bsAcaeqqoyPlwoFJJiFDN0uQK6AbT+VzToOwxT7IX6GHDlGydx29pVO9yZAAAAAElFTkSuQmCC"

/***/ }),
/* 827 */,
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/coupon-icon-get.png";

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAA0JJREFUaAXtmEuIUlEYx8cXhmjRQltIMhJBMLQI3+bCzQwzgUwUQhMxkNtp0zaCiaCgXSHRamrRohfE1Ay4a4RE8VUwbSIIacKEKBpCwnz2/8ABERFjzrn3Lr4Dh3vPw+9+v/93nk5NcWIFWAFWgBVgBVgBVoAVYAVYAVaAFWAFtKNAPB43eL3epGyP9LI/MIn9QCBwsFKpbPZ6vSuT9N9PH+N+fizit8FgcLrdbhPsDOx9F2FznA1VI+z3+0OtVitPsDqd7j0c9Y1zVkSbasCYr0vdbvcNIByAfWoymU6Xy+UdEVDjbOjGNcpqA+wqonoD9rvI1wB6R9a3hu0qChyNRg/U6/WHgF2CI7uI7MVSqZQadkpmWTHgcDjsaDab64ANAeijwWBYLBQKn2TCjbJtGFUpus7n881gJd6C3ZPIm0ajcQGw30R/ZxJ70hctwM4jqlk4M40hfDsWiy3m8/nfkzgno4/UIY3FiQ4SdwHcwPMyFqcXMiD+x6aUIU3HRIvFkgToKpzZwRCeLRaLNKRVT8IjTMfETqfzDLDzoNvC4hTHfP2pOmnfAaFzmI6JgM0SLOZr0mazzWkJlpiFnaX7x8R12Dyk1+sTGMKP+qJq6iEswohsAmR0TNxGfq0pygFnhC1atVptw+l0/sFwXka+4HK53lar1drAtzTxKnzRwlZ0BmRPAG1GpFdwdFzTBGnfCeHAZNfj8ZzAg4b1cUCv2e32lVQq9Zfa1E5SgAkqEokcbjQatD3Nolg2m83ns9nsF7WBhS1awyCZTOaX2+1eQP09ZA8uDmVEfm64n9JlaREeBMG8TiDSD1BH2+Aq5vUtDPXeYB+l3hUBJhhcIsKAfol8BLAbVqt1OZ1O7yoFuvcdxYD70EcB/Ar5FMqfccY+h5vT9p4zSjylzeFRzuP09RWwEbQ9Rz6GO3IOkb80qq+sOkUjPAiBBew6yjeRMcJ19yHEVVwfW4N9ZLyrBkwwgD6Lx2NkK6Bz+OcynsvlqtQmKyk6pIchEFG6bIQBW0GEQ9i63g33EV1WFZhgAP0BsH5Ap1F0UJ3MpDowwQH6B6DpUEJ7NSdWgBVgBVgBVoAVYAVYAVaAFWAFWAFWQLYC/wDUcRhrRZWSOwAAAABJRU5ErkJggg=="

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAA0CAYAAACZ8ljPAAABI0lEQVRYR93YOwrCQBAG4NnkGh4nIKayECw8gxeytxAsLCQYiafRa2wiGyQY89jXP1M41Xbfzkwz/KooH6u60QciokQl+3yZXcybq9T1dn82RIsPoFOV7PJldpICjcOKqqKs1rqpz0SUfnXFhiqDFGW11U19lEBbUBLtQCm0B0qgA5AbHQU50UmQC50FOVAriEadQCTqDKJQLxCBeoOxaBAYgwaDoWgUGIJGg74oBPRBYaArCgVdUDhoQTcs4BSqiF7/Ac6cnfiR2m5c6EhtmNktDHTBYKArBgF9sGjQF4sCQ7BgMBQLAmMwbzAW8wIRmDOIwpxAJGYF0dgsyIFNglzYKMiJDUBurAdKYB0ohbWgeLj3k5eaT7AliW2H4gGtdAT9Bi0Qw0x4We2tAAAAAElFTkSuQmCC"

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bg-coupon-d.png";

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bg-coupon-n.png";

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bg-integral.png";

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bg-orde-list-1.png";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bg-today-gold-value.png";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bg-top-popover.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bg-voucher-n.png";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/circle-1.png";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/circle-2.png";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/circle-3.png";

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA3VJREFUWAnFmFtu00AUhmM3EpdQltD3LgCJuwQF0obSdhN9QIKX3BaR22uR2AQtFaRQQOK+CR7YAtCQSiTh/y2fMHYy9tie4JFGc/HM/J/PmTOexOl2u5XRaLRXKBROkHebzeYnlLmlVqt1DeJPkUtLS0sP3fF4/ASNFeRVx3GOOp3OTdRzSdQmA8RXkVfI5k4mk4HQoF5CfpEHJDWpTQaFZ+AWi8VddOQK2ev1boThyEQ2t1qtfoCvN/OCJBxi4KVqObKQiWwOGl5CsNzCwEM0zvtdBeyHE+RKvV5/L302yyi4Wq32jlquCLJDZ0kuJONslT5cYM9hbc9yAketKSAbfACLPUA1sCfpApuQCtwF6vppQG0Vjv1TF8solu12+zaKQ+yLc9KPyb9g4Qr3hfSlKefBYe3fWGuz0Wi8Da85F5CDFgGJo+Q6XpoBMbVcFBw5tIC2IdPAxQJGQeLNNxDdHzkmLqWF47qRFhRhHEFr+Ow8D+9JE0gdnOu6DIg3oqErjQA5OQ1kVjjqGgMmhbQBlxjQFNIWXCpATsIRdAfFQXhPor3uLeo4/fBRYrrnOF9NiVysTtRBckwYDl1bOISP1fmm9dSAFJgHqQr7h3BqOK6VCZAL6CBtwHH9wGWBHUkT9tYALv0Tnsc+Pgv3J21nsiDOxqu46fQhuqwR/okLxjoO5M+a57HdqS2ogRv6rhXhZb4Ax0pH0jIVoA4OLt0C4DYghgpIJsjELo6Cw+XhNcFwUN/Ft/sA1bMKaCp3JwLUwQFiGz/4XykwWkhYuIwz8Ys6NqpuDIjj5Aoikz+q1YCgK2fgRFBnySSQRoBp4GxBxgZJFjhC+vtyJnDoDa4tL6IrIy2YFU4VxZ9C99DeRw4ETpy7tRa0CUdQP4hmLIlH/ShLzgX0J4S/EJEBQYi4NA8Srr6IeVrIGRcLnD9RNIc4hHewnxjFmROiu4xz8hkWmrobrv4BjTI+i19VgYAFcc5dxkNeNvlWkqzCcVG+KF8YVXrFS9QE9JHPIN3/rlt8wAGLhpsqo2JiSc/FecAJaBykgwGXYLXj/2k5gZOSkNDfRz4jfdyTuKqt8S/gPRUOD05tBoQIRpXck2DYobaMIxOuat5/1OofOaccaCtaRcykxBHE4AxAYl7JBfUj5O/I32C5+xxosuAixlCbDGQhEzQe/wWS29M0BTLbxAAAAABJRU5ErkJggg=="

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/common_btn_check_s.png";

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAA2lJREFUWAnNmMFKG0EYx2eTSBRF0oM5CKkavATUB7DtMYfSXnrpW0gPBR9C6EF8i156UXpIb7Z5gBjIJUS0YCEeGoISxdTt/zfuLGsabUzTrB9sZjazM//fft/M7nzrmQdapVJ54nneK3Ur6njq+/68zucZRvUT1U9UPdZR0vne2traT9oGNW/QCw8ODt7o2g2JvFCZGrBfV4D7unZndXX10yB9/gpUrVafCWJLxzoDJhIJf3p62pudnTXpdNpMTEyYVOqGr9vtmqurK3N5eWna7bY5Pz/3r6+vrYbAyjo2V1ZWvt0HdieQAJKC+aDyHQNI2M9ms14mkwHqvjHDNsGYVqtlms2mL1AHti2o94L7FV4YqfQFOjw8zJydnX0UTBGPzM3NeTqMBol0Hbyqcczp6SmH9ZjGKc3MzLxdWlpq9Y7yh0IAU9YgBbyysLDgTU1N9fYb6rzT6ZijoyPrLUHVBLXeC3XL94JIBp4pALG8vDwyGO7AjTk5OcmKLARayejd3QIK5kwRzywuLoaTNdrhX+ssAHnFzklBFdGMjhmGjNWkSfiVOZPP50fqmaigqxO+RqNh55Q0n7vVF3pItFtczAQe1Zxx4v1KNNCizWlTt0A89PTnOqFiNY3L0EIT7eDBewMkgA0geM4Mu7SHuQm00Az6WgaPd5P+aCqOyUKh4KkcZuyh+/DwrNVqzCUelNmEKF+rkuJ1MG4Y7gJNtGGABXfw1ja8m+KyiHYRoBwgvCjjsoh2LqEZbvcymu1x8dgdA+KwMIcskNtCxEHltGEhZH4cEHdo+oTsB41sruIypw0LIWMPbHd6cQGxy8RgIWTHnLDtjMsi2scAfQGEPXBcFtEuMYd2BdINNuRjZ+LVgTYMYtlLkDcpdvtq8NiQj9vQRBsGWAgZtsMP2YGM6lgMLTQDMctggUjiRFgmVSE7GJehhSbaLpF0HmLJbQJCqsL28n8bGmih47Sph0DsadWwTTxJVdzDiotGbYyNRjB3SBzDbNbt1qymYkq2+lllkVSF7MC9Z0YFBYxyP3NxcYFnSoJ5qTLMYkMPIUgDGaXKGh3q9fpIw0eYGDOAIVFEK4SxDP3u/FGl0g4wCN/j+NjgoChJIAUX/+eYKBT1R/PBqhcs+KRHpkJykJP3+n3S+642PuntPvST3m+zDRpgKo6JzQAAAABJRU5ErkJggg=="

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/common_btn_s.png";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/common_icon_down.png";

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAKpJREFUSA1jbLj6tc5QmKOWn5WJhYEO4OPvf3/Ov/3RzLjxxd/fc6+/Z7n07icdrGVg0BNiZ0jWFPzDAvIpyNL7QVJ0sVhx3TMGkJ1MdLENiyWjFmMJFNoIjQY1bcIVi6mjQY0lUGgjNBrUtAlXLKaOBjWWQKGN0GhQ0yZcsZg6GtRYAoU2QqNBTZtwxWIqC6gvA+xWsIBa+PQAoC4MyE4WUAcK2Jehe6cNAF1PMSJUc0b6AAAAAElFTkSuQmCC"

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAMpJREFUSA3N1L0RQiEMAOCHW9k5haV3FtBbuoBD8B6thZWtnRu4EAcmAwTy550pIckH3JFlISLn/FnX9UBsi5d3VEUI4dJ7f3hhgYJwHRHEAD3GGN+j3NneEMJiL2wKeWEsyANjQ1ZMBFkwMaTFVJAGU0NSzARJMHIEYRNO4MSAyXFrrd1H+WaolLIH5ArYeQSZng6RWusTkFNK6fUTSILgAVQ3kiIqSIOIIS0igiwIG7IiLMgDmUJeyBDyRBAiRxD8+I3z47HJX8UXyyC80i76hH8AAAAASUVORK5CYII="

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAiBJREFUSA1j3Pfuv/ffvwzzWZkYRBnoAH7/Y3jNzMyQyLj79f9Xk6+8Fb307icdrGVg0BNiZ8jVEX7NBPIpvSwF+QxkF8hOJrp4E4sloxZjCRTaCNE0qOW4mRmSVbixupxmFstwMTOstRdhuPj+N/0sZgd6Z5alEMPkG18Yzrz9RT+Lu4wFGK5++M2w6N5XrJaCBFlwypApkQSMUyUeFobgg2/wmkBVi81F2Bgy1XgY/Pe/Yfj1D6+9DFRLXBKcTAyTzQQZ8k6/Z3j2/S9+W4GyVLGYDZSYLIQYZt36wnD8NfbEhO4SrBaLc2AVRtcL57cYCDA8+PqXYc4d3IkJrhjKwGqDBj8rQ7+JAAMzI7pyTH60IheDriArQ/nZD5iSeESwWnz45U8GXmDdNQeYFznw2G4kxMpQqMXLkHb8HcP3v//xWIMphdViUIIEGfb25z+GpTbCDHysmF4XBUbHNHMhhqIzHxgefyOcmNCtxmoxSBHI8hJg8IFKntXAok8MKd5ZgO6YAbR0MbCAOAQMHXIATothhrVf+cSw7uF3hrUOIgwKwEIfBOr1+Rne/PzLMPXmF5gykmmiCpCZt78wvP31l2EV0OcTrn9msBRlBxYSr0m2DFkDURaDNKwB+pqNiZEhS52HwWffa4avf0hLTMiWgthEWwxSvOz+NzAGsSkFBOOYUgtw6R+1GFfIUF2cCdSXAXUr6AVAdoHsZByoThsAd++e4v+A8bgAAAAASUVORK5CYII="

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAkVJREFUSA1j/PP6kDcT4/85jIzMEgx0AP///33x7z9jCuO/Nwef/3u5a+/fV4fv0MFeBmYxWxUmcTdnJpBP6WUpyGMgu0B2MtHDl9jsGLUYW6jQRIymQc3IryvIqlFhgc3lNLOYkU9LgEWvO/nfx4tP6WcxCzcLi3ZzBMOrXQf/Pt/+mG4Ws+r3+jH8ePH8982+09gsBYlRPaiZ1cssGFhFRP5eLt+Cy1KqW8ws5SPPJOZk8/dazYp/f778pYvFTLyqvMzKOSH/7k1b8+/TjU/4LKWej1m4mFl02iP+vjpw7O/TTQ8IWYrTYkYeFV5iNMPUsOp2ev//9fbd35sdx2FihGisiYtJwEic1XhGIBMzKyMhA5hVC0wYOaSlfl8q20RILbI8Vov/Pl17l4GRnYPZaHYkExsvC7IGZDazpJsMs4Snw5/rdSsYfn/8jSxHiI3VYob/f///PpuyguHP129Ay+MYOMQ40A1i5FbkYVIuCPt7f876fx+ufECXJ8THbjFIF8jy89kb/n198JjNeGYiE68yD9wwZnYmFt32sH9vT5z++2T1Xbg4CQzcFkMN+Xu5Yvf/d6cvsuhPTGYUNBACCbPqdngw/Pny9e/1psMk2IWiFGf8Iav6fb3tGLNy1jdWnY7Evy+2HWDkVlL8dSZxNrIaUtlEWQwy9O/daReYmNiYgQ01219nUmcy/Hz3i1TLkNUTbTFI0+/bE84ygDAVAME4poIdWI0YtRhrsNBCkAnUlwF1K2hhODYzQXaB7GQcqE4bAMqlyrIEwitsAAAAAElFTkSuQmCC"

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/common_icon_up.png";

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/goods-details-icon-home.png";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/goods-details-icon-share.png";

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/goods-details-match-light.png";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/home_icon_card_add_n@2x.png";

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA3RJREFUaAXVmr+LE0EUx+dtYrKcnDaHVwViKdgpGDhMzkbQxkoruTL/gFeKhVjqP5BSrLSyUbDxEjiIoJ1gaeCqk1TKheyaZHzf2d3cZpM12d+7A7mbzM68+XxnZmd23wuJGJL8vK+PS9NbJOkmm6vzp6YJsS2FvAjzJOhsJsQfzp7wZyBJftWnpS9052iM61EShW0s+/cuGeNRSyPZYhsNhtWD2GJRgO/PJHWr+laXGh9/B2nv1A0sQP7k0R5MH5NGByTklmMoyn8paCRn8rVeL72hq8FmZWMB8u3Dkrl7+oBB20LInSjA/m1pyNc6ldPd9/To3dS/3vmVjQTI47tXzL/GK0Gza+dNE8xJ7UflQvUJ7X36ta6XtQKM4/3rYjJ7mdyo+yHybJS1w+re0Xe/GijnzcI/jbvN+wzfSR8eTLxMuW/F4I/IO5xPQkO+SZ/7XE61mG/yZ3qr92FVpysF2MsGI19Z1Sj9MjJ5ObVXLaelJYQb1l7zOYHHcPFA8n2o2DyjtyBAbZXYbRLbJj29B/oqd7ATgtHdbEGA2ufT2irdFJvmmc0+i+Yt5gJwwnIpH1K5T22bVYHOBeDxIJ9LxzugcsditcqVADyY4dnGWzWv38EKZvApAXiqjOvBzC260uzdwMddFkcerGCGLSXAfiSOw3ZqNhxmDS8j3GsjtZ7j66gBdg1vUkFfRuJjCG8JzGDnmVCvgeEtZdgS7LgH6hkyRO26DgG1qFYybF/TWMF2hgCRugY7Gd3bfbZSDmMprj3e7DW/hemf20ywhAqdynA68ZZ0OYyKdSPnzNC6emH6Rhuwa7bHLKyNTNuBHUsI7r6iphMIGBSVHuwaHK1FFQB2TXmJLUdroXTAOQx2zXZx4ywoWuqDXZ0DcHEXjd5hVicw/POGcTaK+60sqf0f7ngwY9DVDCC4AP98UWYBrE5ARAkAOIILfLbBP5/zREOL1cKcC7AjI+wPzX3quKM4cwHARmREcHAhtxIQ+ACjKy15p1U0ZjLm+yGpMJKr90BZGlbK+oE3arMwA7CnKnBkhHNmIPuJVlbu9UMvPLpcEoBC+OGlEC+Qz0MCy6rYANiWlpAb2IrSiKfKP+++kFqeTMD7RWeA8V8BqJD3IN9aARBR6DArBCAVOtBtSbD+FvanBm4RyBf2xx5eIUoMe4mz+rnNP0zEgq77HqLBAAAAAElFTkSuQmCC"

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/home_icon_card_subtract_n@2x.png";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/home_icon_card_subtract_p@2x.png";

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAeZJREFUWAnt179PwkAUB3BbKOEf0MFdHfA/cBFmdgcTEmDopv+Dm7NbgzRhdHYGB/8E3Z0cdDfE8sPvIza5NOXovfdczHWgR3u8+/AOru/29vzhM+Az4DPwpxkIbNGTJGmt1+u7KIouBoPBp60v516apkdZliW1Wu1yOBy+l8UIyy7m1wiHdnuxWMzG4/F+fl3j/It7whjny+XyZltMK5AyFwTBK4K0NJEG7hCwGeJfbQNap5g+RJkjHCEJW6/X25LpLuIwRDeO4y82UBPpiqOxd2Yw/2bSTHJwTkDqzEVycc5ADlKCYwFdkFIcG1gFqYETAW1ILZwYWIYMwzBerVYPWDc3izD6WNc5imE7Ki8ztiCTyeRgPp9PaTE3+s3QFuEolgqQAo1GozM8U5+pjSNrNBrH/X7/bfNO8GJ9FleNS785mlbqj8fhN04RqpRHjQJDDCz+IVBgnAD4QtOtUWCIgEUcYF2aViA7Wkj2b7AMZ1YlNL2Y5imgp5IqiAXchQNqc2ggnYFVcVpIJ6ArTgNZGcjFmUhOZV4JKMVJkDuBWjgu0grUxnGQ1oWaNtVaVUmOozPtCpvNZiff0mKcW/O+2bYCacePIPf4gLgqMQeldq/X+6AtLJopztfF+/69z4DPwH/JwA/q3SocyCLBIQAAAABJRU5ErkJggg=="

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAMpJREFUSA3N1L0RQiEMAOCHW9k5haV3FtBbuoBD8B6thZWtnRu4EAcmAwTy550pIckH3JFlISLn/FnX9UBsi5d3VEUI4dJ7f3hhgYJwHRHEAD3GGN+j3NneEMJiL2wKeWEsyANjQ1ZMBFkwMaTFVJAGU0NSzARJMHIEYRNO4MSAyXFrrd1H+WaolLIH5ArYeQSZng6RWusTkFNK6fUTSILgAVQ3kiIqSIOIIS0igiwIG7IiLMgDmUJeyBDyRBAiRxD8+I3z47HJX8UXyyC80i76hH8AAAAASUVORK5CYII="

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAAQZJREFUKBWtUjESgjAQJNABT+AD1hbWtMCM/sJGf6CdT7DxFzoDtNQU1H7AJwBdwN1AnMgIlTdzyWV37ya5i2VNLM/zHX0CW8IEiqLwm6Z5EvM8bxWGYa15Wwfc27a99H0f0Bmb3KdimqZrCEqQziiQQohNkiQVz6oiBCRvcC0ip7CRG4RZlh0BrMmaRowcMYEXBlJKPsA3RUZcO46zsruuuy6IqPdHjZH7j1CgLXdcertUDG162LADRJ8J/EioqbGjKHoh4/xDoCBySsMTm4p+ldNeQlTFcbzBLtVkGEC/h3PXprCRGyZDhjPFXdhTZYz1nAl8/R7XdU+owDu/GA8pM+vcx30DXyNvfNbys9cAAAAASUVORK5CYII="

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAAR1JREFUKBWtkj9uwjAYxf05/BmSkaEDF2BmaBeqZo8Et2Bpb9BuvQEsnKFLkZKsadkYmLkARyCRkOq433PiyLUqJix98vN7P9vyHyG8luf5AuXZglyjKIqoLMsjvDAMJ3Ecn20urUBfVdW71nqMgnazbsU0TacM7DkMWkAR0X2SJAeMzYoMINxwWQiZ8dqsAbMse2FjitRt8JDBIz7hWCmFA0Qu5OhzEAQTWdf1+goEPmoZZ+4tJF2+Hz+F1vOrixFt5WAon0lQ9wL+BGRgJD18nYTUbz7QjTkDYy68P7tbEQnzAh3AAh4yeAYk+lBC9pa8jbKg0fCQWRBiMCsO/Jdwp01jbbx2+Of39EfylTc8oRptZ/3T/+yeFig/+gVrVmldZS3cHQAAAABJRU5ErkJggg=="

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAASlJREFUKBWtUTFOw0AQ3DtDhKy0dPlARJkiFZJpbUuk4Q008APoeAINvwDJdgsiDSlconwgBRKULsCOb9k5c8YYi4qVVjs3M7e3uiXqxfYxWCB7NKkuwc/BuHw1a3CjfT1VBw+F07UDqNWbuSLiCbLB32rbsVwezaiuV0zsQVakavK8+ejwPsfZdmQ+8chsb5wJgsXgoDljtXw5Z6YZiG6AgwZO8VMwqd7NWjqMuyaHZYRid09Pd8oPcy0PDZpgRoPG467+V1VJktwy8/FfDZVSd1riTEztBgYuFPDoMAw3cuNywGApaNaDkzztpWm6kvrjL8WUR1E0l1rbzQCI/1QS1YXlvrRmhVDiOM5lFvnTJoDBtWcHUH3fv5AOmHkD3NV+4SzLFsi+8AnlLna8ndib0AAAAABJRU5ErkJggg=="

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYCAYAAADpnJ2CAAABzElEQVRIS+2Wv0tbURTHv+fm3WoaExQsDro0DVUyVsHJutg/wkUcXKWDINWWtojaQvdMLYKLDiJdOhVB1EEQx2CmELUPNCgJDSbP93LfKe+JEVqevEeSZvFs954fH86P+4Os/fE5ti4WWBkavITIFsBbObrz2dPGp4LM3TGTISSF+zxd2DgDqiUIorl6oXS9PcIUHYAcmPcGXudhZT4B5iWEwKx8ufvFZ0L/mPkCOl5sONAlULXAAKeY6SQIlIiL8spa9w28gZ7DyiwDViEIq2ZLQtsLBHShZhFcztaCKH0TXD4BRftBssvdd3rO5RygdUBE4kBbD7h0BDZ0Dgz8OzXzcAr0qBtyeA0AuWqV+wp1vAot8Rqia9DdcyrDpQzqBx5MgCLPIIdW7rLOpqBO16H1v4GIJR+AwQbQbGVJ7d9piI4EVO5bs3sYh+h8AaVvgGJJ0OOnsM9+NG9oak0QYcCu1JZNm1KHQJE4tOczUPp32PmfLrQpQCv9HqRFEUpMg0Ltzj3jQlV+CzL5AdT2pLHn0O9MN+ymeQDeVqCFJd15VQVR6L4/jd8+3WfHlV8AsyLrYPKjXdHfwTZCjQjsGUO0KxHuXbx5Mf+j/AGssFPVy2BmQgAAAABJRU5ErkJggg=="

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/img-distribution-set-1.png";

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAAAGCAYAAABKDyn0AAAAwUlEQVRIS2NkIAL8L20M/f+fYRURSmmhZDVTT30YuQZXL7oXysA4QG5nZFjdGqOE1e2MhDz0P7dSlIGd48p/BgYxQmqpLc/IwPCK4ecPHcbJ7a/JMbty3m1RJlbmKwwD4HYGBoZX/37/1WlPUsXqdoIB/6+kEZTSQ8nxOKV6GBkZwhi761eTa071knurGP4PjNsZ/jOEtcYp4XQ73oAfLWLIjHI8RQzMRJwBP1rEkBnoBIoYggE/WsSQGfAEihiYqQByuFQHZowVogAAAABJRU5ErkJggg=="

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAA6BJREFUWAntmD1oFEEUx3MBkajRaJRoiEFSCEYEFRWriAiSVCKxExSLtIJgJ9iIYCESxVo7sYna+AGaIsFComARQUSFKIqfGDQxaqHr77/Mc3fZvXNvc7cX5R78eLMzb97739zt3uw0NNStvgL/9goUZiPf87ylzO+BHbAOVjiW42Uf4YPjMX4ERguFwiQ+H0NkMxyGh/ALyrWfTNBc5WguV3XqFSZ5B8mPwiFY7ArN4O/BKIzBO9CqCplWWrTBNtC3sR0WgOwLXITTrPordVTEEDsAn8HsDo09MK/cAprj5iqHmXIPlJsrFk+SdrhtWfFD0B0LzNihXC4nzjfVas+Ujomd8MxP43lv8P2ZEqWYpNygGjLV7EwxLQhhQhdMgGwMWoPR6rRUw9XC+bW7UlUiuAmeaBY2AmXfyakKJQSplquJ8zU0JYRFuwgcVDQ2Dn+fEJ0+6ytqLnC1cd5gyYQE9ICerT9gY8ngKg6qttMgLXoUJhuDN0B2PDkiv15p8JV43vXEqgx2gP6FvsOyxKAcO6XBaZEm/Wn51mgN/EHQ9RD/Op9C/TVpOg1DTtMBExEWvMV1XrXBOeBNy1bTEha8xnU+t8E54E2LaQsk8TuZBFlL0BttMXYSpuSjI8FVpWKUkVwtIItvR+mc9oc8b2FQPtpiXGJlU9GR4EpjfsQsY5SRPDHB4Z/Ee1dWW8Fido6BaZAvZpWKUf4uV2TC+cDxaWxXVrVNTlAtXQtN+9y3ZTef/xiz2cOusds65oDf6zTcj2nhk2xwn0abaXujiMXl1YGGxD+OSH2C7C3gWGSgBhdoKf3XLE0E7QTZDKytgU6/JLXTbX6c6AtSjD2ARXmLpqa2l49AVnp76QQvIfCpH+55t/Dz8xJNrfI38E60XpHeOtF38TogqapRoxX0OibT65k9g9PVZcJ6NxHnvYTedDPLjyJ3P2R/CbWSJGkDrbDZZRo6kqqIkasbrlhyfPbXfFNEkkY4Al9BpteWS1B0k2RzkzzzqneQEi5IodVwHr6BbBzCe5FwuB6Ruts7YTP0gZ6rw2AfnKZ/mjSI//NGEUlSiQuSrwJ7ivSFc9K/Es6C3bA0Y6ZvKPNhYLhe6jYFTzgZpzSJtlZTK2hbSw1rJV+Anuc34QzoPE5HtPkaRfeD7BrooPC1Lpypr2ZHBIkrgaBNpi7k9QwtfoaQmCmnToTpOCt889k2MCcFGcoguBd2QepD8Qxl6lPqK/DfrcBv4Q5yg2wbjUMAAAAASUVORK5CYII="

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAACCAYAAAEbeA0BAAAAAXNSR0IArs4c6QAAAClJREFUCB1j+P///1YGEAAy/oMJMAMmAuJAAUQZVGIrTBQLvQWkBhkAAGCxPpiGAPW7AAAAAElFTkSuQmCC"

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/lntegral_icon_succeed.png";

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/loading_icon_60x60.png";

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAeNJREFUWAntWD1LglEUPudVGioCKVJs6Wvoa2sQ2oKmSBCnoD/Q1h9oq/5DfyBoCsFobQscGoK+hkqXxKIQohxCPZ17cfC+HEWvvuRwX1DvOZ7n431EwQPgrt4SwFbw1Wxx+PMX9hFhi2cWiSjcatamj4hVxj0Qwfn4EBxeJ+MViUc0uHz5PvpTruaAaKkBemXCkkRg2+MbjjF2SuMR70ci4cTd+uS3n09MpVKuHmlziAXwvO1CKpbzA/tRT2dKCajXT5WW1gTY8/N6/oauiTbVa8gL7QRlTvErbqWhzmxSa+pz05NokADmAaH8nIpeNc0GctQarKU1BQXRoJpDwi9hPpBWO62WBgNxYkHqDFqEZkBcgkYcFoVL0CI0A+ISNOKwKFyCFqEZEJegEYdF4RK0CM2AuASNOCwKl6BFaAbEJWjEYVEMfILiZqGbG509K+4S0IqEQcDbl3T8WHqv017PBvkP9wEvgCZEQYQP7v+vQV6QbIS82oxksE6hvNTvptcyQUIa64Qon47e8Jx6WF9aiz8K6RK/JLyTewKCyFzmbU0C9bOnNVhLawrEokFAvFCztXrtRK/IBGA/WopbaWiuhqafd+AXmKJBdRdNK+AklwsBrYAf+Rcg224F7E/U1d0m8AcxapQHW+pl7AAAAABJRU5ErkJggg=="

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_code@2x.png";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_code_yellow.png";

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAARpJREFUWAntmEsOwjAMRFvEKWDDGm4D54TbwLobuEb5SCNZqZk4ripC5G6SemzHfk4lRNfFEwSCACXQa+rufB81+1zbcNqq57G8KybWoK1ZEZ6OtXxzJlI9wShQG3mJjd5BmUi7R7ijTJM5PHtzgZ7kaYzWSOqDpmE3F5gGIsF7ZZr08+zNBXqSpzGskW904ytOKZa+m0esjQAjY5pWEPwRr/nAVv2IzQRZt0wDCe/aDkEvAS2uhHg7BPHlSSIgwTTpjz38EQ+7trZDkHXLNI1Kia0dgiVd53xLiFdPMArMjTunB8EcoZxePcHJnzm7y+PajeP+01nf33IdmnTkszi/zhyOmwNcp78HZTK5R8TS6y/OXLqnyP/XBJ5nZEtF5RMzUAAAAABJRU5ErkJggg=="

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_experience_man_n@2x.png";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_experience_man_s@2x.png";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_experience_woman_n@2x.png";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_experience_woman_s@2x.png";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_my_yellow.png";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_name@2x.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_password@2x.png";

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAdlJREFUWAntWL1KA0EQnsnpFRICQgrBSrDQaCkEhEQFKzG94AvY+QJ26jv4AoJ9xFZNQAjYCP4VAW0Ei4AQgsXF3DiTEFmOOUk2ObTYhZDZyXw/+0GaAXBntAQwDk63pamg1TxApG0gWCSgibhZmz4CfgHCExGe++nMEa6UPzUe1SA9rKeDRqfGxnI9EL6x0XeNwLbHxmYAaLaLR3j0s14el65aUT41lXYjPO6Zw1f0vB2/cFmLAsdxD6obeep0zoAo19UE2I/ypqINuRPBlnynEHaTMif8wi0aUvc1pTaPapDH5xHhY3KtcmMOJ1GLhmiJpsYfY7D7oqYGSKLH6cVqxRpMwogNpzNok5qJcQmaadjULkGb1EyMS9BMw6Z2CdqkZmJcgmYaNrVL0CY1E+MSNNOwqV2CNqmZGJegmYZN/e8TVDcLw7w0qBT2gHBZxSDd+8XqifrbgM2RDUKIh7xYymp6SNjg/h8b9LxNj2hOMxgivmj9YXqxCfI6IjMIEe9X7nhOPtZHtHi7oJ6YPwnWGTDdvi6uqqgxNkVDtACwrtGqBvlFFzIcEpzKikwDjqMn3KIhXH3NKO+/X2CqBuUVPytgoBJfFxJZAQM8E2D5txVwNFF3HzaBb8e5lcpWvU7yAAAAAElFTkSuQmCC"

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAxZJREFUWAntWM9rE0EUfm+bNGtNDagHpf6ANvoHKIipFaK2oD2IKAa0GvGmiBfFg4hgPXjQkyAKemprFVqhNymtIlpJKl69tRHEHyCIok3MNm3m+Sa4ZXa7STambYrsQNi3733zzbdvZt7sBsBrXgZqmwF0O/w1Im24b/IOAB4Hoga3/VQcAmYAsT9xsvk8IpIaK2a7FtjalzoihHhSjKgSP9bh4eSJ8JCbPj43IIkhEltNrIZ4kwDz5r2rK5KPBF2SWCSc4yrX17VAlahJb7k6GMOc6itnRwY+roCsURBYDqvGNfVmOdqOGWwfSIUyUB9UBVPWCJn3X40PTZyRijKIgnRzVxBBiPs3mXzyuhJy6Wexlp+qT9qWTRJ9+GmDIYzHvODa7MCluOedPQZ64FgytvGzOZ5liqdF9l6txElBRLSbstN3TXHyap/iqHRyWkf4aRakpEg+N00AHQWCDt7iURVvF6jLICG+TcbDD1TgYtuR3olmXqMdPE5BgzmeZYpN53K6egKrnY3/K4OR/vc7oo++rP3XrLT1pjbt7Em1czmx1N9SfK4zuKtv4iDN5t8YM78TpQiLxaSoPNAYgBht7U8dKoaz+y1Pwlt9ho8hH7+3PQcNhlUwCdjLBeiA9CFql7lezarxsjaRn7lvFHCITxHhhdqH+TuZfw8X4dx4fEvAjDkKNIM1udoEup7imojlQe0nSUEHanirkYLdqqgpSl8goOs8v+Sr869pyAcqepuZ0mcCZEx/4wMXeflcWUWNt1X+X5Du5thF1SdtR4G8VnIj8XUZFdzaOznEb9HnmGT0ddfmH2rMpZ2J9Eze5wfc59dwcKTLyl9Y/w5EjgIdcJCIh9/xTlzv9mPHiSN5KnzGyV/KV9EarEZcKRGlYhUJLEW0WDFPYLWZ9TJYbQbtZcZgwiCff9v5r47T1ZJX0p+E2PYXLzXMNYtALsSv+MDu5Hq3X/7mUEtocHJeqsNZ1qAP8CwHx1XAUtpcZxN+P59WSmPB8xt/9a+uM3KWfxbmoxbWk9fr0/zB/n1hWT02LwPVZ+APDTP1ne2M82AAAAAASUVORK5CYII="

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_verification_yellow.png";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_visible_n@2x.png";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/login_icon_visible_s@2x.png";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/my-bt-sign-in.png";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/my-integral-icon-detail.png";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/my-integral-icon-earn.png";

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/my-integral-icon-find.png";

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/my-integral-icon-present.png";

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/my-integral-icon-rule.png";

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAAXNSR0IArs4c6QAAAOFJREFUKBWlkk0OgjAQhZE0hB1Lb+Ah9A4uTDyUC65gvJaENRvKb4GFtKnzjE1KglhxkqbTme+9tJNuOOf3KIp2jDHvn5BSek3TJH4QBPu6roXWerUftPCA18ukbdtjVVUPaqwKaOExuREVr33f/2wIDbQTM3PI8zwZx9HZFCw0Ro/dtw9hGB4wC7u2lIOFZonxhBAnesLXa4IBu2hmmgTfhmH4+HT0wBjeaafZpHPzfM8tdTKxoa7rtmSK/zkJ1NCzWeechn4uikIqpTQWctScDebAsiwvWZYpLJpbPMfYtSch15A9CzJnigAAAABJRU5ErkJggg=="

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/subpage-shopping-cart.png";

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/top-icon-classify.png";

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/top-icon-return-s.png";

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAmhJREFUWAntlz9LHEEYh907k4BfIdVV+QB3B2JlISksJAS0iJhwUSstBNPY2KQJSAolCAFBEzUhIEmwFrFId3ef4Rr9CJbu+rzHTFiXmdu9Gbm7YgaGmX3n/fP4m72dcWwstKBAUGCgCkSmarVa7V+SJJNRFP1stVpLJp9h2UqmwsBOYS/HcfzGtD5MmxEYoK7yKGxbHxrzyAHlKRGA8xTyXQ8K+yqYFx8UzlPIts5htVStVq8Zv9h8xD4SCgP5nsPqGzzPGecHAow6v+m3FN/rVTC7pmAPsMthFZdKpc2sT/r5URQG9CVJX9EnUGi9Xq8vpovY5gbY5WazeWLzF7s3MEVnyXNO1xepSLY3D9oCe0Sens0LmKJzwP2hwjNV5ZL7xx22skCjvPHyZIBdQdmjnqRq0RkYBV8DdUaepyrXPlfRGYDfaWjG71mlLbCHRWDFxwkYiAVgfxH/RBXabbfbawAmKHWahhalNTRjg+f0D0yULQzrBCzbTNEf9HEF+xnYDTXvDiZolP3K/doLtm9gir4l6BjYsgL8BOwHNX8wGKBXcZAdlU9X38rq5IVfCWCnAZXt0zEfgd3SiUyjhmYtoctXJPGBlRq6uMzz2gsctP82sNt5AbKuoC+YxvQrnvt6ZyVHuun3MG0zziuVymGn0xlH5Rtg/xqdLEa+HnKwPErTH/sHyfhhyRZ2G3BGH70+6FFv8aDrOtcLwM7SFQwMChcUytktKOwsXcHAoHBBoZzdjKdY+qRzzuwZqP4J2MlesGyvxP+j2bOuc7hcYYFuZBPYgG9wHCq0UtjrZpf9Y8NzUGAUFLgHgygGnrMsKA8AAAAASUVORK5CYII="

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/top_icon_close.png";

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAA5hJREFUSA29l0FIG0EUht1NahoCiT2EBCFo2kNyUKkXDxIvQgm0B1sMtF6KSMWDRSsVeyhElOZQaLGFehCKlF6kEGkttFB61Et6jIJ6aBOIhARbmgglRBLT9y8+GdfdNVFJIJnZnff+b+fNzNsXqaGKT6VSkUqlUsBsNveVy+UuSZKa6euGK41l6Js2mUw/yGaFbNZorHKarGRkQIKWg4ODRyQ0WSgU8olEYmNra+tnJpP5m0ql8vD1eDwOt9t9xe/3X/N6vW1Wq9VBfi9kWX5FfkU9fV0wPX2IHF/v7u6mlpeXv8Tj8ayeiHi/o6PD1d/ff8vpdHroAcYpAlFxnPuaYHKIFIvFoWg0+m51dTXBxrW0PT093lAoNGixWBZpAk/VvifAtIYf9vb22ubm5t5ms9l/aodarl0ul21iYuKB3W7foD1wV/Q9BsZMc7nc7XA4/GZ/f78sGp6139jYaJqdnX3Y1NT0SZy5zIJYU4QXM70oKLShBU1og8E8BUwztWAjYU3PG14WFltoQhsMsDCmgHFksHu1NtLU1NS9kZGRG6KQXr+1tdURiUTGu7u7W9Q20AYDLIzJ9AT0INIkjozaGNf5fP5PZ2dnaHR09KbWON8DdGxs7LHNZnOn0+kc3xdbMMACU6a4B5Ac9M7pwsLC9/X19ZX29vY+PThDKWlcIvuXyWRSSS4iFH0wwAJTRhpERlIbidfz8/Nf9eBq6Obm5m/RV90HC0wZuRdpUG2gvtaC1wqFJlhgminmzci9apDWNeAU7gaEnRLDZcrT1zm8p82U9cACU6YfNyd8HjRqAd/e3v7m8/mClBzsWNNqodAFC8yjBGIEE8cQXsyUNkiB1sra29vbJY5X06ddrRynDAk5qnEQ15Rm/kxvwxlpHbIyOMdpvE+NjDEmQjm8WhvuNB2wwJRROeAlbuSgBWX7WuFgETOGBLKCyoGF1K0RlG1rgYNFzM9IIGsoV1A5sJDYDg8PD1ZzZER4MBj0ixrcBwMsMJX3MR3oJ5TA70xPTy+yEbeBQKBlZ2cnp5cG2Y5bgvpisViS3usn6q2ZmZkhKok+UqifK2BabBR1v5aWlt5rvaFY9DwtSqGBgYH7FL2rdI6LyjlGh+DjqJFQrpwHoOULTWiDARZsjhIIxT2Kwgw1EsoVLYGz3IMWNKENBmscq7lwk9a7/sUePw2FpP7lLcPprNW/oGf44W6v718YhqOlB7jwP23/AXpld2L8yBHWAAAAAElFTkSuQmCC"

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAgCAYAAACRpmGNAAAAAXNSR0IArs4c6QAAALpJREFUWAntlEEOwCAIBGvTH/n/J/imNj0sMcYDS8RgQi/YZtHtIJRa63sZntZaMaRRKTel3ix+cJ6WhJU0zmGimGOSRq2X4TPKOtJg3rVXgtnz14Yml+bYckKf3QoSbFxCzqtbxZzXIGVp9frQ3dobzXUS2EGgWLvUa3z0Px26W2XOaUlYSfdEtGsxp02Y6bwMn1HWGRHtN+2V0O4HXWhyaQ5lYmN2K0sM+iXkvLpVzHkNUlCwxNDd+gESFSN/sU/lnwAAAABJRU5ErkJggg=="

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAKhJREFUWAntlkEOgCAMBMX4I/7/BN6kpyGGZFNSLj2slzUb2ZQBLK33/l4Hzxij/Yef5t3/sArvD0WsM8VXGpHI5pUj5ILUFsA3IUgoNSFFBt+EIKHUhBQZ/NnLot7EgF3N5pVbst0J+zsTUARa9jQQuN4MT/PKnbL5H1pnCgGlEYlsXjlCLkhtAXwTgoRSE1Jk8E0IEkpNSJHBn70s6k0M2NVsXrkl+wCjCCHXCZbYbgAAAABJRU5ErkJggg=="

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/top_icon_screen.png";

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAArdJREFUWAntmE+ITXEUx+cOMxORiUiSKLGYZCMlFliMhY2wmo1iMysLG8pCWSiDYsFCoinNYjaKmqL8SdkzG0okKZmm/EmkmfF8Tv1OnXvfb96793d/b95L99S3c36/3znf73nn/bnv3q6uyqoJ/IcTqNVqN8AsaKfNIH45O94kuyFrEqdwq31nC7z3IUmSTVZzsV2Y+BLxiFvP4m+DObdupeuB/DjodiJ1E/aKM+Fu8BSonfYmRt5E7LwK4h8B7yfAK0vyBvAViP0B27yJkTbh3wn0eyO66wtTUzQE1F4S9BYmyVEA7xLwRoXwQznK/CkUjxmiC/6scrvwXzMa46XYIOoHHx2hvGW7ShFmiuHbD/46/s/4VZmU4ktI9oI5R/oWv7Q4S30FPCuADkPoD9ZnBe5ANiKMzq4H0qTK4BpVQvzN1GHZBYS9QL54aoNlOCE5pET4d2BZGT5vLaQD4DcQ+wT6vYlNNqlbA6aAmHzU9jQpCT+G/KSoOLsbwkTtPSXAXwzhyF2DQAIeGsGjuYtJpO6YqZ0kbslve6onRNaBaScsfm0qYZ4FeXL1/O7q5Oq5fZ7U+NuIHXHC4h40UyBH3pnHkuzsTLOa6OcI31F1/IlGApzbz/4L1osa5bfkDNHl4D0Q+wE2+oTY3wp+AbGfYLMvb0H2EN8N9F/Wc2L5T5sy9mSiasOpw3Ys6MReBQ/bHjhbqZ3in9izkFj/2YfU2ppXZtFnYgntXc1k5qzwMlbDhYVDC6qGQyeXt66acN5JheZVEw6dXN66asJMaiDvtELyYk14xoiflUsw2GL2ooWxGp6go/umq33EcjdxDp+9VJu0Noc0eAC8Btbsc4erbW6xXp5Oe8Ap8M127eLOa1hfAg3KrfwtoE+MpOcret6xniZ3gGfgC4j6XK5jX3TVWDWBBhP4B+a4TtGIhynqAAAAAElFTkSuQmCC"

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/top_icon_search_black.png";

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/top_icon_search_white.png";

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABiklEQVR4Xu1bMUrEUBCdYckB9gSB/FnURsFisbcTvIHYiZ16lbXcbsEjiO12FoIgbKGY+CUHEC+QZGSJRURZq58J/JcDZGYeM39m3n+fKfKPI4+fAAAywAiBPH8/YG6WRLRiphPn3KuFK2YlUBR+RqQXbdB8LZJdRgZAMSfiszZonYvIOQAwQMCwBJABKAGcATgE0QXQBjEHYBDCJIhRGLsAliFsg1iHwQeAEAEjBErMgBGzuxgpClBioMQGSYl576d1rUeh65FZj4l4/5sPeFTl25A2mfUjSZKbNE0/u3Z+0eJ5/vbMTNshnTH890rE7f4HwBMz7Rk6Gcy0Kr1MJm5nIwBlWY6rqjptGhoH82R9G9hzCaxjGY34Lsuyh40AhAy6+2+0QcwBGIQwCA1yEMIh2BMC6ALoAugC6ALoAlCIQCEChQgUIlCIQCEChQgUIlCIQCEChQgUIvEpRLqPpmgm4q56IqN+mDF7MuO936prXbTXcHooIvdRAWAR7F82zTIAAAwEgegz4AsFBGhQgp3nBQAAAABJRU5ErkJggg=="

/***/ })
]),[380]);


// WEBPACK FOOTER //
// js/app.bind.b966.js